
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9t6Kl", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6e4c0e31b5ab7dd9$export$ffb0004e005737fa; }, function (v) { return $6e4c0e31b5ab7dd9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6e4c0e31b5ab7dd9$export$34b9dba7ce09269b; }, function (v) { return $6e4c0e31b5ab7dd9$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6e4c0e31b5ab7dd9$export$25062201e9e25d76; }, function (v) { return $6e4c0e31b5ab7dd9$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6e4c0e31b5ab7dd9$export$ffb0004e005737fa;
var $6e4c0e31b5ab7dd9$export$34b9dba7ce09269b;
var $6e4c0e31b5ab7dd9$export$25062201e9e25d76;
"use strict";

var $ld5Xm = parcelRequire("ld5Xm");
var $6e4c0e31b5ab7dd9$var$k = Symbol.for("react.element"), $6e4c0e31b5ab7dd9$var$l = Symbol.for("react.fragment"), $6e4c0e31b5ab7dd9$var$m = Object.prototype.hasOwnProperty, $6e4c0e31b5ab7dd9$var$n = $ld5Xm.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $6e4c0e31b5ab7dd9$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6e4c0e31b5ab7dd9$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$6e4c0e31b5ab7dd9$var$m.call(a, b) && !$6e4c0e31b5ab7dd9$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $6e4c0e31b5ab7dd9$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $6e4c0e31b5ab7dd9$var$n.current
    };
}
$6e4c0e31b5ab7dd9$export$ffb0004e005737fa = $6e4c0e31b5ab7dd9$var$l;
$6e4c0e31b5ab7dd9$export$34b9dba7ce09269b = $6e4c0e31b5ab7dd9$var$q;
$6e4c0e31b5ab7dd9$export$25062201e9e25d76 = $6e4c0e31b5ab7dd9$var$q;

});
parcelRegister("ld5Xm", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eHx0n"));

});
parcelRegister("eHx0n", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $ab3eaef1db52ddf7$export$dca3b0875bd9a954; }, function (v) { return $ab3eaef1db52ddf7$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $ab3eaef1db52ddf7$export$16fa2f45be04daa8; }, function (v) { return $ab3eaef1db52ddf7$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ab3eaef1db52ddf7$export$ffb0004e005737fa; }, function (v) { return $ab3eaef1db52ddf7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $ab3eaef1db52ddf7$export$e2c29f18771995cb; }, function (v) { return $ab3eaef1db52ddf7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $ab3eaef1db52ddf7$export$221d75b3f55bb0bd; }, function (v) { return $ab3eaef1db52ddf7$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ab3eaef1db52ddf7$export$5f8d39834fd61797; }, function (v) { return $ab3eaef1db52ddf7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ab3eaef1db52ddf7$export$74bf444e3cd11ea5; }, function (v) { return $ab3eaef1db52ddf7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $ab3eaef1db52ddf7$export$ae55be85d98224ed; }, function (v) { return $ab3eaef1db52ddf7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $ab3eaef1db52ddf7$export$3ba232387fd5d6dd; }, function (v) { return $ab3eaef1db52ddf7$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $ab3eaef1db52ddf7$export$e530037191fcd5d7; }, function (v) { return $ab3eaef1db52ddf7$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $ab3eaef1db52ddf7$export$fd42f52fd3ae1109; }, function (v) { return $ab3eaef1db52ddf7$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $ab3eaef1db52ddf7$export$c8a8987d4410bf2d; }, function (v) { return $ab3eaef1db52ddf7$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $ab3eaef1db52ddf7$export$d38cd72104c1f0e9; }, function (v) { return $ab3eaef1db52ddf7$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $ab3eaef1db52ddf7$export$7d1e3a5e95ceca43; }, function (v) { return $ab3eaef1db52ddf7$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $ab3eaef1db52ddf7$export$257a8862b851cb5b; }, function (v) { return $ab3eaef1db52ddf7$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $ab3eaef1db52ddf7$export$a8257692ac88316c; }, function (v) { return $ab3eaef1db52ddf7$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $ab3eaef1db52ddf7$export$488013bae63b21da; }, function (v) { return $ab3eaef1db52ddf7$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $ab3eaef1db52ddf7$export$7c73462e0d25e514; }, function (v) { return $ab3eaef1db52ddf7$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $ab3eaef1db52ddf7$export$7568632d0d33d16d; }, function (v) { return $ab3eaef1db52ddf7$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $ab3eaef1db52ddf7$export$88948ce120ea2619; }, function (v) { return $ab3eaef1db52ddf7$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $ab3eaef1db52ddf7$export$35808ee640e87ca7; }, function (v) { return $ab3eaef1db52ddf7$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $ab3eaef1db52ddf7$export$fae74005e78b1a27; }, function (v) { return $ab3eaef1db52ddf7$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $ab3eaef1db52ddf7$export$dc8fbce3eb94dc1e; }, function (v) { return $ab3eaef1db52ddf7$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $ab3eaef1db52ddf7$export$6a7bc4e911dc01cf; }, function (v) { return $ab3eaef1db52ddf7$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $ab3eaef1db52ddf7$export$6d9c69b0de29b591; }, function (v) { return $ab3eaef1db52ddf7$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $ab3eaef1db52ddf7$export$f680877a34711e37; }, function (v) { return $ab3eaef1db52ddf7$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $ab3eaef1db52ddf7$export$d5a552a76deda3c2; }, function (v) { return $ab3eaef1db52ddf7$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $ab3eaef1db52ddf7$export$aaabe4eda9ed9969; }, function (v) { return $ab3eaef1db52ddf7$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $ab3eaef1db52ddf7$export$e5c5a5f917a5871c; }, function (v) { return $ab3eaef1db52ddf7$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $ab3eaef1db52ddf7$export$1538c33de8887b59; }, function (v) { return $ab3eaef1db52ddf7$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $ab3eaef1db52ddf7$export$13e3392192263954; }, function (v) { return $ab3eaef1db52ddf7$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $ab3eaef1db52ddf7$export$b8f5890fc79d6aca; }, function (v) { return $ab3eaef1db52ddf7$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $ab3eaef1db52ddf7$export$60241385465d0a34; }, function (v) { return $ab3eaef1db52ddf7$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $ab3eaef1db52ddf7$export$306c0aa65ff9ec16; }, function (v) { return $ab3eaef1db52ddf7$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $ab3eaef1db52ddf7$export$7b286972b8d8ccbf; }, function (v) { return $ab3eaef1db52ddf7$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $ab3eaef1db52ddf7$export$83d89fbfd8236492; }, function (v) { return $ab3eaef1db52ddf7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ab3eaef1db52ddf7$export$dca3b0875bd9a954;
var $ab3eaef1db52ddf7$export$16fa2f45be04daa8;
var $ab3eaef1db52ddf7$export$ffb0004e005737fa;
var $ab3eaef1db52ddf7$export$e2c29f18771995cb;
var $ab3eaef1db52ddf7$export$221d75b3f55bb0bd;
var $ab3eaef1db52ddf7$export$5f8d39834fd61797;
var $ab3eaef1db52ddf7$export$74bf444e3cd11ea5;
var $ab3eaef1db52ddf7$export$ae55be85d98224ed;
var $ab3eaef1db52ddf7$export$3ba232387fd5d6dd;
var $ab3eaef1db52ddf7$export$e530037191fcd5d7;
var $ab3eaef1db52ddf7$export$fd42f52fd3ae1109;
var $ab3eaef1db52ddf7$export$c8a8987d4410bf2d;
var $ab3eaef1db52ddf7$export$d38cd72104c1f0e9;
var $ab3eaef1db52ddf7$export$7d1e3a5e95ceca43;
var $ab3eaef1db52ddf7$export$257a8862b851cb5b;
var $ab3eaef1db52ddf7$export$a8257692ac88316c;
var $ab3eaef1db52ddf7$export$488013bae63b21da;
var $ab3eaef1db52ddf7$export$7c73462e0d25e514;
var $ab3eaef1db52ddf7$export$7568632d0d33d16d;
var $ab3eaef1db52ddf7$export$88948ce120ea2619;
var $ab3eaef1db52ddf7$export$35808ee640e87ca7;
var $ab3eaef1db52ddf7$export$fae74005e78b1a27;
var $ab3eaef1db52ddf7$export$dc8fbce3eb94dc1e;
var $ab3eaef1db52ddf7$export$6a7bc4e911dc01cf;
var $ab3eaef1db52ddf7$export$6d9c69b0de29b591;
var $ab3eaef1db52ddf7$export$f680877a34711e37;
var $ab3eaef1db52ddf7$export$d5a552a76deda3c2;
var $ab3eaef1db52ddf7$export$aaabe4eda9ed9969;
var $ab3eaef1db52ddf7$export$e5c5a5f917a5871c;
var $ab3eaef1db52ddf7$export$1538c33de8887b59;
var $ab3eaef1db52ddf7$export$13e3392192263954;
var $ab3eaef1db52ddf7$export$b8f5890fc79d6aca;
var $ab3eaef1db52ddf7$export$60241385465d0a34;
var $ab3eaef1db52ddf7$export$306c0aa65ff9ec16;
var $ab3eaef1db52ddf7$export$7b286972b8d8ccbf;
var $ab3eaef1db52ddf7$export$83d89fbfd8236492;
"use strict";
var $ab3eaef1db52ddf7$var$l = Symbol.for("react.element"), $ab3eaef1db52ddf7$var$n = Symbol.for("react.portal"), $ab3eaef1db52ddf7$var$p = Symbol.for("react.fragment"), $ab3eaef1db52ddf7$var$q = Symbol.for("react.strict_mode"), $ab3eaef1db52ddf7$var$r = Symbol.for("react.profiler"), $ab3eaef1db52ddf7$var$t = Symbol.for("react.provider"), $ab3eaef1db52ddf7$var$u = Symbol.for("react.context"), $ab3eaef1db52ddf7$var$v = Symbol.for("react.forward_ref"), $ab3eaef1db52ddf7$var$w = Symbol.for("react.suspense"), $ab3eaef1db52ddf7$var$x = Symbol.for("react.memo"), $ab3eaef1db52ddf7$var$y = Symbol.for("react.lazy"), $ab3eaef1db52ddf7$var$z = Symbol.iterator;
function $ab3eaef1db52ddf7$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ab3eaef1db52ddf7$var$z && a[$ab3eaef1db52ddf7$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $ab3eaef1db52ddf7$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $ab3eaef1db52ddf7$var$C = Object.assign, $ab3eaef1db52ddf7$var$D = {};
function $ab3eaef1db52ddf7$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ab3eaef1db52ddf7$var$D;
    this.updater = e || $ab3eaef1db52ddf7$var$B;
}
$ab3eaef1db52ddf7$var$E.prototype.isReactComponent = {};
$ab3eaef1db52ddf7$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$ab3eaef1db52ddf7$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $ab3eaef1db52ddf7$var$F() {}
$ab3eaef1db52ddf7$var$F.prototype = $ab3eaef1db52ddf7$var$E.prototype;
function $ab3eaef1db52ddf7$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ab3eaef1db52ddf7$var$D;
    this.updater = e || $ab3eaef1db52ddf7$var$B;
}
var $ab3eaef1db52ddf7$var$H = $ab3eaef1db52ddf7$var$G.prototype = new $ab3eaef1db52ddf7$var$F;
$ab3eaef1db52ddf7$var$H.constructor = $ab3eaef1db52ddf7$var$G;
$ab3eaef1db52ddf7$var$C($ab3eaef1db52ddf7$var$H, $ab3eaef1db52ddf7$var$E.prototype);
$ab3eaef1db52ddf7$var$H.isPureReactComponent = !0;
var $ab3eaef1db52ddf7$var$I = Array.isArray, $ab3eaef1db52ddf7$var$J = Object.prototype.hasOwnProperty, $ab3eaef1db52ddf7$var$K = {
    current: null
}, $ab3eaef1db52ddf7$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ab3eaef1db52ddf7$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$ab3eaef1db52ddf7$var$J.call(b, d) && !$ab3eaef1db52ddf7$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $ab3eaef1db52ddf7$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $ab3eaef1db52ddf7$var$K.current
    };
}
function $ab3eaef1db52ddf7$var$N(a, b) {
    return {
        $$typeof: $ab3eaef1db52ddf7$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $ab3eaef1db52ddf7$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ab3eaef1db52ddf7$var$l;
}
function $ab3eaef1db52ddf7$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $ab3eaef1db52ddf7$var$P = /\/+/g;
function $ab3eaef1db52ddf7$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $ab3eaef1db52ddf7$var$escape("" + a.key) : b.toString(36);
}
function $ab3eaef1db52ddf7$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $ab3eaef1db52ddf7$var$l:
                case $ab3eaef1db52ddf7$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $ab3eaef1db52ddf7$var$Q(h, 0) : d, $ab3eaef1db52ddf7$var$I(c) ? (e = "", null != a && (e = a.replace($ab3eaef1db52ddf7$var$P, "$&/") + "/"), $ab3eaef1db52ddf7$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($ab3eaef1db52ddf7$var$O(c) && (c = $ab3eaef1db52ddf7$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($ab3eaef1db52ddf7$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($ab3eaef1db52ddf7$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $ab3eaef1db52ddf7$var$Q(k, g);
        h += $ab3eaef1db52ddf7$var$R(k, b, e, f, c);
    }
    else if (f = $ab3eaef1db52ddf7$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $ab3eaef1db52ddf7$var$Q(k, g++), h += $ab3eaef1db52ddf7$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $ab3eaef1db52ddf7$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $ab3eaef1db52ddf7$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $ab3eaef1db52ddf7$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $ab3eaef1db52ddf7$var$U = {
    current: null
}, $ab3eaef1db52ddf7$var$V = {
    transition: null
}, $ab3eaef1db52ddf7$var$W = {
    ReactCurrentDispatcher: $ab3eaef1db52ddf7$var$U,
    ReactCurrentBatchConfig: $ab3eaef1db52ddf7$var$V,
    ReactCurrentOwner: $ab3eaef1db52ddf7$var$K
};
function $ab3eaef1db52ddf7$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$ab3eaef1db52ddf7$export$dca3b0875bd9a954 = {
    map: $ab3eaef1db52ddf7$var$S,
    forEach: function(a, b, e) {
        $ab3eaef1db52ddf7$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $ab3eaef1db52ddf7$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $ab3eaef1db52ddf7$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$ab3eaef1db52ddf7$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$ab3eaef1db52ddf7$export$16fa2f45be04daa8 = $ab3eaef1db52ddf7$var$E;
$ab3eaef1db52ddf7$export$ffb0004e005737fa = $ab3eaef1db52ddf7$var$p;
$ab3eaef1db52ddf7$export$e2c29f18771995cb = $ab3eaef1db52ddf7$var$r;
$ab3eaef1db52ddf7$export$221d75b3f55bb0bd = $ab3eaef1db52ddf7$var$G;
$ab3eaef1db52ddf7$export$5f8d39834fd61797 = $ab3eaef1db52ddf7$var$q;
$ab3eaef1db52ddf7$export$74bf444e3cd11ea5 = $ab3eaef1db52ddf7$var$w;
$ab3eaef1db52ddf7$export$ae55be85d98224ed = $ab3eaef1db52ddf7$var$W;
$ab3eaef1db52ddf7$export$3ba232387fd5d6dd = $ab3eaef1db52ddf7$var$X;
$ab3eaef1db52ddf7$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $ab3eaef1db52ddf7$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $ab3eaef1db52ddf7$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$ab3eaef1db52ddf7$var$J.call(b, f) && !$ab3eaef1db52ddf7$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $ab3eaef1db52ddf7$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$ab3eaef1db52ddf7$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $ab3eaef1db52ddf7$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $ab3eaef1db52ddf7$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$ab3eaef1db52ddf7$export$c8a8987d4410bf2d = $ab3eaef1db52ddf7$var$M;
$ab3eaef1db52ddf7$export$d38cd72104c1f0e9 = function(a) {
    var b = $ab3eaef1db52ddf7$var$M.bind(null, a);
    b.type = a;
    return b;
};
$ab3eaef1db52ddf7$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$ab3eaef1db52ddf7$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $ab3eaef1db52ddf7$var$v,
        render: a
    };
};
$ab3eaef1db52ddf7$export$a8257692ac88316c = $ab3eaef1db52ddf7$var$O;
$ab3eaef1db52ddf7$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $ab3eaef1db52ddf7$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $ab3eaef1db52ddf7$var$T
    };
};
$ab3eaef1db52ddf7$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $ab3eaef1db52ddf7$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$ab3eaef1db52ddf7$export$7568632d0d33d16d = function(a) {
    var b = $ab3eaef1db52ddf7$var$V.transition;
    $ab3eaef1db52ddf7$var$V.transition = {};
    try {
        a();
    } finally{
        $ab3eaef1db52ddf7$var$V.transition = b;
    }
};
$ab3eaef1db52ddf7$export$88948ce120ea2619 = $ab3eaef1db52ddf7$var$X;
$ab3eaef1db52ddf7$export$35808ee640e87ca7 = function(a, b) {
    return $ab3eaef1db52ddf7$var$U.current.useCallback(a, b);
};
$ab3eaef1db52ddf7$export$fae74005e78b1a27 = function(a) {
    return $ab3eaef1db52ddf7$var$U.current.useContext(a);
};
$ab3eaef1db52ddf7$export$dc8fbce3eb94dc1e = function() {};
$ab3eaef1db52ddf7$export$6a7bc4e911dc01cf = function(a) {
    return $ab3eaef1db52ddf7$var$U.current.useDeferredValue(a);
};
$ab3eaef1db52ddf7$export$6d9c69b0de29b591 = function(a, b) {
    return $ab3eaef1db52ddf7$var$U.current.useEffect(a, b);
};
$ab3eaef1db52ddf7$export$f680877a34711e37 = function() {
    return $ab3eaef1db52ddf7$var$U.current.useId();
};
$ab3eaef1db52ddf7$export$d5a552a76deda3c2 = function(a, b, e) {
    return $ab3eaef1db52ddf7$var$U.current.useImperativeHandle(a, b, e);
};
$ab3eaef1db52ddf7$export$aaabe4eda9ed9969 = function(a, b) {
    return $ab3eaef1db52ddf7$var$U.current.useInsertionEffect(a, b);
};
$ab3eaef1db52ddf7$export$e5c5a5f917a5871c = function(a, b) {
    return $ab3eaef1db52ddf7$var$U.current.useLayoutEffect(a, b);
};
$ab3eaef1db52ddf7$export$1538c33de8887b59 = function(a, b) {
    return $ab3eaef1db52ddf7$var$U.current.useMemo(a, b);
};
$ab3eaef1db52ddf7$export$13e3392192263954 = function(a, b, e) {
    return $ab3eaef1db52ddf7$var$U.current.useReducer(a, b, e);
};
$ab3eaef1db52ddf7$export$b8f5890fc79d6aca = function(a) {
    return $ab3eaef1db52ddf7$var$U.current.useRef(a);
};
$ab3eaef1db52ddf7$export$60241385465d0a34 = function(a) {
    return $ab3eaef1db52ddf7$var$U.current.useState(a);
};
$ab3eaef1db52ddf7$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $ab3eaef1db52ddf7$var$U.current.useSyncExternalStore(a, b, e);
};
$ab3eaef1db52ddf7$export$7b286972b8d8ccbf = function() {
    return $ab3eaef1db52ddf7$var$U.current.useTransition();
};
$ab3eaef1db52ddf7$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("io9YA", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $d63234f99c1aed29$export$ae55be85d98224ed; }, function (v) { return $d63234f99c1aed29$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $d63234f99c1aed29$export$d39a5bbd09211389; }, function (v) { return $d63234f99c1aed29$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $d63234f99c1aed29$export$882461b6382ed46c; }, function (v) { return $d63234f99c1aed29$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $d63234f99c1aed29$export$466bfc07425424d5; }, function (v) { return $d63234f99c1aed29$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $d63234f99c1aed29$export$cd75ccfd720a3cd4; }, function (v) { return $d63234f99c1aed29$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $d63234f99c1aed29$export$fa8d919ba61d84db; }, function (v) { return $d63234f99c1aed29$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $d63234f99c1aed29$export$757ceba2d55c277e; }, function (v) { return $d63234f99c1aed29$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $d63234f99c1aed29$export$b3890eb0ae9dca99; }, function (v) { return $d63234f99c1aed29$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $d63234f99c1aed29$export$502457920280e6be; }, function (v) { return $d63234f99c1aed29$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $d63234f99c1aed29$export$c78a37762a8d58e1; }, function (v) { return $d63234f99c1aed29$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $d63234f99c1aed29$export$dc54d992c10e8a18; }, function (v) { return $d63234f99c1aed29$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $d63234f99c1aed29$export$83d89fbfd8236492; }, function (v) { return $d63234f99c1aed29$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $d63234f99c1aed29$export$ae55be85d98224ed;
var $d63234f99c1aed29$export$d39a5bbd09211389;
var $d63234f99c1aed29$export$882461b6382ed46c;
var $d63234f99c1aed29$export$466bfc07425424d5;
var $d63234f99c1aed29$export$cd75ccfd720a3cd4;
var $d63234f99c1aed29$export$fa8d919ba61d84db;
var $d63234f99c1aed29$export$757ceba2d55c277e;
var $d63234f99c1aed29$export$b3890eb0ae9dca99;
var $d63234f99c1aed29$export$502457920280e6be;
var $d63234f99c1aed29$export$c78a37762a8d58e1;
var $d63234f99c1aed29$export$dc54d992c10e8a18;
var $d63234f99c1aed29$export$83d89fbfd8236492;
"use strict";

var $ld5Xm = parcelRequire("ld5Xm");

var $bIycj = parcelRequire("bIycj");
function $d63234f99c1aed29$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $d63234f99c1aed29$var$da = new Set, $d63234f99c1aed29$var$ea = {};
function $d63234f99c1aed29$var$fa(a, b) {
    $d63234f99c1aed29$var$ha(a, b);
    $d63234f99c1aed29$var$ha(a + "Capture", b);
}
function $d63234f99c1aed29$var$ha(a, b) {
    $d63234f99c1aed29$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$d63234f99c1aed29$var$da.add(b[a]);
}
var $d63234f99c1aed29$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $d63234f99c1aed29$var$ja = Object.prototype.hasOwnProperty, $d63234f99c1aed29$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $d63234f99c1aed29$var$la = {}, $d63234f99c1aed29$var$ma = {};
function $d63234f99c1aed29$var$oa(a) {
    if ($d63234f99c1aed29$var$ja.call($d63234f99c1aed29$var$ma, a)) return !0;
    if ($d63234f99c1aed29$var$ja.call($d63234f99c1aed29$var$la, a)) return !1;
    if ($d63234f99c1aed29$var$ka.test(a)) return $d63234f99c1aed29$var$ma[a] = !0;
    $d63234f99c1aed29$var$la[a] = !0;
    return !1;
}
function $d63234f99c1aed29$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $d63234f99c1aed29$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $d63234f99c1aed29$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $d63234f99c1aed29$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $d63234f99c1aed29$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $d63234f99c1aed29$var$z[b] = new $d63234f99c1aed29$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $d63234f99c1aed29$var$ra = /[\-:]([a-z])/g;
function $d63234f99c1aed29$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($d63234f99c1aed29$var$ra, $d63234f99c1aed29$var$sa);
    $d63234f99c1aed29$var$z[b] = new $d63234f99c1aed29$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($d63234f99c1aed29$var$ra, $d63234f99c1aed29$var$sa);
    $d63234f99c1aed29$var$z[b] = new $d63234f99c1aed29$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($d63234f99c1aed29$var$ra, $d63234f99c1aed29$var$sa);
    $d63234f99c1aed29$var$z[b] = new $d63234f99c1aed29$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$d63234f99c1aed29$var$z.xlinkHref = new $d63234f99c1aed29$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $d63234f99c1aed29$var$z[a] = new $d63234f99c1aed29$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $d63234f99c1aed29$var$ta(a, b, c, d) {
    var e = $d63234f99c1aed29$var$z.hasOwnProperty(b) ? $d63234f99c1aed29$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $d63234f99c1aed29$var$qa(b, c, e, d) && (c = null), d || null === e ? $d63234f99c1aed29$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $d63234f99c1aed29$var$ua = $ld5Xm.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $d63234f99c1aed29$var$va = Symbol.for("react.element"), $d63234f99c1aed29$var$wa = Symbol.for("react.portal"), $d63234f99c1aed29$var$ya = Symbol.for("react.fragment"), $d63234f99c1aed29$var$za = Symbol.for("react.strict_mode"), $d63234f99c1aed29$var$Aa = Symbol.for("react.profiler"), $d63234f99c1aed29$var$Ba = Symbol.for("react.provider"), $d63234f99c1aed29$var$Ca = Symbol.for("react.context"), $d63234f99c1aed29$var$Da = Symbol.for("react.forward_ref"), $d63234f99c1aed29$var$Ea = Symbol.for("react.suspense"), $d63234f99c1aed29$var$Fa = Symbol.for("react.suspense_list"), $d63234f99c1aed29$var$Ga = Symbol.for("react.memo"), $d63234f99c1aed29$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $d63234f99c1aed29$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $d63234f99c1aed29$var$Ja = Symbol.iterator;
function $d63234f99c1aed29$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $d63234f99c1aed29$var$Ja && a[$d63234f99c1aed29$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $d63234f99c1aed29$var$A = Object.assign, $d63234f99c1aed29$var$La;
function $d63234f99c1aed29$var$Ma(a) {
    if (void 0 === $d63234f99c1aed29$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $d63234f99c1aed29$var$La = b && b[1] || "";
    }
    return "\n" + $d63234f99c1aed29$var$La + a;
}
var $d63234f99c1aed29$var$Na = !1;
function $d63234f99c1aed29$var$Oa(a, b) {
    if (!a || $d63234f99c1aed29$var$Na) return "";
    $d63234f99c1aed29$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $d63234f99c1aed29$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $d63234f99c1aed29$var$Ma(a) : "";
}
function $d63234f99c1aed29$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $d63234f99c1aed29$var$Ma(a.type);
        case 16:
            return $d63234f99c1aed29$var$Ma("Lazy");
        case 13:
            return $d63234f99c1aed29$var$Ma("Suspense");
        case 19:
            return $d63234f99c1aed29$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $d63234f99c1aed29$var$Oa(a.type, !1), a;
        case 11:
            return a = $d63234f99c1aed29$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $d63234f99c1aed29$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $d63234f99c1aed29$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $d63234f99c1aed29$var$ya:
            return "Fragment";
        case $d63234f99c1aed29$var$wa:
            return "Portal";
        case $d63234f99c1aed29$var$Aa:
            return "Profiler";
        case $d63234f99c1aed29$var$za:
            return "StrictMode";
        case $d63234f99c1aed29$var$Ea:
            return "Suspense";
        case $d63234f99c1aed29$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $d63234f99c1aed29$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $d63234f99c1aed29$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $d63234f99c1aed29$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $d63234f99c1aed29$var$Ga:
            return b = a.displayName || null, null !== b ? b : $d63234f99c1aed29$var$Qa(a.type) || "Memo";
        case $d63234f99c1aed29$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $d63234f99c1aed29$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $d63234f99c1aed29$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $d63234f99c1aed29$var$Qa(b);
        case 8:
            return b === $d63234f99c1aed29$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $d63234f99c1aed29$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $d63234f99c1aed29$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $d63234f99c1aed29$var$Ua(a) {
    var b = $d63234f99c1aed29$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $d63234f99c1aed29$var$Va(a) {
    a._valueTracker || (a._valueTracker = $d63234f99c1aed29$var$Ua(a));
}
function $d63234f99c1aed29$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $d63234f99c1aed29$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $d63234f99c1aed29$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $d63234f99c1aed29$var$Ya(a, b) {
    var c = b.checked;
    return $d63234f99c1aed29$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $d63234f99c1aed29$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $d63234f99c1aed29$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $d63234f99c1aed29$var$ab(a, b) {
    b = b.checked;
    null != b && $d63234f99c1aed29$var$ta(a, "checked", b, !1);
}
function $d63234f99c1aed29$var$bb(a, b) {
    $d63234f99c1aed29$var$ab(a, b);
    var c = $d63234f99c1aed29$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $d63234f99c1aed29$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $d63234f99c1aed29$var$cb(a, b.type, $d63234f99c1aed29$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $d63234f99c1aed29$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $d63234f99c1aed29$var$cb(a, b, c) {
    if ("number" !== b || $d63234f99c1aed29$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $d63234f99c1aed29$var$eb = Array.isArray;
function $d63234f99c1aed29$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $d63234f99c1aed29$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $d63234f99c1aed29$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($d63234f99c1aed29$var$p(91));
    return $d63234f99c1aed29$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $d63234f99c1aed29$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($d63234f99c1aed29$var$p(92));
            if ($d63234f99c1aed29$var$eb(c)) {
                if (1 < c.length) throw Error($d63234f99c1aed29$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $d63234f99c1aed29$var$Sa(c)
    };
}
function $d63234f99c1aed29$var$ib(a, b) {
    var c = $d63234f99c1aed29$var$Sa(b.value), d = $d63234f99c1aed29$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $d63234f99c1aed29$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $d63234f99c1aed29$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $d63234f99c1aed29$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $d63234f99c1aed29$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $d63234f99c1aed29$var$mb, $d63234f99c1aed29$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $d63234f99c1aed29$var$mb = $d63234f99c1aed29$var$mb || document.createElement("div");
        $d63234f99c1aed29$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $d63234f99c1aed29$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $d63234f99c1aed29$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $d63234f99c1aed29$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $d63234f99c1aed29$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($d63234f99c1aed29$var$pb).forEach(function(a) {
    $d63234f99c1aed29$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $d63234f99c1aed29$var$pb[b] = $d63234f99c1aed29$var$pb[a];
    });
});
function $d63234f99c1aed29$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $d63234f99c1aed29$var$pb.hasOwnProperty(a) && $d63234f99c1aed29$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $d63234f99c1aed29$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $d63234f99c1aed29$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $d63234f99c1aed29$var$tb = $d63234f99c1aed29$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $d63234f99c1aed29$var$ub(a, b) {
    if (b) {
        if ($d63234f99c1aed29$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($d63234f99c1aed29$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($d63234f99c1aed29$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($d63234f99c1aed29$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($d63234f99c1aed29$var$p(62));
    }
}
function $d63234f99c1aed29$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $d63234f99c1aed29$var$wb = null;
function $d63234f99c1aed29$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $d63234f99c1aed29$var$yb = null, $d63234f99c1aed29$var$zb = null, $d63234f99c1aed29$var$Ab = null;
function $d63234f99c1aed29$var$Bb(a) {
    if (a = $d63234f99c1aed29$var$Cb(a)) {
        if ("function" !== typeof $d63234f99c1aed29$var$yb) throw Error($d63234f99c1aed29$var$p(280));
        var b = a.stateNode;
        b && (b = $d63234f99c1aed29$var$Db(b), $d63234f99c1aed29$var$yb(a.stateNode, a.type, b));
    }
}
function $d63234f99c1aed29$var$Eb(a) {
    $d63234f99c1aed29$var$zb ? $d63234f99c1aed29$var$Ab ? $d63234f99c1aed29$var$Ab.push(a) : $d63234f99c1aed29$var$Ab = [
        a
    ] : $d63234f99c1aed29$var$zb = a;
}
function $d63234f99c1aed29$var$Fb() {
    if ($d63234f99c1aed29$var$zb) {
        var a = $d63234f99c1aed29$var$zb, b = $d63234f99c1aed29$var$Ab;
        $d63234f99c1aed29$var$Ab = $d63234f99c1aed29$var$zb = null;
        $d63234f99c1aed29$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$d63234f99c1aed29$var$Bb(b[a]);
    }
}
function $d63234f99c1aed29$var$Gb(a, b) {
    return a(b);
}
function $d63234f99c1aed29$var$Hb() {}
var $d63234f99c1aed29$var$Ib = !1;
function $d63234f99c1aed29$var$Jb(a, b, c) {
    if ($d63234f99c1aed29$var$Ib) return a(b, c);
    $d63234f99c1aed29$var$Ib = !0;
    try {
        return $d63234f99c1aed29$var$Gb(a, b, c);
    } finally{
        if ($d63234f99c1aed29$var$Ib = !1, null !== $d63234f99c1aed29$var$zb || null !== $d63234f99c1aed29$var$Ab) $d63234f99c1aed29$var$Hb(), $d63234f99c1aed29$var$Fb();
    }
}
function $d63234f99c1aed29$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $d63234f99c1aed29$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($d63234f99c1aed29$var$p(231, b, typeof c));
    return c;
}
var $d63234f99c1aed29$var$Lb = !1;
if ($d63234f99c1aed29$var$ia) try {
    var $d63234f99c1aed29$var$Mb = {};
    Object.defineProperty($d63234f99c1aed29$var$Mb, "passive", {
        get: function() {
            $d63234f99c1aed29$var$Lb = !0;
        }
    });
    window.addEventListener("test", $d63234f99c1aed29$var$Mb, $d63234f99c1aed29$var$Mb);
    window.removeEventListener("test", $d63234f99c1aed29$var$Mb, $d63234f99c1aed29$var$Mb);
} catch (a) {
    $d63234f99c1aed29$var$Lb = !1;
}
function $d63234f99c1aed29$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $d63234f99c1aed29$var$Ob = !1, $d63234f99c1aed29$var$Pb = null, $d63234f99c1aed29$var$Qb = !1, $d63234f99c1aed29$var$Rb = null, $d63234f99c1aed29$var$Sb = {
    onError: function(a) {
        $d63234f99c1aed29$var$Ob = !0;
        $d63234f99c1aed29$var$Pb = a;
    }
};
function $d63234f99c1aed29$var$Tb(a, b, c, d, e, f, g, h, k) {
    $d63234f99c1aed29$var$Ob = !1;
    $d63234f99c1aed29$var$Pb = null;
    $d63234f99c1aed29$var$Nb.apply($d63234f99c1aed29$var$Sb, arguments);
}
function $d63234f99c1aed29$var$Ub(a, b, c, d, e, f, g, h, k) {
    $d63234f99c1aed29$var$Tb.apply(this, arguments);
    if ($d63234f99c1aed29$var$Ob) {
        if ($d63234f99c1aed29$var$Ob) {
            var l = $d63234f99c1aed29$var$Pb;
            $d63234f99c1aed29$var$Ob = !1;
            $d63234f99c1aed29$var$Pb = null;
        } else throw Error($d63234f99c1aed29$var$p(198));
        $d63234f99c1aed29$var$Qb || ($d63234f99c1aed29$var$Qb = !0, $d63234f99c1aed29$var$Rb = l);
    }
}
function $d63234f99c1aed29$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $d63234f99c1aed29$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $d63234f99c1aed29$var$Xb(a) {
    if ($d63234f99c1aed29$var$Vb(a) !== a) throw Error($d63234f99c1aed29$var$p(188));
}
function $d63234f99c1aed29$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $d63234f99c1aed29$var$Vb(a);
        if (null === b) throw Error($d63234f99c1aed29$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $d63234f99c1aed29$var$Xb(e), a;
                if (f === d) return $d63234f99c1aed29$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($d63234f99c1aed29$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($d63234f99c1aed29$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($d63234f99c1aed29$var$p(190));
    }
    if (3 !== c.tag) throw Error($d63234f99c1aed29$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $d63234f99c1aed29$var$Zb(a) {
    a = $d63234f99c1aed29$var$Yb(a);
    return null !== a ? $d63234f99c1aed29$var$$b(a) : null;
}
function $d63234f99c1aed29$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $d63234f99c1aed29$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $d63234f99c1aed29$var$ac = $bIycj.unstable_scheduleCallback, $d63234f99c1aed29$var$bc = $bIycj.unstable_cancelCallback, $d63234f99c1aed29$var$cc = $bIycj.unstable_shouldYield, $d63234f99c1aed29$var$dc = $bIycj.unstable_requestPaint, $d63234f99c1aed29$var$B = $bIycj.unstable_now, $d63234f99c1aed29$var$ec = $bIycj.unstable_getCurrentPriorityLevel, $d63234f99c1aed29$var$fc = $bIycj.unstable_ImmediatePriority, $d63234f99c1aed29$var$gc = $bIycj.unstable_UserBlockingPriority, $d63234f99c1aed29$var$hc = $bIycj.unstable_NormalPriority, $d63234f99c1aed29$var$ic = $bIycj.unstable_LowPriority, $d63234f99c1aed29$var$jc = $bIycj.unstable_IdlePriority, $d63234f99c1aed29$var$kc = null, $d63234f99c1aed29$var$lc = null;
function $d63234f99c1aed29$var$mc(a) {
    if ($d63234f99c1aed29$var$lc && "function" === typeof $d63234f99c1aed29$var$lc.onCommitFiberRoot) try {
        $d63234f99c1aed29$var$lc.onCommitFiberRoot($d63234f99c1aed29$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $d63234f99c1aed29$var$oc = Math.clz32 ? Math.clz32 : $d63234f99c1aed29$var$nc, $d63234f99c1aed29$var$pc = Math.log, $d63234f99c1aed29$var$qc = Math.LN2;
function $d63234f99c1aed29$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($d63234f99c1aed29$var$pc(a) / $d63234f99c1aed29$var$qc | 0) | 0;
}
var $d63234f99c1aed29$var$rc = 64, $d63234f99c1aed29$var$sc = 4194304;
function $d63234f99c1aed29$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $d63234f99c1aed29$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $d63234f99c1aed29$var$tc(h) : (f &= g, 0 !== f && (d = $d63234f99c1aed29$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $d63234f99c1aed29$var$tc(g) : 0 !== f && (d = $d63234f99c1aed29$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $d63234f99c1aed29$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $d63234f99c1aed29$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $d63234f99c1aed29$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $d63234f99c1aed29$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $d63234f99c1aed29$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $d63234f99c1aed29$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $d63234f99c1aed29$var$yc() {
    var a = $d63234f99c1aed29$var$rc;
    $d63234f99c1aed29$var$rc <<= 1;
    0 === ($d63234f99c1aed29$var$rc & 4194240) && ($d63234f99c1aed29$var$rc = 64);
    return a;
}
function $d63234f99c1aed29$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $d63234f99c1aed29$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $d63234f99c1aed29$var$oc(b);
    a[b] = c;
}
function $d63234f99c1aed29$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $d63234f99c1aed29$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $d63234f99c1aed29$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $d63234f99c1aed29$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $d63234f99c1aed29$var$C = 0;
function $d63234f99c1aed29$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $d63234f99c1aed29$var$Ec, $d63234f99c1aed29$var$Fc, $d63234f99c1aed29$var$Gc, $d63234f99c1aed29$var$Hc, $d63234f99c1aed29$var$Ic, $d63234f99c1aed29$var$Jc = !1, $d63234f99c1aed29$var$Kc = [], $d63234f99c1aed29$var$Lc = null, $d63234f99c1aed29$var$Mc = null, $d63234f99c1aed29$var$Nc = null, $d63234f99c1aed29$var$Oc = new Map, $d63234f99c1aed29$var$Pc = new Map, $d63234f99c1aed29$var$Qc = [], $d63234f99c1aed29$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $d63234f99c1aed29$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $d63234f99c1aed29$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $d63234f99c1aed29$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $d63234f99c1aed29$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $d63234f99c1aed29$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $d63234f99c1aed29$var$Pc.delete(b.pointerId);
    }
}
function $d63234f99c1aed29$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $d63234f99c1aed29$var$Cb(b), null !== b && $d63234f99c1aed29$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $d63234f99c1aed29$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $d63234f99c1aed29$var$Lc = $d63234f99c1aed29$var$Tc($d63234f99c1aed29$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $d63234f99c1aed29$var$Mc = $d63234f99c1aed29$var$Tc($d63234f99c1aed29$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $d63234f99c1aed29$var$Nc = $d63234f99c1aed29$var$Tc($d63234f99c1aed29$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $d63234f99c1aed29$var$Oc.set(f, $d63234f99c1aed29$var$Tc($d63234f99c1aed29$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $d63234f99c1aed29$var$Pc.set(f, $d63234f99c1aed29$var$Tc($d63234f99c1aed29$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $d63234f99c1aed29$var$Vc(a) {
    var b = $d63234f99c1aed29$var$Wc(a.target);
    if (null !== b) {
        var c = $d63234f99c1aed29$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $d63234f99c1aed29$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $d63234f99c1aed29$var$Ic(a.priority, function() {
                        $d63234f99c1aed29$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $d63234f99c1aed29$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $d63234f99c1aed29$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $d63234f99c1aed29$var$wb = d;
            c.target.dispatchEvent(d);
            $d63234f99c1aed29$var$wb = null;
        } else return b = $d63234f99c1aed29$var$Cb(c), null !== b && $d63234f99c1aed29$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $d63234f99c1aed29$var$Zc(a, b, c) {
    $d63234f99c1aed29$var$Xc(a) && c.delete(b);
}
function $d63234f99c1aed29$var$$c() {
    $d63234f99c1aed29$var$Jc = !1;
    null !== $d63234f99c1aed29$var$Lc && $d63234f99c1aed29$var$Xc($d63234f99c1aed29$var$Lc) && ($d63234f99c1aed29$var$Lc = null);
    null !== $d63234f99c1aed29$var$Mc && $d63234f99c1aed29$var$Xc($d63234f99c1aed29$var$Mc) && ($d63234f99c1aed29$var$Mc = null);
    null !== $d63234f99c1aed29$var$Nc && $d63234f99c1aed29$var$Xc($d63234f99c1aed29$var$Nc) && ($d63234f99c1aed29$var$Nc = null);
    $d63234f99c1aed29$var$Oc.forEach($d63234f99c1aed29$var$Zc);
    $d63234f99c1aed29$var$Pc.forEach($d63234f99c1aed29$var$Zc);
}
function $d63234f99c1aed29$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $d63234f99c1aed29$var$Jc || ($d63234f99c1aed29$var$Jc = !0, $bIycj.unstable_scheduleCallback($bIycj.unstable_NormalPriority, $d63234f99c1aed29$var$$c)));
}
function $d63234f99c1aed29$var$bd(a) {
    function b(b) {
        return $d63234f99c1aed29$var$ad(b, a);
    }
    if (0 < $d63234f99c1aed29$var$Kc.length) {
        $d63234f99c1aed29$var$ad($d63234f99c1aed29$var$Kc[0], a);
        for(var c = 1; c < $d63234f99c1aed29$var$Kc.length; c++){
            var d = $d63234f99c1aed29$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $d63234f99c1aed29$var$Lc && $d63234f99c1aed29$var$ad($d63234f99c1aed29$var$Lc, a);
    null !== $d63234f99c1aed29$var$Mc && $d63234f99c1aed29$var$ad($d63234f99c1aed29$var$Mc, a);
    null !== $d63234f99c1aed29$var$Nc && $d63234f99c1aed29$var$ad($d63234f99c1aed29$var$Nc, a);
    $d63234f99c1aed29$var$Oc.forEach(b);
    $d63234f99c1aed29$var$Pc.forEach(b);
    for(c = 0; c < $d63234f99c1aed29$var$Qc.length; c++)d = $d63234f99c1aed29$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $d63234f99c1aed29$var$Qc.length && (c = $d63234f99c1aed29$var$Qc[0], null === c.blockedOn);)$d63234f99c1aed29$var$Vc(c), null === c.blockedOn && $d63234f99c1aed29$var$Qc.shift();
}
var $d63234f99c1aed29$var$cd = $d63234f99c1aed29$var$ua.ReactCurrentBatchConfig, $d63234f99c1aed29$var$dd = !0;
function $d63234f99c1aed29$var$ed(a, b, c, d) {
    var e = $d63234f99c1aed29$var$C, f = $d63234f99c1aed29$var$cd.transition;
    $d63234f99c1aed29$var$cd.transition = null;
    try {
        $d63234f99c1aed29$var$C = 1, $d63234f99c1aed29$var$fd(a, b, c, d);
    } finally{
        $d63234f99c1aed29$var$C = e, $d63234f99c1aed29$var$cd.transition = f;
    }
}
function $d63234f99c1aed29$var$gd(a, b, c, d) {
    var e = $d63234f99c1aed29$var$C, f = $d63234f99c1aed29$var$cd.transition;
    $d63234f99c1aed29$var$cd.transition = null;
    try {
        $d63234f99c1aed29$var$C = 4, $d63234f99c1aed29$var$fd(a, b, c, d);
    } finally{
        $d63234f99c1aed29$var$C = e, $d63234f99c1aed29$var$cd.transition = f;
    }
}
function $d63234f99c1aed29$var$fd(a, b, c, d) {
    if ($d63234f99c1aed29$var$dd) {
        var e = $d63234f99c1aed29$var$Yc(a, b, c, d);
        if (null === e) $d63234f99c1aed29$var$hd(a, b, d, $d63234f99c1aed29$var$id, c), $d63234f99c1aed29$var$Sc(a, d);
        else if ($d63234f99c1aed29$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($d63234f99c1aed29$var$Sc(a, d), b & 4 && -1 < $d63234f99c1aed29$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $d63234f99c1aed29$var$Cb(e);
                null !== f && $d63234f99c1aed29$var$Ec(f);
                f = $d63234f99c1aed29$var$Yc(a, b, c, d);
                null === f && $d63234f99c1aed29$var$hd(a, b, d, $d63234f99c1aed29$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $d63234f99c1aed29$var$hd(a, b, d, null, c);
    }
}
var $d63234f99c1aed29$var$id = null;
function $d63234f99c1aed29$var$Yc(a, b, c, d) {
    $d63234f99c1aed29$var$id = null;
    a = $d63234f99c1aed29$var$xb(d);
    a = $d63234f99c1aed29$var$Wc(a);
    if (null !== a) {
        if (b = $d63234f99c1aed29$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $d63234f99c1aed29$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $d63234f99c1aed29$var$id = a;
    return null;
}
function $d63234f99c1aed29$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($d63234f99c1aed29$var$ec()){
                case $d63234f99c1aed29$var$fc:
                    return 1;
                case $d63234f99c1aed29$var$gc:
                    return 4;
                case $d63234f99c1aed29$var$hc:
                case $d63234f99c1aed29$var$ic:
                    return 16;
                case $d63234f99c1aed29$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $d63234f99c1aed29$var$kd = null, $d63234f99c1aed29$var$ld = null, $d63234f99c1aed29$var$md = null;
function $d63234f99c1aed29$var$nd() {
    if ($d63234f99c1aed29$var$md) return $d63234f99c1aed29$var$md;
    var a, b = $d63234f99c1aed29$var$ld, c = b.length, d, e = "value" in $d63234f99c1aed29$var$kd ? $d63234f99c1aed29$var$kd.value : $d63234f99c1aed29$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d63234f99c1aed29$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $d63234f99c1aed29$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $d63234f99c1aed29$var$pd() {
    return !0;
}
function $d63234f99c1aed29$var$qd() {
    return !1;
}
function $d63234f99c1aed29$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $d63234f99c1aed29$var$pd : $d63234f99c1aed29$var$qd;
        this.isPropagationStopped = $d63234f99c1aed29$var$qd;
        return this;
    }
    $d63234f99c1aed29$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $d63234f99c1aed29$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $d63234f99c1aed29$var$pd);
        },
        persist: function() {},
        isPersistent: $d63234f99c1aed29$var$pd
    });
    return b;
}
var $d63234f99c1aed29$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $d63234f99c1aed29$var$td = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$sd), $d63234f99c1aed29$var$ud = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$sd, {
    view: 0,
    detail: 0
}), $d63234f99c1aed29$var$vd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$ud), $d63234f99c1aed29$var$wd, $d63234f99c1aed29$var$xd, $d63234f99c1aed29$var$yd, $d63234f99c1aed29$var$Ad = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $d63234f99c1aed29$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $d63234f99c1aed29$var$yd && ($d63234f99c1aed29$var$yd && "mousemove" === a.type ? ($d63234f99c1aed29$var$wd = a.screenX - $d63234f99c1aed29$var$yd.screenX, $d63234f99c1aed29$var$xd = a.screenY - $d63234f99c1aed29$var$yd.screenY) : $d63234f99c1aed29$var$xd = $d63234f99c1aed29$var$wd = 0, $d63234f99c1aed29$var$yd = a);
        return $d63234f99c1aed29$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $d63234f99c1aed29$var$xd;
    }
}), $d63234f99c1aed29$var$Bd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Ad), $d63234f99c1aed29$var$Cd = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$Ad, {
    dataTransfer: 0
}), $d63234f99c1aed29$var$Dd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Cd), $d63234f99c1aed29$var$Ed = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$ud, {
    relatedTarget: 0
}), $d63234f99c1aed29$var$Fd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Ed), $d63234f99c1aed29$var$Gd = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d63234f99c1aed29$var$Hd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Gd), $d63234f99c1aed29$var$Id = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $d63234f99c1aed29$var$Jd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Id), $d63234f99c1aed29$var$Kd = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$sd, {
    data: 0
}), $d63234f99c1aed29$var$Ld = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Kd), $d63234f99c1aed29$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $d63234f99c1aed29$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $d63234f99c1aed29$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $d63234f99c1aed29$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $d63234f99c1aed29$var$Od[a]) ? !!b[a] : !1;
}
function $d63234f99c1aed29$var$zd() {
    return $d63234f99c1aed29$var$Pd;
}
var $d63234f99c1aed29$var$Qd = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $d63234f99c1aed29$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $d63234f99c1aed29$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $d63234f99c1aed29$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $d63234f99c1aed29$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $d63234f99c1aed29$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $d63234f99c1aed29$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $d63234f99c1aed29$var$Rd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Qd), $d63234f99c1aed29$var$Sd = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $d63234f99c1aed29$var$Td = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Sd), $d63234f99c1aed29$var$Ud = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $d63234f99c1aed29$var$zd
}), $d63234f99c1aed29$var$Vd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Ud), $d63234f99c1aed29$var$Wd = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d63234f99c1aed29$var$Xd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Wd), $d63234f99c1aed29$var$Yd = $d63234f99c1aed29$var$A({}, $d63234f99c1aed29$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $d63234f99c1aed29$var$Zd = $d63234f99c1aed29$var$rd($d63234f99c1aed29$var$Yd), $d63234f99c1aed29$var$$d = [
    9,
    13,
    27,
    32
], $d63234f99c1aed29$var$ae = $d63234f99c1aed29$var$ia && "CompositionEvent" in window, $d63234f99c1aed29$var$be = null;
$d63234f99c1aed29$var$ia && "documentMode" in document && ($d63234f99c1aed29$var$be = document.documentMode);
var $d63234f99c1aed29$var$ce = $d63234f99c1aed29$var$ia && "TextEvent" in window && !$d63234f99c1aed29$var$be, $d63234f99c1aed29$var$de = $d63234f99c1aed29$var$ia && (!$d63234f99c1aed29$var$ae || $d63234f99c1aed29$var$be && 8 < $d63234f99c1aed29$var$be && 11 >= $d63234f99c1aed29$var$be), $d63234f99c1aed29$var$ee = String.fromCharCode(32), $d63234f99c1aed29$var$fe = !1;
function $d63234f99c1aed29$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d63234f99c1aed29$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $d63234f99c1aed29$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $d63234f99c1aed29$var$ie = !1;
function $d63234f99c1aed29$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $d63234f99c1aed29$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $d63234f99c1aed29$var$fe = !0;
            return $d63234f99c1aed29$var$ee;
        case "textInput":
            return a = b.data, a === $d63234f99c1aed29$var$ee && $d63234f99c1aed29$var$fe ? null : a;
        default:
            return null;
    }
}
function $d63234f99c1aed29$var$ke(a, b) {
    if ($d63234f99c1aed29$var$ie) return "compositionend" === a || !$d63234f99c1aed29$var$ae && $d63234f99c1aed29$var$ge(a, b) ? (a = $d63234f99c1aed29$var$nd(), $d63234f99c1aed29$var$md = $d63234f99c1aed29$var$ld = $d63234f99c1aed29$var$kd = null, $d63234f99c1aed29$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $d63234f99c1aed29$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $d63234f99c1aed29$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $d63234f99c1aed29$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$d63234f99c1aed29$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $d63234f99c1aed29$var$ne(a, b, c, d) {
    $d63234f99c1aed29$var$Eb(d);
    b = $d63234f99c1aed29$var$oe(b, "onChange");
    0 < b.length && (c = new $d63234f99c1aed29$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $d63234f99c1aed29$var$pe = null, $d63234f99c1aed29$var$qe = null;
function $d63234f99c1aed29$var$re(a) {
    $d63234f99c1aed29$var$se(a, 0);
}
function $d63234f99c1aed29$var$te(a) {
    var b = $d63234f99c1aed29$var$ue(a);
    if ($d63234f99c1aed29$var$Wa(b)) return a;
}
function $d63234f99c1aed29$var$ve(a, b) {
    if ("change" === a) return b;
}
var $d63234f99c1aed29$var$we = !1;
if ($d63234f99c1aed29$var$ia) {
    var $d63234f99c1aed29$var$xe;
    if ($d63234f99c1aed29$var$ia) {
        var $d63234f99c1aed29$var$ye = "oninput" in document;
        if (!$d63234f99c1aed29$var$ye) {
            var $d63234f99c1aed29$var$ze = document.createElement("div");
            $d63234f99c1aed29$var$ze.setAttribute("oninput", "return;");
            $d63234f99c1aed29$var$ye = "function" === typeof $d63234f99c1aed29$var$ze.oninput;
        }
        $d63234f99c1aed29$var$xe = $d63234f99c1aed29$var$ye;
    } else $d63234f99c1aed29$var$xe = !1;
    $d63234f99c1aed29$var$we = $d63234f99c1aed29$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $d63234f99c1aed29$var$Ae() {
    $d63234f99c1aed29$var$pe && ($d63234f99c1aed29$var$pe.detachEvent("onpropertychange", $d63234f99c1aed29$var$Be), $d63234f99c1aed29$var$qe = $d63234f99c1aed29$var$pe = null);
}
function $d63234f99c1aed29$var$Be(a) {
    if ("value" === a.propertyName && $d63234f99c1aed29$var$te($d63234f99c1aed29$var$qe)) {
        var b = [];
        $d63234f99c1aed29$var$ne(b, $d63234f99c1aed29$var$qe, a, $d63234f99c1aed29$var$xb(a));
        $d63234f99c1aed29$var$Jb($d63234f99c1aed29$var$re, b);
    }
}
function $d63234f99c1aed29$var$Ce(a, b, c) {
    "focusin" === a ? ($d63234f99c1aed29$var$Ae(), $d63234f99c1aed29$var$pe = b, $d63234f99c1aed29$var$qe = c, $d63234f99c1aed29$var$pe.attachEvent("onpropertychange", $d63234f99c1aed29$var$Be)) : "focusout" === a && $d63234f99c1aed29$var$Ae();
}
function $d63234f99c1aed29$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $d63234f99c1aed29$var$te($d63234f99c1aed29$var$qe);
}
function $d63234f99c1aed29$var$Ee(a, b) {
    if ("click" === a) return $d63234f99c1aed29$var$te(b);
}
function $d63234f99c1aed29$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $d63234f99c1aed29$var$te(b);
}
function $d63234f99c1aed29$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d63234f99c1aed29$var$He = "function" === typeof Object.is ? Object.is : $d63234f99c1aed29$var$Ge;
function $d63234f99c1aed29$var$Ie(a, b) {
    if ($d63234f99c1aed29$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$d63234f99c1aed29$var$ja.call(b, e) || !$d63234f99c1aed29$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $d63234f99c1aed29$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $d63234f99c1aed29$var$Ke(a, b) {
    var c = $d63234f99c1aed29$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $d63234f99c1aed29$var$Je(c);
    }
}
function $d63234f99c1aed29$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $d63234f99c1aed29$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $d63234f99c1aed29$var$Me() {
    for(var a = window, b = $d63234f99c1aed29$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $d63234f99c1aed29$var$Xa(a.document);
    }
    return b;
}
function $d63234f99c1aed29$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $d63234f99c1aed29$var$Oe(a) {
    var b = $d63234f99c1aed29$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $d63234f99c1aed29$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $d63234f99c1aed29$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $d63234f99c1aed29$var$Ke(c, f);
                var g = $d63234f99c1aed29$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $d63234f99c1aed29$var$Pe = $d63234f99c1aed29$var$ia && "documentMode" in document && 11 >= document.documentMode, $d63234f99c1aed29$var$Qe = null, $d63234f99c1aed29$var$Re = null, $d63234f99c1aed29$var$Se = null, $d63234f99c1aed29$var$Te = !1;
function $d63234f99c1aed29$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $d63234f99c1aed29$var$Te || null == $d63234f99c1aed29$var$Qe || $d63234f99c1aed29$var$Qe !== $d63234f99c1aed29$var$Xa(d) || (d = $d63234f99c1aed29$var$Qe, "selectionStart" in d && $d63234f99c1aed29$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $d63234f99c1aed29$var$Se && $d63234f99c1aed29$var$Ie($d63234f99c1aed29$var$Se, d) || ($d63234f99c1aed29$var$Se = d, d = $d63234f99c1aed29$var$oe($d63234f99c1aed29$var$Re, "onSelect"), 0 < d.length && (b = new $d63234f99c1aed29$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $d63234f99c1aed29$var$Qe)));
}
function $d63234f99c1aed29$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $d63234f99c1aed29$var$We = {
    animationend: $d63234f99c1aed29$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $d63234f99c1aed29$var$Ve("Animation", "AnimationIteration"),
    animationstart: $d63234f99c1aed29$var$Ve("Animation", "AnimationStart"),
    transitionend: $d63234f99c1aed29$var$Ve("Transition", "TransitionEnd")
}, $d63234f99c1aed29$var$Xe = {}, $d63234f99c1aed29$var$Ye = {};
$d63234f99c1aed29$var$ia && ($d63234f99c1aed29$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $d63234f99c1aed29$var$We.animationend.animation, delete $d63234f99c1aed29$var$We.animationiteration.animation, delete $d63234f99c1aed29$var$We.animationstart.animation), "TransitionEvent" in window || delete $d63234f99c1aed29$var$We.transitionend.transition);
function $d63234f99c1aed29$var$Ze(a) {
    if ($d63234f99c1aed29$var$Xe[a]) return $d63234f99c1aed29$var$Xe[a];
    if (!$d63234f99c1aed29$var$We[a]) return a;
    var b = $d63234f99c1aed29$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $d63234f99c1aed29$var$Ye) return $d63234f99c1aed29$var$Xe[a] = b[c];
    return a;
}
var $d63234f99c1aed29$var$$e = $d63234f99c1aed29$var$Ze("animationend"), $d63234f99c1aed29$var$af = $d63234f99c1aed29$var$Ze("animationiteration"), $d63234f99c1aed29$var$bf = $d63234f99c1aed29$var$Ze("animationstart"), $d63234f99c1aed29$var$cf = $d63234f99c1aed29$var$Ze("transitionend"), $d63234f99c1aed29$var$df = new Map, $d63234f99c1aed29$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $d63234f99c1aed29$var$ff(a, b) {
    $d63234f99c1aed29$var$df.set(a, b);
    $d63234f99c1aed29$var$fa(b, [
        a
    ]);
}
for(var $d63234f99c1aed29$var$gf = 0; $d63234f99c1aed29$var$gf < $d63234f99c1aed29$var$ef.length; $d63234f99c1aed29$var$gf++){
    var $d63234f99c1aed29$var$hf = $d63234f99c1aed29$var$ef[$d63234f99c1aed29$var$gf], $d63234f99c1aed29$var$jf = $d63234f99c1aed29$var$hf.toLowerCase(), $d63234f99c1aed29$var$kf = $d63234f99c1aed29$var$hf[0].toUpperCase() + $d63234f99c1aed29$var$hf.slice(1);
    $d63234f99c1aed29$var$ff($d63234f99c1aed29$var$jf, "on" + $d63234f99c1aed29$var$kf);
}
$d63234f99c1aed29$var$ff($d63234f99c1aed29$var$$e, "onAnimationEnd");
$d63234f99c1aed29$var$ff($d63234f99c1aed29$var$af, "onAnimationIteration");
$d63234f99c1aed29$var$ff($d63234f99c1aed29$var$bf, "onAnimationStart");
$d63234f99c1aed29$var$ff("dblclick", "onDoubleClick");
$d63234f99c1aed29$var$ff("focusin", "onFocus");
$d63234f99c1aed29$var$ff("focusout", "onBlur");
$d63234f99c1aed29$var$ff($d63234f99c1aed29$var$cf, "onTransitionEnd");
$d63234f99c1aed29$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$d63234f99c1aed29$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$d63234f99c1aed29$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$d63234f99c1aed29$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$d63234f99c1aed29$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$d63234f99c1aed29$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$d63234f99c1aed29$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$d63234f99c1aed29$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$d63234f99c1aed29$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$d63234f99c1aed29$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $d63234f99c1aed29$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $d63234f99c1aed29$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($d63234f99c1aed29$var$lf));
function $d63234f99c1aed29$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $d63234f99c1aed29$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $d63234f99c1aed29$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $d63234f99c1aed29$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $d63234f99c1aed29$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($d63234f99c1aed29$var$Qb) throw a = $d63234f99c1aed29$var$Rb, $d63234f99c1aed29$var$Qb = !1, $d63234f99c1aed29$var$Rb = null, a;
}
function $d63234f99c1aed29$var$D(a, b) {
    var c = b[$d63234f99c1aed29$var$of];
    void 0 === c && (c = b[$d63234f99c1aed29$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($d63234f99c1aed29$var$pf(b, a, 2, !1), c.add(d));
}
function $d63234f99c1aed29$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $d63234f99c1aed29$var$pf(c, a, d, b);
}
var $d63234f99c1aed29$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $d63234f99c1aed29$var$sf(a) {
    if (!a[$d63234f99c1aed29$var$rf]) {
        a[$d63234f99c1aed29$var$rf] = !0;
        $d63234f99c1aed29$var$da.forEach(function(b) {
            "selectionchange" !== b && ($d63234f99c1aed29$var$mf.has(b) || $d63234f99c1aed29$var$qf(b, !1, a), $d63234f99c1aed29$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$d63234f99c1aed29$var$rf] || (b[$d63234f99c1aed29$var$rf] = !0, $d63234f99c1aed29$var$qf("selectionchange", !1, b));
    }
}
function $d63234f99c1aed29$var$pf(a, b, c, d) {
    switch($d63234f99c1aed29$var$jd(b)){
        case 1:
            var e = $d63234f99c1aed29$var$ed;
            break;
        case 4:
            e = $d63234f99c1aed29$var$gd;
            break;
        default:
            e = $d63234f99c1aed29$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$d63234f99c1aed29$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $d63234f99c1aed29$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $d63234f99c1aed29$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $d63234f99c1aed29$var$Jb(function() {
        var d = f, e = $d63234f99c1aed29$var$xb(c), g = [];
        a: {
            var h = $d63234f99c1aed29$var$df.get(a);
            if (void 0 !== h) {
                var k = $d63234f99c1aed29$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $d63234f99c1aed29$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $d63234f99c1aed29$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $d63234f99c1aed29$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $d63234f99c1aed29$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $d63234f99c1aed29$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $d63234f99c1aed29$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $d63234f99c1aed29$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $d63234f99c1aed29$var$Vd;
                        break;
                    case $d63234f99c1aed29$var$$e:
                    case $d63234f99c1aed29$var$af:
                    case $d63234f99c1aed29$var$bf:
                        k = $d63234f99c1aed29$var$Hd;
                        break;
                    case $d63234f99c1aed29$var$cf:
                        k = $d63234f99c1aed29$var$Xd;
                        break;
                    case "scroll":
                        k = $d63234f99c1aed29$var$vd;
                        break;
                    case "wheel":
                        k = $d63234f99c1aed29$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $d63234f99c1aed29$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $d63234f99c1aed29$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $d63234f99c1aed29$var$Kb(w, x), null != F && t.push($d63234f99c1aed29$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $d63234f99c1aed29$var$wb && (n = c.relatedTarget || c.fromElement) && ($d63234f99c1aed29$var$Wc(n) || n[$d63234f99c1aed29$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $d63234f99c1aed29$var$Wc(n) : null, null !== n && (J = $d63234f99c1aed29$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $d63234f99c1aed29$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $d63234f99c1aed29$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $d63234f99c1aed29$var$ue(k);
                        u = null == n ? h : $d63234f99c1aed29$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $d63234f99c1aed29$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $d63234f99c1aed29$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $d63234f99c1aed29$var$vf(F))u++;
                            for(; 0 < w - u;)t = $d63234f99c1aed29$var$vf(t), w--;
                            for(; 0 < u - w;)x = $d63234f99c1aed29$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $d63234f99c1aed29$var$vf(t);
                                x = $d63234f99c1aed29$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $d63234f99c1aed29$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $d63234f99c1aed29$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $d63234f99c1aed29$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $d63234f99c1aed29$var$ve;
                else if ($d63234f99c1aed29$var$me(h)) {
                    if ($d63234f99c1aed29$var$we) na = $d63234f99c1aed29$var$Fe;
                    else {
                        na = $d63234f99c1aed29$var$De;
                        var xa = $d63234f99c1aed29$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $d63234f99c1aed29$var$Ee);
                if (na && (na = na(a, d))) {
                    $d63234f99c1aed29$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $d63234f99c1aed29$var$cb(h, "number", h.value);
            }
            xa = d ? $d63234f99c1aed29$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($d63234f99c1aed29$var$me(xa) || "true" === xa.contentEditable) $d63234f99c1aed29$var$Qe = xa, $d63234f99c1aed29$var$Re = d, $d63234f99c1aed29$var$Se = null;
                    break;
                case "focusout":
                    $d63234f99c1aed29$var$Se = $d63234f99c1aed29$var$Re = $d63234f99c1aed29$var$Qe = null;
                    break;
                case "mousedown":
                    $d63234f99c1aed29$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $d63234f99c1aed29$var$Te = !1;
                    $d63234f99c1aed29$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($d63234f99c1aed29$var$Pe) break;
                case "keydown":
                case "keyup":
                    $d63234f99c1aed29$var$Ue(g, c, e);
            }
            var $a;
            if ($d63234f99c1aed29$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $d63234f99c1aed29$var$ie ? $d63234f99c1aed29$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($d63234f99c1aed29$var$de && "ko" !== c.locale && ($d63234f99c1aed29$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $d63234f99c1aed29$var$ie && ($a = $d63234f99c1aed29$var$nd()) : ($d63234f99c1aed29$var$kd = e, $d63234f99c1aed29$var$ld = "value" in $d63234f99c1aed29$var$kd ? $d63234f99c1aed29$var$kd.value : $d63234f99c1aed29$var$kd.textContent, $d63234f99c1aed29$var$ie = !0)), xa = $d63234f99c1aed29$var$oe(d, ba), 0 < xa.length && (ba = new $d63234f99c1aed29$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $d63234f99c1aed29$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $d63234f99c1aed29$var$ce ? $d63234f99c1aed29$var$je(a, c) : $d63234f99c1aed29$var$ke(a, c)) d = $d63234f99c1aed29$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $d63234f99c1aed29$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $d63234f99c1aed29$var$se(g, b);
    });
}
function $d63234f99c1aed29$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $d63234f99c1aed29$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $d63234f99c1aed29$var$Kb(a, c), null != f && d.unshift($d63234f99c1aed29$var$tf(a, f, e)), f = $d63234f99c1aed29$var$Kb(a, b), null != f && d.push($d63234f99c1aed29$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $d63234f99c1aed29$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $d63234f99c1aed29$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $d63234f99c1aed29$var$Kb(c, f), null != k && g.unshift($d63234f99c1aed29$var$tf(c, k, h))) : e || (k = $d63234f99c1aed29$var$Kb(c, f), null != k && g.push($d63234f99c1aed29$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $d63234f99c1aed29$var$xf = /\r\n?/g, $d63234f99c1aed29$var$yf = /\u0000|\uFFFD/g;
function $d63234f99c1aed29$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($d63234f99c1aed29$var$xf, "\n").replace($d63234f99c1aed29$var$yf, "");
}
function $d63234f99c1aed29$var$Af(a, b, c) {
    b = $d63234f99c1aed29$var$zf(b);
    if ($d63234f99c1aed29$var$zf(a) !== b && c) throw Error($d63234f99c1aed29$var$p(425));
}
function $d63234f99c1aed29$var$Bf() {}
var $d63234f99c1aed29$var$Cf = null, $d63234f99c1aed29$var$Df = null;
function $d63234f99c1aed29$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $d63234f99c1aed29$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $d63234f99c1aed29$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $d63234f99c1aed29$var$Hf = "function" === typeof Promise ? Promise : void 0, $d63234f99c1aed29$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $d63234f99c1aed29$var$Hf ? function(a) {
    return $d63234f99c1aed29$var$Hf.resolve(null).then(a).catch($d63234f99c1aed29$var$If);
} : $d63234f99c1aed29$var$Ff;
function $d63234f99c1aed29$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $d63234f99c1aed29$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $d63234f99c1aed29$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $d63234f99c1aed29$var$bd(b);
}
function $d63234f99c1aed29$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $d63234f99c1aed29$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $d63234f99c1aed29$var$Nf = Math.random().toString(36).slice(2), $d63234f99c1aed29$var$Of = "__reactFiber$" + $d63234f99c1aed29$var$Nf, $d63234f99c1aed29$var$Pf = "__reactProps$" + $d63234f99c1aed29$var$Nf, $d63234f99c1aed29$var$uf = "__reactContainer$" + $d63234f99c1aed29$var$Nf, $d63234f99c1aed29$var$of = "__reactEvents$" + $d63234f99c1aed29$var$Nf, $d63234f99c1aed29$var$Qf = "__reactListeners$" + $d63234f99c1aed29$var$Nf, $d63234f99c1aed29$var$Rf = "__reactHandles$" + $d63234f99c1aed29$var$Nf;
function $d63234f99c1aed29$var$Wc(a) {
    var b = a[$d63234f99c1aed29$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$d63234f99c1aed29$var$uf] || c[$d63234f99c1aed29$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $d63234f99c1aed29$var$Mf(a); null !== a;){
                if (c = a[$d63234f99c1aed29$var$Of]) return c;
                a = $d63234f99c1aed29$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $d63234f99c1aed29$var$Cb(a) {
    a = a[$d63234f99c1aed29$var$Of] || a[$d63234f99c1aed29$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $d63234f99c1aed29$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($d63234f99c1aed29$var$p(33));
}
function $d63234f99c1aed29$var$Db(a) {
    return a[$d63234f99c1aed29$var$Pf] || null;
}
var $d63234f99c1aed29$var$Sf = [], $d63234f99c1aed29$var$Tf = -1;
function $d63234f99c1aed29$var$Uf(a) {
    return {
        current: a
    };
}
function $d63234f99c1aed29$var$E(a) {
    0 > $d63234f99c1aed29$var$Tf || (a.current = $d63234f99c1aed29$var$Sf[$d63234f99c1aed29$var$Tf], $d63234f99c1aed29$var$Sf[$d63234f99c1aed29$var$Tf] = null, $d63234f99c1aed29$var$Tf--);
}
function $d63234f99c1aed29$var$G(a, b) {
    $d63234f99c1aed29$var$Tf++;
    $d63234f99c1aed29$var$Sf[$d63234f99c1aed29$var$Tf] = a.current;
    a.current = b;
}
var $d63234f99c1aed29$var$Vf = {}, $d63234f99c1aed29$var$H = $d63234f99c1aed29$var$Uf($d63234f99c1aed29$var$Vf), $d63234f99c1aed29$var$Wf = $d63234f99c1aed29$var$Uf(!1), $d63234f99c1aed29$var$Xf = $d63234f99c1aed29$var$Vf;
function $d63234f99c1aed29$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $d63234f99c1aed29$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $d63234f99c1aed29$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $d63234f99c1aed29$var$$f() {
    $d63234f99c1aed29$var$E($d63234f99c1aed29$var$Wf);
    $d63234f99c1aed29$var$E($d63234f99c1aed29$var$H);
}
function $d63234f99c1aed29$var$ag(a, b, c) {
    if ($d63234f99c1aed29$var$H.current !== $d63234f99c1aed29$var$Vf) throw Error($d63234f99c1aed29$var$p(168));
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$H, b);
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$Wf, c);
}
function $d63234f99c1aed29$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($d63234f99c1aed29$var$p(108, $d63234f99c1aed29$var$Ra(a) || "Unknown", e));
    return $d63234f99c1aed29$var$A({}, c, d);
}
function $d63234f99c1aed29$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $d63234f99c1aed29$var$Vf;
    $d63234f99c1aed29$var$Xf = $d63234f99c1aed29$var$H.current;
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$H, a);
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$Wf, $d63234f99c1aed29$var$Wf.current);
    return !0;
}
function $d63234f99c1aed29$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($d63234f99c1aed29$var$p(169));
    c ? (a = $d63234f99c1aed29$var$bg(a, b, $d63234f99c1aed29$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $d63234f99c1aed29$var$E($d63234f99c1aed29$var$Wf), $d63234f99c1aed29$var$E($d63234f99c1aed29$var$H), $d63234f99c1aed29$var$G($d63234f99c1aed29$var$H, a)) : $d63234f99c1aed29$var$E($d63234f99c1aed29$var$Wf);
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$Wf, c);
}
var $d63234f99c1aed29$var$eg = null, $d63234f99c1aed29$var$fg = !1, $d63234f99c1aed29$var$gg = !1;
function $d63234f99c1aed29$var$hg(a) {
    null === $d63234f99c1aed29$var$eg ? $d63234f99c1aed29$var$eg = [
        a
    ] : $d63234f99c1aed29$var$eg.push(a);
}
function $d63234f99c1aed29$var$ig(a) {
    $d63234f99c1aed29$var$fg = !0;
    $d63234f99c1aed29$var$hg(a);
}
function $d63234f99c1aed29$var$jg() {
    if (!$d63234f99c1aed29$var$gg && null !== $d63234f99c1aed29$var$eg) {
        $d63234f99c1aed29$var$gg = !0;
        var a = 0, b = $d63234f99c1aed29$var$C;
        try {
            var c = $d63234f99c1aed29$var$eg;
            for($d63234f99c1aed29$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $d63234f99c1aed29$var$eg = null;
            $d63234f99c1aed29$var$fg = !1;
        } catch (e) {
            throw null !== $d63234f99c1aed29$var$eg && ($d63234f99c1aed29$var$eg = $d63234f99c1aed29$var$eg.slice(a + 1)), $d63234f99c1aed29$var$ac($d63234f99c1aed29$var$fc, $d63234f99c1aed29$var$jg), e;
        } finally{
            $d63234f99c1aed29$var$C = b, $d63234f99c1aed29$var$gg = !1;
        }
    }
    return null;
}
var $d63234f99c1aed29$var$kg = [], $d63234f99c1aed29$var$lg = 0, $d63234f99c1aed29$var$mg = null, $d63234f99c1aed29$var$ng = 0, $d63234f99c1aed29$var$og = [], $d63234f99c1aed29$var$pg = 0, $d63234f99c1aed29$var$qg = null, $d63234f99c1aed29$var$rg = 1, $d63234f99c1aed29$var$sg = "";
function $d63234f99c1aed29$var$tg(a, b) {
    $d63234f99c1aed29$var$kg[$d63234f99c1aed29$var$lg++] = $d63234f99c1aed29$var$ng;
    $d63234f99c1aed29$var$kg[$d63234f99c1aed29$var$lg++] = $d63234f99c1aed29$var$mg;
    $d63234f99c1aed29$var$mg = a;
    $d63234f99c1aed29$var$ng = b;
}
function $d63234f99c1aed29$var$ug(a, b, c) {
    $d63234f99c1aed29$var$og[$d63234f99c1aed29$var$pg++] = $d63234f99c1aed29$var$rg;
    $d63234f99c1aed29$var$og[$d63234f99c1aed29$var$pg++] = $d63234f99c1aed29$var$sg;
    $d63234f99c1aed29$var$og[$d63234f99c1aed29$var$pg++] = $d63234f99c1aed29$var$qg;
    $d63234f99c1aed29$var$qg = a;
    var d = $d63234f99c1aed29$var$rg;
    a = $d63234f99c1aed29$var$sg;
    var e = 32 - $d63234f99c1aed29$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $d63234f99c1aed29$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $d63234f99c1aed29$var$rg = 1 << 32 - $d63234f99c1aed29$var$oc(b) + e | c << e | d;
        $d63234f99c1aed29$var$sg = f + a;
    } else $d63234f99c1aed29$var$rg = 1 << f | c << e | d, $d63234f99c1aed29$var$sg = a;
}
function $d63234f99c1aed29$var$vg(a) {
    null !== a.return && ($d63234f99c1aed29$var$tg(a, 1), $d63234f99c1aed29$var$ug(a, 1, 0));
}
function $d63234f99c1aed29$var$wg(a) {
    for(; a === $d63234f99c1aed29$var$mg;)$d63234f99c1aed29$var$mg = $d63234f99c1aed29$var$kg[--$d63234f99c1aed29$var$lg], $d63234f99c1aed29$var$kg[$d63234f99c1aed29$var$lg] = null, $d63234f99c1aed29$var$ng = $d63234f99c1aed29$var$kg[--$d63234f99c1aed29$var$lg], $d63234f99c1aed29$var$kg[$d63234f99c1aed29$var$lg] = null;
    for(; a === $d63234f99c1aed29$var$qg;)$d63234f99c1aed29$var$qg = $d63234f99c1aed29$var$og[--$d63234f99c1aed29$var$pg], $d63234f99c1aed29$var$og[$d63234f99c1aed29$var$pg] = null, $d63234f99c1aed29$var$sg = $d63234f99c1aed29$var$og[--$d63234f99c1aed29$var$pg], $d63234f99c1aed29$var$og[$d63234f99c1aed29$var$pg] = null, $d63234f99c1aed29$var$rg = $d63234f99c1aed29$var$og[--$d63234f99c1aed29$var$pg], $d63234f99c1aed29$var$og[$d63234f99c1aed29$var$pg] = null;
}
var $d63234f99c1aed29$var$xg = null, $d63234f99c1aed29$var$yg = null, $d63234f99c1aed29$var$I = !1, $d63234f99c1aed29$var$zg = null;
function $d63234f99c1aed29$var$Ag(a, b) {
    var c = $d63234f99c1aed29$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $d63234f99c1aed29$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $d63234f99c1aed29$var$xg = a, $d63234f99c1aed29$var$yg = $d63234f99c1aed29$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $d63234f99c1aed29$var$xg = a, $d63234f99c1aed29$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $d63234f99c1aed29$var$qg ? {
                id: $d63234f99c1aed29$var$rg,
                overflow: $d63234f99c1aed29$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $d63234f99c1aed29$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $d63234f99c1aed29$var$xg = a, $d63234f99c1aed29$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $d63234f99c1aed29$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $d63234f99c1aed29$var$Eg(a) {
    if ($d63234f99c1aed29$var$I) {
        var b = $d63234f99c1aed29$var$yg;
        if (b) {
            var c = b;
            if (!$d63234f99c1aed29$var$Cg(a, b)) {
                if ($d63234f99c1aed29$var$Dg(a)) throw Error($d63234f99c1aed29$var$p(418));
                b = $d63234f99c1aed29$var$Lf(c.nextSibling);
                var d = $d63234f99c1aed29$var$xg;
                b && $d63234f99c1aed29$var$Cg(a, b) ? $d63234f99c1aed29$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $d63234f99c1aed29$var$I = !1, $d63234f99c1aed29$var$xg = a);
            }
        } else {
            if ($d63234f99c1aed29$var$Dg(a)) throw Error($d63234f99c1aed29$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $d63234f99c1aed29$var$I = !1;
            $d63234f99c1aed29$var$xg = a;
        }
    }
}
function $d63234f99c1aed29$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $d63234f99c1aed29$var$xg = a;
}
function $d63234f99c1aed29$var$Gg(a) {
    if (a !== $d63234f99c1aed29$var$xg) return !1;
    if (!$d63234f99c1aed29$var$I) return $d63234f99c1aed29$var$Fg(a), $d63234f99c1aed29$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$d63234f99c1aed29$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $d63234f99c1aed29$var$yg)) {
        if ($d63234f99c1aed29$var$Dg(a)) throw $d63234f99c1aed29$var$Hg(), Error($d63234f99c1aed29$var$p(418));
        for(; b;)$d63234f99c1aed29$var$Ag(a, b), b = $d63234f99c1aed29$var$Lf(b.nextSibling);
    }
    $d63234f99c1aed29$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($d63234f99c1aed29$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $d63234f99c1aed29$var$yg = $d63234f99c1aed29$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $d63234f99c1aed29$var$yg = null;
        }
    } else $d63234f99c1aed29$var$yg = $d63234f99c1aed29$var$xg ? $d63234f99c1aed29$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $d63234f99c1aed29$var$Hg() {
    for(var a = $d63234f99c1aed29$var$yg; a;)a = $d63234f99c1aed29$var$Lf(a.nextSibling);
}
function $d63234f99c1aed29$var$Ig() {
    $d63234f99c1aed29$var$yg = $d63234f99c1aed29$var$xg = null;
    $d63234f99c1aed29$var$I = !1;
}
function $d63234f99c1aed29$var$Jg(a) {
    null === $d63234f99c1aed29$var$zg ? $d63234f99c1aed29$var$zg = [
        a
    ] : $d63234f99c1aed29$var$zg.push(a);
}
var $d63234f99c1aed29$var$Kg = $d63234f99c1aed29$var$ua.ReactCurrentBatchConfig;
function $d63234f99c1aed29$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($d63234f99c1aed29$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($d63234f99c1aed29$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($d63234f99c1aed29$var$p(284));
        if (!c._owner) throw Error($d63234f99c1aed29$var$p(290, a));
    }
    return a;
}
function $d63234f99c1aed29$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($d63234f99c1aed29$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $d63234f99c1aed29$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $d63234f99c1aed29$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $d63234f99c1aed29$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $d63234f99c1aed29$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $d63234f99c1aed29$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $d63234f99c1aed29$var$Ha && $d63234f99c1aed29$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $d63234f99c1aed29$var$Lg(a, b, c), d.return = a, d;
        d = $d63234f99c1aed29$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $d63234f99c1aed29$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $d63234f99c1aed29$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $d63234f99c1aed29$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $d63234f99c1aed29$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $d63234f99c1aed29$var$va:
                    return c = $d63234f99c1aed29$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $d63234f99c1aed29$var$Lg(a, null, b), c.return = a, c;
                case $d63234f99c1aed29$var$wa:
                    return b = $d63234f99c1aed29$var$Sg(b, a.mode, c), b.return = a, b;
                case $d63234f99c1aed29$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($d63234f99c1aed29$var$eb(b) || $d63234f99c1aed29$var$Ka(b)) return b = $d63234f99c1aed29$var$Tg(b, a.mode, c, null), b.return = a, b;
            $d63234f99c1aed29$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $d63234f99c1aed29$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $d63234f99c1aed29$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $d63234f99c1aed29$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($d63234f99c1aed29$var$eb(c) || $d63234f99c1aed29$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $d63234f99c1aed29$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $d63234f99c1aed29$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $d63234f99c1aed29$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $d63234f99c1aed29$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($d63234f99c1aed29$var$eb(d) || $d63234f99c1aed29$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $d63234f99c1aed29$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $d63234f99c1aed29$var$I && $d63234f99c1aed29$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $d63234f99c1aed29$var$I && $d63234f99c1aed29$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $d63234f99c1aed29$var$I && $d63234f99c1aed29$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $d63234f99c1aed29$var$Ka(h);
        if ("function" !== typeof l) throw Error($d63234f99c1aed29$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($d63234f99c1aed29$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $d63234f99c1aed29$var$I && $d63234f99c1aed29$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $d63234f99c1aed29$var$I && $d63234f99c1aed29$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $d63234f99c1aed29$var$I && $d63234f99c1aed29$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $d63234f99c1aed29$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $d63234f99c1aed29$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $d63234f99c1aed29$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $d63234f99c1aed29$var$Ha && $d63234f99c1aed29$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $d63234f99c1aed29$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $d63234f99c1aed29$var$ya ? (d = $d63234f99c1aed29$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $d63234f99c1aed29$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $d63234f99c1aed29$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $d63234f99c1aed29$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $d63234f99c1aed29$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $d63234f99c1aed29$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($d63234f99c1aed29$var$eb(f)) return n(a, d, f, h);
            if ($d63234f99c1aed29$var$Ka(f)) return t(a, d, f, h);
            $d63234f99c1aed29$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $d63234f99c1aed29$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $d63234f99c1aed29$var$Ug = $d63234f99c1aed29$var$Og(!0), $d63234f99c1aed29$var$Vg = $d63234f99c1aed29$var$Og(!1), $d63234f99c1aed29$var$Wg = $d63234f99c1aed29$var$Uf(null), $d63234f99c1aed29$var$Xg = null, $d63234f99c1aed29$var$Yg = null, $d63234f99c1aed29$var$Zg = null;
function $d63234f99c1aed29$var$$g() {
    $d63234f99c1aed29$var$Zg = $d63234f99c1aed29$var$Yg = $d63234f99c1aed29$var$Xg = null;
}
function $d63234f99c1aed29$var$ah(a) {
    var b = $d63234f99c1aed29$var$Wg.current;
    $d63234f99c1aed29$var$E($d63234f99c1aed29$var$Wg);
    a._currentValue = b;
}
function $d63234f99c1aed29$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $d63234f99c1aed29$var$ch(a, b) {
    $d63234f99c1aed29$var$Xg = a;
    $d63234f99c1aed29$var$Zg = $d63234f99c1aed29$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($d63234f99c1aed29$var$dh = !0), a.firstContext = null);
}
function $d63234f99c1aed29$var$eh(a) {
    var b = a._currentValue;
    if ($d63234f99c1aed29$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $d63234f99c1aed29$var$Yg) {
            if (null === $d63234f99c1aed29$var$Xg) throw Error($d63234f99c1aed29$var$p(308));
            $d63234f99c1aed29$var$Yg = a;
            $d63234f99c1aed29$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $d63234f99c1aed29$var$Yg = $d63234f99c1aed29$var$Yg.next = a;
    }
    return b;
}
var $d63234f99c1aed29$var$fh = null;
function $d63234f99c1aed29$var$gh(a) {
    null === $d63234f99c1aed29$var$fh ? $d63234f99c1aed29$var$fh = [
        a
    ] : $d63234f99c1aed29$var$fh.push(a);
}
function $d63234f99c1aed29$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $d63234f99c1aed29$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $d63234f99c1aed29$var$ih(a, d);
}
function $d63234f99c1aed29$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $d63234f99c1aed29$var$jh = !1;
function $d63234f99c1aed29$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $d63234f99c1aed29$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $d63234f99c1aed29$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $d63234f99c1aed29$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($d63234f99c1aed29$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $d63234f99c1aed29$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $d63234f99c1aed29$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $d63234f99c1aed29$var$ih(a, c);
}
function $d63234f99c1aed29$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $d63234f99c1aed29$var$Cc(a, c);
    }
}
function $d63234f99c1aed29$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $d63234f99c1aed29$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $d63234f99c1aed29$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $d63234f99c1aed29$var$A({}, q, r);
                            break a;
                        case 2:
                            $d63234f99c1aed29$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $d63234f99c1aed29$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $d63234f99c1aed29$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($d63234f99c1aed29$var$p(191, e));
            e.call(d);
        }
    }
}
var $d63234f99c1aed29$var$th = {}, $d63234f99c1aed29$var$uh = $d63234f99c1aed29$var$Uf($d63234f99c1aed29$var$th), $d63234f99c1aed29$var$vh = $d63234f99c1aed29$var$Uf($d63234f99c1aed29$var$th), $d63234f99c1aed29$var$wh = $d63234f99c1aed29$var$Uf($d63234f99c1aed29$var$th);
function $d63234f99c1aed29$var$xh(a) {
    if (a === $d63234f99c1aed29$var$th) throw Error($d63234f99c1aed29$var$p(174));
    return a;
}
function $d63234f99c1aed29$var$yh(a, b) {
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$wh, b);
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$vh, a);
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$uh, $d63234f99c1aed29$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $d63234f99c1aed29$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $d63234f99c1aed29$var$lb(b, a);
    }
    $d63234f99c1aed29$var$E($d63234f99c1aed29$var$uh);
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$uh, b);
}
function $d63234f99c1aed29$var$zh() {
    $d63234f99c1aed29$var$E($d63234f99c1aed29$var$uh);
    $d63234f99c1aed29$var$E($d63234f99c1aed29$var$vh);
    $d63234f99c1aed29$var$E($d63234f99c1aed29$var$wh);
}
function $d63234f99c1aed29$var$Ah(a) {
    $d63234f99c1aed29$var$xh($d63234f99c1aed29$var$wh.current);
    var b = $d63234f99c1aed29$var$xh($d63234f99c1aed29$var$uh.current);
    var c = $d63234f99c1aed29$var$lb(b, a.type);
    b !== c && ($d63234f99c1aed29$var$G($d63234f99c1aed29$var$vh, a), $d63234f99c1aed29$var$G($d63234f99c1aed29$var$uh, c));
}
function $d63234f99c1aed29$var$Bh(a) {
    $d63234f99c1aed29$var$vh.current === a && ($d63234f99c1aed29$var$E($d63234f99c1aed29$var$uh), $d63234f99c1aed29$var$E($d63234f99c1aed29$var$vh));
}
var $d63234f99c1aed29$var$L = $d63234f99c1aed29$var$Uf(0);
function $d63234f99c1aed29$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $d63234f99c1aed29$var$Dh = [];
function $d63234f99c1aed29$var$Eh() {
    for(var a = 0; a < $d63234f99c1aed29$var$Dh.length; a++)$d63234f99c1aed29$var$Dh[a]._workInProgressVersionPrimary = null;
    $d63234f99c1aed29$var$Dh.length = 0;
}
var $d63234f99c1aed29$var$Fh = $d63234f99c1aed29$var$ua.ReactCurrentDispatcher, $d63234f99c1aed29$var$Gh = $d63234f99c1aed29$var$ua.ReactCurrentBatchConfig, $d63234f99c1aed29$var$Hh = 0, $d63234f99c1aed29$var$M = null, $d63234f99c1aed29$var$N = null, $d63234f99c1aed29$var$O = null, $d63234f99c1aed29$var$Ih = !1, $d63234f99c1aed29$var$Jh = !1, $d63234f99c1aed29$var$Kh = 0, $d63234f99c1aed29$var$Lh = 0;
function $d63234f99c1aed29$var$P() {
    throw Error($d63234f99c1aed29$var$p(321));
}
function $d63234f99c1aed29$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$d63234f99c1aed29$var$He(a[c], b[c])) return !1;
    return !0;
}
function $d63234f99c1aed29$var$Nh(a, b, c, d, e, f) {
    $d63234f99c1aed29$var$Hh = f;
    $d63234f99c1aed29$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $d63234f99c1aed29$var$Fh.current = null === a || null === a.memoizedState ? $d63234f99c1aed29$var$Oh : $d63234f99c1aed29$var$Ph;
    a = c(d, e);
    if ($d63234f99c1aed29$var$Jh) {
        f = 0;
        do {
            $d63234f99c1aed29$var$Jh = !1;
            $d63234f99c1aed29$var$Kh = 0;
            if (25 <= f) throw Error($d63234f99c1aed29$var$p(301));
            f += 1;
            $d63234f99c1aed29$var$O = $d63234f99c1aed29$var$N = null;
            b.updateQueue = null;
            $d63234f99c1aed29$var$Fh.current = $d63234f99c1aed29$var$Qh;
            a = c(d, e);
        }while ($d63234f99c1aed29$var$Jh);
    }
    $d63234f99c1aed29$var$Fh.current = $d63234f99c1aed29$var$Rh;
    b = null !== $d63234f99c1aed29$var$N && null !== $d63234f99c1aed29$var$N.next;
    $d63234f99c1aed29$var$Hh = 0;
    $d63234f99c1aed29$var$O = $d63234f99c1aed29$var$N = $d63234f99c1aed29$var$M = null;
    $d63234f99c1aed29$var$Ih = !1;
    if (b) throw Error($d63234f99c1aed29$var$p(300));
    return a;
}
function $d63234f99c1aed29$var$Sh() {
    var a = 0 !== $d63234f99c1aed29$var$Kh;
    $d63234f99c1aed29$var$Kh = 0;
    return a;
}
function $d63234f99c1aed29$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $d63234f99c1aed29$var$O ? $d63234f99c1aed29$var$M.memoizedState = $d63234f99c1aed29$var$O = a : $d63234f99c1aed29$var$O = $d63234f99c1aed29$var$O.next = a;
    return $d63234f99c1aed29$var$O;
}
function $d63234f99c1aed29$var$Uh() {
    if (null === $d63234f99c1aed29$var$N) {
        var a = $d63234f99c1aed29$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $d63234f99c1aed29$var$N.next;
    var b = null === $d63234f99c1aed29$var$O ? $d63234f99c1aed29$var$M.memoizedState : $d63234f99c1aed29$var$O.next;
    if (null !== b) $d63234f99c1aed29$var$O = b, $d63234f99c1aed29$var$N = a;
    else {
        if (null === a) throw Error($d63234f99c1aed29$var$p(310));
        $d63234f99c1aed29$var$N = a;
        a = {
            memoizedState: $d63234f99c1aed29$var$N.memoizedState,
            baseState: $d63234f99c1aed29$var$N.baseState,
            baseQueue: $d63234f99c1aed29$var$N.baseQueue,
            queue: $d63234f99c1aed29$var$N.queue,
            next: null
        };
        null === $d63234f99c1aed29$var$O ? $d63234f99c1aed29$var$M.memoizedState = $d63234f99c1aed29$var$O = a : $d63234f99c1aed29$var$O = $d63234f99c1aed29$var$O.next = a;
    }
    return $d63234f99c1aed29$var$O;
}
function $d63234f99c1aed29$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $d63234f99c1aed29$var$Wh(a) {
    var b = $d63234f99c1aed29$var$Uh(), c = b.queue;
    if (null === c) throw Error($d63234f99c1aed29$var$p(311));
    c.lastRenderedReducer = a;
    var d = $d63234f99c1aed29$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($d63234f99c1aed29$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $d63234f99c1aed29$var$M.lanes |= m;
                $d63234f99c1aed29$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $d63234f99c1aed29$var$He(d, b.memoizedState) || ($d63234f99c1aed29$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $d63234f99c1aed29$var$M.lanes |= f, $d63234f99c1aed29$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $d63234f99c1aed29$var$Xh(a) {
    var b = $d63234f99c1aed29$var$Uh(), c = b.queue;
    if (null === c) throw Error($d63234f99c1aed29$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $d63234f99c1aed29$var$He(f, b.memoizedState) || ($d63234f99c1aed29$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $d63234f99c1aed29$var$Yh() {}
function $d63234f99c1aed29$var$Zh(a, b) {
    var c = $d63234f99c1aed29$var$M, d = $d63234f99c1aed29$var$Uh(), e = b(), f = !$d63234f99c1aed29$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $d63234f99c1aed29$var$dh = !0);
    d = d.queue;
    $d63234f99c1aed29$var$$h($d63234f99c1aed29$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $d63234f99c1aed29$var$O && $d63234f99c1aed29$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $d63234f99c1aed29$var$bi(9, $d63234f99c1aed29$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $d63234f99c1aed29$var$Q) throw Error($d63234f99c1aed29$var$p(349));
        0 !== ($d63234f99c1aed29$var$Hh & 30) || $d63234f99c1aed29$var$di(c, b, e);
    }
    return e;
}
function $d63234f99c1aed29$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $d63234f99c1aed29$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $d63234f99c1aed29$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $d63234f99c1aed29$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $d63234f99c1aed29$var$ei(b) && $d63234f99c1aed29$var$fi(a);
}
function $d63234f99c1aed29$var$ai(a, b, c) {
    return c(function() {
        $d63234f99c1aed29$var$ei(b) && $d63234f99c1aed29$var$fi(a);
    });
}
function $d63234f99c1aed29$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$d63234f99c1aed29$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $d63234f99c1aed29$var$fi(a) {
    var b = $d63234f99c1aed29$var$ih(a, 1);
    null !== b && $d63234f99c1aed29$var$gi(b, a, 1, -1);
}
function $d63234f99c1aed29$var$hi(a) {
    var b = $d63234f99c1aed29$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d63234f99c1aed29$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $d63234f99c1aed29$var$ii.bind(null, $d63234f99c1aed29$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $d63234f99c1aed29$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $d63234f99c1aed29$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $d63234f99c1aed29$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $d63234f99c1aed29$var$ji() {
    return $d63234f99c1aed29$var$Uh().memoizedState;
}
function $d63234f99c1aed29$var$ki(a, b, c, d) {
    var e = $d63234f99c1aed29$var$Th();
    $d63234f99c1aed29$var$M.flags |= a;
    e.memoizedState = $d63234f99c1aed29$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $d63234f99c1aed29$var$li(a, b, c, d) {
    var e = $d63234f99c1aed29$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $d63234f99c1aed29$var$N) {
        var g = $d63234f99c1aed29$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $d63234f99c1aed29$var$Mh(d, g.deps)) {
            e.memoizedState = $d63234f99c1aed29$var$bi(b, c, f, d);
            return;
        }
    }
    $d63234f99c1aed29$var$M.flags |= a;
    e.memoizedState = $d63234f99c1aed29$var$bi(1 | b, c, f, d);
}
function $d63234f99c1aed29$var$mi(a, b) {
    return $d63234f99c1aed29$var$ki(8390656, 8, a, b);
}
function $d63234f99c1aed29$var$$h(a, b) {
    return $d63234f99c1aed29$var$li(2048, 8, a, b);
}
function $d63234f99c1aed29$var$ni(a, b) {
    return $d63234f99c1aed29$var$li(4, 2, a, b);
}
function $d63234f99c1aed29$var$oi(a, b) {
    return $d63234f99c1aed29$var$li(4, 4, a, b);
}
function $d63234f99c1aed29$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $d63234f99c1aed29$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $d63234f99c1aed29$var$li(4, 4, $d63234f99c1aed29$var$pi.bind(null, b, a), c);
}
function $d63234f99c1aed29$var$ri() {}
function $d63234f99c1aed29$var$si(a, b) {
    var c = $d63234f99c1aed29$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $d63234f99c1aed29$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d63234f99c1aed29$var$ti(a, b) {
    var c = $d63234f99c1aed29$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $d63234f99c1aed29$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $d63234f99c1aed29$var$ui(a, b, c) {
    if (0 === ($d63234f99c1aed29$var$Hh & 21)) return a.baseState && (a.baseState = !1, $d63234f99c1aed29$var$dh = !0), a.memoizedState = c;
    $d63234f99c1aed29$var$He(c, b) || (c = $d63234f99c1aed29$var$yc(), $d63234f99c1aed29$var$M.lanes |= c, $d63234f99c1aed29$var$rh |= c, a.baseState = !0);
    return b;
}
function $d63234f99c1aed29$var$vi(a, b) {
    var c = $d63234f99c1aed29$var$C;
    $d63234f99c1aed29$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $d63234f99c1aed29$var$Gh.transition;
    $d63234f99c1aed29$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $d63234f99c1aed29$var$C = c, $d63234f99c1aed29$var$Gh.transition = d;
    }
}
function $d63234f99c1aed29$var$wi() {
    return $d63234f99c1aed29$var$Uh().memoizedState;
}
function $d63234f99c1aed29$var$xi(a, b, c) {
    var d = $d63234f99c1aed29$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d63234f99c1aed29$var$zi(a)) $d63234f99c1aed29$var$Ai(b, c);
    else if (c = $d63234f99c1aed29$var$hh(a, b, c, d), null !== c) {
        var e = $d63234f99c1aed29$var$R();
        $d63234f99c1aed29$var$gi(c, a, d, e);
        $d63234f99c1aed29$var$Bi(c, b, d);
    }
}
function $d63234f99c1aed29$var$ii(a, b, c) {
    var d = $d63234f99c1aed29$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d63234f99c1aed29$var$zi(a)) $d63234f99c1aed29$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($d63234f99c1aed29$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $d63234f99c1aed29$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $d63234f99c1aed29$var$hh(a, b, e, d);
        null !== c && (e = $d63234f99c1aed29$var$R(), $d63234f99c1aed29$var$gi(c, a, d, e), $d63234f99c1aed29$var$Bi(c, b, d));
    }
}
function $d63234f99c1aed29$var$zi(a) {
    var b = a.alternate;
    return a === $d63234f99c1aed29$var$M || null !== b && b === $d63234f99c1aed29$var$M;
}
function $d63234f99c1aed29$var$Ai(a, b) {
    $d63234f99c1aed29$var$Jh = $d63234f99c1aed29$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $d63234f99c1aed29$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $d63234f99c1aed29$var$Cc(a, c);
    }
}
var $d63234f99c1aed29$var$Rh = {
    readContext: $d63234f99c1aed29$var$eh,
    useCallback: $d63234f99c1aed29$var$P,
    useContext: $d63234f99c1aed29$var$P,
    useEffect: $d63234f99c1aed29$var$P,
    useImperativeHandle: $d63234f99c1aed29$var$P,
    useInsertionEffect: $d63234f99c1aed29$var$P,
    useLayoutEffect: $d63234f99c1aed29$var$P,
    useMemo: $d63234f99c1aed29$var$P,
    useReducer: $d63234f99c1aed29$var$P,
    useRef: $d63234f99c1aed29$var$P,
    useState: $d63234f99c1aed29$var$P,
    useDebugValue: $d63234f99c1aed29$var$P,
    useDeferredValue: $d63234f99c1aed29$var$P,
    useTransition: $d63234f99c1aed29$var$P,
    useMutableSource: $d63234f99c1aed29$var$P,
    useSyncExternalStore: $d63234f99c1aed29$var$P,
    useId: $d63234f99c1aed29$var$P,
    unstable_isNewReconciler: !1
}, $d63234f99c1aed29$var$Oh = {
    readContext: $d63234f99c1aed29$var$eh,
    useCallback: function(a, b) {
        $d63234f99c1aed29$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $d63234f99c1aed29$var$eh,
    useEffect: $d63234f99c1aed29$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $d63234f99c1aed29$var$ki(4194308, 4, $d63234f99c1aed29$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $d63234f99c1aed29$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $d63234f99c1aed29$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $d63234f99c1aed29$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $d63234f99c1aed29$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $d63234f99c1aed29$var$xi.bind(null, $d63234f99c1aed29$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $d63234f99c1aed29$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $d63234f99c1aed29$var$hi,
    useDebugValue: $d63234f99c1aed29$var$ri,
    useDeferredValue: function(a) {
        return $d63234f99c1aed29$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $d63234f99c1aed29$var$hi(!1), b = a[0];
        a = $d63234f99c1aed29$var$vi.bind(null, a[1]);
        $d63234f99c1aed29$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $d63234f99c1aed29$var$M, e = $d63234f99c1aed29$var$Th();
        if ($d63234f99c1aed29$var$I) {
            if (void 0 === c) throw Error($d63234f99c1aed29$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $d63234f99c1aed29$var$Q) throw Error($d63234f99c1aed29$var$p(349));
            0 !== ($d63234f99c1aed29$var$Hh & 30) || $d63234f99c1aed29$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $d63234f99c1aed29$var$mi($d63234f99c1aed29$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $d63234f99c1aed29$var$bi(9, $d63234f99c1aed29$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $d63234f99c1aed29$var$Th(), b = $d63234f99c1aed29$var$Q.identifierPrefix;
        if ($d63234f99c1aed29$var$I) {
            var c = $d63234f99c1aed29$var$sg;
            var d = $d63234f99c1aed29$var$rg;
            c = (d & ~(1 << 32 - $d63234f99c1aed29$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $d63234f99c1aed29$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $d63234f99c1aed29$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $d63234f99c1aed29$var$Ph = {
    readContext: $d63234f99c1aed29$var$eh,
    useCallback: $d63234f99c1aed29$var$si,
    useContext: $d63234f99c1aed29$var$eh,
    useEffect: $d63234f99c1aed29$var$$h,
    useImperativeHandle: $d63234f99c1aed29$var$qi,
    useInsertionEffect: $d63234f99c1aed29$var$ni,
    useLayoutEffect: $d63234f99c1aed29$var$oi,
    useMemo: $d63234f99c1aed29$var$ti,
    useReducer: $d63234f99c1aed29$var$Wh,
    useRef: $d63234f99c1aed29$var$ji,
    useState: function() {
        return $d63234f99c1aed29$var$Wh($d63234f99c1aed29$var$Vh);
    },
    useDebugValue: $d63234f99c1aed29$var$ri,
    useDeferredValue: function(a) {
        var b = $d63234f99c1aed29$var$Uh();
        return $d63234f99c1aed29$var$ui(b, $d63234f99c1aed29$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $d63234f99c1aed29$var$Wh($d63234f99c1aed29$var$Vh)[0], b = $d63234f99c1aed29$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $d63234f99c1aed29$var$Yh,
    useSyncExternalStore: $d63234f99c1aed29$var$Zh,
    useId: $d63234f99c1aed29$var$wi,
    unstable_isNewReconciler: !1
}, $d63234f99c1aed29$var$Qh = {
    readContext: $d63234f99c1aed29$var$eh,
    useCallback: $d63234f99c1aed29$var$si,
    useContext: $d63234f99c1aed29$var$eh,
    useEffect: $d63234f99c1aed29$var$$h,
    useImperativeHandle: $d63234f99c1aed29$var$qi,
    useInsertionEffect: $d63234f99c1aed29$var$ni,
    useLayoutEffect: $d63234f99c1aed29$var$oi,
    useMemo: $d63234f99c1aed29$var$ti,
    useReducer: $d63234f99c1aed29$var$Xh,
    useRef: $d63234f99c1aed29$var$ji,
    useState: function() {
        return $d63234f99c1aed29$var$Xh($d63234f99c1aed29$var$Vh);
    },
    useDebugValue: $d63234f99c1aed29$var$ri,
    useDeferredValue: function(a) {
        var b = $d63234f99c1aed29$var$Uh();
        return null === $d63234f99c1aed29$var$N ? b.memoizedState = a : $d63234f99c1aed29$var$ui(b, $d63234f99c1aed29$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $d63234f99c1aed29$var$Xh($d63234f99c1aed29$var$Vh)[0], b = $d63234f99c1aed29$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $d63234f99c1aed29$var$Yh,
    useSyncExternalStore: $d63234f99c1aed29$var$Zh,
    useId: $d63234f99c1aed29$var$wi,
    unstable_isNewReconciler: !1
};
function $d63234f99c1aed29$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $d63234f99c1aed29$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $d63234f99c1aed29$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $d63234f99c1aed29$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $d63234f99c1aed29$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $d63234f99c1aed29$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $d63234f99c1aed29$var$R(), e = $d63234f99c1aed29$var$yi(a), f = $d63234f99c1aed29$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $d63234f99c1aed29$var$nh(a, f, e);
        null !== b && ($d63234f99c1aed29$var$gi(b, a, e, d), $d63234f99c1aed29$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $d63234f99c1aed29$var$R(), e = $d63234f99c1aed29$var$yi(a), f = $d63234f99c1aed29$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $d63234f99c1aed29$var$nh(a, f, e);
        null !== b && ($d63234f99c1aed29$var$gi(b, a, e, d), $d63234f99c1aed29$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $d63234f99c1aed29$var$R(), d = $d63234f99c1aed29$var$yi(a), e = $d63234f99c1aed29$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $d63234f99c1aed29$var$nh(a, e, d);
        null !== b && ($d63234f99c1aed29$var$gi(b, a, d, c), $d63234f99c1aed29$var$oh(b, a, d));
    }
};
function $d63234f99c1aed29$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$d63234f99c1aed29$var$Ie(c, d) || !$d63234f99c1aed29$var$Ie(e, f) : !0;
}
function $d63234f99c1aed29$var$Gi(a, b, c) {
    var d = !1, e = $d63234f99c1aed29$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $d63234f99c1aed29$var$eh(f) : (e = $d63234f99c1aed29$var$Zf(b) ? $d63234f99c1aed29$var$Xf : $d63234f99c1aed29$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $d63234f99c1aed29$var$Yf(a, e) : $d63234f99c1aed29$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $d63234f99c1aed29$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $d63234f99c1aed29$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $d63234f99c1aed29$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $d63234f99c1aed29$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $d63234f99c1aed29$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $d63234f99c1aed29$var$eh(f) : (f = $d63234f99c1aed29$var$Zf(b) ? $d63234f99c1aed29$var$Xf : $d63234f99c1aed29$var$H.current, e.context = $d63234f99c1aed29$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($d63234f99c1aed29$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $d63234f99c1aed29$var$Ei.enqueueReplaceState(e, e.state, null), $d63234f99c1aed29$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $d63234f99c1aed29$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $d63234f99c1aed29$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $d63234f99c1aed29$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $d63234f99c1aed29$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $d63234f99c1aed29$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $d63234f99c1aed29$var$Ni(a, b, c) {
    c = $d63234f99c1aed29$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $d63234f99c1aed29$var$Oi || ($d63234f99c1aed29$var$Oi = !0, $d63234f99c1aed29$var$Pi = d);
        $d63234f99c1aed29$var$Li(a, b);
    };
    return c;
}
function $d63234f99c1aed29$var$Qi(a, b, c) {
    c = $d63234f99c1aed29$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $d63234f99c1aed29$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $d63234f99c1aed29$var$Li(a, b);
        "function" !== typeof d && (null === $d63234f99c1aed29$var$Ri ? $d63234f99c1aed29$var$Ri = new Set([
            this
        ]) : $d63234f99c1aed29$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $d63234f99c1aed29$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $d63234f99c1aed29$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $d63234f99c1aed29$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $d63234f99c1aed29$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $d63234f99c1aed29$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $d63234f99c1aed29$var$mh(-1, 1), b.tag = 2, $d63234f99c1aed29$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $d63234f99c1aed29$var$Wi = $d63234f99c1aed29$var$ua.ReactCurrentOwner, $d63234f99c1aed29$var$dh = !1;
function $d63234f99c1aed29$var$Xi(a, b, c, d) {
    b.child = null === a ? $d63234f99c1aed29$var$Vg(b, null, c, d) : $d63234f99c1aed29$var$Ug(b, a.child, c, d);
}
function $d63234f99c1aed29$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $d63234f99c1aed29$var$ch(b, e);
    d = $d63234f99c1aed29$var$Nh(a, b, c, d, f, e);
    c = $d63234f99c1aed29$var$Sh();
    if (null !== a && !$d63234f99c1aed29$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $d63234f99c1aed29$var$Zi(a, b, e);
    $d63234f99c1aed29$var$I && c && $d63234f99c1aed29$var$vg(b);
    b.flags |= 1;
    $d63234f99c1aed29$var$Xi(a, b, d, e);
    return b.child;
}
function $d63234f99c1aed29$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$d63234f99c1aed29$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $d63234f99c1aed29$var$bj(a, b, f, d, e);
        a = $d63234f99c1aed29$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $d63234f99c1aed29$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $d63234f99c1aed29$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $d63234f99c1aed29$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $d63234f99c1aed29$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($d63234f99c1aed29$var$Ie(f, d) && a.ref === b.ref) {
            if ($d63234f99c1aed29$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($d63234f99c1aed29$var$dh = !0);
            else return b.lanes = a.lanes, $d63234f99c1aed29$var$Zi(a, b, e);
        }
    }
    return $d63234f99c1aed29$var$cj(a, b, c, d, e);
}
function $d63234f99c1aed29$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $d63234f99c1aed29$var$G($d63234f99c1aed29$var$ej, $d63234f99c1aed29$var$fj), $d63234f99c1aed29$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $d63234f99c1aed29$var$G($d63234f99c1aed29$var$ej, $d63234f99c1aed29$var$fj), $d63234f99c1aed29$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $d63234f99c1aed29$var$G($d63234f99c1aed29$var$ej, $d63234f99c1aed29$var$fj);
            $d63234f99c1aed29$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $d63234f99c1aed29$var$G($d63234f99c1aed29$var$ej, $d63234f99c1aed29$var$fj), $d63234f99c1aed29$var$fj |= d;
    $d63234f99c1aed29$var$Xi(a, b, e, c);
    return b.child;
}
function $d63234f99c1aed29$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $d63234f99c1aed29$var$cj(a, b, c, d, e) {
    var f = $d63234f99c1aed29$var$Zf(c) ? $d63234f99c1aed29$var$Xf : $d63234f99c1aed29$var$H.current;
    f = $d63234f99c1aed29$var$Yf(b, f);
    $d63234f99c1aed29$var$ch(b, e);
    c = $d63234f99c1aed29$var$Nh(a, b, c, d, f, e);
    d = $d63234f99c1aed29$var$Sh();
    if (null !== a && !$d63234f99c1aed29$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $d63234f99c1aed29$var$Zi(a, b, e);
    $d63234f99c1aed29$var$I && d && $d63234f99c1aed29$var$vg(b);
    b.flags |= 1;
    $d63234f99c1aed29$var$Xi(a, b, c, e);
    return b.child;
}
function $d63234f99c1aed29$var$hj(a, b, c, d, e) {
    if ($d63234f99c1aed29$var$Zf(c)) {
        var f = !0;
        $d63234f99c1aed29$var$cg(b);
    } else f = !1;
    $d63234f99c1aed29$var$ch(b, e);
    if (null === b.stateNode) $d63234f99c1aed29$var$ij(a, b), $d63234f99c1aed29$var$Gi(b, c, d), $d63234f99c1aed29$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $d63234f99c1aed29$var$eh(l) : (l = $d63234f99c1aed29$var$Zf(c) ? $d63234f99c1aed29$var$Xf : $d63234f99c1aed29$var$H.current, l = $d63234f99c1aed29$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $d63234f99c1aed29$var$Hi(b, g, d, l);
        $d63234f99c1aed29$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $d63234f99c1aed29$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $d63234f99c1aed29$var$Wf.current || $d63234f99c1aed29$var$jh ? ("function" === typeof m && ($d63234f99c1aed29$var$Di(b, c, m, d), k = b.memoizedState), (h = $d63234f99c1aed29$var$jh || $d63234f99c1aed29$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $d63234f99c1aed29$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $d63234f99c1aed29$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $d63234f99c1aed29$var$eh(k) : (k = $d63234f99c1aed29$var$Zf(c) ? $d63234f99c1aed29$var$Xf : $d63234f99c1aed29$var$H.current, k = $d63234f99c1aed29$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $d63234f99c1aed29$var$Hi(b, g, d, k);
        $d63234f99c1aed29$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $d63234f99c1aed29$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $d63234f99c1aed29$var$Wf.current || $d63234f99c1aed29$var$jh ? ("function" === typeof y && ($d63234f99c1aed29$var$Di(b, c, y, d), n = b.memoizedState), (l = $d63234f99c1aed29$var$jh || $d63234f99c1aed29$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $d63234f99c1aed29$var$jj(a, b, c, d, f, e);
}
function $d63234f99c1aed29$var$jj(a, b, c, d, e, f) {
    $d63234f99c1aed29$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $d63234f99c1aed29$var$dg(b, c, !1), $d63234f99c1aed29$var$Zi(a, b, f);
    d = b.stateNode;
    $d63234f99c1aed29$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $d63234f99c1aed29$var$Ug(b, a.child, null, f), b.child = $d63234f99c1aed29$var$Ug(b, null, h, f)) : $d63234f99c1aed29$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $d63234f99c1aed29$var$dg(b, c, !0);
    return b.child;
}
function $d63234f99c1aed29$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $d63234f99c1aed29$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $d63234f99c1aed29$var$ag(a, b.context, !1);
    $d63234f99c1aed29$var$yh(a, b.containerInfo);
}
function $d63234f99c1aed29$var$lj(a, b, c, d, e) {
    $d63234f99c1aed29$var$Ig();
    $d63234f99c1aed29$var$Jg(e);
    b.flags |= 256;
    $d63234f99c1aed29$var$Xi(a, b, c, d);
    return b.child;
}
var $d63234f99c1aed29$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $d63234f99c1aed29$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $d63234f99c1aed29$var$oj(a, b, c) {
    var d = b.pendingProps, e = $d63234f99c1aed29$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$L, e & 1);
    if (null === a) {
        $d63234f99c1aed29$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $d63234f99c1aed29$var$pj(g, d, 0, null), a = $d63234f99c1aed29$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $d63234f99c1aed29$var$nj(c), b.memoizedState = $d63234f99c1aed29$var$mj, a) : $d63234f99c1aed29$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $d63234f99c1aed29$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $d63234f99c1aed29$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $d63234f99c1aed29$var$Pg(h, f) : (f = $d63234f99c1aed29$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $d63234f99c1aed29$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $d63234f99c1aed29$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $d63234f99c1aed29$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $d63234f99c1aed29$var$qj(a, b) {
    b = $d63234f99c1aed29$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $d63234f99c1aed29$var$sj(a, b, c, d) {
    null !== d && $d63234f99c1aed29$var$Jg(d);
    $d63234f99c1aed29$var$Ug(b, a.child, null, c);
    a = $d63234f99c1aed29$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $d63234f99c1aed29$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $d63234f99c1aed29$var$Ki(Error($d63234f99c1aed29$var$p(422))), $d63234f99c1aed29$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $d63234f99c1aed29$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $d63234f99c1aed29$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $d63234f99c1aed29$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $d63234f99c1aed29$var$nj(g);
        b.memoizedState = $d63234f99c1aed29$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $d63234f99c1aed29$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($d63234f99c1aed29$var$p(419));
        d = $d63234f99c1aed29$var$Ki(f, d, void 0);
        return $d63234f99c1aed29$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($d63234f99c1aed29$var$dh || h) {
        d = $d63234f99c1aed29$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $d63234f99c1aed29$var$ih(a, e), $d63234f99c1aed29$var$gi(d, a, e, -1));
        }
        $d63234f99c1aed29$var$tj();
        d = $d63234f99c1aed29$var$Ki(Error($d63234f99c1aed29$var$p(421)));
        return $d63234f99c1aed29$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $d63234f99c1aed29$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $d63234f99c1aed29$var$yg = $d63234f99c1aed29$var$Lf(e.nextSibling);
    $d63234f99c1aed29$var$xg = b;
    $d63234f99c1aed29$var$I = !0;
    $d63234f99c1aed29$var$zg = null;
    null !== a && ($d63234f99c1aed29$var$og[$d63234f99c1aed29$var$pg++] = $d63234f99c1aed29$var$rg, $d63234f99c1aed29$var$og[$d63234f99c1aed29$var$pg++] = $d63234f99c1aed29$var$sg, $d63234f99c1aed29$var$og[$d63234f99c1aed29$var$pg++] = $d63234f99c1aed29$var$qg, $d63234f99c1aed29$var$rg = a.id, $d63234f99c1aed29$var$sg = a.overflow, $d63234f99c1aed29$var$qg = b);
    b = $d63234f99c1aed29$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $d63234f99c1aed29$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $d63234f99c1aed29$var$bh(a.return, b, c);
}
function $d63234f99c1aed29$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $d63234f99c1aed29$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $d63234f99c1aed29$var$Xi(a, b, d.children, c);
    d = $d63234f99c1aed29$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $d63234f99c1aed29$var$vj(a, c, b);
            else if (19 === a.tag) $d63234f99c1aed29$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $d63234f99c1aed29$var$G($d63234f99c1aed29$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $d63234f99c1aed29$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $d63234f99c1aed29$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $d63234f99c1aed29$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $d63234f99c1aed29$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $d63234f99c1aed29$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $d63234f99c1aed29$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $d63234f99c1aed29$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $d63234f99c1aed29$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($d63234f99c1aed29$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $d63234f99c1aed29$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $d63234f99c1aed29$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $d63234f99c1aed29$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $d63234f99c1aed29$var$kj(b);
            $d63234f99c1aed29$var$Ig();
            break;
        case 5:
            $d63234f99c1aed29$var$Ah(b);
            break;
        case 1:
            $d63234f99c1aed29$var$Zf(b.type) && $d63234f99c1aed29$var$cg(b);
            break;
        case 4:
            $d63234f99c1aed29$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $d63234f99c1aed29$var$G($d63234f99c1aed29$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $d63234f99c1aed29$var$G($d63234f99c1aed29$var$L, $d63234f99c1aed29$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $d63234f99c1aed29$var$oj(a, b, c);
                $d63234f99c1aed29$var$G($d63234f99c1aed29$var$L, $d63234f99c1aed29$var$L.current & 1);
                a = $d63234f99c1aed29$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $d63234f99c1aed29$var$G($d63234f99c1aed29$var$L, $d63234f99c1aed29$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $d63234f99c1aed29$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $d63234f99c1aed29$var$G($d63234f99c1aed29$var$L, $d63234f99c1aed29$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $d63234f99c1aed29$var$dj(a, b, c);
    }
    return $d63234f99c1aed29$var$Zi(a, b, c);
}
var $d63234f99c1aed29$var$zj, $d63234f99c1aed29$var$Aj, $d63234f99c1aed29$var$Bj, $d63234f99c1aed29$var$Cj;
$d63234f99c1aed29$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$d63234f99c1aed29$var$Aj = function() {};
$d63234f99c1aed29$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $d63234f99c1aed29$var$xh($d63234f99c1aed29$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $d63234f99c1aed29$var$Ya(a, e);
                d = $d63234f99c1aed29$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $d63234f99c1aed29$var$A({}, e, {
                    value: void 0
                });
                d = $d63234f99c1aed29$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $d63234f99c1aed29$var$gb(a, e);
                d = $d63234f99c1aed29$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $d63234f99c1aed29$var$Bf);
        }
        $d63234f99c1aed29$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($d63234f99c1aed29$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($d63234f99c1aed29$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $d63234f99c1aed29$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$d63234f99c1aed29$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $d63234f99c1aed29$var$Dj(a, b) {
    if (!$d63234f99c1aed29$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $d63234f99c1aed29$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $d63234f99c1aed29$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $d63234f99c1aed29$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $d63234f99c1aed29$var$S(b), null;
        case 1:
            return $d63234f99c1aed29$var$Zf(b.type) && $d63234f99c1aed29$var$$f(), $d63234f99c1aed29$var$S(b), null;
        case 3:
            d = b.stateNode;
            $d63234f99c1aed29$var$zh();
            $d63234f99c1aed29$var$E($d63234f99c1aed29$var$Wf);
            $d63234f99c1aed29$var$E($d63234f99c1aed29$var$H);
            $d63234f99c1aed29$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $d63234f99c1aed29$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $d63234f99c1aed29$var$zg && ($d63234f99c1aed29$var$Fj($d63234f99c1aed29$var$zg), $d63234f99c1aed29$var$zg = null));
            $d63234f99c1aed29$var$Aj(a, b);
            $d63234f99c1aed29$var$S(b);
            return null;
        case 5:
            $d63234f99c1aed29$var$Bh(b);
            var e = $d63234f99c1aed29$var$xh($d63234f99c1aed29$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $d63234f99c1aed29$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($d63234f99c1aed29$var$p(166));
                    $d63234f99c1aed29$var$S(b);
                    return null;
                }
                a = $d63234f99c1aed29$var$xh($d63234f99c1aed29$var$uh.current);
                if ($d63234f99c1aed29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$d63234f99c1aed29$var$Of] = b;
                    d[$d63234f99c1aed29$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $d63234f99c1aed29$var$D("cancel", d);
                            $d63234f99c1aed29$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $d63234f99c1aed29$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $d63234f99c1aed29$var$lf.length; e++)$d63234f99c1aed29$var$D($d63234f99c1aed29$var$lf[e], d);
                            break;
                        case "source":
                            $d63234f99c1aed29$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $d63234f99c1aed29$var$D("error", d);
                            $d63234f99c1aed29$var$D("load", d);
                            break;
                        case "details":
                            $d63234f99c1aed29$var$D("toggle", d);
                            break;
                        case "input":
                            $d63234f99c1aed29$var$Za(d, f);
                            $d63234f99c1aed29$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $d63234f99c1aed29$var$D("invalid", d);
                            break;
                        case "textarea":
                            $d63234f99c1aed29$var$hb(d, f), $d63234f99c1aed29$var$D("invalid", d);
                    }
                    $d63234f99c1aed29$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $d63234f99c1aed29$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $d63234f99c1aed29$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $d63234f99c1aed29$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $d63234f99c1aed29$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $d63234f99c1aed29$var$Va(d);
                            $d63234f99c1aed29$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $d63234f99c1aed29$var$Va(d);
                            $d63234f99c1aed29$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $d63234f99c1aed29$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $d63234f99c1aed29$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$d63234f99c1aed29$var$Of] = b;
                    a[$d63234f99c1aed29$var$Pf] = d;
                    $d63234f99c1aed29$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $d63234f99c1aed29$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $d63234f99c1aed29$var$D("cancel", a);
                                $d63234f99c1aed29$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $d63234f99c1aed29$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $d63234f99c1aed29$var$lf.length; e++)$d63234f99c1aed29$var$D($d63234f99c1aed29$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $d63234f99c1aed29$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $d63234f99c1aed29$var$D("error", a);
                                $d63234f99c1aed29$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $d63234f99c1aed29$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $d63234f99c1aed29$var$Za(a, d);
                                e = $d63234f99c1aed29$var$Ya(a, d);
                                $d63234f99c1aed29$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $d63234f99c1aed29$var$A({}, d, {
                                    value: void 0
                                });
                                $d63234f99c1aed29$var$D("invalid", a);
                                break;
                            case "textarea":
                                $d63234f99c1aed29$var$hb(a, d);
                                e = $d63234f99c1aed29$var$gb(a, d);
                                $d63234f99c1aed29$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $d63234f99c1aed29$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $d63234f99c1aed29$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $d63234f99c1aed29$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $d63234f99c1aed29$var$ob(a, k) : "number" === typeof k && $d63234f99c1aed29$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($d63234f99c1aed29$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $d63234f99c1aed29$var$D("scroll", a) : null != k && $d63234f99c1aed29$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $d63234f99c1aed29$var$Va(a);
                                $d63234f99c1aed29$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $d63234f99c1aed29$var$Va(a);
                                $d63234f99c1aed29$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $d63234f99c1aed29$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $d63234f99c1aed29$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $d63234f99c1aed29$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $d63234f99c1aed29$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $d63234f99c1aed29$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $d63234f99c1aed29$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($d63234f99c1aed29$var$p(166));
                c = $d63234f99c1aed29$var$xh($d63234f99c1aed29$var$wh.current);
                $d63234f99c1aed29$var$xh($d63234f99c1aed29$var$uh.current);
                if ($d63234f99c1aed29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$d63234f99c1aed29$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $d63234f99c1aed29$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $d63234f99c1aed29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $d63234f99c1aed29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$d63234f99c1aed29$var$Of] = b, b.stateNode = d;
            }
            $d63234f99c1aed29$var$S(b);
            return null;
        case 13:
            $d63234f99c1aed29$var$E($d63234f99c1aed29$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($d63234f99c1aed29$var$I && null !== $d63234f99c1aed29$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $d63234f99c1aed29$var$Hg(), $d63234f99c1aed29$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $d63234f99c1aed29$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($d63234f99c1aed29$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($d63234f99c1aed29$var$p(317));
                        f[$d63234f99c1aed29$var$Of] = b;
                    } else $d63234f99c1aed29$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $d63234f99c1aed29$var$S(b);
                    f = !1;
                } else null !== $d63234f99c1aed29$var$zg && ($d63234f99c1aed29$var$Fj($d63234f99c1aed29$var$zg), $d63234f99c1aed29$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($d63234f99c1aed29$var$L.current & 1) ? 0 === $d63234f99c1aed29$var$T && ($d63234f99c1aed29$var$T = 3) : $d63234f99c1aed29$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $d63234f99c1aed29$var$S(b);
            return null;
        case 4:
            return $d63234f99c1aed29$var$zh(), $d63234f99c1aed29$var$Aj(a, b), null === a && $d63234f99c1aed29$var$sf(b.stateNode.containerInfo), $d63234f99c1aed29$var$S(b), null;
        case 10:
            return $d63234f99c1aed29$var$ah(b.type._context), $d63234f99c1aed29$var$S(b), null;
        case 17:
            return $d63234f99c1aed29$var$Zf(b.type) && $d63234f99c1aed29$var$$f(), $d63234f99c1aed29$var$S(b), null;
        case 19:
            $d63234f99c1aed29$var$E($d63234f99c1aed29$var$L);
            f = b.memoizedState;
            if (null === f) return $d63234f99c1aed29$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $d63234f99c1aed29$var$Dj(f, !1);
                else {
                    if (0 !== $d63234f99c1aed29$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $d63234f99c1aed29$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $d63234f99c1aed29$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $d63234f99c1aed29$var$G($d63234f99c1aed29$var$L, $d63234f99c1aed29$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $d63234f99c1aed29$var$B() > $d63234f99c1aed29$var$Gj && (b.flags |= 128, d = !0, $d63234f99c1aed29$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $d63234f99c1aed29$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $d63234f99c1aed29$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$d63234f99c1aed29$var$I) return $d63234f99c1aed29$var$S(b), null;
                    } else 2 * $d63234f99c1aed29$var$B() - f.renderingStartTime > $d63234f99c1aed29$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $d63234f99c1aed29$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $d63234f99c1aed29$var$B(), b.sibling = null, c = $d63234f99c1aed29$var$L.current, $d63234f99c1aed29$var$G($d63234f99c1aed29$var$L, d ? c & 1 | 2 : c & 1), b;
            $d63234f99c1aed29$var$S(b);
            return null;
        case 22:
        case 23:
            return $d63234f99c1aed29$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($d63234f99c1aed29$var$fj & 1073741824) && ($d63234f99c1aed29$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $d63234f99c1aed29$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($d63234f99c1aed29$var$p(156, b.tag));
}
function $d63234f99c1aed29$var$Ij(a, b) {
    $d63234f99c1aed29$var$wg(b);
    switch(b.tag){
        case 1:
            return $d63234f99c1aed29$var$Zf(b.type) && $d63234f99c1aed29$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $d63234f99c1aed29$var$zh(), $d63234f99c1aed29$var$E($d63234f99c1aed29$var$Wf), $d63234f99c1aed29$var$E($d63234f99c1aed29$var$H), $d63234f99c1aed29$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $d63234f99c1aed29$var$Bh(b), null;
        case 13:
            $d63234f99c1aed29$var$E($d63234f99c1aed29$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($d63234f99c1aed29$var$p(340));
                $d63234f99c1aed29$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $d63234f99c1aed29$var$E($d63234f99c1aed29$var$L), null;
        case 4:
            return $d63234f99c1aed29$var$zh(), null;
        case 10:
            return $d63234f99c1aed29$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $d63234f99c1aed29$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $d63234f99c1aed29$var$Jj = !1, $d63234f99c1aed29$var$U = !1, $d63234f99c1aed29$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $d63234f99c1aed29$var$V = null;
function $d63234f99c1aed29$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $d63234f99c1aed29$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $d63234f99c1aed29$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $d63234f99c1aed29$var$W(a, b, d);
    }
}
var $d63234f99c1aed29$var$Nj = !1;
function $d63234f99c1aed29$var$Oj(a, b) {
    $d63234f99c1aed29$var$Cf = $d63234f99c1aed29$var$dd;
    a = $d63234f99c1aed29$var$Me();
    if ($d63234f99c1aed29$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $d63234f99c1aed29$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $d63234f99c1aed29$var$dd = !1;
    for($d63234f99c1aed29$var$V = b; null !== $d63234f99c1aed29$var$V;)if (b = $d63234f99c1aed29$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $d63234f99c1aed29$var$V = a;
    else for(; null !== $d63234f99c1aed29$var$V;){
        b = $d63234f99c1aed29$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $d63234f99c1aed29$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($d63234f99c1aed29$var$p(163));
            }
        } catch (F) {
            $d63234f99c1aed29$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $d63234f99c1aed29$var$V = a;
            break;
        }
        $d63234f99c1aed29$var$V = b.return;
    }
    n = $d63234f99c1aed29$var$Nj;
    $d63234f99c1aed29$var$Nj = !1;
    return n;
}
function $d63234f99c1aed29$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $d63234f99c1aed29$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $d63234f99c1aed29$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $d63234f99c1aed29$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $d63234f99c1aed29$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $d63234f99c1aed29$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$d63234f99c1aed29$var$Of], delete b[$d63234f99c1aed29$var$Pf], delete b[$d63234f99c1aed29$var$of], delete b[$d63234f99c1aed29$var$Qf], delete b[$d63234f99c1aed29$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $d63234f99c1aed29$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $d63234f99c1aed29$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $d63234f99c1aed29$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $d63234f99c1aed29$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $d63234f99c1aed29$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($d63234f99c1aed29$var$Vj(a, b, c), a = a.sibling; null !== a;)$d63234f99c1aed29$var$Vj(a, b, c), a = a.sibling;
}
function $d63234f99c1aed29$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($d63234f99c1aed29$var$Wj(a, b, c), a = a.sibling; null !== a;)$d63234f99c1aed29$var$Wj(a, b, c), a = a.sibling;
}
var $d63234f99c1aed29$var$X = null, $d63234f99c1aed29$var$Xj = !1;
function $d63234f99c1aed29$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$d63234f99c1aed29$var$Zj(a, b, c), c = c.sibling;
}
function $d63234f99c1aed29$var$Zj(a, b, c) {
    if ($d63234f99c1aed29$var$lc && "function" === typeof $d63234f99c1aed29$var$lc.onCommitFiberUnmount) try {
        $d63234f99c1aed29$var$lc.onCommitFiberUnmount($d63234f99c1aed29$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $d63234f99c1aed29$var$U || $d63234f99c1aed29$var$Lj(c, b);
        case 6:
            var d = $d63234f99c1aed29$var$X, e = $d63234f99c1aed29$var$Xj;
            $d63234f99c1aed29$var$X = null;
            $d63234f99c1aed29$var$Yj(a, b, c);
            $d63234f99c1aed29$var$X = d;
            $d63234f99c1aed29$var$Xj = e;
            null !== $d63234f99c1aed29$var$X && ($d63234f99c1aed29$var$Xj ? (a = $d63234f99c1aed29$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $d63234f99c1aed29$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $d63234f99c1aed29$var$X && ($d63234f99c1aed29$var$Xj ? (a = $d63234f99c1aed29$var$X, c = c.stateNode, 8 === a.nodeType ? $d63234f99c1aed29$var$Kf(a.parentNode, c) : 1 === a.nodeType && $d63234f99c1aed29$var$Kf(a, c), $d63234f99c1aed29$var$bd(a)) : $d63234f99c1aed29$var$Kf($d63234f99c1aed29$var$X, c.stateNode));
            break;
        case 4:
            d = $d63234f99c1aed29$var$X;
            e = $d63234f99c1aed29$var$Xj;
            $d63234f99c1aed29$var$X = c.stateNode.containerInfo;
            $d63234f99c1aed29$var$Xj = !0;
            $d63234f99c1aed29$var$Yj(a, b, c);
            $d63234f99c1aed29$var$X = d;
            $d63234f99c1aed29$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$d63234f99c1aed29$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $d63234f99c1aed29$var$Mj(c, b, g) : 0 !== (f & 4) && $d63234f99c1aed29$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $d63234f99c1aed29$var$Yj(a, b, c);
            break;
        case 1:
            if (!$d63234f99c1aed29$var$U && ($d63234f99c1aed29$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $d63234f99c1aed29$var$W(c, b, h);
            }
            $d63234f99c1aed29$var$Yj(a, b, c);
            break;
        case 21:
            $d63234f99c1aed29$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($d63234f99c1aed29$var$U = (d = $d63234f99c1aed29$var$U) || null !== c.memoizedState, $d63234f99c1aed29$var$Yj(a, b, c), $d63234f99c1aed29$var$U = d) : $d63234f99c1aed29$var$Yj(a, b, c);
            break;
        default:
            $d63234f99c1aed29$var$Yj(a, b, c);
    }
}
function $d63234f99c1aed29$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $d63234f99c1aed29$var$Kj);
        b.forEach(function(b) {
            var d = $d63234f99c1aed29$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $d63234f99c1aed29$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $d63234f99c1aed29$var$X = h.stateNode;
                        $d63234f99c1aed29$var$Xj = !1;
                        break a;
                    case 3:
                        $d63234f99c1aed29$var$X = h.stateNode.containerInfo;
                        $d63234f99c1aed29$var$Xj = !0;
                        break a;
                    case 4:
                        $d63234f99c1aed29$var$X = h.stateNode.containerInfo;
                        $d63234f99c1aed29$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $d63234f99c1aed29$var$X) throw Error($d63234f99c1aed29$var$p(160));
            $d63234f99c1aed29$var$Zj(f, g, e);
            $d63234f99c1aed29$var$X = null;
            $d63234f99c1aed29$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $d63234f99c1aed29$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$d63234f99c1aed29$var$dk(b, a), b = b.sibling;
}
function $d63234f99c1aed29$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $d63234f99c1aed29$var$ck(b, a);
            $d63234f99c1aed29$var$ek(a);
            if (d & 4) {
                try {
                    $d63234f99c1aed29$var$Pj(3, a, a.return), $d63234f99c1aed29$var$Qj(3, a);
                } catch (t) {
                    $d63234f99c1aed29$var$W(a, a.return, t);
                }
                try {
                    $d63234f99c1aed29$var$Pj(5, a, a.return);
                } catch (t) {
                    $d63234f99c1aed29$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $d63234f99c1aed29$var$ck(b, a);
            $d63234f99c1aed29$var$ek(a);
            d & 512 && null !== c && $d63234f99c1aed29$var$Lj(c, c.return);
            break;
        case 5:
            $d63234f99c1aed29$var$ck(b, a);
            $d63234f99c1aed29$var$ek(a);
            d & 512 && null !== c && $d63234f99c1aed29$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $d63234f99c1aed29$var$ob(e, "");
                } catch (t) {
                    $d63234f99c1aed29$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $d63234f99c1aed29$var$ab(e, f);
                    $d63234f99c1aed29$var$vb(h, g);
                    var l = $d63234f99c1aed29$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $d63234f99c1aed29$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $d63234f99c1aed29$var$nb(e, q) : "children" === m ? $d63234f99c1aed29$var$ob(e, q) : $d63234f99c1aed29$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $d63234f99c1aed29$var$bb(e, f);
                            break;
                        case "textarea":
                            $d63234f99c1aed29$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $d63234f99c1aed29$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $d63234f99c1aed29$var$fb(e, !!f.multiple, f.defaultValue, !0) : $d63234f99c1aed29$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$d63234f99c1aed29$var$Pf] = f;
                } catch (t) {
                    $d63234f99c1aed29$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $d63234f99c1aed29$var$ck(b, a);
            $d63234f99c1aed29$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($d63234f99c1aed29$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $d63234f99c1aed29$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $d63234f99c1aed29$var$ck(b, a);
            $d63234f99c1aed29$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $d63234f99c1aed29$var$bd(b.containerInfo);
            } catch (t) {
                $d63234f99c1aed29$var$W(a, a.return, t);
            }
            break;
        case 4:
            $d63234f99c1aed29$var$ck(b, a);
            $d63234f99c1aed29$var$ek(a);
            break;
        case 13:
            $d63234f99c1aed29$var$ck(b, a);
            $d63234f99c1aed29$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($d63234f99c1aed29$var$fk = $d63234f99c1aed29$var$B()));
            d & 4 && $d63234f99c1aed29$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($d63234f99c1aed29$var$U = (l = $d63234f99c1aed29$var$U) || m, $d63234f99c1aed29$var$ck(b, a), $d63234f99c1aed29$var$U = l) : $d63234f99c1aed29$var$ck(b, a);
            $d63234f99c1aed29$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($d63234f99c1aed29$var$V = a, m = a.child; null !== m;){
                    for(q = $d63234f99c1aed29$var$V = m; null !== $d63234f99c1aed29$var$V;){
                        r = $d63234f99c1aed29$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $d63234f99c1aed29$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $d63234f99c1aed29$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $d63234f99c1aed29$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $d63234f99c1aed29$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $d63234f99c1aed29$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $d63234f99c1aed29$var$V = y) : $d63234f99c1aed29$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $d63234f99c1aed29$var$rb("display", g));
                            } catch (t) {
                                $d63234f99c1aed29$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $d63234f99c1aed29$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $d63234f99c1aed29$var$ck(b, a);
            $d63234f99c1aed29$var$ek(a);
            d & 4 && $d63234f99c1aed29$var$ak(a);
            break;
        case 21:
            break;
        default:
            $d63234f99c1aed29$var$ck(b, a), $d63234f99c1aed29$var$ek(a);
    }
}
function $d63234f99c1aed29$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($d63234f99c1aed29$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($d63234f99c1aed29$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($d63234f99c1aed29$var$ob(e, ""), d.flags &= -33);
                    var f = $d63234f99c1aed29$var$Uj(a);
                    $d63234f99c1aed29$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $d63234f99c1aed29$var$Uj(a);
                    $d63234f99c1aed29$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($d63234f99c1aed29$var$p(161));
            }
        } catch (k) {
            $d63234f99c1aed29$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $d63234f99c1aed29$var$hk(a, b, c) {
    $d63234f99c1aed29$var$V = a;
    $d63234f99c1aed29$var$ik(a, b, c);
}
function $d63234f99c1aed29$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $d63234f99c1aed29$var$V;){
        var e = $d63234f99c1aed29$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $d63234f99c1aed29$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $d63234f99c1aed29$var$U;
                h = $d63234f99c1aed29$var$Jj;
                var l = $d63234f99c1aed29$var$U;
                $d63234f99c1aed29$var$Jj = g;
                if (($d63234f99c1aed29$var$U = k) && !l) for($d63234f99c1aed29$var$V = e; null !== $d63234f99c1aed29$var$V;)g = $d63234f99c1aed29$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $d63234f99c1aed29$var$jk(e) : null !== k ? (k.return = g, $d63234f99c1aed29$var$V = k) : $d63234f99c1aed29$var$jk(e);
                for(; null !== f;)$d63234f99c1aed29$var$V = f, $d63234f99c1aed29$var$ik(f, b, c), f = f.sibling;
                $d63234f99c1aed29$var$V = e;
                $d63234f99c1aed29$var$Jj = h;
                $d63234f99c1aed29$var$U = l;
            }
            $d63234f99c1aed29$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $d63234f99c1aed29$var$V = f) : $d63234f99c1aed29$var$kk(a, b, c);
    }
}
function $d63234f99c1aed29$var$kk(a) {
    for(; null !== $d63234f99c1aed29$var$V;){
        var b = $d63234f99c1aed29$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $d63234f99c1aed29$var$U || $d63234f99c1aed29$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$d63234f99c1aed29$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $d63234f99c1aed29$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $d63234f99c1aed29$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $d63234f99c1aed29$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $d63234f99c1aed29$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($d63234f99c1aed29$var$p(163));
                }
                $d63234f99c1aed29$var$U || b.flags & 512 && $d63234f99c1aed29$var$Rj(b);
            } catch (r) {
                $d63234f99c1aed29$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $d63234f99c1aed29$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $d63234f99c1aed29$var$V = c;
            break;
        }
        $d63234f99c1aed29$var$V = b.return;
    }
}
function $d63234f99c1aed29$var$gk(a) {
    for(; null !== $d63234f99c1aed29$var$V;){
        var b = $d63234f99c1aed29$var$V;
        if (b === a) {
            $d63234f99c1aed29$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $d63234f99c1aed29$var$V = c;
            break;
        }
        $d63234f99c1aed29$var$V = b.return;
    }
}
function $d63234f99c1aed29$var$jk(a) {
    for(; null !== $d63234f99c1aed29$var$V;){
        var b = $d63234f99c1aed29$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $d63234f99c1aed29$var$Qj(4, b);
                    } catch (k) {
                        $d63234f99c1aed29$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $d63234f99c1aed29$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $d63234f99c1aed29$var$Rj(b);
                    } catch (k) {
                        $d63234f99c1aed29$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $d63234f99c1aed29$var$Rj(b);
                    } catch (k) {
                        $d63234f99c1aed29$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $d63234f99c1aed29$var$W(b, b.return, k);
        }
        if (b === a) {
            $d63234f99c1aed29$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $d63234f99c1aed29$var$V = h;
            break;
        }
        $d63234f99c1aed29$var$V = b.return;
    }
}
var $d63234f99c1aed29$var$lk = Math.ceil, $d63234f99c1aed29$var$mk = $d63234f99c1aed29$var$ua.ReactCurrentDispatcher, $d63234f99c1aed29$var$nk = $d63234f99c1aed29$var$ua.ReactCurrentOwner, $d63234f99c1aed29$var$ok = $d63234f99c1aed29$var$ua.ReactCurrentBatchConfig, $d63234f99c1aed29$var$K = 0, $d63234f99c1aed29$var$Q = null, $d63234f99c1aed29$var$Y = null, $d63234f99c1aed29$var$Z = 0, $d63234f99c1aed29$var$fj = 0, $d63234f99c1aed29$var$ej = $d63234f99c1aed29$var$Uf(0), $d63234f99c1aed29$var$T = 0, $d63234f99c1aed29$var$pk = null, $d63234f99c1aed29$var$rh = 0, $d63234f99c1aed29$var$qk = 0, $d63234f99c1aed29$var$rk = 0, $d63234f99c1aed29$var$sk = null, $d63234f99c1aed29$var$tk = null, $d63234f99c1aed29$var$fk = 0, $d63234f99c1aed29$var$Gj = Infinity, $d63234f99c1aed29$var$uk = null, $d63234f99c1aed29$var$Oi = !1, $d63234f99c1aed29$var$Pi = null, $d63234f99c1aed29$var$Ri = null, $d63234f99c1aed29$var$vk = !1, $d63234f99c1aed29$var$wk = null, $d63234f99c1aed29$var$xk = 0, $d63234f99c1aed29$var$yk = 0, $d63234f99c1aed29$var$zk = null, $d63234f99c1aed29$var$Ak = -1, $d63234f99c1aed29$var$Bk = 0;
function $d63234f99c1aed29$var$R() {
    return 0 !== ($d63234f99c1aed29$var$K & 6) ? $d63234f99c1aed29$var$B() : -1 !== $d63234f99c1aed29$var$Ak ? $d63234f99c1aed29$var$Ak : $d63234f99c1aed29$var$Ak = $d63234f99c1aed29$var$B();
}
function $d63234f99c1aed29$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($d63234f99c1aed29$var$K & 2) && 0 !== $d63234f99c1aed29$var$Z) return $d63234f99c1aed29$var$Z & -$d63234f99c1aed29$var$Z;
    if (null !== $d63234f99c1aed29$var$Kg.transition) return 0 === $d63234f99c1aed29$var$Bk && ($d63234f99c1aed29$var$Bk = $d63234f99c1aed29$var$yc()), $d63234f99c1aed29$var$Bk;
    a = $d63234f99c1aed29$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $d63234f99c1aed29$var$jd(a.type);
    return a;
}
function $d63234f99c1aed29$var$gi(a, b, c, d) {
    if (50 < $d63234f99c1aed29$var$yk) throw $d63234f99c1aed29$var$yk = 0, $d63234f99c1aed29$var$zk = null, Error($d63234f99c1aed29$var$p(185));
    $d63234f99c1aed29$var$Ac(a, c, d);
    if (0 === ($d63234f99c1aed29$var$K & 2) || a !== $d63234f99c1aed29$var$Q) a === $d63234f99c1aed29$var$Q && (0 === ($d63234f99c1aed29$var$K & 2) && ($d63234f99c1aed29$var$qk |= c), 4 === $d63234f99c1aed29$var$T && $d63234f99c1aed29$var$Ck(a, $d63234f99c1aed29$var$Z)), $d63234f99c1aed29$var$Dk(a, d), 1 === c && 0 === $d63234f99c1aed29$var$K && 0 === (b.mode & 1) && ($d63234f99c1aed29$var$Gj = $d63234f99c1aed29$var$B() + 500, $d63234f99c1aed29$var$fg && $d63234f99c1aed29$var$jg());
}
function $d63234f99c1aed29$var$Dk(a, b) {
    var c = a.callbackNode;
    $d63234f99c1aed29$var$wc(a, b);
    var d = $d63234f99c1aed29$var$uc(a, a === $d63234f99c1aed29$var$Q ? $d63234f99c1aed29$var$Z : 0);
    if (0 === d) null !== c && $d63234f99c1aed29$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $d63234f99c1aed29$var$bc(c);
        if (1 === b) 0 === a.tag ? $d63234f99c1aed29$var$ig($d63234f99c1aed29$var$Ek.bind(null, a)) : $d63234f99c1aed29$var$hg($d63234f99c1aed29$var$Ek.bind(null, a)), $d63234f99c1aed29$var$Jf(function() {
            0 === ($d63234f99c1aed29$var$K & 6) && $d63234f99c1aed29$var$jg();
        }), c = null;
        else {
            switch($d63234f99c1aed29$var$Dc(d)){
                case 1:
                    c = $d63234f99c1aed29$var$fc;
                    break;
                case 4:
                    c = $d63234f99c1aed29$var$gc;
                    break;
                case 16:
                    c = $d63234f99c1aed29$var$hc;
                    break;
                case 536870912:
                    c = $d63234f99c1aed29$var$jc;
                    break;
                default:
                    c = $d63234f99c1aed29$var$hc;
            }
            c = $d63234f99c1aed29$var$Fk(c, $d63234f99c1aed29$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $d63234f99c1aed29$var$Gk(a, b) {
    $d63234f99c1aed29$var$Ak = -1;
    $d63234f99c1aed29$var$Bk = 0;
    if (0 !== ($d63234f99c1aed29$var$K & 6)) throw Error($d63234f99c1aed29$var$p(327));
    var c = a.callbackNode;
    if ($d63234f99c1aed29$var$Hk() && a.callbackNode !== c) return null;
    var d = $d63234f99c1aed29$var$uc(a, a === $d63234f99c1aed29$var$Q ? $d63234f99c1aed29$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $d63234f99c1aed29$var$Ik(a, d);
    else {
        b = d;
        var e = $d63234f99c1aed29$var$K;
        $d63234f99c1aed29$var$K |= 2;
        var f = $d63234f99c1aed29$var$Jk();
        if ($d63234f99c1aed29$var$Q !== a || $d63234f99c1aed29$var$Z !== b) $d63234f99c1aed29$var$uk = null, $d63234f99c1aed29$var$Gj = $d63234f99c1aed29$var$B() + 500, $d63234f99c1aed29$var$Kk(a, b);
        for(;;)try {
            $d63234f99c1aed29$var$Lk();
            break;
        } catch (h) {
            $d63234f99c1aed29$var$Mk(a, h);
        }
        $d63234f99c1aed29$var$$g();
        $d63234f99c1aed29$var$mk.current = f;
        $d63234f99c1aed29$var$K = e;
        null !== $d63234f99c1aed29$var$Y ? b = 0 : ($d63234f99c1aed29$var$Q = null, $d63234f99c1aed29$var$Z = 0, b = $d63234f99c1aed29$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $d63234f99c1aed29$var$xc(a), 0 !== e && (d = e, b = $d63234f99c1aed29$var$Nk(a, e)));
        if (1 === b) throw c = $d63234f99c1aed29$var$pk, $d63234f99c1aed29$var$Kk(a, 0), $d63234f99c1aed29$var$Ck(a, d), $d63234f99c1aed29$var$Dk(a, $d63234f99c1aed29$var$B()), c;
        if (6 === b) $d63234f99c1aed29$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$d63234f99c1aed29$var$Ok(e) && (b = $d63234f99c1aed29$var$Ik(a, d), 2 === b && (f = $d63234f99c1aed29$var$xc(a), 0 !== f && (d = f, b = $d63234f99c1aed29$var$Nk(a, f))), 1 === b)) throw c = $d63234f99c1aed29$var$pk, $d63234f99c1aed29$var$Kk(a, 0), $d63234f99c1aed29$var$Ck(a, d), $d63234f99c1aed29$var$Dk(a, $d63234f99c1aed29$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($d63234f99c1aed29$var$p(345));
                case 2:
                    $d63234f99c1aed29$var$Pk(a, $d63234f99c1aed29$var$tk, $d63234f99c1aed29$var$uk);
                    break;
                case 3:
                    $d63234f99c1aed29$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $d63234f99c1aed29$var$fk + 500 - $d63234f99c1aed29$var$B(), 10 < b)) {
                        if (0 !== $d63234f99c1aed29$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $d63234f99c1aed29$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $d63234f99c1aed29$var$Ff($d63234f99c1aed29$var$Pk.bind(null, a, $d63234f99c1aed29$var$tk, $d63234f99c1aed29$var$uk), b);
                        break;
                    }
                    $d63234f99c1aed29$var$Pk(a, $d63234f99c1aed29$var$tk, $d63234f99c1aed29$var$uk);
                    break;
                case 4:
                    $d63234f99c1aed29$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $d63234f99c1aed29$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $d63234f99c1aed29$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $d63234f99c1aed29$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $d63234f99c1aed29$var$Ff($d63234f99c1aed29$var$Pk.bind(null, a, $d63234f99c1aed29$var$tk, $d63234f99c1aed29$var$uk), d);
                        break;
                    }
                    $d63234f99c1aed29$var$Pk(a, $d63234f99c1aed29$var$tk, $d63234f99c1aed29$var$uk);
                    break;
                case 5:
                    $d63234f99c1aed29$var$Pk(a, $d63234f99c1aed29$var$tk, $d63234f99c1aed29$var$uk);
                    break;
                default:
                    throw Error($d63234f99c1aed29$var$p(329));
            }
        }
    }
    $d63234f99c1aed29$var$Dk(a, $d63234f99c1aed29$var$B());
    return a.callbackNode === c ? $d63234f99c1aed29$var$Gk.bind(null, a) : null;
}
function $d63234f99c1aed29$var$Nk(a, b) {
    var c = $d63234f99c1aed29$var$sk;
    a.current.memoizedState.isDehydrated && ($d63234f99c1aed29$var$Kk(a, b).flags |= 256);
    a = $d63234f99c1aed29$var$Ik(a, b);
    2 !== a && (b = $d63234f99c1aed29$var$tk, $d63234f99c1aed29$var$tk = c, null !== b && $d63234f99c1aed29$var$Fj(b));
    return a;
}
function $d63234f99c1aed29$var$Fj(a) {
    null === $d63234f99c1aed29$var$tk ? $d63234f99c1aed29$var$tk = a : $d63234f99c1aed29$var$tk.push.apply($d63234f99c1aed29$var$tk, a);
}
function $d63234f99c1aed29$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$d63234f99c1aed29$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $d63234f99c1aed29$var$Ck(a, b) {
    b &= ~$d63234f99c1aed29$var$rk;
    b &= ~$d63234f99c1aed29$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $d63234f99c1aed29$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $d63234f99c1aed29$var$Ek(a) {
    if (0 !== ($d63234f99c1aed29$var$K & 6)) throw Error($d63234f99c1aed29$var$p(327));
    $d63234f99c1aed29$var$Hk();
    var b = $d63234f99c1aed29$var$uc(a, 0);
    if (0 === (b & 1)) return $d63234f99c1aed29$var$Dk(a, $d63234f99c1aed29$var$B()), null;
    var c = $d63234f99c1aed29$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $d63234f99c1aed29$var$xc(a);
        0 !== d && (b = d, c = $d63234f99c1aed29$var$Nk(a, d));
    }
    if (1 === c) throw c = $d63234f99c1aed29$var$pk, $d63234f99c1aed29$var$Kk(a, 0), $d63234f99c1aed29$var$Ck(a, b), $d63234f99c1aed29$var$Dk(a, $d63234f99c1aed29$var$B()), c;
    if (6 === c) throw Error($d63234f99c1aed29$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $d63234f99c1aed29$var$Pk(a, $d63234f99c1aed29$var$tk, $d63234f99c1aed29$var$uk);
    $d63234f99c1aed29$var$Dk(a, $d63234f99c1aed29$var$B());
    return null;
}
function $d63234f99c1aed29$var$Qk(a, b) {
    var c = $d63234f99c1aed29$var$K;
    $d63234f99c1aed29$var$K |= 1;
    try {
        return a(b);
    } finally{
        $d63234f99c1aed29$var$K = c, 0 === $d63234f99c1aed29$var$K && ($d63234f99c1aed29$var$Gj = $d63234f99c1aed29$var$B() + 500, $d63234f99c1aed29$var$fg && $d63234f99c1aed29$var$jg());
    }
}
function $d63234f99c1aed29$var$Rk(a) {
    null !== $d63234f99c1aed29$var$wk && 0 === $d63234f99c1aed29$var$wk.tag && 0 === ($d63234f99c1aed29$var$K & 6) && $d63234f99c1aed29$var$Hk();
    var b = $d63234f99c1aed29$var$K;
    $d63234f99c1aed29$var$K |= 1;
    var c = $d63234f99c1aed29$var$ok.transition, d = $d63234f99c1aed29$var$C;
    try {
        if ($d63234f99c1aed29$var$ok.transition = null, $d63234f99c1aed29$var$C = 1, a) return a();
    } finally{
        $d63234f99c1aed29$var$C = d, $d63234f99c1aed29$var$ok.transition = c, $d63234f99c1aed29$var$K = b, 0 === ($d63234f99c1aed29$var$K & 6) && $d63234f99c1aed29$var$jg();
    }
}
function $d63234f99c1aed29$var$Hj() {
    $d63234f99c1aed29$var$fj = $d63234f99c1aed29$var$ej.current;
    $d63234f99c1aed29$var$E($d63234f99c1aed29$var$ej);
}
function $d63234f99c1aed29$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $d63234f99c1aed29$var$Gf(c));
    if (null !== $d63234f99c1aed29$var$Y) for(c = $d63234f99c1aed29$var$Y.return; null !== c;){
        var d = c;
        $d63234f99c1aed29$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $d63234f99c1aed29$var$$f();
                break;
            case 3:
                $d63234f99c1aed29$var$zh();
                $d63234f99c1aed29$var$E($d63234f99c1aed29$var$Wf);
                $d63234f99c1aed29$var$E($d63234f99c1aed29$var$H);
                $d63234f99c1aed29$var$Eh();
                break;
            case 5:
                $d63234f99c1aed29$var$Bh(d);
                break;
            case 4:
                $d63234f99c1aed29$var$zh();
                break;
            case 13:
                $d63234f99c1aed29$var$E($d63234f99c1aed29$var$L);
                break;
            case 19:
                $d63234f99c1aed29$var$E($d63234f99c1aed29$var$L);
                break;
            case 10:
                $d63234f99c1aed29$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $d63234f99c1aed29$var$Hj();
        }
        c = c.return;
    }
    $d63234f99c1aed29$var$Q = a;
    $d63234f99c1aed29$var$Y = a = $d63234f99c1aed29$var$Pg(a.current, null);
    $d63234f99c1aed29$var$Z = $d63234f99c1aed29$var$fj = b;
    $d63234f99c1aed29$var$T = 0;
    $d63234f99c1aed29$var$pk = null;
    $d63234f99c1aed29$var$rk = $d63234f99c1aed29$var$qk = $d63234f99c1aed29$var$rh = 0;
    $d63234f99c1aed29$var$tk = $d63234f99c1aed29$var$sk = null;
    if (null !== $d63234f99c1aed29$var$fh) {
        for(b = 0; b < $d63234f99c1aed29$var$fh.length; b++)if (c = $d63234f99c1aed29$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $d63234f99c1aed29$var$fh = null;
    }
    return a;
}
function $d63234f99c1aed29$var$Mk(a, b) {
    do {
        var c = $d63234f99c1aed29$var$Y;
        try {
            $d63234f99c1aed29$var$$g();
            $d63234f99c1aed29$var$Fh.current = $d63234f99c1aed29$var$Rh;
            if ($d63234f99c1aed29$var$Ih) {
                for(var d = $d63234f99c1aed29$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $d63234f99c1aed29$var$Ih = !1;
            }
            $d63234f99c1aed29$var$Hh = 0;
            $d63234f99c1aed29$var$O = $d63234f99c1aed29$var$N = $d63234f99c1aed29$var$M = null;
            $d63234f99c1aed29$var$Jh = !1;
            $d63234f99c1aed29$var$Kh = 0;
            $d63234f99c1aed29$var$nk.current = null;
            if (null === c || null === c.return) {
                $d63234f99c1aed29$var$T = 1;
                $d63234f99c1aed29$var$pk = b;
                $d63234f99c1aed29$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $d63234f99c1aed29$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $d63234f99c1aed29$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $d63234f99c1aed29$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $d63234f99c1aed29$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $d63234f99c1aed29$var$Si(f, l, b);
                            $d63234f99c1aed29$var$tj();
                            break a;
                        }
                        k = Error($d63234f99c1aed29$var$p(426));
                    }
                } else if ($d63234f99c1aed29$var$I && h.mode & 1) {
                    var J = $d63234f99c1aed29$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $d63234f99c1aed29$var$Vi(J, g, h, f, b);
                        $d63234f99c1aed29$var$Jg($d63234f99c1aed29$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $d63234f99c1aed29$var$Ji(k, h);
                4 !== $d63234f99c1aed29$var$T && ($d63234f99c1aed29$var$T = 2);
                null === $d63234f99c1aed29$var$sk ? $d63234f99c1aed29$var$sk = [
                    f
                ] : $d63234f99c1aed29$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $d63234f99c1aed29$var$Ni(f, k, b);
                            $d63234f99c1aed29$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $d63234f99c1aed29$var$Ri || !$d63234f99c1aed29$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $d63234f99c1aed29$var$Qi(f, h, b);
                                $d63234f99c1aed29$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $d63234f99c1aed29$var$Sk(c);
        } catch (na) {
            b = na;
            $d63234f99c1aed29$var$Y === c && null !== c && ($d63234f99c1aed29$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $d63234f99c1aed29$var$Jk() {
    var a = $d63234f99c1aed29$var$mk.current;
    $d63234f99c1aed29$var$mk.current = $d63234f99c1aed29$var$Rh;
    return null === a ? $d63234f99c1aed29$var$Rh : a;
}
function $d63234f99c1aed29$var$tj() {
    if (0 === $d63234f99c1aed29$var$T || 3 === $d63234f99c1aed29$var$T || 2 === $d63234f99c1aed29$var$T) $d63234f99c1aed29$var$T = 4;
    null === $d63234f99c1aed29$var$Q || 0 === ($d63234f99c1aed29$var$rh & 268435455) && 0 === ($d63234f99c1aed29$var$qk & 268435455) || $d63234f99c1aed29$var$Ck($d63234f99c1aed29$var$Q, $d63234f99c1aed29$var$Z);
}
function $d63234f99c1aed29$var$Ik(a, b) {
    var c = $d63234f99c1aed29$var$K;
    $d63234f99c1aed29$var$K |= 2;
    var d = $d63234f99c1aed29$var$Jk();
    if ($d63234f99c1aed29$var$Q !== a || $d63234f99c1aed29$var$Z !== b) $d63234f99c1aed29$var$uk = null, $d63234f99c1aed29$var$Kk(a, b);
    for(;;)try {
        $d63234f99c1aed29$var$Tk();
        break;
    } catch (e) {
        $d63234f99c1aed29$var$Mk(a, e);
    }
    $d63234f99c1aed29$var$$g();
    $d63234f99c1aed29$var$K = c;
    $d63234f99c1aed29$var$mk.current = d;
    if (null !== $d63234f99c1aed29$var$Y) throw Error($d63234f99c1aed29$var$p(261));
    $d63234f99c1aed29$var$Q = null;
    $d63234f99c1aed29$var$Z = 0;
    return $d63234f99c1aed29$var$T;
}
function $d63234f99c1aed29$var$Tk() {
    for(; null !== $d63234f99c1aed29$var$Y;)$d63234f99c1aed29$var$Uk($d63234f99c1aed29$var$Y);
}
function $d63234f99c1aed29$var$Lk() {
    for(; null !== $d63234f99c1aed29$var$Y && !$d63234f99c1aed29$var$cc();)$d63234f99c1aed29$var$Uk($d63234f99c1aed29$var$Y);
}
function $d63234f99c1aed29$var$Uk(a) {
    var b = $d63234f99c1aed29$var$Vk(a.alternate, a, $d63234f99c1aed29$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $d63234f99c1aed29$var$Sk(a) : $d63234f99c1aed29$var$Y = b;
    $d63234f99c1aed29$var$nk.current = null;
}
function $d63234f99c1aed29$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $d63234f99c1aed29$var$Ej(c, b, $d63234f99c1aed29$var$fj), null !== c) {
                $d63234f99c1aed29$var$Y = c;
                return;
            }
        } else {
            c = $d63234f99c1aed29$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $d63234f99c1aed29$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $d63234f99c1aed29$var$T = 6;
                $d63234f99c1aed29$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $d63234f99c1aed29$var$Y = b;
            return;
        }
        $d63234f99c1aed29$var$Y = b = a;
    }while (null !== b);
    0 === $d63234f99c1aed29$var$T && ($d63234f99c1aed29$var$T = 5);
}
function $d63234f99c1aed29$var$Pk(a, b, c) {
    var d = $d63234f99c1aed29$var$C, e = $d63234f99c1aed29$var$ok.transition;
    try {
        $d63234f99c1aed29$var$ok.transition = null, $d63234f99c1aed29$var$C = 1, $d63234f99c1aed29$var$Wk(a, b, c, d);
    } finally{
        $d63234f99c1aed29$var$ok.transition = e, $d63234f99c1aed29$var$C = d;
    }
    return null;
}
function $d63234f99c1aed29$var$Wk(a, b, c, d) {
    do $d63234f99c1aed29$var$Hk();
    while (null !== $d63234f99c1aed29$var$wk);
    if (0 !== ($d63234f99c1aed29$var$K & 6)) throw Error($d63234f99c1aed29$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($d63234f99c1aed29$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $d63234f99c1aed29$var$Bc(a, f);
    a === $d63234f99c1aed29$var$Q && ($d63234f99c1aed29$var$Y = $d63234f99c1aed29$var$Q = null, $d63234f99c1aed29$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $d63234f99c1aed29$var$vk || ($d63234f99c1aed29$var$vk = !0, $d63234f99c1aed29$var$Fk($d63234f99c1aed29$var$hc, function() {
        $d63234f99c1aed29$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $d63234f99c1aed29$var$ok.transition;
        $d63234f99c1aed29$var$ok.transition = null;
        var g = $d63234f99c1aed29$var$C;
        $d63234f99c1aed29$var$C = 1;
        var h = $d63234f99c1aed29$var$K;
        $d63234f99c1aed29$var$K |= 4;
        $d63234f99c1aed29$var$nk.current = null;
        $d63234f99c1aed29$var$Oj(a, c);
        $d63234f99c1aed29$var$dk(c, a);
        $d63234f99c1aed29$var$Oe($d63234f99c1aed29$var$Df);
        $d63234f99c1aed29$var$dd = !!$d63234f99c1aed29$var$Cf;
        $d63234f99c1aed29$var$Df = $d63234f99c1aed29$var$Cf = null;
        a.current = c;
        $d63234f99c1aed29$var$hk(c, a, e);
        $d63234f99c1aed29$var$dc();
        $d63234f99c1aed29$var$K = h;
        $d63234f99c1aed29$var$C = g;
        $d63234f99c1aed29$var$ok.transition = f;
    } else a.current = c;
    $d63234f99c1aed29$var$vk && ($d63234f99c1aed29$var$vk = !1, $d63234f99c1aed29$var$wk = a, $d63234f99c1aed29$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($d63234f99c1aed29$var$Ri = null);
    $d63234f99c1aed29$var$mc(c.stateNode, d);
    $d63234f99c1aed29$var$Dk(a, $d63234f99c1aed29$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($d63234f99c1aed29$var$Oi) throw $d63234f99c1aed29$var$Oi = !1, a = $d63234f99c1aed29$var$Pi, $d63234f99c1aed29$var$Pi = null, a;
    0 !== ($d63234f99c1aed29$var$xk & 1) && 0 !== a.tag && $d63234f99c1aed29$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $d63234f99c1aed29$var$zk ? $d63234f99c1aed29$var$yk++ : ($d63234f99c1aed29$var$yk = 0, $d63234f99c1aed29$var$zk = a) : $d63234f99c1aed29$var$yk = 0;
    $d63234f99c1aed29$var$jg();
    return null;
}
function $d63234f99c1aed29$var$Hk() {
    if (null !== $d63234f99c1aed29$var$wk) {
        var a = $d63234f99c1aed29$var$Dc($d63234f99c1aed29$var$xk), b = $d63234f99c1aed29$var$ok.transition, c = $d63234f99c1aed29$var$C;
        try {
            $d63234f99c1aed29$var$ok.transition = null;
            $d63234f99c1aed29$var$C = 16 > a ? 16 : a;
            if (null === $d63234f99c1aed29$var$wk) var d = !1;
            else {
                a = $d63234f99c1aed29$var$wk;
                $d63234f99c1aed29$var$wk = null;
                $d63234f99c1aed29$var$xk = 0;
                if (0 !== ($d63234f99c1aed29$var$K & 6)) throw Error($d63234f99c1aed29$var$p(331));
                var e = $d63234f99c1aed29$var$K;
                $d63234f99c1aed29$var$K |= 4;
                for($d63234f99c1aed29$var$V = a.current; null !== $d63234f99c1aed29$var$V;){
                    var f = $d63234f99c1aed29$var$V, g = f.child;
                    if (0 !== ($d63234f99c1aed29$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($d63234f99c1aed29$var$V = l; null !== $d63234f99c1aed29$var$V;){
                                    var m = $d63234f99c1aed29$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $d63234f99c1aed29$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $d63234f99c1aed29$var$V = q;
                                    else for(; null !== $d63234f99c1aed29$var$V;){
                                        m = $d63234f99c1aed29$var$V;
                                        var r = m.sibling, y = m.return;
                                        $d63234f99c1aed29$var$Sj(m);
                                        if (m === l) {
                                            $d63234f99c1aed29$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $d63234f99c1aed29$var$V = r;
                                            break;
                                        }
                                        $d63234f99c1aed29$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $d63234f99c1aed29$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $d63234f99c1aed29$var$V = g;
                    else b: for(; null !== $d63234f99c1aed29$var$V;){
                        f = $d63234f99c1aed29$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $d63234f99c1aed29$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $d63234f99c1aed29$var$V = x;
                            break b;
                        }
                        $d63234f99c1aed29$var$V = f.return;
                    }
                }
                var w = a.current;
                for($d63234f99c1aed29$var$V = w; null !== $d63234f99c1aed29$var$V;){
                    g = $d63234f99c1aed29$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $d63234f99c1aed29$var$V = u;
                    else b: for(g = w; null !== $d63234f99c1aed29$var$V;){
                        h = $d63234f99c1aed29$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $d63234f99c1aed29$var$Qj(9, h);
                            }
                        } catch (na) {
                            $d63234f99c1aed29$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $d63234f99c1aed29$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $d63234f99c1aed29$var$V = F;
                            break b;
                        }
                        $d63234f99c1aed29$var$V = h.return;
                    }
                }
                $d63234f99c1aed29$var$K = e;
                $d63234f99c1aed29$var$jg();
                if ($d63234f99c1aed29$var$lc && "function" === typeof $d63234f99c1aed29$var$lc.onPostCommitFiberRoot) try {
                    $d63234f99c1aed29$var$lc.onPostCommitFiberRoot($d63234f99c1aed29$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $d63234f99c1aed29$var$C = c, $d63234f99c1aed29$var$ok.transition = b;
        }
    }
    return !1;
}
function $d63234f99c1aed29$var$Xk(a, b, c) {
    b = $d63234f99c1aed29$var$Ji(c, b);
    b = $d63234f99c1aed29$var$Ni(a, b, 1);
    a = $d63234f99c1aed29$var$nh(a, b, 1);
    b = $d63234f99c1aed29$var$R();
    null !== a && ($d63234f99c1aed29$var$Ac(a, 1, b), $d63234f99c1aed29$var$Dk(a, b));
}
function $d63234f99c1aed29$var$W(a, b, c) {
    if (3 === a.tag) $d63234f99c1aed29$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $d63234f99c1aed29$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $d63234f99c1aed29$var$Ri || !$d63234f99c1aed29$var$Ri.has(d))) {
                a = $d63234f99c1aed29$var$Ji(c, a);
                a = $d63234f99c1aed29$var$Qi(b, a, 1);
                b = $d63234f99c1aed29$var$nh(b, a, 1);
                a = $d63234f99c1aed29$var$R();
                null !== b && ($d63234f99c1aed29$var$Ac(b, 1, a), $d63234f99c1aed29$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $d63234f99c1aed29$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $d63234f99c1aed29$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $d63234f99c1aed29$var$Q === a && ($d63234f99c1aed29$var$Z & c) === c && (4 === $d63234f99c1aed29$var$T || 3 === $d63234f99c1aed29$var$T && ($d63234f99c1aed29$var$Z & 130023424) === $d63234f99c1aed29$var$Z && 500 > $d63234f99c1aed29$var$B() - $d63234f99c1aed29$var$fk ? $d63234f99c1aed29$var$Kk(a, 0) : $d63234f99c1aed29$var$rk |= c);
    $d63234f99c1aed29$var$Dk(a, b);
}
function $d63234f99c1aed29$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $d63234f99c1aed29$var$sc, $d63234f99c1aed29$var$sc <<= 1, 0 === ($d63234f99c1aed29$var$sc & 130023424) && ($d63234f99c1aed29$var$sc = 4194304)));
    var c = $d63234f99c1aed29$var$R();
    a = $d63234f99c1aed29$var$ih(a, b);
    null !== a && ($d63234f99c1aed29$var$Ac(a, b, c), $d63234f99c1aed29$var$Dk(a, c));
}
function $d63234f99c1aed29$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $d63234f99c1aed29$var$Yk(a, c);
}
function $d63234f99c1aed29$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($d63234f99c1aed29$var$p(314));
    }
    null !== d && d.delete(b);
    $d63234f99c1aed29$var$Yk(a, c);
}
var $d63234f99c1aed29$var$Vk;
$d63234f99c1aed29$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $d63234f99c1aed29$var$Wf.current) $d63234f99c1aed29$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $d63234f99c1aed29$var$dh = !1, $d63234f99c1aed29$var$yj(a, b, c);
            $d63234f99c1aed29$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $d63234f99c1aed29$var$dh = !1, $d63234f99c1aed29$var$I && 0 !== (b.flags & 1048576) && $d63234f99c1aed29$var$ug(b, $d63234f99c1aed29$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $d63234f99c1aed29$var$ij(a, b);
            a = b.pendingProps;
            var e = $d63234f99c1aed29$var$Yf(b, $d63234f99c1aed29$var$H.current);
            $d63234f99c1aed29$var$ch(b, c);
            e = $d63234f99c1aed29$var$Nh(null, b, d, a, e, c);
            var f = $d63234f99c1aed29$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $d63234f99c1aed29$var$Zf(d) ? (f = !0, $d63234f99c1aed29$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $d63234f99c1aed29$var$kh(b), e.updater = $d63234f99c1aed29$var$Ei, b.stateNode = e, e._reactInternals = b, $d63234f99c1aed29$var$Ii(b, d, a, c), b = $d63234f99c1aed29$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $d63234f99c1aed29$var$I && f && $d63234f99c1aed29$var$vg(b), $d63234f99c1aed29$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $d63234f99c1aed29$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $d63234f99c1aed29$var$Zk(d);
                a = $d63234f99c1aed29$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $d63234f99c1aed29$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $d63234f99c1aed29$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $d63234f99c1aed29$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $d63234f99c1aed29$var$$i(null, b, d, $d63234f99c1aed29$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($d63234f99c1aed29$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d63234f99c1aed29$var$Ci(d, e), $d63234f99c1aed29$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d63234f99c1aed29$var$Ci(d, e), $d63234f99c1aed29$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $d63234f99c1aed29$var$kj(b);
                if (null === a) throw Error($d63234f99c1aed29$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $d63234f99c1aed29$var$lh(a, b);
                $d63234f99c1aed29$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $d63234f99c1aed29$var$Ji(Error($d63234f99c1aed29$var$p(423)), b);
                        b = $d63234f99c1aed29$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $d63234f99c1aed29$var$Ji(Error($d63234f99c1aed29$var$p(424)), b);
                        b = $d63234f99c1aed29$var$lj(a, b, d, c, e);
                        break a;
                    } else for($d63234f99c1aed29$var$yg = $d63234f99c1aed29$var$Lf(b.stateNode.containerInfo.firstChild), $d63234f99c1aed29$var$xg = b, $d63234f99c1aed29$var$I = !0, $d63234f99c1aed29$var$zg = null, c = $d63234f99c1aed29$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $d63234f99c1aed29$var$Ig();
                    if (d === e) {
                        b = $d63234f99c1aed29$var$Zi(a, b, c);
                        break a;
                    }
                    $d63234f99c1aed29$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $d63234f99c1aed29$var$Ah(b), null === a && $d63234f99c1aed29$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $d63234f99c1aed29$var$Ef(d, e) ? g = null : null !== f && $d63234f99c1aed29$var$Ef(d, f) && (b.flags |= 32), $d63234f99c1aed29$var$gj(a, b), $d63234f99c1aed29$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $d63234f99c1aed29$var$Eg(b), null;
        case 13:
            return $d63234f99c1aed29$var$oj(a, b, c);
        case 4:
            return $d63234f99c1aed29$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $d63234f99c1aed29$var$Ug(b, null, d, c) : $d63234f99c1aed29$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d63234f99c1aed29$var$Ci(d, e), $d63234f99c1aed29$var$Yi(a, b, d, e, c);
        case 7:
            return $d63234f99c1aed29$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $d63234f99c1aed29$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $d63234f99c1aed29$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $d63234f99c1aed29$var$G($d63234f99c1aed29$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($d63234f99c1aed29$var$He(f.value, g)) {
                        if (f.children === e.children && !$d63234f99c1aed29$var$Wf.current) {
                            b = $d63234f99c1aed29$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $d63234f99c1aed29$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $d63234f99c1aed29$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($d63234f99c1aed29$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $d63234f99c1aed29$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $d63234f99c1aed29$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $d63234f99c1aed29$var$ch(b, c), e = $d63234f99c1aed29$var$eh(e), d = d(e), b.flags |= 1, $d63234f99c1aed29$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $d63234f99c1aed29$var$Ci(d, b.pendingProps), e = $d63234f99c1aed29$var$Ci(d.type, e), $d63234f99c1aed29$var$$i(a, b, d, e, c);
        case 15:
            return $d63234f99c1aed29$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $d63234f99c1aed29$var$Ci(d, e), $d63234f99c1aed29$var$ij(a, b), b.tag = 1, $d63234f99c1aed29$var$Zf(d) ? (a = !0, $d63234f99c1aed29$var$cg(b)) : a = !1, $d63234f99c1aed29$var$ch(b, c), $d63234f99c1aed29$var$Gi(b, d, e), $d63234f99c1aed29$var$Ii(b, d, e, c), $d63234f99c1aed29$var$jj(null, b, d, !0, a, c);
        case 19:
            return $d63234f99c1aed29$var$xj(a, b, c);
        case 22:
            return $d63234f99c1aed29$var$dj(a, b, c);
    }
    throw Error($d63234f99c1aed29$var$p(156, b.tag));
};
function $d63234f99c1aed29$var$Fk(a, b) {
    return $d63234f99c1aed29$var$ac(a, b);
}
function $d63234f99c1aed29$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $d63234f99c1aed29$var$Bg(a, b, c, d) {
    return new $d63234f99c1aed29$var$$k(a, b, c, d);
}
function $d63234f99c1aed29$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $d63234f99c1aed29$var$Zk(a) {
    if ("function" === typeof a) return $d63234f99c1aed29$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $d63234f99c1aed29$var$Da) return 11;
        if (a === $d63234f99c1aed29$var$Ga) return 14;
    }
    return 2;
}
function $d63234f99c1aed29$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $d63234f99c1aed29$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $d63234f99c1aed29$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $d63234f99c1aed29$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $d63234f99c1aed29$var$ya:
            return $d63234f99c1aed29$var$Tg(c.children, e, f, b);
        case $d63234f99c1aed29$var$za:
            g = 8;
            e |= 8;
            break;
        case $d63234f99c1aed29$var$Aa:
            return a = $d63234f99c1aed29$var$Bg(12, c, b, e | 2), a.elementType = $d63234f99c1aed29$var$Aa, a.lanes = f, a;
        case $d63234f99c1aed29$var$Ea:
            return a = $d63234f99c1aed29$var$Bg(13, c, b, e), a.elementType = $d63234f99c1aed29$var$Ea, a.lanes = f, a;
        case $d63234f99c1aed29$var$Fa:
            return a = $d63234f99c1aed29$var$Bg(19, c, b, e), a.elementType = $d63234f99c1aed29$var$Fa, a.lanes = f, a;
        case $d63234f99c1aed29$var$Ia:
            return $d63234f99c1aed29$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $d63234f99c1aed29$var$Ba:
                    g = 10;
                    break a;
                case $d63234f99c1aed29$var$Ca:
                    g = 9;
                    break a;
                case $d63234f99c1aed29$var$Da:
                    g = 11;
                    break a;
                case $d63234f99c1aed29$var$Ga:
                    g = 14;
                    break a;
                case $d63234f99c1aed29$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($d63234f99c1aed29$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $d63234f99c1aed29$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $d63234f99c1aed29$var$Tg(a, b, c, d) {
    a = $d63234f99c1aed29$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $d63234f99c1aed29$var$pj(a, b, c, d) {
    a = $d63234f99c1aed29$var$Bg(22, a, d, b);
    a.elementType = $d63234f99c1aed29$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $d63234f99c1aed29$var$Qg(a, b, c) {
    a = $d63234f99c1aed29$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $d63234f99c1aed29$var$Sg(a, b, c) {
    b = $d63234f99c1aed29$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $d63234f99c1aed29$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $d63234f99c1aed29$var$zc(0);
    this.expirationTimes = $d63234f99c1aed29$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $d63234f99c1aed29$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $d63234f99c1aed29$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $d63234f99c1aed29$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $d63234f99c1aed29$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $d63234f99c1aed29$var$kh(f);
    return a;
}
function $d63234f99c1aed29$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $d63234f99c1aed29$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $d63234f99c1aed29$var$dl(a) {
    if (!a) return $d63234f99c1aed29$var$Vf;
    a = a._reactInternals;
    a: {
        if ($d63234f99c1aed29$var$Vb(a) !== a || 1 !== a.tag) throw Error($d63234f99c1aed29$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($d63234f99c1aed29$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($d63234f99c1aed29$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($d63234f99c1aed29$var$Zf(c)) return $d63234f99c1aed29$var$bg(a, c, b);
    }
    return b;
}
function $d63234f99c1aed29$var$el(a, b, c, d, e, f, g, h, k) {
    a = $d63234f99c1aed29$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $d63234f99c1aed29$var$dl(null);
    c = a.current;
    d = $d63234f99c1aed29$var$R();
    e = $d63234f99c1aed29$var$yi(c);
    f = $d63234f99c1aed29$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $d63234f99c1aed29$var$nh(c, f, e);
    a.current.lanes = e;
    $d63234f99c1aed29$var$Ac(a, e, d);
    $d63234f99c1aed29$var$Dk(a, d);
    return a;
}
function $d63234f99c1aed29$var$fl(a, b, c, d) {
    var e = b.current, f = $d63234f99c1aed29$var$R(), g = $d63234f99c1aed29$var$yi(e);
    c = $d63234f99c1aed29$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $d63234f99c1aed29$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $d63234f99c1aed29$var$nh(e, b, g);
    null !== a && ($d63234f99c1aed29$var$gi(a, e, g, f), $d63234f99c1aed29$var$oh(a, e, g));
    return g;
}
function $d63234f99c1aed29$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $d63234f99c1aed29$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $d63234f99c1aed29$var$il(a, b) {
    $d63234f99c1aed29$var$hl(a, b);
    (a = a.alternate) && $d63234f99c1aed29$var$hl(a, b);
}
function $d63234f99c1aed29$var$jl() {
    return null;
}
var $d63234f99c1aed29$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $d63234f99c1aed29$var$ll(a) {
    this._internalRoot = a;
}
$d63234f99c1aed29$var$ml.prototype.render = $d63234f99c1aed29$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($d63234f99c1aed29$var$p(409));
    $d63234f99c1aed29$var$fl(a, b, null, null);
};
$d63234f99c1aed29$var$ml.prototype.unmount = $d63234f99c1aed29$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $d63234f99c1aed29$var$Rk(function() {
            $d63234f99c1aed29$var$fl(null, a, null, null);
        });
        b[$d63234f99c1aed29$var$uf] = null;
    }
};
function $d63234f99c1aed29$var$ml(a) {
    this._internalRoot = a;
}
$d63234f99c1aed29$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $d63234f99c1aed29$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $d63234f99c1aed29$var$Qc.length && 0 !== b && b < $d63234f99c1aed29$var$Qc[c].priority; c++);
        $d63234f99c1aed29$var$Qc.splice(c, 0, a);
        0 === c && $d63234f99c1aed29$var$Vc(a);
    }
};
function $d63234f99c1aed29$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $d63234f99c1aed29$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $d63234f99c1aed29$var$pl() {}
function $d63234f99c1aed29$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $d63234f99c1aed29$var$gl(g);
                f.call(a);
            };
        }
        var g = $d63234f99c1aed29$var$el(b, d, a, 0, null, !1, !1, "", $d63234f99c1aed29$var$pl);
        a._reactRootContainer = g;
        a[$d63234f99c1aed29$var$uf] = g.current;
        $d63234f99c1aed29$var$sf(8 === a.nodeType ? a.parentNode : a);
        $d63234f99c1aed29$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $d63234f99c1aed29$var$gl(k);
            h.call(a);
        };
    }
    var k = $d63234f99c1aed29$var$bl(a, 0, !1, null, null, !1, !1, "", $d63234f99c1aed29$var$pl);
    a._reactRootContainer = k;
    a[$d63234f99c1aed29$var$uf] = k.current;
    $d63234f99c1aed29$var$sf(8 === a.nodeType ? a.parentNode : a);
    $d63234f99c1aed29$var$Rk(function() {
        $d63234f99c1aed29$var$fl(b, k, c, d);
    });
    return k;
}
function $d63234f99c1aed29$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $d63234f99c1aed29$var$gl(g);
                h.call(a);
            };
        }
        $d63234f99c1aed29$var$fl(b, g, a, e);
    } else g = $d63234f99c1aed29$var$ql(c, b, a, e, d);
    return $d63234f99c1aed29$var$gl(g);
}
$d63234f99c1aed29$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $d63234f99c1aed29$var$tc(b.pendingLanes);
                0 !== c && ($d63234f99c1aed29$var$Cc(b, c | 1), $d63234f99c1aed29$var$Dk(b, $d63234f99c1aed29$var$B()), 0 === ($d63234f99c1aed29$var$K & 6) && ($d63234f99c1aed29$var$Gj = $d63234f99c1aed29$var$B() + 500, $d63234f99c1aed29$var$jg()));
            }
            break;
        case 13:
            $d63234f99c1aed29$var$Rk(function() {
                var b = $d63234f99c1aed29$var$ih(a, 1);
                if (null !== b) {
                    var c = $d63234f99c1aed29$var$R();
                    $d63234f99c1aed29$var$gi(b, a, 1, c);
                }
            }), $d63234f99c1aed29$var$il(a, 1);
    }
};
$d63234f99c1aed29$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $d63234f99c1aed29$var$ih(a, 134217728);
        if (null !== b) {
            var c = $d63234f99c1aed29$var$R();
            $d63234f99c1aed29$var$gi(b, a, 134217728, c);
        }
        $d63234f99c1aed29$var$il(a, 134217728);
    }
};
$d63234f99c1aed29$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $d63234f99c1aed29$var$yi(a), c = $d63234f99c1aed29$var$ih(a, b);
        if (null !== c) {
            var d = $d63234f99c1aed29$var$R();
            $d63234f99c1aed29$var$gi(c, a, b, d);
        }
        $d63234f99c1aed29$var$il(a, b);
    }
};
$d63234f99c1aed29$var$Hc = function() {
    return $d63234f99c1aed29$var$C;
};
$d63234f99c1aed29$var$Ic = function(a, b) {
    var c = $d63234f99c1aed29$var$C;
    try {
        return $d63234f99c1aed29$var$C = a, b();
    } finally{
        $d63234f99c1aed29$var$C = c;
    }
};
$d63234f99c1aed29$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $d63234f99c1aed29$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $d63234f99c1aed29$var$Db(d);
                        if (!e) throw Error($d63234f99c1aed29$var$p(90));
                        $d63234f99c1aed29$var$Wa(d);
                        $d63234f99c1aed29$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $d63234f99c1aed29$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $d63234f99c1aed29$var$fb(a, !!c.multiple, b, !1);
    }
};
$d63234f99c1aed29$var$Gb = $d63234f99c1aed29$var$Qk;
$d63234f99c1aed29$var$Hb = $d63234f99c1aed29$var$Rk;
var $d63234f99c1aed29$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $d63234f99c1aed29$var$Cb,
        $d63234f99c1aed29$var$ue,
        $d63234f99c1aed29$var$Db,
        $d63234f99c1aed29$var$Eb,
        $d63234f99c1aed29$var$Fb,
        $d63234f99c1aed29$var$Qk
    ]
}, $d63234f99c1aed29$var$tl = {
    findFiberByHostInstance: $d63234f99c1aed29$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $d63234f99c1aed29$var$ul = {
    bundleType: $d63234f99c1aed29$var$tl.bundleType,
    version: $d63234f99c1aed29$var$tl.version,
    rendererPackageName: $d63234f99c1aed29$var$tl.rendererPackageName,
    rendererConfig: $d63234f99c1aed29$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $d63234f99c1aed29$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $d63234f99c1aed29$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $d63234f99c1aed29$var$tl.findFiberByHostInstance || $d63234f99c1aed29$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $d63234f99c1aed29$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$d63234f99c1aed29$var$vl.isDisabled && $d63234f99c1aed29$var$vl.supportsFiber) try {
        $d63234f99c1aed29$var$kc = $d63234f99c1aed29$var$vl.inject($d63234f99c1aed29$var$ul), $d63234f99c1aed29$var$lc = $d63234f99c1aed29$var$vl;
    } catch (a) {}
}
$d63234f99c1aed29$export$ae55be85d98224ed = $d63234f99c1aed29$var$sl;
$d63234f99c1aed29$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$d63234f99c1aed29$var$nl(b)) throw Error($d63234f99c1aed29$var$p(200));
    return $d63234f99c1aed29$var$cl(a, b, null, c);
};
$d63234f99c1aed29$export$882461b6382ed46c = function(a, b) {
    if (!$d63234f99c1aed29$var$nl(a)) throw Error($d63234f99c1aed29$var$p(299));
    var c = !1, d = "", e = $d63234f99c1aed29$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $d63234f99c1aed29$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$d63234f99c1aed29$var$uf] = b.current;
    $d63234f99c1aed29$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $d63234f99c1aed29$var$ll(b);
};
$d63234f99c1aed29$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($d63234f99c1aed29$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($d63234f99c1aed29$var$p(268, a));
    }
    a = $d63234f99c1aed29$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$d63234f99c1aed29$export$cd75ccfd720a3cd4 = function(a) {
    return $d63234f99c1aed29$var$Rk(a);
};
$d63234f99c1aed29$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$d63234f99c1aed29$var$ol(b)) throw Error($d63234f99c1aed29$var$p(200));
    return $d63234f99c1aed29$var$rl(null, a, b, !0, c);
};
$d63234f99c1aed29$export$757ceba2d55c277e = function(a, b, c) {
    if (!$d63234f99c1aed29$var$nl(a)) throw Error($d63234f99c1aed29$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $d63234f99c1aed29$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $d63234f99c1aed29$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$d63234f99c1aed29$var$uf] = b.current;
    $d63234f99c1aed29$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $d63234f99c1aed29$var$ml(b);
};
$d63234f99c1aed29$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$d63234f99c1aed29$var$ol(b)) throw Error($d63234f99c1aed29$var$p(200));
    return $d63234f99c1aed29$var$rl(null, a, b, !1, c);
};
$d63234f99c1aed29$export$502457920280e6be = function(a) {
    if (!$d63234f99c1aed29$var$ol(a)) throw Error($d63234f99c1aed29$var$p(40));
    return a._reactRootContainer ? ($d63234f99c1aed29$var$Rk(function() {
        $d63234f99c1aed29$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$d63234f99c1aed29$var$uf] = null;
        });
    }), !0) : !1;
};
$d63234f99c1aed29$export$c78a37762a8d58e1 = $d63234f99c1aed29$var$Qk;
$d63234f99c1aed29$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$d63234f99c1aed29$var$ol(c)) throw Error($d63234f99c1aed29$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($d63234f99c1aed29$var$p(38));
    return $d63234f99c1aed29$var$rl(a, b, c, !1, d);
};
$d63234f99c1aed29$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("bIycj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4elY8"));

});
parcelRegister("4elY8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $314982d064dfaa0b$export$c4744153514ff05d; }, function (v) { return $314982d064dfaa0b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $314982d064dfaa0b$export$3e506c1ccc9cc1a7; }, function (v) { return $314982d064dfaa0b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $314982d064dfaa0b$export$e26fe2ed2fa76875; }, function (v) { return $314982d064dfaa0b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $314982d064dfaa0b$export$502329bbf4b505b1; }, function (v) { return $314982d064dfaa0b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $314982d064dfaa0b$export$6e3807111c4874c4; }, function (v) { return $314982d064dfaa0b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $314982d064dfaa0b$export$c27134553091fb3a; }, function (v) { return $314982d064dfaa0b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $314982d064dfaa0b$export$33ee1acdc04fd2a2; }, function (v) { return $314982d064dfaa0b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $314982d064dfaa0b$export$b00a404bbd5edef2; }, function (v) { return $314982d064dfaa0b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $314982d064dfaa0b$export$8352ce38b91d0c62; }, function (v) { return $314982d064dfaa0b$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $314982d064dfaa0b$export$d66a1c1c77bd778b; }, function (v) { return $314982d064dfaa0b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $314982d064dfaa0b$export$d3dfb8e4810cb555; }, function (v) { return $314982d064dfaa0b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $314982d064dfaa0b$export$839f9183b0465a69; }, function (v) { return $314982d064dfaa0b$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $314982d064dfaa0b$export$72fdf0e06517287b; }, function (v) { return $314982d064dfaa0b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $314982d064dfaa0b$export$4b844e58a3e414b4; }, function (v) { return $314982d064dfaa0b$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $314982d064dfaa0b$export$816d2913ae6b83b1; }, function (v) { return $314982d064dfaa0b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $314982d064dfaa0b$export$61bcfe829111a1d0; }, function (v) { return $314982d064dfaa0b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $314982d064dfaa0b$export$7ee8c9beb337bc3f; }, function (v) { return $314982d064dfaa0b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $314982d064dfaa0b$export$b5836b71941fa3ed; }, function (v) { return $314982d064dfaa0b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $314982d064dfaa0b$export$cf845f2c119da08a; }, function (v) { return $314982d064dfaa0b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $314982d064dfaa0b$export$c4744153514ff05d;
var $314982d064dfaa0b$export$3e506c1ccc9cc1a7;
var $314982d064dfaa0b$export$e26fe2ed2fa76875;
var $314982d064dfaa0b$export$502329bbf4b505b1;
var $314982d064dfaa0b$export$6e3807111c4874c4;
var $314982d064dfaa0b$export$c27134553091fb3a;
var $314982d064dfaa0b$export$33ee1acdc04fd2a2;
var $314982d064dfaa0b$export$b00a404bbd5edef2;
var $314982d064dfaa0b$export$8352ce38b91d0c62;
var $314982d064dfaa0b$export$d66a1c1c77bd778b;
var $314982d064dfaa0b$export$d3dfb8e4810cb555;
var $314982d064dfaa0b$export$839f9183b0465a69;
var $314982d064dfaa0b$export$72fdf0e06517287b;
var $314982d064dfaa0b$export$4b844e58a3e414b4;
var $314982d064dfaa0b$export$816d2913ae6b83b1;
var $314982d064dfaa0b$export$61bcfe829111a1d0;
var $314982d064dfaa0b$export$7ee8c9beb337bc3f;
var $314982d064dfaa0b$export$b5836b71941fa3ed;
var $314982d064dfaa0b$export$cf845f2c119da08a;
"use strict";
function $314982d064dfaa0b$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $314982d064dfaa0b$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $314982d064dfaa0b$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $314982d064dfaa0b$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $314982d064dfaa0b$var$g(C, c)) n < e && 0 > $314982d064dfaa0b$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $314982d064dfaa0b$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $314982d064dfaa0b$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $314982d064dfaa0b$var$l = performance;
    $314982d064dfaa0b$export$c4744153514ff05d = function() {
        return $314982d064dfaa0b$var$l.now();
    };
} else {
    var $314982d064dfaa0b$var$p = Date, $314982d064dfaa0b$var$q = $314982d064dfaa0b$var$p.now();
    $314982d064dfaa0b$export$c4744153514ff05d = function() {
        return $314982d064dfaa0b$var$p.now() - $314982d064dfaa0b$var$q;
    };
}
var $314982d064dfaa0b$var$r = [], $314982d064dfaa0b$var$t = [], $314982d064dfaa0b$var$u = 1, $314982d064dfaa0b$var$v = null, $314982d064dfaa0b$var$y = 3, $314982d064dfaa0b$var$z = !1, $314982d064dfaa0b$var$A = !1, $314982d064dfaa0b$var$B = !1, $314982d064dfaa0b$var$D = "function" === typeof setTimeout ? setTimeout : null, $314982d064dfaa0b$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $314982d064dfaa0b$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $314982d064dfaa0b$var$G(a) {
    for(var b = $314982d064dfaa0b$var$h($314982d064dfaa0b$var$t); null !== b;){
        if (null === b.callback) $314982d064dfaa0b$var$k($314982d064dfaa0b$var$t);
        else if (b.startTime <= a) $314982d064dfaa0b$var$k($314982d064dfaa0b$var$t), b.sortIndex = b.expirationTime, $314982d064dfaa0b$var$f($314982d064dfaa0b$var$r, b);
        else break;
        b = $314982d064dfaa0b$var$h($314982d064dfaa0b$var$t);
    }
}
function $314982d064dfaa0b$var$H(a) {
    $314982d064dfaa0b$var$B = !1;
    $314982d064dfaa0b$var$G(a);
    if (!$314982d064dfaa0b$var$A) {
        if (null !== $314982d064dfaa0b$var$h($314982d064dfaa0b$var$r)) $314982d064dfaa0b$var$A = !0, $314982d064dfaa0b$var$I($314982d064dfaa0b$var$J);
        else {
            var b = $314982d064dfaa0b$var$h($314982d064dfaa0b$var$t);
            null !== b && $314982d064dfaa0b$var$K($314982d064dfaa0b$var$H, b.startTime - a);
        }
    }
}
function $314982d064dfaa0b$var$J(a, b) {
    $314982d064dfaa0b$var$A = !1;
    $314982d064dfaa0b$var$B && ($314982d064dfaa0b$var$B = !1, $314982d064dfaa0b$var$E($314982d064dfaa0b$var$L), $314982d064dfaa0b$var$L = -1);
    $314982d064dfaa0b$var$z = !0;
    var c = $314982d064dfaa0b$var$y;
    try {
        $314982d064dfaa0b$var$G(b);
        for($314982d064dfaa0b$var$v = $314982d064dfaa0b$var$h($314982d064dfaa0b$var$r); null !== $314982d064dfaa0b$var$v && (!($314982d064dfaa0b$var$v.expirationTime > b) || a && !$314982d064dfaa0b$var$M());){
            var d = $314982d064dfaa0b$var$v.callback;
            if ("function" === typeof d) {
                $314982d064dfaa0b$var$v.callback = null;
                $314982d064dfaa0b$var$y = $314982d064dfaa0b$var$v.priorityLevel;
                var e = d($314982d064dfaa0b$var$v.expirationTime <= b);
                b = $314982d064dfaa0b$export$c4744153514ff05d();
                "function" === typeof e ? $314982d064dfaa0b$var$v.callback = e : $314982d064dfaa0b$var$v === $314982d064dfaa0b$var$h($314982d064dfaa0b$var$r) && $314982d064dfaa0b$var$k($314982d064dfaa0b$var$r);
                $314982d064dfaa0b$var$G(b);
            } else $314982d064dfaa0b$var$k($314982d064dfaa0b$var$r);
            $314982d064dfaa0b$var$v = $314982d064dfaa0b$var$h($314982d064dfaa0b$var$r);
        }
        if (null !== $314982d064dfaa0b$var$v) var w = !0;
        else {
            var m = $314982d064dfaa0b$var$h($314982d064dfaa0b$var$t);
            null !== m && $314982d064dfaa0b$var$K($314982d064dfaa0b$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $314982d064dfaa0b$var$v = null, $314982d064dfaa0b$var$y = c, $314982d064dfaa0b$var$z = !1;
    }
}
var $314982d064dfaa0b$var$N = !1, $314982d064dfaa0b$var$O = null, $314982d064dfaa0b$var$L = -1, $314982d064dfaa0b$var$P = 5, $314982d064dfaa0b$var$Q = -1;
function $314982d064dfaa0b$var$M() {
    return $314982d064dfaa0b$export$c4744153514ff05d() - $314982d064dfaa0b$var$Q < $314982d064dfaa0b$var$P ? !1 : !0;
}
function $314982d064dfaa0b$var$R() {
    if (null !== $314982d064dfaa0b$var$O) {
        var a = $314982d064dfaa0b$export$c4744153514ff05d();
        $314982d064dfaa0b$var$Q = a;
        var b = !0;
        try {
            b = $314982d064dfaa0b$var$O(!0, a);
        } finally{
            b ? $314982d064dfaa0b$var$S() : ($314982d064dfaa0b$var$N = !1, $314982d064dfaa0b$var$O = null);
        }
    } else $314982d064dfaa0b$var$N = !1;
}
var $314982d064dfaa0b$var$S;
if ("function" === typeof $314982d064dfaa0b$var$F) $314982d064dfaa0b$var$S = function() {
    $314982d064dfaa0b$var$F($314982d064dfaa0b$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $314982d064dfaa0b$var$T = new MessageChannel, $314982d064dfaa0b$var$U = $314982d064dfaa0b$var$T.port2;
    $314982d064dfaa0b$var$T.port1.onmessage = $314982d064dfaa0b$var$R;
    $314982d064dfaa0b$var$S = function() {
        $314982d064dfaa0b$var$U.postMessage(null);
    };
} else $314982d064dfaa0b$var$S = function() {
    $314982d064dfaa0b$var$D($314982d064dfaa0b$var$R, 0);
};
function $314982d064dfaa0b$var$I(a) {
    $314982d064dfaa0b$var$O = a;
    $314982d064dfaa0b$var$N || ($314982d064dfaa0b$var$N = !0, $314982d064dfaa0b$var$S());
}
function $314982d064dfaa0b$var$K(a, b) {
    $314982d064dfaa0b$var$L = $314982d064dfaa0b$var$D(function() {
        a($314982d064dfaa0b$export$c4744153514ff05d());
    }, b);
}
$314982d064dfaa0b$export$3e506c1ccc9cc1a7 = 5;
$314982d064dfaa0b$export$e26fe2ed2fa76875 = 1;
$314982d064dfaa0b$export$502329bbf4b505b1 = 4;
$314982d064dfaa0b$export$6e3807111c4874c4 = 3;
$314982d064dfaa0b$export$c27134553091fb3a = null;
$314982d064dfaa0b$export$33ee1acdc04fd2a2 = 2;
$314982d064dfaa0b$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$314982d064dfaa0b$export$8352ce38b91d0c62 = function() {
    $314982d064dfaa0b$var$A || $314982d064dfaa0b$var$z || ($314982d064dfaa0b$var$A = !0, $314982d064dfaa0b$var$I($314982d064dfaa0b$var$J));
};
$314982d064dfaa0b$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $314982d064dfaa0b$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$314982d064dfaa0b$export$d3dfb8e4810cb555 = function() {
    return $314982d064dfaa0b$var$y;
};
$314982d064dfaa0b$export$839f9183b0465a69 = function() {
    return $314982d064dfaa0b$var$h($314982d064dfaa0b$var$r);
};
$314982d064dfaa0b$export$72fdf0e06517287b = function(a) {
    switch($314982d064dfaa0b$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $314982d064dfaa0b$var$y;
    }
    var c = $314982d064dfaa0b$var$y;
    $314982d064dfaa0b$var$y = b;
    try {
        return a();
    } finally{
        $314982d064dfaa0b$var$y = c;
    }
};
$314982d064dfaa0b$export$4b844e58a3e414b4 = function() {};
$314982d064dfaa0b$export$816d2913ae6b83b1 = function() {};
$314982d064dfaa0b$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $314982d064dfaa0b$var$y;
    $314982d064dfaa0b$var$y = a;
    try {
        return b();
    } finally{
        $314982d064dfaa0b$var$y = c;
    }
};
$314982d064dfaa0b$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $314982d064dfaa0b$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $314982d064dfaa0b$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $314982d064dfaa0b$var$f($314982d064dfaa0b$var$t, a), null === $314982d064dfaa0b$var$h($314982d064dfaa0b$var$r) && a === $314982d064dfaa0b$var$h($314982d064dfaa0b$var$t) && ($314982d064dfaa0b$var$B ? ($314982d064dfaa0b$var$E($314982d064dfaa0b$var$L), $314982d064dfaa0b$var$L = -1) : $314982d064dfaa0b$var$B = !0, $314982d064dfaa0b$var$K($314982d064dfaa0b$var$H, c - d))) : (a.sortIndex = e, $314982d064dfaa0b$var$f($314982d064dfaa0b$var$r, a), $314982d064dfaa0b$var$A || $314982d064dfaa0b$var$z || ($314982d064dfaa0b$var$A = !0, $314982d064dfaa0b$var$I($314982d064dfaa0b$var$J)));
    return a;
};
$314982d064dfaa0b$export$b5836b71941fa3ed = $314982d064dfaa0b$var$M;
$314982d064dfaa0b$export$cf845f2c119da08a = function(a) {
    var b = $314982d064dfaa0b$var$y;
    return function() {
        var c = $314982d064dfaa0b$var$y;
        $314982d064dfaa0b$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $314982d064dfaa0b$var$y = c;
        }
    };
};

});



parcelRegister("iKQu3", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $inE0k.default;
    }
});

var $inE0k = parcelRequire("inE0k");

});
parcelRegister("inE0k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d61968038cd9a3ab$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $ld5Xm = parcelRequire("ld5Xm");

var $8QkV3 = parcelRequire("8QkV3");

var $2WrlN = parcelRequire("2WrlN");
"use client";
function $d61968038cd9a3ab$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $2WrlN.jsx)((0, $8QkV3.default), (0, $ixQMS.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $8QkV3.default).muiName;
    return /*#__PURE__*/ $ld5Xm.memo(/*#__PURE__*/ $ld5Xm.forwardRef(Component));
}

});
parcelRegister("ixQMS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d80441884e922140$export$2e2bcd8739ae039; });
function $d80441884e922140$export$2e2bcd8739ae039() {
    $d80441884e922140$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d80441884e922140$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("8QkV3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6703682c1de4a03a$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $ld5Xm = parcelRequire("ld5Xm");


var $HtKrm = parcelRequire("HtKrm");

var $kp4xz = parcelRequire("kp4xz");

var $jdCro = parcelRequire("jdCro");

var $jVkAB = parcelRequire("jVkAB");

var $al25i = parcelRequire("al25i");

var $2WroH = parcelRequire("2WroH");

var $2WrlN = parcelRequire("2WrlN");
"use client";
const $6703682c1de4a03a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $6703682c1de4a03a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $jdCro.default)(color)}`,
            `fontSize${(0, $jdCro.default)(fontSize)}`
        ]
    };
    return (0, $kp4xz.default)(slots, (0, $2WroH.getSvgIconUtilityClass), classes);
};
const $6703682c1de4a03a$var$SvgIconRoot = (0, $al25i.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $jdCro.default)(ownerState.color)}`],
            styles[`fontSize${(0, $jdCro.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $6703682c1de4a03a$var$SvgIcon = /*#__PURE__*/ $ld5Xm.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $jVkAB.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $2rDSW.default)(props, $6703682c1de4a03a$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $ld5Xm.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $ixQMS.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $6703682c1de4a03a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2WrlN.jsxs)($6703682c1de4a03a$var$SvgIconRoot, (0, $ixQMS.default)({
        as: component,
        className: (0, $HtKrm.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $2WrlN.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$6703682c1de4a03a$var$SvgIcon.muiName = "SvgIcon";
var $6703682c1de4a03a$export$2e2bcd8739ae039 = $6703682c1de4a03a$var$SvgIcon;

});
parcelRegister("2rDSW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c7d0ac5e0a201b3$export$2e2bcd8739ae039; });
function $1c7d0ac5e0a201b3$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("HtKrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $479aeaf7957a2446$export$2e2bcd8739ae039; });
function $479aeaf7957a2446$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $479aeaf7957a2446$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $479aeaf7957a2446$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $479aeaf7957a2446$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $479aeaf7957a2446$export$2e2bcd8739ae039 = $479aeaf7957a2446$export$4f5d2d50c9deca37;

});

parcelRegister("kp4xz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eda9aa19c5cf36d1$export$2e2bcd8739ae039; });
function $eda9aa19c5cf36d1$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("jdCro", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfdd0cbe9c2dcdfc$export$2e2bcd8739ae039; });

var $6i6gU = parcelRequire("6i6gU");
var $dfdd0cbe9c2dcdfc$export$2e2bcd8739ae039 = (0, $6i6gU.default);

});
parcelRegister("6i6gU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $494949ee63902235$export$2e2bcd8739ae039; });

var $elHuP = parcelRequire("elHuP");
function $494949ee63902235$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $elHuP.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("elHuP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a724c4469858202f$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $a724c4469858202f$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("jVkAB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8134fd21960dcbc$export$2e2bcd8739ae039; });

var $9Qeza = parcelRequire("9Qeza");

var $bgmzV = parcelRequire("bgmzV");

var $f0pJw = parcelRequire("f0pJw");
"use client";
function $e8134fd21960dcbc$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $9Qeza.default)({
        props: props,
        name: name,
        defaultTheme: $bgmzV.default,
        themeId: (0, $f0pJw.default)
    });
}

});
parcelRegister("9Qeza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72a444ed25ae79bc$export$2e2bcd8739ae039; });

var $20DBK = parcelRequire("20DBK");

var $7hXqU = parcelRequire("7hXqU");
"use client";
function $72a444ed25ae79bc$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $7hXqU.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $20DBK.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("20DBK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $176a4e2bbaddbf91$export$2e2bcd8739ae039; });

var $9jd2K = parcelRequire("9jd2K");
function $176a4e2bbaddbf91$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $9jd2K.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("9jd2K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c70018bf2364227$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");
function $6c70018bf2364227$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $ixQMS.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $ixQMS.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $ixQMS.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $6c70018bf2364227$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("7hXqU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54e83918f0069d96$export$2e2bcd8739ae039; });

var $iwaPO = parcelRequire("iwaPO");

var $57Ttp = parcelRequire("57Ttp");
"use client";
const $54e83918f0069d96$export$35e57303dbd8a66 = (0, $iwaPO.default)();
function $54e83918f0069d96$var$useTheme(defaultTheme = $54e83918f0069d96$export$35e57303dbd8a66) {
    return (0, $57Ttp.default)(defaultTheme);
}
var $54e83918f0069d96$export$2e2bcd8739ae039 = $54e83918f0069d96$var$useTheme;

});
parcelRegister("iwaPO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7b39eadcd24acb0$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $7rDXv = parcelRequire("7rDXv");

var $9rFgJ = parcelRequire("9rFgJ");

var $eZPk3 = parcelRequire("eZPk3");

var $aVY6G = parcelRequire("aVY6G");

var $3YPxV = parcelRequire("3YPxV");

var $1OReq = parcelRequire("1OReq");

var $hwD0B = parcelRequire("hwD0B");
const $d7b39eadcd24acb0$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $d7b39eadcd24acb0$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $2rDSW.default)(options, $d7b39eadcd24acb0$var$_excluded);
    const breakpoints = (0, $9rFgJ.default)(breakpointsInput);
    const spacing = (0, $aVY6G.default)(spacingInput);
    let muiTheme = (0, $7rDXv.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $ixQMS.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $ixQMS.default)({}, (0, $eZPk3.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $hwD0B.default);
    muiTheme = args.reduce((acc, argument)=>(0, $7rDXv.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $ixQMS.default)({}, (0, $1OReq.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $3YPxV.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $d7b39eadcd24acb0$export$2e2bcd8739ae039 = $d7b39eadcd24acb0$var$createTheme;

});
parcelRegister("7rDXv", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $56ba0d026d8b417e$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $56ba0d026d8b417e$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");
function $56ba0d026d8b417e$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $56ba0d026d8b417e$var$deepClone(source) {
    if (!$56ba0d026d8b417e$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $56ba0d026d8b417e$var$deepClone(source[key]);
    });
    return output;
}
function $56ba0d026d8b417e$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $ixQMS.default)({}, target) : target;
    if ($56ba0d026d8b417e$export$53b83ca8eaab0383(target) && $56ba0d026d8b417e$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($56ba0d026d8b417e$export$53b83ca8eaab0383(source[key]) && key in target && $56ba0d026d8b417e$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $56ba0d026d8b417e$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $56ba0d026d8b417e$export$53b83ca8eaab0383(source[key]) ? $56ba0d026d8b417e$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("9rFgJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e06a5d1ea3dd5ba$export$2e2bcd8739ae039; });

var $2rDSW = parcelRequire("2rDSW");

var $ixQMS = parcelRequire("ixQMS");
const $6e06a5d1ea3dd5ba$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $6e06a5d1ea3dd5ba$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $6e06a5d1ea3dd5ba$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $ixQMS.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $6e06a5d1ea3dd5ba$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $2rDSW.default)(breakpoints, $6e06a5d1ea3dd5ba$var$_excluded);
    const sortedValues = $6e06a5d1ea3dd5ba$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $ixQMS.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("eZPk3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeae92c8ce4dff5c$export$2e2bcd8739ae039; });
const $aeae92c8ce4dff5c$var$shape = {
    borderRadius: 4
};
var $aeae92c8ce4dff5c$export$2e2bcd8739ae039 = $aeae92c8ce4dff5c$var$shape;

});

parcelRegister("aVY6G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $020de69dcc2cb651$export$2e2bcd8739ae039; });

var $7pNzQ = parcelRequire("7pNzQ");
function $020de69dcc2cb651$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $7pNzQ.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("7pNzQ", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $5661532e519be2bb$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $5661532e519be2bb$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $5661532e519be2bb$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $5661532e519be2bb$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $5661532e519be2bb$export$6f98e8eaf0be1996; });


var $e1VIY = parcelRequire("e1VIY");

var $l0LEo = parcelRequire("l0LEo");

var $7INgM = parcelRequire("7INgM");

var $4CMO7 = parcelRequire("4CMO7");
const $5661532e519be2bb$var$properties = {
    m: "margin",
    p: "padding"
};
const $5661532e519be2bb$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $5661532e519be2bb$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $5661532e519be2bb$var$getCssProperties = (0, $4CMO7.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($5661532e519be2bb$var$aliases[prop]) prop = $5661532e519be2bb$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $5661532e519be2bb$var$properties[a];
    const direction = $5661532e519be2bb$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $5661532e519be2bb$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $5661532e519be2bb$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $5661532e519be2bb$var$spacingKeys = [
    ...$5661532e519be2bb$export$aab52a0dde05ad8a,
    ...$5661532e519be2bb$export$f8397d44f03ab6ad
];
function $5661532e519be2bb$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $l0LEo.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $5661532e519be2bb$export$1def6f833384e3d1(theme) {
    return $5661532e519be2bb$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $5661532e519be2bb$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $5661532e519be2bb$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $5661532e519be2bb$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $5661532e519be2bb$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $5661532e519be2bb$var$getCssProperties(prop);
    const styleFromPropValue = $5661532e519be2bb$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $e1VIY.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $5661532e519be2bb$var$style(props, keys) {
    const transformer = $5661532e519be2bb$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$5661532e519be2bb$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $7INgM.default), {});
}
function $5661532e519be2bb$export$7ede87f9b603dd3c(props) {
    return $5661532e519be2bb$var$style(props, $5661532e519be2bb$export$aab52a0dde05ad8a);
}
$5661532e519be2bb$export$7ede87f9b603dd3c.propTypes = {};
$5661532e519be2bb$export$7ede87f9b603dd3c.filterProps = $5661532e519be2bb$export$aab52a0dde05ad8a;
function $5661532e519be2bb$export$6f98e8eaf0be1996(props) {
    return $5661532e519be2bb$var$style(props, $5661532e519be2bb$export$f8397d44f03ab6ad);
}
$5661532e519be2bb$export$6f98e8eaf0be1996.propTypes = {};
$5661532e519be2bb$export$6f98e8eaf0be1996.filterProps = $5661532e519be2bb$export$f8397d44f03ab6ad;
function $5661532e519be2bb$var$spacing(props) {
    return $5661532e519be2bb$var$style(props, $5661532e519be2bb$var$spacingKeys);
}
$5661532e519be2bb$var$spacing.propTypes = {};
$5661532e519be2bb$var$spacing.filterProps = $5661532e519be2bb$var$spacingKeys;
var $5661532e519be2bb$export$2e2bcd8739ae039 = $5661532e519be2bb$var$spacing;

});
parcelRegister("e1VIY", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $a36def8542e02a89$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $a36def8542e02a89$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $a36def8542e02a89$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $a36def8542e02a89$export$8922c90b6e020726; });

var $ixQMS = parcelRequire("ixQMS");


var $7rDXv = parcelRequire("7rDXv");

var $7INgM = parcelRequire("7INgM");
const $a36def8542e02a89$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $a36def8542e02a89$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$a36def8542e02a89$export$68c286be0e7e55b7[key]}px)`
};
function $a36def8542e02a89$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $a36def8542e02a89$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $a36def8542e02a89$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $a36def8542e02a89$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $a36def8542e02a89$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $a36def8542e02a89$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $ixQMS.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $7INgM.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $a36def8542e02a89$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $a36def8542e02a89$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $a36def8542e02a89$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $a36def8542e02a89$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $7rDXv.default)(prev, next), {});
    return $a36def8542e02a89$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $a36def8542e02a89$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $a36def8542e02a89$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $a36def8542e02a89$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $a36def8542e02a89$export$2e2bcd8739ae039 = $a36def8542e02a89$var$breakpoints;

});
parcelRegister("7INgM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59f2dc6a06cbd8d7$export$2e2bcd8739ae039; });

var $7rDXv = parcelRequire("7rDXv");
function $59f2dc6a06cbd8d7$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $7rDXv.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $59f2dc6a06cbd8d7$export$2e2bcd8739ae039 = $59f2dc6a06cbd8d7$var$merge;

});


parcelRegister("l0LEo", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $f4be8f7378493149$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $f4be8f7378493149$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $f4be8f7378493149$export$2e2bcd8739ae039; });

var $6i6gU = parcelRequire("6i6gU");


var $e1VIY = parcelRequire("e1VIY");
function $f4be8f7378493149$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $f4be8f7378493149$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $f4be8f7378493149$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $f4be8f7378493149$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $f4be8f7378493149$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $f4be8f7378493149$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $f4be8f7378493149$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $6i6gU.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $e1VIY.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $f4be8f7378493149$export$2e2bcd8739ae039 = $f4be8f7378493149$var$style;

});

parcelRegister("4CMO7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35e092283b324140$export$2e2bcd8739ae039; });
function $35e092283b324140$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("3YPxV", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $2e5ef5b6da7732d8$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $2e5ef5b6da7732d8$export$2e2bcd8739ae039; });

var $6i6gU = parcelRequire("6i6gU");

var $7INgM = parcelRequire("7INgM");

var $l0LEo = parcelRequire("l0LEo");

var $e1VIY = parcelRequire("e1VIY");

var $1OReq = parcelRequire("1OReq");
function $2e5ef5b6da7732d8$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $2e5ef5b6da7732d8$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $2e5ef5b6da7732d8$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $l0LEo.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $l0LEo.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $l0LEo.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $6i6gU.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $e1VIY.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $1OReq.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $e1VIY.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $2e5ef5b6da7732d8$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $7INgM.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $e1VIY.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($2e5ef5b6da7732d8$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $7INgM.default)(css, breakpointsValues);
                        }
                    } else css = (0, $7INgM.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $e1VIY.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $2e5ef5b6da7732d8$var$styleFunctionSx = $2e5ef5b6da7732d8$export$7d53d8bf2911e013();
$2e5ef5b6da7732d8$var$styleFunctionSx.filterProps = [
    "sx"
];
var $2e5ef5b6da7732d8$export$2e2bcd8739ae039 = $2e5ef5b6da7732d8$var$styleFunctionSx;

});
parcelRegister("1OReq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1533c0ab42c1bc80$export$2e2bcd8739ae039; });

var $7pNzQ = parcelRequire("7pNzQ");

var $kScKI = parcelRequire("kScKI");

var $d19i2 = parcelRequire("d19i2");

var $bG3uY = parcelRequire("bG3uY");

var $cbpIz = parcelRequire("cbpIz");
const $1533c0ab42c1bc80$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $kScKI.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $kScKI.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $kScKI.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $kScKI.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $kScKI.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $kScKI.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $kScKI.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $bG3uY.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $bG3uY.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $bG3uY.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $7pNzQ.padding)
    },
    pt: {
        style: (0, $7pNzQ.padding)
    },
    pr: {
        style: (0, $7pNzQ.padding)
    },
    pb: {
        style: (0, $7pNzQ.padding)
    },
    pl: {
        style: (0, $7pNzQ.padding)
    },
    px: {
        style: (0, $7pNzQ.padding)
    },
    py: {
        style: (0, $7pNzQ.padding)
    },
    padding: {
        style: (0, $7pNzQ.padding)
    },
    paddingTop: {
        style: (0, $7pNzQ.padding)
    },
    paddingRight: {
        style: (0, $7pNzQ.padding)
    },
    paddingBottom: {
        style: (0, $7pNzQ.padding)
    },
    paddingLeft: {
        style: (0, $7pNzQ.padding)
    },
    paddingX: {
        style: (0, $7pNzQ.padding)
    },
    paddingY: {
        style: (0, $7pNzQ.padding)
    },
    paddingInline: {
        style: (0, $7pNzQ.padding)
    },
    paddingInlineStart: {
        style: (0, $7pNzQ.padding)
    },
    paddingInlineEnd: {
        style: (0, $7pNzQ.padding)
    },
    paddingBlock: {
        style: (0, $7pNzQ.padding)
    },
    paddingBlockStart: {
        style: (0, $7pNzQ.padding)
    },
    paddingBlockEnd: {
        style: (0, $7pNzQ.padding)
    },
    m: {
        style: (0, $7pNzQ.margin)
    },
    mt: {
        style: (0, $7pNzQ.margin)
    },
    mr: {
        style: (0, $7pNzQ.margin)
    },
    mb: {
        style: (0, $7pNzQ.margin)
    },
    ml: {
        style: (0, $7pNzQ.margin)
    },
    mx: {
        style: (0, $7pNzQ.margin)
    },
    my: {
        style: (0, $7pNzQ.margin)
    },
    margin: {
        style: (0, $7pNzQ.margin)
    },
    marginTop: {
        style: (0, $7pNzQ.margin)
    },
    marginRight: {
        style: (0, $7pNzQ.margin)
    },
    marginBottom: {
        style: (0, $7pNzQ.margin)
    },
    marginLeft: {
        style: (0, $7pNzQ.margin)
    },
    marginX: {
        style: (0, $7pNzQ.margin)
    },
    marginY: {
        style: (0, $7pNzQ.margin)
    },
    marginInline: {
        style: (0, $7pNzQ.margin)
    },
    marginInlineStart: {
        style: (0, $7pNzQ.margin)
    },
    marginInlineEnd: {
        style: (0, $7pNzQ.margin)
    },
    marginBlock: {
        style: (0, $7pNzQ.margin)
    },
    marginBlockStart: {
        style: (0, $7pNzQ.margin)
    },
    marginBlockEnd: {
        style: (0, $7pNzQ.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $d19i2.gap)
    },
    rowGap: {
        style: (0, $d19i2.rowGap)
    },
    columnGap: {
        style: (0, $d19i2.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $cbpIz.sizingTransform)
    },
    maxWidth: {
        style: (0, $cbpIz.maxWidth)
    },
    minWidth: {
        transform: (0, $cbpIz.sizingTransform)
    },
    height: {
        transform: (0, $cbpIz.sizingTransform)
    },
    maxHeight: {
        transform: (0, $cbpIz.sizingTransform)
    },
    minHeight: {
        transform: (0, $cbpIz.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $1533c0ab42c1bc80$export$2e2bcd8739ae039 = $1533c0ab42c1bc80$var$defaultSxConfig;

});
parcelRegister("kScKI", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $f322be317b13bd25$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $f322be317b13bd25$export$7a57f79000377ca2; });


var $l0LEo = parcelRequire("l0LEo");

var $in7vx = parcelRequire("in7vx");

var $7pNzQ = parcelRequire("7pNzQ");

var $e1VIY = parcelRequire("e1VIY");
function $f322be317b13bd25$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $f322be317b13bd25$var$createBorderStyle(prop, transform) {
    return (0, $l0LEo.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $f322be317b13bd25$export$1edee58a52776cd9 = $f322be317b13bd25$var$createBorderStyle("border", $f322be317b13bd25$export$34e2febe53ae29cc);
const $f322be317b13bd25$export$f9a7b6bd24892946 = $f322be317b13bd25$var$createBorderStyle("borderTop", $f322be317b13bd25$export$34e2febe53ae29cc);
const $f322be317b13bd25$export$5abca33e6be905d2 = $f322be317b13bd25$var$createBorderStyle("borderRight", $f322be317b13bd25$export$34e2febe53ae29cc);
const $f322be317b13bd25$export$e2ce9f12a980a822 = $f322be317b13bd25$var$createBorderStyle("borderBottom", $f322be317b13bd25$export$34e2febe53ae29cc);
const $f322be317b13bd25$export$47658cca1a909427 = $f322be317b13bd25$var$createBorderStyle("borderLeft", $f322be317b13bd25$export$34e2febe53ae29cc);
const $f322be317b13bd25$export$e7fb0694ba2404fc = $f322be317b13bd25$var$createBorderStyle("borderColor");
const $f322be317b13bd25$export$126a92c968acdb85 = $f322be317b13bd25$var$createBorderStyle("borderTopColor");
const $f322be317b13bd25$export$85cc51cb8fbb8c0e = $f322be317b13bd25$var$createBorderStyle("borderRightColor");
const $f322be317b13bd25$export$340b0327727f6d1a = $f322be317b13bd25$var$createBorderStyle("borderBottomColor");
const $f322be317b13bd25$export$60beef91a985b4bf = $f322be317b13bd25$var$createBorderStyle("borderLeftColor");
const $f322be317b13bd25$export$f9258c55612cbed7 = $f322be317b13bd25$var$createBorderStyle("outline", $f322be317b13bd25$export$34e2febe53ae29cc);
const $f322be317b13bd25$export$621fe586efeb64b9 = $f322be317b13bd25$var$createBorderStyle("outlineColor");
const $f322be317b13bd25$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $7pNzQ.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $7pNzQ.getValue)(transformer, propValue)
            });
        return (0, $e1VIY.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$f322be317b13bd25$export$7a57f79000377ca2.propTypes = {};
$f322be317b13bd25$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $f322be317b13bd25$var$borders = (0, $in7vx.default)($f322be317b13bd25$export$1edee58a52776cd9, $f322be317b13bd25$export$f9a7b6bd24892946, $f322be317b13bd25$export$5abca33e6be905d2, $f322be317b13bd25$export$e2ce9f12a980a822, $f322be317b13bd25$export$47658cca1a909427, $f322be317b13bd25$export$e7fb0694ba2404fc, $f322be317b13bd25$export$126a92c968acdb85, $f322be317b13bd25$export$85cc51cb8fbb8c0e, $f322be317b13bd25$export$340b0327727f6d1a, $f322be317b13bd25$export$60beef91a985b4bf, $f322be317b13bd25$export$7a57f79000377ca2, $f322be317b13bd25$export$f9258c55612cbed7, $f322be317b13bd25$export$621fe586efeb64b9);
var $f322be317b13bd25$export$2e2bcd8739ae039 = $f322be317b13bd25$var$borders;

});
parcelRegister("in7vx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d60032d22ba947e5$export$2e2bcd8739ae039; });

var $7INgM = parcelRequire("7INgM");
function $d60032d22ba947e5$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $7INgM.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $d60032d22ba947e5$export$2e2bcd8739ae039 = $d60032d22ba947e5$var$compose;

});


parcelRegister("d19i2", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $97a293234d97b428$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $97a293234d97b428$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $97a293234d97b428$export$8a833ffa5f5dbeda; });

var $l0LEo = parcelRequire("l0LEo");

var $in7vx = parcelRequire("in7vx");

var $7pNzQ = parcelRequire("7pNzQ");

var $e1VIY = parcelRequire("e1VIY");

const $97a293234d97b428$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $7pNzQ.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $7pNzQ.getValue)(transformer, propValue)
            });
        return (0, $e1VIY.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$97a293234d97b428$export$5df9adcb0db95e1e.propTypes = {};
$97a293234d97b428$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $97a293234d97b428$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $7pNzQ.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $7pNzQ.getValue)(transformer, propValue)
            });
        return (0, $e1VIY.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$97a293234d97b428$export$ec60d70ff941a580.propTypes = {};
$97a293234d97b428$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $97a293234d97b428$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $7pNzQ.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $7pNzQ.getValue)(transformer, propValue)
            });
        return (0, $e1VIY.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$97a293234d97b428$export$8a833ffa5f5dbeda.propTypes = {};
$97a293234d97b428$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $97a293234d97b428$export$baf44164ca3a34e8 = (0, $l0LEo.default)({
    prop: "gridColumn"
});
const $97a293234d97b428$export$8f7213a1cd01e832 = (0, $l0LEo.default)({
    prop: "gridRow"
});
const $97a293234d97b428$export$b0e0abbc49ba668 = (0, $l0LEo.default)({
    prop: "gridAutoFlow"
});
const $97a293234d97b428$export$bcd8b929d4b4142 = (0, $l0LEo.default)({
    prop: "gridAutoColumns"
});
const $97a293234d97b428$export$e5039a674e14c828 = (0, $l0LEo.default)({
    prop: "gridAutoRows"
});
const $97a293234d97b428$export$42bd9088661ffb03 = (0, $l0LEo.default)({
    prop: "gridTemplateColumns"
});
const $97a293234d97b428$export$920682ae05b999bc = (0, $l0LEo.default)({
    prop: "gridTemplateRows"
});
const $97a293234d97b428$export$1b88fbdd482fd33a = (0, $l0LEo.default)({
    prop: "gridTemplateAreas"
});
const $97a293234d97b428$export$bdb486e40d52d26f = (0, $l0LEo.default)({
    prop: "gridArea"
});
const $97a293234d97b428$var$grid = (0, $in7vx.default)($97a293234d97b428$export$5df9adcb0db95e1e, $97a293234d97b428$export$ec60d70ff941a580, $97a293234d97b428$export$8a833ffa5f5dbeda, $97a293234d97b428$export$baf44164ca3a34e8, $97a293234d97b428$export$8f7213a1cd01e832, $97a293234d97b428$export$b0e0abbc49ba668, $97a293234d97b428$export$bcd8b929d4b4142, $97a293234d97b428$export$e5039a674e14c828, $97a293234d97b428$export$42bd9088661ffb03, $97a293234d97b428$export$920682ae05b999bc, $97a293234d97b428$export$1b88fbdd482fd33a, $97a293234d97b428$export$bdb486e40d52d26f);
var $97a293234d97b428$export$2e2bcd8739ae039 = $97a293234d97b428$var$grid;

});

parcelRegister("bG3uY", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $880654b367331301$export$dbaffd4420ea0ac6; });

var $l0LEo = parcelRequire("l0LEo");

var $in7vx = parcelRequire("in7vx");
function $880654b367331301$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $880654b367331301$export$35e9368ef982300f = (0, $l0LEo.default)({
    prop: "color",
    themeKey: "palette",
    transform: $880654b367331301$export$dbaffd4420ea0ac6
});
const $880654b367331301$export$2506f56c10355b33 = (0, $l0LEo.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $880654b367331301$export$dbaffd4420ea0ac6
});
const $880654b367331301$export$8c5a050822fd698c = (0, $l0LEo.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $880654b367331301$export$dbaffd4420ea0ac6
});
const $880654b367331301$var$palette = (0, $in7vx.default)($880654b367331301$export$35e9368ef982300f, $880654b367331301$export$2506f56c10355b33, $880654b367331301$export$8c5a050822fd698c);
var $880654b367331301$export$2e2bcd8739ae039 = $880654b367331301$var$palette;

});

parcelRegister("cbpIz", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $8dea7629ea8a8cb0$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $8dea7629ea8a8cb0$export$488fda99655ff65a; });

var $l0LEo = parcelRequire("l0LEo");

var $in7vx = parcelRequire("in7vx");

var $e1VIY = parcelRequire("e1VIY");
function $8dea7629ea8a8cb0$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $8dea7629ea8a8cb0$export$7e3df82ee760448c = (0, $l0LEo.default)({
    prop: "width",
    transform: $8dea7629ea8a8cb0$export$8afece71750ec241
});
const $8dea7629ea8a8cb0$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $e1VIY.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $8dea7629ea8a8cb0$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $e1VIY.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$8dea7629ea8a8cb0$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $8dea7629ea8a8cb0$export$ee148fbbe8357dd2 = (0, $l0LEo.default)({
    prop: "minWidth",
    transform: $8dea7629ea8a8cb0$export$8afece71750ec241
});
const $8dea7629ea8a8cb0$export$ac607276a8fe9f0a = (0, $l0LEo.default)({
    prop: "height",
    transform: $8dea7629ea8a8cb0$export$8afece71750ec241
});
const $8dea7629ea8a8cb0$export$dc0d8bd0b94f8570 = (0, $l0LEo.default)({
    prop: "maxHeight",
    transform: $8dea7629ea8a8cb0$export$8afece71750ec241
});
const $8dea7629ea8a8cb0$export$a43cf604e12f3b17 = (0, $l0LEo.default)({
    prop: "minHeight",
    transform: $8dea7629ea8a8cb0$export$8afece71750ec241
});
const $8dea7629ea8a8cb0$export$ffed9f14fb65e276 = (0, $l0LEo.default)({
    prop: "size",
    cssProperty: "width",
    transform: $8dea7629ea8a8cb0$export$8afece71750ec241
});
const $8dea7629ea8a8cb0$export$905076ed6620e671 = (0, $l0LEo.default)({
    prop: "size",
    cssProperty: "height",
    transform: $8dea7629ea8a8cb0$export$8afece71750ec241
});
const $8dea7629ea8a8cb0$export$6ccc93f785106a58 = (0, $l0LEo.default)({
    prop: "boxSizing"
});
const $8dea7629ea8a8cb0$var$sizing = (0, $in7vx.default)($8dea7629ea8a8cb0$export$7e3df82ee760448c, $8dea7629ea8a8cb0$export$488fda99655ff65a, $8dea7629ea8a8cb0$export$ee148fbbe8357dd2, $8dea7629ea8a8cb0$export$ac607276a8fe9f0a, $8dea7629ea8a8cb0$export$dc0d8bd0b94f8570, $8dea7629ea8a8cb0$export$a43cf604e12f3b17, $8dea7629ea8a8cb0$export$6ccc93f785106a58);
var $8dea7629ea8a8cb0$export$2e2bcd8739ae039 = $8dea7629ea8a8cb0$var$sizing;

});



parcelRegister("hwD0B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc23af23effae341$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $cc23af23effae341$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("57Ttp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bb8a30bd7dedfa3$export$2e2bcd8739ae039; });

var $ld5Xm = parcelRequire("ld5Xm");
parcelRequire("2FbfX");
var $eySkF = parcelRequire("eySkF");
"use client";
function $3bb8a30bd7dedfa3$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $3bb8a30bd7dedfa3$var$useTheme(defaultTheme = null) {
    const contextTheme = $ld5Xm.useContext((0, $eySkF.T));
    return !contextTheme || $3bb8a30bd7dedfa3$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $3bb8a30bd7dedfa3$export$2e2bcd8739ae039 = $3bb8a30bd7dedfa3$var$useTheme;

});
parcelRegister("2FbfX", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $1f08246447887c05$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $1f08246447887c05$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $1f08246447887c05$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("eySkF")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("eySkF")).w; });

var $eySkF = parcelRequire("eySkF");

var $ld5Xm = parcelRequire("ld5Xm");

var $iuZ9D = parcelRequire("iuZ9D");

var $gocPY = parcelRequire("gocPY");

var $1gGLZ = parcelRequire("1gGLZ");
parcelRequire("6ke6O");
parcelRequire("ajoJB");
parcelRequire("ineBE");

parcelRequire("kZiIn");
var $1f08246447887c05$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $1f08246447887c05$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $eySkF.h).call(props, "css")) // $FlowFixMe
    return $ld5Xm.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eySkF.E);
    createElementArgArray[1] = (0, $eySkF.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $ld5Xm.createElement.apply(null, createElementArgArray);
};
var $1f08246447887c05$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $1f08246447887c05$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eySkF.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $1gGLZ.serializeStyles)([
        styles
    ], undefined, $ld5Xm.useContext((0, $eySkF.T)));
    if (!(0, $eySkF.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $ld5Xm.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $ld5Xm.useRef();
    (0, $gocPY.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gocPY.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $iuZ9D.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $1f08246447887c05$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $1gGLZ.serializeStyles)(args);
}
var $1f08246447887c05$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $1f08246447887c05$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $1f08246447887c05$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $1f08246447887c05$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $iuZ9D.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $1f08246447887c05$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $gocPY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $iuZ9D.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $1f08246447887c05$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eySkF.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $1gGLZ.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $iuZ9D.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $1f08246447887c05$var$merge(cache.registered, css, $1f08246447887c05$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $ld5Xm.useContext((0, $eySkF.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $ld5Xm.createElement($ld5Xm.Fragment, null, /*#__PURE__*/ $ld5Xm.createElement($1f08246447887c05$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $1f08246447887c05$var$isBrowser, $1f08246447887c05$var$isTestEnv, $1f08246447887c05$var$globalContext, $1f08246447887c05$var$globalKey;

});
parcelRegister("eySkF", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $a99e62f21f418b3e$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $a99e62f21f418b3e$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $a99e62f21f418b3e$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $a99e62f21f418b3e$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $a99e62f21f418b3e$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $a99e62f21f418b3e$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $a99e62f21f418b3e$export$a9c23c6ac3fc3eca; });

var $ld5Xm = parcelRequire("ld5Xm");

var $6ke6O = parcelRequire("6ke6O");

var $ixQMS = parcelRequire("ixQMS");

var $ineBE = parcelRequire("ineBE");

var $3oHuP = parcelRequire("3oHuP");

var $iuZ9D = parcelRequire("iuZ9D");

var $1gGLZ = parcelRequire("1gGLZ");

var $gocPY = parcelRequire("gocPY");
var $a99e62f21f418b3e$export$23f2a1d2818174ef = true;
var $a99e62f21f418b3e$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $a99e62f21f418b3e$var$EmotionCacheContext = /* #__PURE__ */ $ld5Xm.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $6ke6O.default)({
    key: "css"
}) : null);
var $a99e62f21f418b3e$export$e7094788287c5e9b = $a99e62f21f418b3e$var$EmotionCacheContext.Provider;
var $a99e62f21f418b3e$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $ld5Xm.useContext)($a99e62f21f418b3e$var$EmotionCacheContext);
};
var $a99e62f21f418b3e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $ld5Xm.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $ld5Xm.useContext)($a99e62f21f418b3e$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$a99e62f21f418b3e$export$23f2a1d2818174ef) $a99e62f21f418b3e$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $ld5Xm.useContext)($a99e62f21f418b3e$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $6ke6O.default)({
                key: "css"
            });
            return /*#__PURE__*/ $ld5Xm.createElement($a99e62f21f418b3e$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $a99e62f21f418b3e$export$971d5caa766a69d7 = /* #__PURE__ */ $ld5Xm.createContext({});
var $a99e62f21f418b3e$export$3b14a55fb2447963 = function useTheme() {
    return $ld5Xm.useContext($a99e62f21f418b3e$export$971d5caa766a69d7);
};
var $a99e62f21f418b3e$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $ixQMS.default)({}, outerTheme, theme);
};
var $a99e62f21f418b3e$var$createCacheWithTheme = /* #__PURE__ */ (0, $ineBE.default)(function(outerTheme) {
    return (0, $ineBE.default)(function(theme) {
        return $a99e62f21f418b3e$var$getTheme(outerTheme, theme);
    });
});
var $a99e62f21f418b3e$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $ld5Xm.useContext($a99e62f21f418b3e$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $a99e62f21f418b3e$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $ld5Xm.createElement($a99e62f21f418b3e$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $a99e62f21f418b3e$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $ld5Xm.useContext($a99e62f21f418b3e$export$971d5caa766a69d7);
        return /*#__PURE__*/ $ld5Xm.createElement(Component, (0, $ixQMS.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $ld5Xm.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3oHuP.default)(WithTheme, Component);
}
var $a99e62f21f418b3e$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $a99e62f21f418b3e$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $a99e62f21f418b3e$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $a99e62f21f418b3e$var$getLastPart(match[1]);
    return undefined;
};
var $a99e62f21f418b3e$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $a99e62f21f418b3e$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $a99e62f21f418b3e$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $a99e62f21f418b3e$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($a99e62f21f418b3e$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $a99e62f21f418b3e$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $a99e62f21f418b3e$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $a99e62f21f418b3e$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $a99e62f21f418b3e$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($a99e62f21f418b3e$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$a99e62f21f418b3e$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $a99e62f21f418b3e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $iuZ9D.registerStyles)(cache, serialized, isStringTag);
    (0, $gocPY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $iuZ9D.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $a99e62f21f418b3e$var$Emotion = /* #__PURE__ */ $a99e62f21f418b3e$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$a99e62f21f418b3e$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $iuZ9D.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $1gGLZ.serializeStyles)(registeredStyles, undefined, $ld5Xm.useContext($a99e62f21f418b3e$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($a99e62f21f418b3e$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $a99e62f21f418b3e$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $ld5Xm.createElement($ld5Xm.Fragment, null, /*#__PURE__*/ $ld5Xm.createElement($a99e62f21f418b3e$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $ld5Xm.createElement(WrappedComponent, newProps));
});
var $a99e62f21f418b3e$export$a9c23c6ac3fc3eca = $a99e62f21f418b3e$var$Emotion;

});
parcelRegister("6ke6O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49af8e0bc6eecdf2$export$2e2bcd8739ae039; });

var $jZ7kD = parcelRequire("jZ7kD");

var $161x2 = parcelRequire("161x2");
parcelRequire("ineBE");
parcelRequire("iKjya");
var $49af8e0bc6eecdf2$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $161x2.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $161x2.token)(character)) break;
        (0, $161x2.next)();
    }
    return (0, $161x2.slice)(begin, (0, $161x2.position));
};
var $49af8e0bc6eecdf2$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $161x2.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $161x2.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $49af8e0bc6eecdf2$var$identifierWithPointTracking((0, $161x2.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $161x2.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $161x2.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $161x2.from)(character);
    }
    while (character = (0, $161x2.next)());
    return parsed;
};
var $49af8e0bc6eecdf2$var$getRules = function getRules(value, points) {
    return (0, $161x2.dealloc)($49af8e0bc6eecdf2$var$toRules((0, $161x2.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $49af8e0bc6eecdf2$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $49af8e0bc6eecdf2$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$49af8e0bc6eecdf2$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $49af8e0bc6eecdf2$var$fixedElements.set(element, true);
    var points = [];
    var rules = $49af8e0bc6eecdf2$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $49af8e0bc6eecdf2$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $49af8e0bc6eecdf2$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $49af8e0bc6eecdf2$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($49af8e0bc6eecdf2$var$ignoreFlag) > -1;
};
var $49af8e0bc6eecdf2$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($49af8e0bc6eecdf2$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $49af8e0bc6eecdf2$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $49af8e0bc6eecdf2$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$49af8e0bc6eecdf2$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $49af8e0bc6eecdf2$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $49af8e0bc6eecdf2$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$49af8e0bc6eecdf2$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $49af8e0bc6eecdf2$var$nullifyElement(element);
    } else if ($49af8e0bc6eecdf2$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $49af8e0bc6eecdf2$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $49af8e0bc6eecdf2$var$prefix(value, length) {
    switch((0, $161x2.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $161x2.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $161x2.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $161x2.WEBKIT) + value + (0, $161x2.MOZ) + value + (0, $161x2.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + value + value;
        // order
        case 6165:
            return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $161x2.WEBKIT) + value + (0, $161x2.replace)(value, /(\w+).+(:[^]+)/, (0, $161x2.WEBKIT) + "box-$1$2" + (0, $161x2.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + "flex-item-" + (0, $161x2.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + "flex-line-pack" + (0, $161x2.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + (0, $161x2.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + (0, $161x2.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $161x2.WEBKIT) + "box-" + (0, $161x2.replace)(value, "-grow", "") + (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + (0, $161x2.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $161x2.WEBKIT) + (0, $161x2.replace)(value, /([^-])(transform)/g, "$1" + (0, $161x2.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $161x2.replace)((0, $161x2.replace)((0, $161x2.replace)(value, /(zoom-|grab)/, (0, $161x2.WEBKIT) + "$1"), /(image-set)/, (0, $161x2.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $161x2.replace)(value, /(image-set\([^]*)/, (0, $161x2.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $161x2.replace)((0, $161x2.replace)(value, /(.+:)(flex-)?(.*)/, (0, $161x2.WEBKIT) + "box-pack:$3" + (0, $161x2.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $161x2.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $161x2.replace)(value, /(.+)-inline(.+)/, (0, $161x2.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $161x2.strlen)(value) - 1 - length > 6) switch((0, $161x2.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $161x2.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $161x2.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $161x2.WEBKIT) + "$2-$3" + "$1" + (0, $161x2.MOZ) + ((0, $161x2.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $161x2.indexof)(value, "stretch") ? $49af8e0bc6eecdf2$var$prefix((0, $161x2.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $161x2.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $161x2.charat)(value, (0, $161x2.strlen)(value) - 3 - (~(0, $161x2.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $161x2.replace)(value, ":", ":" + (0, $161x2.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $161x2.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $161x2.WEBKIT) + ((0, $161x2.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $161x2.WEBKIT) + "$2$3" + "$1" + (0, $161x2.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $161x2.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + (0, $161x2.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + (0, $161x2.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + (0, $161x2.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $161x2.WEBKIT) + value + (0, $161x2.MS) + value + value;
    }
    return value;
}
var $49af8e0bc6eecdf2$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $161x2.DECLARATION:
                element["return"] = $49af8e0bc6eecdf2$var$prefix(element.value, element.length);
                break;
            case 0, $161x2.KEYFRAMES:
                return (0, $161x2.serialize)([
                    (0, $161x2.copy)(element, {
                        value: (0, $161x2.replace)(element.value, "@", "@" + (0, $161x2.WEBKIT))
                    })
                ], callback);
            case 0, $161x2.RULESET:
                if (element.length) return (0, $161x2.combine)(element.props, function(value) {
                    switch((0, $161x2.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $161x2.serialize)([
                                (0, $161x2.copy)(element, {
                                    props: [
                                        (0, $161x2.replace)(value, /:(read-\w+)/, ":" + (0, $161x2.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $161x2.serialize)([
                                (0, $161x2.copy)(element, {
                                    props: [
                                        (0, $161x2.replace)(value, /:(plac\w+)/, ":" + (0, $161x2.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $161x2.copy)(element, {
                                    props: [
                                        (0, $161x2.replace)(value, /:(plac\w+)/, ":" + (0, $161x2.MOZ) + "$1")
                                    ]
                                }),
                                (0, $161x2.copy)(element, {
                                    props: [
                                        (0, $161x2.replace)(value, /:(plac\w+)/, (0, $161x2.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $49af8e0bc6eecdf2$var$defaultStylisPlugins = [
    $49af8e0bc6eecdf2$var$prefixer
];
var $49af8e0bc6eecdf2$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $49af8e0bc6eecdf2$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $49af8e0bc6eecdf2$var$compat,
        $49af8e0bc6eecdf2$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $161x2.stringify),
        (0, $161x2.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $161x2.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $161x2.serialize)((0, $161x2.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $jZ7kD.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jZ7kD", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $e8c966c17b8c6532$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $e8c966c17b8c6532$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $e8c966c17b8c6532$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e8c966c17b8c6532$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e8c966c17b8c6532$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $e8c966c17b8c6532$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("161x2", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $910bfe35ff4c41b1$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $910bfe35ff4c41b1$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $910bfe35ff4c41b1$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $910bfe35ff4c41b1$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $910bfe35ff4c41b1$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $910bfe35ff4c41b1$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $910bfe35ff4c41b1$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $910bfe35ff4c41b1$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $910bfe35ff4c41b1$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $910bfe35ff4c41b1$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $910bfe35ff4c41b1$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $910bfe35ff4c41b1$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $910bfe35ff4c41b1$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $910bfe35ff4c41b1$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $910bfe35ff4c41b1$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $910bfe35ff4c41b1$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $910bfe35ff4c41b1$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $910bfe35ff4c41b1$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $910bfe35ff4c41b1$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $910bfe35ff4c41b1$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $910bfe35ff4c41b1$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $910bfe35ff4c41b1$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $910bfe35ff4c41b1$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $910bfe35ff4c41b1$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $910bfe35ff4c41b1$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $910bfe35ff4c41b1$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $910bfe35ff4c41b1$export$38bcb760f1d4871c; });
var $910bfe35ff4c41b1$export$71ad59f2e432cfe8 = "-ms-";
var $910bfe35ff4c41b1$export$2c0f367103c8d01c = "-moz-";
var $910bfe35ff4c41b1$export$39dfd62a25e0fe93 = "-webkit-";
var $910bfe35ff4c41b1$export$a29989082612d0d9 = "comm";
var $910bfe35ff4c41b1$export$aa3a2e812ca8570d = "rule";
var $910bfe35ff4c41b1$export$527d108ccf083c2b = "decl";
var $910bfe35ff4c41b1$export$d3d35020fa5b54f0 = "@page";
var $910bfe35ff4c41b1$export$500415a86c544f73 = "@media";
var $910bfe35ff4c41b1$export$a763edbf796b780a = "@import";
var $910bfe35ff4c41b1$export$2790aeb8b4e5c826 = "@charset";
var $910bfe35ff4c41b1$export$1cc683e23b84b133 = "@viewport";
var $910bfe35ff4c41b1$export$9447a5efea57e862 = "@supports";
var $910bfe35ff4c41b1$export$ef011b4e114b1fba = "@document";
var $910bfe35ff4c41b1$export$6aad947bda0f3f46 = "@namespace";
var $910bfe35ff4c41b1$export$b44a8529a35fcb60 = "@keyframes";
var $910bfe35ff4c41b1$export$2c16de31893252e6 = "@font-face";
var $910bfe35ff4c41b1$export$3d846dd52e150c6f = "@counter-style";
var $910bfe35ff4c41b1$export$22314bfbb57653fe = "@font-feature-values";
var $910bfe35ff4c41b1$export$d773506282b3cfe6 = "@layer";
var $910bfe35ff4c41b1$export$2335f513bbd82c6d = Math.abs;
var $910bfe35ff4c41b1$export$6788812c4e6611e6 = String.fromCharCode;
var $910bfe35ff4c41b1$export$e6e34fd1f2686227 = Object.assign;
function $910bfe35ff4c41b1$export$d6af199866bfb566(e, r) {
    return $910bfe35ff4c41b1$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $910bfe35ff4c41b1$export$a9db5e087081082d(e, 0)) << 2 ^ $910bfe35ff4c41b1$export$a9db5e087081082d(e, 1)) << 2 ^ $910bfe35ff4c41b1$export$a9db5e087081082d(e, 2)) << 2 ^ $910bfe35ff4c41b1$export$a9db5e087081082d(e, 3) : 0;
}
function $910bfe35ff4c41b1$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $910bfe35ff4c41b1$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $910bfe35ff4c41b1$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $910bfe35ff4c41b1$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $910bfe35ff4c41b1$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $910bfe35ff4c41b1$export$36776f635604f274(e) {
    return e.length;
}
function $910bfe35ff4c41b1$export$f9084667e487ed46(e) {
    return e.length;
}
function $910bfe35ff4c41b1$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $910bfe35ff4c41b1$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $910bfe35ff4c41b1$export$53f1d5ea8de3d7c = 1;
var $910bfe35ff4c41b1$export$4e0c71f277ca26b3 = 1;
var $910bfe35ff4c41b1$export$f24224f1c91d8156 = 0;
var $910bfe35ff4c41b1$export$5880b8b5730aff45 = 0;
var $910bfe35ff4c41b1$export$c0306caf338ac095 = 0;
var $910bfe35ff4c41b1$export$30a86d91af8ff6e6 = "";
function $910bfe35ff4c41b1$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $910bfe35ff4c41b1$export$53f1d5ea8de3d7c,
        column: $910bfe35ff4c41b1$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $910bfe35ff4c41b1$export$784d13d8ee351f07(e, r) {
    return $910bfe35ff4c41b1$export$e6e34fd1f2686227($910bfe35ff4c41b1$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $910bfe35ff4c41b1$export$eba6f6f03b0a92e7() {
    return $910bfe35ff4c41b1$export$c0306caf338ac095;
}
function $910bfe35ff4c41b1$export$232faf9add678146() {
    $910bfe35ff4c41b1$export$c0306caf338ac095 = $910bfe35ff4c41b1$export$5880b8b5730aff45 > 0 ? $910bfe35ff4c41b1$export$a9db5e087081082d($910bfe35ff4c41b1$export$30a86d91af8ff6e6, --$910bfe35ff4c41b1$export$5880b8b5730aff45) : 0;
    if ($910bfe35ff4c41b1$export$4e0c71f277ca26b3--, $910bfe35ff4c41b1$export$c0306caf338ac095 === 10) $910bfe35ff4c41b1$export$4e0c71f277ca26b3 = 1, $910bfe35ff4c41b1$export$53f1d5ea8de3d7c--;
    return $910bfe35ff4c41b1$export$c0306caf338ac095;
}
function $910bfe35ff4c41b1$export$48cfd1e771a65c4f() {
    $910bfe35ff4c41b1$export$c0306caf338ac095 = $910bfe35ff4c41b1$export$5880b8b5730aff45 < $910bfe35ff4c41b1$export$f24224f1c91d8156 ? $910bfe35ff4c41b1$export$a9db5e087081082d($910bfe35ff4c41b1$export$30a86d91af8ff6e6, $910bfe35ff4c41b1$export$5880b8b5730aff45++) : 0;
    if ($910bfe35ff4c41b1$export$4e0c71f277ca26b3++, $910bfe35ff4c41b1$export$c0306caf338ac095 === 10) $910bfe35ff4c41b1$export$4e0c71f277ca26b3 = 1, $910bfe35ff4c41b1$export$53f1d5ea8de3d7c++;
    return $910bfe35ff4c41b1$export$c0306caf338ac095;
}
function $910bfe35ff4c41b1$export$4d3fb11e950abb9e() {
    return $910bfe35ff4c41b1$export$a9db5e087081082d($910bfe35ff4c41b1$export$30a86d91af8ff6e6, $910bfe35ff4c41b1$export$5880b8b5730aff45);
}
function $910bfe35ff4c41b1$export$e88cb2efb12ae807() {
    return $910bfe35ff4c41b1$export$5880b8b5730aff45;
}
function $910bfe35ff4c41b1$export$58adb3bec8346d0f(e, r) {
    return $910bfe35ff4c41b1$export$2f35ab04d2335697($910bfe35ff4c41b1$export$30a86d91af8ff6e6, e, r);
}
function $910bfe35ff4c41b1$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $910bfe35ff4c41b1$export$2de70f21292aac9e(e) {
    return $910bfe35ff4c41b1$export$53f1d5ea8de3d7c = $910bfe35ff4c41b1$export$4e0c71f277ca26b3 = 1, $910bfe35ff4c41b1$export$f24224f1c91d8156 = $910bfe35ff4c41b1$export$36776f635604f274($910bfe35ff4c41b1$export$30a86d91af8ff6e6 = e), $910bfe35ff4c41b1$export$5880b8b5730aff45 = 0, [];
}
function $910bfe35ff4c41b1$export$45918ac1574455b1(e) {
    return $910bfe35ff4c41b1$export$30a86d91af8ff6e6 = "", e;
}
function $910bfe35ff4c41b1$export$410ac95b9ec204b8(e) {
    return $910bfe35ff4c41b1$export$87c2784dc9fc4ab($910bfe35ff4c41b1$export$58adb3bec8346d0f($910bfe35ff4c41b1$export$5880b8b5730aff45 - 1, $910bfe35ff4c41b1$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $910bfe35ff4c41b1$export$660b2ee2d4fb4eff(e) {
    return $910bfe35ff4c41b1$export$45918ac1574455b1($910bfe35ff4c41b1$export$5f8c09e3ae6f64e1($910bfe35ff4c41b1$export$2de70f21292aac9e(e)));
}
function $910bfe35ff4c41b1$export$7af1228ff777d175(e) {
    while($910bfe35ff4c41b1$export$c0306caf338ac095 = $910bfe35ff4c41b1$export$4d3fb11e950abb9e())if ($910bfe35ff4c41b1$export$c0306caf338ac095 < 33) $910bfe35ff4c41b1$export$48cfd1e771a65c4f();
    else break;
    return $910bfe35ff4c41b1$export$9e1725a4cfeada27(e) > 2 || $910bfe35ff4c41b1$export$9e1725a4cfeada27($910bfe35ff4c41b1$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $910bfe35ff4c41b1$export$5f8c09e3ae6f64e1(e) {
    while($910bfe35ff4c41b1$export$48cfd1e771a65c4f())switch($910bfe35ff4c41b1$export$9e1725a4cfeada27($910bfe35ff4c41b1$export$c0306caf338ac095)){
        case 0:
            $910bfe35ff4c41b1$export$10d8903dec122b9d($910bfe35ff4c41b1$export$c2ab62c7bf24634($910bfe35ff4c41b1$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $910bfe35ff4c41b1$export$10d8903dec122b9d($910bfe35ff4c41b1$export$410ac95b9ec204b8($910bfe35ff4c41b1$export$c0306caf338ac095), e);
            break;
        default:
            $910bfe35ff4c41b1$export$10d8903dec122b9d($910bfe35ff4c41b1$export$6788812c4e6611e6($910bfe35ff4c41b1$export$c0306caf338ac095), e);
    }
    return e;
}
function $910bfe35ff4c41b1$export$955ba06d119e085e(e, r) {
    while(--r && $910bfe35ff4c41b1$export$48cfd1e771a65c4f())if ($910bfe35ff4c41b1$export$c0306caf338ac095 < 48 || $910bfe35ff4c41b1$export$c0306caf338ac095 > 102 || $910bfe35ff4c41b1$export$c0306caf338ac095 > 57 && $910bfe35ff4c41b1$export$c0306caf338ac095 < 65 || $910bfe35ff4c41b1$export$c0306caf338ac095 > 70 && $910bfe35ff4c41b1$export$c0306caf338ac095 < 97) break;
    return $910bfe35ff4c41b1$export$58adb3bec8346d0f(e, $910bfe35ff4c41b1$export$e88cb2efb12ae807() + (r < 6 && $910bfe35ff4c41b1$export$4d3fb11e950abb9e() == 32 && $910bfe35ff4c41b1$export$48cfd1e771a65c4f() == 32));
}
function $910bfe35ff4c41b1$export$c889f2fcc19dbf12(e) {
    while($910bfe35ff4c41b1$export$48cfd1e771a65c4f())switch($910bfe35ff4c41b1$export$c0306caf338ac095){
        case e:
            return $910bfe35ff4c41b1$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $910bfe35ff4c41b1$export$c889f2fcc19dbf12($910bfe35ff4c41b1$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $910bfe35ff4c41b1$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $910bfe35ff4c41b1$export$48cfd1e771a65c4f();
            break;
    }
    return $910bfe35ff4c41b1$export$5880b8b5730aff45;
}
function $910bfe35ff4c41b1$export$4254d4e2b3745c4c(e, r) {
    while($910bfe35ff4c41b1$export$48cfd1e771a65c4f())if (e + $910bfe35ff4c41b1$export$c0306caf338ac095 === 57) break;
    else if (e + $910bfe35ff4c41b1$export$c0306caf338ac095 === 84 && $910bfe35ff4c41b1$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $910bfe35ff4c41b1$export$58adb3bec8346d0f(r, $910bfe35ff4c41b1$export$5880b8b5730aff45 - 1) + "*" + $910bfe35ff4c41b1$export$6788812c4e6611e6(e === 47 ? e : $910bfe35ff4c41b1$export$48cfd1e771a65c4f());
}
function $910bfe35ff4c41b1$export$c2ab62c7bf24634(e) {
    while(!$910bfe35ff4c41b1$export$9e1725a4cfeada27($910bfe35ff4c41b1$export$4d3fb11e950abb9e()))$910bfe35ff4c41b1$export$48cfd1e771a65c4f();
    return $910bfe35ff4c41b1$export$58adb3bec8346d0f(e, $910bfe35ff4c41b1$export$5880b8b5730aff45);
}
function $910bfe35ff4c41b1$export$ef7acd7185315e22(e) {
    return $910bfe35ff4c41b1$export$45918ac1574455b1($910bfe35ff4c41b1$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $910bfe35ff4c41b1$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $910bfe35ff4c41b1$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $910bfe35ff4c41b1$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $910bfe35ff4c41b1$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($910bfe35ff4c41b1$export$f8e21b1e77979a08(j += $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed($910bfe35ff4c41b1$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $910bfe35ff4c41b1$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $910bfe35ff4c41b1$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $910bfe35ff4c41b1$export$955ba06d119e085e($910bfe35ff4c41b1$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($910bfe35ff4c41b1$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $910bfe35ff4c41b1$export$10d8903dec122b9d($910bfe35ff4c41b1$export$4a34f930e789283c($910bfe35ff4c41b1$export$4254d4e2b3745c4c($910bfe35ff4c41b1$export$48cfd1e771a65c4f(), $910bfe35ff4c41b1$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $910bfe35ff4c41b1$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $910bfe35ff4c41b1$export$36776f635604f274(j) - l) $910bfe35ff4c41b1$export$10d8903dec122b9d(p > 32 ? $910bfe35ff4c41b1$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $910bfe35ff4c41b1$export$f8483753829ec8f3($910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $910bfe35ff4c41b1$export$10d8903dec122b9d(y = $910bfe35ff4c41b1$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $910bfe35ff4c41b1$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $910bfe35ff4c41b1$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $910bfe35ff4c41b1$export$98e6a39c04603d36(e, y, y, n && $910bfe35ff4c41b1$export$10d8903dec122b9d($910bfe35ff4c41b1$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $910bfe35ff4c41b1$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $910bfe35ff4c41b1$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $910bfe35ff4c41b1$export$232faf9add678146() == 125) continue;
            }
            switch(j += $910bfe35ff4c41b1$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($910bfe35ff4c41b1$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($910bfe35ff4c41b1$export$4d3fb11e950abb9e() === 45) j += $910bfe35ff4c41b1$export$410ac95b9ec204b8($910bfe35ff4c41b1$export$48cfd1e771a65c4f());
                    v = $910bfe35ff4c41b1$export$4d3fb11e950abb9e(), o = l = $910bfe35ff4c41b1$export$36776f635604f274(g = j += $910bfe35ff4c41b1$export$c2ab62c7bf24634($910bfe35ff4c41b1$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $910bfe35ff4c41b1$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $910bfe35ff4c41b1$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $910bfe35ff4c41b1$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $910bfe35ff4c41b1$export$2f35ab04d2335697(e, v + 1, v = $910bfe35ff4c41b1$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $910bfe35ff4c41b1$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $910bfe35ff4c41b1$export$35059013cd4a06db(e, r, a, s === 0 ? $910bfe35ff4c41b1$export$aa3a2e812ca8570d : i, f, o, l);
}
function $910bfe35ff4c41b1$export$4a34f930e789283c(e, r, a) {
    return $910bfe35ff4c41b1$export$35059013cd4a06db(e, r, a, $910bfe35ff4c41b1$export$a29989082612d0d9, $910bfe35ff4c41b1$export$6788812c4e6611e6($910bfe35ff4c41b1$export$eba6f6f03b0a92e7()), $910bfe35ff4c41b1$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $910bfe35ff4c41b1$export$f8483753829ec8f3(e, r, a, n) {
    return $910bfe35ff4c41b1$export$35059013cd4a06db(e, r, a, $910bfe35ff4c41b1$export$527d108ccf083c2b, $910bfe35ff4c41b1$export$2f35ab04d2335697(e, 0, n), $910bfe35ff4c41b1$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $910bfe35ff4c41b1$export$82e9f45cca5ba907(n, c, s) {
    switch($910bfe35ff4c41b1$export$d6af199866bfb566(n, c)){
        case 5103:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $910bfe35ff4c41b1$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$2c0f367103c8d01c + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($910bfe35ff4c41b1$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "box-$1$2" + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "flex-item-" + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$910bfe35ff4c41b1$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "grid-row-" + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "flex-line-pack" + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "box-" + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "-grow", "") + $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed($910bfe35ff4c41b1$export$77ad94ebf1c2b9ed($910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed($910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "box-pack:$3" + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$910bfe35ff4c41b1$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "grid-column-align" + $910bfe35ff4c41b1$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $910bfe35ff4c41b1$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$910bfe35ff4c41b1$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$910bfe35ff4c41b1$export$f8e21b1e77979a08(s, "span") ? $910bfe35ff4c41b1$export$4659b591c19bdf3d(s, /\d+/) : +$910bfe35ff4c41b1$export$4659b591c19bdf3d(s, /\d+/) - +$910bfe35ff4c41b1$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $910bfe35ff4c41b1$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed($910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($910bfe35ff4c41b1$export$36776f635604f274(n) - 1 - c > 6) switch($910bfe35ff4c41b1$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($910bfe35ff4c41b1$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $910bfe35ff4c41b1$export$2c0f367103c8d01c + ($910bfe35ff4c41b1$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$910bfe35ff4c41b1$export$f8e21b1e77979a08(n, "stretch") ? $910bfe35ff4c41b1$export$82e9f45cca5ba907($910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($910bfe35ff4c41b1$export$a9db5e087081082d(n, c + 6) === 121) return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, ":", ":" + $910bfe35ff4c41b1$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($910bfe35ff4c41b1$export$a9db5e087081082d(n, $910bfe35ff4c41b1$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + ($910bfe35ff4c41b1$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, ":", ":" + $910bfe35ff4c41b1$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $910bfe35ff4c41b1$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $910bfe35ff4c41b1$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $910bfe35ff4c41b1$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $910bfe35ff4c41b1$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $910bfe35ff4c41b1$export$a763edbf796b780a:
        case $910bfe35ff4c41b1$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $910bfe35ff4c41b1$export$a29989082612d0d9:
            return "";
        case $910bfe35ff4c41b1$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $910bfe35ff4c41b1$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $910bfe35ff4c41b1$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $910bfe35ff4c41b1$export$36776f635604f274(a = $910bfe35ff4c41b1$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $910bfe35ff4c41b1$export$5a7767152ae0305f(e) {
    var r = $910bfe35ff4c41b1$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $910bfe35ff4c41b1$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $910bfe35ff4c41b1$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $910bfe35ff4c41b1$export$527d108ccf083c2b:
                n.return = $910bfe35ff4c41b1$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $910bfe35ff4c41b1$export$b44a8529a35fcb60:
                return $910bfe35ff4c41b1$export$dfdc1655ccc5b9cb([
                    $910bfe35ff4c41b1$export$784d13d8ee351f07(n, {
                        value: $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $910bfe35ff4c41b1$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $910bfe35ff4c41b1$export$aa3a2e812ca8570d:
                if (n.length) return $910bfe35ff4c41b1$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($910bfe35ff4c41b1$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $910bfe35ff4c41b1$export$dfdc1655ccc5b9cb([
                                $910bfe35ff4c41b1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $910bfe35ff4c41b1$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $910bfe35ff4c41b1$export$dfdc1655ccc5b9cb([
                                $910bfe35ff4c41b1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $910bfe35ff4c41b1$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $910bfe35ff4c41b1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $910bfe35ff4c41b1$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $910bfe35ff4c41b1$export$784d13d8ee351f07(n, {
                                    props: [
                                        $910bfe35ff4c41b1$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $910bfe35ff4c41b1$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $910bfe35ff4c41b1$export$76a88f7de6507443(e) {
    switch(e.type){
        case $910bfe35ff4c41b1$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $910bfe35ff4c41b1$export$1be1fc439b849fdf($910bfe35ff4c41b1$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($910bfe35ff4c41b1$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $910bfe35ff4c41b1$export$2f35ab04d2335697(r, 1, $910bfe35ff4c41b1$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $910bfe35ff4c41b1$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $910bfe35ff4c41b1$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $910bfe35ff4c41b1$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("ineBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d605b4781af588be$export$2e2bcd8739ae039; });
var $d605b4781af588be$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("iKjya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da5bb01f926959d0$export$2e2bcd8739ae039; });
function $da5bb01f926959d0$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("3oHuP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27955a71aef2ff05$export$2e2bcd8739ae039; });

var $kZiIn = parcelRequire("kZiIn");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $27955a71aef2ff05$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kZiIn)))(targetComponent, sourceComponent);
};

});
parcelRegister("kZiIn", function(module, exports) {
"use strict";

var $kcgs1 = parcelRequire("kcgs1");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f478058006d4890a$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f478058006d4890a$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f478058006d4890a$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f478058006d4890a$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f478058006d4890a$var$TYPE_STATICS = {};
$f478058006d4890a$var$TYPE_STATICS[$kcgs1.ForwardRef] = $f478058006d4890a$var$FORWARD_REF_STATICS;
$f478058006d4890a$var$TYPE_STATICS[$kcgs1.Memo] = $f478058006d4890a$var$MEMO_STATICS;
function $f478058006d4890a$var$getStatics(component) {
    // React v16.11 and below
    if ($kcgs1.isMemo(component)) return $f478058006d4890a$var$MEMO_STATICS;
     // React v16.12 and above
    return $f478058006d4890a$var$TYPE_STATICS[component["$$typeof"]] || $f478058006d4890a$var$REACT_STATICS;
}
var $f478058006d4890a$var$defineProperty = Object.defineProperty;
var $f478058006d4890a$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f478058006d4890a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f478058006d4890a$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f478058006d4890a$var$getPrototypeOf = Object.getPrototypeOf;
var $f478058006d4890a$var$objectPrototype = Object.prototype;
function $f478058006d4890a$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($f478058006d4890a$var$objectPrototype) {
            var inheritedComponent = $f478058006d4890a$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f478058006d4890a$var$objectPrototype) $f478058006d4890a$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f478058006d4890a$var$getOwnPropertyNames(sourceComponent);
        if ($f478058006d4890a$var$getOwnPropertySymbols) keys = keys.concat($f478058006d4890a$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f478058006d4890a$var$getStatics(targetComponent);
        var sourceStatics = $f478058006d4890a$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f478058006d4890a$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f478058006d4890a$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f478058006d4890a$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $f478058006d4890a$var$hoistNonReactStatics;

});
parcelRegister("kcgs1", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hyjTP"));

});
parcelRegister("hyjTP", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $cc750c490f151774$export$2b8d127b894957b9; }, function (v) { return $cc750c490f151774$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $cc750c490f151774$export$cea3a54a6425200c; }, function (v) { return $cc750c490f151774$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $cc750c490f151774$export$a7c73072b1a182ae; }, function (v) { return $cc750c490f151774$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $cc750c490f151774$export$9f27bc3417b4524d; }, function (v) { return $cc750c490f151774$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $cc750c490f151774$export$db77ccec0bb4ccac; }, function (v) { return $cc750c490f151774$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $cc750c490f151774$export$8392c0c9d3dcbd35; }, function (v) { return $cc750c490f151774$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $cc750c490f151774$export$ffb0004e005737fa; }, function (v) { return $cc750c490f151774$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $cc750c490f151774$export$b624eff549462981; }, function (v) { return $cc750c490f151774$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $cc750c490f151774$export$7897aa7841a5380c; }, function (v) { return $cc750c490f151774$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $cc750c490f151774$export$602eac185826482c; }, function (v) { return $cc750c490f151774$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $cc750c490f151774$export$e2c29f18771995cb; }, function (v) { return $cc750c490f151774$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cc750c490f151774$export$5f8d39834fd61797; }, function (v) { return $cc750c490f151774$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $cc750c490f151774$export$74bf444e3cd11ea5; }, function (v) { return $cc750c490f151774$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $cc750c490f151774$export$92387174baf9b227; }, function (v) { return $cc750c490f151774$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $cc750c490f151774$export$ec112efeb987d9c6; }, function (v) { return $cc750c490f151774$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $cc750c490f151774$export$b706b080d889d2c9; }, function (v) { return $cc750c490f151774$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $cc750c490f151774$export$5be5a87408f70ddc; }, function (v) { return $cc750c490f151774$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $cc750c490f151774$export$45a5e7f76e0caa8d; }, function (v) { return $cc750c490f151774$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $cc750c490f151774$export$455c2e768291efa6; }, function (v) { return $cc750c490f151774$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $cc750c490f151774$export$9522e17588c12572; }, function (v) { return $cc750c490f151774$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $cc750c490f151774$export$2110ac352bb060b9; }, function (v) { return $cc750c490f151774$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $cc750c490f151774$export$56885ab8b9c456ab; }, function (v) { return $cc750c490f151774$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $cc750c490f151774$export$d927fcb6adf8f9de; }, function (v) { return $cc750c490f151774$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $cc750c490f151774$export$b82d16f27459e05a; }, function (v) { return $cc750c490f151774$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $cc750c490f151774$export$522c17b4f5e123e8; }, function (v) { return $cc750c490f151774$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $cc750c490f151774$export$1aabd8a0274ecfd6; }, function (v) { return $cc750c490f151774$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $cc750c490f151774$export$9b621391a187a31a; }, function (v) { return $cc750c490f151774$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $cc750c490f151774$export$f5bbd400c2f4426f; }, function (v) { return $cc750c490f151774$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc750c490f151774$export$2b8d127b894957b9;
var $cc750c490f151774$export$cea3a54a6425200c;
var $cc750c490f151774$export$a7c73072b1a182ae;
var $cc750c490f151774$export$9f27bc3417b4524d;
var $cc750c490f151774$export$db77ccec0bb4ccac;
var $cc750c490f151774$export$8392c0c9d3dcbd35;
var $cc750c490f151774$export$ffb0004e005737fa;
var $cc750c490f151774$export$b624eff549462981;
var $cc750c490f151774$export$7897aa7841a5380c;
var $cc750c490f151774$export$602eac185826482c;
var $cc750c490f151774$export$e2c29f18771995cb;
var $cc750c490f151774$export$5f8d39834fd61797;
var $cc750c490f151774$export$74bf444e3cd11ea5;
var $cc750c490f151774$export$92387174baf9b227;
var $cc750c490f151774$export$ec112efeb987d9c6;
var $cc750c490f151774$export$b706b080d889d2c9;
var $cc750c490f151774$export$5be5a87408f70ddc;
var $cc750c490f151774$export$45a5e7f76e0caa8d;
var $cc750c490f151774$export$455c2e768291efa6;
var $cc750c490f151774$export$9522e17588c12572;
var $cc750c490f151774$export$2110ac352bb060b9;
var $cc750c490f151774$export$56885ab8b9c456ab;
var $cc750c490f151774$export$d927fcb6adf8f9de;
var $cc750c490f151774$export$b82d16f27459e05a;
var $cc750c490f151774$export$522c17b4f5e123e8;
var $cc750c490f151774$export$1aabd8a0274ecfd6;
var $cc750c490f151774$export$9b621391a187a31a;
var $cc750c490f151774$export$f5bbd400c2f4426f;
"use strict";
var $cc750c490f151774$var$b = "function" === typeof Symbol && Symbol.for, $cc750c490f151774$var$c = $cc750c490f151774$var$b ? Symbol.for("react.element") : 60103, $cc750c490f151774$var$d = $cc750c490f151774$var$b ? Symbol.for("react.portal") : 60106, $cc750c490f151774$var$e = $cc750c490f151774$var$b ? Symbol.for("react.fragment") : 60107, $cc750c490f151774$var$f = $cc750c490f151774$var$b ? Symbol.for("react.strict_mode") : 60108, $cc750c490f151774$var$g = $cc750c490f151774$var$b ? Symbol.for("react.profiler") : 60114, $cc750c490f151774$var$h = $cc750c490f151774$var$b ? Symbol.for("react.provider") : 60109, $cc750c490f151774$var$k = $cc750c490f151774$var$b ? Symbol.for("react.context") : 60110, $cc750c490f151774$var$l = $cc750c490f151774$var$b ? Symbol.for("react.async_mode") : 60111, $cc750c490f151774$var$m = $cc750c490f151774$var$b ? Symbol.for("react.concurrent_mode") : 60111, $cc750c490f151774$var$n = $cc750c490f151774$var$b ? Symbol.for("react.forward_ref") : 60112, $cc750c490f151774$var$p = $cc750c490f151774$var$b ? Symbol.for("react.suspense") : 60113, $cc750c490f151774$var$q = $cc750c490f151774$var$b ? Symbol.for("react.suspense_list") : 60120, $cc750c490f151774$var$r = $cc750c490f151774$var$b ? Symbol.for("react.memo") : 60115, $cc750c490f151774$var$t = $cc750c490f151774$var$b ? Symbol.for("react.lazy") : 60116, $cc750c490f151774$var$v = $cc750c490f151774$var$b ? Symbol.for("react.block") : 60121, $cc750c490f151774$var$w = $cc750c490f151774$var$b ? Symbol.for("react.fundamental") : 60117, $cc750c490f151774$var$x = $cc750c490f151774$var$b ? Symbol.for("react.responder") : 60118, $cc750c490f151774$var$y = $cc750c490f151774$var$b ? Symbol.for("react.scope") : 60119;
function $cc750c490f151774$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $cc750c490f151774$var$c:
                switch(a = a.type, a){
                    case $cc750c490f151774$var$l:
                    case $cc750c490f151774$var$m:
                    case $cc750c490f151774$var$e:
                    case $cc750c490f151774$var$g:
                    case $cc750c490f151774$var$f:
                    case $cc750c490f151774$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cc750c490f151774$var$k:
                            case $cc750c490f151774$var$n:
                            case $cc750c490f151774$var$t:
                            case $cc750c490f151774$var$r:
                            case $cc750c490f151774$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $cc750c490f151774$var$d:
                return u;
        }
    }
}
function $cc750c490f151774$var$A(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$m;
}
$cc750c490f151774$export$2b8d127b894957b9 = $cc750c490f151774$var$l;
$cc750c490f151774$export$cea3a54a6425200c = $cc750c490f151774$var$m;
$cc750c490f151774$export$a7c73072b1a182ae = $cc750c490f151774$var$k;
$cc750c490f151774$export$9f27bc3417b4524d = $cc750c490f151774$var$h;
$cc750c490f151774$export$db77ccec0bb4ccac = $cc750c490f151774$var$c;
$cc750c490f151774$export$8392c0c9d3dcbd35 = $cc750c490f151774$var$n;
$cc750c490f151774$export$ffb0004e005737fa = $cc750c490f151774$var$e;
$cc750c490f151774$export$b624eff549462981 = $cc750c490f151774$var$t;
$cc750c490f151774$export$7897aa7841a5380c = $cc750c490f151774$var$r;
$cc750c490f151774$export$602eac185826482c = $cc750c490f151774$var$d;
$cc750c490f151774$export$e2c29f18771995cb = $cc750c490f151774$var$g;
$cc750c490f151774$export$5f8d39834fd61797 = $cc750c490f151774$var$f;
$cc750c490f151774$export$74bf444e3cd11ea5 = $cc750c490f151774$var$p;
$cc750c490f151774$export$92387174baf9b227 = function(a) {
    return $cc750c490f151774$var$A(a) || $cc750c490f151774$var$z(a) === $cc750c490f151774$var$l;
};
$cc750c490f151774$export$ec112efeb987d9c6 = $cc750c490f151774$var$A;
$cc750c490f151774$export$b706b080d889d2c9 = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$k;
};
$cc750c490f151774$export$5be5a87408f70ddc = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$h;
};
$cc750c490f151774$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cc750c490f151774$var$c;
};
$cc750c490f151774$export$455c2e768291efa6 = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$n;
};
$cc750c490f151774$export$9522e17588c12572 = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$e;
};
$cc750c490f151774$export$2110ac352bb060b9 = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$t;
};
$cc750c490f151774$export$56885ab8b9c456ab = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$r;
};
$cc750c490f151774$export$d927fcb6adf8f9de = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$d;
};
$cc750c490f151774$export$b82d16f27459e05a = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$g;
};
$cc750c490f151774$export$522c17b4f5e123e8 = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$f;
};
$cc750c490f151774$export$1aabd8a0274ecfd6 = function(a) {
    return $cc750c490f151774$var$z(a) === $cc750c490f151774$var$p;
};
$cc750c490f151774$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cc750c490f151774$var$e || a === $cc750c490f151774$var$m || a === $cc750c490f151774$var$g || a === $cc750c490f151774$var$f || a === $cc750c490f151774$var$p || a === $cc750c490f151774$var$q || "object" === typeof a && null !== a && (a.$$typeof === $cc750c490f151774$var$t || a.$$typeof === $cc750c490f151774$var$r || a.$$typeof === $cc750c490f151774$var$h || a.$$typeof === $cc750c490f151774$var$k || a.$$typeof === $cc750c490f151774$var$n || a.$$typeof === $cc750c490f151774$var$w || a.$$typeof === $cc750c490f151774$var$x || a.$$typeof === $cc750c490f151774$var$y || a.$$typeof === $cc750c490f151774$var$v);
};
$cc750c490f151774$export$f5bbd400c2f4426f = $cc750c490f151774$var$z;

});




parcelRegister("iuZ9D", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $d77a7750658b1ff8$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $d77a7750658b1ff8$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $d77a7750658b1ff8$export$6f077d94b33a01aa; });
var $d77a7750658b1ff8$var$isBrowser = true;
function $d77a7750658b1ff8$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $d77a7750658b1ff8$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d77a7750658b1ff8$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d77a7750658b1ff8$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d77a7750658b1ff8$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("1gGLZ", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $0ec876e2b690d743$export$6321afa313b251b5; });

var $2bZAj = parcelRequire("2bZAj");

var $7a84v = parcelRequire("7a84v");

var $iKjya = parcelRequire("iKjya");
var $0ec876e2b690d743$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $0ec876e2b690d743$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $0ec876e2b690d743$var$hyphenateRegex = /[A-Z]|^ms/g;
var $0ec876e2b690d743$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $0ec876e2b690d743$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $0ec876e2b690d743$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $0ec876e2b690d743$var$processStyleName = /* #__PURE__ */ (0, $iKjya.default)(function(styleName) {
    return $0ec876e2b690d743$var$isCustomProperty(styleName) ? styleName : styleName.replace($0ec876e2b690d743$var$hyphenateRegex, "-$&").toLowerCase();
});
var $0ec876e2b690d743$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($0ec876e2b690d743$var$animationRegex, function(match, p1, p2) {
                $0ec876e2b690d743$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $0ec876e2b690d743$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7a84v.default)[key] !== 1 && !$0ec876e2b690d743$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $0ec876e2b690d743$var$contentValuePattern, $0ec876e2b690d743$var$contentValues, $0ec876e2b690d743$var$oldProcessStyleValue, $0ec876e2b690d743$var$msPattern, $0ec876e2b690d743$var$hyphenPattern, $0ec876e2b690d743$var$hyphenatedCache;
var $0ec876e2b690d743$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $0ec876e2b690d743$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $0ec876e2b690d743$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $0ec876e2b690d743$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $0ec876e2b690d743$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $0ec876e2b690d743$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $0ec876e2b690d743$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $0ec876e2b690d743$var$cursor;
                var result = interpolation(mergedProps);
                $0ec876e2b690d743$var$cursor = previousCursor;
                return $0ec876e2b690d743$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $0ec876e2b690d743$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $0ec876e2b690d743$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($0ec876e2b690d743$var$isProcessableValue(value)) string += $0ec876e2b690d743$var$processStyleName(_key) + ":" + $0ec876e2b690d743$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($0ec876e2b690d743$var$isProcessableValue(value[_i])) string += $0ec876e2b690d743$var$processStyleName(_key) + ":" + $0ec876e2b690d743$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $0ec876e2b690d743$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $0ec876e2b690d743$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $0ec876e2b690d743$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $0ec876e2b690d743$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $0ec876e2b690d743$var$cursor;
var $0ec876e2b690d743$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $0ec876e2b690d743$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $0ec876e2b690d743$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $0ec876e2b690d743$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $0ec876e2b690d743$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $0ec876e2b690d743$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $2bZAj.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $0ec876e2b690d743$var$cursor
    };
};

});
parcelRegister("2bZAj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $198c614c7df18cf8$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $198c614c7df18cf8$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("7a84v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $536fba6c0d477152$export$2e2bcd8739ae039; });
var $536fba6c0d477152$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("gocPY", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $bee8d86da3f806fd$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $bee8d86da3f806fd$export$811a713a7276cb9d; });

var $ld5Xm = parcelRequire("ld5Xm");
var $bee8d86da3f806fd$var$syncFallback = function syncFallback(create) {
    return create();
};
var $bee8d86da3f806fd$var$useInsertionEffect = $ld5Xm.useInsertionEffect ? $ld5Xm.useInsertionEffect : false;
var $bee8d86da3f806fd$export$db21c7ffa21794e7 = $bee8d86da3f806fd$var$useInsertionEffect || $bee8d86da3f806fd$var$syncFallback;
var $bee8d86da3f806fd$export$811a713a7276cb9d = $bee8d86da3f806fd$var$useInsertionEffect || $ld5Xm.useLayoutEffect;

});


parcelRegister("ajoJB", function(module, exports) {
function $781edd7c3281795d$var$_extends() {
    module.exports = $781edd7c3281795d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $781edd7c3281795d$var$_extends.apply(this, arguments);
}
module.exports = $781edd7c3281795d$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("bgmzV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8332b3f481ce7aee$export$2e2bcd8739ae039; });

var $kkzOL = parcelRequire("kkzOL");
"use client";
const $8332b3f481ce7aee$var$defaultTheme = (0, $kkzOL.default)();
var $8332b3f481ce7aee$export$2e2bcd8739ae039 = $8332b3f481ce7aee$var$defaultTheme;

});
parcelRegister("kkzOL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecd1759175e61d29$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $elHuP = parcelRequire("elHuP");

var $7rDXv = parcelRequire("7rDXv");

var $3YPxV = parcelRequire("3YPxV");
var $1OReq = parcelRequire("1OReq");

var $iwaPO = parcelRequire("iwaPO");


var $cHN9p = parcelRequire("cHN9p");

var $10y0x = parcelRequire("10y0x");

var $kCO7j = parcelRequire("kCO7j");

var $5wgBH = parcelRequire("5wgBH");

var $6sL1Q = parcelRequire("6sL1Q");

var $a5cGF = parcelRequire("a5cGF");
const $ecd1759175e61d29$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ecd1759175e61d29$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $2rDSW.default)(options, $ecd1759175e61d29$var$_excluded);
    if (options.vars) throw new Error((0, $elHuP.default)(18));
    const palette = (0, $10y0x.default)(paletteInput);
    const systemTheme = (0, $iwaPO.default)(options);
    let muiTheme = (0, $7rDXv.default)(systemTheme, {
        mixins: (0, $cHN9p.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $5wgBH.default).slice(),
        typography: (0, $kCO7j.default)(palette, typographyInput),
        transitions: (0, $6sL1Q.default)(transitionsInput),
        zIndex: (0, $ixQMS.default)({}, (0, $a5cGF.default))
    });
    muiTheme = (0, $7rDXv.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $7rDXv.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $ixQMS.default)({}, (0, $1OReq.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $3YPxV.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ecd1759175e61d29$var$warnedOnce = false;
function $ecd1759175e61d29$export$c469355549431d9b(...args) {
    return $ecd1759175e61d29$var$createTheme(...args);
}
var $ecd1759175e61d29$export$2e2bcd8739ae039 = $ecd1759175e61d29$var$createTheme;

});
parcelRegister("cHN9p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93ffa082ed4f6e05$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");
function $93ffa082ed4f6e05$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $ixQMS.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("10y0x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc02bb9e33b6b44$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $elHuP = parcelRequire("elHuP");

var $7rDXv = parcelRequire("7rDXv");

var $27ztC = parcelRequire("27ztC");

var $9tuDH = parcelRequire("9tuDH");

var $gwTIv = parcelRequire("gwTIv");

var $7OTk8 = parcelRequire("7OTk8");

var $bkYtl = parcelRequire("bkYtl");

var $ePaxh = parcelRequire("ePaxh");

var $97Bxy = parcelRequire("97Bxy");

var $H4Bjy = parcelRequire("H4Bjy");

var $cG0Y7 = parcelRequire("cG0Y7");
const $0bc02bb9e33b6b44$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $0bc02bb9e33b6b44$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $9tuDH.default).white,
        default: (0, $9tuDH.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $0bc02bb9e33b6b44$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $9tuDH.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $9tuDH.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $0bc02bb9e33b6b44$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $27ztC.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $27ztC.darken)(intent.main, tonalOffsetDark);
    }
}
function $0bc02bb9e33b6b44$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $97Bxy.default)[200],
        light: (0, $97Bxy.default)[50],
        dark: (0, $97Bxy.default)[400]
    };
    return {
        main: (0, $97Bxy.default)[700],
        light: (0, $97Bxy.default)[400],
        dark: (0, $97Bxy.default)[800]
    };
}
function $0bc02bb9e33b6b44$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7OTk8.default)[200],
        light: (0, $7OTk8.default)[50],
        dark: (0, $7OTk8.default)[400]
    };
    return {
        main: (0, $7OTk8.default)[500],
        light: (0, $7OTk8.default)[300],
        dark: (0, $7OTk8.default)[700]
    };
}
function $0bc02bb9e33b6b44$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $bkYtl.default)[500],
        light: (0, $bkYtl.default)[300],
        dark: (0, $bkYtl.default)[700]
    };
    return {
        main: (0, $bkYtl.default)[700],
        light: (0, $bkYtl.default)[400],
        dark: (0, $bkYtl.default)[800]
    };
}
function $0bc02bb9e33b6b44$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $H4Bjy.default)[400],
        light: (0, $H4Bjy.default)[300],
        dark: (0, $H4Bjy.default)[700]
    };
    return {
        main: (0, $H4Bjy.default)[700],
        light: (0, $H4Bjy.default)[500],
        dark: (0, $H4Bjy.default)[900]
    };
}
function $0bc02bb9e33b6b44$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $cG0Y7.default)[400],
        light: (0, $cG0Y7.default)[300],
        dark: (0, $cG0Y7.default)[700]
    };
    return {
        main: (0, $cG0Y7.default)[800],
        light: (0, $cG0Y7.default)[500],
        dark: (0, $cG0Y7.default)[900]
    };
}
function $0bc02bb9e33b6b44$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $ePaxh.default)[400],
        light: (0, $ePaxh.default)[300],
        dark: (0, $ePaxh.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $ePaxh.default)[500],
        dark: (0, $ePaxh.default)[900]
    };
}
function $0bc02bb9e33b6b44$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $2rDSW.default)(palette, $0bc02bb9e33b6b44$var$_excluded);
    const primary = palette.primary || $0bc02bb9e33b6b44$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $0bc02bb9e33b6b44$var$getDefaultSecondary(mode);
    const error = palette.error || $0bc02bb9e33b6b44$var$getDefaultError(mode);
    const info = palette.info || $0bc02bb9e33b6b44$var$getDefaultInfo(mode);
    const success = palette.success || $0bc02bb9e33b6b44$var$getDefaultSuccess(mode);
    const warning = palette.warning || $0bc02bb9e33b6b44$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $27ztC.getContrastRatio)(background, $0bc02bb9e33b6b44$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $0bc02bb9e33b6b44$export$55ce6f3a06c59543.text.primary : $0bc02bb9e33b6b44$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $ixQMS.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $elHuP.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $elHuP.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $0bc02bb9e33b6b44$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $0bc02bb9e33b6b44$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $0bc02bb9e33b6b44$export$55ce6f3a06c59543,
        light: $0bc02bb9e33b6b44$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $7rDXv.default)((0, $ixQMS.default)({
        // A collection of common colors.
        common: (0, $ixQMS.default)({}, (0, $9tuDH.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $gwTIv.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("27ztC", function(module, exports) {
"use strict";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $18b7c126a5c12e0b$var$alpha;
module.exports.blend = $18b7c126a5c12e0b$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $18b7c126a5c12e0b$var$darken;
module.exports.decomposeColor = $18b7c126a5c12e0b$var$decomposeColor;
module.exports.emphasize = $18b7c126a5c12e0b$var$emphasize;
module.exports.getContrastRatio = $18b7c126a5c12e0b$var$getContrastRatio;
module.exports.getLuminance = $18b7c126a5c12e0b$var$getLuminance;
module.exports.hexToRgb = $18b7c126a5c12e0b$var$hexToRgb;
module.exports.hslToRgb = $18b7c126a5c12e0b$var$hslToRgb;
module.exports.lighten = $18b7c126a5c12e0b$var$lighten;
module.exports.private_safeAlpha = $18b7c126a5c12e0b$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $18b7c126a5c12e0b$var$private_safeDarken;
module.exports.private_safeEmphasize = $18b7c126a5c12e0b$var$private_safeEmphasize;
module.exports.private_safeLighten = $18b7c126a5c12e0b$var$private_safeLighten;
module.exports.recomposeColor = $18b7c126a5c12e0b$var$recomposeColor;
module.exports.rgbToHex = $18b7c126a5c12e0b$var$rgbToHex;

var $18b7c126a5c12e0b$var$_formatMuiErrorMessage2 = $hkjon((parcelRequire("2qqXE")));

var $18b7c126a5c12e0b$var$_clamp = $hkjon((parcelRequire("4Zro3")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $18b7c126a5c12e0b$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $18b7c126a5c12e0b$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $18b7c126a5c12e0b$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $18b7c126a5c12e0b$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $18b7c126a5c12e0b$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $18b7c126a5c12e0b$var$decomposeColor($18b7c126a5c12e0b$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $18b7c126a5c12e0b$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $18b7c126a5c12e0b$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $18b7c126a5c12e0b$var$colorChannel = (color)=>{
    const decomposedColor = $18b7c126a5c12e0b$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $18b7c126a5c12e0b$var$colorChannel;
const $18b7c126a5c12e0b$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $18b7c126a5c12e0b$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $18b7c126a5c12e0b$var$private_safeColorChannel;
function $18b7c126a5c12e0b$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $18b7c126a5c12e0b$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $18b7c126a5c12e0b$var$decomposeColor(color);
    return `#${values.map((n, i)=>$18b7c126a5c12e0b$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $18b7c126a5c12e0b$var$hslToRgb(color) {
    color = $18b7c126a5c12e0b$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $18b7c126a5c12e0b$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $18b7c126a5c12e0b$var$getLuminance(color) {
    color = $18b7c126a5c12e0b$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $18b7c126a5c12e0b$var$decomposeColor($18b7c126a5c12e0b$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $18b7c126a5c12e0b$var$getContrastRatio(foreground, background) {
    const lumA = $18b7c126a5c12e0b$var$getLuminance(foreground);
    const lumB = $18b7c126a5c12e0b$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $18b7c126a5c12e0b$var$alpha(color, value) {
    color = $18b7c126a5c12e0b$var$decomposeColor(color);
    value = $18b7c126a5c12e0b$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $18b7c126a5c12e0b$var$recomposeColor(color);
}
function $18b7c126a5c12e0b$var$private_safeAlpha(color, value, warning) {
    try {
        return $18b7c126a5c12e0b$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $18b7c126a5c12e0b$var$darken(color, coefficient) {
    color = $18b7c126a5c12e0b$var$decomposeColor(color);
    coefficient = $18b7c126a5c12e0b$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $18b7c126a5c12e0b$var$recomposeColor(color);
}
function $18b7c126a5c12e0b$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $18b7c126a5c12e0b$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $18b7c126a5c12e0b$var$lighten(color, coefficient) {
    color = $18b7c126a5c12e0b$var$decomposeColor(color);
    coefficient = $18b7c126a5c12e0b$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $18b7c126a5c12e0b$var$recomposeColor(color);
}
function $18b7c126a5c12e0b$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $18b7c126a5c12e0b$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $18b7c126a5c12e0b$var$emphasize(color, coefficient = 0.15) {
    return $18b7c126a5c12e0b$var$getLuminance(color) > 0.5 ? $18b7c126a5c12e0b$var$darken(color, coefficient) : $18b7c126a5c12e0b$var$lighten(color, coefficient);
}
function $18b7c126a5c12e0b$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $18b7c126a5c12e0b$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $18b7c126a5c12e0b$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $18b7c126a5c12e0b$var$decomposeColor(background);
    const overlayColor = $18b7c126a5c12e0b$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $18b7c126a5c12e0b$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("hkjon", function(module, exports) {
function $c9d358cd9fd129a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $c9d358cd9fd129a8$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2qqXE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("elHuP")).default; });

var $elHuP = parcelRequire("elHuP");

});

parcelRegister("4Zro3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("dMiRR")).default; });

var $dMiRR = parcelRequire("dMiRR");

});
parcelRegister("dMiRR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a07e64ca3349cd01$export$2e2bcd8739ae039; });
function $a07e64ca3349cd01$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $a07e64ca3349cd01$export$2e2bcd8739ae039 = $a07e64ca3349cd01$var$clamp;

});



parcelRegister("9tuDH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e5e96d436db6a86$export$2e2bcd8739ae039; });
const $6e5e96d436db6a86$var$common = {
    black: "#000",
    white: "#fff"
};
var $6e5e96d436db6a86$export$2e2bcd8739ae039 = $6e5e96d436db6a86$var$common;

});

parcelRegister("gwTIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c08adaadb73474dc$export$2e2bcd8739ae039; });
const $c08adaadb73474dc$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $c08adaadb73474dc$export$2e2bcd8739ae039 = $c08adaadb73474dc$var$grey;

});

parcelRegister("7OTk8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b181e1129b49642$export$2e2bcd8739ae039; });
const $5b181e1129b49642$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $5b181e1129b49642$export$2e2bcd8739ae039 = $5b181e1129b49642$var$purple;

});

parcelRegister("bkYtl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8410788552900ebc$export$2e2bcd8739ae039; });
const $8410788552900ebc$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $8410788552900ebc$export$2e2bcd8739ae039 = $8410788552900ebc$var$red;

});

parcelRegister("ePaxh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acae004e8f488d75$export$2e2bcd8739ae039; });
const $acae004e8f488d75$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $acae004e8f488d75$export$2e2bcd8739ae039 = $acae004e8f488d75$var$orange;

});

parcelRegister("97Bxy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a41e338c79b2e06$export$2e2bcd8739ae039; });
const $6a41e338c79b2e06$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $6a41e338c79b2e06$export$2e2bcd8739ae039 = $6a41e338c79b2e06$var$blue;

});

parcelRegister("H4Bjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $081795e6393ff63f$export$2e2bcd8739ae039; });
const $081795e6393ff63f$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $081795e6393ff63f$export$2e2bcd8739ae039 = $081795e6393ff63f$var$lightBlue;

});

parcelRegister("cG0Y7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93aa28a66296b4f1$export$2e2bcd8739ae039; });
const $93aa28a66296b4f1$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $93aa28a66296b4f1$export$2e2bcd8739ae039 = $93aa28a66296b4f1$var$green;

});


parcelRegister("kCO7j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f03e3b73de9b6b65$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $7rDXv = parcelRequire("7rDXv");
const $f03e3b73de9b6b65$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $f03e3b73de9b6b65$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $f03e3b73de9b6b65$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $f03e3b73de9b6b65$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $f03e3b73de9b6b65$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $f03e3b73de9b6b65$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $2rDSW.default)(_ref, $f03e3b73de9b6b65$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $ixQMS.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $f03e3b73de9b6b65$var$defaultFontFamily ? {
            letterSpacing: `${$f03e3b73de9b6b65$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $f03e3b73de9b6b65$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $f03e3b73de9b6b65$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $7rDXv.default)((0, $ixQMS.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("5wgBH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $404cd2b9ff29a102$export$2e2bcd8739ae039; });
const $404cd2b9ff29a102$var$shadowKeyUmbraOpacity = 0.2;
const $404cd2b9ff29a102$var$shadowKeyPenumbraOpacity = 0.14;
const $404cd2b9ff29a102$var$shadowAmbientShadowOpacity = 0.12;
function $404cd2b9ff29a102$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$404cd2b9ff29a102$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$404cd2b9ff29a102$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$404cd2b9ff29a102$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $404cd2b9ff29a102$var$shadows = [
    "none",
    $404cd2b9ff29a102$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $404cd2b9ff29a102$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $404cd2b9ff29a102$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $404cd2b9ff29a102$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $404cd2b9ff29a102$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $404cd2b9ff29a102$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $404cd2b9ff29a102$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $404cd2b9ff29a102$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $404cd2b9ff29a102$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $404cd2b9ff29a102$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $404cd2b9ff29a102$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $404cd2b9ff29a102$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $404cd2b9ff29a102$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $404cd2b9ff29a102$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $404cd2b9ff29a102$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $404cd2b9ff29a102$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $404cd2b9ff29a102$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $404cd2b9ff29a102$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $404cd2b9ff29a102$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $404cd2b9ff29a102$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $404cd2b9ff29a102$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $404cd2b9ff29a102$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $404cd2b9ff29a102$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $404cd2b9ff29a102$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $404cd2b9ff29a102$export$2e2bcd8739ae039 = $404cd2b9ff29a102$var$shadows;

});

parcelRegister("6sL1Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b49d687becb3860$export$2e2bcd8739ae039; });

var $2rDSW = parcelRequire("2rDSW");

var $ixQMS = parcelRequire("ixQMS");
const $4b49d687becb3860$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $4b49d687becb3860$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $4b49d687becb3860$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $4b49d687becb3860$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $4b49d687becb3860$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $4b49d687becb3860$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $ixQMS.default)({}, $4b49d687becb3860$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $ixQMS.default)({}, $4b49d687becb3860$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $2rDSW.default)(options, $4b49d687becb3860$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $4b49d687becb3860$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $4b49d687becb3860$var$formatMs(delay)}`).join(",");
    };
    return (0, $ixQMS.default)({
        getAutoHeightDuration: $4b49d687becb3860$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("a5cGF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7574366f329fb6f1$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $7574366f329fb6f1$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $7574366f329fb6f1$export$2e2bcd8739ae039 = $7574366f329fb6f1$var$zIndex;

});



parcelRegister("f0pJw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aecad12b47b7440d$export$2e2bcd8739ae039; });
var $aecad12b47b7440d$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("al25i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $786d7b74b1c93f9c$export$2e2bcd8739ae039; });

var $3jQWa = parcelRequire("3jQWa");

var $bgmzV = parcelRequire("bgmzV");

var $f0pJw = parcelRequire("f0pJw");

var $3Wyf0 = parcelRequire("3Wyf0");

"use client";
const $786d7b74b1c93f9c$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($3jQWa)))({
    themeId: (0, $f0pJw.default),
    defaultTheme: $bgmzV.default,
    rootShouldForwardProp: $3Wyf0.default
});
var $786d7b74b1c93f9c$export$2e2bcd8739ae039 = $786d7b74b1c93f9c$var$styled;

});
parcelRegister("3jQWa", function(module, exports) {
"use strict";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $26ac35a763638401$var$createStyled;
module.exports.shouldForwardProp = $26ac35a763638401$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $26ac35a763638401$var$_extends2 = $hkjon((parcelRequire("ajoJB")));

var $26ac35a763638401$var$_objectWithoutPropertiesLoose2 = $hkjon((parcelRequire("eTmQY")));

var $26ac35a763638401$var$_styledEngine = $26ac35a763638401$var$_interopRequireWildcard((parcelRequire("3VYOz")));

var $7rDXv = parcelRequire("7rDXv");

var $26ac35a763638401$var$_capitalize = $hkjon((parcelRequire("69HFt")));

var $26ac35a763638401$var$_getDisplayName = $hkjon((parcelRequire("cvHVb")));

var $26ac35a763638401$var$_createTheme = $hkjon((parcelRequire("7Yudo")));

var $26ac35a763638401$var$_styleFunctionSx = $hkjon((parcelRequire("47F1V")));
const $26ac35a763638401$var$_excluded = [
    "ownerState"
], $26ac35a763638401$var$_excluded2 = [
    "variants"
], $26ac35a763638401$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $26ac35a763638401$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($26ac35a763638401$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $26ac35a763638401$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $26ac35a763638401$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $26ac35a763638401$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $26ac35a763638401$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $26ac35a763638401$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $26ac35a763638401$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $26ac35a763638401$var$_createTheme.default)();
const $26ac35a763638401$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $26ac35a763638401$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $26ac35a763638401$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $26ac35a763638401$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $26ac35a763638401$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $26ac35a763638401$var$_objectWithoutPropertiesLoose2.default)(_ref, $26ac35a763638401$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $26ac35a763638401$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$26ac35a763638401$var$processStyleArg(resolvedStyle, (0, $26ac35a763638401$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $26ac35a763638401$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $26ac35a763638401$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $26ac35a763638401$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $26ac35a763638401$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $26ac35a763638401$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $26ac35a763638401$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $26ac35a763638401$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $26ac35a763638401$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $26ac35a763638401$var$_styleFunctionSx.default)((0, $26ac35a763638401$var$_extends2.default)({}, props, {
            theme: $26ac35a763638401$var$resolveTheme((0, $26ac35a763638401$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $26ac35a763638401$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $26ac35a763638401$var$defaultOverridesResolver($26ac35a763638401$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $26ac35a763638401$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $26ac35a763638401$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $26ac35a763638401$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($26ac35a763638401$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $26ac35a763638401$var$_styledEngine.default)(tag, (0, $26ac35a763638401$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $7rDXv.isPlainObject)(stylesArg)) return (props)=>$26ac35a763638401$var$processStyleArg(stylesArg, (0, $26ac35a763638401$var$_extends2.default)({}, props, {
                    theme: $26ac35a763638401$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $26ac35a763638401$var$resolveTheme((0, $26ac35a763638401$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $26ac35a763638401$var$processStyleArg(slotStyle, (0, $26ac35a763638401$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $26ac35a763638401$var$resolveTheme((0, $26ac35a763638401$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $26ac35a763638401$var$processStyleArg({
                    variants: themeVariants
                }, (0, $26ac35a763638401$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("eTmQY", function(module, exports) {
function $ad77edf46da9ea39$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $ad77edf46da9ea39$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3VYOz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2dd5de7e70c6bf4c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $2dd5de7e70c6bf4c$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("eySkF")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("2FbfX")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("2FbfX")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("5azed")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("9pETW")).default; });
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $47S6T = parcelRequire("47S6T");

var $2FbfX = parcelRequire("2FbfX");
var $eySkF = parcelRequire("eySkF");

var $5azed = parcelRequire("5azed");

var $9pETW = parcelRequire("9pETW");
"use client";
function $2dd5de7e70c6bf4c$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $47S6T.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $2dd5de7e70c6bf4c$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("47S6T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3011ca0476e9260f$export$2e2bcd8739ae039; });

var $gP6WM = parcelRequire("gP6WM");
parcelRequire("ajoJB");
parcelRequire("ld5Xm");
parcelRequire("jDGYq");

parcelRequire("iuZ9D");
parcelRequire("1gGLZ");
parcelRequire("gocPY");
var $3011ca0476e9260f$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $3011ca0476e9260f$export$2e2bcd8739ae039 = (0, $gP6WM.default).bind();
$3011ca0476e9260f$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $3011ca0476e9260f$export$2e2bcd8739ae039[tagName] = $3011ca0476e9260f$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("gP6WM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3f6cc51a755097a$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $ld5Xm = parcelRequire("ld5Xm");

var $jDGYq = parcelRequire("jDGYq");
parcelRequire("2FbfX");
var $eySkF = parcelRequire("eySkF");

var $iuZ9D = parcelRequire("iuZ9D");

var $1gGLZ = parcelRequire("1gGLZ");

var $gocPY = parcelRequire("gocPY");
var $c3f6cc51a755097a$var$testOmitPropsOnStringTag = (0, $jDGYq.default);
var $c3f6cc51a755097a$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $c3f6cc51a755097a$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $c3f6cc51a755097a$var$testOmitPropsOnStringTag : $c3f6cc51a755097a$var$testOmitPropsOnComponent;
};
var $c3f6cc51a755097a$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $c3f6cc51a755097a$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $c3f6cc51a755097a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $iuZ9D.registerStyles)(cache, serialized, isStringTag);
    (0, $gocPY.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $iuZ9D.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $c3f6cc51a755097a$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $c3f6cc51a755097a$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $c3f6cc51a755097a$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $eySkF.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $ld5Xm.useContext((0, $eySkF.T));
            }
            if (typeof props.className === "string") className = (0, $iuZ9D.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $1gGLZ.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $c3f6cc51a755097a$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $ld5Xm.createElement($ld5Xm.Fragment, null, /*#__PURE__*/ $ld5Xm.createElement($c3f6cc51a755097a$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $ld5Xm.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $ixQMS.default)({}, options, nextOptions, {
                shouldForwardProp: $c3f6cc51a755097a$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("jDGYq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4c2fe85619dacc5$export$2e2bcd8739ae039; });

var $iKjya = parcelRequire("iKjya");
var $e4c2fe85619dacc5$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e4c2fe85619dacc5$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $iKjya.default)(function(prop) {
    return $e4c2fe85619dacc5$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("5azed", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c39368298fc5f67$export$2e2bcd8739ae039; });
parcelRequire("ld5Xm");


var $eySkF = parcelRequire("eySkF");

var $6ke6O = parcelRequire("6ke6O");

var $2WrlN = parcelRequire("2WrlN");
"use client";
let $3c39368298fc5f67$var$cache;
if (typeof document === "object") $3c39368298fc5f67$var$cache = (0, $6ke6O.default)({
    key: "css",
    prepend: true
});
function $3c39368298fc5f67$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $3c39368298fc5f67$var$cache ? /*#__PURE__*/ (0, $2WrlN.jsx)((0, $eySkF.C), {
        value: $3c39368298fc5f67$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("2WrlN", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9t6Kl"));

});


parcelRegister("9pETW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6da62cff2262d841$export$2e2bcd8739ae039; });
parcelRequire("ld5Xm");


var $2FbfX = parcelRequire("2FbfX");

var $2WrlN = parcelRequire("2WrlN");
"use client";
function $6da62cff2262d841$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $6da62cff2262d841$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($6da62cff2262d841$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $2WrlN.jsx)((0, $2FbfX.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("69HFt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6i6gU")).default; });

var $6i6gU = parcelRequire("6i6gU");

});

parcelRegister("cvHVb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9iX9S")).default; });

var $9iX9S = parcelRequire("9iX9S");
$parcel$exportWildcard(module.exports, $9iX9S);

});
parcelRegister("9iX9S", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $6c63af1e4e53eab3$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $6c63af1e4e53eab3$export$2e2bcd8739ae039; });

var $4gTN5 = parcelRequire("4gTN5");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $6c63af1e4e53eab3$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $6c63af1e4e53eab3$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($6c63af1e4e53eab3$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $6c63af1e4e53eab3$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $6c63af1e4e53eab3$export$aad197c7121a6651(Component) || fallback;
}
function $6c63af1e4e53eab3$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $6c63af1e4e53eab3$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $6c63af1e4e53eab3$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $6c63af1e4e53eab3$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $4gTN5.ForwardRef:
            return $6c63af1e4e53eab3$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $4gTN5.Memo:
            return $6c63af1e4e53eab3$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("4gTN5", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1xcNC"));

});
parcelRegister("1xcNC", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $11e2cd34df9a9b67$export$a7c73072b1a182ae; }, function (v) { return $11e2cd34df9a9b67$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $11e2cd34df9a9b67$export$9f27bc3417b4524d; }, function (v) { return $11e2cd34df9a9b67$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $11e2cd34df9a9b67$export$db77ccec0bb4ccac; }, function (v) { return $11e2cd34df9a9b67$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $11e2cd34df9a9b67$export$8392c0c9d3dcbd35; }, function (v) { return $11e2cd34df9a9b67$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $11e2cd34df9a9b67$export$ffb0004e005737fa; }, function (v) { return $11e2cd34df9a9b67$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $11e2cd34df9a9b67$export$b624eff549462981; }, function (v) { return $11e2cd34df9a9b67$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $11e2cd34df9a9b67$export$7897aa7841a5380c; }, function (v) { return $11e2cd34df9a9b67$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $11e2cd34df9a9b67$export$602eac185826482c; }, function (v) { return $11e2cd34df9a9b67$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $11e2cd34df9a9b67$export$e2c29f18771995cb; }, function (v) { return $11e2cd34df9a9b67$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $11e2cd34df9a9b67$export$5f8d39834fd61797; }, function (v) { return $11e2cd34df9a9b67$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $11e2cd34df9a9b67$export$74bf444e3cd11ea5; }, function (v) { return $11e2cd34df9a9b67$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $11e2cd34df9a9b67$export$998bcd577473dd93; }, function (v) { return $11e2cd34df9a9b67$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $11e2cd34df9a9b67$export$92387174baf9b227; }, function (v) { return $11e2cd34df9a9b67$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $11e2cd34df9a9b67$export$ec112efeb987d9c6; }, function (v) { return $11e2cd34df9a9b67$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $11e2cd34df9a9b67$export$b706b080d889d2c9; }, function (v) { return $11e2cd34df9a9b67$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $11e2cd34df9a9b67$export$5be5a87408f70ddc; }, function (v) { return $11e2cd34df9a9b67$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $11e2cd34df9a9b67$export$45a5e7f76e0caa8d; }, function (v) { return $11e2cd34df9a9b67$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $11e2cd34df9a9b67$export$455c2e768291efa6; }, function (v) { return $11e2cd34df9a9b67$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $11e2cd34df9a9b67$export$9522e17588c12572; }, function (v) { return $11e2cd34df9a9b67$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $11e2cd34df9a9b67$export$2110ac352bb060b9; }, function (v) { return $11e2cd34df9a9b67$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $11e2cd34df9a9b67$export$56885ab8b9c456ab; }, function (v) { return $11e2cd34df9a9b67$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $11e2cd34df9a9b67$export$d927fcb6adf8f9de; }, function (v) { return $11e2cd34df9a9b67$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $11e2cd34df9a9b67$export$b82d16f27459e05a; }, function (v) { return $11e2cd34df9a9b67$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $11e2cd34df9a9b67$export$522c17b4f5e123e8; }, function (v) { return $11e2cd34df9a9b67$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $11e2cd34df9a9b67$export$1aabd8a0274ecfd6; }, function (v) { return $11e2cd34df9a9b67$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $11e2cd34df9a9b67$export$3d6c20d97e46b957; }, function (v) { return $11e2cd34df9a9b67$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $11e2cd34df9a9b67$export$9b621391a187a31a; }, function (v) { return $11e2cd34df9a9b67$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $11e2cd34df9a9b67$export$f5bbd400c2f4426f; }, function (v) { return $11e2cd34df9a9b67$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11e2cd34df9a9b67$export$a7c73072b1a182ae;
var $11e2cd34df9a9b67$export$9f27bc3417b4524d;
var $11e2cd34df9a9b67$export$db77ccec0bb4ccac;
var $11e2cd34df9a9b67$export$8392c0c9d3dcbd35;
var $11e2cd34df9a9b67$export$ffb0004e005737fa;
var $11e2cd34df9a9b67$export$b624eff549462981;
var $11e2cd34df9a9b67$export$7897aa7841a5380c;
var $11e2cd34df9a9b67$export$602eac185826482c;
var $11e2cd34df9a9b67$export$e2c29f18771995cb;
var $11e2cd34df9a9b67$export$5f8d39834fd61797;
var $11e2cd34df9a9b67$export$74bf444e3cd11ea5;
var $11e2cd34df9a9b67$export$998bcd577473dd93;
var $11e2cd34df9a9b67$export$92387174baf9b227;
var $11e2cd34df9a9b67$export$ec112efeb987d9c6;
var $11e2cd34df9a9b67$export$b706b080d889d2c9;
var $11e2cd34df9a9b67$export$5be5a87408f70ddc;
var $11e2cd34df9a9b67$export$45a5e7f76e0caa8d;
var $11e2cd34df9a9b67$export$455c2e768291efa6;
var $11e2cd34df9a9b67$export$9522e17588c12572;
var $11e2cd34df9a9b67$export$2110ac352bb060b9;
var $11e2cd34df9a9b67$export$56885ab8b9c456ab;
var $11e2cd34df9a9b67$export$d927fcb6adf8f9de;
var $11e2cd34df9a9b67$export$b82d16f27459e05a;
var $11e2cd34df9a9b67$export$522c17b4f5e123e8;
var $11e2cd34df9a9b67$export$1aabd8a0274ecfd6;
var $11e2cd34df9a9b67$export$3d6c20d97e46b957;
var $11e2cd34df9a9b67$export$9b621391a187a31a;
var $11e2cd34df9a9b67$export$f5bbd400c2f4426f;
"use strict";
var $11e2cd34df9a9b67$var$b = Symbol.for("react.element"), $11e2cd34df9a9b67$var$c = Symbol.for("react.portal"), $11e2cd34df9a9b67$var$d = Symbol.for("react.fragment"), $11e2cd34df9a9b67$var$e = Symbol.for("react.strict_mode"), $11e2cd34df9a9b67$var$f = Symbol.for("react.profiler"), $11e2cd34df9a9b67$var$g = Symbol.for("react.provider"), $11e2cd34df9a9b67$var$h = Symbol.for("react.context"), $11e2cd34df9a9b67$var$k = Symbol.for("react.server_context"), $11e2cd34df9a9b67$var$l = Symbol.for("react.forward_ref"), $11e2cd34df9a9b67$var$m = Symbol.for("react.suspense"), $11e2cd34df9a9b67$var$n = Symbol.for("react.suspense_list"), $11e2cd34df9a9b67$var$p = Symbol.for("react.memo"), $11e2cd34df9a9b67$var$q = Symbol.for("react.lazy"), $11e2cd34df9a9b67$var$t = Symbol.for("react.offscreen"), $11e2cd34df9a9b67$var$u;
$11e2cd34df9a9b67$var$u = Symbol.for("react.module.reference");
function $11e2cd34df9a9b67$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $11e2cd34df9a9b67$var$b:
                switch(a = a.type, a){
                    case $11e2cd34df9a9b67$var$d:
                    case $11e2cd34df9a9b67$var$f:
                    case $11e2cd34df9a9b67$var$e:
                    case $11e2cd34df9a9b67$var$m:
                    case $11e2cd34df9a9b67$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $11e2cd34df9a9b67$var$k:
                            case $11e2cd34df9a9b67$var$h:
                            case $11e2cd34df9a9b67$var$l:
                            case $11e2cd34df9a9b67$var$q:
                            case $11e2cd34df9a9b67$var$p:
                            case $11e2cd34df9a9b67$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $11e2cd34df9a9b67$var$c:
                return r;
        }
    }
}
$11e2cd34df9a9b67$export$a7c73072b1a182ae = $11e2cd34df9a9b67$var$h;
$11e2cd34df9a9b67$export$9f27bc3417b4524d = $11e2cd34df9a9b67$var$g;
$11e2cd34df9a9b67$export$db77ccec0bb4ccac = $11e2cd34df9a9b67$var$b;
$11e2cd34df9a9b67$export$8392c0c9d3dcbd35 = $11e2cd34df9a9b67$var$l;
$11e2cd34df9a9b67$export$ffb0004e005737fa = $11e2cd34df9a9b67$var$d;
$11e2cd34df9a9b67$export$b624eff549462981 = $11e2cd34df9a9b67$var$q;
$11e2cd34df9a9b67$export$7897aa7841a5380c = $11e2cd34df9a9b67$var$p;
$11e2cd34df9a9b67$export$602eac185826482c = $11e2cd34df9a9b67$var$c;
$11e2cd34df9a9b67$export$e2c29f18771995cb = $11e2cd34df9a9b67$var$f;
$11e2cd34df9a9b67$export$5f8d39834fd61797 = $11e2cd34df9a9b67$var$e;
$11e2cd34df9a9b67$export$74bf444e3cd11ea5 = $11e2cd34df9a9b67$var$m;
$11e2cd34df9a9b67$export$998bcd577473dd93 = $11e2cd34df9a9b67$var$n;
$11e2cd34df9a9b67$export$92387174baf9b227 = function() {
    return !1;
};
$11e2cd34df9a9b67$export$ec112efeb987d9c6 = function() {
    return !1;
};
$11e2cd34df9a9b67$export$b706b080d889d2c9 = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$h;
};
$11e2cd34df9a9b67$export$5be5a87408f70ddc = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$g;
};
$11e2cd34df9a9b67$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $11e2cd34df9a9b67$var$b;
};
$11e2cd34df9a9b67$export$455c2e768291efa6 = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$l;
};
$11e2cd34df9a9b67$export$9522e17588c12572 = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$d;
};
$11e2cd34df9a9b67$export$2110ac352bb060b9 = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$q;
};
$11e2cd34df9a9b67$export$56885ab8b9c456ab = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$p;
};
$11e2cd34df9a9b67$export$d927fcb6adf8f9de = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$c;
};
$11e2cd34df9a9b67$export$b82d16f27459e05a = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$f;
};
$11e2cd34df9a9b67$export$522c17b4f5e123e8 = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$e;
};
$11e2cd34df9a9b67$export$1aabd8a0274ecfd6 = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$m;
};
$11e2cd34df9a9b67$export$3d6c20d97e46b957 = function(a) {
    return $11e2cd34df9a9b67$var$v(a) === $11e2cd34df9a9b67$var$n;
};
$11e2cd34df9a9b67$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $11e2cd34df9a9b67$var$d || a === $11e2cd34df9a9b67$var$f || a === $11e2cd34df9a9b67$var$e || a === $11e2cd34df9a9b67$var$m || a === $11e2cd34df9a9b67$var$n || a === $11e2cd34df9a9b67$var$t || "object" === typeof a && null !== a && (a.$$typeof === $11e2cd34df9a9b67$var$q || a.$$typeof === $11e2cd34df9a9b67$var$p || a.$$typeof === $11e2cd34df9a9b67$var$g || a.$$typeof === $11e2cd34df9a9b67$var$h || a.$$typeof === $11e2cd34df9a9b67$var$l || a.$$typeof === $11e2cd34df9a9b67$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$11e2cd34df9a9b67$export$f5bbd400c2f4426f = $11e2cd34df9a9b67$var$v;

});




parcelRegister("7Yudo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("iwaPO")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("9rFgJ")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("hwD0B")).default; });

var $iwaPO = parcelRequire("iwaPO");

var $9rFgJ = parcelRequire("9rFgJ");

var $hwD0B = parcelRequire("hwD0B");

});

parcelRegister("47F1V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3YPxV")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("3YPxV")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("2xBLE")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("1OReq")).default; });

var $3YPxV = parcelRequire("3YPxV");

var $2xBLE = parcelRequire("2xBLE");

var $1OReq = parcelRequire("1OReq");

});
parcelRegister("2xBLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d9bf5affd940d3b$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $7rDXv = parcelRequire("7rDXv");

var $1OReq = parcelRequire("1OReq");
const $1d9bf5affd940d3b$var$_excluded = [
    "sx"
];
const $1d9bf5affd940d3b$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $1OReq.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $1d9bf5affd940d3b$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $2rDSW.default)(props, $1d9bf5affd940d3b$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $1d9bf5affd940d3b$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $7rDXv.isPlainObject)(result)) return systemProps;
        return (0, $ixQMS.default)({}, systemProps, result);
    };
    else finalSx = (0, $ixQMS.default)({}, systemProps, inSx);
    return (0, $ixQMS.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("3Wyf0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2df1596bcf5d669f$export$2e2bcd8739ae039; });

var $7jveN = parcelRequire("7jveN");
const $2df1596bcf5d669f$var$rootShouldForwardProp = (prop)=>(0, $7jveN.default)(prop) && prop !== "classes";
var $2df1596bcf5d669f$export$2e2bcd8739ae039 = $2df1596bcf5d669f$var$rootShouldForwardProp;

});
parcelRegister("7jveN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $553289e3ade30260$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $553289e3ade30260$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $553289e3ade30260$export$2e2bcd8739ae039 = $553289e3ade30260$var$slotShouldForwardProp;

});



parcelRegister("2WroH", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $2246401f1823a0ff$export$c7c50641356bdfa5; });

var $7Kfdo = parcelRequire("7Kfdo");

var $jOBMM = parcelRequire("jOBMM");
function $2246401f1823a0ff$export$c7c50641356bdfa5(slot) {
    return (0, $jOBMM.default)("MuiSvgIcon", slot);
}
const $2246401f1823a0ff$var$svgIconClasses = (0, $7Kfdo.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $2246401f1823a0ff$export$2e2bcd8739ae039 = $2246401f1823a0ff$var$svgIconClasses;

});
parcelRegister("7Kfdo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a38a1a50238231b$export$2e2bcd8739ae039; });

var $jOBMM = parcelRequire("jOBMM");
function $5a38a1a50238231b$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $jOBMM.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("jOBMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6cfff533b53c5fe$export$2e2bcd8739ae039; });

var $gBfqO = parcelRequire("gBfqO");
const $e6cfff533b53c5fe$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $e6cfff533b53c5fe$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $e6cfff533b53c5fe$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $gBfqO.default).generate(componentName)}-${slot}`;
}
function $e6cfff533b53c5fe$export$34c0130b1f3e8ae3(slot) {
    return $e6cfff533b53c5fe$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("gBfqO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c15c12634fd1ff93$export$2e2bcd8739ae039; });
const $c15c12634fd1ff93$var$defaultGenerator = (componentName)=>componentName;
const $c15c12634fd1ff93$var$createClassNameGenerator = ()=>{
    let generate = $c15c12634fd1ff93$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $c15c12634fd1ff93$var$defaultGenerator;
        }
    };
};
const $c15c12634fd1ff93$var$ClassNameGenerator = $c15c12634fd1ff93$var$createClassNameGenerator();
var $c15c12634fd1ff93$export$2e2bcd8739ae039 = $c15c12634fd1ff93$var$ClassNameGenerator;

});







parcelRegister("kYoAx", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cW2ig.default;
    }
});

var $cW2ig = parcelRequire("cW2ig");

});
parcelRegister("cW2ig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96acae4547de847d$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $ld5Xm = parcelRequire("ld5Xm");

var $csE1p = parcelRequire("csE1p");

var $2WrlN = parcelRequire("2WrlN");
"use client";
function $96acae4547de847d$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $2WrlN.jsx)((0, $csE1p.default), (0, $ixQMS.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $csE1p.default).muiName;
    return /*#__PURE__*/ $ld5Xm.memo(/*#__PURE__*/ $ld5Xm.forwardRef(Component));
}

});
parcelRegister("csE1p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91272509524497e4$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $ld5Xm = parcelRequire("ld5Xm");


var $HtKrm = parcelRequire("HtKrm");

var $kp4xz = parcelRequire("kp4xz");

var $7HsOM = parcelRequire("7HsOM");

var $bTFeP = parcelRequire("bTFeP");

var $2Zehi = parcelRequire("2Zehi");

var $l9FXd = parcelRequire("l9FXd");

var $2WrlN = parcelRequire("2WrlN");
"use client";
const $91272509524497e4$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $91272509524497e4$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $7HsOM.default)(color)}`,
            `fontSize${(0, $7HsOM.default)(fontSize)}`
        ]
    };
    return (0, $kp4xz.default)(slots, (0, $l9FXd.getSvgIconUtilityClass), classes);
};
const $91272509524497e4$var$SvgIconRoot = (0, $2Zehi.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $7HsOM.default)(ownerState.color)}`],
            styles[`fontSize${(0, $7HsOM.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $91272509524497e4$var$SvgIcon = /*#__PURE__*/ $ld5Xm.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $bTFeP.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $2rDSW.default)(props, $91272509524497e4$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $ld5Xm.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $ixQMS.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $91272509524497e4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $2WrlN.jsxs)($91272509524497e4$var$SvgIconRoot, (0, $ixQMS.default)({
        as: component,
        className: (0, $HtKrm.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $2WrlN.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$91272509524497e4$var$SvgIcon.muiName = "SvgIcon";
var $91272509524497e4$export$2e2bcd8739ae039 = $91272509524497e4$var$SvgIcon;

});
parcelRegister("7HsOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59b2e7377495f75e$export$2e2bcd8739ae039; });

var $6i6gU = parcelRequire("6i6gU");
var $59b2e7377495f75e$export$2e2bcd8739ae039 = (0, $6i6gU.default);

});

parcelRegister("bTFeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a94d1c9cdf0b80a$export$2e2bcd8739ae039; });

var $9Qeza = parcelRequire("9Qeza");

var $VZKDD = parcelRequire("VZKDD");

var $1xQ98 = parcelRequire("1xQ98");
"use client";
function $8a94d1c9cdf0b80a$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $9Qeza.default)({
        props: props,
        name: name,
        defaultTheme: $VZKDD.default,
        themeId: (0, $1xQ98.default)
    });
}

});
parcelRegister("VZKDD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ae5397e763813cd$export$2e2bcd8739ae039; });

var $ko1Dy = parcelRequire("ko1Dy");
"use client";
const $0ae5397e763813cd$var$defaultTheme = (0, $ko1Dy.default)();
var $0ae5397e763813cd$export$2e2bcd8739ae039 = $0ae5397e763813cd$var$defaultTheme;

});
parcelRegister("ko1Dy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed7751a093dd2980$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $elHuP = parcelRequire("elHuP");

var $7rDXv = parcelRequire("7rDXv");

var $3YPxV = parcelRequire("3YPxV");
var $1OReq = parcelRequire("1OReq");

var $iwaPO = parcelRequire("iwaPO");


var $iOEP4 = parcelRequire("iOEP4");

var $jfF9S = parcelRequire("jfF9S");

var $5fk23 = parcelRequire("5fk23");

var $hWZib = parcelRequire("hWZib");

var $gMNyA = parcelRequire("gMNyA");

var $kOGOF = parcelRequire("kOGOF");
const $ed7751a093dd2980$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ed7751a093dd2980$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $2rDSW.default)(options, $ed7751a093dd2980$var$_excluded);
    if (options.vars) throw new Error((0, $elHuP.default)(18));
    const palette = (0, $jfF9S.default)(paletteInput);
    const systemTheme = (0, $iwaPO.default)(options);
    let muiTheme = (0, $7rDXv.default)(systemTheme, {
        mixins: (0, $iOEP4.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $hWZib.default).slice(),
        typography: (0, $5fk23.default)(palette, typographyInput),
        transitions: (0, $gMNyA.default)(transitionsInput),
        zIndex: (0, $ixQMS.default)({}, (0, $kOGOF.default))
    });
    muiTheme = (0, $7rDXv.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $7rDXv.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $ixQMS.default)({}, (0, $1OReq.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $3YPxV.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ed7751a093dd2980$var$warnedOnce = false;
function $ed7751a093dd2980$export$c469355549431d9b(...args) {
    return $ed7751a093dd2980$var$createTheme(...args);
}
var $ed7751a093dd2980$export$2e2bcd8739ae039 = $ed7751a093dd2980$var$createTheme;

});
parcelRegister("iOEP4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db2c90060cdd4924$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");
function $db2c90060cdd4924$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $ixQMS.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("jfF9S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e03f583b2b73c4fb$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $elHuP = parcelRequire("elHuP");

var $7rDXv = parcelRequire("7rDXv");

var $27ztC = parcelRequire("27ztC");

var $khlaK = parcelRequire("khlaK");

var $5q2Av = parcelRequire("5q2Av");

var $aiNNo = parcelRequire("aiNNo");

var $szShs = parcelRequire("szShs");

var $2YDi5 = parcelRequire("2YDi5");

var $inlbj = parcelRequire("inlbj");

var $dfigl = parcelRequire("dfigl");

var $a8a83 = parcelRequire("a8a83");
const $e03f583b2b73c4fb$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $e03f583b2b73c4fb$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $khlaK.default).white,
        default: (0, $khlaK.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $e03f583b2b73c4fb$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $khlaK.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $khlaK.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $e03f583b2b73c4fb$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $27ztC.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $27ztC.darken)(intent.main, tonalOffsetDark);
    }
}
function $e03f583b2b73c4fb$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $inlbj.default)[200],
        light: (0, $inlbj.default)[50],
        dark: (0, $inlbj.default)[400]
    };
    return {
        main: (0, $inlbj.default)[700],
        light: (0, $inlbj.default)[400],
        dark: (0, $inlbj.default)[800]
    };
}
function $e03f583b2b73c4fb$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $aiNNo.default)[200],
        light: (0, $aiNNo.default)[50],
        dark: (0, $aiNNo.default)[400]
    };
    return {
        main: (0, $aiNNo.default)[500],
        light: (0, $aiNNo.default)[300],
        dark: (0, $aiNNo.default)[700]
    };
}
function $e03f583b2b73c4fb$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $szShs.default)[500],
        light: (0, $szShs.default)[300],
        dark: (0, $szShs.default)[700]
    };
    return {
        main: (0, $szShs.default)[700],
        light: (0, $szShs.default)[400],
        dark: (0, $szShs.default)[800]
    };
}
function $e03f583b2b73c4fb$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $dfigl.default)[400],
        light: (0, $dfigl.default)[300],
        dark: (0, $dfigl.default)[700]
    };
    return {
        main: (0, $dfigl.default)[700],
        light: (0, $dfigl.default)[500],
        dark: (0, $dfigl.default)[900]
    };
}
function $e03f583b2b73c4fb$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $a8a83.default)[400],
        light: (0, $a8a83.default)[300],
        dark: (0, $a8a83.default)[700]
    };
    return {
        main: (0, $a8a83.default)[800],
        light: (0, $a8a83.default)[500],
        dark: (0, $a8a83.default)[900]
    };
}
function $e03f583b2b73c4fb$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $2YDi5.default)[400],
        light: (0, $2YDi5.default)[300],
        dark: (0, $2YDi5.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $2YDi5.default)[500],
        dark: (0, $2YDi5.default)[900]
    };
}
function $e03f583b2b73c4fb$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $2rDSW.default)(palette, $e03f583b2b73c4fb$var$_excluded);
    const primary = palette.primary || $e03f583b2b73c4fb$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $e03f583b2b73c4fb$var$getDefaultSecondary(mode);
    const error = palette.error || $e03f583b2b73c4fb$var$getDefaultError(mode);
    const info = palette.info || $e03f583b2b73c4fb$var$getDefaultInfo(mode);
    const success = palette.success || $e03f583b2b73c4fb$var$getDefaultSuccess(mode);
    const warning = palette.warning || $e03f583b2b73c4fb$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $27ztC.getContrastRatio)(background, $e03f583b2b73c4fb$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $e03f583b2b73c4fb$export$55ce6f3a06c59543.text.primary : $e03f583b2b73c4fb$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $ixQMS.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $elHuP.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $elHuP.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $e03f583b2b73c4fb$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $e03f583b2b73c4fb$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $e03f583b2b73c4fb$export$55ce6f3a06c59543,
        light: $e03f583b2b73c4fb$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $7rDXv.default)((0, $ixQMS.default)({
        // A collection of common colors.
        common: (0, $ixQMS.default)({}, (0, $khlaK.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $5q2Av.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("khlaK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec35d19636051228$export$2e2bcd8739ae039; });
const $ec35d19636051228$var$common = {
    black: "#000",
    white: "#fff"
};
var $ec35d19636051228$export$2e2bcd8739ae039 = $ec35d19636051228$var$common;

});

parcelRegister("5q2Av", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f216358499c2778$export$2e2bcd8739ae039; });
const $3f216358499c2778$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $3f216358499c2778$export$2e2bcd8739ae039 = $3f216358499c2778$var$grey;

});

parcelRegister("aiNNo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $780236357b6172a7$export$2e2bcd8739ae039; });
const $780236357b6172a7$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $780236357b6172a7$export$2e2bcd8739ae039 = $780236357b6172a7$var$purple;

});

parcelRegister("szShs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $055e719105d233f9$export$2e2bcd8739ae039; });
const $055e719105d233f9$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $055e719105d233f9$export$2e2bcd8739ae039 = $055e719105d233f9$var$red;

});

parcelRegister("2YDi5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22afa9b3696c251b$export$2e2bcd8739ae039; });
const $22afa9b3696c251b$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $22afa9b3696c251b$export$2e2bcd8739ae039 = $22afa9b3696c251b$var$orange;

});

parcelRegister("inlbj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d60ace32394cc2ed$export$2e2bcd8739ae039; });
const $d60ace32394cc2ed$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $d60ace32394cc2ed$export$2e2bcd8739ae039 = $d60ace32394cc2ed$var$blue;

});

parcelRegister("dfigl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a4ad7a3e971ce46$export$2e2bcd8739ae039; });
const $9a4ad7a3e971ce46$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $9a4ad7a3e971ce46$export$2e2bcd8739ae039 = $9a4ad7a3e971ce46$var$lightBlue;

});

parcelRegister("a8a83", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7602821c91d4c228$export$2e2bcd8739ae039; });
const $7602821c91d4c228$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $7602821c91d4c228$export$2e2bcd8739ae039 = $7602821c91d4c228$var$green;

});


parcelRegister("5fk23", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d1de46bd4d11f63$export$2e2bcd8739ae039; });

var $ixQMS = parcelRequire("ixQMS");

var $2rDSW = parcelRequire("2rDSW");

var $7rDXv = parcelRequire("7rDXv");
const $3d1de46bd4d11f63$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $3d1de46bd4d11f63$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $3d1de46bd4d11f63$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $3d1de46bd4d11f63$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $3d1de46bd4d11f63$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $3d1de46bd4d11f63$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $2rDSW.default)(_ref, $3d1de46bd4d11f63$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $ixQMS.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $3d1de46bd4d11f63$var$defaultFontFamily ? {
            letterSpacing: `${$3d1de46bd4d11f63$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $3d1de46bd4d11f63$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $3d1de46bd4d11f63$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $7rDXv.default)((0, $ixQMS.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("hWZib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d11765d0e06c1642$export$2e2bcd8739ae039; });
const $d11765d0e06c1642$var$shadowKeyUmbraOpacity = 0.2;
const $d11765d0e06c1642$var$shadowKeyPenumbraOpacity = 0.14;
const $d11765d0e06c1642$var$shadowAmbientShadowOpacity = 0.12;
function $d11765d0e06c1642$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$d11765d0e06c1642$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$d11765d0e06c1642$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$d11765d0e06c1642$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $d11765d0e06c1642$var$shadows = [
    "none",
    $d11765d0e06c1642$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $d11765d0e06c1642$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $d11765d0e06c1642$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $d11765d0e06c1642$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $d11765d0e06c1642$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $d11765d0e06c1642$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $d11765d0e06c1642$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $d11765d0e06c1642$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $d11765d0e06c1642$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $d11765d0e06c1642$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $d11765d0e06c1642$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $d11765d0e06c1642$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $d11765d0e06c1642$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $d11765d0e06c1642$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $d11765d0e06c1642$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $d11765d0e06c1642$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $d11765d0e06c1642$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $d11765d0e06c1642$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $d11765d0e06c1642$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $d11765d0e06c1642$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $d11765d0e06c1642$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $d11765d0e06c1642$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $d11765d0e06c1642$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $d11765d0e06c1642$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $d11765d0e06c1642$export$2e2bcd8739ae039 = $d11765d0e06c1642$var$shadows;

});

parcelRegister("gMNyA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c38791f85f862198$export$2e2bcd8739ae039; });

var $2rDSW = parcelRequire("2rDSW");

var $ixQMS = parcelRequire("ixQMS");
const $c38791f85f862198$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $c38791f85f862198$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $c38791f85f862198$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $c38791f85f862198$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $c38791f85f862198$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $c38791f85f862198$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $ixQMS.default)({}, $c38791f85f862198$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $ixQMS.default)({}, $c38791f85f862198$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $2rDSW.default)(options, $c38791f85f862198$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $c38791f85f862198$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $c38791f85f862198$var$formatMs(delay)}`).join(",");
    };
    return (0, $ixQMS.default)({
        getAutoHeightDuration: $c38791f85f862198$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("kOGOF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f279b09520489801$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f279b09520489801$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f279b09520489801$export$2e2bcd8739ae039 = $f279b09520489801$var$zIndex;

});



parcelRegister("1xQ98", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $120152aceafacbbb$export$2e2bcd8739ae039; });
var $120152aceafacbbb$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("2Zehi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22cc5a9bc5d7cd5e$export$2e2bcd8739ae039; });

var $3jQWa = parcelRequire("3jQWa");

var $VZKDD = parcelRequire("VZKDD");

var $1xQ98 = parcelRequire("1xQ98");

var $dH0wl = parcelRequire("dH0wl");

"use client";
const $22cc5a9bc5d7cd5e$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($3jQWa)))({
    themeId: (0, $1xQ98.default),
    defaultTheme: $VZKDD.default,
    rootShouldForwardProp: $dH0wl.default
});
var $22cc5a9bc5d7cd5e$export$2e2bcd8739ae039 = $22cc5a9bc5d7cd5e$var$styled;

});
parcelRegister("dH0wl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f7fb1ef1b096a95$export$2e2bcd8739ae039; });

var $dLtys = parcelRequire("dLtys");
const $9f7fb1ef1b096a95$var$rootShouldForwardProp = (prop)=>(0, $dLtys.default)(prop) && prop !== "classes";
var $9f7fb1ef1b096a95$export$2e2bcd8739ae039 = $9f7fb1ef1b096a95$var$rootShouldForwardProp;

});
parcelRegister("dLtys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a056971fec740ed4$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $a056971fec740ed4$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $a056971fec740ed4$export$2e2bcd8739ae039 = $a056971fec740ed4$var$slotShouldForwardProp;

});



parcelRegister("l9FXd", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $f66afb757c42c0b6$export$c7c50641356bdfa5; });

var $7Kfdo = parcelRequire("7Kfdo");

var $jOBMM = parcelRequire("jOBMM");
function $f66afb757c42c0b6$export$c7c50641356bdfa5(slot) {
    return (0, $jOBMM.default)("MuiSvgIcon", slot);
}
const $f66afb757c42c0b6$var$svgIconClasses = (0, $7Kfdo.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $f66afb757c42c0b6$export$2e2bcd8739ae039 = $f66afb757c42c0b6$var$svgIconClasses;

});





var $2WrlN = parcelRequire("2WrlN");
var $adf38e62d3ba55f8$export$882461b6382ed46c;
var $adf38e62d3ba55f8$export$757ceba2d55c277e;
"use strict";
var $b86f1e2f9a665e04$exports = {};
"use strict";
function $b86f1e2f9a665e04$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b86f1e2f9a665e04$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b86f1e2f9a665e04$var$checkDCE();

$b86f1e2f9a665e04$exports = (parcelRequire("io9YA"));


var $adf38e62d3ba55f8$var$i;
$adf38e62d3ba55f8$export$882461b6382ed46c = $b86f1e2f9a665e04$exports.createRoot;
$adf38e62d3ba55f8$export$757ceba2d55c277e = $b86f1e2f9a665e04$exports.hydrateRoot;



var $ld5Xm = parcelRequire("ld5Xm");
/*! @azure/msal-common v13.1.0 2023-06-07 */ /*! @azure/msal-common v13.1.0 2023-06-07 */ /*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $35bd2ff9e18a8648$var$extendStatics = function(d, b) {
    $35bd2ff9e18a8648$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $35bd2ff9e18a8648$var$extendStatics(d, b);
};
function $35bd2ff9e18a8648$export$a8ba968b8961cb8a(d, b) {
    $35bd2ff9e18a8648$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $35bd2ff9e18a8648$export$18ce0697a983be9b = function() {
    $35bd2ff9e18a8648$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $35bd2ff9e18a8648$export$18ce0697a983be9b.apply(this, arguments);
};
function $35bd2ff9e18a8648$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $35bd2ff9e18a8648$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $35bd2ff9e18a8648$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $1b76d687a319d9ed$export$a002182e51710d39 = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // Prefix for all library cache entries
    CACHE_PREFIX: "msal",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    DEFAULT_COMMON_TENANT: "common",
    // ADFS String
    ADFS: "adfs",
    DSTS: "dstsv2",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // CIAM URL
    CIAM_AUTH_URL: ".ciamlogin.com",
    AAD_TENANT_DOMAIN_SUFFIX: ".onmicrosoft.com",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    // Default response type for authorization code flow
    CODE_RESPONSE_TYPE: "code",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    FRAGMENT_RESPONSE_MODE: "fragment",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    NOT_APPLICABLE: "N/A",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    REGIONAL_AUTH_NON_MSI_QUERY_STRING: "allowestsrnonmsi=true",
    KNOWN_PUBLIC_CLOUDS: [
        "login.microsoftonline.com",
        "login.windows.net",
        "login.microsoft.com",
        "sts.windows.net"
    ],
    TOKEN_RESPONSE_TYPE: "token",
    ID_TOKEN_RESPONSE_TYPE: "id_token",
    SHR_NONCE_VALIDITY: 240,
    INVALID_INSTANCE: "invalid_instance"
};
var $1b76d687a319d9ed$export$893b1b5b686d84ef = [
    $1b76d687a319d9ed$export$a002182e51710d39.OPENID_SCOPE,
    $1b76d687a319d9ed$export$a002182e51710d39.PROFILE_SCOPE,
    $1b76d687a319d9ed$export$a002182e51710d39.OFFLINE_ACCESS_SCOPE
];
var $1b76d687a319d9ed$export$268e88275f5afab2 = (0, $35bd2ff9e18a8648$export$6388937ca91ccae8)($1b76d687a319d9ed$export$893b1b5b686d84ef, [
    $1b76d687a319d9ed$export$a002182e51710d39.EMAIL_SCOPE
]);
/**
 * Request header names
 */ var $1b76d687a319d9ed$export$28d77f87efed1d88;
(function(HeaderNames) {
    HeaderNames["CONTENT_TYPE"] = "Content-Type";
    HeaderNames["RETRY_AFTER"] = "Retry-After";
    HeaderNames["CCS_HEADER"] = "X-AnchorMailbox";
    HeaderNames["WWWAuthenticate"] = "WWW-Authenticate";
    HeaderNames["AuthenticationInfo"] = "Authentication-Info";
    HeaderNames["X_MS_REQUEST_ID"] = "x-ms-request-id";
    HeaderNames["X_MS_HTTP_VERSION"] = "x-ms-httpver";
})($1b76d687a319d9ed$export$28d77f87efed1d88 || ($1b76d687a319d9ed$export$28d77f87efed1d88 = {}));
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ var $1b76d687a319d9ed$export$81ab9ba9bd28255c;
(function(PersistentCacheKeys) {
    PersistentCacheKeys["ID_TOKEN"] = "idtoken";
    PersistentCacheKeys["CLIENT_INFO"] = "client.info";
    PersistentCacheKeys["ADAL_ID_TOKEN"] = "adal.idtoken";
    PersistentCacheKeys["ERROR"] = "error";
    PersistentCacheKeys["ERROR_DESC"] = "error.description";
    PersistentCacheKeys["ACTIVE_ACCOUNT"] = "active-account";
    PersistentCacheKeys["ACTIVE_ACCOUNT_FILTERS"] = "active-account-filters"; // new cache entry for active_account for a more robust version for browser
})($1b76d687a319d9ed$export$81ab9ba9bd28255c || ($1b76d687a319d9ed$export$81ab9ba9bd28255c = {}));
/**
 * String constants related to AAD Authority
 */ var $1b76d687a319d9ed$export$e18ac120172ed505;
(function(AADAuthorityConstants) {
    AADAuthorityConstants["COMMON"] = "common";
    AADAuthorityConstants["ORGANIZATIONS"] = "organizations";
    AADAuthorityConstants["CONSUMERS"] = "consumers";
})($1b76d687a319d9ed$export$e18ac120172ed505 || ($1b76d687a319d9ed$export$e18ac120172ed505 = {}));
/**
 * Keys in the hashParams sent by AAD Server
 */ var $1b76d687a319d9ed$export$cf7709e7db2ddf5d;
(function(AADServerParamKeys) {
    AADServerParamKeys["CLIENT_ID"] = "client_id";
    AADServerParamKeys["REDIRECT_URI"] = "redirect_uri";
    AADServerParamKeys["RESPONSE_TYPE"] = "response_type";
    AADServerParamKeys["RESPONSE_MODE"] = "response_mode";
    AADServerParamKeys["GRANT_TYPE"] = "grant_type";
    AADServerParamKeys["CLAIMS"] = "claims";
    AADServerParamKeys["SCOPE"] = "scope";
    AADServerParamKeys["ERROR"] = "error";
    AADServerParamKeys["ERROR_DESCRIPTION"] = "error_description";
    AADServerParamKeys["ACCESS_TOKEN"] = "access_token";
    AADServerParamKeys["ID_TOKEN"] = "id_token";
    AADServerParamKeys["REFRESH_TOKEN"] = "refresh_token";
    AADServerParamKeys["EXPIRES_IN"] = "expires_in";
    AADServerParamKeys["STATE"] = "state";
    AADServerParamKeys["NONCE"] = "nonce";
    AADServerParamKeys["PROMPT"] = "prompt";
    AADServerParamKeys["SESSION_STATE"] = "session_state";
    AADServerParamKeys["CLIENT_INFO"] = "client_info";
    AADServerParamKeys["CODE"] = "code";
    AADServerParamKeys["CODE_CHALLENGE"] = "code_challenge";
    AADServerParamKeys["CODE_CHALLENGE_METHOD"] = "code_challenge_method";
    AADServerParamKeys["CODE_VERIFIER"] = "code_verifier";
    AADServerParamKeys["CLIENT_REQUEST_ID"] = "client-request-id";
    AADServerParamKeys["X_CLIENT_SKU"] = "x-client-SKU";
    AADServerParamKeys["X_CLIENT_VER"] = "x-client-VER";
    AADServerParamKeys["X_CLIENT_OS"] = "x-client-OS";
    AADServerParamKeys["X_CLIENT_CPU"] = "x-client-CPU";
    AADServerParamKeys["X_CLIENT_CURR_TELEM"] = "x-client-current-telemetry";
    AADServerParamKeys["X_CLIENT_LAST_TELEM"] = "x-client-last-telemetry";
    AADServerParamKeys["X_MS_LIB_CAPABILITY"] = "x-ms-lib-capability";
    AADServerParamKeys["X_APP_NAME"] = "x-app-name";
    AADServerParamKeys["X_APP_VER"] = "x-app-ver";
    AADServerParamKeys["POST_LOGOUT_URI"] = "post_logout_redirect_uri";
    AADServerParamKeys["ID_TOKEN_HINT"] = "id_token_hint";
    AADServerParamKeys["DEVICE_CODE"] = "device_code";
    AADServerParamKeys["CLIENT_SECRET"] = "client_secret";
    AADServerParamKeys["CLIENT_ASSERTION"] = "client_assertion";
    AADServerParamKeys["CLIENT_ASSERTION_TYPE"] = "client_assertion_type";
    AADServerParamKeys["TOKEN_TYPE"] = "token_type";
    AADServerParamKeys["REQ_CNF"] = "req_cnf";
    AADServerParamKeys["OBO_ASSERTION"] = "assertion";
    AADServerParamKeys["REQUESTED_TOKEN_USE"] = "requested_token_use";
    AADServerParamKeys["ON_BEHALF_OF"] = "on_behalf_of";
    AADServerParamKeys["FOCI"] = "foci";
    AADServerParamKeys["CCS_HEADER"] = "X-AnchorMailbox";
    AADServerParamKeys["RETURN_SPA_CODE"] = "return_spa_code";
    AADServerParamKeys["NATIVE_BROKER"] = "nativebroker";
    AADServerParamKeys["LOGOUT_HINT"] = "logout_hint";
})($1b76d687a319d9ed$export$cf7709e7db2ddf5d || ($1b76d687a319d9ed$export$cf7709e7db2ddf5d = {}));
/**
 * Claims request keys
 */ var $1b76d687a319d9ed$export$c125cda26c71ef54;
(function(ClaimsRequestKeys) {
    ClaimsRequestKeys["ACCESS_TOKEN"] = "access_token";
    ClaimsRequestKeys["XMS_CC"] = "xms_cc";
})($1b76d687a319d9ed$export$c125cda26c71ef54 || ($1b76d687a319d9ed$export$c125cda26c71ef54 = {}));
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ var $1b76d687a319d9ed$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * SSO Types - generated to populate hints
 */ var $1b76d687a319d9ed$export$7f68224783b2bd08;
(function(SSOTypes) {
    SSOTypes["ACCOUNT"] = "account";
    SSOTypes["SID"] = "sid";
    SSOTypes["LOGIN_HINT"] = "login_hint";
    SSOTypes["ID_TOKEN"] = "id_token";
    SSOTypes["DOMAIN_HINT"] = "domain_hint";
    SSOTypes["ORGANIZATIONS"] = "organizations";
    SSOTypes["CONSUMERS"] = "consumers";
    SSOTypes["ACCOUNT_ID"] = "accountIdentifier";
    SSOTypes["HOMEACCOUNT_ID"] = "homeAccountIdentifier";
})($1b76d687a319d9ed$export$7f68224783b2bd08 || ($1b76d687a319d9ed$export$7f68224783b2bd08 = {}));
/**
 * allowed values for codeVerifier
 */ var $1b76d687a319d9ed$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * allowed values for response_mode
 */ var $1b76d687a319d9ed$export$f990a5bae1260b8c;
(function(ResponseMode) {
    ResponseMode["QUERY"] = "query";
    ResponseMode["FRAGMENT"] = "fragment";
    ResponseMode["FORM_POST"] = "form_post";
})($1b76d687a319d9ed$export$f990a5bae1260b8c || ($1b76d687a319d9ed$export$f990a5bae1260b8c = {}));
/**
 * allowed grant_type
 */ var $1b76d687a319d9ed$export$ce68f19b50b39c0b;
(function(GrantType) {
    GrantType["IMPLICIT_GRANT"] = "implicit";
    GrantType["AUTHORIZATION_CODE_GRANT"] = "authorization_code";
    GrantType["CLIENT_CREDENTIALS_GRANT"] = "client_credentials";
    GrantType["RESOURCE_OWNER_PASSWORD_GRANT"] = "password";
    GrantType["REFRESH_TOKEN_GRANT"] = "refresh_token";
    GrantType["DEVICE_CODE_GRANT"] = "device_code";
    GrantType["JWT_BEARER"] = "urn:ietf:params:oauth:grant-type:jwt-bearer";
})($1b76d687a319d9ed$export$ce68f19b50b39c0b || ($1b76d687a319d9ed$export$ce68f19b50b39c0b = {}));
/**
 * Account types in Cache
 */ var $1b76d687a319d9ed$export$23244fafa2e7f55c;
(function(CacheAccountType) {
    CacheAccountType["MSSTS_ACCOUNT_TYPE"] = "MSSTS";
    CacheAccountType["ADFS_ACCOUNT_TYPE"] = "ADFS";
    CacheAccountType["MSAV1_ACCOUNT_TYPE"] = "MSA";
    CacheAccountType["GENERIC_ACCOUNT_TYPE"] = "Generic"; // NTLM, Kerberos, FBA, Basic etc
})($1b76d687a319d9ed$export$23244fafa2e7f55c || ($1b76d687a319d9ed$export$23244fafa2e7f55c = {}));
/**
 * Separators used in cache
 */ var $1b76d687a319d9ed$export$520854da2ba5d734;
(function(Separators) {
    Separators["CACHE_KEY_SEPARATOR"] = "-";
    Separators["CLIENT_INFO_SEPARATOR"] = ".";
})($1b76d687a319d9ed$export$520854da2ba5d734 || ($1b76d687a319d9ed$export$520854da2ba5d734 = {}));
/**
 * Credential Type stored in the cache
 */ var $1b76d687a319d9ed$export$eca2dc7e6e608a68;
(function(CredentialType) {
    CredentialType["ID_TOKEN"] = "IdToken";
    CredentialType["ACCESS_TOKEN"] = "AccessToken";
    CredentialType["ACCESS_TOKEN_WITH_AUTH_SCHEME"] = "AccessToken_With_AuthScheme";
    CredentialType["REFRESH_TOKEN"] = "RefreshToken";
})($1b76d687a319d9ed$export$eca2dc7e6e608a68 || ($1b76d687a319d9ed$export$eca2dc7e6e608a68 = {}));
/**
 * Combine all cache types
 */ var $1b76d687a319d9ed$export$ba193b555633db78;
(function(CacheType) {
    CacheType[CacheType["ADFS"] = 1001] = "ADFS";
    CacheType[CacheType["MSA"] = 1002] = "MSA";
    CacheType[CacheType["MSSTS"] = 1003] = "MSSTS";
    CacheType[CacheType["GENERIC"] = 1004] = "GENERIC";
    CacheType[CacheType["ACCESS_TOKEN"] = 2001] = "ACCESS_TOKEN";
    CacheType[CacheType["REFRESH_TOKEN"] = 2002] = "REFRESH_TOKEN";
    CacheType[CacheType["ID_TOKEN"] = 2003] = "ID_TOKEN";
    CacheType[CacheType["APP_METADATA"] = 3001] = "APP_METADATA";
    CacheType[CacheType["UNDEFINED"] = 9999] = "UNDEFINED";
})($1b76d687a319d9ed$export$ba193b555633db78 || ($1b76d687a319d9ed$export$ba193b555633db78 = {}));
/**
 * More Cache related constants
 */ var $1b76d687a319d9ed$export$7e1bea6dc1b6b32e = "appmetadata";
var $1b76d687a319d9ed$export$476989d62bcb4c85 = "client_info";
var $1b76d687a319d9ed$export$978fe7ab5e74b539 = "1";
var $1b76d687a319d9ed$export$d483f966e66f4db5 = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 86400 // 24 Hours
};
var $1b76d687a319d9ed$export$5d365d77acfcb55d;
(function(AuthorityMetadataSource) {
    AuthorityMetadataSource["CONFIG"] = "config";
    AuthorityMetadataSource["CACHE"] = "cache";
    AuthorityMetadataSource["NETWORK"] = "network";
    AuthorityMetadataSource["HARDCODED_VALUES"] = "hardcoded_values";
})($1b76d687a319d9ed$export$5d365d77acfcb55d || ($1b76d687a319d9ed$export$5d365d77acfcb55d = {}));
var $1b76d687a319d9ed$export$30fa4ad28fb9feeb = {
    SCHEMA_VERSION: 5,
    MAX_CUR_HEADER_BYTES: 80,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */ var $1b76d687a319d9ed$export$901491a717da2ba5;
(function(AuthenticationScheme) {
    AuthenticationScheme["BEARER"] = "Bearer";
    AuthenticationScheme["POP"] = "pop";
    AuthenticationScheme["SSH"] = "ssh-cert";
})($1b76d687a319d9ed$export$901491a717da2ba5 || ($1b76d687a319d9ed$export$901491a717da2ba5 = {}));
/**
 * Constants related to throttling
 */ var $1b76d687a319d9ed$export$a2330d6808e6d893 = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
var $1b76d687a319d9ed$export$b8e9cd941e8016ac = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch"
};
/**
 * Password grant parameters
 */ var $1b76d687a319d9ed$export$fa8b29062cab1da;
(function(PasswordGrantConstants) {
    PasswordGrantConstants["username"] = "username";
    PasswordGrantConstants["password"] = "password";
})($1b76d687a319d9ed$export$fa8b29062cab1da || ($1b76d687a319d9ed$export$fa8b29062cab1da = {}));
/**
 * Response codes
 */ var $1b76d687a319d9ed$export$20ba0879771a17be;
(function(ResponseCodes) {
    ResponseCodes[ResponseCodes["httpSuccess"] = 200] = "httpSuccess";
    ResponseCodes[ResponseCodes["httpBadRequest"] = 400] = "httpBadRequest";
})($1b76d687a319d9ed$export$20ba0879771a17be || ($1b76d687a319d9ed$export$20ba0879771a17be = {}));
/**
 * Region Discovery Sources
 */ var $1b76d687a319d9ed$export$3d4a3e11df589b40;
(function(RegionDiscoverySources) {
    RegionDiscoverySources["FAILED_AUTO_DETECTION"] = "1";
    RegionDiscoverySources["INTERNAL_CACHE"] = "2";
    RegionDiscoverySources["ENVIRONMENT_VARIABLE"] = "3";
    RegionDiscoverySources["IMDS"] = "4";
})($1b76d687a319d9ed$export$3d4a3e11df589b40 || ($1b76d687a319d9ed$export$3d4a3e11df589b40 = {}));
/**
 * Region Discovery Outcomes
 */ var $1b76d687a319d9ed$export$92a685f9218422bd;
(function(RegionDiscoveryOutcomes) {
    RegionDiscoveryOutcomes["CONFIGURED_MATCHES_DETECTED"] = "1";
    RegionDiscoveryOutcomes["CONFIGURED_NO_AUTO_DETECTION"] = "2";
    RegionDiscoveryOutcomes["CONFIGURED_NOT_DETECTED"] = "3";
    RegionDiscoveryOutcomes["AUTO_DETECTION_REQUESTED_SUCCESSFUL"] = "4";
    RegionDiscoveryOutcomes["AUTO_DETECTION_REQUESTED_FAILED"] = "5";
})($1b76d687a319d9ed$export$92a685f9218422bd || ($1b76d687a319d9ed$export$92a685f9218422bd = {}));
var $1b76d687a319d9ed$export$aa4af185ea049f6b;
(function(CacheOutcome) {
    CacheOutcome["NO_CACHE_HIT"] = "0";
    CacheOutcome["FORCE_REFRESH"] = "1";
    CacheOutcome["NO_CACHED_ACCESS_TOKEN"] = "2";
    CacheOutcome["CACHED_ACCESS_TOKEN_EXPIRED"] = "3";
    CacheOutcome["REFRESH_CACHED_ACCESS_TOKEN"] = "4";
})($1b76d687a319d9ed$export$aa4af185ea049f6b || ($1b76d687a319d9ed$export$aa4af185ea049f6b = {}));
var $1b76d687a319d9ed$export$70dd17b99a838729;
(function(JsonTypes) {
    JsonTypes["Jwt"] = "JWT";
    JsonTypes["Jwk"] = "JWK";
    JsonTypes["Pop"] = "pop";
})($1b76d687a319d9ed$export$70dd17b99a838729 || ($1b76d687a319d9ed$export$70dd17b99a838729 = {}));
var $1b76d687a319d9ed$export$14c29d43b22a755f = 86400000;


/*! @azure/msal-common v13.1.0 2023-06-07 */ /*! @azure/msal-common v13.1.0 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ var $7f0aeee92385582d$export$930cbd4733f218f0 = {
    unexpectedError: {
        code: "unexpected_error",
        desc: "Unexpected error in authentication."
    },
    postRequestFailed: {
        code: "post_request_failed",
        desc: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */ var $7f0aeee92385582d$export$145273558d58e0ac = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(AuthError, _super);
    function AuthError(errorCode, errorMessage, suberror) {
        var _this = this;
        var errorString = errorMessage ? errorCode + ": " + errorMessage : errorCode;
        _this = _super.call(this, errorString) || this;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.errorCode = errorCode || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        _this.errorMessage = errorMessage || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        _this.subError = suberror || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        _this.name = "AuthError";
        return _this;
    }
    AuthError.prototype.setCorrelationId = function(correlationId) {
        this.correlationId = correlationId;
    };
    /**
     * Creates an error that is thrown when something unexpected happens in the library.
     * @param errDesc
     */ AuthError.createUnexpectedError = function(errDesc) {
        return new AuthError($7f0aeee92385582d$export$930cbd4733f218f0.unexpectedError.code, $7f0aeee92385582d$export$930cbd4733f218f0.unexpectedError.desc + ": " + errDesc);
    };
    /**
     * Creates an error for post request failures.
     * @param errDesc
     * @returns
     */ AuthError.createPostRequestFailed = function(errDesc) {
        return new AuthError($7f0aeee92385582d$export$930cbd4733f218f0.postRequestFailed.code, $7f0aeee92385582d$export$930cbd4733f218f0.postRequestFailed.desc + ": " + errDesc);
    };
    return AuthError;
}(Error);


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ var $30cd164be78785f3$export$51eee17394e135b = {
    clientInfoDecodingError: {
        code: "client_info_decoding_error",
        desc: "The client info could not be parsed/decoded correctly. Please review the trace to determine the root cause."
    },
    clientInfoEmptyError: {
        code: "client_info_empty_error",
        desc: "The client info was empty. Please review the trace to determine the root cause."
    },
    tokenParsingError: {
        code: "token_parsing_error",
        desc: "Token cannot be parsed. Please review stack trace to determine root cause."
    },
    nullOrEmptyToken: {
        code: "null_or_empty_token",
        desc: "The token is null or empty. Please review the trace to determine the root cause."
    },
    endpointResolutionError: {
        code: "endpoints_resolution_error",
        desc: "Error: could not resolve endpoints. Please check network and try again."
    },
    networkError: {
        code: "network_error",
        desc: "Network request failed. Please check network trace to determine root cause."
    },
    unableToGetOpenidConfigError: {
        code: "openid_config_error",
        desc: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints."
    },
    hashNotDeserialized: {
        code: "hash_not_deserialized",
        desc: "The hash parameters could not be deserialized. Please review the trace to determine the root cause."
    },
    blankGuidGenerated: {
        code: "blank_guid_generated",
        desc: "The guid generated was blank. Please review the trace to determine the root cause."
    },
    invalidStateError: {
        code: "invalid_state",
        desc: "State was not the expected format. Please check the logs to determine whether the request was sent using ProtocolUtils.setRequestState()."
    },
    stateMismatchError: {
        code: "state_mismatch",
        desc: "State mismatch error. Please check your network. Continued requests may cause cache overflow."
    },
    stateNotFoundError: {
        code: "state_not_found",
        desc: "State not found"
    },
    nonceMismatchError: {
        code: "nonce_mismatch",
        desc: "Nonce mismatch error. This may be caused by a race condition in concurrent requests."
    },
    nonceNotFoundError: {
        code: "nonce_not_found",
        desc: "nonce not found"
    },
    authTimeNotFoundError: {
        code: "auth_time_not_found",
        desc: "Max Age was requested and the ID token is missing the auth_time variable. auth_time is an optional claim and is not enabled by default - it must be enabled. See https://aka.ms/msaljs/optional-claims for more information."
    },
    maxAgeTranspiredError: {
        code: "max_age_transpired",
        desc: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication."
    },
    noTokensFoundError: {
        code: "no_tokens_found",
        desc: "No tokens were found for the given scopes, and no authorization code was passed to acquireToken. You must retrieve an authorization code before making a call to acquireToken()."
    },
    multipleMatchingTokens: {
        code: "multiple_matching_tokens",
        desc: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements such as authority or account."
    },
    multipleMatchingAccounts: {
        code: "multiple_matching_accounts",
        desc: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account"
    },
    multipleMatchingAppMetadata: {
        code: "multiple_matching_appMetadata",
        desc: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata"
    },
    tokenRequestCannotBeMade: {
        code: "request_cannot_be_made",
        desc: "Token request cannot be made without authorization code or refresh token."
    },
    appendEmptyScopeError: {
        code: "cannot_append_empty_scope",
        desc: "Cannot append null or empty scope to ScopeSet. Please check the stack trace for more info."
    },
    removeEmptyScopeError: {
        code: "cannot_remove_empty_scope",
        desc: "Cannot remove null or empty scope from ScopeSet. Please check the stack trace for more info."
    },
    appendScopeSetError: {
        code: "cannot_append_scopeset",
        desc: "Cannot append ScopeSet due to error."
    },
    emptyInputScopeSetError: {
        code: "empty_input_scopeset",
        desc: "Empty input ScopeSet cannot be processed."
    },
    DeviceCodePollingCancelled: {
        code: "device_code_polling_cancelled",
        desc: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true."
    },
    DeviceCodeExpired: {
        code: "device_code_expired",
        desc: "Device code is expired."
    },
    DeviceCodeUnknownError: {
        code: "device_code_unknown_error",
        desc: "Device code stopped polling for unknown reasons."
    },
    NoAccountInSilentRequest: {
        code: "no_account_in_silent_request",
        desc: "Please pass an account object, silent flow is not supported without account information"
    },
    invalidCacheRecord: {
        code: "invalid_cache_record",
        desc: "Cache record object was null or undefined."
    },
    invalidCacheEnvironment: {
        code: "invalid_cache_environment",
        desc: "Invalid environment when attempting to create cache entry"
    },
    noAccountFound: {
        code: "no_account_found",
        desc: "No account found in cache for given key."
    },
    CachePluginError: {
        code: "no cache plugin set on CacheManager",
        desc: "ICachePlugin needs to be set before using readFromStorage or writeFromStorage"
    },
    noCryptoObj: {
        code: "no_crypto_object",
        desc: "No crypto object detected. This is required for the following operation: "
    },
    invalidCacheType: {
        code: "invalid_cache_type",
        desc: "Invalid cache type"
    },
    unexpectedAccountType: {
        code: "unexpected_account_type",
        desc: "Unexpected account type."
    },
    unexpectedCredentialType: {
        code: "unexpected_credential_type",
        desc: "Unexpected credential type."
    },
    invalidAssertion: {
        code: "invalid_assertion",
        desc: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515"
    },
    invalidClientCredential: {
        code: "invalid_client_credential",
        desc: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential"
    },
    tokenRefreshRequired: {
        code: "token_refresh_required",
        desc: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired."
    },
    userTimeoutReached: {
        code: "user_timeout_reached",
        desc: "User defined timeout for device code polling reached"
    },
    tokenClaimsRequired: {
        code: "token_claims_cnf_required_for_signedjwt",
        desc: "Cannot generate a POP jwt if the token_claims are not populated"
    },
    noAuthorizationCodeFromServer: {
        code: "authorization_code_missing_from_server_response",
        desc: "Server response does not contain an authorization code to proceed"
    },
    noAzureRegionDetected: {
        code: "no_azure_region_detected",
        desc: "No azure region was detected and no fallback was made available"
    },
    accessTokenEntityNullError: {
        code: "access_token_entity_null",
        desc: "Access token entity is null, please check logs and cache to ensure a valid access token is present."
    },
    bindingKeyNotRemovedError: {
        code: "binding_key_not_removed",
        desc: "Could not remove the credential's binding key from storage."
    },
    logoutNotSupported: {
        code: "end_session_endpoint_not_supported",
        desc: "Provided authority does not support logout."
    },
    keyIdMissing: {
        code: "key_id_missing",
        desc: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key."
    },
    noNetworkConnectivity: {
        code: "no_network_connectivity",
        desc: "No network connectivity. Check your internet connection."
    },
    userCanceledError: {
        code: "user_canceled",
        desc: "User canceled the flow."
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ var $30cd164be78785f3$export$a839ff85a7957561 = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(ClientAuthError, _super);
    function ClientAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientAuthError";
        Object.setPrototypeOf(_this, ClientAuthError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when client info object doesn't decode correctly.
     * @param caughtError
     */ ClientAuthError.createClientInfoDecodingError = function(caughtError) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.clientInfoDecodingError.code, $30cd164be78785f3$export$51eee17394e135b.clientInfoDecodingError.desc + " Failed with error: " + caughtError);
    };
    /**
     * Creates an error thrown if the client info is empty.
     * @param rawClientInfo
     */ ClientAuthError.createClientInfoEmptyError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.clientInfoEmptyError.code, "" + $30cd164be78785f3$export$51eee17394e135b.clientInfoEmptyError.desc);
    };
    /**
     * Creates an error thrown when the id token extraction errors out.
     * @param err
     */ ClientAuthError.createTokenParsingError = function(caughtExtractionError) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.tokenParsingError.code, $30cd164be78785f3$export$51eee17394e135b.tokenParsingError.desc + " Failed with error: " + caughtExtractionError);
    };
    /**
     * Creates an error thrown when the id token string is null or empty.
     * @param invalidRawTokenString
     */ ClientAuthError.createTokenNullOrEmptyError = function(invalidRawTokenString) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.nullOrEmptyToken.code, $30cd164be78785f3$export$51eee17394e135b.nullOrEmptyToken.desc + " Raw Token Value: " + invalidRawTokenString);
    };
    /**
     * Creates an error thrown when the endpoint discovery doesn't complete correctly.
     */ ClientAuthError.createEndpointDiscoveryIncompleteError = function(errDetail) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.endpointResolutionError.code, $30cd164be78785f3$export$51eee17394e135b.endpointResolutionError.desc + " Detail: " + errDetail);
    };
    /**
     * Creates an error thrown when the fetch client throws
     */ ClientAuthError.createNetworkError = function(endpoint, errDetail) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.networkError.code, $30cd164be78785f3$export$51eee17394e135b.networkError.desc + " | Fetch client threw: " + errDetail + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Creates an error thrown when the openid-configuration endpoint cannot be reached or does not contain the required data
     */ ClientAuthError.createUnableToGetOpenidConfigError = function(errDetail) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.unableToGetOpenidConfigError.code, $30cd164be78785f3$export$51eee17394e135b.unableToGetOpenidConfigError.desc + " Attempted to retrieve endpoints from: " + errDetail);
    };
    /**
     * Creates an error thrown when the hash cannot be deserialized.
     * @param hashParamObj
     */ ClientAuthError.createHashNotDeserializedError = function(hashParamObj) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.hashNotDeserialized.code, $30cd164be78785f3$export$51eee17394e135b.hashNotDeserialized.desc + " Given Object: " + hashParamObj);
    };
    /**
     * Creates an error thrown when the state cannot be parsed.
     * @param invalidState
     */ ClientAuthError.createInvalidStateError = function(invalidState, errorString) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.invalidStateError.code, $30cd164be78785f3$export$51eee17394e135b.invalidStateError.desc + " Invalid State: " + invalidState + ", Root Err: " + errorString);
    };
    /**
     * Creates an error thrown when two states do not match.
     */ ClientAuthError.createStateMismatchError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.stateMismatchError.code, $30cd164be78785f3$export$51eee17394e135b.stateMismatchError.desc);
    };
    /**
     * Creates an error thrown when the state is not present
     * @param missingState
     */ ClientAuthError.createStateNotFoundError = function(missingState) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.stateNotFoundError.code, $30cd164be78785f3$export$51eee17394e135b.stateNotFoundError.desc + ":  " + missingState);
    };
    /**
     * Creates an error thrown when the nonce does not match.
     */ ClientAuthError.createNonceMismatchError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.nonceMismatchError.code, $30cd164be78785f3$export$51eee17394e135b.nonceMismatchError.desc);
    };
    /**
     * Creates an error thrown when max_age was provided in the request, but auth_time is not in the token claims
     * @param missingNonce
     */ ClientAuthError.createAuthTimeNotFoundError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.authTimeNotFoundError.code, $30cd164be78785f3$export$51eee17394e135b.authTimeNotFoundError.desc);
    };
    /**
     * Creates an error thrown when too much time has elapsed since the last end-user authentication
     */ ClientAuthError.createMaxAgeTranspiredError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.maxAgeTranspiredError.code, $30cd164be78785f3$export$51eee17394e135b.maxAgeTranspiredError.desc);
    };
    /**
     * Creates an error thrown when the mnonce is not present
     * @param missingNonce
     */ ClientAuthError.createNonceNotFoundError = function(missingNonce) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.nonceNotFoundError.code, $30cd164be78785f3$export$51eee17394e135b.nonceNotFoundError.desc + ":  " + missingNonce);
    };
    /**
     * Throws error when multiple tokens are in cache.
     */ ClientAuthError.createMultipleMatchingTokensInCacheError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.multipleMatchingTokens.code, $30cd164be78785f3$export$51eee17394e135b.multipleMatchingTokens.desc + ".");
    };
    /**
     * Throws error when multiple accounts are in cache for the given params
     */ ClientAuthError.createMultipleMatchingAccountsInCacheError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.multipleMatchingAccounts.code, $30cd164be78785f3$export$51eee17394e135b.multipleMatchingAccounts.desc);
    };
    /**
     * Throws error when multiple appMetada are in cache for the given clientId.
     */ ClientAuthError.createMultipleMatchingAppMetadataInCacheError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.multipleMatchingAppMetadata.code, $30cd164be78785f3$export$51eee17394e135b.multipleMatchingAppMetadata.desc);
    };
    /**
     * Throws error when no auth code or refresh token is given to ServerTokenRequestParameters.
     */ ClientAuthError.createTokenRequestCannotBeMadeError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.tokenRequestCannotBeMade.code, $30cd164be78785f3$export$51eee17394e135b.tokenRequestCannotBeMade.desc);
    };
    /**
     * Throws error when attempting to append a null, undefined or empty scope to a set
     * @param givenScope
     */ ClientAuthError.createAppendEmptyScopeToSetError = function(givenScope) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.appendEmptyScopeError.code, $30cd164be78785f3$export$51eee17394e135b.appendEmptyScopeError.desc + " Given Scope: " + givenScope);
    };
    /**
     * Throws error when attempting to append a null, undefined or empty scope to a set
     * @param givenScope
     */ ClientAuthError.createRemoveEmptyScopeFromSetError = function(givenScope) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.removeEmptyScopeError.code, $30cd164be78785f3$export$51eee17394e135b.removeEmptyScopeError.desc + " Given Scope: " + givenScope);
    };
    /**
     * Throws error when attempting to append null or empty ScopeSet.
     * @param appendError
     */ ClientAuthError.createAppendScopeSetError = function(appendError) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.appendScopeSetError.code, $30cd164be78785f3$export$51eee17394e135b.appendScopeSetError.desc + " Detail Error: " + appendError);
    };
    /**
     * Throws error if ScopeSet is null or undefined.
     * @param givenScopeSet
     */ ClientAuthError.createEmptyInputScopeSetError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.emptyInputScopeSetError.code, "" + $30cd164be78785f3$export$51eee17394e135b.emptyInputScopeSetError.desc);
    };
    /**
     * Throws error if user sets CancellationToken.cancel = true during polling of token endpoint during device code flow
     */ ClientAuthError.createDeviceCodeCancelledError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.DeviceCodePollingCancelled.code, "" + $30cd164be78785f3$export$51eee17394e135b.DeviceCodePollingCancelled.desc);
    };
    /**
     * Throws error if device code is expired
     */ ClientAuthError.createDeviceCodeExpiredError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.DeviceCodeExpired.code, "" + $30cd164be78785f3$export$51eee17394e135b.DeviceCodeExpired.desc);
    };
    /**
     * Throws error if device code is expired
     */ ClientAuthError.createDeviceCodeUnknownError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.DeviceCodeUnknownError.code, "" + $30cd164be78785f3$export$51eee17394e135b.DeviceCodeUnknownError.desc);
    };
    /**
     * Throws error when silent requests are made without an account object
     */ ClientAuthError.createNoAccountInSilentRequestError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.NoAccountInSilentRequest.code, "" + $30cd164be78785f3$export$51eee17394e135b.NoAccountInSilentRequest.desc);
    };
    /**
     * Throws error when cache record is null or undefined.
     */ ClientAuthError.createNullOrUndefinedCacheRecord = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.invalidCacheRecord.code, $30cd164be78785f3$export$51eee17394e135b.invalidCacheRecord.desc);
    };
    /**
     * Throws error when provided environment is not part of the CloudDiscoveryMetadata object
     */ ClientAuthError.createInvalidCacheEnvironmentError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.invalidCacheEnvironment.code, $30cd164be78785f3$export$51eee17394e135b.invalidCacheEnvironment.desc);
    };
    /**
     * Throws error when account is not found in cache.
     */ ClientAuthError.createNoAccountFoundError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.noAccountFound.code, $30cd164be78785f3$export$51eee17394e135b.noAccountFound.desc);
    };
    /**
     * Throws error if ICachePlugin not set on CacheManager.
     */ ClientAuthError.createCachePluginError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.CachePluginError.code, "" + $30cd164be78785f3$export$51eee17394e135b.CachePluginError.desc);
    };
    /**
     * Throws error if crypto object not found.
     * @param operationName
     */ ClientAuthError.createNoCryptoObjectError = function(operationName) {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.noCryptoObj.code, "" + $30cd164be78785f3$export$51eee17394e135b.noCryptoObj.desc + operationName);
    };
    /**
     * Throws error if cache type is invalid.
     */ ClientAuthError.createInvalidCacheTypeError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.invalidCacheType.code, "" + $30cd164be78785f3$export$51eee17394e135b.invalidCacheType.desc);
    };
    /**
     * Throws error if unexpected account type.
     */ ClientAuthError.createUnexpectedAccountTypeError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.unexpectedAccountType.code, "" + $30cd164be78785f3$export$51eee17394e135b.unexpectedAccountType.desc);
    };
    /**
     * Throws error if unexpected credential type.
     */ ClientAuthError.createUnexpectedCredentialTypeError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.unexpectedCredentialType.code, "" + $30cd164be78785f3$export$51eee17394e135b.unexpectedCredentialType.desc);
    };
    /**
     * Throws error if client assertion is not valid.
     */ ClientAuthError.createInvalidAssertionError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.invalidAssertion.code, "" + $30cd164be78785f3$export$51eee17394e135b.invalidAssertion.desc);
    };
    /**
     * Throws error if client assertion is not valid.
     */ ClientAuthError.createInvalidCredentialError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.invalidClientCredential.code, "" + $30cd164be78785f3$export$51eee17394e135b.invalidClientCredential.desc);
    };
    /**
     * Throws error if token cannot be retrieved from cache due to refresh being required.
     */ ClientAuthError.createRefreshRequiredError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.tokenRefreshRequired.code, $30cd164be78785f3$export$51eee17394e135b.tokenRefreshRequired.desc);
    };
    /**
     * Throws error if the user defined timeout is reached.
     */ ClientAuthError.createUserTimeoutReachedError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.userTimeoutReached.code, $30cd164be78785f3$export$51eee17394e135b.userTimeoutReached.desc);
    };
    /*
     * Throws error if token claims are not populated for a signed jwt generation
     */ ClientAuthError.createTokenClaimsRequiredError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.tokenClaimsRequired.code, $30cd164be78785f3$export$51eee17394e135b.tokenClaimsRequired.desc);
    };
    /**
     * Throws error when the authorization code is missing from the server response
     */ ClientAuthError.createNoAuthCodeInServerResponseError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.noAuthorizationCodeFromServer.code, $30cd164be78785f3$export$51eee17394e135b.noAuthorizationCodeFromServer.desc);
    };
    ClientAuthError.createBindingKeyNotRemovedError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.bindingKeyNotRemovedError.code, $30cd164be78785f3$export$51eee17394e135b.bindingKeyNotRemovedError.desc);
    };
    /**
     * Thrown when logout is attempted for an authority that doesnt have an end_session_endpoint
     */ ClientAuthError.createLogoutNotSupportedError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.logoutNotSupported.code, $30cd164be78785f3$export$51eee17394e135b.logoutNotSupported.desc);
    };
    /**
     * Create an error when kid attribute is missing from a PoP token's cache record
     */ ClientAuthError.createKeyIdMissingError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.keyIdMissing.code, $30cd164be78785f3$export$51eee17394e135b.keyIdMissing.desc);
    };
    /**
     * Create an error when the client does not have network connectivity
     */ ClientAuthError.createNoNetworkConnectivityError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.noNetworkConnectivity.code, $30cd164be78785f3$export$51eee17394e135b.noNetworkConnectivity.desc);
    };
    /**
     * Create an error when the user cancels the flow
     */ ClientAuthError.createUserCanceledError = function() {
        return new ClientAuthError($30cd164be78785f3$export$51eee17394e135b.userCanceledError.code, $30cd164be78785f3$export$51eee17394e135b.userCanceledError.desc);
    };
    return ClientAuthError;
}((0, $7f0aeee92385582d$export$145273558d58e0ac));


/*! @azure/msal-common v13.1.0 2023-06-07 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ var $1842614da3ac031b$export$ecc754f99843e759 = /** @class */ function() {
    function StringUtils() {}
    /**
     * decode a JWT
     *
     * @param authToken
     */ StringUtils.decodeAuthToken = function(authToken) {
        if (StringUtils.isEmpty(authToken)) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createTokenNullOrEmptyError(authToken);
        var tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
        var matches = tokenPartsRegex.exec(authToken);
        if (!matches || matches.length < 4) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createTokenParsingError("Given token is malformed: " + JSON.stringify(authToken));
        var crackedToken = {
            header: matches[1],
            JWSPayload: matches[2],
            JWSSig: matches[3]
        };
        return crackedToken;
    };
    /**
     * Check if a string is empty.
     *
     * @param str
     */ StringUtils.isEmpty = function(str) {
        return typeof str === "undefined" || !str || 0 === str.length;
    };
    /**
     * Check if stringified object is empty
     * @param strObj
     */ StringUtils.isEmptyObj = function(strObj) {
        if (strObj && !StringUtils.isEmpty(strObj)) try {
            var obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    };
    StringUtils.startsWith = function(str, search) {
        return str.indexOf(search) === 0;
    };
    StringUtils.endsWith = function(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    };
    /**
     * Parses string into an object.
     *
     * @param query
     */ StringUtils.queryStringToObject = function(query) {
        var obj = {};
        var params = query.split("&");
        var decode = function(s) {
            return decodeURIComponent(s.replace(/\+/g, " "));
        };
        params.forEach(function(pair) {
            if (pair.trim()) {
                var _a = pair.split(/=(.+)/g, 2), key = _a[0], value = _a[1]; // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    };
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ StringUtils.trimArrayEntries = function(arr) {
        return arr.map(function(entry) {
            return entry.trim();
        });
    };
    /**
     * Removes empty strings from array
     * @param arr
     */ StringUtils.removeEmptyStringsFromArray = function(arr) {
        return arr.filter(function(entry) {
            return !StringUtils.isEmpty(entry);
        });
    };
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ StringUtils.jsonParseHelper = function(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    };
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */ StringUtils.matchPattern = function(pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */ var regex = new RegExp(pattern.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\?")); // eslint-disable-line security/detect-non-literal-regexp
        return regex.test(input);
    };
    return StringUtils;
}();



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $c78bc4095f73f45d$export$575e1419cfbab7f8(rawClientInfo, crypto) {
    if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(rawClientInfo)) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createClientInfoEmptyError();
    try {
        var decodedClientInfo = crypto.base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, $30cd164be78785f3$export$a839ff85a7957561).createClientInfoDecodingError(e.message);
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $c78bc4095f73f45d$export$63508a6d6b7dbe07(homeAccountId) {
    if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(homeAccountId)) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createClientInfoDecodingError("Home account ID was empty.");
    var clientInfoParts = homeAccountId.split((0, $1b76d687a319d9ed$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING : clientInfoParts[1]
    };
}




/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ var $26d2ec0e655e729b$export$cd82032b224a3839;
(function(AuthorityType) {
    AuthorityType[AuthorityType["Default"] = 0] = "Default";
    AuthorityType[AuthorityType["Adfs"] = 1] = "Adfs";
    AuthorityType[AuthorityType["Dsts"] = 2] = "Dsts";
    AuthorityType[AuthorityType["Ciam"] = 3] = "Ciam";
})($26d2ec0e655e729b$export$cd82032b224a3839 || ($26d2ec0e655e729b$export$cd82032b224a3839 = {}));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      clientInfo: Full base64 encoded client info received from ESTS
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      idTokenClaims: Object containing claims parsed from ID token
 *      nativeAccountId: Account identifier on the native device
 * }
 */ var $5d6dde05c7528aa5$export$680160523e6bfa6a = /** @class */ function() {
    function AccountEntity() {}
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */ AccountEntity.prototype.generateAccountId = function() {
        var accountId = [
            this.homeAccountId,
            this.environment
        ];
        return accountId.join((0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generate Account Cache Key as per the schema: <home_account_id>-<environment>-<realm*>
     */ AccountEntity.prototype.generateAccountKey = function() {
        return AccountEntity.generateAccountCacheKey({
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId
        });
    };
    /**
     * returns the type of the cache (in this case account)
     */ AccountEntity.prototype.generateType = function() {
        switch(this.authorityType){
            case (0, $1b76d687a319d9ed$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE:
                return (0, $1b76d687a319d9ed$export$ba193b555633db78).ADFS;
            case (0, $1b76d687a319d9ed$export$23244fafa2e7f55c).MSAV1_ACCOUNT_TYPE:
                return (0, $1b76d687a319d9ed$export$ba193b555633db78).MSA;
            case (0, $1b76d687a319d9ed$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE:
                return (0, $1b76d687a319d9ed$export$ba193b555633db78).MSSTS;
            case (0, $1b76d687a319d9ed$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE:
                return (0, $1b76d687a319d9ed$export$ba193b555633db78).GENERIC;
            default:
                throw (0, $30cd164be78785f3$export$a839ff85a7957561).createUnexpectedAccountTypeError();
        }
    };
    /**
     * Returns the AccountInfo interface for this account.
     */ AccountEntity.prototype.getAccountInfo = function() {
        return {
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId,
            name: this.name,
            idTokenClaims: this.idTokenClaims,
            nativeAccountId: this.nativeAccountId
        };
    };
    /**
     * Generates account key from interface
     * @param accountInterface
     */ AccountEntity.generateAccountCacheKey = function(accountInterface) {
        var accountKey = [
            accountInterface.homeAccountId,
            accountInterface.environment || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            accountInterface.tenantId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        ];
        return accountKey.join((0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param clientInfo
     * @param authority
     * @param idToken
     * @param policy
     */ AccountEntity.createAccount = function(clientInfo, homeAccountId, idToken, authority, cloudGraphHostName, msGraphHost, environment, nativeAccountId) {
        var _a, _b, _c, _d, _e, _f;
        var account = new AccountEntity();
        account.authorityType = (0, $1b76d687a319d9ed$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE;
        account.clientInfo = clientInfo;
        account.homeAccountId = homeAccountId;
        account.nativeAccountId = nativeAccountId;
        var env = environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createInvalidCacheEnvironmentError();
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.tid) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        if (idToken) {
            account.idTokenClaims = idToken.claims;
            // How do you account for MSA CID here?
            account.localAccountId = ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.oid) || ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.sub) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            /*
             * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
             * In most cases it will contain a single email. This field should not be relied upon if a custom
             * policy is configured to return more than 1 email.
             */ var preferredUsername = (_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.preferred_username;
            var email = ((_e = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _e === void 0 ? void 0 : _e.emails) ? idToken.claims.emails[0] : null;
            account.username = preferredUsername || email || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            account.name = (_f = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _f === void 0 ? void 0 : _f.name;
        }
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        return account;
    };
    /**
     * Builds non-AAD/ADFS account.
     * @param authority
     * @param idToken
     */ AccountEntity.createGenericAccount = function(homeAccountId, idToken, authority, cloudGraphHostName, msGraphHost, environment) {
        var _a, _b, _c, _d;
        var account = new AccountEntity();
        account.authorityType = authority && authority.authorityType === (0, $26d2ec0e655e729b$export$cd82032b224a3839).Adfs ? (0, $1b76d687a319d9ed$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE : (0, $1b76d687a319d9ed$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = homeAccountId;
        // non AAD scenarios can have empty realm
        account.realm = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        var env = environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createInvalidCacheEnvironmentError();
        if (idToken) {
            // How do you account for MSA CID here?
            account.localAccountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.oid) || ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.sub) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            // upn claim for most ADFS scenarios
            account.username = ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.upn) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            account.name = ((_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.name) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            account.idTokenClaims = idToken === null || idToken === void 0 ? void 0 : idToken.claims;
        }
        account.environment = env;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        /*
         * add uniqueName to claims
         * account.name = idToken.claims.uniqueName;
         */ return account;
    };
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */ AccountEntity.generateHomeAccountId = function(serverClientInfo, authType, logger, cryptoObj, idToken) {
        var _a;
        var accountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.sub) ? idToken.claims.sub : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        // since ADFS does not have tid and does not set client_info
        if (authType === (0, $26d2ec0e655e729b$export$cd82032b224a3839).Adfs || authType === (0, $26d2ec0e655e729b$export$cd82032b224a3839).Dsts) return accountId;
        // for cases where there is clientInfo
        if (serverClientInfo) try {
            var clientInfo = (0, $c78bc4095f73f45d$export$575e1419cfbab7f8)(serverClientInfo, cryptoObj);
            if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(clientInfo.uid) && !(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(clientInfo.utid)) return "" + clientInfo.uid + (0, $1b76d687a319d9ed$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR + clientInfo.utid;
        } catch (e) {}
        // default to "sub" claim
        logger.verbose("No client info in response");
        return accountId;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ AccountEntity.isAccountEntity = function(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
    };
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */ AccountEntity.accountInfoIsEqual = function(accountA, accountB, compareClaims) {
        if (!accountA || !accountB) return false;
        var claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            var accountAClaims = accountA.idTokenClaims || {};
            var accountBClaims = accountB.idTokenClaims || {};
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
        }
        return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
    };
    return AccountEntity;
}();

/*! @azure/msal-browser v2.37.1 2023-06-07 */ /*! @azure/msal-browser v2.37.1 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $8576a8f6fd30fa65$export$3d7865934588d77e;
(function(EventType) {
    EventType["INITIALIZE_START"] = "msal:initializeStart";
    EventType["INITIALIZE_END"] = "msal:initializeEnd";
    EventType["ACCOUNT_ADDED"] = "msal:accountAdded";
    EventType["ACCOUNT_REMOVED"] = "msal:accountRemoved";
    EventType["LOGIN_START"] = "msal:loginStart";
    EventType["LOGIN_SUCCESS"] = "msal:loginSuccess";
    EventType["LOGIN_FAILURE"] = "msal:loginFailure";
    EventType["ACQUIRE_TOKEN_START"] = "msal:acquireTokenStart";
    EventType["ACQUIRE_TOKEN_SUCCESS"] = "msal:acquireTokenSuccess";
    EventType["ACQUIRE_TOKEN_FAILURE"] = "msal:acquireTokenFailure";
    EventType["ACQUIRE_TOKEN_NETWORK_START"] = "msal:acquireTokenFromNetworkStart";
    EventType["SSO_SILENT_START"] = "msal:ssoSilentStart";
    EventType["SSO_SILENT_SUCCESS"] = "msal:ssoSilentSuccess";
    EventType["SSO_SILENT_FAILURE"] = "msal:ssoSilentFailure";
    EventType["ACQUIRE_TOKEN_BY_CODE_START"] = "msal:acquireTokenByCodeStart";
    EventType["ACQUIRE_TOKEN_BY_CODE_SUCCESS"] = "msal:acquireTokenByCodeSuccess";
    EventType["ACQUIRE_TOKEN_BY_CODE_FAILURE"] = "msal:acquireTokenByCodeFailure";
    EventType["HANDLE_REDIRECT_START"] = "msal:handleRedirectStart";
    EventType["HANDLE_REDIRECT_END"] = "msal:handleRedirectEnd";
    EventType["POPUP_OPENED"] = "msal:popupOpened";
    EventType["LOGOUT_START"] = "msal:logoutStart";
    EventType["LOGOUT_SUCCESS"] = "msal:logoutSuccess";
    EventType["LOGOUT_FAILURE"] = "msal:logoutFailure";
    EventType["LOGOUT_END"] = "msal:logoutEnd";
    EventType["RESTORE_FROM_BFCACHE"] = "msal:restoreFromBFCache";
})($8576a8f6fd30fa65$export$3d7865934588d77e || ($8576a8f6fd30fa65$export$3d7865934588d77e = {}));


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ var $7b3089fdde5d004f$export$a0a689e4294b9880 = {
    /**
     * Interaction in progress cache value
     */ INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */ DEFAULT_POLL_INTERVAL_MS: 30,
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
var $7b3089fdde5d004f$export$fec113838800867f = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS"
};
var $7b3089fdde5d004f$export$3536098be6c7dadb;
(function(NativeExtensionMethod) {
    NativeExtensionMethod["HandshakeRequest"] = "Handshake";
    NativeExtensionMethod["HandshakeResponse"] = "HandshakeResponse";
    NativeExtensionMethod["GetToken"] = "GetToken";
    NativeExtensionMethod["Response"] = "Response";
})($7b3089fdde5d004f$export$3536098be6c7dadb || ($7b3089fdde5d004f$export$3536098be6c7dadb = {}));
var $7b3089fdde5d004f$export$573384e47a12d835;
(function(BrowserCacheLocation) {
    BrowserCacheLocation["LocalStorage"] = "localStorage";
    BrowserCacheLocation["SessionStorage"] = "sessionStorage";
    BrowserCacheLocation["MemoryStorage"] = "memoryStorage";
})($7b3089fdde5d004f$export$573384e47a12d835 || ($7b3089fdde5d004f$export$573384e47a12d835 = {}));
/**
 * HTTP Request types supported by MSAL.
 */ var $7b3089fdde5d004f$export$c774c31b4c31da8;
(function(HTTP_REQUEST_TYPE) {
    HTTP_REQUEST_TYPE["GET"] = "GET";
    HTTP_REQUEST_TYPE["POST"] = "POST";
})($7b3089fdde5d004f$export$c774c31b4c31da8 || ($7b3089fdde5d004f$export$c774c31b4c31da8 = {}));
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ var $7b3089fdde5d004f$export$21d55bedf0d269fb;
(function(TemporaryCacheKeys) {
    TemporaryCacheKeys["AUTHORITY"] = "authority";
    TemporaryCacheKeys["ACQUIRE_TOKEN_ACCOUNT"] = "acquireToken.account";
    TemporaryCacheKeys["SESSION_STATE"] = "session.state";
    TemporaryCacheKeys["REQUEST_STATE"] = "request.state";
    TemporaryCacheKeys["NONCE_IDTOKEN"] = "nonce.id_token";
    TemporaryCacheKeys["ORIGIN_URI"] = "request.origin";
    TemporaryCacheKeys["RENEW_STATUS"] = "token.renew.status";
    TemporaryCacheKeys["URL_HASH"] = "urlHash";
    TemporaryCacheKeys["REQUEST_PARAMS"] = "request.params";
    TemporaryCacheKeys["SCOPES"] = "scopes";
    TemporaryCacheKeys["INTERACTION_STATUS_KEY"] = "interaction.status";
    TemporaryCacheKeys["CCS_CREDENTIAL"] = "ccs.credential";
    TemporaryCacheKeys["CORRELATION_ID"] = "request.correlationId";
    TemporaryCacheKeys["NATIVE_REQUEST"] = "request.native";
    TemporaryCacheKeys["REDIRECT_CONTEXT"] = "request.redirect.context";
})($7b3089fdde5d004f$export$21d55bedf0d269fb || ($7b3089fdde5d004f$export$21d55bedf0d269fb = {}));
var $7b3089fdde5d004f$export$f6ce23cce692699f;
(function(StaticCacheKeys) {
    StaticCacheKeys["ACCOUNT_KEYS"] = "msal.account.keys";
    StaticCacheKeys["TOKEN_KEYS"] = "msal.token.keys";
})($7b3089fdde5d004f$export$f6ce23cce692699f || ($7b3089fdde5d004f$export$f6ce23cce692699f = {}));
/**
 * Cache keys stored in-memory
 */ var $7b3089fdde5d004f$export$8f546f90896bcfa9;
(function(InMemoryCacheKeys) {
    InMemoryCacheKeys["WRAPPER_SKU"] = "wrapper.sku";
    InMemoryCacheKeys["WRAPPER_VER"] = "wrapper.version";
})($7b3089fdde5d004f$export$8f546f90896bcfa9 || ($7b3089fdde5d004f$export$8f546f90896bcfa9 = {}));
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 */ var $7b3089fdde5d004f$export$192d74ad69b40705;
(function(ApiId) {
    ApiId[ApiId["acquireTokenRedirect"] = 861] = "acquireTokenRedirect";
    ApiId[ApiId["acquireTokenPopup"] = 862] = "acquireTokenPopup";
    ApiId[ApiId["ssoSilent"] = 863] = "ssoSilent";
    ApiId[ApiId["acquireTokenSilent_authCode"] = 864] = "acquireTokenSilent_authCode";
    ApiId[ApiId["handleRedirectPromise"] = 865] = "handleRedirectPromise";
    ApiId[ApiId["acquireTokenByCode"] = 866] = "acquireTokenByCode";
    ApiId[ApiId["acquireTokenSilent_silentFlow"] = 61] = "acquireTokenSilent_silentFlow";
    ApiId[ApiId["logout"] = 961] = "logout";
    ApiId[ApiId["logoutPopup"] = 962] = "logoutPopup";
})($7b3089fdde5d004f$export$192d74ad69b40705 || ($7b3089fdde5d004f$export$192d74ad69b40705 = {}));
/*
 * Interaction type of the API - used for state and telemetry
 */ var $7b3089fdde5d004f$export$4ec29255e7e7f68f;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($7b3089fdde5d004f$export$4ec29255e7e7f68f || ($7b3089fdde5d004f$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ var $7b3089fdde5d004f$export$bec20eda0179362b;
(function(InteractionStatus) {
    /**
     * Initial status before interaction occurs
     */ InteractionStatus["Startup"] = "startup";
    /**
     * Status set when all login calls occuring
     */ InteractionStatus["Login"] = "login";
    /**
     * Status set when logout call occuring
     */ InteractionStatus["Logout"] = "logout";
    /**
     * Status set for acquireToken calls
     */ InteractionStatus["AcquireToken"] = "acquireToken";
    /**
     * Status set for ssoSilent calls
     */ InteractionStatus["SsoSilent"] = "ssoSilent";
    /**
     * Status set when handleRedirect in progress
     */ InteractionStatus["HandleRedirect"] = "handleRedirect";
    /**
     * Status set when interaction is complete
     */ InteractionStatus["None"] = "none";
})($7b3089fdde5d004f$export$bec20eda0179362b || ($7b3089fdde5d004f$export$bec20eda0179362b = {}));
var $7b3089fdde5d004f$export$7e12949cd6884193 = {
    scopes: (0, $1b76d687a319d9ed$export$893b1b5b686d84ef)
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ var $7b3089fdde5d004f$export$1294c3e3f84694cd = "jwk";
// Supported wrapper SKUs
var $7b3089fdde5d004f$export$8abb9de997bb4e44;
(function(WrapperSKU) {
    WrapperSKU["React"] = "@azure/msal-react";
    WrapperSKU["Angular"] = "@azure/msal-angular";
})($7b3089fdde5d004f$export$8abb9de997bb4e44 || ($7b3089fdde5d004f$export$8abb9de997bb4e44 = {}));
// DatabaseStorage Constants
var $7b3089fdde5d004f$export$3c22ff8b64b8f565 = "msal.db";
var $7b3089fdde5d004f$export$6a9022b4c5fcea02 = 1;
var $7b3089fdde5d004f$export$9d785db034fb436f = $7b3089fdde5d004f$export$3c22ff8b64b8f565 + ".keys";
var $7b3089fdde5d004f$export$4394baa7e922d42d;
(function(CacheLookupPolicy) {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ CacheLookupPolicy[CacheLookupPolicy["Default"] = 0] = "Default";
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ CacheLookupPolicy[CacheLookupPolicy["AccessToken"] = 1] = "AccessToken";
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ CacheLookupPolicy[CacheLookupPolicy["AccessTokenAndRefreshToken"] = 2] = "AccessTokenAndRefreshToken";
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ CacheLookupPolicy[CacheLookupPolicy["RefreshToken"] = 3] = "RefreshToken";
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ CacheLookupPolicy[CacheLookupPolicy["RefreshTokenAndNetwork"] = 4] = "RefreshTokenAndNetwork";
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ CacheLookupPolicy[CacheLookupPolicy["Skip"] = 5] = "Skip";
})($7b3089fdde5d004f$export$4394baa7e922d42d || ($7b3089fdde5d004f$export$4394baa7e922d42d = {}));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $7a81b544a5e6867b$export$ba9166e03da6599c = /** @class */ function() {
    function EventMessageUtils() {}
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */ EventMessageUtils.getInteractionStatusFromEvent = function(message, currentStatus) {
        switch(message.eventType){
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_START:
                return (0, $7b3089fdde5d004f$export$bec20eda0179362b).Login;
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).SSO_SILENT_START:
                return (0, $7b3089fdde5d004f$export$bec20eda0179362b).SsoSilent;
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_START:
                if (message.interactionType === (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup) return (0, $7b3089fdde5d004f$export$bec20eda0179362b).AcquireToken;
                break;
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).HANDLE_REDIRECT_START:
                return (0, $7b3089fdde5d004f$export$bec20eda0179362b).HandleRedirect;
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_START:
                return (0, $7b3089fdde5d004f$export$bec20eda0179362b).Logout;
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                if (currentStatus && currentStatus !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).SsoSilent) break;
                return (0, $7b3089fdde5d004f$export$bec20eda0179362b).None;
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_END:
                if (currentStatus && currentStatus !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).Logout) break;
                return (0, $7b3089fdde5d004f$export$bec20eda0179362b).None;
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).HandleRedirect) break;
                return (0, $7b3089fdde5d004f$export$bec20eda0179362b).None;
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_SUCCESS:
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_FAILURE:
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS:
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE:
            case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).RESTORE_FROM_BFCACHE:
                if (message.interactionType === (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup) {
                    if (currentStatus && currentStatus !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).Login && currentStatus !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).AcquireToken) break;
                    return (0, $7b3089fdde5d004f$export$bec20eda0179362b).None;
                }
                break;
        }
        return null;
    };
    return EventMessageUtils;
}();

/*! @azure/msal-common v13.1.0 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ var $dec424bb7347a355$export$e16d6a6c677acec5 = [
    "interaction_required",
    "consent_required",
    "login_required"
];
var $dec424bb7347a355$export$9689959ec6716811 = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required"
];
/**
 * Interaction required errors defined by the SDK
 */ var $dec424bb7347a355$export$d44d3b7b7a580eb6 = {
    noTokensFoundError: {
        code: "no_tokens_found",
        desc: "No refresh token found in the cache. Please sign-in."
    },
    native_account_unavailable: {
        code: "native_account_unavailable",
        desc: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API."
    }
};
/**
 * Error thrown when user interaction is required.
 */ var $dec424bb7347a355$export$6ba3e818c6bc76ba = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(InteractionRequiredAuthError, _super);
    function InteractionRequiredAuthError(errorCode, errorMessage, subError, timestamp, traceId, correlationId, claims) {
        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
        Object.setPrototypeOf(_this, InteractionRequiredAuthError.prototype);
        _this.timestamp = timestamp || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        _this.traceId = traceId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        _this.correlationId = correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        _this.claims = claims || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        _this.name = "InteractionRequiredAuthError";
        return _this;
    }
    /**
     * Helper function used to determine if an error thrown by the server requires interaction to resolve
     * @param errorCode
     * @param errorString
     * @param subError
     */ InteractionRequiredAuthError.isInteractionRequiredError = function(errorCode, errorString, subError) {
        var isInteractionRequiredErrorCode = !!errorCode && $dec424bb7347a355$export$e16d6a6c677acec5.indexOf(errorCode) > -1;
        var isInteractionRequiredSubError = !!subError && $dec424bb7347a355$export$9689959ec6716811.indexOf(subError) > -1;
        var isInteractionRequiredErrorDesc = !!errorString && $dec424bb7347a355$export$e16d6a6c677acec5.some(function(irErrorCode) {
            return errorString.indexOf(irErrorCode) > -1;
        });
        return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
    };
    /**
     * Creates an error thrown when the authorization code required for a token request is null or empty.
     */ InteractionRequiredAuthError.createNoTokensFoundError = function() {
        return new InteractionRequiredAuthError($dec424bb7347a355$export$d44d3b7b7a580eb6.noTokensFoundError.code, $dec424bb7347a355$export$d44d3b7b7a580eb6.noTokensFoundError.desc);
    };
    /**
     * Creates an error thrown when the native broker returns ACCOUNT_UNAVAILABLE status, indicating that the account was removed and interactive sign-in is required
     * @returns
     */ InteractionRequiredAuthError.createNativeAccountUnavailableError = function() {
        return new InteractionRequiredAuthError($dec424bb7347a355$export$d44d3b7b7a580eb6.native_account_unavailable.code, $dec424bb7347a355$export$d44d3b7b7a580eb6.native_account_unavailable.desc);
    };
    return InteractionRequiredAuthError;
}((0, $7f0aeee92385582d$export$145273558d58e0ac));

/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $176db342bac9b10e$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($176db342bac9b10e$export$243e62d78d3b544d || ($176db342bac9b10e$export$243e62d78d3b544d = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */ var $176db342bac9b10e$export$efa9a398d6368992 = /** @class */ function() {
    function Logger(loggerOptions, packageName, packageVersion) {
        // Current log level, defaults to info.
        this.level = $176db342bac9b10e$export$243e62d78d3b544d.Info;
        var defaultLoggerCallback = function() {
            return;
        };
        var setLoggerOptions = loggerOptions || Logger.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $176db342bac9b10e$export$243e62d78d3b544d.Info;
        this.correlationId = setLoggerOptions.correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        this.packageName = packageName || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        this.packageVersion = packageVersion || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
    }
    Logger.createDefaultLoggerOptions = function() {
        return {
            loggerCallback: function() {
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Info
        };
    };
    /**
     * Create new Logger with existing configurations.
     */ Logger.prototype.clone = function(packageName, packageVersion, correlationId) {
        return new Logger({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level,
            correlationId: correlationId || this.correlationId
        }, packageName, packageVersion);
    };
    /**
     * Log message with required options.
     */ Logger.prototype.logMessage = function(logMessage, options) {
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        var timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        var logHeader;
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(options.correlationId)) logHeader = "[" + timestamp + "] : [" + options.correlationId + "]";
        else if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(this.correlationId)) logHeader = "[" + timestamp + "] : [" + this.correlationId + "]";
        else logHeader = "[" + timestamp + "]";
        var log = logHeader + " : " + this.packageName + "@" + this.packageVersion + " : " + $176db342bac9b10e$export$243e62d78d3b544d[options.logLevel] + " - " + logMessage;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": Constants.EMPTY_STRING}${options.context ? `:${options.context}` : Constants.EMPTY_STRING}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    };
    /**
     * Execute callback with message.
     */ Logger.prototype.executeCallback = function(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    };
    /**
     * Logs error messages.
     */ Logger.prototype.error = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs error messages with PII.
     */ Logger.prototype.errorPii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs warning messages.
     */ Logger.prototype.warning = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs warning messages with PII.
     */ Logger.prototype.warningPii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs info messages.
     */ Logger.prototype.info = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs info messages with PII.
     */ Logger.prototype.infoPii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs verbose messages.
     */ Logger.prototype.verbose = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs verbose messages with PII.
     */ Logger.prototype.verbosePii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs trace messages.
     */ Logger.prototype.trace = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Logs trace messages with PII.
     */ Logger.prototype.tracePii = function(message, correlationId) {
        this.logMessage(message, {
            logLevel: $176db342bac9b10e$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        });
    };
    /**
     * Returns whether PII Logging is enabled or not.
     */ Logger.prototype.isPiiLoggingEnabled = function() {
        return this.piiLoggingEnabled || false;
    };
    return Logger;
}();

/*! @azure/msal-browser v2.37.1 2023-06-07 */ /*! @azure/msal-browser v2.37.1 2023-06-07 */ /*! @azure/msal-browser v2.37.1 2023-06-07 */ "use strict";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ac3fbc8ec7de8c8c$var$extendStatics = function(d, b) {
    $ac3fbc8ec7de8c8c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ac3fbc8ec7de8c8c$var$extendStatics(d, b);
};
function $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a(d, b) {
    $ac3fbc8ec7de8c8c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ac3fbc8ec7de8c8c$export$18ce0697a983be9b = function() {
    $ac3fbc8ec7de8c8c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ac3fbc8ec7de8c8c$export$18ce0697a983be9b.apply(this, arguments);
};
function $ac3fbc8ec7de8c8c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ac3fbc8ec7de8c8c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ac3fbc8ec7de8c8c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ac3fbc8ec7de8c8c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ac3fbc8ec7de8c8c$export$8d051b38c9118094(arguments[i]));
    return ar;
}



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ var $9979eb0576c15d31$export$daccd9364f884077 = {
    redirectUriNotSet: {
        code: "redirect_uri_empty",
        desc: "A redirect URI is required for all calls, and none has been set."
    },
    postLogoutUriNotSet: {
        code: "post_logout_uri_empty",
        desc: "A post logout redirect has not been set."
    },
    storageNotSupportedError: {
        code: "storage_not_supported",
        desc: "Given storage configuration option was not supported."
    },
    noRedirectCallbacksSet: {
        code: "no_redirect_callbacks",
        desc: "No redirect callbacks have been set. Please call setRedirectCallbacks() with the appropriate function arguments before continuing. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    invalidCallbackObject: {
        code: "invalid_callback_object",
        desc: "The object passed for the callback was invalid. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    stubPcaInstanceCalled: {
        code: "stubbed_public_client_application_called",
        desc: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors"
    },
    inMemRedirectUnavailable: {
        code: "in_mem_redirect_unavailable",
        desc: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
    },
    entropyNotProvided: {
        code: "entropy_not_provided",
        desc: "The available browser crypto interface requires entropy set via system.cryptoOptions.entropy configuration option."
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ var $9979eb0576c15d31$export$2eb7a1dfdc4c5fba = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(BrowserConfigurationAuthError, _super);
    function BrowserConfigurationAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(_this, BrowserConfigurationAuthError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when the redirect uri is empty (not set by caller)
     */ BrowserConfigurationAuthError.createRedirectUriEmptyError = function() {
        return new BrowserConfigurationAuthError($9979eb0576c15d31$export$daccd9364f884077.redirectUriNotSet.code, $9979eb0576c15d31$export$daccd9364f884077.redirectUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
     */ BrowserConfigurationAuthError.createPostLogoutRedirectUriEmptyError = function() {
        return new BrowserConfigurationAuthError($9979eb0576c15d31$export$daccd9364f884077.postLogoutUriNotSet.code, $9979eb0576c15d31$export$daccd9364f884077.postLogoutUriNotSet.desc);
    };
    /**
     * Creates error thrown when given storage location is not supported.
     * @param givenStorageLocation
     */ BrowserConfigurationAuthError.createStorageNotSupportedError = function(givenStorageLocation) {
        return new BrowserConfigurationAuthError($9979eb0576c15d31$export$daccd9364f884077.storageNotSupportedError.code, $9979eb0576c15d31$export$daccd9364f884077.storageNotSupportedError.desc + " Given Location: " + givenStorageLocation);
    };
    /**
     * Creates error thrown when redirect callbacks are not set before calling loginRedirect() or acquireTokenRedirect().
     */ BrowserConfigurationAuthError.createRedirectCallbacksNotSetError = function() {
        return new BrowserConfigurationAuthError($9979eb0576c15d31$export$daccd9364f884077.noRedirectCallbacksSet.code, $9979eb0576c15d31$export$daccd9364f884077.noRedirectCallbacksSet.desc);
    };
    /**
     * Creates error thrown when the stub instance of PublicClientApplication is called.
     */ BrowserConfigurationAuthError.createStubPcaInstanceCalledError = function() {
        return new BrowserConfigurationAuthError($9979eb0576c15d31$export$daccd9364f884077.stubPcaInstanceCalled.code, $9979eb0576c15d31$export$daccd9364f884077.stubPcaInstanceCalled.desc);
    };
    /*
     * Create an error thrown when in-memory storage is used and storeAuthStateInCookie=false.
     */ BrowserConfigurationAuthError.createInMemoryRedirectUnavailableError = function() {
        return new BrowserConfigurationAuthError($9979eb0576c15d31$export$daccd9364f884077.inMemRedirectUnavailable.code, $9979eb0576c15d31$export$daccd9364f884077.inMemRedirectUnavailable.desc);
    };
    /**
     * Creates an error thrown when a crypto interface that requires entropy is initialized without entropy
     */ BrowserConfigurationAuthError.createEntropyNotProvided = function() {
        return new BrowserConfigurationAuthError($9979eb0576c15d31$export$daccd9364f884077.entropyNotProvided.code, $9979eb0576c15d31$export$daccd9364f884077.entropyNotProvided.desc);
    };
    return BrowserConfigurationAuthError;
}((0, $7f0aeee92385582d$export$145273558d58e0ac));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $d642a5e4f4cba21c$export$29650b96fd06034a = {
    initialize: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    acquireTokenPopup: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    acquireTokenRedirect: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    acquireTokenSilent: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    acquireTokenByCode: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    getAllAccounts: function() {
        return [];
    },
    getAccountByHomeId: function() {
        return null;
    },
    getAccountByUsername: function() {
        return null;
    },
    getAccountByLocalId: function() {
        return null;
    },
    handleRedirectPromise: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    loginPopup: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    loginRedirect: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    logout: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    logoutRedirect: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    logoutPopup: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    ssoSilent: function() {
        return Promise.reject((0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError());
    },
    addEventCallback: function() {
        return null;
    },
    removeEventCallback: function() {
        return;
    },
    addPerformanceCallback: function() {
        return "";
    },
    removePerformanceCallback: function() {
        return false;
    },
    enableAccountStorageEvents: function() {
        return;
    },
    disableAccountStorageEvents: function() {
        return;
    },
    getTokenCache: function() {
        throw (0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError();
    },
    getLogger: function() {
        throw (0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError();
    },
    setLogger: function() {
        return;
    },
    setActiveAccount: function() {
        return;
    },
    getActiveAccount: function() {
        return null;
    },
    initializeWrapperLibrary: function() {
        return;
    },
    setNavigationClient: function() {
        return;
    },
    getConfiguration: function() {
        throw (0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStubPcaInstanceCalledError();
    }
};


/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */ const $6552874ea2db8d8d$var$defaultMsalContext = {
    instance: (0, $d642a5e4f4cba21c$export$29650b96fd06034a),
    inProgress: (0, $7b3089fdde5d004f$export$bec20eda0179362b).None,
    accounts: [],
    logger: /*#__PURE__*/ new (0, $176db342bac9b10e$export$efa9a398d6368992)({})
};
const $6552874ea2db8d8d$export$66324aeea97dd1e5 = /*#__PURE__*/ (0, $ld5Xm.createContext)($6552874ea2db8d8d$var$defaultMsalContext);
const $6552874ea2db8d8d$export$b74154d0810e24c1 = $6552874ea2db8d8d$export$66324aeea97dd1e5.Consumer;
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $6552874ea2db8d8d$var$getChildrenOrFunction(children, args) {
    if (typeof children === "function") return children(args);
    return children;
}
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */ function $6552874ea2db8d8d$var$accountArraysAreEqual(arrayA, arrayB) {
    if (arrayA.length !== arrayB.length) return false;
    const comparisonArray = [
        ...arrayB
    ];
    return arrayA.every((elementA)=>{
        const elementB = comparisonArray.shift();
        if (!elementA || !elementB) return false;
        return elementA.homeAccountId === elementB.homeAccountId && elementA.localAccountId === elementB.localAccountId && elementA.username === elementB.username;
    });
}
function $6552874ea2db8d8d$var$getAccountByIdentifiers(allAccounts, accountIdentifiers) {
    if (allAccounts.length > 0 && (accountIdentifiers.homeAccountId || accountIdentifiers.localAccountId || accountIdentifiers.username)) {
        const matchedAccounts = allAccounts.filter((accountObj)=>{
            if (accountIdentifiers.username && accountIdentifiers.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountIdentifiers.homeAccountId && accountIdentifiers.homeAccountId.toLowerCase() !== accountObj.homeAccountId.toLowerCase()) return false;
            if (accountIdentifiers.localAccountId && accountIdentifiers.localAccountId.toLowerCase() !== accountObj.localAccountId.toLowerCase()) return false;
            return true;
        });
        return matchedAccounts[0] || null;
    } else return null;
}
/* eslint-disable header/header */ const $6552874ea2db8d8d$var$name = "@azure/msal-react";
const $6552874ea2db8d8d$export$83d89fbfd8236492 = "1.5.8";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $6552874ea2db8d8d$var$MsalProviderActionType;
(function(MsalProviderActionType) {
    MsalProviderActionType["UNBLOCK_INPROGRESS"] = "UNBLOCK_INPROGRESS";
    MsalProviderActionType["EVENT"] = "EVENT";
})($6552874ea2db8d8d$var$MsalProviderActionType || ($6552874ea2db8d8d$var$MsalProviderActionType = {}));
/**
 * Returns the next inProgress and accounts state based on event message
 * @param previousState
 * @param action
 */ const $6552874ea2db8d8d$var$reducer = (previousState, action)=>{
    const { type: type, payload: payload } = action;
    let newInProgress = previousState.inProgress;
    switch(type){
        case $6552874ea2db8d8d$var$MsalProviderActionType.UNBLOCK_INPROGRESS:
            if (previousState.inProgress === (0, $7b3089fdde5d004f$export$bec20eda0179362b).Startup) {
                newInProgress = (0, $7b3089fdde5d004f$export$bec20eda0179362b).None;
                payload.logger.info("MsalProvider - handleRedirectPromise resolved, setting inProgress to 'none'");
            }
            break;
        case $6552874ea2db8d8d$var$MsalProviderActionType.EVENT:
            const message = payload.message;
            const status = (0, $7a81b544a5e6867b$export$ba9166e03da6599c).getInteractionStatusFromEvent(message, previousState.inProgress);
            if (status) {
                payload.logger.info(`MsalProvider - ${message.eventType} results in setting inProgress from ${previousState.inProgress} to ${status}`);
                newInProgress = status;
            }
            break;
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
    const currentAccounts = payload.instance.getAllAccounts();
    if (newInProgress !== previousState.inProgress && !$6552874ea2db8d8d$var$accountArraysAreEqual(currentAccounts, previousState.accounts)) // Both inProgress and accounts changed
    return {
        ...previousState,
        inProgress: newInProgress,
        accounts: currentAccounts
    };
    else if (newInProgress !== previousState.inProgress) // Only only inProgress changed
    return {
        ...previousState,
        inProgress: newInProgress
    };
    else if (!$6552874ea2db8d8d$var$accountArraysAreEqual(currentAccounts, previousState.accounts)) // Only accounts changed
    return {
        ...previousState,
        accounts: currentAccounts
    };
    else // Nothing changed
    return previousState;
};
/**
 * MSAL context provider component. This must be rendered above any other components that use MSAL.
 */ function $6552874ea2db8d8d$export$25bac41dc3d78d47(_ref) {
    let { instance: instance, children: children } = _ref;
    (0, $ld5Xm.useEffect)(()=>{
        instance.initializeWrapperLibrary((0, $7b3089fdde5d004f$export$8abb9de997bb4e44).React, $6552874ea2db8d8d$export$83d89fbfd8236492);
    }, [
        instance
    ]); // Create a logger instance for msal-react with the same options as PublicClientApplication
    const logger = (0, $ld5Xm.useMemo)(()=>{
        return instance.getLogger().clone($6552874ea2db8d8d$var$name, $6552874ea2db8d8d$export$83d89fbfd8236492);
    }, [
        instance
    ]);
    const [state, updateState] = (0, $ld5Xm.useReducer)($6552874ea2db8d8d$var$reducer, undefined, ()=>{
        // Lazy initialization of the initial state
        return {
            inProgress: (0, $7b3089fdde5d004f$export$bec20eda0179362b).Startup,
            accounts: instance.getAllAccounts()
        };
    });
    (0, $ld5Xm.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            updateState({
                payload: {
                    instance: instance,
                    logger: logger,
                    message: message
                },
                type: $6552874ea2db8d8d$var$MsalProviderActionType.EVENT
            });
        });
        logger.verbose(`MsalProvider - Registered event callback with id: ${callbackId}`);
        instance.initialize().then(()=>{
            instance.handleRedirectPromise().catch(()=>{
                // Errors should be handled by listening to the LOGIN_FAILURE event
                return;
            }).finally(()=>{
                /*
         * If handleRedirectPromise returns a cached promise the necessary events may not be fired
         * This is a fallback to prevent inProgress from getting stuck in 'startup'
         */ updateState({
                    payload: {
                        instance: instance,
                        logger: logger
                    },
                    type: $6552874ea2db8d8d$var$MsalProviderActionType.UNBLOCK_INPROGRESS
                });
            });
        });
        return ()=>{
            // Remove callback when component unmounts or accounts change
            if (callbackId) {
                logger.verbose(`MsalProvider - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    const contextValue = {
        instance: instance,
        inProgress: state.inProgress,
        accounts: state.accounts,
        logger: logger
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).createElement($6552874ea2db8d8d$export$66324aeea97dd1e5.Provider, {
        value: contextValue
    }, children);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns Msal Context values
 */ const $6552874ea2db8d8d$export$f41558044a1dd55 = ()=>(0, $ld5Xm.useContext)($6552874ea2db8d8d$export$66324aeea97dd1e5);
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $6552874ea2db8d8d$var$isAuthenticated(allAccounts, matchAccount) {
    if (matchAccount && (matchAccount.username || matchAccount.homeAccountId || matchAccount.localAccountId)) return !!$6552874ea2db8d8d$var$getAccountByIdentifiers(allAccounts, matchAccount);
    return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */ function $6552874ea2db8d8d$export$7e9c60d6d1836c84(matchAccount) {
    const { accounts: allAccounts, inProgress: inProgress } = $6552874ea2db8d8d$export$f41558044a1dd55();
    const [hasAuthenticated, setHasAuthenticated] = (0, $ld5Xm.useState)(()=>{
        if (inProgress === (0, $7b3089fdde5d004f$export$bec20eda0179362b).Startup) return false;
        return $6552874ea2db8d8d$var$isAuthenticated(allAccounts, matchAccount);
    });
    (0, $ld5Xm.useEffect)(()=>{
        setHasAuthenticated($6552874ea2db8d8d$var$isAuthenticated(allAccounts, matchAccount));
    }, [
        allAccounts,
        matchAccount
    ]);
    return hasAuthenticated;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is authenticated
 * @param props
 */ function $6552874ea2db8d8d$export$3f7734c901feade6(_ref) {
    let { username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children } = _ref;
    const context = $6552874ea2db8d8d$export$f41558044a1dd55();
    const accountIdentifier = (0, $ld5Xm.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = $6552874ea2db8d8d$export$7e9c60d6d1836c84(accountIdentifier);
    if (isAuthenticated && context.inProgress !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).Startup) return (0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).Fragment, null, $6552874ea2db8d8d$var$getChildrenOrFunction(children, context));
    return null;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is unauthenticated
 * @param props
 */ function $6552874ea2db8d8d$export$8285a35799c5812b(_ref) {
    let { username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children } = _ref;
    const context = $6552874ea2db8d8d$export$f41558044a1dd55();
    const accountIdentifier = (0, $ld5Xm.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = $6552874ea2db8d8d$export$7e9c60d6d1836c84(accountIdentifier);
    if (!isAuthenticated && context.inProgress !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).Startup && context.inProgress !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).HandleRedirect) return (0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).Fragment, null, $6552874ea2db8d8d$var$getChildrenOrFunction(children, context));
    return null;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $6552874ea2db8d8d$var$getAccount(instance, accountIdentifiers) {
    if (!accountIdentifiers || !accountIdentifiers.homeAccountId && !accountIdentifiers.localAccountId && !accountIdentifiers.username) // If no account identifiers are provided, return active account
    return instance.getActiveAccount();
    return $6552874ea2db8d8d$var$getAccountByIdentifiers(instance.getAllAccounts(), accountIdentifiers);
}
/**
 * Given 1 or more accountIdentifiers, returns the Account object if the user is signed-in
 * @param accountIdentifiers
 */ function $6552874ea2db8d8d$export$83a8e409853da004(accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = $6552874ea2db8d8d$export$f41558044a1dd55();
    const [account, setAccount] = (0, $ld5Xm.useState)(()=>$6552874ea2db8d8d$var$getAccount(instance, accountIdentifiers));
    (0, $ld5Xm.useEffect)(()=>{
        setAccount((currentAccount)=>{
            const nextAccount = $6552874ea2db8d8d$var$getAccount(instance, accountIdentifiers);
            if (!(0, $5d6dde05c7528aa5$export$680160523e6bfa6a).accountInfoIsEqual(currentAccount, nextAccount, true)) {
                logger.info("useAccount - Updating account");
                return nextAccount;
            }
            return currentAccount;
        });
    }, [
        inProgress,
        accountIdentifiers,
        instance,
        logger
    ]);
    return account;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $6552874ea2db8d8d$var$ReactAuthErrorMessage = {
    invalidInteractionType: {
        code: "invalid_interaction_type",
        desc: "The provided interaction type is invalid."
    },
    unableToFallbackToInteraction: {
        code: "unable_to_fallback_to_interaction",
        desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
    }
};
class $6552874ea2db8d8d$var$ReactAuthError extends (0, $7f0aeee92385582d$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $6552874ea2db8d8d$var$ReactAuthError.prototype);
        this.name = "ReactAuthError";
    }
    static createInvalidInteractionTypeError() {
        return new $6552874ea2db8d8d$var$ReactAuthError($6552874ea2db8d8d$var$ReactAuthErrorMessage.invalidInteractionType.code, $6552874ea2db8d8d$var$ReactAuthErrorMessage.invalidInteractionType.desc);
    }
    static createUnableToFallbackToInteractionError() {
        return new $6552874ea2db8d8d$var$ReactAuthError($6552874ea2db8d8d$var$ReactAuthErrorMessage.unableToFallbackToInteraction.code, $6552874ea2db8d8d$var$ReactAuthErrorMessage.unableToFallbackToInteraction.desc);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * If a user is not currently signed in this hook invokes a login. Failed logins can be retried using the login callback returned.
 * If a user is currently signed in this hook attempts to acquire a token. Subsequent token requests can use the acquireToken callback returned.
 * Optionally provide a request object to be used in the login/acquireToken call.
 * Optionally provide a specific user that should be logged in.
 * @param interactionType
 * @param authenticationRequest
 * @param accountIdentifiers
 */ function $6552874ea2db8d8d$export$d130d543558e611f(interactionType, authenticationRequest, accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = $6552874ea2db8d8d$export$f41558044a1dd55();
    const isAuthenticated = $6552874ea2db8d8d$export$7e9c60d6d1836c84(accountIdentifiers);
    const account = $6552874ea2db8d8d$export$83a8e409853da004(accountIdentifiers);
    const [[result, error], setResponse] = (0, $ld5Xm.useState)([
        null,
        null
    ]); // Used to prevent state updates after unmount
    const mounted = (0, $ld5Xm.useRef)(true);
    (0, $ld5Xm.useEffect)(()=>{
        return ()=>{
            mounted.current = false;
        };
    }, []); // Boolean used to check if interaction is in progress in acquireTokenSilent fallback. Use Ref instead of state to prevent acquireToken function from being regenerated on each change to interactionInProgress value
    const interactionInProgress = (0, $ld5Xm.useRef)(inProgress !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).None);
    (0, $ld5Xm.useEffect)(()=>{
        interactionInProgress.current = inProgress !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).None;
    }, [
        inProgress
    ]); // Flag used to control when the hook calls login/acquireToken
    const shouldAcquireToken = (0, $ld5Xm.useRef)(true);
    (0, $ld5Xm.useEffect)(()=>{
        if (!!error) {
            // Errors should be handled by consuming component
            shouldAcquireToken.current = false;
            return;
        }
        if (!!result) {
            // Token has already been acquired, consuming component/application is responsible for renewing
            shouldAcquireToken.current = false;
            return;
        }
    }, [
        error,
        result
    ]);
    const login = (0, $ld5Xm.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const loginType = callbackInteractionType || interactionType;
        const loginRequest = callbackRequest || authenticationRequest;
        switch(loginType){
            case (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup:
                logger.verbose("useMsalAuthentication - Calling loginPopup");
                return instance.loginPopup(loginRequest);
            case (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect:
                // This promise is not expected to resolve due to full frame redirect
                logger.verbose("useMsalAuthentication - Calling loginRedirect");
                return instance.loginRedirect(loginRequest).then(null);
            case (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent:
                logger.verbose("useMsalAuthentication - Calling ssoSilent");
                return instance.ssoSilent(loginRequest);
            default:
                throw $6552874ea2db8d8d$var$ReactAuthError.createInvalidInteractionTypeError();
        }
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger
    ]);
    const acquireToken = (0, $ld5Xm.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const fallbackInteractionType = callbackInteractionType || interactionType;
        let tokenRequest;
        if (callbackRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the callback");
            tokenRequest = {
                ...callbackRequest
            };
        } else if (authenticationRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the hook");
            tokenRequest = {
                ...authenticationRequest,
                scopes: authenticationRequest.scopes || (0, $1b76d687a319d9ed$export$893b1b5b686d84ef)
            };
        } else {
            logger.trace("useMsalAuthentication - acquireToken - No request object provided, using default request.");
            tokenRequest = {
                scopes: (0, $1b76d687a319d9ed$export$893b1b5b686d84ef)
            };
        }
        if (!tokenRequest.account && account) {
            logger.trace("useMsalAuthentication - acquireToken - Attaching account to request");
            tokenRequest.account = account;
        }
        const getToken = async ()=>{
            logger.verbose("useMsalAuthentication - Calling acquireTokenSilent");
            return instance.acquireTokenSilent(tokenRequest).catch(async (e)=>{
                if (e instanceof (0, $dec424bb7347a355$export$6ba3e818c6bc76ba)) {
                    if (!interactionInProgress.current) {
                        logger.error("useMsalAuthentication - Interaction required, falling back to interaction");
                        return login(fallbackInteractionType, tokenRequest);
                    } else {
                        logger.error("useMsalAuthentication - Interaction required but is already in progress. Please try again, if needed, after interaction completes.");
                        throw $6552874ea2db8d8d$var$ReactAuthError.createUnableToFallbackToInteractionError();
                    }
                }
                throw e;
            });
        };
        return getToken().then((response)=>{
            if (mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch((e)=>{
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger,
        account,
        login
    ]);
    (0, $ld5Xm.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            switch(message.eventType){
                case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_SUCCESS:
                case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
                    if (message.payload) setResponse([
                        message.payload,
                        null
                    ]);
                    break;
                case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_FAILURE:
                case (0, $8576a8f6fd30fa65$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                    if (message.error) setResponse([
                        null,
                        message.error
                    ]);
                    break;
            }
        });
        logger.verbose(`useMsalAuthentication - Registered event callback with id: ${callbackId}`);
        return ()=>{
            if (callbackId) {
                logger.verbose(`useMsalAuthentication - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    (0, $ld5Xm.useEffect)(()=>{
        if (shouldAcquireToken.current && inProgress === (0, $7b3089fdde5d004f$export$bec20eda0179362b).None) {
            shouldAcquireToken.current = false;
            if (!isAuthenticated) {
                logger.info("useMsalAuthentication - No user is authenticated, attempting to login");
                login().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            } else if (account) {
                logger.info("useMsalAuthentication - User is authenticated, attempting to acquire token");
                acquireToken().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            }
        }
    }, [
        isAuthenticated,
        account,
        inProgress,
        login,
        acquireToken,
        logger
    ]);
    return {
        login: login,
        acquireToken: acquireToken,
        result: result,
        error: error
    };
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Attempts to authenticate user if not already authenticated, then renders child components
 * @param props
 */ function $6552874ea2db8d8d$export$c9cd7a02d4bd7707(_ref) {
    let { interactionType: interactionType, username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, authenticationRequest: authenticationRequest, loadingComponent: LoadingComponent, errorComponent: ErrorComponent, children: children } = _ref;
    const accountIdentifier = (0, $ld5Xm.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const context = $6552874ea2db8d8d$export$f41558044a1dd55();
    const msalAuthResult = $6552874ea2db8d8d$export$d130d543558e611f(interactionType, authenticationRequest, accountIdentifier);
    const isAuthenticated = $6552874ea2db8d8d$export$7e9c60d6d1836c84(accountIdentifier);
    if (msalAuthResult.error && context.inProgress === (0, $7b3089fdde5d004f$export$bec20eda0179362b).None) {
        if (!!ErrorComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).createElement(ErrorComponent, Object.assign({}, msalAuthResult));
        throw msalAuthResult.error;
    }
    if (isAuthenticated) return (0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).Fragment, null, $6552874ea2db8d8d$var$getChildrenOrFunction(children, msalAuthResult));
    if (!!LoadingComponent && context.inProgress !== (0, $7b3089fdde5d004f$export$bec20eda0179362b).None) return (0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).createElement(LoadingComponent, Object.assign({}, context));
    return null;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Higher order component wraps provided component with msal by injecting msal context values into the component's props
 * @param Component
 */ const $6552874ea2db8d8d$export$8dea26c30ebc61cd = (Component)=>{
    const ComponentWithMsal = (props)=>{
        const msal = $6552874ea2db8d8d$export$f41558044a1dd55();
        return (0, (/*@__PURE__*/$parcel$interopDefault($ld5Xm))).createElement(Component, Object.assign({}, props, {
            msalContext: msal
        }));
    };
    const componentName = Component.displayName || Component.name || "Component";
    ComponentWithMsal.displayName = `withMsal(${componentName})`;
    return ComponentWithMsal;
};


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Enumeration of operations that are instrumented by have their performance measured by the PerformanceClient.
 *
 * @export
 * @enum {number}
 */ var $57d7adee307e257f$export$2f2811a3e1b21823;
(function(PerformanceEvents) {
    /**
     * acquireTokenByCode API (msal-browser and msal-node).
     * Used to acquire tokens by trading an authorization code against the token endpoint.
     */ PerformanceEvents["AcquireTokenByCode"] = "acquireTokenByCode";
    /**
     * acquireTokenByRefreshToken API (msal-browser and msal-node).
     * Used to renew an access token using a refresh token against the token endpoint.
     */ PerformanceEvents["AcquireTokenByRefreshToken"] = "acquireTokenByRefreshToken";
    /**
     * acquireTokenSilent API (msal-browser and msal-node).
     * Used to silently acquire a new access token (from the cache or the network).
     */ PerformanceEvents["AcquireTokenSilent"] = "acquireTokenSilent";
    /**
     * acquireTokenSilentAsync (msal-browser).
     * Internal API for acquireTokenSilent.
     */ PerformanceEvents["AcquireTokenSilentAsync"] = "acquireTokenSilentAsync";
    /**
     * acquireTokenPopup (msal-browser).
     * Used to acquire a new access token interactively through pop ups
     */ PerformanceEvents["AcquireTokenPopup"] = "acquireTokenPopup";
    /**
     * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
     * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
     */ PerformanceEvents["CryptoOptsGetPublicKeyThumbprint"] = "cryptoOptsGetPublicKeyThumbprint";
    /**
     * signJwt API in CryptoOpts class (msal-browser).
     * Used to signed a pop token.
     */ PerformanceEvents["CryptoOptsSignJwt"] = "cryptoOptsSignJwt";
    /**
     * acquireToken API in the SilentCacheClient class (msal-browser).
     * Used to read access tokens from the cache.
     */ PerformanceEvents["SilentCacheClientAcquireToken"] = "silentCacheClientAcquireToken";
    /**
     * acquireToken API in the SilentIframeClient class (msal-browser).
     * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
     */ PerformanceEvents["SilentIframeClientAcquireToken"] = "silentIframeClientAcquireToken";
    /**
     * acquireToken API in SilentRereshClient (msal-browser).
     * Used to acquire a new set of tokens from the token endpoint using a refresh token.
     */ PerformanceEvents["SilentRefreshClientAcquireToken"] = "silentRefreshClientAcquireToken";
    /**
     * ssoSilent API (msal-browser).
     * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
     */ PerformanceEvents["SsoSilent"] = "ssoSilent";
    /**
     * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
     * Used to load authority metadata for a request.
     */ PerformanceEvents["StandardInteractionClientGetDiscoveredAuthority"] = "standardInteractionClientGetDiscoveredAuthority";
    /**
     * acquireToken APIs in msal-browser.
     * Used to make an /authorize endpoint call with native brokering enabled.
     */ PerformanceEvents["FetchAccountIdWithNativeBroker"] = "fetchAccountIdWithNativeBroker";
    /**
     * acquireToken API in NativeInteractionClient class (msal-browser).
     * Used to acquire a token from Native component when native brokering is enabled.
     */ PerformanceEvents["NativeInteractionClientAcquireToken"] = "nativeInteractionClientAcquireToken";
    /**
     * Time spent creating default headers for requests to token endpoint
     */ PerformanceEvents["BaseClientCreateTokenRequestHeaders"] = "baseClientCreateTokenRequestHeaders";
    /**
     * Used to measure the time taken for completing embedded-broker handshake (PW-Broker).
     */ PerformanceEvents["BrokerHandhshake"] = "brokerHandshake";
    /**
     * acquireTokenByRefreshToken API in BrokerClientApplication (PW-Broker) .
     */ PerformanceEvents["AcquireTokenByRefreshTokenInBroker"] = "acquireTokenByRefreshTokenInBroker";
    /**
     * Time taken for token acquisition by broker
     */ PerformanceEvents["AcquireTokenByBroker"] = "acquireTokenByBroker";
    /**
     * Time spent on the network for refresh token acquisition
     */ PerformanceEvents["RefreshTokenClientExecuteTokenRequest"] = "refreshTokenClientExecuteTokenRequest";
    /**
     * Time taken for acquiring refresh token , records RT size
     */ PerformanceEvents["RefreshTokenClientAcquireToken"] = "refreshTokenClientAcquireToken";
    /**
     * Time taken for acquiring cached refresh token
     */ PerformanceEvents["RefreshTokenClientAcquireTokenWithCachedRefreshToken"] = "refreshTokenClientAcquireTokenWithCachedRefreshToken";
    /**
     * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
     */ PerformanceEvents["RefreshTokenClientAcquireTokenByRefreshToken"] = "refreshTokenClientAcquireTokenByRefreshToken";
    /**
     * Helper function to create token request body in RefreshTokenClient (msal-common).
     */ PerformanceEvents["RefreshTokenClientCreateTokenRequestBody"] = "refreshTokenClientCreateTokenRequestBody";
    /**
     * acquireTokenFromCache (msal-browser).
     * Internal API for acquiring token from cache
     */ PerformanceEvents["AcquireTokenFromCache"] = "acquireTokenFromCache";
    /**
     * acquireTokenBySilentIframe (msal-browser).
     * Internal API for acquiring token by silent Iframe
     */ PerformanceEvents["AcquireTokenBySilentIframe"] = "acquireTokenBySilentIframe";
    /**
     * Internal API for initializing base request in BaseInteractionClient (msal-browser)
     */ PerformanceEvents["InitializeBaseRequest"] = "initializeBaseRequest";
    /**
     * Internal API for initializing silent request in SilentCacheClient (msal-browser)
     */ PerformanceEvents["InitializeSilentRequest"] = "initializeSilentRequest";
    PerformanceEvents["InitializeClientApplication"] = "initializeClientApplication";
    /**
     * Helper function in SilentIframeClient class (msal-browser).
     */ PerformanceEvents["SilentIframeClientTokenHelper"] = "silentIframeClientTokenHelper";
    /**
     * SilentHandler
     */ PerformanceEvents["SilentHandlerInitiateAuthRequest"] = "silentHandlerInitiateAuthRequest";
    PerformanceEvents["SilentHandlerMonitorIframeForHash"] = "silentHandlerMonitorIframeForHash";
    PerformanceEvents["SilentHandlerLoadFrame"] = "silentHandlerLoadFrame";
    /**
     * Helper functions in StandardInteractionClient class (msal-browser)
     */ PerformanceEvents["StandardInteractionClientCreateAuthCodeClient"] = "standardInteractionClientCreateAuthCodeClient";
    PerformanceEvents["StandardInteractionClientGetClientConfiguration"] = "standardInteractionClientGetClientConfiguration";
    PerformanceEvents["StandardInteractionClientInitializeAuthorizationRequest"] = "standardInteractionClientInitializeAuthorizationRequest";
    PerformanceEvents["StandardInteractionClientInitializeAuthorizationCodeRequest"] = "standardInteractionClientInitializeAuthorizationCodeRequest";
    /**
     * getAuthCodeUrl API (msal-browser and msal-node).
     */ PerformanceEvents["GetAuthCodeUrl"] = "getAuthCodeUrl";
    /**
     * Functions from InteractionHandler (msal-browser)
     */ PerformanceEvents["HandleCodeResponseFromServer"] = "handleCodeResponseFromServer";
    PerformanceEvents["HandleCodeResponseFromHash"] = "handleCodeResponseFromHash";
    PerformanceEvents["UpdateTokenEndpointAuthority"] = "updateTokenEndpointAuthority";
    /**
     * APIs in Authorization Code Client (msal-common)
     */ PerformanceEvents["AuthClientAcquireToken"] = "authClientAcquireToken";
    PerformanceEvents["AuthClientExecuteTokenRequest"] = "authClientExecuteTokenRequest";
    PerformanceEvents["AuthClientCreateTokenRequestBody"] = "authClientCreateTokenRequestBody";
    PerformanceEvents["AuthClientCreateQueryString"] = "authClientCreateQueryString";
    /**
     * Generate functions in PopTokenGenerator (msal-common)
     */ PerformanceEvents["PopTokenGenerateCnf"] = "popTokenGenerateCnf";
    PerformanceEvents["PopTokenGenerateKid"] = "popTokenGenerateKid";
    /**
     * handleServerTokenResponse API in ResponseHandler (msal-common)
     */ PerformanceEvents["HandleServerTokenResponse"] = "handleServerTokenResponse";
    /**
     * Authority functions
     */ PerformanceEvents["AuthorityFactoryCreateDiscoveredInstance"] = "authorityFactoryCreateDiscoveredInstance";
    PerformanceEvents["AuthorityResolveEndpointsAsync"] = "authorityResolveEndpointsAsync";
    PerformanceEvents["AuthorityGetCloudDiscoveryMetadataFromNetwork"] = "authorityGetCloudDiscoveryMetadataFromNetwork";
    PerformanceEvents["AuthorityUpdateCloudDiscoveryMetadata"] = "authorityUpdateCloudDiscoveryMetadata";
    PerformanceEvents["AuthorityGetEndpointMetadataFromNetwork"] = "authorityGetEndpointMetadataFromNetwork";
    PerformanceEvents["AuthorityUpdateEndpointMetadata"] = "authorityUpdateEndpointMetadata";
    PerformanceEvents["AuthorityUpdateMetadataWithRegionalInformation"] = "authorityUpdateMetadataWithRegionalInformation";
    /**
     * Region Discovery functions
     */ PerformanceEvents["RegionDiscoveryDetectRegion"] = "regionDiscoveryDetectRegion";
    PerformanceEvents["RegionDiscoveryGetRegionFromIMDS"] = "regionDiscoveryGetRegionFromIMDS";
    PerformanceEvents["RegionDiscoveryGetCurrentVersion"] = "regionDiscoveryGetCurrentVersion";
    PerformanceEvents["AcquireTokenByCodeAsync"] = "acquireTokenByCodeAsync";
    PerformanceEvents["GetEndpointMetadataFromNetwork"] = "getEndpointMetadataFromNetwork";
    PerformanceEvents["GetCloudDiscoveryMetadataFromNetworkMeasurement"] = "getCloudDiscoveryMetadataFromNetworkMeasurement";
    PerformanceEvents["HandleRedirectPromiseMeasurement"] = "handleRedirectPromiseMeasurement";
    PerformanceEvents["UpdateCloudDiscoveryMetadataMeasurement"] = "updateCloudDiscoveryMetadataMeasurement";
    PerformanceEvents["UsernamePasswordClientAcquireToken"] = "usernamePasswordClientAcquireToken";
    PerformanceEvents["NativeMessageHandlerHandshake"] = "nativeMessageHandlerHandshake";
})($57d7adee307e257f$export$2f2811a3e1b21823 || ($57d7adee307e257f$export$2f2811a3e1b21823 = {}));
/**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ var $57d7adee307e257f$export$bc3547c8ae7b1db;
(function(PerformanceEventStatus) {
    PerformanceEventStatus[PerformanceEventStatus["NotStarted"] = 0] = "NotStarted";
    PerformanceEventStatus[PerformanceEventStatus["InProgress"] = 1] = "InProgress";
    PerformanceEventStatus[PerformanceEventStatus["Completed"] = 2] = "Completed";
})($57d7adee307e257f$export$bc3547c8ae7b1db || ($57d7adee307e257f$export$bc3547c8ae7b1db = {}));
var $57d7adee307e257f$export$f16d39729f4b7302 = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "queuedTimeMs",
    "startTimeMs",
    "status"
]);

/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ var $b198a6cc5c52ae21$export$ea52035eac03daf0 = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(ServerError, _super);
    function ServerError(errorCode, errorMessage, subError) {
        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
        _this.name = "ServerError";
        Object.setPrototypeOf(_this, ServerError.prototype);
        return _this;
    }
    return ServerError;
}((0, $7f0aeee92385582d$export$145273558d58e0ac));



/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ /*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ var $184466e8d2b2e0aa$export$7d28d6e0c10c5bab = {
    missingKidError: {
        code: "missing_kid_error",
        desc: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided."
    },
    missingAlgError: {
        code: "missing_alg_error",
        desc: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ var $184466e8d2b2e0aa$export$980ad46b7a115fad = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(JoseHeaderError, _super);
    function JoseHeaderError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "JoseHeaderError";
        Object.setPrototypeOf(_this, JoseHeaderError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when keyId isn't set on JOSE header.
     */ JoseHeaderError.createMissingKidError = function() {
        return new JoseHeaderError($184466e8d2b2e0aa$export$7d28d6e0c10c5bab.missingKidError.code, $184466e8d2b2e0aa$export$7d28d6e0c10c5bab.missingKidError.desc);
    };
    /**
     * Creates an error thrown when algorithm isn't set on JOSE header.
     */ JoseHeaderError.createMissingAlgError = function() {
        return new JoseHeaderError($184466e8d2b2e0aa$export$7d28d6e0c10c5bab.missingAlgError.code, $184466e8d2b2e0aa$export$7d28d6e0c10c5bab.missingAlgError.desc);
    };
    return JoseHeaderError;
}((0, $7f0aeee92385582d$export$145273558d58e0ac));



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $176fa532d6fbfc17$export$91748d132e6cb9b3 = /** @class */ function() {
    function JoseHeader(options) {
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ JoseHeader.getShrHeaderString = function(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, $184466e8d2b2e0aa$export$980ad46b7a115fad).createMissingKidError();
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, $184466e8d2b2e0aa$export$980ad46b7a115fad).createMissingAlgError();
        var shrHeader = new JoseHeader({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, $1b76d687a319d9ed$export$70dd17b99a838729).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    };
    return JoseHeader;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-browser v2.37.1 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility class for math specific functions in browser.
 */ var $81d934d4e160ba3a$export$6a7ef315a0d1ef07 = /** @class */ function() {
    function MathUtils() {}
    /**
     * Decimal to Hex
     *
     * @param num
     */ MathUtils.decimalToHex = function(num) {
        var hex = num.toString(16);
        while(hex.length < 2)hex = "0" + hex;
        return hex;
    };
    return MathUtils;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $2adb43089fcdf0dc$export$62dc58eaf2cdc52 = /** @class */ function() {
    function GuidGenerator(cryptoObj) {
        this.cryptoObj = cryptoObj;
    }
    /*
     * RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
     * pseudo-random numbers.
     * The algorithm is as follows:
     *     Set the two most significant bits (bits 6 and 7) of the
     *        clock_seq_hi_and_reserved to zero and one, respectively.
     *     Set the four most significant bits (bits 12 through 15) of the
     *        time_hi_and_version field to the 4-bit version number from
     *        Section 4.1.3. Version4
     *     Set all the other bits to randomly (or pseudo-randomly) chosen
     *     values.
     * UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
     * time-low               = 4hexOctet
     * time-mid               = 2hexOctet
     * time-high-and-version  = 2hexOctet
     * clock-seq-and-reserved = hexOctet:
     * clock-seq-low          = hexOctet
     * node                   = 6hexOctet
     * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
     * y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
     * y values are 8, 9, A, B
     */ GuidGenerator.prototype.generateGuid = function() {
        try {
            var buffer = new Uint8Array(16);
            this.cryptoObj.getRandomValues(buffer);
            // buffer[6] and buffer[7] represents the time_hi_and_version field. We will set the four most significant bits (4 through 7) of buffer[6] to represent decimal number 4 (UUID version number).
            buffer[6] |= 0x40; // buffer[6] | 01000000 will set the 6 bit to 1.
            buffer[6] &= 0x4f; // buffer[6] & 01001111 will set the 4, 5, and 7 bit to 0 such that bits 4-7 == 0100 = "4".
            // buffer[8] represents the clock_seq_hi_and_reserved field. We will set the two most significant bits (6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively.
            buffer[8] |= 0x80; // buffer[8] | 10000000 will set the 7 bit to 1.
            buffer[8] &= 0xbf; // buffer[8] & 10111111 will set the 6 bit to 0.
            return (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[0]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[1]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[2]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[3]) + "-" + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[4]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[5]) + "-" + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[6]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[7]) + "-" + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[8]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[9]) + "-" + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[10]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[11]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[12]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[13]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[14]) + (0, $81d934d4e160ba3a$export$6a7ef315a0d1ef07).decimalToHex(buffer[15]);
        } catch (err) {
            var guidHolder = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
            var hex = "0123456789abcdef";
            var r = 0;
            var guidResponse = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            for(var i = 0; i < 36; i++){
                if (guidHolder[i] !== "-" && guidHolder[i] !== "4") // each x and y needs to be random
                r = Math.random() * 16 | 0;
                if (guidHolder[i] === "x") guidResponse += hex[r];
                else if (guidHolder[i] === "y") {
                    // clock-seq-and-reserved first hex is filtered and remaining hex values are random
                    r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
                    r |= 0x8; // set pos 3 to 1 as 1???
                    guidResponse += hex[r];
                } else guidResponse += guidHolder[i];
            }
            return guidResponse;
        }
    };
    /**
     * verifies if a string is  GUID
     * @param guid
     */ GuidGenerator.prototype.isGuid = function(guid) {
        var regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return regexGuid.test(guid);
    };
    return GuidGenerator;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for strings in a browser. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ var $8322bc7f1a7ff5b3$export$27a4bf5378101665 = /** @class */ function() {
    function BrowserStringUtils() {}
    /**
     * Converts string to Uint8Array
     * @param sDOMStr
     */ BrowserStringUtils.stringToUtf8Arr = function(sDOMStr) {
        var nChr;
        var nArrLen = 0;
        var nStrLen = sDOMStr.length;
        /* mapping... */ for(var nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++){
            nChr = sDOMStr.charCodeAt(nMapIdx);
            nArrLen += nChr < 0x80 ? 1 : nChr < 0x800 ? 2 : nChr < 0x10000 ? 3 : nChr < 0x200000 ? 4 : nChr < 0x4000000 ? 5 : 6;
        }
        var aBytes = new Uint8Array(nArrLen);
        /* transcription... */ for(var nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++){
            nChr = sDOMStr.charCodeAt(nChrIdx);
            if (nChr < 128) /* one byte */ aBytes[nIdx++] = nChr;
            else if (nChr < 0x800) {
                /* two bytes */ aBytes[nIdx++] = 192 + (nChr >>> 6);
                aBytes[nIdx++] = 128 + (nChr & 63);
            } else if (nChr < 0x10000) {
                /* three bytes */ aBytes[nIdx++] = 224 + (nChr >>> 12);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            } else if (nChr < 0x200000) {
                /* four bytes */ aBytes[nIdx++] = 240 + (nChr >>> 18);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            } else if (nChr < 0x4000000) {
                /* five bytes */ aBytes[nIdx++] = 248 + (nChr >>> 24);
                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            } else /* if (nChr <= 0x7fffffff) */ {
                /* six bytes */ aBytes[nIdx++] = 252 + (nChr >>> 30);
                aBytes[nIdx++] = 128 + (nChr >>> 24 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
                aBytes[nIdx++] = 128 + (nChr & 63);
            }
        }
        return aBytes;
    };
    /**
     * Converst string to ArrayBuffer
     * @param dataString
     */ BrowserStringUtils.stringToArrayBuffer = function(dataString) {
        var data = new ArrayBuffer(dataString.length);
        var dataView = new Uint8Array(data);
        for(var i = 0; i < dataString.length; i++)dataView[i] = dataString.charCodeAt(i);
        return data;
    };
    /**
     * Converts Uint8Array to a string
     * @param aBytes
     */ BrowserStringUtils.utf8ArrToString = function(aBytes) {
        var sView = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        for(var nPart = void 0, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++){
            nPart = aBytes[nIdx];
            sView += String.fromCharCode(nPart > 251 && nPart < 254 && nIdx + 5 < nLen ? /* six bytes */ /* (nPart - 252 << 30) may be not so safe in ECMAScript! So...: */ (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128 : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ? /* five bytes */ (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128 : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ? /* four bytes */ (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128 : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ? /* three bytes */ (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128 : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ? /* two bytes */ (nPart - 192 << 6) + aBytes[++nIdx] - 128 : /* nPart < 127 ? */ /* one byte */ nPart);
        }
        return sView;
    };
    /**
     * Returns stringified jwk.
     * @param jwk
     */ BrowserStringUtils.getSortedObjectString = function(obj) {
        return JSON.stringify(obj, Object.keys(obj).sort());
    };
    return BrowserStringUtils;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ var $393ce314c54015e0$export$d99f397851818755 = /** @class */ function() {
    function Base64Encode() {}
    /**
     * Returns URL Safe b64 encoded string from a plaintext string.
     * @param input
     */ Base64Encode.prototype.urlEncode = function(input) {
        return encodeURIComponent(this.encode(input).replace(/=/g, (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING).replace(/\+/g, "-").replace(/\//g, "_"));
    };
    /**
     * Returns URL Safe b64 encoded string from an int8Array.
     * @param inputArr
     */ Base64Encode.prototype.urlEncodeArr = function(inputArr) {
        return this.base64EncArr(inputArr).replace(/=/g, (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING).replace(/\+/g, "-").replace(/\//g, "_");
    };
    /**
     * Returns b64 encoded string from plaintext string.
     * @param input
     */ Base64Encode.prototype.encode = function(input) {
        var inputUtf8Arr = (0, $8322bc7f1a7ff5b3$export$27a4bf5378101665).stringToUtf8Arr(input);
        return this.base64EncArr(inputUtf8Arr);
    };
    /**
     * Base64 encode byte array
     * @param aBytes
     */ Base64Encode.prototype.base64EncArr = function(aBytes) {
        var eqLen = (3 - aBytes.length % 3) % 3;
        var sB64Enc = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        for(var nMod3 = void 0, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++){
            nMod3 = nIdx % 3;
            /* Uncomment the following line in order to split the output in lines 76-character long: */ /*
             *if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
             */ nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
            if (nMod3 === 2 || aBytes.length - nIdx === 1) {
                sB64Enc += String.fromCharCode(this.uint6ToB64(nUint24 >>> 18 & 63), this.uint6ToB64(nUint24 >>> 12 & 63), this.uint6ToB64(nUint24 >>> 6 & 63), this.uint6ToB64(nUint24 & 63));
                nUint24 = 0;
            }
        }
        return eqLen === 0 ? sB64Enc : sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? "=" : "==");
    };
    /**
     * Base64 string to array encoding helper
     * @param nUint6
     */ Base64Encode.prototype.uint6ToB64 = function(nUint6) {
        return nUint6 < 26 ? nUint6 + 65 : nUint6 < 52 ? nUint6 + 71 : nUint6 < 62 ? nUint6 - 4 : nUint6 === 62 ? 43 : nUint6 === 63 ? 47 : 65;
    };
    return Base64Encode;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ var $1cdfb8b1eee1d075$export$fe555b2490ffa3fb = /** @class */ function() {
    function Base64Decode() {}
    /**
     * Returns a URL-safe plaintext decoded string from b64 encoded input.
     * @param input
     */ Base64Decode.prototype.decode = function(input) {
        var encodedString = input.replace(/-/g, "+").replace(/_/g, "/");
        switch(encodedString.length % 4){
            case 0:
                break;
            case 2:
                encodedString += "==";
                break;
            case 3:
                encodedString += "=";
                break;
            default:
                throw new Error("Invalid base64 string");
        }
        var inputUtf8Arr = this.base64DecToArr(encodedString);
        return (0, $8322bc7f1a7ff5b3$export$27a4bf5378101665).utf8ArrToString(inputUtf8Arr);
    };
    /**
     * Decodes base64 into Uint8Array
     * @param base64String
     * @param nBlockSize
     */ Base64Decode.prototype.base64DecToArr = function(base64String, nBlockSize) {
        var sB64Enc = base64String.replace(/[^A-Za-z0-9\+\/]/g, (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
        var nInLen = sB64Enc.length;
        var nOutLen = nBlockSize ? Math.ceil((nInLen * 3 + 1 >>> 2) / nBlockSize) * nBlockSize : nInLen * 3 + 1 >>> 2;
        var aBytes = new Uint8Array(nOutLen);
        for(var nMod3 = void 0, nMod4 = void 0, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++){
            nMod4 = nInIdx & 3;
            nUint24 |= this.b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4;
            if (nMod4 === 3 || nInLen - nInIdx === 1) {
                for(nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++)aBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
                nUint24 = 0;
            }
        }
        return aBytes;
    };
    /**
     * Base64 string to array decoding helper
     * @param charNum
     */ Base64Decode.prototype.b64ToUint6 = function(charNum) {
        return charNum > 64 && charNum < 91 ? charNum - 65 : charNum > 96 && charNum < 123 ? charNum - 71 : charNum > 47 && charNum < 58 ? charNum + 4 : charNum === 43 ? 62 : charNum === 47 ? 63 : 0;
    };
    return Base64Decode;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ var $68ecaba305c397db$export$6deffaef56f0bd5a = {
    pkceNotGenerated: {
        code: "pkce_not_created",
        desc: "The PKCE code challenge and verifier could not be generated."
    },
    cryptoDoesNotExist: {
        code: "crypto_nonexistent",
        desc: "The crypto object or function is not available."
    },
    httpMethodNotImplementedError: {
        code: "http_method_not_implemented",
        desc: "The HTTP method given has not been implemented in this library."
    },
    emptyNavigateUriError: {
        code: "empty_navigate_uri",
        desc: "Navigation URI is empty. Please check stack trace for more info."
    },
    hashEmptyError: {
        code: "hash_empty_error",
        desc: "Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. For more visit: aka.ms/msaljs/browser-errors."
    },
    hashDoesNotContainStateError: {
        code: "no_state_in_hash",
        desc: "Hash does not contain state. Please verify that the request originated from msal."
    },
    hashDoesNotContainKnownPropertiesError: {
        code: "hash_does_not_contain_known_properties",
        desc: "Hash does not contain known properites. Please verify that your redirectUri is not changing the hash. For more visit: aka.ms/msaljs/browser-errors."
    },
    unableToParseStateError: {
        code: "unable_to_parse_state",
        desc: "Unable to parse state. Please verify that the request originated from msal."
    },
    stateInteractionTypeMismatchError: {
        code: "state_interaction_type_mismatch",
        desc: "Hash contains state but the interaction type does not match the caller."
    },
    interactionInProgress: {
        code: "interaction_in_progress",
        desc: "Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.  For more visit: aka.ms/msaljs/browser-errors."
    },
    popupWindowError: {
        code: "popup_window_error",
        desc: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser."
    },
    emptyWindowError: {
        code: "empty_window_error",
        desc: "window.open returned null or undefined window object."
    },
    userCancelledError: {
        code: "user_cancelled",
        desc: "User cancelled the flow."
    },
    monitorPopupTimeoutError: {
        code: "monitor_window_timeout",
        desc: "Token acquisition in popup failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
    },
    monitorIframeTimeoutError: {
        code: "monitor_window_timeout",
        desc: "Token acquisition in iframe failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
    },
    redirectInIframeError: {
        code: "redirect_in_iframe",
        desc: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs."
    },
    blockTokenRequestsInHiddenIframeError: {
        code: "block_iframe_reload",
        desc: "Request was blocked inside an iframe because MSAL detected an authentication response. For more visit: aka.ms/msaljs/browser-errors"
    },
    blockAcquireTokenInPopupsError: {
        code: "block_nested_popups",
        desc: "Request was blocked inside a popup because MSAL detected it was running in a popup."
    },
    iframeClosedPrematurelyError: {
        code: "iframe_closed_prematurely",
        desc: "The iframe being monitored was closed prematurely."
    },
    silentLogoutUnsupportedError: {
        code: "silent_logout_unsupported",
        desc: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead."
    },
    noAccountError: {
        code: "no_account_error",
        desc: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request."
    },
    silentPromptValueError: {
        code: "silent_prompt_value_error",
        desc: "The value given for the prompt value is not valid for silent requests - must be set to 'none' or 'no_session'."
    },
    noTokenRequestCacheError: {
        code: "no_token_request_cache_error",
        desc: "No token request found in cache."
    },
    unableToParseTokenRequestCacheError: {
        code: "unable_to_parse_token_request_cache_error",
        desc: "The cached token request could not be parsed."
    },
    noCachedAuthorityError: {
        code: "no_cached_authority_error",
        desc: "No cached authority found."
    },
    authRequestNotSet: {
        code: "auth_request_not_set_error",
        desc: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler"
    },
    invalidCacheType: {
        code: "invalid_cache_type",
        desc: "Invalid cache type"
    },
    notInBrowserEnvironment: {
        code: "non_browser_environment",
        desc: "Login and token requests are not supported in non-browser environments."
    },
    databaseNotOpen: {
        code: "database_not_open",
        desc: "Database is not open!"
    },
    noNetworkConnectivity: {
        code: "no_network_connectivity",
        desc: "No network connectivity. Check your internet connection."
    },
    postRequestFailed: {
        code: "post_request_failed",
        desc: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'"
    },
    getRequestFailed: {
        code: "get_request_failed",
        desc: "Network request failed. Please check the network trace to determine root cause."
    },
    failedToParseNetworkResponse: {
        code: "failed_to_parse_response",
        desc: "Failed to parse network response. Check network trace."
    },
    unableToLoadTokenError: {
        code: "unable_to_load_token",
        desc: "Error loading token to cache."
    },
    signingKeyNotFoundInStorage: {
        code: "crypto_key_not_found",
        desc: "Cryptographic Key or Keypair not found in browser storage."
    },
    authCodeRequired: {
        code: "auth_code_required",
        desc: "An authorization code must be provided (as the `code` property on the request) to this flow."
    },
    authCodeOrNativeAccountRequired: {
        code: "auth_code_or_nativeAccountId_required",
        desc: "An authorization code or nativeAccountId must be provided to this flow."
    },
    spaCodeAndNativeAccountPresent: {
        code: "spa_code_and_nativeAccountId_present",
        desc: "Request cannot contain both spa code and native account id."
    },
    databaseUnavailable: {
        code: "database_unavailable",
        desc: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts."
    },
    unableToAcquireTokenFromNativePlatform: {
        code: "unable_to_acquire_token_from_native_platform",
        desc: "Unable to acquire token from native platform. For a list of possible reasons visit aka.ms/msaljs/browser-errors."
    },
    nativeHandshakeTimeout: {
        code: "native_handshake_timeout",
        desc: "Timed out while attempting to establish connection to browser extension"
    },
    nativeExtensionNotInstalled: {
        code: "native_extension_not_installed",
        desc: "Native extension is not installed. If you think this is a mistake call the initialize function."
    },
    nativeConnectionNotEstablished: {
        code: "native_connection_not_established",
        desc: "Connection to native platform has not been established. Please install a compatible browser extension and run initialize(). For more please visit aka.ms/msaljs/browser-errors."
    },
    nativeBrokerCalledBeforeInitialize: {
        code: "native_broker_called_before_initialize",
        desc: "You must call and await the initialize function before attempting to call any other MSAL API when native brokering is enabled. For more please visit aka.ms/msaljs/browser-errors."
    },
    nativePromptNotSupported: {
        code: "native_prompt_not_supported",
        desc: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow."
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ var $68ecaba305c397db$export$f8eb6760ca13876a = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(BrowserAuthError, _super);
    function BrowserAuthError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        Object.setPrototypeOf(_this, BrowserAuthError.prototype);
        _this.name = "BrowserAuthError";
        return _this;
    }
    /**
     * Creates an error thrown when PKCE is not implemented.
     * @param errDetail
     */ BrowserAuthError.createPkceNotGeneratedError = function(errDetail) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.pkceNotGenerated.code, $68ecaba305c397db$export$6deffaef56f0bd5a.pkceNotGenerated.desc + " Detail:" + errDetail);
    };
    /**
     * Creates an error thrown when the crypto object is unavailable.
     * @param errDetail
     */ BrowserAuthError.createCryptoNotAvailableError = function(errDetail) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.cryptoDoesNotExist.code, $68ecaba305c397db$export$6deffaef56f0bd5a.cryptoDoesNotExist.desc + " Detail:" + errDetail);
    };
    /**
     * Creates an error thrown when an HTTP method hasn't been implemented by the browser class.
     * @param method
     */ BrowserAuthError.createHttpMethodNotImplementedError = function(method) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.httpMethodNotImplementedError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.httpMethodNotImplementedError.desc + " Given Method: " + method);
    };
    /**
     * Creates an error thrown when the navigation URI is empty.
     */ BrowserAuthError.createEmptyNavigationUriError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.emptyNavigateUriError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.emptyNavigateUriError.desc);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     * @param hashValue
     */ BrowserAuthError.createEmptyHashError = function(hashValue) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.hashEmptyError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.hashEmptyError.desc + " Given Url: " + hashValue);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     */ BrowserAuthError.createHashDoesNotContainStateError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.hashDoesNotContainStateError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.hashDoesNotContainStateError.desc);
    };
    /**
     * Creates an error thrown when the hash string value does not contain known properties
     */ BrowserAuthError.createHashDoesNotContainKnownPropertiesError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.hashDoesNotContainKnownPropertiesError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.hashDoesNotContainKnownPropertiesError.desc);
    };
    /**
     * Creates an error thrown when the hash string value is unexpectedly empty.
     */ BrowserAuthError.createUnableToParseStateError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.unableToParseStateError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.unableToParseStateError.desc);
    };
    /**
     * Creates an error thrown when the state value in the hash does not match the interaction type of the API attempting to consume it.
     */ BrowserAuthError.createStateInteractionTypeMismatchError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.stateInteractionTypeMismatchError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.stateInteractionTypeMismatchError.desc);
    };
    /**
     * Creates an error thrown when a browser interaction (redirect or popup) is in progress.
     */ BrowserAuthError.createInteractionInProgressError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.interactionInProgress.code, $68ecaba305c397db$export$6deffaef56f0bd5a.interactionInProgress.desc);
    };
    /**
     * Creates an error thrown when the popup window could not be opened.
     * @param errDetail
     */ BrowserAuthError.createPopupWindowError = function(errDetail) {
        var errorMessage = $68ecaba305c397db$export$6deffaef56f0bd5a.popupWindowError.desc;
        errorMessage = !(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(errDetail) ? errorMessage + " Details: " + errDetail : errorMessage;
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.popupWindowError.code, errorMessage);
    };
    /**
     * Creates an error thrown when window.open returns an empty window object.
     * @param errDetail
     */ BrowserAuthError.createEmptyWindowCreatedError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.emptyWindowError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.emptyWindowError.desc);
    };
    /**
     * Creates an error thrown when the user closes a popup.
     */ BrowserAuthError.createUserCancelledError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.userCancelledError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.userCancelledError.desc);
    };
    /**
     * Creates an error thrown when monitorPopupFromHash times out for a given popup.
     */ BrowserAuthError.createMonitorPopupTimeoutError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.monitorPopupTimeoutError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.monitorPopupTimeoutError.desc);
    };
    /**
     * Creates an error thrown when monitorIframeFromHash times out for a given iframe.
     */ BrowserAuthError.createMonitorIframeTimeoutError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.monitorIframeTimeoutError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.monitorIframeTimeoutError.desc);
    };
    /**
     * Creates an error thrown when navigateWindow is called inside an iframe or brokered applications.
     * @param windowParentCheck
     */ BrowserAuthError.createRedirectInIframeError = function(windowParentCheck) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.redirectInIframeError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.redirectInIframeError.desc + " (window.parent !== window) => " + windowParentCheck);
    };
    /**
     * Creates an error thrown when an auth reload is done inside an iframe.
     */ BrowserAuthError.createBlockReloadInHiddenIframeError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.blockTokenRequestsInHiddenIframeError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.blockTokenRequestsInHiddenIframeError.desc);
    };
    /**
     * Creates an error thrown when a popup attempts to call an acquireToken API
     * @returns
     */ BrowserAuthError.createBlockAcquireTokenInPopupsError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.blockAcquireTokenInPopupsError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.blockAcquireTokenInPopupsError.desc);
    };
    /**
     * Creates an error thrown when an iframe is found to be closed before the timeout is reached.
     */ BrowserAuthError.createIframeClosedPrematurelyError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.iframeClosedPrematurelyError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.iframeClosedPrematurelyError.desc);
    };
    /**
     * Creates an error thrown when the logout API is called on any of the silent interaction clients
     */ BrowserAuthError.createSilentLogoutUnsupportedError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.silentLogoutUnsupportedError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.silentLogoutUnsupportedError.desc);
    };
    /**
     * Creates an error thrown when the account object is not provided in the acquireTokenSilent API.
     */ BrowserAuthError.createNoAccountError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.noAccountError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.noAccountError.desc);
    };
    /**
     * Creates an error thrown when a given prompt value is invalid for silent requests.
     */ BrowserAuthError.createSilentPromptValueError = function(givenPrompt) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.silentPromptValueError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.silentPromptValueError.desc + " Given value: " + givenPrompt);
    };
    /**
     * Creates an error thrown when the cached token request could not be retrieved from the cache
     */ BrowserAuthError.createUnableToParseTokenRequestCacheError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.unableToParseTokenRequestCacheError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.unableToParseTokenRequestCacheError.desc);
    };
    /**
     * Creates an error thrown when the token request could not be retrieved from the cache
     */ BrowserAuthError.createNoTokenRequestCacheError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.noTokenRequestCacheError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.noTokenRequestCacheError.desc);
    };
    /**
     * Creates an error thrown when handleCodeResponse is called before initiateAuthRequest (InteractionHandler)
     */ BrowserAuthError.createAuthRequestNotSetError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.authRequestNotSet.code, $68ecaba305c397db$export$6deffaef56f0bd5a.authRequestNotSet.desc);
    };
    /**
     * Creates an error thrown when the authority could not be retrieved from the cache
     */ BrowserAuthError.createNoCachedAuthorityError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.noCachedAuthorityError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.noCachedAuthorityError.desc);
    };
    /**
     * Creates an error thrown if cache type is invalid.
     */ BrowserAuthError.createInvalidCacheTypeError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.invalidCacheType.code, "" + $68ecaba305c397db$export$6deffaef56f0bd5a.invalidCacheType.desc);
    };
    /**
     * Create an error thrown when login and token requests are made from a non-browser environment
     */ BrowserAuthError.createNonBrowserEnvironmentError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.notInBrowserEnvironment.code, $68ecaba305c397db$export$6deffaef56f0bd5a.notInBrowserEnvironment.desc);
    };
    /**
     * Create an error thrown when indexDB database is not open
     */ BrowserAuthError.createDatabaseNotOpenError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.databaseNotOpen.code, $68ecaba305c397db$export$6deffaef56f0bd5a.databaseNotOpen.desc);
    };
    /**
     * Create an error thrown when token fetch fails due to no internet
     */ BrowserAuthError.createNoNetworkConnectivityError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.noNetworkConnectivity.code, $68ecaba305c397db$export$6deffaef56f0bd5a.noNetworkConnectivity.desc);
    };
    /**
     * Create an error thrown when token fetch fails due to reasons other than internet connectivity
     */ BrowserAuthError.createPostRequestFailedError = function(errorDesc, endpoint) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.postRequestFailed.code, $68ecaba305c397db$export$6deffaef56f0bd5a.postRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when get request fails due to reasons other than internet connectivity
     */ BrowserAuthError.createGetRequestFailedError = function(errorDesc, endpoint) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.getRequestFailed.code, $68ecaba305c397db$export$6deffaef56f0bd5a.getRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when network client fails to parse network response
     */ BrowserAuthError.createFailedToParseNetworkResponseError = function(endpoint) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.failedToParseNetworkResponse.code, $68ecaba305c397db$export$6deffaef56f0bd5a.failedToParseNetworkResponse.desc + " | Attempted to reach: " + endpoint.split("?")[0]);
    };
    /**
     * Create an error thrown when the necessary information is not available to sideload tokens
     */ BrowserAuthError.createUnableToLoadTokenError = function(errorDetail) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.unableToLoadTokenError.code, $68ecaba305c397db$export$6deffaef56f0bd5a.unableToLoadTokenError.desc + " | " + errorDetail);
    };
    /**
     * Create an error thrown when the queried cryptographic key is not found in IndexedDB
     */ BrowserAuthError.createSigningKeyNotFoundInStorageError = function(keyId) {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.signingKeyNotFoundInStorage.code, $68ecaba305c397db$export$6deffaef56f0bd5a.signingKeyNotFoundInStorage.desc + " | No match found for KeyId: " + keyId);
    };
    /**
     * Create an error when an authorization code is required but not provided
     */ BrowserAuthError.createAuthCodeRequiredError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.authCodeRequired.code, $68ecaba305c397db$export$6deffaef56f0bd5a.authCodeRequired.desc);
    };
    /**
     * Create an error when an authorization code or native account ID is required but not provided
     */ BrowserAuthError.createAuthCodeOrNativeAccountIdRequiredError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.authCodeOrNativeAccountRequired.code, $68ecaba305c397db$export$6deffaef56f0bd5a.authCodeOrNativeAccountRequired.desc);
    };
    /**
     * Create an error when both authorization code and native account ID are provided
     */ BrowserAuthError.createSpaCodeAndNativeAccountIdPresentError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.spaCodeAndNativeAccountPresent.code, $68ecaba305c397db$export$6deffaef56f0bd5a.spaCodeAndNativeAccountPresent.desc);
    };
    /**
     * Create an error when IndexedDB is unavailable
     */ BrowserAuthError.createDatabaseUnavailableError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.databaseUnavailable.code, $68ecaba305c397db$export$6deffaef56f0bd5a.databaseUnavailable.desc);
    };
    /**
     * Create an error when native token acquisition is not possible
     */ BrowserAuthError.createUnableToAcquireTokenFromNativePlatformError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.unableToAcquireTokenFromNativePlatform.code, $68ecaba305c397db$export$6deffaef56f0bd5a.unableToAcquireTokenFromNativePlatform.desc);
    };
    /**
     * Create an error thrown when Handshake with browser extension times out
     */ BrowserAuthError.createNativeHandshakeTimeoutError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.nativeHandshakeTimeout.code, $68ecaba305c397db$export$6deffaef56f0bd5a.nativeHandshakeTimeout.desc);
    };
    /**
     * Create an error thrown when browser extension is not installed
     */ BrowserAuthError.createNativeExtensionNotInstalledError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.nativeExtensionNotInstalled.code, $68ecaba305c397db$export$6deffaef56f0bd5a.nativeExtensionNotInstalled.desc);
    };
    /**
     * Create an error when native connection has not been established
     * @returns
     */ BrowserAuthError.createNativeConnectionNotEstablishedError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.nativeConnectionNotEstablished.code, $68ecaba305c397db$export$6deffaef56f0bd5a.nativeConnectionNotEstablished.desc);
    };
    /**
     * Create an error thrown when the initialize function hasn't been called
     */ BrowserAuthError.createNativeBrokerCalledBeforeInitialize = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.nativeBrokerCalledBeforeInitialize.code, $68ecaba305c397db$export$6deffaef56f0bd5a.nativeBrokerCalledBeforeInitialize.desc);
    };
    /**
     * Create an error thrown when requesting a token directly from the native platform with an unsupported prompt parameter e.g. select_account, login or create
     * These requests must go through eSTS to ensure eSTS is aware of the new account
     */ BrowserAuthError.createNativePromptParameterNotSupportedError = function() {
        return new BrowserAuthError($68ecaba305c397db$export$6deffaef56f0bd5a.nativePromptNotSupported.code, $68ecaba305c397db$export$6deffaef56f0bd5a.nativePromptNotSupported.desc);
    };
    return BrowserAuthError;
}((0, $7f0aeee92385582d$export$145273558d58e0ac));



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
var $23c60c77a73f24dc$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * Class which exposes APIs to generate PKCE codes and code verifiers.
 */ var $23c60c77a73f24dc$export$562113aa73225ba6 = /** @class */ function() {
    function PkceGenerator(cryptoObj) {
        this.base64Encode = new (0, $393ce314c54015e0$export$d99f397851818755)();
        this.cryptoObj = cryptoObj;
    }
    /**
     * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
     */ PkceGenerator.prototype.generateCodes = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var codeVerifier, codeChallenge;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        codeVerifier = this.generateCodeVerifier();
                        return [
                            4 /*yield*/ ,
                            this.generateCodeChallengeFromVerifier(codeVerifier)
                        ];
                    case 1:
                        codeChallenge = _a.sent();
                        return [
                            2 /*return*/ ,
                            {
                                verifier: codeVerifier,
                                challenge: codeChallenge
                            }
                        ];
                }
            });
        });
    };
    /**
     * Generates a random 32 byte buffer and returns the base64
     * encoded string to be used as a PKCE Code Verifier
     */ PkceGenerator.prototype.generateCodeVerifier = function() {
        try {
            // Generate random values as utf-8
            var buffer = new Uint8Array($23c60c77a73f24dc$var$RANDOM_BYTE_ARR_LENGTH);
            this.cryptoObj.getRandomValues(buffer);
            // encode verifier as base64
            var pkceCodeVerifierB64 = this.base64Encode.urlEncodeArr(buffer);
            return pkceCodeVerifierB64;
        } catch (e) {
            throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createPkceNotGeneratedError(e);
        }
    };
    /**
     * Creates a base64 encoded PKCE Code Challenge string from the
     * hash created from the PKCE Code Verifier supplied
     */ PkceGenerator.prototype.generateCodeChallengeFromVerifier = function(pkceCodeVerifier) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var pkceHashedCodeVerifier, e_1;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cryptoObj.sha256Digest(pkceCodeVerifier)
                        ];
                    case 1:
                        pkceHashedCodeVerifier = _a.sent();
                        // encode hash as base64
                        return [
                            2 /*return*/ ,
                            this.base64Encode.urlEncodeArr(new Uint8Array(pkceHashedCodeVerifier))
                        ];
                    case 2:
                        e_1 = _a.sent();
                        throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createPkceNotGeneratedError(e_1);
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return PkceGenerator;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $d9991c85b0c91719$export$b3934e1e9b87df7a = /** @class */ function() {
    function ModernBrowserCrypto() {}
    ModernBrowserCrypto.prototype.getRandomValues = function(dataBuffer) {
        return window.crypto.getRandomValues(dataBuffer);
    };
    ModernBrowserCrypto.prototype.generateKey = function(algorithm, extractable, keyUsages) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.generateKey(algorithm, extractable, keyUsages)
                ];
            });
        });
    };
    ModernBrowserCrypto.prototype.exportKey = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.exportKey((0, $7b3089fdde5d004f$export$1294c3e3f84694cd), key)
                ];
            });
        });
    };
    ModernBrowserCrypto.prototype.importKey = function(keyData, algorithm, extractable, keyUsages) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.importKey((0, $7b3089fdde5d004f$export$1294c3e3f84694cd), keyData, algorithm, extractable, keyUsages)
                ];
            });
        });
    };
    ModernBrowserCrypto.prototype.sign = function(algorithm, key, data) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.sign(algorithm, key, data)
                ];
            });
        });
    };
    ModernBrowserCrypto.prototype.digest = function(algorithm, data) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.crypto.subtle.digest(algorithm, data)
                ];
            });
        });
    };
    return ModernBrowserCrypto;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $8f1d29d6cb157b8a$export$67e475a39cf5b913 = /** @class */ function() {
    function MsrBrowserCrypto() {}
    MsrBrowserCrypto.prototype.initPrng = function(entropy) {
        // Turn into array, as initPrng seems to not always like Uint8Array (even though it should support both)
        return window.msrCrypto.initPrng((0, $ac3fbc8ec7de8c8c$export$afc72e2116322959)(entropy));
    };
    MsrBrowserCrypto.prototype.getRandomValues = function(dataBuffer) {
        return window.msrCrypto.getRandomValues(dataBuffer);
    };
    MsrBrowserCrypto.prototype.generateKey = function(algorithm, extractable, keyUsages) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.generateKey(algorithm, extractable, keyUsages)
                ];
            });
        });
    };
    MsrBrowserCrypto.prototype.exportKey = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.exportKey((0, $7b3089fdde5d004f$export$1294c3e3f84694cd), key)
                ];
            });
        });
    };
    MsrBrowserCrypto.prototype.importKey = function(keyData, algorithm, extractable, keyUsages) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.importKey((0, $7b3089fdde5d004f$export$1294c3e3f84694cd), keyData, algorithm, extractable, keyUsages)
                ];
            });
        });
    };
    MsrBrowserCrypto.prototype.sign = function(algorithm, key, data) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.sign(algorithm, key, data)
                ];
            });
        });
    };
    MsrBrowserCrypto.prototype.digest = function(algorithm, data) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    window.msrCrypto.subtle.digest(algorithm, data)
                ];
            });
        });
    };
    return MsrBrowserCrypto;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $c5bdaa5a5be222ac$export$642a89235724bda7 = /** @class */ function() {
    function MsBrowserCrypto() {}
    MsBrowserCrypto.prototype.getRandomValues = function(dataBuffer) {
        return window["msCrypto"].getRandomValues(dataBuffer);
    };
    MsBrowserCrypto.prototype.generateKey = function(algorithm, extractable, keyUsages) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var msGenerateKey = window["msCrypto"].subtle.generateKey(algorithm, extractable, keyUsages);
                        msGenerateKey.addEventListener("complete", function(e) {
                            resolve(e.target.result);
                        });
                        msGenerateKey.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    MsBrowserCrypto.prototype.exportKey = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var msExportKey = window["msCrypto"].subtle.exportKey((0, $7b3089fdde5d004f$export$1294c3e3f84694cd), key);
                        msExportKey.addEventListener("complete", function(e) {
                            var resultBuffer = e.target.result;
                            var resultString = (0, $8322bc7f1a7ff5b3$export$27a4bf5378101665).utf8ArrToString(new Uint8Array(resultBuffer)).replace(/\r/g, (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING).replace(/\n/g, (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING).replace(/\t/g, (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING).split(" ").join((0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING).replace("\0", (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
                            try {
                                resolve(JSON.parse(resultString));
                            } catch (e) {
                                reject(e);
                            }
                        });
                        msExportKey.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    MsBrowserCrypto.prototype.importKey = function(keyData, algorithm, extractable, keyUsages) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var keyString, keyBuffer;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                keyString = (0, $8322bc7f1a7ff5b3$export$27a4bf5378101665).getSortedObjectString(keyData);
                keyBuffer = (0, $8322bc7f1a7ff5b3$export$27a4bf5378101665).stringToArrayBuffer(keyString);
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var msImportKey = window["msCrypto"].subtle.importKey((0, $7b3089fdde5d004f$export$1294c3e3f84694cd), keyBuffer, algorithm, extractable, keyUsages);
                        msImportKey.addEventListener("complete", function(e) {
                            resolve(e.target.result);
                        });
                        msImportKey.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    MsBrowserCrypto.prototype.sign = function(algorithm, key, data) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var msSign = window["msCrypto"].subtle.sign(algorithm, key, data);
                        msSign.addEventListener("complete", function(e) {
                            resolve(e.target.result);
                        });
                        msSign.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    MsBrowserCrypto.prototype.digest = function(algorithm, data) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var digestOperation = window["msCrypto"].subtle.digest(algorithm, data.buffer);
                        digestOperation.addEventListener("complete", function(e) {
                            resolve(e.target.result);
                        });
                        digestOperation.addEventListener("error", function(error) {
                            reject(error);
                        });
                    })
                ];
            });
        });
    };
    return MsBrowserCrypto;
}();



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // RSA KeyGen Algorithm
var $9e4f9f8893be8953$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
// SHA-256 hashing algorithm
var $9e4f9f8893be8953$var$S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
var $9e4f9f8893be8953$var$MODULUS_LENGTH = 2048;
// Public Exponent
var $9e4f9f8893be8953$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
/**
 * This class implements functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ var $9e4f9f8893be8953$export$bdaac271e902e541 = /** @class */ function() {
    function BrowserCrypto(logger, cryptoOptions) {
        var _a, _b;
        this.logger = logger;
        this.cryptoOptions = cryptoOptions;
        if (this.hasBrowserCrypto()) {
            // Use standard modern web crypto if available
            this.logger.verbose("BrowserCrypto: modern crypto interface available");
            this.subtleCrypto = new (0, $d9991c85b0c91719$export$b3934e1e9b87df7a)();
        } else if (this.hasIECrypto()) {
            // For IE11, use msCrypto interface
            this.logger.verbose("BrowserCrypto: MS crypto interface available");
            this.subtleCrypto = new (0, $c5bdaa5a5be222ac$export$642a89235724bda7)();
        } else if (this.hasMsrCrypto() && ((_a = this.cryptoOptions) === null || _a === void 0 ? void 0 : _a.useMsrCrypto)) {
            // For other browsers, use MSR Crypto if found
            this.logger.verbose("BrowserCrypto: MSR crypto interface available");
            this.subtleCrypto = new (0, $8f1d29d6cb157b8a$export$67e475a39cf5b913)();
        } else {
            if (this.hasMsrCrypto()) this.logger.info("BrowserCrypto: MSR Crypto interface available but system.cryptoOptions.useMsrCrypto not enabled");
            this.logger.error("BrowserCrypto: No crypto interfaces available.");
            throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createCryptoNotAvailableError("Browser crypto, msCrypto, or msrCrypto interfaces not available.");
        }
        // Mainly needed for MSR Crypto: https://github.com/microsoft/MSR-JavaScript-Crypto#random-number-generator-prng
        if (this.subtleCrypto.initPrng) {
            this.logger.verbose("BrowserCrypto: Interface requires entropy");
            if (!((_b = this.cryptoOptions) === null || _b === void 0 ? void 0 : _b.entropy)) {
                this.logger.error("BrowserCrypto: Interface requires entropy but none provided.");
                throw (0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createEntropyNotProvided();
            }
            this.logger.verbose("BrowserCrypto: Entropy provided");
            this.subtleCrypto.initPrng(this.cryptoOptions.entropy);
        }
        this.keygenAlgorithmOptions = {
            name: $9e4f9f8893be8953$var$PKCS1_V15_KEYGEN_ALG,
            hash: $9e4f9f8893be8953$var$S256_HASH_ALG,
            modulusLength: $9e4f9f8893be8953$var$MODULUS_LENGTH,
            publicExponent: $9e4f9f8893be8953$var$PUBLIC_EXPONENT
        };
    }
    /**
     * Check whether IE crypto or other browser cryptography is available.
     */ BrowserCrypto.prototype.hasIECrypto = function() {
        return "msCrypto" in window;
    };
    /**
     * Check whether browser crypto is available.
     */ BrowserCrypto.prototype.hasBrowserCrypto = function() {
        return "crypto" in window;
    };
    /**
     * Check whether MSR crypto polyfill is available
     */ BrowserCrypto.prototype.hasMsrCrypto = function() {
        return "msrCrypto" in window;
    };
    /**
     * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
     * @param dataString
     */ BrowserCrypto.prototype.sha256Digest = function(dataString) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var data;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                data = (0, $8322bc7f1a7ff5b3$export$27a4bf5378101665).stringToUtf8Arr(dataString);
                // MSR Crypto wants object with name property, instead of string
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.digest({
                        name: $9e4f9f8893be8953$var$S256_HASH_ALG
                    }, data)
                ];
            });
        });
    };
    /**
     * Populates buffer with cryptographically random values.
     * @param dataBuffer
     */ BrowserCrypto.prototype.getRandomValues = function(dataBuffer) {
        return this.subtleCrypto.getRandomValues(dataBuffer);
    };
    /**
     * Generates a keypair based on current keygen algorithm config.
     * @param extractable
     * @param usages
     */ BrowserCrypto.prototype.generateKeyPair = function(extractable, usages) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.generateKey(this.keygenAlgorithmOptions, extractable, usages)
                ];
            });
        });
    };
    /**
     * Export key as Json Web Key (JWK)
     * @param key
     * @param format
     */ BrowserCrypto.prototype.exportJwk = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.exportKey(key)
                ];
            });
        });
    };
    /**
     * Imports key as Json Web Key (JWK), can set extractable and usages.
     * @param key
     * @param format
     * @param extractable
     * @param usages
     */ BrowserCrypto.prototype.importJwk = function(key, extractable, usages) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.importKey(key, this.keygenAlgorithmOptions, extractable, usages)
                ];
            });
        });
    };
    /**
     * Signs given data with given key
     * @param key
     * @param data
     */ BrowserCrypto.prototype.sign = function(key, data) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.subtleCrypto.sign(this.keygenAlgorithmOptions, key, data)
                ];
            });
        });
    };
    return BrowserCrypto;
}();




/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

/*! @azure/msal-browser v2.37.1 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ var $e418256889b47027$export$286b0f3b569e5f16 = /** @class */ function() {
    function DatabaseStorage() {
        this.dbName = (0, $7b3089fdde5d004f$export$3c22ff8b64b8f565);
        this.version = (0, $7b3089fdde5d004f$export$6a9022b4c5fcea02);
        this.tableName = (0, $7b3089fdde5d004f$export$9d785db034fb436f);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ DatabaseStorage.prototype.open = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var openDB = window.indexedDB.open(_this.dbName, _this.version);
                        openDB.addEventListener("upgradeneeded", function(e) {
                            var event = e;
                            event.target.result.createObjectStore(_this.tableName);
                        });
                        openDB.addEventListener("success", function(e) {
                            var event = e;
                            _this.db = event.target.result;
                            _this.dbOpen = true;
                            resolve();
                        });
                        openDB.addEventListener("error", function() {
                            return reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createDatabaseUnavailableError());
                        });
                    })
                ];
            });
        });
    };
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ DatabaseStorage.prototype.closeConnection = function() {
        var db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    };
    /**
     * Opens database if it's not already open
     */ DatabaseStorage.prototype.validateDbIsOpen = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.dbOpen) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.open()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ DatabaseStorage.prototype.getItem = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                // TODO: Add timeouts?
                                if (!_this.db) return reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readonly");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbGet = objectStore.get(key);
                                dbGet.addEventListener("success", function(e) {
                                    var event = e;
                                    _this.closeConnection();
                                    resolve(event.target.result);
                                });
                                dbGet.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ DatabaseStorage.prototype.setItem = function(key, payload) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                // TODO: Add timeouts?
                                if (!_this.db) return reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readwrite");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbPut = objectStore.put(payload, key);
                                dbPut.addEventListener("success", function() {
                                    _this.closeConnection();
                                    resolve();
                                });
                                dbPut.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ DatabaseStorage.prototype.removeItem = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                if (!_this.db) return reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readwrite");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbDelete = objectStore.delete(key);
                                dbDelete.addEventListener("success", function() {
                                    _this.closeConnection();
                                    resolve();
                                });
                                dbDelete.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ DatabaseStorage.prototype.getKeys = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                if (!_this.db) return reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readonly");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbGetKeys = objectStore.getAllKeys();
                                dbGetKeys.addEventListener("success", function(e) {
                                    var event = e;
                                    _this.closeConnection();
                                    resolve(event.target.result);
                                });
                                dbGetKeys.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ DatabaseStorage.prototype.containsKey = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.validateDbIsOpen()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                if (!_this.db) return reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createDatabaseNotOpenError());
                                var transaction = _this.db.transaction([
                                    _this.tableName
                                ], "readonly");
                                var objectStore = transaction.objectStore(_this.tableName);
                                var dbContainsKey = objectStore.count(key);
                                dbContainsKey.addEventListener("success", function(e) {
                                    var event = e;
                                    _this.closeConnection();
                                    resolve(event.target.result === 1);
                                });
                                dbContainsKey.addEventListener("error", function(e) {
                                    _this.closeConnection();
                                    reject(e);
                                });
                            })
                        ];
                }
            });
        });
    };
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ DatabaseStorage.prototype.deleteDatabase = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                // Check if database being deleted exists
                if (this.db && this.dbOpen) this.closeConnection();
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var deleteDbRequest = window.indexedDB.deleteDatabase((0, $7b3089fdde5d004f$export$3c22ff8b64b8f565));
                        deleteDbRequest.addEventListener("success", function() {
                            return resolve(true);
                        });
                        deleteDbRequest.addEventListener("blocked", function() {
                            return resolve(true);
                        });
                        deleteDbRequest.addEventListener("error", function() {
                            return reject(false);
                        });
                    })
                ];
            });
        });
    };
    return DatabaseStorage;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $2b3883238de6b5a2$export$d7392285c701ecf5 = /** @class */ function() {
    function MemoryStorage() {
        this.cache = new Map();
    }
    MemoryStorage.prototype.getItem = function(key) {
        return this.cache.get(key) || null;
    };
    MemoryStorage.prototype.setItem = function(key, value) {
        this.cache.set(key, value);
    };
    MemoryStorage.prototype.removeItem = function(key) {
        this.cache.delete(key);
    };
    MemoryStorage.prototype.getKeys = function() {
        var cacheKeys = [];
        this.cache.forEach(function(value, key) {
            cacheKeys.push(key);
        });
        return cacheKeys;
    };
    MemoryStorage.prototype.containsKey = function(key) {
        return this.cache.has(key);
    };
    MemoryStorage.prototype.clear = function() {
        this.cache.clear();
    };
    return MemoryStorage;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ var $f173bedaab35ddf6$export$b38f35aab37afcde = /** @class */ function() {
    function AsyncMemoryStorage(logger, storeName) {
        this.inMemoryCache = new (0, $2b3883238de6b5a2$export$d7392285c701ecf5)();
        this.indexedDBCache = new (0, $e418256889b47027$export$286b0f3b569e5f16)();
        this.logger = logger;
        this.storeName = storeName;
    }
    AsyncMemoryStorage.prototype.handleDatabaseAccessError = function(error) {
        if (error instanceof (0, $68ecaba305c397db$export$f8eb6760ca13876a) && error.errorCode === (0, $68ecaba305c397db$export$6deffaef56f0bd5a).databaseUnavailable.code) this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
        else throw error;
    };
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     */ AsyncMemoryStorage.prototype.getItem = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var item, e_1;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        item = this.inMemoryCache.getItem(key);
                        if (!!item) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage.");
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.getItem(key)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        e_1 = _a.sent();
                        this.handleDatabaseAccessError(e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            item
                        ];
                }
            });
        });
    };
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     */ AsyncMemoryStorage.prototype.setItem = function(key, value) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_2;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.inMemoryCache.setItem(key, value);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.setItem(key, value)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_2 = _a.sent();
                        this.handleDatabaseAccessError(e_2);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     */ AsyncMemoryStorage.prototype.removeItem = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_3;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.inMemoryCache.removeItem(key);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.removeItem(key)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_3 = _a.sent();
                        this.handleDatabaseAccessError(e_3);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     */ AsyncMemoryStorage.prototype.getKeys = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var cacheKeys, e_4;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        cacheKeys = this.inMemoryCache.getKeys();
                        if (!(cacheKeys.length === 0)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        this.logger.verbose("In-memory cache is empty, now querying persistent storage.");
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.getKeys()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        e_4 = _a.sent();
                        this.handleDatabaseAccessError(e_4);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            cacheKeys
                        ];
                }
            });
        });
    };
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     */ AsyncMemoryStorage.prototype.containsKey = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var containsKey, e_5;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        containsKey = this.inMemoryCache.containsKey(key);
                        if (!!containsKey) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        this.logger.verbose("Key not found in in-memory cache, now querying persistent storage.");
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.containsKey(key)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        e_5 = _a.sent();
                        this.handleDatabaseAccessError(e_5);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            containsKey
                        ];
                }
            });
        });
    };
    /**
     * Clears in-memory Map
     */ AsyncMemoryStorage.prototype.clearInMemory = function() {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose("Deleting in-memory keystore " + this.storeName);
        this.inMemoryCache.clear();
        this.logger.verbose("In-memory keystore " + this.storeName + " deleted");
    };
    /**
     * Tries to delete the IndexedDB database
     * @returns
     */ AsyncMemoryStorage.prototype.clearPersistent = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var dbDeleted, e_6;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        this.logger.verbose("Deleting persistent keystore");
                        return [
                            4 /*yield*/ ,
                            this.indexedDBCache.deleteDatabase()
                        ];
                    case 1:
                        dbDeleted = _a.sent();
                        if (dbDeleted) this.logger.verbose("Persistent keystore deleted");
                        return [
                            2 /*return*/ ,
                            dbDeleted
                        ];
                    case 2:
                        e_6 = _a.sent();
                        this.handleDatabaseAccessError(e_6);
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return AsyncMemoryStorage;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $de5d29fee20d8c89$export$8aedbc9f96e92cd4;
(function(CryptoKeyStoreNames) {
    CryptoKeyStoreNames["asymmetricKeys"] = "asymmetricKeys";
    CryptoKeyStoreNames["symmetricKeys"] = "symmetricKeys";
})($de5d29fee20d8c89$export$8aedbc9f96e92cd4 || ($de5d29fee20d8c89$export$8aedbc9f96e92cd4 = {}));
/**
 * MSAL CryptoKeyStore DB Version 2
 */ var $de5d29fee20d8c89$export$fb0c2afa49bfcd68 = /** @class */ function() {
    function CryptoKeyStore(logger) {
        this.logger = logger;
        this.asymmetricKeys = new (0, $f173bedaab35ddf6$export$b38f35aab37afcde)(this.logger, $de5d29fee20d8c89$export$8aedbc9f96e92cd4.asymmetricKeys);
        this.symmetricKeys = new (0, $f173bedaab35ddf6$export$b38f35aab37afcde)(this.logger, $de5d29fee20d8c89$export$8aedbc9f96e92cd4.symmetricKeys);
    }
    CryptoKeyStore.prototype.clear = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_1;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Delete in-memory keystores
                        this.asymmetricKeys.clearInMemory();
                        this.symmetricKeys.clearInMemory();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.asymmetricKeys.clearPersistent()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof Error) this.logger.error("Clearing keystore failed with error: " + e_1.message);
                        else this.logger.error("Clearing keystore failed with unknown error");
                        return [
                            2 /*return*/ ,
                            false
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return CryptoKeyStore;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ var $188a01d1aa1ef5b2$export$c274a7f0ebd24b14 = /** @class */ function() {
    function CryptoOps(logger, performanceClient, cryptoConfig) {
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        this.browserCrypto = new (0, $9e4f9f8893be8953$export$bdaac271e902e541)(this.logger, cryptoConfig);
        this.b64Encode = new (0, $393ce314c54015e0$export$d99f397851818755)();
        this.b64Decode = new (0, $1cdfb8b1eee1d075$export$fe555b2490ffa3fb)();
        this.guidGenerator = new (0, $2adb43089fcdf0dc$export$62dc58eaf2cdc52)(this.browserCrypto);
        this.pkceGenerator = new (0, $23c60c77a73f24dc$export$562113aa73225ba6)(this.browserCrypto);
        this.cache = new (0, $de5d29fee20d8c89$export$fb0c2afa49bfcd68)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ CryptoOps.prototype.createNewGuid = function() {
        return this.guidGenerator.generateGuid();
    };
    /**
     * Encodes input string to base64.
     * @param input
     */ CryptoOps.prototype.base64Encode = function(input) {
        return this.b64Encode.encode(input);
    };
    /**
     * Decodes input string from base64.
     * @param input
     */ CryptoOps.prototype.base64Decode = function(input) {
        return this.b64Decode.decode(input);
    };
    /**
     * Generates PKCE codes used in Authorization Code Flow.
     */ CryptoOps.prototype.generatePkceCodes = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.pkceGenerator.generateCodes()
                ];
            });
        });
    };
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ CryptoOps.prototype.getPublicKeyThumbprint = function(request) {
        var _a;
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var publicKeyThumbMeasurement, keyPair, publicKeyJwk, pubKeyThumprintObj, publicJwkString, publicJwkHash, privateKeyJwk, unextractablePrivateKey;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        publicKeyThumbMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).CryptoOptsGetPublicKeyThumbprint, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.generateKeyPair(CryptoOps.EXTRACTABLE, CryptoOps.POP_KEY_USAGES)
                        ];
                    case 1:
                        keyPair = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.exportJwk(keyPair.publicKey)
                        ];
                    case 2:
                        publicKeyJwk = _b.sent();
                        pubKeyThumprintObj = {
                            e: publicKeyJwk.e,
                            kty: publicKeyJwk.kty,
                            n: publicKeyJwk.n
                        };
                        publicJwkString = (0, $8322bc7f1a7ff5b3$export$27a4bf5378101665).getSortedObjectString(pubKeyThumprintObj);
                        return [
                            4 /*yield*/ ,
                            this.hashString(publicJwkString)
                        ];
                    case 3:
                        publicJwkHash = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.exportJwk(keyPair.privateKey)
                        ];
                    case 4:
                        privateKeyJwk = _b.sent();
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.importJwk(privateKeyJwk, false, [
                                "sign"
                            ])
                        ];
                    case 5:
                        unextractablePrivateKey = _b.sent();
                        // Store Keypair data in keystore
                        return [
                            4 /*yield*/ ,
                            this.cache.asymmetricKeys.setItem(publicJwkHash, {
                                privateKey: unextractablePrivateKey,
                                publicKey: keyPair.publicKey,
                                requestMethod: request.resourceRequestMethod,
                                requestUri: request.resourceRequestUri
                            })
                        ];
                    case 6:
                        // Store Keypair data in keystore
                        _b.sent();
                        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.endMeasurement({
                            success: true
                        });
                        return [
                            2 /*return*/ ,
                            publicJwkHash
                        ];
                }
            });
        });
    };
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     */ CryptoOps.prototype.removeTokenBindingKey = function(kid) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var keyFound;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.cache.asymmetricKeys.removeItem(kid)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.cache.asymmetricKeys.containsKey(kid)
                        ];
                    case 2:
                        keyFound = _a.sent();
                        return [
                            2 /*return*/ ,
                            !keyFound
                        ];
                }
            });
        });
    };
    /**
     * Removes all cryptographic keys from IndexedDB storage
     */ CryptoOps.prototype.clearKeystore = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.cache.clear()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ CryptoOps.prototype.signJwt = function(payload, kid, correlationId) {
        var _a;
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var signJwtMeasurement, cachedKeyPair, publicKeyJwk, publicKeyJwkString, encodedKeyIdThumbprint, shrHeader, encodedShrHeader, encodedPayload, tokenString, tokenBuffer, signatureBuffer, encodedSignature, signedJwt;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        signJwtMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).CryptoOptsSignJwt, correlationId);
                        return [
                            4 /*yield*/ ,
                            this.cache.asymmetricKeys.getItem(kid)
                        ];
                    case 1:
                        cachedKeyPair = _b.sent();
                        if (!cachedKeyPair) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createSigningKeyNotFoundInStorageError(kid);
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.exportJwk(cachedKeyPair.publicKey)
                        ];
                    case 2:
                        publicKeyJwk = _b.sent();
                        publicKeyJwkString = (0, $8322bc7f1a7ff5b3$export$27a4bf5378101665).getSortedObjectString(publicKeyJwk);
                        encodedKeyIdThumbprint = this.b64Encode.urlEncode(JSON.stringify({
                            kid: kid
                        }));
                        shrHeader = (0, $176fa532d6fbfc17$export$91748d132e6cb9b3).getShrHeaderString({
                            kid: encodedKeyIdThumbprint,
                            alg: publicKeyJwk.alg
                        });
                        encodedShrHeader = this.b64Encode.urlEncode(shrHeader);
                        // Generate payload
                        payload.cnf = {
                            jwk: JSON.parse(publicKeyJwkString)
                        };
                        encodedPayload = this.b64Encode.urlEncode(JSON.stringify(payload));
                        tokenString = encodedShrHeader + "." + encodedPayload;
                        tokenBuffer = (0, $8322bc7f1a7ff5b3$export$27a4bf5378101665).stringToArrayBuffer(tokenString);
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.sign(cachedKeyPair.privateKey, tokenBuffer)
                        ];
                    case 3:
                        signatureBuffer = _b.sent();
                        encodedSignature = this.b64Encode.urlEncodeArr(new Uint8Array(signatureBuffer));
                        signedJwt = tokenString + "." + encodedSignature;
                        if (signJwtMeasurement) signJwtMeasurement.endMeasurement({
                            success: true
                        });
                        return [
                            2 /*return*/ ,
                            signedJwt
                        ];
                }
            });
        });
    };
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ CryptoOps.prototype.hashString = function(plainText) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var hashBuffer, hashBytes;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.sha256Digest(plainText)
                        ];
                    case 1:
                        hashBuffer = _a.sent();
                        hashBytes = new Uint8Array(hashBuffer);
                        return [
                            2 /*return*/ ,
                            this.b64Encode.urlEncodeArr(hashBytes)
                        ];
                }
            });
        });
    };
    CryptoOps.POP_KEY_USAGES = [
        "sign",
        "verify"
    ];
    CryptoOps.EXTRACTABLE = true;
    return CryptoOps;
}();


/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $2e9f1da89a74ab73$export$865f57d401606752 = {
    createNewGuid: function() {
        var notImplErr = "Crypto interface - createNewGuid() has not been implemented";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    },
    base64Decode: function() {
        var notImplErr = "Crypto interface - base64Decode() has not been implemented";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    },
    base64Encode: function() {
        var notImplErr = "Crypto interface - base64Encode() has not been implemented";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    },
    generatePkceCodes: function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - generatePkceCodes() has not been implemented";
                throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    getPublicKeyThumbprint: function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - getPublicKeyThumbprint() has not been implemented";
                throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    removeTokenBindingKey: function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - removeTokenBindingKey() has not been implemented";
                throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    clearKeystore: function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - clearKeystore() has not been implemented";
                throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    signJwt: function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - signJwt() has not been implemented";
                throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    hashString: function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Crypto interface - hashString() has not been implemented";
                throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    }
};

/*! @azure/msal-common v13.1.0 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $25dab4b95c1456d8$export$820526014323765f = /** @class */ function() {
    /**
     * Creates an instance of PerformanceClient,
     * an abstract class containing core performance telemetry logic.
     *
     * @constructor
     * @param {string} clientId Client ID of the application
     * @param {string} authority Authority used by the application
     * @param {Logger} logger Logger used by the application
     * @param {string} libraryName Name of the library
     * @param {string} libraryVersion Version of the library
     */ function PerformanceClient(clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry) {
        this.authority = authority;
        this.libraryName = libraryName;
        this.libraryVersion = libraryVersion;
        this.applicationTelemetry = applicationTelemetry;
        this.clientId = clientId;
        this.logger = logger;
        this.callbacks = new Map();
        this.eventsByCorrelationId = new Map();
        this.queueMeasurements = new Map();
        this.preQueueTimeByCorrelationId = new Map();
    }
    /**
     * Starts and returns an platform-specific implementation of IPerformanceMeasurement.
     * Note: this function can be changed to abstract at the next major version bump.
     *
     * @param {string} measureName
     * @param {string} correlationId
     * @returns {IPerformanceMeasurement}
     */ /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ PerformanceClient.prototype.startPerformanceMeasurement = function(measureName, correlationId) {
        return {};
    };
    /**
     * Starts and returns an platform-specific implementation of IPerformanceMeasurement.
     * Note: this incorrectly-named function will be removed at the next major version bump.
     *
     * @param {string} measureName
     * @param {string} correlationId
     * @returns {IPerformanceMeasurement}
     */ /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ PerformanceClient.prototype.startPerformanceMeasuremeant = function(measureName, correlationId) {
        return {};
    };
    /**
     * Get integral fields.
     * Override to change the set.
     */ PerformanceClient.prototype.getIntFields = function() {
        return 0, $57d7adee307e257f$export$f16d39729f4b7302;
    };
    /**
     * Gets map of pre-queue times by correlation Id
     *
     * @param {PerformanceEvents} eventName
     * @param {string} correlationId
     * @returns {number}
     */ PerformanceClient.prototype.getPreQueueTime = function(eventName, correlationId) {
        var preQueueEvent = this.preQueueTimeByCorrelationId.get(correlationId);
        if (!preQueueEvent) {
            this.logger.trace("PerformanceClient.getPreQueueTime: no pre-queue times found for correlationId: " + correlationId + ", unable to add queue measurement");
            return;
        } else if (preQueueEvent.name !== eventName) {
            this.logger.trace("PerformanceClient.getPreQueueTime: no pre-queue time found for " + eventName + ", unable to add queue measurement");
            return;
        }
        return preQueueEvent.time;
    };
    /**
     * Calculates the difference between current time and time when function was queued.
     * Note: It is possible to have 0 as the queue time if the current time and the queued time was the same.
     *
     * @param {number} preQueueTime
     * @param {number} currentTime
     * @returns {number}
     */ PerformanceClient.prototype.calculateQueuedTime = function(preQueueTime, currentTime) {
        if (preQueueTime < 1) {
            this.logger.trace("PerformanceClient: preQueueTime should be a positive integer and not " + preQueueTime);
            return 0;
        }
        if (currentTime < 1) {
            this.logger.trace("PerformanceClient: currentTime should be a positive integer and not " + currentTime);
            return 0;
        }
        if (currentTime < preQueueTime) {
            this.logger.trace("PerformanceClient: currentTime is less than preQueueTime, check how time is being retrieved");
            return 0;
        }
        return currentTime - preQueueTime;
    };
    /**
     * Adds queue measurement time to QueueMeasurements array for given correlation ID.
     *
     * @param {PerformanceEvents} eventName
     * @param {?string} correlationId
     * @param {?number} queueTime
     * @param {?boolean} manuallyCompleted - indicator for manually completed queue measurements
     * @returns
     */ PerformanceClient.prototype.addQueueMeasurement = function(eventName, correlationId, queueTime, manuallyCompleted) {
        if (!correlationId) {
            this.logger.trace("PerformanceClient.addQueueMeasurement: correlationId not provided for " + eventName + ", cannot add queue measurement");
            return;
        }
        if (queueTime === 0) // Possible for there to be no queue time after calculation
        this.logger.trace("PerformanceClient.addQueueMeasurement: queue time provided for " + eventName + " is " + queueTime);
        else if (!queueTime) {
            this.logger.trace("PerformanceClient.addQueueMeasurement: no queue time provided for " + eventName);
            return;
        }
        var queueMeasurement = {
            eventName: eventName,
            queueTime: queueTime,
            manuallyCompleted: manuallyCompleted
        };
        // Adds to existing correlation Id if present in queueMeasurements
        var existingMeasurements = this.queueMeasurements.get(correlationId);
        if (existingMeasurements) {
            existingMeasurements.push(queueMeasurement);
            this.queueMeasurements.set(correlationId, existingMeasurements);
        } else {
            // Sets new correlation Id if not present in queueMeasurements
            this.logger.trace("PerformanceClient.addQueueMeasurement: adding correlationId " + correlationId + " to queue measurements");
            var measurementArray = [
                queueMeasurement
            ];
            this.queueMeasurements.set(correlationId, measurementArray);
        }
        // Delete processed pre-queue event.
        this.preQueueTimeByCorrelationId.delete(correlationId);
    };
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {InProgressPerformanceEvent}
     */ PerformanceClient.prototype.startMeasurement = function(measureName, correlationId) {
        var _this = this;
        var _a, _b;
        // Generate a placeholder correlation if the request does not provide one
        var eventCorrelationId = correlationId || this.generateId();
        if (!correlationId) this.logger.info("PerformanceClient: No correlation id provided for " + measureName + ", generating", eventCorrelationId);
        // Duplicate code to address spelling error will be removed at the next major version bump.
        this.logger.trace("PerformanceClient: Performance measurement started for " + measureName, eventCorrelationId);
        var performanceMeasurement = this.startPerformanceMeasuremeant(measureName, eventCorrelationId);
        performanceMeasurement.startMeasurement();
        var inProgressEvent = {
            eventId: this.generateId(),
            status: (0, $57d7adee307e257f$export$bc3547c8ae7b1db).InProgress,
            authority: this.authority,
            libraryName: this.libraryName,
            libraryVersion: this.libraryVersion,
            clientId: this.clientId,
            name: measureName,
            startTimeMs: Date.now(),
            correlationId: eventCorrelationId,
            appName: (_a = this.applicationTelemetry) === null || _a === void 0 ? void 0 : _a.appName,
            appVersion: (_b = this.applicationTelemetry) === null || _b === void 0 ? void 0 : _b.appVersion
        };
        // Store in progress events so they can be discarded if not ended properly
        this.cacheEventByCorrelationId(inProgressEvent);
        // Return the event and functions the caller can use to properly end/flush the measurement
        return {
            endMeasurement: function(event) {
                return _this.endMeasurement((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, inProgressEvent), event), performanceMeasurement);
            },
            discardMeasurement: function() {
                return _this.discardMeasurements(inProgressEvent.correlationId);
            },
            addStaticFields: function(fields) {
                return _this.addStaticFields(fields, inProgressEvent.correlationId);
            },
            increment: function(counters) {
                return _this.increment(counters, inProgressEvent.correlationId);
            },
            measurement: performanceMeasurement,
            event: inProgressEvent
        };
    };
    /**
     * Stops measuring the performance for an operation. Should only be called directly by PerformanceClient classes,
     * as consumers should instead use the function returned by startMeasurement.
     * Adds a new field named as "[event name]DurationMs" for sub-measurements, completes and emits an event
     * otherwise.
     *
     * @param {PerformanceEvent} event
     * @param {IPerformanceMeasurement} measurement
     * @returns {(PerformanceEvent | null)}
     */ PerformanceClient.prototype.endMeasurement = function(event, measurement) {
        var _this = this;
        var _a, _b;
        var rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (!rootEvent) {
            this.logger.trace("PerformanceClient: Measurement not found for " + event.eventId, event.correlationId);
            return null;
        }
        var isRoot = event.eventId === rootEvent.eventId;
        var queueInfo = {
            totalQueueTime: 0,
            totalQueueCount: 0,
            manuallyCompletedCount: 0
        };
        if (isRoot) {
            queueInfo = this.getQueueInfo(event.correlationId);
            this.discardCache(rootEvent.correlationId);
        } else (_a = rootEvent.incompleteSubMeasurements) === null || _a === void 0 || _a.delete(event.eventId);
        measurement === null || measurement === void 0 || measurement.endMeasurement();
        var durationMs = measurement === null || measurement === void 0 ? void 0 : measurement.flushMeasurement();
        // null indicates no measurement was taken (e.g. needed performance APIs not present)
        if (!durationMs) {
            this.logger.trace("PerformanceClient: Performance measurement not taken", rootEvent.correlationId);
            return null;
        }
        this.logger.trace("PerformanceClient: Performance measurement ended for " + event.name + ": " + durationMs + " ms", event.correlationId);
        // Add sub-measurement attribute to root event.
        if (!isRoot) {
            rootEvent[event.name + "DurationMs"] = Math.floor(durationMs);
            return (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, rootEvent);
        }
        var finalEvent = (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, rootEvent), event);
        var incompleteSubsCount = 0;
        // Incomplete sub-measurements are discarded. They are likely an instrumentation bug that should be fixed.
        (_b = finalEvent.incompleteSubMeasurements) === null || _b === void 0 || _b.forEach(function(subMeasurement) {
            _this.logger.trace("PerformanceClient: Incomplete submeasurement " + subMeasurement.name + " found for " + event.name, finalEvent.correlationId);
            incompleteSubsCount++;
        });
        finalEvent.incompleteSubMeasurements = undefined;
        finalEvent = (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, finalEvent), {
            durationMs: Math.round(durationMs),
            queuedTimeMs: queueInfo.totalQueueTime,
            queuedCount: queueInfo.totalQueueCount,
            queuedManuallyCompletedCount: queueInfo.manuallyCompletedCount,
            status: (0, $57d7adee307e257f$export$bc3547c8ae7b1db).Completed,
            incompleteSubsCount: incompleteSubsCount
        });
        this.truncateIntegralFields(finalEvent, this.getIntFields());
        this.emitEvents([
            finalEvent
        ], event.correlationId);
        return finalEvent;
    };
    /**
     * Saves extra information to be emitted when the measurements are flushed
     * @param fields
     * @param correlationId
     */ PerformanceClient.prototype.addStaticFields = function(fields, correlationId) {
        this.logger.trace("PerformanceClient: Updating static fields");
        var event = this.eventsByCorrelationId.get(correlationId);
        if (event) this.eventsByCorrelationId.set(correlationId, (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, event), fields));
        else this.logger.trace("PerformanceClient: Event not found for", correlationId);
    };
    /**
     * Increment counters to be emitted when the measurements are flushed
     * @param counters {Counters}
     * @param correlationId {string} correlation identifier
     */ PerformanceClient.prototype.increment = function(counters, correlationId) {
        this.logger.trace("PerformanceClient: Updating counters");
        var event = this.eventsByCorrelationId.get(correlationId);
        if (event) for(var counter in counters){
            if (!event.hasOwnProperty(counter)) event[counter] = 0;
            event[counter] += counters[counter];
        }
        else this.logger.trace("PerformanceClient: Event not found for", correlationId);
    };
    /**
     * Upserts event into event cache.
     * First key is the correlation id, second key is the event id.
     * Allows for events to be grouped by correlation id,
     * and to easily allow for properties on them to be updated.
     *
     * @private
     * @param {PerformanceEvent} event
     */ PerformanceClient.prototype.cacheEventByCorrelationId = function(event) {
        var rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (rootEvent) {
            this.logger.trace("PerformanceClient: Performance measurement for " + event.name + " added/updated", event.correlationId);
            rootEvent.incompleteSubMeasurements = rootEvent.incompleteSubMeasurements || new Map();
            rootEvent.incompleteSubMeasurements.set(event.eventId, {
                name: event.name,
                startTimeMs: event.startTimeMs
            });
        } else {
            this.logger.trace("PerformanceClient: Performance measurement for " + event.name + " started", event.correlationId);
            this.eventsByCorrelationId.set(event.correlationId, (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, event));
        }
    };
    PerformanceClient.prototype.getQueueInfo = function(correlationId) {
        var queueMeasurementForCorrelationId = this.queueMeasurements.get(correlationId);
        if (!queueMeasurementForCorrelationId) this.logger.trace("PerformanceClient: no queue measurements found for for correlationId: " + correlationId);
        var totalQueueTime = 0;
        var totalQueueCount = 0;
        var manuallyCompletedCount = 0;
        queueMeasurementForCorrelationId === null || queueMeasurementForCorrelationId === void 0 || queueMeasurementForCorrelationId.forEach(function(measurement) {
            totalQueueTime += measurement.queueTime;
            totalQueueCount++;
            manuallyCompletedCount += measurement.manuallyCompleted ? 1 : 0;
        });
        return {
            totalQueueTime: totalQueueTime,
            totalQueueCount: totalQueueCount,
            manuallyCompletedCount: manuallyCompletedCount
        };
    };
    /**
     * Removes measurements for a given correlation id.
     *
     * @param {string} correlationId
     */ PerformanceClient.prototype.discardMeasurements = function(correlationId) {
        this.logger.trace("PerformanceClient: Performance measurements discarded", correlationId);
        this.eventsByCorrelationId.delete(correlationId);
    };
    /**
     * Removes cache for a given correlation id.
     *
     * @param {string} correlationId correlation identifier
     */ PerformanceClient.prototype.discardCache = function(correlationId) {
        this.discardMeasurements(correlationId);
        this.logger.trace("PerformanceClient: QueueMeasurements discarded", correlationId);
        this.queueMeasurements.delete(correlationId);
        this.logger.trace("PerformanceClient: Pre-queue times discarded", correlationId);
        this.preQueueTimeByCorrelationId.delete(correlationId);
    };
    /**
     * Registers a callback function to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ PerformanceClient.prototype.addPerformanceCallback = function(callback) {
        var callbackId = this.generateId();
        this.callbacks.set(callbackId, callback);
        this.logger.verbose("PerformanceClient: Performance callback registered with id: " + callbackId);
        return callbackId;
    };
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ PerformanceClient.prototype.removePerformanceCallback = function(callbackId) {
        var result = this.callbacks.delete(callbackId);
        if (result) this.logger.verbose("PerformanceClient: Performance callback " + callbackId + " removed.");
        else this.logger.verbose("PerformanceClient: Performance callback " + callbackId + " not removed.");
        return result;
    };
    /**
     * Emits events to all registered callbacks.
     *
     * @param {PerformanceEvent[]} events
     * @param {?string} [correlationId]
     */ PerformanceClient.prototype.emitEvents = function(events, correlationId) {
        var _this = this;
        this.logger.verbose("PerformanceClient: Emitting performance events", correlationId);
        this.callbacks.forEach(function(callback, callbackId) {
            _this.logger.trace("PerformanceClient: Emitting event to callback " + callbackId, correlationId);
            callback.apply(null, [
                events
            ]);
        });
    };
    /**
     * Enforce truncation of integral fields in performance event.
     * @param {PerformanceEvent} event performance event to update.
     * @param {Set<string>} intFields integral fields.
     */ PerformanceClient.prototype.truncateIntegralFields = function(event, intFields) {
        intFields.forEach(function(key) {
            if (key in event && typeof event[key] === "number") event[key] = Math.floor(event[key]);
        });
    };
    return PerformanceClient;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $a4de6f8cf4e2564d$export$647004217f4122f0 = /** @class */ function() {
    function StubPerformanceMeasurement() {}
    /* eslint-disable-next-line @typescript-eslint/no-empty-function */ StubPerformanceMeasurement.prototype.startMeasurement = function() {};
    /* eslint-disable-next-line @typescript-eslint/no-empty-function */ StubPerformanceMeasurement.prototype.endMeasurement = function() {};
    StubPerformanceMeasurement.prototype.flushMeasurement = function() {
        return null;
    };
    return StubPerformanceMeasurement;
}();
var $a4de6f8cf4e2564d$export$c70f2989a65fda3e = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(StubPerformanceClient, _super);
    function StubPerformanceClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StubPerformanceClient.prototype.generateId = function() {
        return "callback-id";
    };
    StubPerformanceClient.prototype.startPerformanceMeasuremeant = function() {
        return new $a4de6f8cf4e2564d$export$647004217f4122f0();
    };
    StubPerformanceClient.prototype.startPerformanceMeasurement = function() {
        return new $a4de6f8cf4e2564d$export$647004217f4122f0();
    };
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ StubPerformanceClient.prototype.calculateQueuedTime = function(preQueueTime, currentTime) {
        return 0;
    };
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ StubPerformanceClient.prototype.addQueueMeasurement = function(eventName, correlationId, queueTime) {
        return;
    };
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ StubPerformanceClient.prototype.setPreQueueTime = function(eventName, correlationId) {
        return;
    };
    return StubPerformanceClient;
}((0, $25dab4b95c1456d8$export$820526014323765f));


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base type for credentials to be stored in the cache: eg: ACCESS_TOKEN, ID_TOKEN etc
 *
 * Key:Value Schema:
 *
 * Key: <home_account_id*>-<environment>-<credential_type>-<client_id>-<realm*>-<target*>-<requestedClaims*>-<scheme*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, usually only used for refresh tokens
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 *      tokenType: Matches the authentication scheme for which the token was issued (i.e. Bearer or pop)
 *      requestedClaimsHash: Matches the SHA 256 hash of the claims object included in the token request
 *      userAssertionHash: Matches the SHA 256 hash of the obo_assertion for the OBO flow
 * }
 */ var $00f293d2e5477c13$export$39bc12230e4d3f33 = /** @class */ function() {
    function CredentialEntity() {}
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */ CredentialEntity.prototype.generateAccountId = function() {
        return CredentialEntity.generateAccountIdForCacheKey(this.homeAccountId, this.environment);
    };
    /**
     * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
     */ CredentialEntity.prototype.generateCredentialId = function() {
        return CredentialEntity.generateCredentialIdForCacheKey(this.credentialType, this.clientId, this.realm, this.familyId);
    };
    /**
     * Generate target key component as per schema: <target>
     */ CredentialEntity.prototype.generateTarget = function() {
        return CredentialEntity.generateTargetForCacheKey(this.target);
    };
    /**
     * generates credential key
     */ CredentialEntity.prototype.generateCredentialKey = function() {
        return CredentialEntity.generateCredentialCacheKey(this.homeAccountId, this.environment, this.credentialType, this.clientId, this.realm, this.target, this.familyId, this.tokenType, this.requestedClaimsHash);
    };
    /**
     * returns the type of the cache (in this case credential)
     */ CredentialEntity.prototype.generateType = function() {
        switch(this.credentialType){
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN:
                return (0, $1b76d687a319d9ed$export$ba193b555633db78).ID_TOKEN;
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN:
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME:
                return (0, $1b76d687a319d9ed$export$ba193b555633db78).ACCESS_TOKEN;
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                return (0, $1b76d687a319d9ed$export$ba193b555633db78).REFRESH_TOKEN;
            default:
                throw (0, $30cd164be78785f3$export$a839ff85a7957561).createUnexpectedCredentialTypeError();
        }
    };
    /**
     * generates credential key
     * <home_account_id*>-\<environment>-<credential_type>-<client_id>-<realm\*>-<target\*>-<scheme\*>
     */ CredentialEntity.generateCredentialCacheKey = function(homeAccountId, environment, credentialType, clientId, realm, target, familyId, tokenType, requestedClaimsHash) {
        var credentialKey = [
            this.generateAccountIdForCacheKey(homeAccountId, environment),
            this.generateCredentialIdForCacheKey(credentialType, clientId, realm, familyId),
            this.generateTargetForCacheKey(target),
            this.generateClaimsHashForCacheKey(requestedClaimsHash),
            this.generateSchemeForCacheKey(tokenType)
        ];
        return credentialKey.join((0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * generates Account Id for keys
     * @param homeAccountId
     * @param environment
     */ CredentialEntity.generateAccountIdForCacheKey = function(homeAccountId, environment) {
        var accountId = [
            homeAccountId,
            environment
        ];
        return accountId.join((0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generates Credential Id for keys
     * @param credentialType
     * @param realm
     * @param clientId
     * @param familyId
     */ CredentialEntity.generateCredentialIdForCacheKey = function(credentialType, clientId, realm, familyId) {
        var clientOrFamilyId = credentialType === (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN ? familyId || clientId : clientId;
        var credentialId = [
            credentialType,
            clientOrFamilyId,
            realm || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        ];
        return credentialId.join((0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Generate target key component as per schema: <target>
     */ CredentialEntity.generateTargetForCacheKey = function(scopes) {
        return (scopes || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING).toLowerCase();
    };
    /**
     * Generate requested claims key component as per schema: <requestedClaims>
     */ CredentialEntity.generateClaimsHashForCacheKey = function(requestedClaimsHash) {
        return (requestedClaimsHash || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING).toLowerCase();
    };
    /**
     * Generate scheme key componenet as per schema: <scheme>
     */ CredentialEntity.generateSchemeForCacheKey = function(tokenType) {
        /*
         * PoP Tokens and SSH certs include scheme in cache key
         * Cast to lowercase to handle "bearer" from ADFS
         */ return tokenType && tokenType.toLowerCase() !== (0, $1b76d687a319d9ed$export$901491a717da2ba5).BEARER.toLowerCase() ? tokenType.toLowerCase() : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
    };
    return CredentialEntity;
}();



/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility class which exposes functions for managing date and time operations.
 */ var $7efd823b057a2db4$export$3117a0de16ab2854 = /** @class */ function() {
    function TimeUtils() {}
    /**
     * return the current time in Unix time (seconds).
     */ TimeUtils.nowSeconds = function() {
        // Date.getTime() returns in milliseconds.
        return Math.round(new Date().getTime() / 1000.0);
    };
    /**
     * check if a token is expired based on given UTC time in seconds.
     * @param expiresOn
     */ TimeUtils.isTokenExpired = function(expiresOn, offset) {
        // check for access token expiry
        var expirationSec = Number(expiresOn) || 0;
        var offsetCurrentTimeSec = TimeUtils.nowSeconds() + offset;
        // If current time + offset is greater than token expiration time, then token is expired.
        return offsetCurrentTimeSec > expirationSec;
    };
    /**
     * If the current time is earlier than the time that a token was cached at, we must discard the token
     * i.e. The system clock was turned back after acquiring the cached token
     * @param cachedAt
     * @param offset
     */ TimeUtils.wasClockTurnedBack = function(cachedAt) {
        var cachedAtSec = Number(cachedAt);
        return cachedAtSec > TimeUtils.nowSeconds();
    };
    /**
     * Waits for t number of milliseconds
     * @param t number
     * @param value T
     */ TimeUtils.delay = function(t, value) {
        return new Promise(function(resolve) {
            return setTimeout(function() {
                return resolve(value);
            }, t);
        });
    };
    return TimeUtils;
}();



/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * JWT Token representation class. Parses token string and generates claims object.
 */ var $88f623fdecedc666$export$3a170961dab30083 = /** @class */ function() {
    function AuthToken(rawToken, crypto) {
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(rawToken)) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createTokenNullOrEmptyError(rawToken);
        this.rawToken = rawToken;
        this.claims = AuthToken.extractTokenClaims(rawToken, crypto);
    }
    /**
     * Extract token by decoding the rawToken
     *
     * @param encodedToken
     */ AuthToken.extractTokenClaims = function(encodedToken, crypto) {
        var decodedToken = (0, $1842614da3ac031b$export$ecc754f99843e759).decodeAuthToken(encodedToken);
        // token will be decoded to get the username
        try {
            var base64TokenPayload = decodedToken.JWSPayload;
            // base64Decode() should throw an error if there is an issue
            var base64Decoded = crypto.base64Decode(base64TokenPayload);
            return JSON.parse(base64Decoded);
        } catch (err) {
            throw (0, $30cd164be78785f3$export$a839ff85a7957561).createTokenParsingError(err);
        }
    };
    /**
     * Determine if the token's max_age has transpired
     */ AuthToken.checkMaxAge = function(authTime, maxAge) {
        /*
         * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
         * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
         * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
         */ var fiveMinuteSkew = 300000; // five minutes in milliseconds
        if (maxAge === 0 || Date.now() - fiveMinuteSkew > authTime + maxAge) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createMaxAgeTranspiredError();
    };
    return AuthToken;
}();



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ACCESS_TOKEN Credential Type
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-accesstoken-clientId-contoso.com-user.read
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, usually only used for refresh tokens
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 *      cachedAt: Absolute device time when entry was created in the cache.
 *      expiresOn: Token expiry time, calculated based on current UTC time in seconds. Represented as a string.
 *      extendedExpiresOn: Additional extended expiry time until when token is valid in case of server-side outage. Represented as string in UTC seconds.
 *      keyId: used for POP and SSH tokenTypes
 *      tokenType: Type of the token issued. Usually "Bearer"
 * }
 */ var $698539a43f4f793b$export$6b7a8e14ec177765 = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(AccessTokenEntity, _super);
    function AccessTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create AccessTokenEntity
     * @param homeAccountId
     * @param environment
     * @param accessToken
     * @param clientId
     * @param tenantId
     * @param scopes
     * @param expiresOn
     * @param extExpiresOn
     */ AccessTokenEntity.createAccessTokenEntity = function(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, cryptoUtils, refreshOn, tokenType, userAssertionHash, keyId, requestedClaims, requestedClaimsHash) {
        var _a, _b;
        var atEntity = new AccessTokenEntity();
        atEntity.homeAccountId = homeAccountId;
        atEntity.credentialType = (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        atEntity.secret = accessToken;
        var currentTime = (0, $7efd823b057a2db4$export$3117a0de16ab2854).nowSeconds();
        atEntity.cachedAt = currentTime.toString();
        /*
         * Token expiry time.
         * This value should be  calculated based on the current UTC time measured locally and the value  expires_in Represented as a string in JSON.
         */ atEntity.expiresOn = expiresOn.toString();
        atEntity.extendedExpiresOn = extExpiresOn.toString();
        if (refreshOn) atEntity.refreshOn = refreshOn.toString();
        atEntity.environment = environment;
        atEntity.clientId = clientId;
        atEntity.realm = tenantId;
        atEntity.target = scopes;
        atEntity.userAssertionHash = userAssertionHash;
        atEntity.tokenType = (0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(tokenType) ? (0, $1b76d687a319d9ed$export$901491a717da2ba5).BEARER : tokenType;
        if (requestedClaims) {
            atEntity.requestedClaims = requestedClaims;
            atEntity.requestedClaimsHash = requestedClaimsHash;
        }
        /*
         * Create Access Token With Auth Scheme instead of regular access token
         * Cast to lower to handle "bearer" from ADFS
         */ if (((_a = atEntity.tokenType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== (0, $1b76d687a319d9ed$export$901491a717da2ba5).BEARER.toLowerCase()) {
            atEntity.credentialType = (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
            switch(atEntity.tokenType){
                case (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP:
                    // Make sure keyId is present and add it to credential
                    var tokenClaims = (0, $88f623fdecedc666$export$3a170961dab30083).extractTokenClaims(accessToken, cryptoUtils);
                    if (!((_b = tokenClaims === null || tokenClaims === void 0 ? void 0 : tokenClaims.cnf) === null || _b === void 0 ? void 0 : _b.kid)) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createTokenClaimsRequiredError();
                    atEntity.keyId = tokenClaims.cnf.kid;
                    break;
                case (0, $1b76d687a319d9ed$export$901491a717da2ba5).SSH:
                    atEntity.keyId = keyId;
            }
        }
        return atEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ AccessTokenEntity.isAccessTokenEntity = function(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN || entity["credentialType"] === (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME);
    };
    return AccessTokenEntity;
}((0, $00f293d2e5477c13$export$39bc12230e4d3f33));

/*! @azure/msal-common v13.1.0 2023-06-07 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * APP_METADATA Cache
 *
 * Key:Value Schema:
 *
 * Key: appmetadata-<environment>-<client_id>
 *
 * Value:
 * {
 *      clientId: client ID of the application
 *      environment: entity that issued the token, represented as a full host
 *      familyId: Family ID identifier, '1' represents Microsoft Family
 * }
 */ var $bd0d508238673d4b$export$b939be19f91a34cc = /** @class */ function() {
    function AppMetadataEntity() {}
    /**
     * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
     */ AppMetadataEntity.prototype.generateAppMetadataKey = function() {
        return AppMetadataEntity.generateAppMetadataCacheKey(this.environment, this.clientId);
    };
    /**
     * Generate AppMetadata Cache Key
     */ AppMetadataEntity.generateAppMetadataCacheKey = function(environment, clientId) {
        var appMetaDataKeyArray = [
            (0, $1b76d687a319d9ed$export$7e1bea6dc1b6b32e),
            environment,
            clientId
        ];
        return appMetaDataKeyArray.join((0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    };
    /**
     * Creates AppMetadataEntity
     * @param clientId
     * @param environment
     * @param familyId
     */ AppMetadataEntity.createAppMetadataEntity = function(clientId, environment, familyId) {
        var appMetadata = new AppMetadataEntity();
        appMetadata.clientId = clientId;
        appMetadata.environment = environment;
        if (familyId) appMetadata.familyId = familyId;
        return appMetadata;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ AppMetadataEntity.isAppMetadataEntity = function(key, entity) {
        if (!entity) return false;
        return key.indexOf((0, $1b76d687a319d9ed$export$7e1bea6dc1b6b32e)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
    };
    return AppMetadataEntity;
}();

/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $cfca0354626cc9b4$export$49e7dcb371a5f08e = /** @class */ function() {
    function AuthorityMetadataEntity() {
        this.expiresAt = (0, $7efd823b057a2db4$export$3117a0de16ab2854).nowSeconds() + (0, $1b76d687a319d9ed$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
    }
    /**
     * Update the entity with new aliases, preferred_cache and preferred_network values
     * @param metadata
     * @param fromNetwork
     */ AuthorityMetadataEntity.prototype.updateCloudDiscoveryMetadata = function(metadata, fromNetwork) {
        this.aliases = metadata.aliases;
        this.preferred_cache = metadata.preferred_cache;
        this.preferred_network = metadata.preferred_network;
        this.aliasesFromNetwork = fromNetwork;
    };
    /**
     * Update the entity with new endpoints
     * @param metadata
     * @param fromNetwork
     */ AuthorityMetadataEntity.prototype.updateEndpointMetadata = function(metadata, fromNetwork) {
        this.authorization_endpoint = metadata.authorization_endpoint;
        this.token_endpoint = metadata.token_endpoint;
        this.end_session_endpoint = metadata.end_session_endpoint;
        this.issuer = metadata.issuer;
        this.endpointsFromNetwork = fromNetwork;
        this.jwks_uri = metadata.jwks_uri;
    };
    /**
     * Save the authority that was used to create this cache entry
     * @param authority
     */ AuthorityMetadataEntity.prototype.updateCanonicalAuthority = function(authority) {
        this.canonical_authority = authority;
    };
    /**
     * Reset the exiresAt value
     */ AuthorityMetadataEntity.prototype.resetExpiresAt = function() {
        this.expiresAt = (0, $7efd823b057a2db4$export$3117a0de16ab2854).nowSeconds() + (0, $1b76d687a319d9ed$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
    };
    /**
     * Returns whether or not the data needs to be refreshed
     */ AuthorityMetadataEntity.prototype.isExpired = function() {
        return this.expiresAt <= (0, $7efd823b057a2db4$export$3117a0de16ab2854).nowSeconds();
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ AuthorityMetadataEntity.isAuthorityMetadataEntity = function(key, entity) {
        if (!entity) return false;
        return key.indexOf((0, $1b76d687a319d9ed$export$d483f966e66f4db5).CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
    };
    return AuthorityMetadataEntity;
}();

/*! @azure/msal-common v13.1.0 2023-06-07 */ 

/*! @azure/msal-common v13.1.0 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 */ var $00955c54f5ad4b2a$export$8a1024301e8298df = {
    redirectUriNotSet: {
        code: "redirect_uri_empty",
        desc: "A redirect URI is required for all calls, and none has been set."
    },
    postLogoutUriNotSet: {
        code: "post_logout_uri_empty",
        desc: "A post logout redirect has not been set."
    },
    claimsRequestParsingError: {
        code: "claims_request_parsing_error",
        desc: "Could not parse the given claims request object."
    },
    authorityUriInsecure: {
        code: "authority_uri_insecure",
        desc: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options"
    },
    urlParseError: {
        code: "url_parse_error",
        desc: "URL could not be parsed into appropriate segments."
    },
    urlEmptyError: {
        code: "empty_url_error",
        desc: "URL was empty or null."
    },
    emptyScopesError: {
        code: "empty_input_scopes_error",
        desc: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token."
    },
    nonArrayScopesError: {
        code: "nonarray_input_scopes_error",
        desc: "Scopes cannot be passed as non-array."
    },
    clientIdSingleScopeError: {
        code: "clientid_input_scopes_error",
        desc: "Client ID can only be provided as a single scope."
    },
    invalidPrompt: {
        code: "invalid_prompt_value",
        desc: "Supported prompt values are 'login', 'select_account', 'consent', 'create', 'none' and 'no_session'.  Please see here for valid configuration options: https://azuread.github.io/microsoft-authentication-library-for-js/ref/modules/_azure_msal_common.html#commonauthorizationurlrequest"
    },
    invalidClaimsRequest: {
        code: "invalid_claims",
        desc: "Given claims parameter must be a stringified JSON object."
    },
    tokenRequestEmptyError: {
        code: "token_request_empty",
        desc: "Token request was empty and not found in cache."
    },
    logoutRequestEmptyError: {
        code: "logout_request_empty",
        desc: "The logout request was null or undefined."
    },
    invalidCodeChallengeMethod: {
        code: "invalid_code_challenge_method",
        desc: 'code_challenge_method passed is invalid. Valid values are "plain" and "S256".'
    },
    invalidCodeChallengeParams: {
        code: "pkce_params_missing",
        desc: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request"
    },
    invalidCloudDiscoveryMetadata: {
        code: "invalid_cloud_discovery_metadata",
        desc: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields"
    },
    invalidAuthorityMetadata: {
        code: "invalid_authority_metadata",
        desc: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields."
    },
    untrustedAuthority: {
        code: "untrusted_authority",
        desc: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter."
    },
    invalidAzureCloudInstance: {
        code: "invalid_azure_cloud_instance",
        desc: "Invalid AzureCloudInstance provided. Please refer MSAL JS docs: aks.ms/msaljs/azure_cloud_instance for valid values"
    },
    missingSshJwk: {
        code: "missing_ssh_jwk",
        desc: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme."
    },
    missingSshKid: {
        code: "missing_ssh_kid",
        desc: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme."
    },
    missingNonceAuthenticationHeader: {
        code: "missing_nonce_authentication_header",
        desc: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce."
    },
    invalidAuthenticationHeader: {
        code: "invalid_authentication_header",
        desc: "Invalid authentication header provided"
    },
    authorityMismatch: {
        code: "authority_mismatch",
        desc: "Authority mismatch error. Authority provided in login request or PublicClientApplication config does not match the environment of the provided account. Please use a matching account or make an interactive request to login to this authority."
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ var $00955c54f5ad4b2a$export$ac9d9d20c2327339 = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(ClientConfigurationError, _super);
    function ClientConfigurationError(errorCode, errorMessage) {
        var _this = _super.call(this, errorCode, errorMessage) || this;
        _this.name = "ClientConfigurationError";
        Object.setPrototypeOf(_this, ClientConfigurationError.prototype);
        return _this;
    }
    /**
     * Creates an error thrown when the redirect uri is empty (not set by caller)
     */ ClientConfigurationError.createRedirectUriEmptyError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.redirectUriNotSet.code, $00955c54f5ad4b2a$export$8a1024301e8298df.redirectUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
     */ ClientConfigurationError.createPostLogoutRedirectUriEmptyError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.postLogoutUriNotSet.code, $00955c54f5ad4b2a$export$8a1024301e8298df.postLogoutUriNotSet.desc);
    };
    /**
     * Creates an error thrown when the claims request could not be successfully parsed
     */ ClientConfigurationError.createClaimsRequestParsingError = function(claimsRequestParseError) {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.claimsRequestParsingError.code, $00955c54f5ad4b2a$export$8a1024301e8298df.claimsRequestParsingError.desc + " Given value: " + claimsRequestParseError);
    };
    /**
     * Creates an error thrown if authority uri is given an insecure protocol.
     * @param urlString
     */ ClientConfigurationError.createInsecureAuthorityUriError = function(urlString) {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.authorityUriInsecure.code, $00955c54f5ad4b2a$export$8a1024301e8298df.authorityUriInsecure.desc + " Given URI: " + urlString);
    };
    /**
     * Creates an error thrown if URL string does not parse into separate segments.
     * @param urlString
     */ ClientConfigurationError.createUrlParseError = function(urlParseError) {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.urlParseError.code, $00955c54f5ad4b2a$export$8a1024301e8298df.urlParseError.desc + " Given Error: " + urlParseError);
    };
    /**
     * Creates an error thrown if URL string is empty or null.
     * @param urlString
     */ ClientConfigurationError.createUrlEmptyError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.urlEmptyError.code, $00955c54f5ad4b2a$export$8a1024301e8298df.urlEmptyError.desc);
    };
    /**
     * Error thrown when scopes are empty.
     * @param scopesValue
     */ ClientConfigurationError.createEmptyScopesArrayError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.emptyScopesError.code, "" + $00955c54f5ad4b2a$export$8a1024301e8298df.emptyScopesError.desc);
    };
    /**
     * Error thrown when client id scope is not provided as single scope.
     * @param inputScopes
     */ ClientConfigurationError.createClientIdSingleScopeError = function(inputScopes) {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.clientIdSingleScopeError.code, $00955c54f5ad4b2a$export$8a1024301e8298df.clientIdSingleScopeError.desc + " Given Scopes: " + inputScopes);
    };
    /**
     * Error thrown when prompt is not an allowed type.
     * @param promptValue
     */ ClientConfigurationError.createInvalidPromptError = function(promptValue) {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.invalidPrompt.code, $00955c54f5ad4b2a$export$8a1024301e8298df.invalidPrompt.desc + " Given value: " + promptValue);
    };
    /**
     * Creates error thrown when claims parameter is not a stringified JSON object
     */ ClientConfigurationError.createInvalidClaimsRequestError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.invalidClaimsRequest.code, $00955c54f5ad4b2a$export$8a1024301e8298df.invalidClaimsRequest.desc);
    };
    /**
     * Throws error when token request is empty and nothing cached in storage.
     */ ClientConfigurationError.createEmptyLogoutRequestError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.logoutRequestEmptyError.code, $00955c54f5ad4b2a$export$8a1024301e8298df.logoutRequestEmptyError.desc);
    };
    /**
     * Throws error when token request is empty and nothing cached in storage.
     */ ClientConfigurationError.createEmptyTokenRequestError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.tokenRequestEmptyError.code, $00955c54f5ad4b2a$export$8a1024301e8298df.tokenRequestEmptyError.desc);
    };
    /**
     * Throws error when an invalid code_challenge_method is passed by the user
     */ ClientConfigurationError.createInvalidCodeChallengeMethodError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.invalidCodeChallengeMethod.code, $00955c54f5ad4b2a$export$8a1024301e8298df.invalidCodeChallengeMethod.desc);
    };
    /**
     * Throws error when both params: code_challenge and code_challenge_method are not passed together
     */ ClientConfigurationError.createInvalidCodeChallengeParamsError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.invalidCodeChallengeParams.code, $00955c54f5ad4b2a$export$8a1024301e8298df.invalidCodeChallengeParams.desc);
    };
    /**
     * Throws an error when the user passes invalid cloudDiscoveryMetadata
     */ ClientConfigurationError.createInvalidCloudDiscoveryMetadataError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.invalidCloudDiscoveryMetadata.code, $00955c54f5ad4b2a$export$8a1024301e8298df.invalidCloudDiscoveryMetadata.desc);
    };
    /**
     * Throws an error when the user passes invalid cloudDiscoveryMetadata
     */ ClientConfigurationError.createInvalidAuthorityMetadataError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.invalidAuthorityMetadata.code, $00955c54f5ad4b2a$export$8a1024301e8298df.invalidAuthorityMetadata.desc);
    };
    /**
     * Throws error when provided authority is not a member of the trusted host list
     */ ClientConfigurationError.createUntrustedAuthorityError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.untrustedAuthority.code, $00955c54f5ad4b2a$export$8a1024301e8298df.untrustedAuthority.desc);
    };
    /**
     * Throws error when the AzureCloudInstance is set to an invalid value
     */ ClientConfigurationError.createInvalidAzureCloudInstanceError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.invalidAzureCloudInstance.code, $00955c54f5ad4b2a$export$8a1024301e8298df.invalidAzureCloudInstance.desc);
    };
    /**
     * Throws an error when the authentication scheme is set to SSH but the SSH public key is omitted from the request
     */ ClientConfigurationError.createMissingSshJwkError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.missingSshJwk.code, $00955c54f5ad4b2a$export$8a1024301e8298df.missingSshJwk.desc);
    };
    /**
     * Throws an error when the authentication scheme is set to SSH but the SSH public key ID is omitted from the request
     */ ClientConfigurationError.createMissingSshKidError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.missingSshKid.code, $00955c54f5ad4b2a$export$8a1024301e8298df.missingSshKid.desc);
    };
    /**
     * Throws error when provided headers don't contain a header that a server nonce can be extracted from
     */ ClientConfigurationError.createMissingNonceAuthenticationHeadersError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.missingNonceAuthenticationHeader.code, $00955c54f5ad4b2a$export$8a1024301e8298df.missingNonceAuthenticationHeader.desc);
    };
    /**
     * Throws error when a provided header is invalid in any way
     */ ClientConfigurationError.createInvalidAuthenticationHeaderError = function(invalidHeaderName, details) {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.invalidAuthenticationHeader.code, $00955c54f5ad4b2a$export$8a1024301e8298df.invalidAuthenticationHeader.desc + ". Invalid header: " + invalidHeaderName + ". Details: " + details);
    };
    /**
     * Create an error when the authority provided in request does not match authority provided in account or MSAL.js configuration.
     */ ClientConfigurationError.createAuthorityMismatchError = function() {
        return new ClientConfigurationError($00955c54f5ad4b2a$export$8a1024301e8298df.authorityMismatch.code, $00955c54f5ad4b2a$export$8a1024301e8298df.authorityMismatch.desc);
    };
    return ClientConfigurationError;
}((0, $30cd164be78785f3$export$a839ff85a7957561));





"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ var $6c0c9a351143193b$export$b9b82b0f94ae1f99 = /** @class */ function() {
    function ScopeSet(inputScopes) {
        var _this = this;
        // Filter empty string and null/undefined array items
        var scopeArr = inputScopes ? (0, $1842614da3ac031b$export$ecc754f99843e759).trimArrayEntries((0, $35bd2ff9e18a8648$export$6388937ca91ccae8)(inputScopes)) : [];
        var filteredInput = scopeArr ? (0, $1842614da3ac031b$export$ecc754f99843e759).removeEmptyStringsFromArray(scopeArr) : [];
        // Validate and filter scopes (validate function throws if validation fails)
        this.validateInputScopes(filteredInput);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach(function(scope) {
            return _this.scopes.add(scope);
        });
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ ScopeSet.fromString = function(inputScopeString) {
        var scopeString = inputScopeString || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        var inputScopes = scopeString.split(" ");
        return new ScopeSet(inputScopes);
    };
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ ScopeSet.createSearchScopes = function(inputScopeString) {
        var scopeSet = new ScopeSet(inputScopeString);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, $1b76d687a319d9ed$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    };
    /**
     * Used to validate the scopes input parameter requested  by the developer.
     * @param {Array<string>} inputScopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
     * @param {boolean} scopesRequired - Boolean indicating whether the scopes array is required or not
     */ ScopeSet.prototype.validateInputScopes = function(inputScopes) {
        // Check if scopes are required but not given or is an empty array
        if (!inputScopes || inputScopes.length < 1) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createEmptyScopesArrayError();
    };
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ ScopeSet.prototype.containsScope = function(scope) {
        var lowerCaseScopes = this.printScopesLowerCase().split(" ");
        var lowerCaseScopesSet = new ScopeSet(lowerCaseScopes);
        // compare lowercase scopes
        return !(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(scope) ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    };
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ ScopeSet.prototype.containsScopeSet = function(scopeSet) {
        var _this = this;
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every(function(scope) {
            return _this.containsScope(scope);
        });
    };
    /**
     * Check if set of scopes contains only the defaults
     */ ScopeSet.prototype.containsOnlyOIDCScopes = function() {
        var _this = this;
        var defaultScopeCount = 0;
        (0, $1b76d687a319d9ed$export$268e88275f5afab2).forEach(function(defaultScope) {
            if (_this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    };
    /**
     * Appends single scope if passed
     * @param newScope
     */ ScopeSet.prototype.appendScope = function(newScope) {
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(newScope)) this.scopes.add(newScope.trim());
    };
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ ScopeSet.prototype.appendScopes = function(newScopes) {
        var _this = this;
        try {
            newScopes.forEach(function(newScope) {
                return _this.appendScope(newScope);
            });
        } catch (e) {
            throw (0, $30cd164be78785f3$export$a839ff85a7957561).createAppendScopeSetError(e);
        }
    };
    /**
     * Removes element from set of scopes.
     * @param scope
     */ ScopeSet.prototype.removeScope = function(scope) {
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(scope)) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createRemoveEmptyScopeFromSetError(scope);
        this.scopes.delete(scope.trim());
    };
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ ScopeSet.prototype.removeOIDCScopes = function() {
        var _this = this;
        (0, $1b76d687a319d9ed$export$268e88275f5afab2).forEach(function(defaultScope) {
            _this.scopes.delete(defaultScope);
        });
    };
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ ScopeSet.prototype.unionScopeSets = function(otherScopes) {
        if (!otherScopes) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEmptyInputScopeSetError();
        var unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach(function(scope) {
            return unionScopes.add(scope.toLowerCase());
        });
        this.scopes.forEach(function(scope) {
            return unionScopes.add(scope.toLowerCase());
        });
        return unionScopes;
    };
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ ScopeSet.prototype.intersectingScopeSets = function(otherScopes) {
        if (!otherScopes) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEmptyInputScopeSetError();
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        var unionScopes = this.unionScopeSets(otherScopes);
        var sizeOtherScopes = otherScopes.getScopeCount();
        var sizeThisScopes = this.getScopeCount();
        var sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    };
    /**
     * Returns size of set of scopes.
     */ ScopeSet.prototype.getScopeCount = function() {
        return this.scopes.size;
    };
    /**
     * Returns the scopes as an array of string values
     */ ScopeSet.prototype.asArray = function() {
        var array = [];
        this.scopes.forEach(function(val) {
            return array.push(val);
        });
        return array;
    };
    /**
     * Prints scopes into a space-delimited string
     */ ScopeSet.prototype.printScopes = function() {
        if (this.scopes) {
            var scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
    };
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ ScopeSet.prototype.printScopesLowerCase = function() {
        return this.printScopes().toLowerCase();
    };
    return ScopeSet;
}();






/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/* eslint-disable header/header */ var $d86c8dd6d40ffd16$export$a8ff84c12d48cfa6 = "@azure/msal-common";
var $d86c8dd6d40ffd16$export$83d89fbfd8236492 = "13.1.0";


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 */ var $6d140ee99f8bea66$export$996e3ea69314b5c6 = /** @class */ function() {
    function CacheManager(clientId, cryptoImpl, logger) {
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, $d86c8dd6d40ffd16$export$a8ff84c12d48cfa6), (0, $d86c8dd6d40ffd16$export$83d89fbfd8236492));
    }
    /**
     * Returns all accounts in cache
     */ CacheManager.prototype.getAllAccounts = function() {
        var _this = this;
        var allAccountKeys = this.getAccountKeys();
        if (allAccountKeys.length < 1) return [];
        var accountEntities = allAccountKeys.reduce(function(accounts, key) {
            var entity = _this.getAccount(key);
            if (!entity) return accounts;
            accounts.push(entity);
            return accounts;
        }, []);
        if (accountEntities.length < 1) return [];
        else {
            var allAccounts = accountEntities.map(function(accountEntity) {
                return _this.getAccountInfoFromEntity(accountEntity);
            });
            return allAccounts;
        }
    };
    /**
     * Gets accountInfo object based on provided filters
     */ CacheManager.prototype.getAccountInfoFilteredBy = function(accountFilter) {
        var allAccounts = this.getAccountsFilteredBy(accountFilter);
        if (allAccounts.length > 0) return this.getAccountInfoFromEntity(allAccounts[0]);
        else return null;
    };
    CacheManager.prototype.getAccountInfoFromEntity = function(accountEntity) {
        var accountInfo = accountEntity.getAccountInfo();
        var idToken = this.getIdToken(accountInfo);
        if (idToken) {
            accountInfo.idToken = idToken.secret;
            accountInfo.idTokenClaims = new (0, $88f623fdecedc666$export$3a170961dab30083)(idToken.secret, this.cryptoImpl).claims;
        }
        return accountInfo;
    };
    /**
     * saves a cache record
     * @param cacheRecord
     */ CacheManager.prototype.saveCacheRecord = function(cacheRecord) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!cacheRecord) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNullOrUndefinedCacheRecord();
                        if (!!cacheRecord.account) this.setAccount(cacheRecord.account);
                        if (!!cacheRecord.idToken) this.setIdTokenCredential(cacheRecord.idToken);
                        if (!!!cacheRecord.accessToken) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.saveAccessToken(cacheRecord.accessToken)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!!cacheRecord.refreshToken) this.setRefreshTokenCredential(cacheRecord.refreshToken);
                        if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * saves access token credential
     * @param credential
     */ CacheManager.prototype.saveAccessToken = function(credential) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var accessTokenFilter, tokenKeys, currentScopes, removedAccessTokens;
            var _this = this;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        accessTokenFilter = {
                            clientId: credential.clientId,
                            credentialType: credential.credentialType,
                            environment: credential.environment,
                            homeAccountId: credential.homeAccountId,
                            realm: credential.realm,
                            tokenType: credential.tokenType,
                            requestedClaimsHash: credential.requestedClaimsHash
                        };
                        tokenKeys = this.getTokenKeys();
                        currentScopes = (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(credential.target);
                        removedAccessTokens = [];
                        tokenKeys.accessToken.forEach(function(key) {
                            if (!_this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
                            var tokenEntity = _this.getAccessTokenCredential(key);
                            if (tokenEntity && _this.credentialMatchesFilter(tokenEntity, accessTokenFilter)) {
                                var tokenScopeSet = (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(tokenEntity.target);
                                if (tokenScopeSet.intersectingScopeSets(currentScopes)) removedAccessTokens.push(_this.removeAccessToken(key));
                            }
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(removedAccessTokens)
                        ];
                    case 1:
                        _a.sent();
                        this.setAccessTokenCredential(credential);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * retrieve accounts matching all provided filters; if no filter is set, get all accounts
     * not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param homeAccountId
     * @param environment
     * @param realm
     */ CacheManager.prototype.getAccountsFilteredBy = function(accountFilter) {
        var _this = this;
        var allAccountKeys = this.getAccountKeys();
        var matchingAccounts = [];
        allAccountKeys.forEach(function(cacheKey) {
            if (!_this.isAccountKey(cacheKey, accountFilter.homeAccountId, accountFilter.realm)) // Don't parse value if the key doesn't match the account filters
            return;
            var entity = _this.getAccount(cacheKey);
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !_this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.localAccountId && !_this.matchLocalAccountId(entity, accountFilter.localAccountId)) return;
            if (!!accountFilter.username && !_this.matchUsername(entity, accountFilter.username)) return;
            if (!!accountFilter.environment && !_this.matchEnvironment(entity, accountFilter.environment)) return;
            if (!!accountFilter.realm && !_this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.nativeAccountId && !_this.matchNativeAccountId(entity, accountFilter.nativeAccountId)) return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    };
    /**
     * Returns true if the given key matches our account key schema. Also matches homeAccountId and/or tenantId if provided
     * @param key
     * @param homeAccountId
     * @param tenantId
     * @returns
     */ CacheManager.prototype.isAccountKey = function(key, homeAccountId, tenantId) {
        if (key.split((0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 3) // Account cache keys contain 3 items separated by '-' (each item may also contain '-')
        return false;
        if (homeAccountId && !key.toLowerCase().includes(homeAccountId.toLowerCase())) return false;
        if (tenantId && !key.toLowerCase().includes(tenantId.toLowerCase())) return false;
        // Do not check environment as aliasing can cause false negatives
        return true;
    };
    /**
     * Returns true if the given key matches our credential key schema.
     * @param key
     */ CacheManager.prototype.isCredentialKey = function(key) {
        if (key.split((0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 6) // Credential cache keys contain 6 items separated by '-' (each item may also contain '-')
        return false;
        var lowerCaseKey = key.toLowerCase();
        // Credential keys must indicate what credential type they represent
        if (lowerCaseKey.indexOf((0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) === -1) return false;
        if (lowerCaseKey.indexOf((0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) > -1) {
            // Refresh tokens must contain the client id or family id
            var clientIdValidation = "" + (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN + (0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + this.clientId + (0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR;
            var familyIdValidation = "" + (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN + (0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + (0, $1b76d687a319d9ed$export$978fe7ab5e74b539) + (0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR;
            if (lowerCaseKey.indexOf(clientIdValidation.toLowerCase()) === -1 && lowerCaseKey.indexOf(familyIdValidation.toLowerCase()) === -1) return false;
        } else if (lowerCaseKey.indexOf(this.clientId.toLowerCase()) === -1) // Tokens must contain the clientId
        return false;
        return true;
    };
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @returns
     */ CacheManager.prototype.credentialMatchesFilter = function(entity, filter) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target)) return false;
        // If request OR cached entity has requested Claims Hash, check if they match
        if (filter.requestedClaimsHash || entity.requestedClaimsHash) {
            // Don't match if either is undefined or they are different
            if (entity.requestedClaimsHash !== filter.requestedClaimsHash) return false;
        }
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, $1b76d687a319d9ed$export$901491a717da2ba5).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        return true;
    };
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */ CacheManager.prototype.getAppMetadataFilteredBy = function(filter) {
        return this.getAppMetadataFilteredByInternal(filter.environment, filter.clientId);
    };
    /**
     * Support function to help match appMetadata
     * @param environment
     * @param clientId
     */ CacheManager.prototype.getAppMetadataFilteredByInternal = function(environment, clientId) {
        var _this = this;
        var allCacheKeys = this.getKeys();
        var matchingAppMetadata = {};
        allCacheKeys.forEach(function(cacheKey) {
            // don't parse any non-appMetadata type cache entities
            if (!_this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            var entity = _this.getAppMetadata(cacheKey);
            if (!entity) return;
            if (!!environment && !_this.matchEnvironment(entity, environment)) return;
            if (!!clientId && !_this.matchClientId(entity, clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    };
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */ CacheManager.prototype.getAuthorityMetadataByAlias = function(host) {
        var _this = this;
        var allCacheKeys = this.getAuthorityMetadataKeys();
        var matchedEntity = null;
        allCacheKeys.forEach(function(cacheKey) {
            // don't parse any non-authorityMetadata type cache entities
            if (!_this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(_this.clientId) === -1) return;
            // Attempt retrieval
            var entity = _this.getAuthorityMetadata(cacheKey);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    };
    /**
     * Removes all accounts and related tokens from cache.
     */ CacheManager.prototype.removeAllAccounts = function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var allAccountKeys, removedAccounts;
            var _this = this;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        allAccountKeys = this.getAccountKeys();
                        removedAccounts = [];
                        allAccountKeys.forEach(function(cacheKey) {
                            removedAccounts.push(_this.removeAccount(cacheKey));
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(removedAccounts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ CacheManager.prototype.removeAccount = function(accountKey) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var account;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        account = this.getAccount(accountKey);
                        if (!account) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNoAccountFoundError();
                        return [
                            4 /*yield*/ ,
                            this.removeAccountContext(account)
                        ];
                    case 1:
                        _a.sent();
                        this.removeItem(accountKey);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ CacheManager.prototype.removeAccountContext = function(account) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var allTokenKeys, accountId, removedCredentials;
            var _this = this;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        allTokenKeys = this.getTokenKeys();
                        accountId = account.generateAccountId();
                        removedCredentials = [];
                        allTokenKeys.idToken.forEach(function(key) {
                            if (key.indexOf(accountId) === 0) _this.removeIdToken(key);
                        });
                        allTokenKeys.accessToken.forEach(function(key) {
                            if (key.indexOf(accountId) === 0) removedCredentials.push(_this.removeAccessToken(key));
                        });
                        allTokenKeys.refreshToken.forEach(function(key) {
                            if (key.indexOf(accountId) === 0) _this.removeRefreshToken(key);
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(removedCredentials)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * returns a boolean if the given credential is removed
     * @param credential
     */ CacheManager.prototype.removeAccessToken = function(key) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var credential, accessTokenWithAuthSchemeEntity, kid;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        credential = this.getAccessTokenCredential(key);
                        if (!credential) return [
                            2 /*return*/ 
                        ];
                        if (!(credential.credentialType.toLowerCase() === (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase())) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!(credential.tokenType === (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            4
                        ];
                        accessTokenWithAuthSchemeEntity = credential;
                        kid = accessTokenWithAuthSchemeEntity.keyId;
                        if (!kid) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.cryptoImpl.removeTokenBindingKey(kid)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        _a.sent();
                        throw (0, $30cd164be78785f3$export$a839ff85a7957561).createBindingKeyNotRemovedError();
                    case 4:
                        return [
                            2 /*return*/ ,
                            this.removeItem(key)
                        ];
                }
            });
        });
    };
    /**
     * Removes all app metadata objects from cache.
     */ CacheManager.prototype.removeAppMetadata = function() {
        var _this = this;
        var allCacheKeys = this.getKeys();
        allCacheKeys.forEach(function(cacheKey) {
            if (_this.isAppMetadata(cacheKey)) _this.removeItem(cacheKey);
        });
        return true;
    };
    /**
     * Retrieve the cached credentials into a cacherecord
     * @param account
     * @param clientId
     * @param scopes
     * @param environment
     * @param authScheme
     */ CacheManager.prototype.readCacheRecord = function(account, request, environment) {
        var tokenKeys = this.getTokenKeys();
        var cachedAccount = this.readAccountFromCache(account);
        var cachedIdToken = this.getIdToken(account, tokenKeys);
        var cachedAccessToken = this.getAccessToken(account, request, tokenKeys);
        var cachedRefreshToken = this.getRefreshToken(account, false, tokenKeys);
        var cachedAppMetadata = this.readAppMetadataFromCache(environment);
        if (cachedAccount && cachedIdToken) cachedAccount.idTokenClaims = new (0, $88f623fdecedc666$export$3a170961dab30083)(cachedIdToken.secret, this.cryptoImpl).claims;
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    };
    /**
     * Retrieve AccountEntity from cache
     * @param account
     */ CacheManager.prototype.readAccountFromCache = function(account) {
        var accountKey = (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).generateAccountCacheKey(account);
        return this.getAccount(accountKey);
    };
    /**
     * Retrieve IdTokenEntity from cache
     * @param clientId
     * @param account
     * @param inputRealm
     */ CacheManager.prototype.getIdToken = function(account, tokenKeys) {
        this.commonLogger.trace("CacheManager - getIdToken called");
        var idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN,
            clientId: this.clientId,
            realm: account.tenantId
        };
        var idTokens = this.getIdTokensByFilter(idTokenFilter, tokenKeys);
        var numIdTokens = idTokens.length;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found");
            return null;
        } else if (numIdTokens > 1) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createMultipleMatchingTokensInCacheError();
        this.commonLogger.info("CacheManager:getIdToken - Returning id token");
        return idTokens[0];
    };
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ CacheManager.prototype.getIdTokensByFilter = function(filter, tokenKeys) {
        var _this = this;
        var idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        var idTokens = [];
        idTokenKeys.forEach(function(key) {
            if (!_this.idTokenKeyMatchesFilter(key, (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({
                clientId: _this.clientId
            }, filter))) return;
            var idToken = _this.getIdTokenCredential(key);
            if (idToken && _this.credentialMatchesFilter(idToken, filter)) idTokens.push(idToken);
        });
        return idTokens;
    };
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ CacheManager.prototype.idTokenKeyMatchesFilter = function(inputKey, filter) {
        var key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    };
    /**
     * Removes idToken from the cache
     * @param key
     */ CacheManager.prototype.removeIdToken = function(key) {
        this.removeItem(key);
    };
    /**
     * Removes refresh token from the cache
     * @param key
     */ CacheManager.prototype.removeRefreshToken = function(key) {
        this.removeItem(key);
    };
    /**
     * Retrieve AccessTokenEntity from cache
     * @param clientId
     * @param account
     * @param scopes
     * @param authScheme
     */ CacheManager.prototype.getAccessToken = function(account, request, tokenKeys) {
        var _this = this;
        this.commonLogger.trace("CacheManager - getAccessToken called");
        var scopes = (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).createSearchScopes(request.scopes);
        var authScheme = request.authenticationScheme || (0, $1b76d687a319d9ed$export$901491a717da2ba5).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ var credentialType = authScheme && authScheme.toLowerCase() !== (0, $1b76d687a319d9ed$export$901491a717da2ba5).BEARER.toLowerCase() ? (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        var accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash
        };
        var accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        var accessTokens = [];
        accessTokenKeys.forEach(function(key) {
            // Validate key
            if (_this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                var accessToken = _this.getAccessTokenCredential(key);
                // Validate value
                if (accessToken && _this.credentialMatchesFilter(accessToken, accessTokenFilter)) accessTokens.push(accessToken);
            }
        });
        var numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found");
            return null;
        } else if (numAccessTokens > 1) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createMultipleMatchingTokensInCacheError();
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token");
        return accessTokens[0];
    };
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ CacheManager.prototype.accessTokenKeyMatchesFilter = function(inputKey, filter, keyMustContainAllScopes) {
        var key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.requestedClaimsHash && key.indexOf(filter.requestedClaimsHash.toLowerCase()) === -1) return false;
        if (filter.target) {
            var scopes = filter.target.asArray();
            for(var i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    };
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ CacheManager.prototype.getAccessTokensByFilter = function(filter) {
        var _this = this;
        var tokenKeys = this.getTokenKeys();
        var accessTokens = [];
        tokenKeys.accessToken.forEach(function(key) {
            if (!_this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            var accessToken = _this.getAccessTokenCredential(key);
            if (accessToken && _this.credentialMatchesFilter(accessToken, filter)) accessTokens.push(accessToken);
        });
        return accessTokens;
    };
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param clientId
     * @param account
     * @param familyRT
     */ CacheManager.prototype.getRefreshToken = function(account, familyRT, tokenKeys) {
        var _this = this;
        this.commonLogger.trace("CacheManager - getRefreshToken called");
        var id = familyRT ? (0, $1b76d687a319d9ed$export$978fe7ab5e74b539) : undefined;
        var refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        var refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        var refreshTokens = [];
        refreshTokenKeys.forEach(function(key) {
            // Validate key
            if (_this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                var refreshToken = _this.getRefreshTokenCredential(key);
                // Validate value
                if (refreshToken && _this.credentialMatchesFilter(refreshToken, refreshTokenFilter)) refreshTokens.push(refreshToken);
            }
        });
        var numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.");
            return null;
        }
        // address the else case after remove functions address environment aliases
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token");
        return refreshTokens[0];
    };
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ CacheManager.prototype.refreshTokenKeyMatchesFilter = function(inputKey, filter) {
        var key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    };
    /**
     * Retrieve AppMetadataEntity from cache
     */ CacheManager.prototype.readAppMetadataFromCache = function(environment) {
        var appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        var appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        var appMetadataEntries = Object.keys(appMetadata).map(function(key) {
            return appMetadata[key];
        });
        var numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createMultipleMatchingAppMetadataInCacheError();
        return appMetadataEntries[0];
    };
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ CacheManager.prototype.isAppMetadataFOCI = function(environment) {
        var appMetadata = this.readAppMetadataFromCache(environment);
        return !!(appMetadata && appMetadata.familyId === (0, $1b76d687a319d9ed$export$978fe7ab5e74b539));
    };
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ CacheManager.prototype.matchHomeAccountId = function(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    };
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ CacheManager.prototype.matchLocalAccountId = function(entity, localAccountId) {
        return !!(typeof entity.localAccountId === "string" && localAccountId === entity.localAccountId);
    };
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ CacheManager.prototype.matchUsername = function(entity, username) {
        return !!(typeof entity.username === "string" && username.toLowerCase() === entity.username.toLowerCase());
    };
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ CacheManager.prototype.matchUserAssertionHash = function(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    };
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ CacheManager.prototype.matchEnvironment = function(entity, environment) {
        var cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    };
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ CacheManager.prototype.matchCredentialType = function(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    };
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ CacheManager.prototype.matchClientId = function(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    };
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ CacheManager.prototype.matchFamilyId = function(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    };
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ CacheManager.prototype.matchRealm = function(entity, realm) {
        return !!(entity.realm && realm === entity.realm);
    };
    /**
     * helper to match nativeAccountId
     * @param entity
     * @param nativeAccountId
     * @returns boolean indicating the match result
     */ CacheManager.prototype.matchNativeAccountId = function(entity, nativeAccountId) {
        return !!(entity.nativeAccountId && nativeAccountId === entity.nativeAccountId);
    };
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ CacheManager.prototype.matchTarget = function(entity, target) {
        var isNotAccessTokenCredential = entity.credentialType !== (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN && entity.credentialType !== (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        var entityScopeSet = (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(entity.target);
        return entityScopeSet.containsScopeSet(target);
    };
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ CacheManager.prototype.matchTokenType = function(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    };
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ CacheManager.prototype.matchKeyId = function(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    };
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ CacheManager.prototype.isAppMetadata = function(key) {
        return key.indexOf((0, $1b76d687a319d9ed$export$7e1bea6dc1b6b32e)) !== -1;
    };
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ CacheManager.prototype.isAuthorityMetadata = function(key) {
        return key.indexOf((0, $1b76d687a319d9ed$export$d483f966e66f4db5).CACHE_KEY) !== -1;
    };
    /**
     * returns cache key used for cloud instance metadata
     */ CacheManager.prototype.generateAuthorityMetadataCacheKey = function(authority) {
        return (0, $1b76d687a319d9ed$export$d483f966e66f4db5).CACHE_KEY + "-" + this.clientId + "-" + authority;
    };
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ CacheManager.toObject = function(obj, json) {
        for(var propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    };
    return CacheManager;
}();
var $6d140ee99f8bea66$export$b7254d304b3004b6 = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(DefaultStorageClass, _super);
    function DefaultStorageClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultStorageClass.prototype.setAccount = function() {
        var notImplErr = "Storage interface - setAccount() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccount = function() {
        var notImplErr = "Storage interface - getAccount() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setIdTokenCredential = function() {
        var notImplErr = "Storage interface - setIdTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getIdTokenCredential = function() {
        var notImplErr = "Storage interface - getIdTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAccessTokenCredential = function() {
        var notImplErr = "Storage interface - setAccessTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccessTokenCredential = function() {
        var notImplErr = "Storage interface - getAccessTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setRefreshTokenCredential = function() {
        var notImplErr = "Storage interface - setRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getRefreshTokenCredential = function() {
        var notImplErr = "Storage interface - getRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAppMetadata = function() {
        var notImplErr = "Storage interface - setAppMetadata() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAppMetadata = function() {
        var notImplErr = "Storage interface - getAppMetadata() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setServerTelemetry = function() {
        var notImplErr = "Storage interface - setServerTelemetry() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getServerTelemetry = function() {
        var notImplErr = "Storage interface - getServerTelemetry() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setAuthorityMetadata = function() {
        var notImplErr = "Storage interface - setAuthorityMetadata() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAuthorityMetadata = function() {
        var notImplErr = "Storage interface - getAuthorityMetadata() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAuthorityMetadataKeys = function() {
        var notImplErr = "Storage interface - getAuthorityMetadataKeys() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.setThrottlingCache = function() {
        var notImplErr = "Storage interface - setThrottlingCache() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getThrottlingCache = function() {
        var notImplErr = "Storage interface - getThrottlingCache() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.removeItem = function() {
        var notImplErr = "Storage interface - removeItem() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.containsKey = function() {
        var notImplErr = "Storage interface - containsKey() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getKeys = function() {
        var notImplErr = "Storage interface - getKeys() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getAccountKeys = function() {
        var notImplErr = "Storage interface - getAccountKeys() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.getTokenKeys = function() {
        var notImplErr = "Storage interface - getTokenKeys() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    DefaultStorageClass.prototype.clear = function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Storage interface - clear() has not been implemented for the cacheStorage interface.";
                throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    };
    DefaultStorageClass.prototype.updateCredentialCacheKey = function() {
        var notImplErr = "Storage interface - updateCredentialCacheKey() has not been implemented for the cacheStorage interface.";
        throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
    };
    return DefaultStorageClass;
}($6d140ee99f8bea66$export$996e3ea69314b5c6);

/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $8ac3ff1b00f89083$export$17b7b3ac1abef49f;
(function(CcsCredentialType) {
    CcsCredentialType["HOME_ACCOUNT_ID"] = "home_account_id";
    CcsCredentialType["UPN"] = "UPN";
})($8ac3ff1b00f89083$export$17b7b3ac1abef49f || ($8ac3ff1b00f89083$export$17b7b3ac1abef49f = {}));

/*! @azure/msal-common v13.1.0 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ID_TOKEN Cache
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-idtoken-clientId-contoso.com-
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      realm: Full tenant or organizational identifier that the account belongs to
 * }
 */ var $0c09c5966c1cc91f$export$49ed297fa7d02bde = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(IdTokenEntity, _super);
    function IdTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create IdTokenEntity
     * @param homeAccountId
     * @param authenticationResult
     * @param clientId
     * @param authority
     */ IdTokenEntity.createIdTokenEntity = function(homeAccountId, environment, idToken, clientId, tenantId) {
        var idTokenEntity = new IdTokenEntity();
        idTokenEntity.credentialType = (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN;
        idTokenEntity.homeAccountId = homeAccountId;
        idTokenEntity.environment = environment;
        idTokenEntity.clientId = clientId;
        idTokenEntity.secret = idToken;
        idTokenEntity.realm = tenantId;
        return idTokenEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ IdTokenEntity.isIdTokenEntity = function(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret") && entity["credentialType"] === (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN;
    };
    return IdTokenEntity;
}((0, $00f293d2e5477c13$export$39bc12230e4d3f33));

/*! @azure/msal-common v13.1.0 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */ var $43862c84d67ae4c1$export$871e33217042c65e = /** @class */ function() {
    function ProtocolUtils() {}
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */ ProtocolUtils.setRequestState = function(cryptoObj, userState, meta) {
        var libraryState = ProtocolUtils.generateLibraryState(cryptoObj, meta);
        return !(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(userState) ? "" + libraryState + (0, $1b76d687a319d9ed$export$a002182e51710d39).RESOURCE_DELIM + userState : libraryState;
    };
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */ ProtocolUtils.generateLibraryState = function(cryptoObj, meta) {
        if (!cryptoObj) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNoCryptoObjectError("generateLibraryState");
        // Create a state object containing a unique id and the timestamp of the request creation
        var stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) stateObj.meta = meta;
        var stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    };
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */ ProtocolUtils.parseRequestState = function(cryptoObj, state) {
        if (!cryptoObj) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNoCryptoObjectError("parseRequestState");
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(state)) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createInvalidStateError(state, "Null, undefined or empty state");
        try {
            // Split the state between library state and user passed state and decode them separately
            var splitState = state.split((0, $1b76d687a319d9ed$export$a002182e51710d39).RESOURCE_DELIM);
            var libraryState = splitState[0];
            var userState = splitState.length > 1 ? splitState.slice(1).join((0, $1b76d687a319d9ed$export$a002182e51710d39).RESOURCE_DELIM) : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            var libraryStateString = cryptoObj.base64Decode(libraryState);
            var libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: !(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(userState) ? userState : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                libraryState: libraryStateObj
            };
        } catch (e) {
            throw (0, $30cd164be78785f3$export$a839ff85a7957561).createInvalidStateError(state, e);
        }
    };
    return ProtocolUtils;
}();

/*! @azure/msal-common v13.1.0 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * REFRESH_TOKEN Cache
 *
 * Key:Value Schema:
 *
 * Key Example: uid.utid-login.microsoftonline.com-refreshtoken-clientId--
 *
 * Value:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
 *      clientId: client ID of the application
 *      secret: Actual credential as a string
 *      familyId: Family ID identifier, '1' represents Microsoft Family
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
 * }
 */ var $16a85bb95b6824db$export$2f7722c9adbc0a1b = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(RefreshTokenEntity, _super);
    function RefreshTokenEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create RefreshTokenEntity
     * @param homeAccountId
     * @param authenticationResult
     * @param clientId
     * @param authority
     */ RefreshTokenEntity.createRefreshTokenEntity = function(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash) {
        var rtEntity = new RefreshTokenEntity();
        rtEntity.clientId = clientId;
        rtEntity.credentialType = (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN;
        rtEntity.environment = environment;
        rtEntity.homeAccountId = homeAccountId;
        rtEntity.secret = refreshToken;
        rtEntity.userAssertionHash = userAssertionHash;
        if (familyId) rtEntity.familyId = familyId;
        return rtEntity;
    };
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ RefreshTokenEntity.isRefreshTokenEntity = function(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret") && entity["credentialType"] === (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN;
    };
    return RefreshTokenEntity;
}((0, $00f293d2e5477c13$export$39bc12230e4d3f33));

/*! @azure/msal-common v13.1.0 2023-06-07 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $9b88af41c7151908$export$ff670b37c5e10296 = /** @class */ function() {
    function ServerTelemetryEntity() {
        this.failedRequests = [];
        this.errors = [];
        this.cacheHits = 0;
    }
    /**
     * validates if a given cache entry is "Telemetry", parses <key,value>
     * @param key
     * @param entity
     */ ServerTelemetryEntity.isServerTelemetryEntity = function(key, entity) {
        var validateKey = key.indexOf((0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).CACHE_KEY) === 0;
        var validateEntity = true;
        if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
        return validateKey && validateEntity;
    };
    return ServerTelemetryEntity;
}();

/*! @azure/msal-common v13.1.0 2023-06-07 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $d355d47fec590bb4$export$15b974958510ada9 = /** @class */ function() {
    function ThrottlingEntity() {}
    /**
     * validates if a given cache entry is "Throttling", parses <key,value>
     * @param key
     * @param entity
     */ ThrottlingEntity.isThrottlingEntity = function(key, entity) {
        var validateKey = false;
        if (key) validateKey = key.indexOf((0, $1b76d687a319d9ed$export$a2330d6808e6d893).THROTTLING_PREFIX) === 0;
        var validateEntity = true;
        if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
        return validateKey && validateEntity;
    };
    return ThrottlingEntity;
}();




/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $28c2b9976bb437b2$export$2baa60fa09b100be = /** @class */ function() {
    function BrowserStorage(cacheLocation) {
        this.validateWindowStorage(cacheLocation);
        this.windowStorage = window[cacheLocation];
    }
    BrowserStorage.prototype.validateWindowStorage = function(cacheLocation) {
        if (cacheLocation !== (0, $7b3089fdde5d004f$export$573384e47a12d835).LocalStorage && cacheLocation !== (0, $7b3089fdde5d004f$export$573384e47a12d835).SessionStorage) throw (0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStorageNotSupportedError(cacheLocation);
        var storageSupported = !!window[cacheLocation];
        if (!storageSupported) throw (0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createStorageNotSupportedError(cacheLocation);
    };
    BrowserStorage.prototype.getItem = function(key) {
        return this.windowStorage.getItem(key);
    };
    BrowserStorage.prototype.setItem = function(key, value) {
        this.windowStorage.setItem(key, value);
    };
    BrowserStorage.prototype.removeItem = function(key) {
        this.windowStorage.removeItem(key);
    };
    BrowserStorage.prototype.getKeys = function() {
        return Object.keys(this.windowStorage);
    };
    BrowserStorage.prototype.containsKey = function(key) {
        return this.windowStorage.hasOwnProperty(key);
    };
    return BrowserStorage;
}();



/*! @azure/msal-browser v2.37.1 2023-06-07 */ /*! @azure/msal-common v13.1.0 2023-06-07 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ var $7e4e9c310bf6f49d$export$3abcdca7229e54f2 = /** @class */ function() {
    function UrlString(url) {
        this._urlString = url;
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(this._urlString)) // Throws error if url is empty
        throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createUrlEmptyError();
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(this.getHash())) this._urlString = UrlString.canonicalizeUri(url);
    }
    Object.defineProperty(UrlString.prototype, "urlString", {
        get: function() {
            return this._urlString;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ UrlString.canonicalizeUri = function(url) {
        if (url) {
            var lowerCaseUrl = url.toLowerCase();
            if ((0, $1842614da3ac031b$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $1842614da3ac031b$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $1842614da3ac031b$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    };
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ UrlString.prototype.validateAsUri = function() {
        // Attempts to parse url for uri components
        var components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createUrlParseError(e);
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createUrlParseError("Given url string: " + this.urlString);
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createInsecureAuthorityUriError(this.urlString);
    };
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ UrlString.appendQueryString = function(url, queryString) {
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(queryString)) return url;
        return url.indexOf("?") < 0 ? url + "?" + queryString : url + "&" + queryString;
    };
    /**
     * Returns a url with the hash removed
     * @param url
     */ UrlString.removeHashFromUrl = function(url) {
        return UrlString.canonicalizeUri(url.split("#")[0]);
    };
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ UrlString.prototype.replaceTenantPath = function(tenantId) {
        var urlObject = this.getUrlComponents();
        var pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $1b76d687a319d9ed$export$e18ac120172ed505).COMMON || pathArray[0] === (0, $1b76d687a319d9ed$export$e18ac120172ed505).ORGANIZATIONS)) pathArray[0] = tenantId;
        return UrlString.constructAuthorityUriFromObject(urlObject);
    };
    /**
     * Returns the anchor part(#) of the URL
     */ UrlString.prototype.getHash = function() {
        return UrlString.parseHash(this.urlString);
    };
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ UrlString.prototype.getUrlComponents = function() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        var regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        var match = this.urlString.match(regEx);
        if (!match) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createUrlParseError("Given url string: " + this.urlString);
        // Url component object
        var urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        var pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter(function(val) {
            return val && val.length > 0;
        }); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(urlComponents.QueryString) && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    };
    UrlString.getDomainFromUrl = function(url) {
        var regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        var match = url.match(regEx);
        if (!match) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createUrlParseError("Given url string: " + url);
        return match[2];
    };
    UrlString.getAbsoluteUrl = function(relativeUrl, baseUrl) {
        if (relativeUrl[0] === (0, $1b76d687a319d9ed$export$a002182e51710d39).FORWARD_SLASH) {
            var url = new UrlString(baseUrl);
            var baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    };
    /**
     * Parses hash string from given string. Returns empty string if no hash symbol is found.
     * @param hashString
     */ UrlString.parseHash = function(hashString) {
        var hashIndex1 = hashString.indexOf("#");
        var hashIndex2 = hashString.indexOf("#/");
        if (hashIndex2 > -1) return hashString.substring(hashIndex2 + 2);
        else if (hashIndex1 > -1) return hashString.substring(hashIndex1 + 1);
        return (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
    };
    /**
     * Parses query string from given string. Returns empty string if no query symbol is found.
     * @param queryString
     */ UrlString.parseQueryString = function(queryString) {
        var queryIndex1 = queryString.indexOf("?");
        var queryIndex2 = queryString.indexOf("/?");
        if (queryIndex2 > -1) return queryString.substring(queryIndex2 + 2);
        else if (queryIndex1 > -1) return queryString.substring(queryIndex1 + 1);
        return (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
    };
    UrlString.constructAuthorityUriFromObject = function(urlObject) {
        return new UrlString(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    };
    /**
     * Returns URL hash as server auth code response object.
     */ UrlString.getDeserializedHash = function(hash) {
        // Check if given hash is empty
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(hash)) return {};
        // Strip the # symbol if present
        var parsedHash = UrlString.parseHash(hash);
        // If # symbol was not present, above will return empty string, so give original hash value
        var deserializedHash = (0, $1842614da3ac031b$export$ecc754f99843e759).queryStringToObject((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(parsedHash) ? hash : parsedHash);
        // Check if deserialization didn't work
        if (!deserializedHash) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createHashNotDeserializedError(JSON.stringify(deserializedHash));
        return deserializedHash;
    };
    /**
     * Returns URL query string as server auth code response object.
     */ UrlString.getDeserializedQueryString = function(query) {
        // Check if given query is empty
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(query)) return {};
        // Strip the ? symbol if present
        var parsedQueryString = UrlString.parseQueryString(query);
        // If ? symbol was not present, above will return empty string, so give original query value
        var deserializedQueryString = (0, $1842614da3ac031b$export$ecc754f99843e759).queryStringToObject((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(parsedQueryString) ? query : parsedQueryString);
        // Check if deserialization didn't work
        if (!deserializedQueryString) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createHashNotDeserializedError(JSON.stringify(deserializedQueryString));
        return deserializedQueryString;
    };
    /**
     * Check if the hash of the URL string contains known properties
     */ UrlString.hashContainsKnownProperties = function(hash) {
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(hash) || hash.indexOf("=") < 0) // Hash doesn't contain key/value pairs
        return false;
        var parameters = UrlString.getDeserializedHash(hash);
        return !!(parameters.code || parameters.error_description || parameters.error || parameters.state);
    };
    return UrlString;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $60804433685cab28$export$83c579d74a9d4ed7 = /** @class */ function() {
    function BrowserProtocolUtils() {}
    /**
     * Extracts the BrowserStateObject from the state string.
     * @param browserCrypto
     * @param state
     */ BrowserProtocolUtils.extractBrowserRequestState = function(browserCrypto, state) {
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(state)) return null;
        try {
            var requestStateObj = (0, $43862c84d67ae4c1$export$871e33217042c65e).parseRequestState(browserCrypto, state);
            return requestStateObj.libraryState.meta;
        } catch (e) {
            throw (0, $30cd164be78785f3$export$a839ff85a7957561).createInvalidStateError(state, e);
        }
    };
    /**
     * Parses properties of server response from url hash
     * @param locationHash Hash from url
     */ BrowserProtocolUtils.parseServerResponseFromHash = function(locationHash) {
        if (!locationHash) return {};
        var hashUrlString = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(locationHash);
        return (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getDeserializedHash(hashUrlString.getHash());
    };
    return BrowserProtocolUtils;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */ var $6a4e3e48f11f536f$export$44d7291b5c8cc149 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(BrowserCacheManager, _super);
    function BrowserCacheManager(clientId, cacheConfig, cryptoImpl, logger) {
        var _this = _super.call(this, clientId, cryptoImpl, logger) || this;
        // Cookie life calculation (hours * minutes * seconds * ms)
        _this.COOKIE_LIFE_MULTIPLIER = 86400000;
        _this.cacheConfig = cacheConfig;
        _this.logger = logger;
        _this.internalStorage = new (0, $2b3883238de6b5a2$export$d7392285c701ecf5)();
        _this.browserStorage = _this.setupBrowserStorage(_this.cacheConfig.cacheLocation);
        _this.temporaryCacheStorage = _this.setupTemporaryCacheStorage(_this.cacheConfig.temporaryCacheLocation, _this.cacheConfig.cacheLocation);
        // Migrate cache entries from older versions of MSAL.
        if (cacheConfig.cacheMigrationEnabled) {
            _this.migrateCacheEntries();
            _this.createKeyMaps();
        }
        return _this;
    }
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
     * @param cacheLocation
     */ BrowserCacheManager.prototype.setupBrowserStorage = function(cacheLocation) {
        switch(cacheLocation){
            case (0, $7b3089fdde5d004f$export$573384e47a12d835).LocalStorage:
            case (0, $7b3089fdde5d004f$export$573384e47a12d835).SessionStorage:
                try {
                    return new (0, $28c2b9976bb437b2$export$2baa60fa09b100be)(cacheLocation);
                } catch (e) {
                    this.logger.verbose(e);
                    break;
                }
        }
        this.cacheConfig.cacheLocation = (0, $7b3089fdde5d004f$export$573384e47a12d835).MemoryStorage;
        return new (0, $2b3883238de6b5a2$export$d7392285c701ecf5)();
    };
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured temporaryCacheLocation.
     * @param temporaryCacheLocation
     * @param cacheLocation
     */ BrowserCacheManager.prototype.setupTemporaryCacheStorage = function(temporaryCacheLocation, cacheLocation) {
        switch(cacheLocation){
            case (0, $7b3089fdde5d004f$export$573384e47a12d835).LocalStorage:
            case (0, $7b3089fdde5d004f$export$573384e47a12d835).SessionStorage:
                try {
                    /*
                     * When users do not explicitly choose their own temporaryCacheLocation,
                     * temporary cache items will always be stored in session storage to mitigate problems caused by multiple tabs
                     */ return new (0, $28c2b9976bb437b2$export$2baa60fa09b100be)(temporaryCacheLocation || (0, $7b3089fdde5d004f$export$573384e47a12d835).SessionStorage);
                } catch (e) {
                    this.logger.verbose(e);
                    return this.internalStorage;
                }
            case (0, $7b3089fdde5d004f$export$573384e47a12d835).MemoryStorage:
            default:
                return this.internalStorage;
        }
    };
    /**
     * Migrate all old cache entries to new schema. No rollback supported.
     * @param storeAuthStateInCookie
     */ BrowserCacheManager.prototype.migrateCacheEntries = function() {
        var _this = this;
        var idTokenKey = (0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ID_TOKEN;
        var clientInfoKey = (0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).CLIENT_INFO;
        var errorKey = (0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ERROR;
        var errorDescKey = (0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ERROR_DESC;
        var idTokenValue = this.browserStorage.getItem(idTokenKey);
        var clientInfoValue = this.browserStorage.getItem(clientInfoKey);
        var errorValue = this.browserStorage.getItem(errorKey);
        var errorDescValue = this.browserStorage.getItem(errorDescKey);
        var values = [
            idTokenValue,
            clientInfoValue,
            errorValue,
            errorDescValue
        ];
        var keysToMigrate = [
            (0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ID_TOKEN,
            (0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).CLIENT_INFO,
            (0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ERROR,
            (0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ERROR_DESC
        ];
        keysToMigrate.forEach(function(cacheKey, index) {
            return _this.migrateCacheEntry(cacheKey, values[index]);
        });
    };
    /**
     * Utility function to help with migration.
     * @param newKey
     * @param value
     * @param storeAuthStateInCookie
     */ BrowserCacheManager.prototype.migrateCacheEntry = function(newKey, value) {
        if (value) this.setTemporaryCache(newKey, value, true);
    };
    /**
     * Searches all cache entries for MSAL accounts and creates the account key map
     * This is used to migrate users from older versions of MSAL which did not create the map.
     * @returns
     */ BrowserCacheManager.prototype.createKeyMaps = function() {
        var _this = this;
        this.logger.trace("BrowserCacheManager - createKeyMaps called.");
        var accountKeys = this.getItem((0, $7b3089fdde5d004f$export$f6ce23cce692699f).ACCOUNT_KEYS);
        var tokenKeys = this.getItem((0, $7b3089fdde5d004f$export$f6ce23cce692699f).TOKEN_KEYS + "." + this.clientId);
        if (accountKeys && tokenKeys) {
            this.logger.verbose("BrowserCacheManager:createKeyMaps - account and token key maps already exist, skipping migration.");
            // Key maps already exist, no need to iterate through cache
            return;
        }
        var allKeys = this.browserStorage.getKeys();
        allKeys.forEach(function(key) {
            if (_this.isCredentialKey(key)) {
                // Get item, parse, validate and write key to map
                var value = _this.getItem(key);
                if (value) {
                    var credObj = _this.validateAndParseJson(value);
                    if (credObj && credObj.hasOwnProperty("credentialType")) switch(credObj["credentialType"]){
                        case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN:
                            if ((0, $0c09c5966c1cc91f$export$49ed297fa7d02bde).isIdTokenEntity(credObj)) {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - idToken found, saving key to token key map");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - idToken with key: " + key + " found, saving key to token key map");
                                var idTokenEntity = (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $0c09c5966c1cc91f$export$49ed297fa7d02bde)(), credObj);
                                var newKey = _this.updateCredentialCacheKey(key, idTokenEntity);
                                _this.addTokenKey(newKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN);
                                return;
                            } else {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching idToken schema with value containing idToken credentialType field but value failed IdTokenEntity validation, skipping.");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - failed idToken validation on key: " + key);
                            }
                            break;
                        case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                        case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME:
                            if ((0, $698539a43f4f793b$export$6b7a8e14ec177765).isAccessTokenEntity(credObj)) {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - accessToken found, saving key to token key map");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - accessToken with key: " + key + " found, saving key to token key map");
                                var accessTokenEntity = (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $698539a43f4f793b$export$6b7a8e14ec177765)(), credObj);
                                var newKey = _this.updateCredentialCacheKey(key, accessTokenEntity);
                                _this.addTokenKey(newKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN);
                                return;
                            } else {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching accessToken schema with value containing accessToken credentialType field but value failed AccessTokenEntity validation, skipping.");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - failed accessToken validation on key: " + key);
                            }
                            break;
                        case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                            if ((0, $16a85bb95b6824db$export$2f7722c9adbc0a1b).isRefreshTokenEntity(credObj)) {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - refreshToken found, saving key to token key map");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - refreshToken with key: " + key + " found, saving key to token key map");
                                var refreshTokenEntity = (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $16a85bb95b6824db$export$2f7722c9adbc0a1b)(), credObj);
                                var newKey = _this.updateCredentialCacheKey(key, refreshTokenEntity);
                                _this.addTokenKey(newKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN);
                                return;
                            } else {
                                _this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching refreshToken schema with value containing refreshToken credentialType field but value failed RefreshTokenEntity validation, skipping.");
                                _this.logger.tracePii("BrowserCacheManager:createKeyMaps - failed refreshToken validation on key: " + key);
                            }
                            break;
                    }
                }
            }
            if (_this.isAccountKey(key)) {
                var value = _this.getItem(key);
                if (value) {
                    var accountObj = _this.validateAndParseJson(value);
                    if (accountObj && (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).isAccountEntity(accountObj)) {
                        _this.logger.trace("BrowserCacheManager:createKeyMaps - account found, saving key to account key map");
                        _this.logger.tracePii("BrowserCacheManager:createKeyMaps - account with key: " + key + " found, saving key to account key map");
                        _this.addAccountKeyToMap(key);
                    }
                }
            }
        });
    };
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ BrowserCacheManager.prototype.validateAndParseJson = function(jsonValue) {
        try {
            var parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    };
    /**
     * fetches the entry from the browser storage based off the key
     * @param key
     */ BrowserCacheManager.prototype.getItem = function(key) {
        return this.browserStorage.getItem(key);
    };
    /**
     * sets the entry in the browser storage
     * @param key
     * @param value
     */ BrowserCacheManager.prototype.setItem = function(key, value) {
        this.browserStorage.setItem(key, value);
    };
    /**
     * fetch the account entity from the platform cache
     * @param accountKey
     */ BrowserCacheManager.prototype.getAccount = function(accountKey) {
        this.logger.trace("BrowserCacheManager.getAccount called");
        var account = this.getItem(accountKey);
        if (!account) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        var parsedAccount = this.validateAndParseJson(account);
        if (!parsedAccount || !(0, $5d6dde05c7528aa5$export$680160523e6bfa6a).isAccountEntity(parsedAccount)) {
            this.removeAccountKeyFromMap(accountKey);
            return null;
        }
        return (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $5d6dde05c7528aa5$export$680160523e6bfa6a)(), parsedAccount);
    };
    /**
     * set account entity in the platform cache
     * @param key
     * @param value
     */ BrowserCacheManager.prototype.setAccount = function(account) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        var key = account.generateAccountKey();
        this.setItem(key, JSON.stringify(account));
        this.addAccountKeyToMap(key);
    };
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ BrowserCacheManager.prototype.getAccountKeys = function() {
        this.logger.trace("BrowserCacheManager.getAccountKeys called");
        var accountKeys = this.getItem((0, $7b3089fdde5d004f$export$f6ce23cce692699f).ACCOUNT_KEYS);
        if (accountKeys) return JSON.parse(accountKeys);
        this.logger.verbose("BrowserCacheManager.getAccountKeys - No account keys found");
        return [];
    };
    /**
     * Add a new account to the key map
     * @param key
     */ BrowserCacheManager.prototype.addAccountKeyToMap = function(key) {
        this.logger.trace("BrowserCacheManager.addAccountKeyToMap called");
        this.logger.tracePii("BrowserCacheManager.addAccountKeyToMap called with key: " + key);
        var accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem((0, $7b3089fdde5d004f$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key added");
        } else this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key already exists in map");
    };
    /**
     * Remove an account from the key map
     * @param key
     */ BrowserCacheManager.prototype.removeAccountKeyFromMap = function(key) {
        this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap called");
        this.logger.tracePii("BrowserCacheManager.removeAccountKeyFromMap called with key: " + key);
        var accountKeys = this.getAccountKeys();
        var removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setItem((0, $7b3089fdde5d004f$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys));
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap account key removed");
        } else this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap key not found in existing map");
    };
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ BrowserCacheManager.prototype.removeAccount = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                _super.prototype.removeAccount.call(this, key);
                this.removeAccountKeyFromMap(key);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ BrowserCacheManager.prototype.removeIdToken = function(key) {
        _super.prototype.removeIdToken.call(this, key);
        this.removeTokenKey(key, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN);
    };
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ BrowserCacheManager.prototype.removeAccessToken = function(key) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                _super.prototype.removeAccessToken.call(this, key);
                this.removeTokenKey(key, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ BrowserCacheManager.prototype.removeRefreshToken = function(key) {
        _super.prototype.removeRefreshToken.call(this, key);
        this.removeTokenKey(key, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN);
    };
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ BrowserCacheManager.prototype.getTokenKeys = function() {
        this.logger.trace("BrowserCacheManager.getTokenKeys called");
        var item = this.getItem((0, $7b3089fdde5d004f$export$f6ce23cce692699f).TOKEN_KEYS + "." + this.clientId);
        if (item) {
            var tokenKeys = this.validateAndParseJson(item);
            if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
            else this.logger.error("BrowserCacheManager.getTokenKeys - Token keys found but in an unknown format. Returning empty key map.");
        } else this.logger.verbose("BrowserCacheManager.getTokenKeys - No token keys found");
        return {
            idToken: [],
            accessToken: [],
            refreshToken: []
        };
    };
    /**
     * Adds the given key to the token key map
     * @param key
     * @param type
     */ BrowserCacheManager.prototype.addTokenKey = function(key, type) {
        this.logger.trace("BrowserCacheManager addTokenKey called");
        var tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN:
                if (tokenKeys.idToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - idToken added to map");
                    tokenKeys.idToken.push(key);
                }
                break;
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                if (tokenKeys.accessToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - accessToken added to map");
                    tokenKeys.accessToken.push(key);
                }
                break;
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                if (tokenKeys.refreshToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - refreshToken added to map");
                    tokenKeys.refreshToken.push(key);
                }
                break;
            default:
                this.logger.error("BrowserCacheManager:addTokenKey - CredentialType provided invalid. CredentialType: " + type);
                (0, $30cd164be78785f3$export$a839ff85a7957561).createUnexpectedCredentialTypeError();
        }
        this.setItem((0, $7b3089fdde5d004f$export$f6ce23cce692699f).TOKEN_KEYS + "." + this.clientId, JSON.stringify(tokenKeys));
    };
    /**
     * Removes the given key from the token key map
     * @param key
     * @param type
     */ BrowserCacheManager.prototype.removeTokenKey = function(key, type) {
        this.logger.trace("BrowserCacheManager removeTokenKey called");
        var tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN:
                this.logger.infoPii("BrowserCacheManager: removeTokenKey - attempting to remove idToken with key: " + key + " from map");
                var idRemoval = tokenKeys.idToken.indexOf(key);
                if (idRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - idToken removed from map");
                    tokenKeys.idToken.splice(idRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - idToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                this.logger.infoPii("BrowserCacheManager: removeTokenKey - attempting to remove accessToken with key: " + key + " from map");
                var accessRemoval = tokenKeys.accessToken.indexOf(key);
                if (accessRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - accessToken removed from map");
                    tokenKeys.accessToken.splice(accessRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - accessToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                this.logger.infoPii("BrowserCacheManager: removeTokenKey - attempting to remove refreshToken with key: " + key + " from map");
                var refreshRemoval = tokenKeys.refreshToken.indexOf(key);
                if (refreshRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken removed from map");
                    tokenKeys.refreshToken.splice(refreshRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            default:
                this.logger.error("BrowserCacheManager:removeTokenKey - CredentialType provided invalid. CredentialType: " + type);
                (0, $30cd164be78785f3$export$a839ff85a7957561).createUnexpectedCredentialTypeError();
        }
        this.setItem((0, $7b3089fdde5d004f$export$f6ce23cce692699f).TOKEN_KEYS + "." + this.clientId, JSON.stringify(tokenKeys));
    };
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ BrowserCacheManager.prototype.getIdTokenCredential = function(idTokenKey) {
        var value = this.getItem(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN);
            return null;
        }
        var parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, $0c09c5966c1cc91f$export$49ed297fa7d02bde).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeTokenKey(idTokenKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $0c09c5966c1cc91f$export$49ed297fa7d02bde)(), parsedIdToken);
    };
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ BrowserCacheManager.prototype.setIdTokenCredential = function(idToken) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        var idTokenKey = idToken.generateCredentialKey();
        this.setItem(idTokenKey, JSON.stringify(idToken));
        this.addTokenKey(idTokenKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ID_TOKEN);
    };
    /**
     * generates accessToken entity from a string
     * @param key
     */ BrowserCacheManager.prototype.getAccessTokenCredential = function(accessTokenKey) {
        var value = this.getItem(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN);
            return null;
        }
        var parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, $698539a43f4f793b$export$6b7a8e14ec177765).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $698539a43f4f793b$export$6b7a8e14ec177765)(), parsedAccessToken);
    };
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ BrowserCacheManager.prototype.setAccessTokenCredential = function(accessToken) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        var accessTokenKey = accessToken.generateCredentialKey();
        this.setItem(accessTokenKey, JSON.stringify(accessToken));
        this.addTokenKey(accessTokenKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).ACCESS_TOKEN);
    };
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ BrowserCacheManager.prototype.getRefreshTokenCredential = function(refreshTokenKey) {
        var value = this.getItem(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN);
            return null;
        }
        var parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, $16a85bb95b6824db$export$2f7722c9adbc0a1b).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN);
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $16a85bb95b6824db$export$2f7722c9adbc0a1b)(), parsedRefreshToken);
    };
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ BrowserCacheManager.prototype.setRefreshTokenCredential = function(refreshToken) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        var refreshTokenKey = refreshToken.generateCredentialKey();
        this.setItem(refreshTokenKey, JSON.stringify(refreshToken));
        this.addTokenKey(refreshTokenKey, (0, $1b76d687a319d9ed$export$eca2dc7e6e608a68).REFRESH_TOKEN);
    };
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */ BrowserCacheManager.prototype.getAppMetadata = function(appMetadataKey) {
        var value = this.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $bd0d508238673d4b$export$b939be19f91a34cc).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $bd0d508238673d4b$export$b939be19f91a34cc)(), parsedMetadata);
    };
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */ BrowserCacheManager.prototype.setAppMetadata = function(appMetadata) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        var appMetadataKey = appMetadata.generateAppMetadataKey();
        this.setItem(appMetadataKey, JSON.stringify(appMetadata));
    };
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */ BrowserCacheManager.prototype.getServerTelemetry = function(serverTelemetryKey) {
        var value = this.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $9b88af41c7151908$export$ff670b37c5e10296).isServerTelemetryEntity(serverTelemetryKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $9b88af41c7151908$export$ff670b37c5e10296)(), parsedMetadata);
    };
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ BrowserCacheManager.prototype.setServerTelemetry = function(serverTelemetryKey, serverTelemetry) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry));
    };
    /**
     *
     */ BrowserCacheManager.prototype.getAuthorityMetadata = function(key) {
        var value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        var parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, $cfca0354626cc9b4$export$49e7dcb371a5f08e).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $cfca0354626cc9b4$export$49e7dcb371a5f08e)(), parsedMetadata);
        }
        return null;
    };
    /**
     *
     */ BrowserCacheManager.prototype.getAuthorityMetadataKeys = function() {
        var _this = this;
        var allKeys = this.internalStorage.getKeys();
        return allKeys.filter(function(key) {
            return _this.isAuthorityMetadata(key);
        });
    };
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ BrowserCacheManager.prototype.setWrapperMetadata = function(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, $7b3089fdde5d004f$export$8f546f90896bcfa9).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, $7b3089fdde5d004f$export$8f546f90896bcfa9).WRAPPER_VER, wrapperVersion);
    };
    /**
     * Returns wrapper metadata from in-memory storage
     */ BrowserCacheManager.prototype.getWrapperMetadata = function() {
        var sku = this.internalStorage.getItem((0, $7b3089fdde5d004f$export$8f546f90896bcfa9).WRAPPER_SKU) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        var version = this.internalStorage.getItem((0, $7b3089fdde5d004f$export$8f546f90896bcfa9).WRAPPER_VER) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        return [
            sku,
            version
        ];
    };
    /**
     *
     * @param entity
     */ BrowserCacheManager.prototype.setAuthorityMetadata = function(key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    };
    /**
     * Gets the active account
     */ BrowserCacheManager.prototype.getActiveAccount = function() {
        var activeAccountKeyFilters = this.generateCacheKey((0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        var activeAccountValueFilters = this.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            // if new active account cache type isn't found, it's an old version, so look for that instead
            this.logger.trace("BrowserCacheManager.getActiveAccount: No active account filters cache schema found, looking for legacy schema");
            var activeAccountKeyLocal = this.generateCacheKey((0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
            var activeAccountValueLocal = this.getItem(activeAccountKeyLocal);
            if (!activeAccountValueLocal) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
                return null;
            }
            var activeAccount = this.getAccountInfoByFilter({
                localAccountId: activeAccountValueLocal
            })[0] || null;
            if (activeAccount) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: Legacy active account cache schema found");
                this.logger.trace("BrowserCacheManager.getActiveAccount: Adding active account filters cache schema");
                this.setActiveAccount(activeAccount);
                return activeAccount;
            }
            return null;
        }
        var activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: Active account filters schema found");
            return this.getAccountInfoByFilter({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId
            })[0] || null;
        }
        this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
        return null;
    };
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ BrowserCacheManager.prototype.setActiveAccount = function(account) {
        var activeAccountKey = this.generateCacheKey((0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        var activeAccountKeyLocal = this.generateCacheKey((0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            var activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId
            };
            this.browserStorage.setItem(activeAccountKey, JSON.stringify(activeAccountValue));
            this.browserStorage.setItem(activeAccountKeyLocal, account.localAccountId);
        } else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.browserStorage.removeItem(activeAccountKey);
            this.browserStorage.removeItem(activeAccountKeyLocal);
        }
    };
    /**
     * Gets a list of accounts that match all of the filters provided
     * @param account
     */ BrowserCacheManager.prototype.getAccountInfoByFilter = function(accountFilter) {
        var allAccounts = this.getAllAccounts();
        this.logger.trace("BrowserCacheManager.getAccountInfoByFilter: total " + allAccounts.length + " accounts found");
        return allAccounts.filter(function(accountObj) {
            if (accountFilter.username && accountFilter.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountFilter.homeAccountId && accountFilter.homeAccountId !== accountObj.homeAccountId) return false;
            if (accountFilter.localAccountId && accountFilter.localAccountId !== accountObj.localAccountId) return false;
            if (accountFilter.tenantId && accountFilter.tenantId !== accountObj.tenantId) return false;
            if (accountFilter.environment && accountFilter.environment !== accountObj.environment) return false;
            return true;
        });
    };
    /**
     * Checks the cache for accounts matching loginHint or SID
     * @param loginHint
     * @param sid
     */ BrowserCacheManager.prototype.getAccountInfoByHints = function(loginHint, sid) {
        var matchingAccounts = this.getAllAccounts().filter(function(accountInfo) {
            if (sid) {
                var accountSid = accountInfo.idTokenClaims && accountInfo.idTokenClaims["sid"];
                return sid === accountSid;
            }
            if (loginHint) return loginHint === accountInfo.username;
            return false;
        });
        if (matchingAccounts.length === 1) return matchingAccounts[0];
        else if (matchingAccounts.length > 1) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createMultipleMatchingAccountsInCacheError();
        return null;
    };
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */ BrowserCacheManager.prototype.getThrottlingCache = function(throttlingCacheKey) {
        var value = this.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        var parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, $d355d47fec590bb4$export$15b974958510ada9).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $d355d47fec590bb4$export$15b974958510ada9)(), parsedThrottlingCache);
    };
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ BrowserCacheManager.prototype.setThrottlingCache = function(throttlingCacheKey, throttlingCache) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache));
    };
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */ BrowserCacheManager.prototype.getTemporaryCache = function(cacheKey, generateKey) {
        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            var itemCookie = this.getItemCookie(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        var value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === (0, $7b3089fdde5d004f$export$573384e47a12d835).LocalStorage) {
                var item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    };
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */ BrowserCacheManager.prototype.setTemporaryCache = function(cacheKey, value, generateKey) {
        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.setItemCookie(key, value);
        }
    };
    /**
     * Removes the cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */ BrowserCacheManager.prototype.removeItem = function(key) {
        this.browserStorage.removeItem(key);
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.clearItemCookie(key);
        }
    };
    /**
     * Checks whether key is in cache.
     * @param key
     */ BrowserCacheManager.prototype.containsKey = function(key) {
        return this.browserStorage.containsKey(key) || this.temporaryCacheStorage.containsKey(key);
    };
    /**
     * Gets all keys in window.
     */ BrowserCacheManager.prototype.getKeys = function() {
        return (0, $ac3fbc8ec7de8c8c$export$afc72e2116322959)(this.browserStorage.getKeys(), this.temporaryCacheStorage.getKeys());
    };
    /**
     * Clears all cache entries created by MSAL.
     */ BrowserCacheManager.prototype.clear = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Removes all accounts and their credentials
                        return [
                            4 /*yield*/ ,
                            this.removeAllAccounts()
                        ];
                    case 1:
                        // Removes all accounts and their credentials
                        _a.sent();
                        this.removeAppMetadata();
                        // Removes all remaining MSAL cache items
                        this.getKeys().forEach(function(cacheKey) {
                            // Check if key contains msal prefix; For now, we are clearing all the cache items created by MSAL.js
                            if ((_this.browserStorage.containsKey(cacheKey) || _this.temporaryCacheStorage.containsKey(cacheKey)) && (cacheKey.indexOf((0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(_this.clientId) !== -1)) _this.removeItem(cacheKey);
                        });
                        this.internalStorage.clear();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Add value to cookies
     * @param cookieName
     * @param cookieValue
     * @param expires
     */ BrowserCacheManager.prototype.setItemCookie = function(cookieName, cookieValue, expires) {
        var cookieStr = encodeURIComponent(cookieName) + "=" + encodeURIComponent(cookieValue) + ";path=/;SameSite=Lax;";
        if (expires) {
            var expireTime = this.getCookieExpirationTime(expires);
            cookieStr += "expires=" + expireTime + ";";
        }
        if (this.cacheConfig.secureCookies) cookieStr += "Secure;";
        document.cookie = cookieStr;
    };
    /**
     * Get one item by key from cookies
     * @param cookieName
     */ BrowserCacheManager.prototype.getItemCookie = function(cookieName) {
        var name = encodeURIComponent(cookieName) + "=";
        var cookieList = document.cookie.split(";");
        for(var i = 0; i < cookieList.length; i++){
            var cookie = cookieList[i];
            while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
            if (cookie.indexOf(name) === 0) return decodeURIComponent(cookie.substring(name.length, cookie.length));
        }
        return (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
    };
    /**
     * Clear all msal-related cookies currently set in the browser. Should only be used to clear temporary cache items.
     */ BrowserCacheManager.prototype.clearMsalCookies = function() {
        var _this = this;
        var cookiePrefix = (0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX + "." + this.clientId;
        var cookieList = document.cookie.split(";");
        cookieList.forEach(function(cookie) {
            while(cookie.charAt(0) === " ")// eslint-disable-next-line no-param-reassign
            cookie = cookie.substring(1);
            if (cookie.indexOf(cookiePrefix) === 0) {
                var cookieKey = cookie.split("=")[0];
                _this.clearItemCookie(cookieKey);
            }
        });
    };
    /**
     * Clear an item in the cookies by key
     * @param cookieName
     */ BrowserCacheManager.prototype.clearItemCookie = function(cookieName) {
        this.setItemCookie(cookieName, (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, -1);
    };
    /**
     * Get cookie expiration time
     * @param cookieLifeDays
     */ BrowserCacheManager.prototype.getCookieExpirationTime = function(cookieLifeDays) {
        var today = new Date();
        var expr = new Date(today.getTime() + cookieLifeDays * this.COOKIE_LIFE_MULTIPLIER);
        return expr.toUTCString();
    };
    /**
     * Gets the cache object referenced by the browser
     */ BrowserCacheManager.prototype.getCache = function() {
        return this.browserStorage;
    };
    /**
     * interface compat, we cannot overwrite browser cache; Functionality is supported by individual entities in browser
     */ BrowserCacheManager.prototype.setCache = function() {
    // sets nothing
    };
    /**
     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
     * @param key
     * @param addInstanceId
     */ BrowserCacheManager.prototype.generateCacheKey = function(key) {
        var generatedKey = this.validateAndParseJson(key);
        if (!generatedKey) {
            if ((0, $1842614da3ac031b$export$ecc754f99843e759).startsWith(key, (0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX) || (0, $1842614da3ac031b$export$ecc754f99843e759).startsWith(key, (0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ADAL_ID_TOKEN)) return key;
            return (0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX + "." + this.clientId + "." + key;
        }
        return JSON.stringify(key);
    };
    /**
     * Create authorityKey to cache authority
     * @param state
     */ BrowserCacheManager.prototype.generateAuthorityKey = function(stateString) {
        var stateId = (0, $43862c84d67ae4c1$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).AUTHORITY + "." + stateId);
    };
    /**
     * Create Nonce key to cache nonce
     * @param state
     */ BrowserCacheManager.prototype.generateNonceKey = function(stateString) {
        var stateId = (0, $43862c84d67ae4c1$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).NONCE_IDTOKEN + "." + stateId);
    };
    /**
     * Creates full cache key for the request state
     * @param stateString State string for the request
     */ BrowserCacheManager.prototype.generateStateKey = function(stateString) {
        // Use the library state id to key temp storage for uniqueness for multiple concurrent requests
        var stateId = (0, $43862c84d67ae4c1$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString).libraryState.id;
        return this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).REQUEST_STATE + "." + stateId);
    };
    /**
     * Gets the cached authority based on the cached state. Returns empty if no cached state found.
     */ BrowserCacheManager.prototype.getCachedAuthority = function(cachedState) {
        var stateCacheKey = this.generateStateKey(cachedState);
        var state = this.getTemporaryCache(stateCacheKey);
        if (!state) return null;
        var authorityCacheKey = this.generateAuthorityKey(state);
        return this.getTemporaryCache(authorityCacheKey);
    };
    /**
     * Updates account, authority, and state in cache
     * @param serverAuthenticationRequest
     * @param account
     */ BrowserCacheManager.prototype.updateCacheEntries = function(state, nonce, authorityInstance, loginHint, account) {
        this.logger.trace("BrowserCacheManager.updateCacheEntries called");
        // Cache the request state
        var stateCacheKey = this.generateStateKey(state);
        this.setTemporaryCache(stateCacheKey, state, false);
        // Cache the nonce
        var nonceCacheKey = this.generateNonceKey(state);
        this.setTemporaryCache(nonceCacheKey, nonce, false);
        // Cache authorityKey
        var authorityCacheKey = this.generateAuthorityKey(state);
        this.setTemporaryCache(authorityCacheKey, authorityInstance, false);
        if (account) {
            var ccsCredential = {
                credential: account.homeAccountId,
                type: (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
            this.setTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        } else if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(loginHint)) {
            var ccsCredential = {
                credential: loginHint,
                type: (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).UPN
            };
            this.setTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        }
    };
    /**
     * Reset all temporary cache items
     * @param state
     */ BrowserCacheManager.prototype.resetRequestCache = function(state) {
        var _this = this;
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        // check state and remove associated cache items
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(state)) this.getKeys().forEach(function(key) {
            if (key.indexOf(state) !== -1) _this.removeItem(key);
        });
        // delete generic interactive request parameters
        if (state) {
            this.removeItem(this.generateStateKey(state));
            this.removeItem(this.generateNonceKey(state));
            this.removeItem(this.generateAuthorityKey(state));
        }
        this.removeItem(this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).REQUEST_PARAMS));
        this.removeItem(this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).ORIGIN_URI));
        this.removeItem(this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).URL_HASH));
        this.removeItem(this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).CORRELATION_ID));
        this.removeItem(this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).CCS_CREDENTIAL));
        this.removeItem(this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).NATIVE_REQUEST));
        this.setInteractionInProgress(false);
    };
    /**
     * Removes temporary cache for the provided state
     * @param stateString
     */ BrowserCacheManager.prototype.cleanRequestByState = function(stateString) {
        this.logger.trace("BrowserCacheManager.cleanRequestByState called");
        // Interaction is completed - remove interaction status.
        if (stateString) {
            var stateKey = this.generateStateKey(stateString);
            var cachedState = this.temporaryCacheStorage.getItem(stateKey);
            this.logger.infoPii("BrowserCacheManager.cleanRequestByState: Removing temporary cache items for state: " + cachedState);
            this.resetRequestCache(cachedState || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
        }
        this.clearMsalCookies();
    };
    /**
     * Looks in temporary cache for any state values with the provided interactionType and removes all temporary cache items for that state
     * Used in scenarios where temp cache needs to be cleaned but state is not known, such as clicking browser back button.
     * @param interactionType
     */ BrowserCacheManager.prototype.cleanRequestByInteractionType = function(interactionType) {
        var _this = this;
        this.logger.trace("BrowserCacheManager.cleanRequestByInteractionType called");
        // Loop through all keys to find state key
        this.getKeys().forEach(function(key) {
            // If this key is not the state key, move on
            if (key.indexOf((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).REQUEST_STATE) === -1) return;
            // Retrieve state value, return if not a valid value
            var stateValue = _this.temporaryCacheStorage.getItem(key);
            if (!stateValue) return;
            // Extract state and ensure it matches given InteractionType, then clean request cache
            var parsedState = (0, $60804433685cab28$export$83c579d74a9d4ed7).extractBrowserRequestState(_this.cryptoImpl, stateValue);
            if (parsedState && parsedState.interactionType === interactionType) {
                _this.logger.infoPii("BrowserCacheManager.cleanRequestByInteractionType: Removing temporary cache items for state: " + stateValue);
                _this.resetRequestCache(stateValue);
            }
        });
        this.clearMsalCookies();
        this.setInteractionInProgress(false);
    };
    BrowserCacheManager.prototype.cacheCodeRequest = function(authCodeRequest, browserCrypto) {
        this.logger.trace("BrowserCacheManager.cacheCodeRequest called");
        var encodedValue = browserCrypto.base64Encode(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).REQUEST_PARAMS, encodedValue, true);
    };
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */ BrowserCacheManager.prototype.getCachedRequest = function(state, browserCrypto) {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        var encodedTokenRequest = this.getTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).REQUEST_PARAMS, true);
        if (!encodedTokenRequest) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNoTokenRequestCacheError();
        var parsedRequest = this.validateAndParseJson(browserCrypto.base64Decode(encodedTokenRequest));
        if (!parsedRequest) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToParseTokenRequestCacheError();
        this.removeItem(this.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).REQUEST_PARAMS));
        // Get cached authority and use if no authority is cached with request.
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(parsedRequest.authority)) {
            var authorityCacheKey = this.generateAuthorityKey(state);
            var cachedAuthority = this.getTemporaryCache(authorityCacheKey);
            if (!cachedAuthority) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNoCachedAuthorityError();
            parsedRequest.authority = cachedAuthority;
        }
        return parsedRequest;
    };
    /**
     * Gets cached native request for redirect flows
     */ BrowserCacheManager.prototype.getCachedNativeRequest = function() {
        this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
        var cachedRequest = this.getTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).NATIVE_REQUEST, true);
        if (!cachedRequest) {
            this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found");
            return null;
        }
        var parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request");
            return null;
        }
        return parsedRequest;
    };
    BrowserCacheManager.prototype.isInteractionInProgress = function(matchClientId) {
        var clientId = this.getInteractionInProgress();
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    };
    BrowserCacheManager.prototype.getInteractionInProgress = function() {
        var key = (0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $7b3089fdde5d004f$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY;
        return this.getTemporaryCache(key, false);
    };
    BrowserCacheManager.prototype.setInteractionInProgress = function(inProgress) {
        // Ensure we don't overwrite interaction in progress for a different clientId
        var key = (0, $1b76d687a319d9ed$export$a002182e51710d39).CACHE_PREFIX + "." + (0, $7b3089fdde5d004f$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY;
        if (inProgress) {
            if (this.getInteractionInProgress()) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createInteractionInProgressError();
            else // No interaction is in progress
            this.setTemporaryCache(key, this.clientId, false);
        } else if (!inProgress && this.getInteractionInProgress() === this.clientId) this.removeItem(key);
    };
    /**
     * Returns username retrieved from ADAL or MSAL v1 idToken
     */ BrowserCacheManager.prototype.getLegacyLoginHint = function() {
        // Only check for adal/msal token if no SSO params are being used
        var adalIdTokenString = this.getTemporaryCache((0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
        if (adalIdTokenString) {
            this.browserStorage.removeItem((0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
            this.logger.verbose("Cached ADAL id token retrieved.");
        }
        // Check for cached MSAL v1 id token
        var msalIdTokenString = this.getTemporaryCache((0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ID_TOKEN, true);
        if (msalIdTokenString) {
            this.removeItem(this.generateCacheKey((0, $1b76d687a319d9ed$export$81ab9ba9bd28255c).ID_TOKEN));
            this.logger.verbose("Cached MSAL.js v1 id token retrieved");
        }
        var cachedIdTokenString = msalIdTokenString || adalIdTokenString;
        if (cachedIdTokenString) {
            var cachedIdToken = new (0, $88f623fdecedc666$export$3a170961dab30083)(cachedIdTokenString, this.cryptoImpl);
            if (cachedIdToken.claims && cachedIdToken.claims.preferred_username) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 preferred_username as loginHint");
                return cachedIdToken.claims.preferred_username;
            } else if (cachedIdToken.claims && cachedIdToken.claims.upn) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 upn as loginHint");
                return cachedIdToken.claims.upn;
            } else this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, however, no account hint claim found. Enable preferred_username or upn id token claim to get SSO.");
        }
        return null;
    };
    /**
     * Updates a credential's cache key if the current cache key is outdated
     */ BrowserCacheManager.prototype.updateCredentialCacheKey = function(currentCacheKey, credential) {
        var updatedCacheKey = credential.generateCredentialKey();
        if (currentCacheKey !== updatedCacheKey) {
            var cacheItem = this.getItem(currentCacheKey);
            if (cacheItem) {
                this.removeItem(currentCacheKey);
                this.setItem(updatedCacheKey, cacheItem);
                this.logger.verbose("Updated an outdated " + credential.credentialType + " cache key");
                return updatedCacheKey;
            } else this.logger.error("Attempted to update an outdated " + credential.credentialType + " cache key but no item matching the outdated key was found in storage");
        }
        return currentCacheKey;
    };
    /**
     * Returns application id as redirect context during AcquireTokenRedirect flow.
     */ BrowserCacheManager.prototype.getRedirectRequestContext = function() {
        return this.getTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).REDIRECT_CONTEXT, true);
    };
    /**
     * Sets application id as the redirect context during AcquireTokenRedirect flow.
     * @param value
     */ BrowserCacheManager.prototype.setRedirectRequestContext = function(value) {
        this.setTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).REDIRECT_CONTEXT, value, true);
    };
    return BrowserCacheManager;
}((0, $6d140ee99f8bea66$export$996e3ea69314b5c6));
var $6a4e3e48f11f536f$export$8e2d54002f8f6e5d = function(clientId, logger) {
    var cacheOptions = {
        cacheLocation: (0, $7b3089fdde5d004f$export$573384e47a12d835).MemoryStorage,
        temporaryCacheLocation: (0, $7b3089fdde5d004f$export$573384e47a12d835).MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        cacheMigrationEnabled: false
    };
    return new $6a4e3e48f11f536f$export$44d7291b5c8cc149(clientId, cacheOptions, (0, $2e9f1da89a74ab73$export$865f57d401606752), logger);
};


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $d3f66d4e6c82e919$export$4cda21933050d9ec;
(function(AzureCloudInstance) {
    // AzureCloudInstance is not specified.
    AzureCloudInstance[AzureCloudInstance["None"] = 0] = "None";
    // Microsoft Azure public cloud
    AzureCloudInstance["AzurePublic"] = "https://login.microsoftonline.com";
    // Microsoft PPE
    AzureCloudInstance["AzurePpe"] = "https://login.windows-ppe.net";
    // Microsoft Chinese national cloud
    AzureCloudInstance["AzureChina"] = "https://login.chinacloudapi.cn";
    // Microsoft German national cloud ("Black Forest")
    AzureCloudInstance["AzureGermany"] = "https://login.microsoftonline.de";
    // US Government cloud
    AzureCloudInstance["AzureUsGovernment"] = "https://login.microsoftonline.us";
})($d3f66d4e6c82e919$export$4cda21933050d9ec || ($d3f66d4e6c82e919$export$4cda21933050d9ec = {}));

/*! @azure/msal-common v13.1.0 2023-06-07 */ 







"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Token renewal offset default in seconds
var $fbb13fa60d5b5843$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC = 300;
var $fbb13fa60d5b5843$export$f7a7dd6bfc156d75 = {
    tokenRenewalOffsetSeconds: $fbb13fa60d5b5843$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC,
    preventCorsPreflight: false
};
var $fbb13fa60d5b5843$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: function() {
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, $176db342bac9b10e$export$243e62d78d3b544d).Info,
    correlationId: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
};
var $fbb13fa60d5b5843$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    sendGetRequestAsync: function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Network interface - sendGetRequestAsync() has not been implemented";
                throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    },
    sendPostRequestAsync: function() {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var notImplErr;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                notImplErr = "Network interface - sendPostRequestAsync() has not been implemented";
                throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr);
            });
        });
    }
};
var $fbb13fa60d5b5843$var$DEFAULT_LIBRARY_INFO = {
    sku: (0, $1b76d687a319d9ed$export$a002182e51710d39).SKU,
    version: (0, $d86c8dd6d40ffd16$export$83d89fbfd8236492),
    cpu: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
    os: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
};
var $fbb13fa60d5b5843$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
    clientAssertion: undefined
};
var $fbb13fa60d5b5843$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, $d3f66d4e6c82e919$export$4cda21933050d9ec).None,
    tenant: "" + (0, $1b76d687a319d9ed$export$a002182e51710d39).DEFAULT_COMMON_TENANT
};
var $fbb13fa60d5b5843$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */ function $fbb13fa60d5b5843$export$57a091701dcdabb2(_a) {
    var userAuthOptions = _a.authOptions, userSystemOptions = _a.systemOptions, userLoggerOption = _a.loggerOptions, storageImplementation = _a.storageInterface, networkImplementation = _a.networkInterface, cryptoImplementation = _a.cryptoInterface, clientCredentials = _a.clientCredentials, libraryInfo = _a.libraryInfo, telemetry = _a.telemetry, serverTelemetryManager = _a.serverTelemetryManager, persistencePlugin = _a.persistencePlugin, serializableCache = _a.serializableCache;
    var loggerOptions = (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, $fbb13fa60d5b5843$var$DEFAULT_LOGGER_IMPLEMENTATION), userLoggerOption);
    return {
        authOptions: $fbb13fa60d5b5843$var$buildAuthOptions(userAuthOptions),
        systemOptions: (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, $fbb13fa60d5b5843$export$f7a7dd6bfc156d75), userSystemOptions),
        loggerOptions: loggerOptions,
        storageInterface: storageImplementation || new (0, $6d140ee99f8bea66$export$b7254d304b3004b6)(userAuthOptions.clientId, (0, $2e9f1da89a74ab73$export$865f57d401606752), new (0, $176db342bac9b10e$export$efa9a398d6368992)(loggerOptions)),
        networkInterface: networkImplementation || $fbb13fa60d5b5843$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, $2e9f1da89a74ab73$export$865f57d401606752),
        clientCredentials: clientCredentials || $fbb13fa60d5b5843$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, $fbb13fa60d5b5843$var$DEFAULT_LIBRARY_INFO), libraryInfo),
        telemetry: (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, $fbb13fa60d5b5843$var$DEFAULT_TELEMETRY_OPTIONS), telemetry),
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $fbb13fa60d5b5843$var$buildAuthOptions(authOptions) {
    return (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({
        clientCapabilities: [],
        azureCloudOptions: $fbb13fa60d5b5843$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        skipAuthorityMetadataCache: false
    }, authOptions);
}

/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ var $814799ffd517c6ae$export$73a3e3dedd37150d;
(function(ProtocolMode) {
    ProtocolMode["AAD"] = "AAD";
    ProtocolMode["OIDC"] = "OIDC";
})($814799ffd517c6ae$export$73a3e3dedd37150d || ($814799ffd517c6ae$export$73a3e3dedd37150d = {}));

/*! @azure/msal-common v13.1.0 2023-06-07 */ 
"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $450a9f3f28973c54$export$6d95060a8ed7155a = {
    sendGetRequestAsync: function() {
        var notImplErr = "Network interface - sendGetRequestAsync() has not been implemented for the Network interface.";
        return Promise.reject((0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr));
    },
    sendPostRequestAsync: function() {
        var notImplErr = "Network interface - sendPostRequestAsync() has not been implemented for the Network interface.";
        return Promise.reject((0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError(notImplErr));
    }
};


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-browser v2.37.1 2023-06-07 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ var $358050dcc8569719$export$4c206ef5be879972 = /** @class */ function() {
    function FetchClient() {}
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ FetchClient.prototype.sendGetRequestAsync = function(url, options) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var response, e_1, _a;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch(url, {
                                method: (0, $7b3089fdde5d004f$export$c774c31b4c31da8).GET,
                                headers: this.getFetchHeaders(options)
                            })
                        ];
                    case 1:
                        response = _b.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        e_1 = _b.sent();
                        if (window.navigator.onLine) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createGetRequestFailedError(e_1, url);
                        else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNoNetworkConnectivityError();
                    case 3:
                        _b.trys.push([
                            3,
                            5,
                            ,
                            6
                        ]);
                        _a = {
                            headers: this.getHeaderDict(response.headers)
                        };
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            (_a.body = _b.sent(), _a.status = response.status, _a)
                        ];
                    case 5:
                        _b.sent();
                        throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createFailedToParseNetworkResponseError(url);
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ FetchClient.prototype.sendPostRequestAsync = function(url, options) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var reqBody, response, e_3, _a;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        reqBody = options && options.body || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch(url, {
                                method: (0, $7b3089fdde5d004f$export$c774c31b4c31da8).POST,
                                headers: this.getFetchHeaders(options),
                                body: reqBody
                            })
                        ];
                    case 2:
                        response = _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_3 = _b.sent();
                        if (window.navigator.onLine) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createPostRequestFailedError(e_3, url);
                        else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNoNetworkConnectivityError();
                    case 4:
                        _b.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        _a = {
                            headers: this.getHeaderDict(response.headers)
                        };
                        return [
                            4 /*yield*/ ,
                            response.json()
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            (_a.body = _b.sent(), _a.status = response.status, _a)
                        ];
                    case 6:
                        _b.sent();
                        throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createFailedToParseNetworkResponseError(url);
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get Fetch API Headers object from string map
     * @param inputHeaders
     */ FetchClient.prototype.getFetchHeaders = function(options) {
        var headers = new Headers();
        if (!(options && options.headers)) return headers;
        var optionsHeaders = options.headers;
        Object.keys(optionsHeaders).forEach(function(key) {
            headers.append(key, optionsHeaders[key]);
        });
        return headers;
    };
    FetchClient.prototype.getHeaderDict = function(headers) {
        var headerDict = {};
        headers.forEach(function(value, key) {
            headerDict[key] = value;
        });
        return headerDict;
    };
    return FetchClient;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This client implements the XMLHttpRequest class to send GET and POST requests.
 */ var $5290ea5659454ff1$export$4a5808801761cc05 = /** @class */ function() {
    function XhrClient() {}
    /**
     * XhrClient for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ XhrClient.prototype.sendGetRequestAsync = function(url, options) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.sendRequestAsync(url, (0, $7b3089fdde5d004f$export$c774c31b4c31da8).GET, options)
                ];
            });
        });
    };
    /**
     * XhrClient for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ XhrClient.prototype.sendPostRequestAsync = function(url, options) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.sendRequestAsync(url, (0, $7b3089fdde5d004f$export$c774c31b4c31da8).POST, options)
                ];
            });
        });
    };
    /**
     * Helper for XhrClient requests.
     * @param url
     * @param method
     * @param options
     */ XhrClient.prototype.sendRequestAsync = function(url, method, options) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url, /* async: */ true);
            _this.setXhrHeaders(xhr, options);
            xhr.onload = function() {
                if (xhr.status < 200 || xhr.status >= 300) {
                    if (method === (0, $7b3089fdde5d004f$export$c774c31b4c31da8).POST) reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createPostRequestFailedError("Failed with status " + xhr.status, url));
                    else reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createGetRequestFailedError("Failed with status " + xhr.status, url));
                }
                try {
                    var jsonResponse = JSON.parse(xhr.responseText);
                    var networkResponse = {
                        headers: _this.getHeaderDict(xhr),
                        body: jsonResponse,
                        status: xhr.status
                    };
                    resolve(networkResponse);
                } catch (e) {
                    reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createFailedToParseNetworkResponseError(url));
                }
            };
            xhr.onerror = function() {
                if (window.navigator.onLine) {
                    if (method === (0, $7b3089fdde5d004f$export$c774c31b4c31da8).POST) reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createPostRequestFailedError("Failed with status " + xhr.status, url));
                    else reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createGetRequestFailedError("Failed with status " + xhr.status, url));
                } else reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createNoNetworkConnectivityError());
            };
            if (method === (0, $7b3089fdde5d004f$export$c774c31b4c31da8).POST && options && options.body) xhr.send(options.body);
            else if (method === (0, $7b3089fdde5d004f$export$c774c31b4c31da8).GET) xhr.send();
            else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createHttpMethodNotImplementedError(method);
        });
    };
    /**
     * Helper to set XHR headers for request.
     * @param xhr
     * @param options
     */ XhrClient.prototype.setXhrHeaders = function(xhr, options) {
        if (options && options.headers) {
            var headers_1 = options.headers;
            Object.keys(headers_1).forEach(function(key) {
                xhr.setRequestHeader(key, headers_1[key]);
            });
        }
    };
    /**
     * Gets a string map of the headers received in the response.
     *
     * Algorithm comes from https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders
     * @param xhr
     */ XhrClient.prototype.getHeaderDict = function(xhr) {
        var headerString = xhr.getAllResponseHeaders();
        var headerArr = headerString.trim().split(/[\r\n]+/);
        var headerDict = {};
        headerArr.forEach(function(value) {
            var parts = value.split(": ");
            var headerName = parts.shift();
            var headerVal = parts.join(": ");
            if (headerName && headerVal) headerDict[headerName] = headerVal;
        });
        return headerDict;
    };
    return XhrClient;
}();




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility class for browser specific functions
 */ var $94c261d7c4faec3a$export$311899ae85124b2d = /** @class */ function() {
    function BrowserUtils() {}
    // #region Window Navigation and URL management
    /**
     * Clears hash from window url.
     */ BrowserUtils.clearHash = function(contentWindow) {
        // Office.js sets history.replaceState to null
        contentWindow.location.hash = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
        contentWindow.history.replaceState(null, (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, "" + contentWindow.location.origin + contentWindow.location.pathname + contentWindow.location.search);
    };
    /**
     * Replaces current hash with hash from provided url
     */ BrowserUtils.replaceHash = function(url) {
        var urlParts = url.split("#");
        urlParts.shift(); // Remove part before the hash
        window.location.hash = urlParts.length > 0 ? urlParts.join("#") : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
    };
    /**
     * Returns boolean of whether the current window is in an iframe or not.
     */ BrowserUtils.isInIframe = function() {
        return window.parent !== window;
    };
    /**
     * Returns boolean of whether or not the current window is a popup opened by msal
     */ BrowserUtils.isInPopup = function() {
        return typeof window !== "undefined" && !!window.opener && window.opener !== window && typeof window.name === "string" && window.name.indexOf((0, $7b3089fdde5d004f$export$a0a689e4294b9880).POPUP_NAME_PREFIX + ".") === 0;
    };
    // #endregion
    /**
     * Returns current window URL as redirect uri
     */ BrowserUtils.getCurrentUri = function() {
        return window.location.href.split("?")[0].split("#")[0];
    };
    /**
     * Gets the homepage url for the current window location.
     */ BrowserUtils.getHomepage = function() {
        var currentUrl = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(window.location.href);
        var urlComponents = currentUrl.getUrlComponents();
        return urlComponents.Protocol + "//" + urlComponents.HostNameAndPort + "/";
    };
    /**
     * Returns best compatible network client object.
     */ BrowserUtils.getBrowserNetworkClient = function() {
        if (window.fetch && window.Headers) return new (0, $358050dcc8569719$export$4c206ef5be879972)();
        else return new (0, $5290ea5659454ff1$export$4a5808801761cc05)();
    };
    /**
     * Throws error if we have completed an auth and are
     * attempting another auth request inside an iframe.
     */ BrowserUtils.blockReloadInHiddenIframes = function() {
        var isResponseHash = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).hashContainsKnownProperties(window.location.hash);
        // return an error if called from the hidden iframe created by the msal js silent calls
        if (isResponseHash && BrowserUtils.isInIframe()) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createBlockReloadInHiddenIframeError();
    };
    /**
     * Block redirect operations in iframes unless explicitly allowed
     * @param interactionType Interaction type for the request
     * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
     */ BrowserUtils.blockRedirectInIframe = function(interactionType, allowRedirectInIframe) {
        var isIframedApp = BrowserUtils.isInIframe();
        if (interactionType === (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect && isIframedApp && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
        throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createRedirectInIframeError(isIframedApp);
    };
    /**
     * Block redirectUri loaded in popup from calling AcquireToken APIs
     */ BrowserUtils.blockAcquireTokenInPopups = function() {
        // Popups opened by msal popup APIs are given a name that starts with "msal."
        if (BrowserUtils.isInPopup()) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createBlockAcquireTokenInPopupsError();
    };
    /**
     * Throws error if token requests are made in non-browser environment
     * @param isBrowserEnvironment Flag indicating if environment is a browser.
     */ BrowserUtils.blockNonBrowserEnvironment = function(isBrowserEnvironment) {
        if (!isBrowserEnvironment) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNonBrowserEnvironmentError();
    };
    /**
     * Throws error if native brokering is enabled but initialize hasn't been called
     * @param allowNativeBroker
     * @param initialized
     */ BrowserUtils.blockNativeBrokerCalledBeforeInitialized = function(allowNativeBroker, initialized) {
        if (allowNativeBroker && !initialized) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNativeBrokerCalledBeforeInitialize();
    };
    /**
     * Returns boolean of whether current browser is an Internet Explorer or Edge browser.
     */ BrowserUtils.detectIEOrEdge = function() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        var msie11 = ua.indexOf("Trident/");
        var msedge = ua.indexOf("Edge/");
        var isIE = msie > 0 || msie11 > 0;
        var isEdge = msedge > 0;
        return isIE || isEdge;
    };
    return BrowserUtils;
}();



/*! @azure/msal-browser v2.37.1 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $4e0bade83e767854$export$d0d362a73d466c9b = /** @class */ function() {
    function NavigationClient() {}
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ NavigationClient.prototype.navigateInternal = function(url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    };
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ NavigationClient.prototype.navigateExternal = function(url, options) {
        return NavigationClient.defaultNavigateWindow(url, options);
    };
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ NavigationClient.defaultNavigateWindow = function(url, options) {
        if (options.noHistory) window.location.replace(url);
        else window.location.assign(url);
        return new Promise(function(resolve) {
            setTimeout(function() {
                resolve(true);
            }, options.timeout);
        });
    };
    return NavigationClient;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
var $f8475258f3a6b261$export$a5835ee54399d410 = 60000;
var $f8475258f3a6b261$export$f3ffe700be354b19 = 6000;
var $f8475258f3a6b261$export$293647e7865520c6 = 30000;
var $f8475258f3a6b261$export$73d1d87a8b7ddb57 = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $f8475258f3a6b261$export$f8352245bee68086(_a, isBrowserEnvironment) {
    var userInputAuth = _a.auth, userInputCache = _a.cache, userInputSystem = _a.system, userInputTelemetry = _a.telemetry;
    // Default auth options for browser
    var DEFAULT_AUTH_OPTIONS = {
        clientId: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
        authority: "" + (0, $1b76d687a319d9ed$export$a002182e51710d39).DEFAULT_AUTHORITY,
        knownAuthorities: [],
        cloudDiscoveryMetadata: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
        authorityMetadata: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
        redirectUri: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
        postLogoutRedirectUri: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: (0, $814799ffd517c6ae$export$73a3e3dedd37150d).AAD,
        azureCloudOptions: {
            azureCloudInstance: (0, $d3f66d4e6c82e919$export$4cda21933050d9ec).None,
            tenant: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        },
        skipAuthorityMetadataCache: false
    };
    // Default cache options for browser
    var DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, $7b3089fdde5d004f$export$573384e47a12d835).SessionStorage,
        temporaryCacheLocation: (0, $7b3089fdde5d004f$export$573384e47a12d835).SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        // Default cache migration to true if cache location is localStorage since entries are preserved across tabs/windows. Migration has little to no benefit in sessionStorage and memoryStorage
        cacheMigrationEnabled: userInputCache && userInputCache.cacheLocation === (0, $7b3089fdde5d004f$export$573384e47a12d835).LocalStorage ? true : false
    };
    // Default logger options for browser
    var DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: function() {
        // allow users to not set logger call back 
        },
        logLevel: (0, $176db342bac9b10e$export$243e62d78d3b544d).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    var DEFAULT_BROWSER_SYSTEM_OPTIONS = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, (0, $fbb13fa60d5b5843$export$f7a7dd6bfc156d75)), {
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? (0, $94c261d7c4faec3a$export$311899ae85124b2d).getBrowserNetworkClient() : (0, $450a9f3f28973c54$export$6d95060a8ed7155a),
        navigationClient: new (0, $4e0bade83e767854$export$d0d362a73d466c9b)(),
        loadFrameTimeout: 0,
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.loadFrameTimeout) || $f8475258f3a6b261$export$a5835ee54399d410,
        iframeHashTimeout: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.loadFrameTimeout) || $f8475258f3a6b261$export$f3ffe700be354b19,
        navigateFrameWait: isBrowserEnvironment && (0, $94c261d7c4faec3a$export$311899ae85124b2d).detectIEOrEdge() ? 500 : 0,
        redirectNavigationTimeout: $f8475258f3a6b261$export$293647e7865520c6,
        asyncPopups: false,
        allowRedirectInIframe: false,
        allowNativeBroker: false,
        nativeBrokerHandshakeTimeout: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.nativeBrokerHandshakeTimeout) || $f8475258f3a6b261$export$73d1d87a8b7ddb57,
        pollIntervalMilliseconds: (0, $7b3089fdde5d004f$export$a0a689e4294b9880).DEFAULT_POLL_INTERVAL_MS,
        cryptoOptions: {
            useMsrCrypto: false,
            entropy: undefined
        }
    });
    var providedSystemOptions = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, userInputSystem), {
        loggerOptions: (userInputSystem === null || userInputSystem === void 0 ? void 0 : userInputSystem.loggerOptions) || DEFAULT_LOGGER_OPTIONS
    });
    var DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            appVersion: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
        }
    };
    var overlayedConfig = {
        auth: (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, DEFAULT_AUTH_OPTIONS), userInputAuth),
        cache: (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, DEFAULT_CACHE_OPTIONS), userInputCache),
        system: (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, DEFAULT_BROWSER_SYSTEM_OPTIONS), providedSystemOptions),
        telemetry: (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, DEFAULT_TELEMETRY_OPTIONS), userInputTelemetry)
    };
    return overlayedConfig;
}




/*! @azure/msal-browser v2.37.1 2023-06-07 */ "use strict";
/* eslint-disable header/header */ var $374e1ca34fdd445d$export$a8ff84c12d48cfa6 = "@azure/msal-browser";
var $374e1ca34fdd445d$export$83d89fbfd8236492 = "2.37.1";




/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $07757f610459ee76$export$ce0ba2422a1c7815 = /** @class */ function() {
    function EventHandler(logger, browserCrypto) {
        this.eventCallbacks = new Map();
        this.logger = logger;
        this.browserCrypto = browserCrypto;
        this.listeningToStorageEvents = false;
        this.handleAccountCacheChange = this.handleAccountCacheChange.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ EventHandler.prototype.addEventCallback = function(callback) {
        if (typeof window !== "undefined") {
            var callbackId = this.browserCrypto.createNewGuid();
            this.eventCallbacks.set(callbackId, callback);
            this.logger.verbose("Event callback registered with id: " + callbackId);
            return callbackId;
        }
        return null;
    };
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ EventHandler.prototype.removeEventCallback = function(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose("Event callback " + callbackId + " removed.");
    };
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ EventHandler.prototype.enableAccountStorageEvents = function() {
        if (typeof window === "undefined") return;
        if (!this.listeningToStorageEvents) {
            this.logger.verbose("Adding account storage listener.");
            this.listeningToStorageEvents = true;
            window.addEventListener("storage", this.handleAccountCacheChange);
        } else this.logger.verbose("Account storage listener already registered.");
    };
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ EventHandler.prototype.disableAccountStorageEvents = function() {
        if (typeof window === "undefined") return;
        if (this.listeningToStorageEvents) {
            this.logger.verbose("Removing account storage listener.");
            window.removeEventListener("storage", this.handleAccountCacheChange);
            this.listeningToStorageEvents = false;
        } else this.logger.verbose("No account storage listener registered.");
    };
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ EventHandler.prototype.emitEvent = function(eventType, interactionType, payload, error) {
        var _this = this;
        if (typeof window !== "undefined") {
            var message_1 = {
                eventType: eventType,
                interactionType: interactionType || null,
                payload: payload || null,
                error: error || null,
                timestamp: Date.now()
            };
            this.logger.info("Emitting event: " + eventType);
            this.eventCallbacks.forEach(function(callback, callbackId) {
                _this.logger.verbose("Emitting event to callback " + callbackId + ": " + eventType);
                callback.apply(null, [
                    message_1
                ]);
            });
        }
    };
    /**
     * Emit account added/removed events when cached accounts are changed in a different tab or frame
     */ EventHandler.prototype.handleAccountCacheChange = function(e) {
        try {
            var cacheValue = e.newValue || e.oldValue;
            if (!cacheValue) return;
            var parsedValue = JSON.parse(cacheValue);
            if (typeof parsedValue !== "object" || !(0, $5d6dde05c7528aa5$export$680160523e6bfa6a).isAccountEntity(parsedValue)) return;
            var accountEntity = (0, $6d140ee99f8bea66$export$996e3ea69314b5c6).toObject(new (0, $5d6dde05c7528aa5$export$680160523e6bfa6a)(), parsedValue);
            var accountInfo = accountEntity.getAccountInfo();
            if (!e.oldValue && e.newValue) {
                this.logger.info("Account was added to cache in a different window");
                this.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACCOUNT_ADDED, undefined, accountInfo);
            } else if (!e.newValue && e.oldValue) {
                this.logger.info("Account was removed from cache in a different window");
                this.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACCOUNT_REMOVED, undefined, accountInfo);
            }
        } catch (e) {
            return;
        }
    };
    return EventHandler;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $c78f3ba4540ca0dd$export$c060a619741dd765 = /** @class */ function() {
    function ThrottlingUtils() {}
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ ThrottlingUtils.generateThrottlingStorageKey = function(thumbprint) {
        return (0, $1b76d687a319d9ed$export$a2330d6808e6d893).THROTTLING_PREFIX + "." + JSON.stringify(thumbprint);
    };
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ ThrottlingUtils.preProcess = function(cacheManager, thumbprint) {
        var _a;
        var key = ThrottlingUtils.generateThrottlingStorageKey(thumbprint);
        var value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key);
                return;
            }
            throw new (0, $b198a6cc5c52ae21$export$ea52035eac03daf0)(((_a = value.errorCodes) === null || _a === void 0 ? void 0 : _a.join(" ")) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, value.errorMessage, value.subError);
        }
    };
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ ThrottlingUtils.postProcess = function(cacheManager, thumbprint, response) {
        if (ThrottlingUtils.checkResponseStatus(response) || ThrottlingUtils.checkResponseForRetryAfter(response)) {
            var thumbprintValue = {
                throttleTime: ThrottlingUtils.calculateThrottleTime(parseInt(response.headers[(0, $1b76d687a319d9ed$export$28d77f87efed1d88).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache(ThrottlingUtils.generateThrottlingStorageKey(thumbprint), thumbprintValue);
        }
    };
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ ThrottlingUtils.checkResponseStatus = function(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    };
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ ThrottlingUtils.checkResponseForRetryAfter = function(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, $1b76d687a319d9ed$export$28d77f87efed1d88).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    };
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ ThrottlingUtils.calculateThrottleTime = function(throttleTime) {
        var time = throttleTime <= 0 ? 0 : throttleTime;
        var currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, $1b76d687a319d9ed$export$a2330d6808e6d893).DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + (0, $1b76d687a319d9ed$export$a2330d6808e6d893).DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    };
    ThrottlingUtils.removeThrottle = function(cacheManager, clientId, request, homeAccountIdentifier) {
        var thumbprint = {
            clientId: clientId,
            authority: request.authority,
            scopes: request.scopes,
            homeAccountIdentifier: homeAccountIdentifier,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        var key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key);
    };
    return ThrottlingUtils;
}();


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ 

/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $bb51a26afa6348ef$export$aab44dc88900a3b(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}





/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $ce6e7a20b7730562$export$223f43dfec89cb87 = {
    "endpointMetadata": {
        "https://login.microsoftonline.com/common/": {
            "token_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.com/common/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.com/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.com/common/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.com/common/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.com",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pas.windows.net"
        },
        "https://login.chinacloudapi.cn/common/": {
            "token_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.chinacloudapi.cn/common/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo",
            "authorization_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.chinacloudapi.cn/common/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.chinacloudapi.cn/common/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "partner.microsoftonline.cn",
            "cloud_graph_host_name": "graph.chinacloudapi.cn",
            "msgraph_host": "microsoftgraph.chinacloudapi.cn",
            "rbac_url": "https://pas.chinacloudapi.cn"
        },
        "https://login.microsoftonline.us/common/": {
            "token_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.us/common/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.us/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.us/common/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.us/common/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.us",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pasff.usgovcloudapi.net"
        },
        "https://login.microsoftonline.com/consumers/": {
            "token_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.com/consumers/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.com/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.com/consumers/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.com/consumers/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.com",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pas.windows.net"
        },
        "https://login.chinacloudapi.cn/consumers/": {
            "token_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.chinacloudapi.cn/consumers/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.partner.microsoftonline.cn/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo",
            "authorization_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.chinacloudapi.cn/consumers/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "partner.microsoftonline.cn",
            "cloud_graph_host_name": "graph.chinacloudapi.cn",
            "msgraph_host": "microsoftgraph.chinacloudapi.cn",
            "rbac_url": "https://pas.chinacloudapi.cn"
        },
        "https://login.microsoftonline.us/consumers/": {
            "token_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.us/consumers/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.us/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.us/consumers/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.us/consumers/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.us",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pasff.usgovcloudapi.net"
        },
        "https://login.microsoftonline.com/organizations/": {
            "token_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.com/organizations/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.com/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.com/organizations/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.com/organizations/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.com",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pas.windows.net"
        },
        "https://login.chinacloudapi.cn/organizations/": {
            "token_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.chinacloudapi.cn/organizations/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo",
            "authorization_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.chinacloudapi.cn/organizations/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "partner.microsoftonline.cn",
            "cloud_graph_host_name": "graph.chinacloudapi.cn",
            "msgraph_host": "microsoftgraph.chinacloudapi.cn",
            "rbac_url": "https://pas.chinacloudapi.cn"
        },
        "https://login.microsoftonline.us/organizations/": {
            "token_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/token",
            "token_endpoint_auth_methods_supported": [
                "client_secret_post",
                "private_key_jwt",
                "client_secret_basic"
            ],
            "jwks_uri": "https://login.microsoftonline.us/organizations/discovery/v2.0/keys",
            "response_modes_supported": [
                "query",
                "fragment",
                "form_post"
            ],
            "subject_types_supported": [
                "pairwise"
            ],
            "id_token_signing_alg_values_supported": [
                "RS256"
            ],
            "response_types_supported": [
                "code",
                "id_token",
                "code id_token",
                "id_token token"
            ],
            "scopes_supported": [
                "openid",
                "profile",
                "email",
                "offline_access"
            ],
            "issuer": "https://login.microsoftonline.us/{tenantid}/v2.0",
            "request_uri_parameter_supported": false,
            "userinfo_endpoint": "https://graph.microsoft.com/oidc/userinfo",
            "authorization_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/authorize",
            "device_authorization_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/devicecode",
            "http_logout_supported": true,
            "frontchannel_logout_supported": true,
            "end_session_endpoint": "https://login.microsoftonline.us/organizations/oauth2/v2.0/logout",
            "claims_supported": [
                "sub",
                "iss",
                "cloud_instance_name",
                "cloud_instance_host_name",
                "cloud_graph_host_name",
                "msgraph_host",
                "aud",
                "exp",
                "iat",
                "auth_time",
                "acr",
                "nonce",
                "preferred_username",
                "name",
                "tid",
                "ver",
                "at_hash",
                "c_hash",
                "email"
            ],
            "kerberos_endpoint": "https://login.microsoftonline.us/organizations/kerberos",
            "tenant_region_scope": null,
            "cloud_instance_name": "microsoftonline.us",
            "cloud_graph_host_name": "graph.windows.net",
            "msgraph_host": "graph.microsoft.com",
            "rbac_url": "https://pasff.usgovcloudapi.net"
        }
    },
    "instanceDiscoveryMetadata": {
        "https://login.microsoftonline.com/common/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.com/common/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.chinacloudapi.cn/common/": {
            "tenant_discovery_endpoint": "https://login.chinacloudapi.cn/common/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.us/common/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.us/common/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.com/consumers/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.com/consumers/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.chinacloudapi.cn/consumers/": {
            "tenant_discovery_endpoint": "https://login.chinacloudapi.cn/consumers/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.us/consumers/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.us/consumers/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.com/organizations/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.com/organizations/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.chinacloudapi.cn/organizations/": {
            "tenant_discovery_endpoint": "https://login.chinacloudapi.cn/organizations/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        },
        "https://login.microsoftonline.us/organizations/": {
            "tenant_discovery_endpoint": "https://login.microsoftonline.us/organizations/v2.0/.well-known/openid-configuration",
            "api-version": "1.1",
            "metadata": [
                {
                    "preferred_network": "login.microsoftonline.com",
                    "preferred_cache": "login.windows.net",
                    "aliases": [
                        "login.microsoftonline.com",
                        "login.windows.net",
                        "login.microsoft.com",
                        "sts.windows.net"
                    ]
                },
                {
                    "preferred_network": "login.partner.microsoftonline.cn",
                    "preferred_cache": "login.partner.microsoftonline.cn",
                    "aliases": [
                        "login.partner.microsoftonline.cn",
                        "login.chinacloudapi.cn"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.de",
                    "preferred_cache": "login.microsoftonline.de",
                    "aliases": [
                        "login.microsoftonline.de"
                    ]
                },
                {
                    "preferred_network": "login.microsoftonline.us",
                    "preferred_cache": "login.microsoftonline.us",
                    "aliases": [
                        "login.microsoftonline.us",
                        "login.usgovcloudapi.net"
                    ]
                },
                {
                    "preferred_network": "login-us.microsoftonline.com",
                    "preferred_cache": "login-us.microsoftonline.com",
                    "aliases": [
                        "login-us.microsoftonline.com"
                    ]
                }
            ]
        }
    }
};
var $ce6e7a20b7730562$export$f612854287391207 = $ce6e7a20b7730562$export$223f43dfec89cb87.endpointMetadata;
var $ce6e7a20b7730562$export$a21acafc3b6f5582 = $ce6e7a20b7730562$export$223f43dfec89cb87.instanceDiscoveryMetadata;






/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $a6d138b0703dd7e2$export$b288ea4a1e969e42(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}


/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $d641072a563cef37$export$6716273459d383f8(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}


/*! @azure/msal-common v13.1.0 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $dbb49da8ab53d647$export$1afa9d0f261ebb47 = /** @class */ function() {
    function RegionDiscovery(networkInterface, performanceClient, correlationId) {
        this.networkInterface = networkInterface;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ RegionDiscovery.prototype.detectRegion = function(environmentRegion, regionDiscoveryMetadata) {
        var _a, _b, _c, _d;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var autodetectedRegionName, options, localIMDSVersionResponse, currentIMDSVersion, currentIMDSVersionResponse;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
                        autodetectedRegionName = environmentRegion;
                        if (!!autodetectedRegionName) return [
                            3 /*break*/ ,
                            8
                        ];
                        options = RegionDiscovery.IMDS_OPTIONS;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getRegionFromIMDS((0, $1b76d687a319d9ed$export$a002182e51710d39).IMDS_VERSION, options)
                        ];
                    case 2:
                        localIMDSVersionResponse = _e.sent();
                        if (localIMDSVersionResponse.status === (0, $1b76d687a319d9ed$export$20ba0879771a17be).httpSuccess) {
                            autodetectedRegionName = localIMDSVersionResponse.body;
                            regionDiscoveryMetadata.region_source = (0, $1b76d687a319d9ed$export$3d4a3e11df589b40).IMDS;
                        }
                        if (!(localIMDSVersionResponse.status === (0, $1b76d687a319d9ed$export$20ba0879771a17be).httpBadRequest)) return [
                            3 /*break*/ ,
                            5
                        ];
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getCurrentVersion(options)
                        ];
                    case 3:
                        currentIMDSVersion = _e.sent();
                        if (!currentIMDSVersion) {
                            regionDiscoveryMetadata.region_source = (0, $1b76d687a319d9ed$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        (_d = this.performanceClient) === null || _d === void 0 || _d.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getRegionFromIMDS(currentIMDSVersion, options)
                        ];
                    case 4:
                        currentIMDSVersionResponse = _e.sent();
                        if (currentIMDSVersionResponse.status === (0, $1b76d687a319d9ed$export$20ba0879771a17be).httpSuccess) {
                            autodetectedRegionName = currentIMDSVersionResponse.body;
                            regionDiscoveryMetadata.region_source = (0, $1b76d687a319d9ed$export$3d4a3e11df589b40).IMDS;
                        }
                        _e.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        _e.sent();
                        regionDiscoveryMetadata.region_source = (0, $1b76d687a319d9ed$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        regionDiscoveryMetadata.region_source = (0, $1b76d687a319d9ed$export$3d4a3e11df589b40).ENVIRONMENT_VARIABLE;
                        _e.label = 9;
                    case 9:
                        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
                        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $1b76d687a319d9ed$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return [
                            2 /*return*/ ,
                            autodetectedRegionName || null
                        ];
                }
            });
        });
    };
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */ RegionDiscovery.prototype.getRegionFromIMDS = function(version, options) {
        var _a;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_b) {
                (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
                return [
                    2 /*return*/ ,
                    this.networkInterface.sendGetRequestAsync((0, $1b76d687a319d9ed$export$a002182e51710d39).IMDS_ENDPOINT + "?api-version=" + version + "&format=text", options, (0, $1b76d687a319d9ed$export$a002182e51710d39).IMDS_TIMEOUT)
                ];
            });
        });
    };
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ RegionDiscovery.prototype.getCurrentVersion = function(options) {
        var _a;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var response;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.networkInterface.sendGetRequestAsync((0, $1b76d687a319d9ed$export$a002182e51710d39).IMDS_ENDPOINT + "?format=json", options)
                        ];
                    case 2:
                        response = _b.sent();
                        // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
                        if (response.status === (0, $1b76d687a319d9ed$export$20ba0879771a17be).httpBadRequest && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return [
                            2 /*return*/ ,
                            response.body["newest-versions"][0]
                        ];
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 3:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Options for the IMDS endpoint request
    RegionDiscovery.IMDS_OPTIONS = {
        headers: {
            Metadata: "true"
        }
    };
    return RegionDiscovery;
}();




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 */ var $08caa87d494f4ccf$export$f1c6ec2e6d68c49c = /** @class */ function() {
    function Authority(authority, networkInterface, cacheManager, authorityOptions, logger, performanceClient, correlationId) {
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.regionDiscovery = new (0, $dbb49da8ab53d647$export$1afa9d0f261ebb47)(networkInterface, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType}
     * @param authorityUri {@link IUri}
     * @private
     */ Authority.prototype.getAuthorityType = function(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, $1b76d687a319d9ed$export$a002182e51710d39).CIAM_AUTH_URL)) return (0, $26d2ec0e655e729b$export$cd82032b224a3839).Ciam;
        var pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case (0, $1b76d687a319d9ed$export$a002182e51710d39).ADFS:
                return (0, $26d2ec0e655e729b$export$cd82032b224a3839).Adfs;
            case (0, $1b76d687a319d9ed$export$a002182e51710d39).DSTS:
                return (0, $26d2ec0e655e729b$export$cd82032b224a3839).Dsts;
        }
        return (0, $26d2ec0e655e729b$export$cd82032b224a3839).Default;
    };
    Object.defineProperty(Authority.prototype, "authorityType", {
        // See above for AuthorityType
        get: function() {
            return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "protocolMode", {
        /**
         * ProtocolMode enum representing the way endpoints are constructed.
         */ get: function() {
            return this.authorityOptions.protocolMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "options", {
        /**
         * Returns authorityOptions which can be used to reinstantiate a new authority instance
         */ get: function() {
            return this.authorityOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "canonicalAuthority", {
        /**
         * A URL that is the authority set by the developer
         */ get: function() {
            return this._canonicalAuthority.urlString;
        },
        /**
         * Sets canonical authority.
         */ set: function(url) {
            this._canonicalAuthority = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(url);
            this._canonicalAuthority.validateAsUri();
            this._canonicalAuthorityUrlComponents = null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "canonicalAuthorityUrlComponents", {
        /**
         * Get authority components.
         */ get: function() {
            if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
            return this._canonicalAuthorityUrlComponents;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "hostnameAndPort", {
        /**
         * Get hostname and port i.e. login.microsoftonline.com
         */ get: function() {
            return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "tenant", {
        /**
         * Get tenant for authority.
         */ get: function() {
            return this.canonicalAuthorityUrlComponents.PathSegments[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "authorizationEndpoint", {
        /**
         * OAuth /authorize endpoint for requests
         */ get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
            else throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "tokenEndpoint", {
        /**
         * OAuth /token endpoint for requests
         */ get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
            else throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "deviceCodeEndpoint", {
        get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
            else throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "endSessionEndpoint", {
        /**
         * OAuth logout endpoint for requests
         */ get: function() {
            if (this.discoveryComplete()) {
                // ROPC policies may not have end_session_endpoint set
                if (!this.metadata.end_session_endpoint) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createLogoutNotSupportedError();
                return this.replacePath(this.metadata.end_session_endpoint);
            } else throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "selfSignedJwtAudience", {
        /**
         * OAuth issuer for requests
         */ get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
            else throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Authority.prototype, "jwksUri", {
        /**
         * Jwks_uri for token signing keys
         */ get: function() {
            if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
            else throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ Authority.prototype.canReplaceTenant = function(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !Authority.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, $26d2ec0e655e729b$export$cd82032b224a3839).Default && this.protocolMode === (0, $814799ffd517c6ae$export$73a3e3dedd37150d).AAD;
    };
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ Authority.prototype.replaceTenant = function(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    };
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ Authority.prototype.replacePath = function(urlString) {
        var _this = this;
        var endpoint = urlString;
        var cachedAuthorityUrl = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(this.metadata.canonical_authority);
        var cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        var cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        var currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach(function(currentPart, index) {
            var cachedPart = cachedAuthorityParts[index];
            if (index === 0 && _this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                var tenantId = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(_this.metadata.authorization_endpoint).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    _this.logger.verbose("Replacing tenant domain name " + cachedPart + " with id " + tenantId);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace("/" + cachedPart + "/", "/" + currentPart + "/");
        });
        return this.replaceTenant(endpoint);
    };
    Object.defineProperty(Authority.prototype, "defaultOpenIdConfigurationEndpoint", {
        /**
         * The default open id configuration endpoint for any canonical authority.
         */ get: function() {
            if (this.authorityType === (0, $26d2ec0e655e729b$export$cd82032b224a3839).Adfs || this.authorityType === (0, $26d2ec0e655e729b$export$cd82032b224a3839).Dsts || this.protocolMode === (0, $814799ffd517c6ae$export$73a3e3dedd37150d).OIDC) return this.canonicalAuthority + ".well-known/openid-configuration";
            return this.canonicalAuthority + "v2.0/.well-known/openid-configuration";
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Boolean that returns whethr or not tenant discovery has been completed.
     */ Authority.prototype.discoveryComplete = function() {
        return !!this.metadata;
    };
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ Authority.prototype.resolveEndpointsAsync = function() {
        var _a, _b, _c;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var metadataEntity, cloudDiscoverySource, endpointSource, cacheKey;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, this.correlationId);
                        metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
                        if (!metadataEntity) {
                            metadataEntity = new (0, $cfca0354626cc9b4$export$49e7dcb371a5f08e)();
                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
                        }
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateCloudDiscoveryMetadata(metadataEntity)
                        ];
                    case 1:
                        cloudDiscoverySource = _d.sent();
                        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateEndpointMetadata(metadataEntity)
                        ];
                    case 2:
                        endpointSource = _d.sent();
                        if (cloudDiscoverySource !== (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).CACHE && endpointSource !== (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).CACHE) {
                            // Reset the expiration time unless both values came from a successful cache lookup
                            metadataEntity.resetExpiresAt();
                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
                        }
                        cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
                        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
                        this.metadata = metadataEntity;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ Authority.prototype.updateEndpointMetadata = function(metadataEntity) {
        var _a, _b, _c, _d, _e, _f;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var metadata, harcodedMetadata;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
                        metadata = this.getEndpointMetadataFromConfig();
                        if (metadata) {
                            metadataEntity.updateEndpointMetadata(metadata, false);
                            return [
                                2 /*return*/ ,
                                (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).CONFIG
                            ];
                        }
                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntity.isExpired()) // No need to update
                        return [
                            2 /*return*/ ,
                            (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).CACHE
                        ];
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getEndpointMetadataFromNetwork()
                        ];
                    case 1:
                        metadata = _g.sent();
                        if (!metadata) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!((_c = this.authorityOptions.azureRegionConfiguration) === null || _c === void 0 ? void 0 : _c.azureRegion)) return [
                            3 /*break*/ ,
                            3
                        ];
                        (_d = this.performanceClient) === null || _d === void 0 || _d.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateMetadataWithRegionalInformation(metadata)
                        ];
                    case 2:
                        metadata = _g.sent();
                        _g.label = 3;
                    case 3:
                        metadataEntity.updateEndpointMetadata(metadata, true);
                        return [
                            2 /*return*/ ,
                            (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).NETWORK
                        ];
                    case 4:
                        harcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
                        if (!(harcodedMetadata && !this.authorityOptions.skipAuthorityMetadataCache)) return [
                            3 /*break*/ ,
                            7
                        ];
                        if (!((_e = this.authorityOptions.azureRegionConfiguration) === null || _e === void 0 ? void 0 : _e.azureRegion)) return [
                            3 /*break*/ ,
                            6
                        ];
                        (_f = this.performanceClient) === null || _f === void 0 || _f.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateMetadataWithRegionalInformation(harcodedMetadata)
                        ];
                    case 5:
                        harcodedMetadata = _g.sent();
                        _g.label = 6;
                    case 6:
                        metadataEntity.updateEndpointMetadata(harcodedMetadata, false);
                        return [
                            2 /*return*/ ,
                            (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).HARDCODED_VALUES
                        ];
                    case 7:
                        throw (0, $30cd164be78785f3$export$a839ff85a7957561).createUnableToGetOpenidConfigError(this.defaultOpenIdConfigurationEndpoint);
                }
            });
        });
    };
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ Authority.prototype.isAuthoritySameType = function(metadataEntity) {
        var cachedAuthorityUrl = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(metadataEntity.canonical_authority);
        var cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    };
    /**
     * Parse authorityMetadata config option
     */ Authority.prototype.getEndpointMetadataFromConfig = function() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createInvalidAuthorityMetadataError();
        }
        return null;
    };
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ Authority.prototype.getEndpointMetadataFromNetwork = function() {
        var _a;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var options, response;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
                        options = {};
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.networkInterface.sendGetRequestAsync(this.defaultOpenIdConfigurationEndpoint, options)
                        ];
                    case 2:
                        response = _b.sent();
                        return [
                            2 /*return*/ ,
                            (0, $bb51a26afa6348ef$export$aab44dc88900a3b)(response.body) ? response.body : null
                        ];
                    case 3:
                        _b.sent();
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Get OAuth endpoints for common authorities.
     */ Authority.prototype.getEndpointMetadataFromHardcodedValues = function() {
        if (this.canonicalAuthority in (0, $ce6e7a20b7730562$export$f612854287391207)) return (0, $ce6e7a20b7730562$export$f612854287391207)[this.canonicalAuthority];
        return null;
    };
    /**
     * Update the retrieved metadata with regional information.
     */ Authority.prototype.updateMetadataWithRegionalInformation = function(metadata) {
        var _a, _b, _c, _d, _e, _f, _g;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var autodetectedRegionName, azureRegion;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.regionDiscovery.detectRegion((_c = this.authorityOptions.azureRegionConfiguration) === null || _c === void 0 ? void 0 : _c.environmentRegion, this.regionDiscoveryMetadata)
                        ];
                    case 1:
                        autodetectedRegionName = _h.sent();
                        azureRegion = ((_d = this.authorityOptions.azureRegionConfiguration) === null || _d === void 0 ? void 0 : _d.azureRegion) === (0, $1b76d687a319d9ed$export$a002182e51710d39).AZURE_REGION_AUTO_DISCOVER_FLAG ? autodetectedRegionName : (_e = this.authorityOptions.azureRegionConfiguration) === null || _e === void 0 ? void 0 : _e.azureRegion;
                        if (((_f = this.authorityOptions.azureRegionConfiguration) === null || _f === void 0 ? void 0 : _f.azureRegion) === (0, $1b76d687a319d9ed$export$a002182e51710d39).AZURE_REGION_AUTO_DISCOVER_FLAG) this.regionDiscoveryMetadata.region_outcome = autodetectedRegionName ? (0, $1b76d687a319d9ed$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_SUCCESSFUL : (0, $1b76d687a319d9ed$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_FAILED;
                        else if (autodetectedRegionName) this.regionDiscoveryMetadata.region_outcome = ((_g = this.authorityOptions.azureRegionConfiguration) === null || _g === void 0 ? void 0 : _g.azureRegion) === autodetectedRegionName ? (0, $1b76d687a319d9ed$export$92a685f9218422bd).CONFIGURED_MATCHES_DETECTED : (0, $1b76d687a319d9ed$export$92a685f9218422bd).CONFIGURED_NOT_DETECTED;
                        else this.regionDiscoveryMetadata.region_outcome = (0, $1b76d687a319d9ed$export$92a685f9218422bd).CONFIGURED_NO_AUTO_DETECTION;
                        if (azureRegion) {
                            this.regionDiscoveryMetadata.region_used = azureRegion;
                            return [
                                2 /*return*/ ,
                                Authority.replaceWithRegionalInformation(metadata, azureRegion)
                            ];
                        }
                        return [
                            2 /*return*/ ,
                            metadata
                        ];
                }
            });
        });
    };
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ Authority.prototype.updateCloudDiscoveryMetadata = function(metadataEntity) {
        var _a, _b;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var metadata, metadataEntityExpired, harcodedMetadata;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
                        // attempt to read metadata from the config
                        this.logger.verbose("Attempting to get cloud discovery metadata in the config");
                        this.logger.verbosePii("Known Authorities: " + (this.authorityOptions.knownAuthorities || (0, $1b76d687a319d9ed$export$a002182e51710d39).NOT_APPLICABLE));
                        this.logger.verbosePii("Authority Metadata: " + (this.authorityOptions.authorityMetadata || (0, $1b76d687a319d9ed$export$a002182e51710d39).NOT_APPLICABLE));
                        this.logger.verbosePii("Canonical Authority: " + (metadataEntity.canonical_authority || (0, $1b76d687a319d9ed$export$a002182e51710d39).NOT_APPLICABLE));
                        metadata = this.getCloudDiscoveryMetadataFromConfig();
                        if (metadata) {
                            this.logger.verbose("Found cloud discovery metadata in the config.");
                            metadataEntity.updateCloudDiscoveryMetadata(metadata, false);
                            return [
                                2 /*return*/ ,
                                (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).CONFIG
                            ];
                        }
                        // If the cached metadata came from config but that config was not passed to this instance, we must go to the network
                        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the cache.");
                        metadataEntityExpired = metadataEntity.isExpired();
                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
                            this.logger.verbose("Found metadata in the cache.");
                            // No need to update
                            return [
                                2 /*return*/ ,
                                (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).CACHE
                            ];
                        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
                        this.logger.verbose("Did not find cloud discovery metadata in the cache... Attempting to get cloud discovery metadata from the network.");
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getCloudDiscoveryMetadataFromNetwork()
                        ];
                    case 1:
                        metadata = _c.sent();
                        if (metadata) {
                            this.logger.verbose("cloud discovery metadata was successfully returned from getCloudDiscoveryMetadataFromNetwork()");
                            metadataEntity.updateCloudDiscoveryMetadata(metadata, true);
                            return [
                                2 /*return*/ ,
                                (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).NETWORK
                            ];
                        }
                        this.logger.verbose("Did not find cloud discovery metadata from the network... Attempting to get cloud discovery metadata from hardcoded values.");
                        harcodedMetadata = this.getCloudDiscoveryMetadataFromHarcodedValues();
                        if (harcodedMetadata && !this.options.skipAuthorityMetadataCache) {
                            this.logger.verbose("Found cloud discovery metadata from hardcoded values.");
                            metadataEntity.updateCloudDiscoveryMetadata(harcodedMetadata, false);
                            return [
                                2 /*return*/ ,
                                (0, $1b76d687a319d9ed$export$5d365d77acfcb55d).HARDCODED_VALUES
                            ];
                        }
                        // Metadata could not be obtained from the config, cache, network or hardcoded values
                        this.logger.error("Did not find cloud discovery metadata from hardcoded values... Metadata could not be obtained from config, cache, network or hardcoded values. Throwing Untrusted Authority Error.");
                        throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createUntrustedAuthorityError();
                }
            });
        });
    };
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ Authority.prototype.getCloudDiscoveryMetadataFromConfig = function() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, $26d2ec0e655e729b$export$cd82032b224a3839).Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.");
            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.");
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.");
                var parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                var metadata = Authority.getCloudDiscoveryMetadataFromNetworkResponse(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.");
                    return metadata;
                } else this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.");
            } catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.");
                throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createInvalidCloudDiscoveryMetadataError();
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.");
            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    };
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ Authority.prototype.getCloudDiscoveryMetadataFromNetwork = function() {
        var _a;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var instanceDiscoveryEndpoint, options, match, response, typedResponseBody, metadata, error_1, typedError;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
                        instanceDiscoveryEndpoint = "" + (0, $1b76d687a319d9ed$export$a002182e51710d39).AAD_INSTANCE_DISCOVERY_ENDPT + this.canonicalAuthority + "oauth2/v2.0/authorize";
                        options = {};
                        match = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options)
                        ];
                    case 2:
                        response = _b.sent();
                        typedResponseBody = void 0;
                        metadata = void 0;
                        if ((0, $a6d138b0703dd7e2$export$b288ea4a1e969e42)(response.body)) {
                            typedResponseBody = response.body;
                            metadata = typedResponseBody.metadata;
                            this.logger.verbosePii("tenant_discovery_endpoint is: " + typedResponseBody.tenant_discovery_endpoint);
                        } else if ((0, $d641072a563cef37$export$6716273459d383f8)(response.body)) {
                            this.logger.warning("A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: " + response.status);
                            typedResponseBody = response.body;
                            if (typedResponseBody.error === (0, $1b76d687a319d9ed$export$a002182e51710d39).INVALID_INSTANCE) {
                                this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.");
                                return [
                                    2 /*return*/ ,
                                    null
                                ];
                            }
                            this.logger.warning("The CloudInstanceDiscoveryErrorResponse error is " + typedResponseBody.error);
                            this.logger.warning("The CloudInstanceDiscoveryErrorResponse error description is " + typedResponseBody.error_description);
                            this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network) to []");
                            metadata = [];
                        } else {
                            this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse");
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.");
                        match = Authority.getCloudDiscoveryMetadataFromNetworkResponse(metadata, this.hostnameAndPort);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_1 = _b.sent();
                        if (error_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) this.logger.error("There was a network error while attempting to get the cloud discovery instance metadata.\nError: " + error_1.errorCode + "\nError Description: " + error_1.errorMessage);
                        else {
                            typedError = error_1;
                            this.logger.error("A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: " + typedError.name + "\nError Description: " + typedError.message);
                        }
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 4:
                        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
                        if (!match) {
                            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.");
                            this.logger.verbose("Creating custom Authority for custom domain scenario.");
                            match = Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
                        }
                        return [
                            2 /*return*/ ,
                            match
                        ];
                }
            });
        });
    };
    /**
     * Get cloud discovery metadata for common authorities
     */ Authority.prototype.getCloudDiscoveryMetadataFromHarcodedValues = function() {
        if (this.canonicalAuthority in (0, $ce6e7a20b7730562$export$a21acafc3b6f5582)) return (0, $ce6e7a20b7730562$export$a21acafc3b6f5582)[this.canonicalAuthority];
        return null;
    };
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */ Authority.prototype.isInKnownAuthorities = function() {
        var _this = this;
        var matches = this.authorityOptions.knownAuthorities.filter(function(authority) {
            return (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getDomainFromUrl(authority).toLowerCase() === _this.hostnameAndPort;
        });
        return matches.length > 0;
    };
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ Authority.generateAuthority = function(authorityString, azureCloudOptions) {
        var authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, $d3f66d4e6c82e919$export$4cda21933050d9ec).None) {
            var tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, $1b76d687a319d9ed$export$a002182e51710d39).DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = azureCloudOptions.azureCloudInstance + "/" + tenant + "/";
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    };
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ Authority.createCloudDiscoveryMetadataFromHost = function(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    };
    /**
     * Searches instance discovery network response for the entry that contains the host in the aliases list
     * @param response
     * @param authority
     */ Authority.getCloudDiscoveryMetadataFromNetworkResponse = function(response, authority) {
        for(var i = 0; i < response.length; i++){
            var metadata = response[i];
            if (metadata.aliases.indexOf(authority) > -1) return metadata;
        }
        return null;
    };
    /**
     * helper function to generate environment from authority object
     */ Authority.prototype.getPreferredCache = function() {
        if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Discovery incomplete.");
    };
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ Authority.prototype.isAlias = function(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    };
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ Authority.isPublicCloudAuthority = function(host) {
        return (0, $1b76d687a319d9ed$export$a002182e51710d39).KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    };
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ Authority.buildRegionalAuthorityString = function(host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        var authorityUrlInstance = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(host);
        authorityUrlInstance.validateAsUri();
        var authorityUrlParts = authorityUrlInstance.getUrlComponents();
        var hostNameAndPort = region + "." + authorityUrlParts.HostNameAndPort;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = region + "." + (0, $1b76d687a319d9ed$export$a002182e51710d39).REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX;
        // Include the query string portion of the url
        var url = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).constructAuthorityUriFromObject((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, authorityUrlInstance.getUrlComponents()), {
            HostNameAndPort: hostNameAndPort
        })).urlString;
        // Add the query string if a query string was provided
        if (queryString) return url + "?" + queryString;
        return url;
    };
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ Authority.replaceWithRegionalInformation = function(metadata, azureRegion) {
        metadata.authorization_endpoint = Authority.buildRegionalAuthorityString(metadata.authorization_endpoint, azureRegion);
        // TODO: Enquire on whether we should leave the query string or remove it before releasing the feature
        metadata.token_endpoint = Authority.buildRegionalAuthorityString(metadata.token_endpoint, azureRegion, (0, $1b76d687a319d9ed$export$a002182e51710d39).REGIONAL_AUTH_NON_MSI_QUERY_STRING);
        if (metadata.end_session_endpoint) metadata.end_session_endpoint = Authority.buildRegionalAuthorityString(metadata.end_session_endpoint, azureRegion);
        return metadata;
    };
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ Authority.transformCIAMAuthority = function(authority) {
        var ciamAuthority = authority.endsWith((0, $1b76d687a319d9ed$export$a002182e51710d39).FORWARD_SLASH) ? authority : "" + authority + (0, $1b76d687a319d9ed$export$a002182e51710d39).FORWARD_SLASH;
        var authorityUrl = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(authority);
        var authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, $1b76d687a319d9ed$export$a002182e51710d39).CIAM_AUTH_URL)) {
            var tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = "" + ciamAuthority + tenantIdOrDomain + (0, $1b76d687a319d9ed$export$a002182e51710d39).AAD_TENANT_DOMAIN_SUFFIX;
        }
        return ciamAuthority;
    };
    // Reserved tenant domain names that will not be replaced with tenant id
    Authority.reservedTenantDomains = new Set([
        "{tenant}",
        "{tenantid}",
        (0, $1b76d687a319d9ed$export$e18ac120172ed505).COMMON,
        (0, $1b76d687a319d9ed$export$e18ac120172ed505).CONSUMERS,
        (0, $1b76d687a319d9ed$export$e18ac120172ed505).ORGANIZATIONS
    ]);
    return Authority;
}();

/*! @azure/msal-common v13.1.0 2023-06-07 */ 





"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $188344d4eb4caccf$export$4b476259e3402a97 = /** @class */ function() {
    function AuthorityFactory() {}
    /**
     * Create an authority object of the correct type based on the url
     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
     *
     * Also performs endpoint discovery.
     *
     * @param authorityUri
     * @param networkClient
     * @param protocolMode
     */ AuthorityFactory.createDiscoveredInstance = function(authorityUri, networkClient, cacheManager, authorityOptions, logger, performanceClient, correlationId) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authorityUriFinal, acquireTokenAuthority, e_1;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        performanceClient === null || performanceClient === void 0 || performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, correlationId);
                        authorityUriFinal = (0, $08caa87d494f4ccf$export$f1c6ec2e6d68c49c).transformCIAMAuthority(authorityUri);
                        acquireTokenAuthority = AuthorityFactory.createInstance(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, performanceClient, correlationId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        performanceClient === null || performanceClient === void 0 || performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, correlationId);
                        return [
                            4 /*yield*/ ,
                            acquireTokenAuthority.resolveEndpointsAsync()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            acquireTokenAuthority
                        ];
                    case 3:
                        e_1 = _a.sent();
                        throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError(e_1);
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Create an authority object of the correct type based on the url
     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
     *
     * Does not perform endpoint discovery.
     *
     * @param authorityUrl
     * @param networkInterface
     * @param protocolMode
     */ AuthorityFactory.createInstance = function(authorityUrl, networkInterface, cacheManager, authorityOptions, logger, performanceClient, correlationId) {
        // Throw error if authority url is empty
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(authorityUrl)) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createUrlEmptyError();
        return new (0, $08caa87d494f4ccf$export$f1c6ec2e6d68c49c)(authorityUrl, networkInterface, cacheManager, authorityOptions, logger, performanceClient, correlationId);
    };
    return AuthorityFactory;
}();

/*! @azure/msal-common v13.1.0 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ 

/*! @azure/msal-common v13.1.0 2023-06-07 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $6227cb553f9f2db5$export$c69de3e7a1e69077 = /** @class */ function() {
    function NetworkManager(networkClient, cacheManager) {
        this.networkClient = networkClient;
        this.cacheManager = cacheManager;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint
     * @param tokenEndpoint
     * @param options
     */ NetworkManager.prototype.sendPostRequest = function(thumbprint, tokenEndpoint, options) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var response, e_1;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $c78f3ba4540ca0dd$export$c060a619741dd765).preProcess(this.cacheManager, thumbprint);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.networkClient.sendPostRequestAsync(tokenEndpoint, options)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) throw e_1;
                        else throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNetworkError(tokenEndpoint, e_1);
                    case 4:
                        (0, $c78f3ba4540ca0dd$export$c060a619741dd765).postProcess(this.cacheManager, thumbprint, response);
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    return NetworkManager;
}();








/*! @azure/msal-common v13.1.0 2023-06-07 */ 



/*! @azure/msal-common v13.1.0 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Validates server consumable params from the "request" objects
 */ var $2742c18af4f8d62d$export$9800b929b6984365 = /** @class */ function() {
    function RequestValidator() {}
    /**
     * Utility to check if the `redirectUri` in the request is a non-null value
     * @param redirectUri
     */ RequestValidator.validateRedirectUri = function(redirectUri) {
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(redirectUri)) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createRedirectUriEmptyError();
    };
    /**
     * Utility to validate prompt sent by the user in the request
     * @param prompt
     */ RequestValidator.validatePrompt = function(prompt) {
        var promptValues = [];
        for(var value in 0, $1b76d687a319d9ed$export$49a06cbda5acaa5)promptValues.push((0, $1b76d687a319d9ed$export$49a06cbda5acaa5)[value]);
        if (promptValues.indexOf(prompt) < 0) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createInvalidPromptError(prompt);
    };
    RequestValidator.validateClaims = function(claims) {
        try {
            JSON.parse(claims);
        } catch (e) {
            throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createInvalidClaimsRequestError();
        }
    };
    /**
     * Utility to validate code_challenge and code_challenge_method
     * @param codeChallenge
     * @param codeChallengeMethod
     */ RequestValidator.validateCodeChallengeParams = function(codeChallenge, codeChallengeMethod) {
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(codeChallenge) || (0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(codeChallengeMethod)) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createInvalidCodeChallengeParamsError();
        else this.validateCodeChallengeMethod(codeChallengeMethod);
    };
    /**
     * Utility to validate code_challenge_method
     * @param codeChallengeMethod
     */ RequestValidator.validateCodeChallengeMethod = function(codeChallengeMethod) {
        if ([
            (0, $1b76d687a319d9ed$export$a1fe36237c1cc863).PLAIN,
            (0, $1b76d687a319d9ed$export$a1fe36237c1cc863).S256
        ].indexOf(codeChallengeMethod) < 0) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createInvalidCodeChallengeMethodError();
    };
    /**
     * Removes unnecessary, duplicate, and empty string query parameters from extraQueryParameters
     * @param request
     */ RequestValidator.sanitizeEQParams = function(eQParams, queryParams) {
        if (!eQParams) return {};
        // Remove any query parameters already included in SSO params
        queryParams.forEach(function(value, key) {
            if (eQParams[key]) delete eQParams[key];
        });
        // remove empty string parameters
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return Object.fromEntries(Object.entries(eQParams).filter(function(_a) {
            var value = _a[1];
            return value !== "";
        }));
    };
    return RequestValidator;
}();



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $310de39a31effb4f$export$882078dd8a9e0bfa = /** @class */ function() {
    function RequestParameterBuilder() {
        this.parameters = new Map();
    }
    /**
     * add response_type = code
     */ RequestParameterBuilder.prototype.addResponseTypeCode = function() {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).RESPONSE_TYPE, encodeURIComponent((0, $1b76d687a319d9ed$export$a002182e51710d39).CODE_RESPONSE_TYPE));
    };
    /**
     * add response_type = token id_token
     */ RequestParameterBuilder.prototype.addResponseTypeForTokenAndIdToken = function() {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).RESPONSE_TYPE, encodeURIComponent((0, $1b76d687a319d9ed$export$a002182e51710d39).TOKEN_RESPONSE_TYPE + " " + (0, $1b76d687a319d9ed$export$a002182e51710d39).ID_TOKEN_RESPONSE_TYPE));
    };
    /**
     * add response_mode. defaults to query.
     * @param responseMode
     */ RequestParameterBuilder.prototype.addResponseMode = function(responseMode) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).RESPONSE_MODE, encodeURIComponent(responseMode ? responseMode : (0, $1b76d687a319d9ed$export$f990a5bae1260b8c).QUERY));
    };
    /**
     * Add flag to indicate STS should attempt to use WAM if available
     */ RequestParameterBuilder.prototype.addNativeBroker = function() {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).NATIVE_BROKER, encodeURIComponent("1"));
    };
    /**
     * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
     * @param scopeSet
     * @param addOidcScopes
     */ RequestParameterBuilder.prototype.addScopes = function(scopes, addOidcScopes) {
        if (addOidcScopes === void 0) addOidcScopes = true;
        var requestScopes = addOidcScopes ? (0, $35bd2ff9e18a8648$export$6388937ca91ccae8)(scopes || [], (0, $1b76d687a319d9ed$export$893b1b5b686d84ef)) : scopes || [];
        var scopeSet = new (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99)(requestScopes);
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).SCOPE, encodeURIComponent(scopeSet.printScopes()));
    };
    /**
     * add clientId
     * @param clientId
     */ RequestParameterBuilder.prototype.addClientId = function(clientId) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CLIENT_ID, encodeURIComponent(clientId));
    };
    /**
     * add redirect_uri
     * @param redirectUri
     */ RequestParameterBuilder.prototype.addRedirectUri = function(redirectUri) {
        (0, $2742c18af4f8d62d$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).REDIRECT_URI, encodeURIComponent(redirectUri));
    };
    /**
     * add post logout redirectUri
     * @param redirectUri
     */ RequestParameterBuilder.prototype.addPostLogoutRedirectUri = function(redirectUri) {
        (0, $2742c18af4f8d62d$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).POST_LOGOUT_URI, encodeURIComponent(redirectUri));
    };
    /**
     * add id_token_hint to logout request
     * @param idTokenHint
     */ RequestParameterBuilder.prototype.addIdTokenHint = function(idTokenHint) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).ID_TOKEN_HINT, encodeURIComponent(idTokenHint));
    };
    /**
     * add domain_hint
     * @param domainHint
     */ RequestParameterBuilder.prototype.addDomainHint = function(domainHint) {
        this.parameters.set((0, $1b76d687a319d9ed$export$7f68224783b2bd08).DOMAIN_HINT, encodeURIComponent(domainHint));
    };
    /**
     * add login_hint
     * @param loginHint
     */ RequestParameterBuilder.prototype.addLoginHint = function(loginHint) {
        this.parameters.set((0, $1b76d687a319d9ed$export$7f68224783b2bd08).LOGIN_HINT, encodeURIComponent(loginHint));
    };
    /**
     * Adds the CCS (Cache Credential Service) query parameter for login_hint
     * @param loginHint
     */ RequestParameterBuilder.prototype.addCcsUpn = function(loginHint) {
        this.parameters.set((0, $1b76d687a319d9ed$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent("UPN:" + loginHint));
    };
    /**
     * Adds the CCS (Cache Credential Service) query parameter for account object
     * @param loginHint
     */ RequestParameterBuilder.prototype.addCcsOid = function(clientInfo) {
        this.parameters.set((0, $1b76d687a319d9ed$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent("Oid:" + clientInfo.uid + "@" + clientInfo.utid));
    };
    /**
     * add sid
     * @param sid
     */ RequestParameterBuilder.prototype.addSid = function(sid) {
        this.parameters.set((0, $1b76d687a319d9ed$export$7f68224783b2bd08).SID, encodeURIComponent(sid));
    };
    /**
     * add claims
     * @param claims
     */ RequestParameterBuilder.prototype.addClaims = function(claims, clientCapabilities) {
        var mergedClaims = this.addClientCapabilitiesToClaims(claims, clientCapabilities);
        (0, $2742c18af4f8d62d$export$9800b929b6984365).validateClaims(mergedClaims);
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CLAIMS, encodeURIComponent(mergedClaims));
    };
    /**
     * add correlationId
     * @param correlationId
     */ RequestParameterBuilder.prototype.addCorrelationId = function(correlationId) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CLIENT_REQUEST_ID, encodeURIComponent(correlationId));
    };
    /**
     * add library info query params
     * @param libraryInfo
     */ RequestParameterBuilder.prototype.addLibraryInfo = function(libraryInfo) {
        // Telemetry Info
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).X_CLIENT_SKU, libraryInfo.sku);
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).X_CLIENT_VER, libraryInfo.version);
        if (libraryInfo.os) this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).X_CLIENT_OS, libraryInfo.os);
        if (libraryInfo.cpu) this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).X_CLIENT_CPU, libraryInfo.cpu);
    };
    /**
     * Add client telemetry parameters
     * @param appTelemetry
     */ RequestParameterBuilder.prototype.addApplicationTelemetry = function(appTelemetry) {
        if (appTelemetry === null || appTelemetry === void 0 ? void 0 : appTelemetry.appName) this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).X_APP_NAME, appTelemetry.appName);
        if (appTelemetry === null || appTelemetry === void 0 ? void 0 : appTelemetry.appVersion) this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).X_APP_VER, appTelemetry.appVersion);
    };
    /**
     * add prompt
     * @param prompt
     */ RequestParameterBuilder.prototype.addPrompt = function(prompt) {
        (0, $2742c18af4f8d62d$export$9800b929b6984365).validatePrompt(prompt);
        this.parameters.set("" + (0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).PROMPT, encodeURIComponent(prompt));
    };
    /**
     * add state
     * @param state
     */ RequestParameterBuilder.prototype.addState = function(state) {
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(state)) this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).STATE, encodeURIComponent(state));
    };
    /**
     * add nonce
     * @param nonce
     */ RequestParameterBuilder.prototype.addNonce = function(nonce) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).NONCE, encodeURIComponent(nonce));
    };
    /**
     * add code_challenge and code_challenge_method
     * - throw if either of them are not passed
     * @param codeChallenge
     * @param codeChallengeMethod
     */ RequestParameterBuilder.prototype.addCodeChallengeParams = function(codeChallenge, codeChallengeMethod) {
        (0, $2742c18af4f8d62d$export$9800b929b6984365).validateCodeChallengeParams(codeChallenge, codeChallengeMethod);
        if (codeChallenge && codeChallengeMethod) {
            this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CODE_CHALLENGE, encodeURIComponent(codeChallenge));
            this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CODE_CHALLENGE_METHOD, encodeURIComponent(codeChallengeMethod));
        } else throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createInvalidCodeChallengeParamsError();
    };
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ RequestParameterBuilder.prototype.addAuthorizationCode = function(code) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CODE, encodeURIComponent(code));
    };
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ RequestParameterBuilder.prototype.addDeviceCode = function(code) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).DEVICE_CODE, encodeURIComponent(code));
    };
    /**
     * add the `refreshToken` passed by the user
     * @param refreshToken
     */ RequestParameterBuilder.prototype.addRefreshToken = function(refreshToken) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).REFRESH_TOKEN, encodeURIComponent(refreshToken));
    };
    /**
     * add the `code_verifier` passed by the user to exchange for a token
     * @param codeVerifier
     */ RequestParameterBuilder.prototype.addCodeVerifier = function(codeVerifier) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CODE_VERIFIER, encodeURIComponent(codeVerifier));
    };
    /**
     * add client_secret
     * @param clientSecret
     */ RequestParameterBuilder.prototype.addClientSecret = function(clientSecret) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CLIENT_SECRET, encodeURIComponent(clientSecret));
    };
    /**
     * add clientAssertion for confidential client flows
     * @param clientAssertion
     */ RequestParameterBuilder.prototype.addClientAssertion = function(clientAssertion) {
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(clientAssertion)) this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CLIENT_ASSERTION, encodeURIComponent(clientAssertion));
    };
    /**
     * add clientAssertionType for confidential client flows
     * @param clientAssertionType
     */ RequestParameterBuilder.prototype.addClientAssertionType = function(clientAssertionType) {
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(clientAssertionType)) this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).CLIENT_ASSERTION_TYPE, encodeURIComponent(clientAssertionType));
    };
    /**
     * add OBO assertion for confidential client flows
     * @param clientAssertion
     */ RequestParameterBuilder.prototype.addOboAssertion = function(oboAssertion) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).OBO_ASSERTION, encodeURIComponent(oboAssertion));
    };
    /**
     * add grant type
     * @param grantType
     */ RequestParameterBuilder.prototype.addRequestTokenUse = function(tokenUse) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).REQUESTED_TOKEN_USE, encodeURIComponent(tokenUse));
    };
    /**
     * add grant type
     * @param grantType
     */ RequestParameterBuilder.prototype.addGrantType = function(grantType) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).GRANT_TYPE, encodeURIComponent(grantType));
    };
    /**
     * add client info
     *
     */ RequestParameterBuilder.prototype.addClientInfo = function() {
        this.parameters.set((0, $1b76d687a319d9ed$export$476989d62bcb4c85), "1");
    };
    /**
     * add extraQueryParams
     * @param eQParams
     */ RequestParameterBuilder.prototype.addExtraQueryParameters = function(eQParams) {
        var _this = this;
        var sanitizedEQParams = (0, $2742c18af4f8d62d$export$9800b929b6984365).sanitizeEQParams(eQParams, this.parameters);
        Object.keys(sanitizedEQParams).forEach(function(key) {
            _this.parameters.set(key, eQParams[key]);
        });
    };
    RequestParameterBuilder.prototype.addClientCapabilitiesToClaims = function(claims, clientCapabilities) {
        var mergedClaims;
        // Parse provided claims into JSON object or initialize empty object
        if (!claims) mergedClaims = {};
        else try {
            mergedClaims = JSON.parse(claims);
        } catch (e) {
            throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createInvalidClaimsRequestError();
        }
        if (clientCapabilities && clientCapabilities.length > 0) {
            if (!mergedClaims.hasOwnProperty((0, $1b76d687a319d9ed$export$c125cda26c71ef54).ACCESS_TOKEN)) // Add access_token key to claims object
            mergedClaims[(0, $1b76d687a319d9ed$export$c125cda26c71ef54).ACCESS_TOKEN] = {};
            // Add xms_cc claim with provided clientCapabilities to access_token key
            mergedClaims[(0, $1b76d687a319d9ed$export$c125cda26c71ef54).ACCESS_TOKEN][(0, $1b76d687a319d9ed$export$c125cda26c71ef54).XMS_CC] = {
                values: clientCapabilities
            };
        }
        return JSON.stringify(mergedClaims);
    };
    /**
     * adds `username` for Password Grant flow
     * @param username
     */ RequestParameterBuilder.prototype.addUsername = function(username) {
        this.parameters.set((0, $1b76d687a319d9ed$export$fa8b29062cab1da).username, encodeURIComponent(username));
    };
    /**
     * adds `password` for Password Grant flow
     * @param password
     */ RequestParameterBuilder.prototype.addPassword = function(password) {
        this.parameters.set((0, $1b76d687a319d9ed$export$fa8b29062cab1da).password, encodeURIComponent(password));
    };
    /**
     * add pop_jwk to query params
     * @param cnfString
     */ RequestParameterBuilder.prototype.addPopToken = function(cnfString) {
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(cnfString)) {
            this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).TOKEN_TYPE, (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP);
            this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).REQ_CNF, encodeURIComponent(cnfString));
        }
    };
    /**
     * add SSH JWK and key ID to query params
     */ RequestParameterBuilder.prototype.addSshJwk = function(sshJwkString) {
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(sshJwkString)) {
            this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).TOKEN_TYPE, (0, $1b76d687a319d9ed$export$901491a717da2ba5).SSH);
            this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).REQ_CNF, encodeURIComponent(sshJwkString));
        }
    };
    /**
     * add server telemetry fields
     * @param serverTelemetryManager
     */ RequestParameterBuilder.prototype.addServerTelemetry = function(serverTelemetryManager) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).X_CLIENT_CURR_TELEM, serverTelemetryManager.generateCurrentRequestHeaderValue());
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).X_CLIENT_LAST_TELEM, serverTelemetryManager.generateLastRequestHeaderValue());
    };
    /**
     * Adds parameter that indicates to the server that throttling is supported
     */ RequestParameterBuilder.prototype.addThrottling = function() {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).X_MS_LIB_CAPABILITY, (0, $1b76d687a319d9ed$export$a2330d6808e6d893).X_MS_LIB_CAPABILITY_VALUE);
    };
    /**
     * Adds logout_hint parameter for "silent" logout which prevent server account picker
     */ RequestParameterBuilder.prototype.addLogoutHint = function(logoutHint) {
        this.parameters.set((0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).LOGOUT_HINT, encodeURIComponent(logoutHint));
    };
    /**
     * Utility to create a URL from the params map
     */ RequestParameterBuilder.prototype.createQueryString = function() {
        var queryParameterArray = new Array();
        this.parameters.forEach(function(value, key) {
            queryParameterArray.push(key + "=" + value);
        });
        return queryParameterArray.join("&");
    };
    return RequestParameterBuilder;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 */ var $a9ce84fba6ce70d2$export$4f22f74eddb7716a = /** @class */ function() {
    function BaseClient(configuration, performanceClient) {
        // Set the configuration
        this.config = (0, $fbb13fa60d5b5843$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $176db342bac9b10e$export$efa9a398d6368992)(this.config.loggerOptions, (0, $d86c8dd6d40ffd16$export$a8ff84c12d48cfa6), (0, $d86c8dd6d40ffd16$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set the NetworkManager
        this.networkManager = new (0, $6227cb553f9f2db5$export$c69de3e7a1e69077)(this.networkClient, this.cacheManager);
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Creates default headers for requests to token endpoint
     */ BaseClient.prototype.createTokenRequestHeaders = function(ccsCred) {
        var headers = {};
        headers[(0, $1b76d687a319d9ed$export$28d77f87efed1d88).CONTENT_TYPE] = (0, $1b76d687a319d9ed$export$a002182e51710d39).URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    var clientInfo = (0, $c78bc4095f73f45d$export$63508a6d6b7dbe07)(ccsCred.credential);
                    headers[(0, $1b76d687a319d9ed$export$28d77f87efed1d88).CCS_HEADER] = "Oid:" + clientInfo.uid + "@" + clientInfo.utid;
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).UPN:
                headers[(0, $1b76d687a319d9ed$export$28d77f87efed1d88).CCS_HEADER] = "UPN: " + ccsCred.credential;
                break;
        }
        return headers;
    };
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */ BaseClient.prototype.executePostToTokenEndpoint = function(tokenEndpoint, queryString, headers, thumbprint) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var response;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.networkManager.sendPostRequest(thumbprint, tokenEndpoint, {
                                body: queryString,
                                headers: headers
                            })
                        ];
                    case 1:
                        response = _a.sent();
                        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
                        this.config.serverTelemetryManager.clearTelemetryCache();
                        return [
                            2 /*return*/ ,
                            response
                        ];
                }
            });
        });
    };
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */ BaseClient.prototype.updateAuthority = function(updatedAuthority) {
        if (!updatedAuthority.discoveryComplete()) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createEndpointDiscoveryIncompleteError("Updated authority has not completed endpoint discovery.");
        this.authority = updatedAuthority;
    };
    /**
     * Creates query string for the /token request
     * @param request
     */ BaseClient.prototype.createTokenQueryParameters = function(request) {
        var parameterBuilder = new (0, $310de39a31effb4f$export$882078dd8a9e0bfa)();
        if (request.tokenQueryParameters) parameterBuilder.addExtraQueryParameters(request.tokenQueryParameters);
        return parameterBuilder.createQueryString();
    };
    return BaseClient;
}();




/*! @azure/msal-common v13.1.0 2023-06-07 */ 












/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $4e2a602fb391f03c$export$5ee5669a32bdea66 = /** @class */ function() {
    function CacheRecord(accountEntity, idTokenEntity, accessTokenEntity, refreshTokenEntity, appMetadataEntity) {
        this.account = accountEntity || null;
        this.idToken = idTokenEntity || null;
        this.accessToken = accessTokenEntity || null;
        this.refreshToken = refreshTokenEntity || null;
        this.appMetadata = appMetadataEntity || null;
    }
    return CacheRecord;
}();




/*! @azure/msal-common v13.1.0 2023-06-07 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $6ca44babb2872b58$var$KeyLocation;
(function(KeyLocation) {
    KeyLocation["SW"] = "sw";
    KeyLocation["UHW"] = "uhw";
})($6ca44babb2872b58$var$KeyLocation || ($6ca44babb2872b58$var$KeyLocation = {}));
var $6ca44babb2872b58$export$3dd8467151c83e3e = /** @class */ function() {
    function PopTokenGenerator(cryptoUtils, performanceClient) {
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ PopTokenGenerator.prototype.generateCnf = function(request) {
        var _a, _b;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var reqCnf, reqCnfString, _c;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.generateKid(request)
                        ];
                    case 1:
                        reqCnf = _d.sent();
                        reqCnfString = this.cryptoUtils.base64Encode(JSON.stringify(reqCnf));
                        _c = {
                            kid: reqCnf.kid,
                            reqCnfString: reqCnfString
                        };
                        return [
                            4 /*yield*/ ,
                            this.cryptoUtils.hashString(reqCnfString)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            (_c.reqCnfHash = _d.sent(), _c)
                        ];
                }
            });
        });
    };
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ PopTokenGenerator.prototype.generateKid = function(request) {
        var _a;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var kidThumbprint;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.cryptoUtils.getPublicKeyThumbprint(request)
                        ];
                    case 1:
                        kidThumbprint = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                kid: kidThumbprint,
                                xms_ksl: $6ca44babb2872b58$var$KeyLocation.SW
                            }
                        ];
                }
            });
        });
    };
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ PopTokenGenerator.prototype.signPopToken = function(accessToken, keyId, request) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.signPayload(accessToken, keyId, request)
                ];
            });
        });
    };
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ PopTokenGenerator.prototype.signPayload = function(payload, keyId, request, claims) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var resourceRequestMethod, resourceRequestUri, shrClaims, shrNonce, resourceUrlString, resourceUrlComponents;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        resourceRequestMethod = request.resourceRequestMethod, resourceRequestUri = request.resourceRequestUri, shrClaims = request.shrClaims, shrNonce = request.shrNonce;
                        resourceUrlString = resourceRequestUri ? new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(resourceRequestUri) : undefined;
                        resourceUrlComponents = resourceUrlString === null || resourceUrlString === void 0 ? void 0 : resourceUrlString.getUrlComponents();
                        return [
                            4 /*yield*/ ,
                            this.cryptoUtils.signJwt((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({
                                at: payload,
                                ts: (0, $7efd823b057a2db4$export$3117a0de16ab2854).nowSeconds(),
                                m: resourceRequestMethod === null || resourceRequestMethod === void 0 ? void 0 : resourceRequestMethod.toUpperCase(),
                                u: resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.HostNameAndPort,
                                nonce: shrNonce || this.cryptoUtils.createNewGuid(),
                                p: resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.AbsolutePath,
                                q: (resourceUrlComponents === null || resourceUrlComponents === void 0 ? void 0 : resourceUrlComponents.QueryString) ? [
                                    [],
                                    resourceUrlComponents.QueryString
                                ] : undefined,
                                client_claims: shrClaims || undefined
                            }, claims), keyId, request.correlationId)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return PopTokenGenerator;
}();



/*! @azure/msal-common v13.1.0 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ var $451604493dca7024$export$500ab620f6bcc747 = /** @class */ function() {
    function TokenCacheContext(tokenCache, hasChanged) {
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    Object.defineProperty(TokenCacheContext.prototype, "cacheHasChanged", {
        /**
         * boolean which indicates the changes in cache
         */ get: function() {
            return this.hasChanged;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TokenCacheContext.prototype, "tokenCache", {
        /**
         * function to retrieve the token cache
         */ get: function() {
            return this.cache;
        },
        enumerable: false,
        configurable: true
    });
    return TokenCacheContext;
}();



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class that handles response parsing.
 */ var $61eec8e2bbef8abe$export$f456c9835cc63582 = /** @class */ function() {
    function ResponseHandler(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin, performanceClient) {
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
        this.performanceClient = performanceClient;
    }
    /**
     * Function which validates server authorization code response.
     * @param serverResponseHash
     * @param cachedState
     * @param cryptoObj
     */ ResponseHandler.prototype.validateServerAuthorizationCodeResponse = function(serverResponseHash, cachedState, cryptoObj) {
        if (!serverResponseHash.state || !cachedState) throw !serverResponseHash.state ? (0, $30cd164be78785f3$export$a839ff85a7957561).createStateNotFoundError("Server State") : (0, $30cd164be78785f3$export$a839ff85a7957561).createStateNotFoundError("Cached State");
        if (decodeURIComponent(serverResponseHash.state) !== decodeURIComponent(cachedState)) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createStateMismatchError();
        // Check for error
        if (serverResponseHash.error || serverResponseHash.error_description || serverResponseHash.suberror) {
            if ((0, $dec424bb7347a355$export$6ba3e818c6bc76ba).isInteractionRequiredError(serverResponseHash.error, serverResponseHash.error_description, serverResponseHash.suberror)) throw new (0, $dec424bb7347a355$export$6ba3e818c6bc76ba)(serverResponseHash.error || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror, serverResponseHash.timestamp || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.trace_id || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.correlation_id || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.claims || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
            throw new (0, $b198a6cc5c52ae21$export$ea52035eac03daf0)(serverResponseHash.error || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror);
        }
        if (serverResponseHash.client_info) (0, $c78bc4095f73f45d$export$575e1419cfbab7f8)(serverResponseHash.client_info, cryptoObj);
    };
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     */ ResponseHandler.prototype.validateTokenResponse = function(serverResponse) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            if ((0, $dec424bb7347a355$export$6ba3e818c6bc76ba).isInteractionRequiredError(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $dec424bb7347a355$export$6ba3e818c6bc76ba)(serverResponse.error, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, serverResponse.trace_id || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, serverResponse.correlation_id || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, serverResponse.claims || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
            var errString = serverResponse.error_codes + " - [" + serverResponse.timestamp + "]: " + serverResponse.error_description + " - Correlation ID: " + serverResponse.correlation_id + " - Trace ID: " + serverResponse.trace_id;
            throw new (0, $b198a6cc5c52ae21$export$ea52035eac03daf0)(serverResponse.error, errString, serverResponse.suberror);
        }
    };
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ ResponseHandler.prototype.handleServerTokenResponse = function(serverTokenResponse, authority, reqTimestamp, request, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId) {
        var _a;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var idTokenObj, authTime, requestStateObj, cacheRecord, cacheContext, key, account;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).HandleServerTokenResponse, serverTokenResponse.correlation_id);
                        if (serverTokenResponse.id_token) {
                            idTokenObj = new (0, $88f623fdecedc666$export$3a170961dab30083)(serverTokenResponse.id_token || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, this.cryptoObj);
                            // token nonce check (TODO: Add a warning if no nonce is given?)
                            if (authCodePayload && !(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(authCodePayload.nonce)) {
                                if (idTokenObj.claims.nonce !== authCodePayload.nonce) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNonceMismatchError();
                            }
                            // token max_age check
                            if (request.maxAge || request.maxAge === 0) {
                                authTime = idTokenObj.claims.auth_time;
                                if (!authTime) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createAuthTimeNotFoundError();
                                (0, $88f623fdecedc666$export$3a170961dab30083).checkMaxAge(authTime, request.maxAge);
                            }
                        }
                        // generate homeAccountId
                        this.homeAccountIdentifier = (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).generateHomeAccountId(serverTokenResponse.client_info || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenObj);
                        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, $43862c84d67ae4c1$export$871e33217042c65e).parseRequestState(this.cryptoObj, authCodePayload.state);
                        // Add keyId from request to serverTokenResponse if defined
                        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
                        cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenObj, userAssertionHash, authCodePayload);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            ,
                            5,
                            8
                        ]);
                        if (!(this.persistencePlugin && this.serializableCache)) return [
                            3 /*break*/ ,
                            3
                        ];
                        this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                        cacheContext = new (0, $451604493dca7024$export$500ab620f6bcc747)(this.serializableCache, true);
                        return [
                            4 /*yield*/ ,
                            this.persistencePlugin.beforeCacheAccess(cacheContext)
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        /*
                         * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
                         * If not present, we should return null, as it's the case that another application called removeAccount in between
                         * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
                         * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
                         */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                            key = cacheRecord.account.generateAccountKey();
                            account = this.cacheStorage.getAccount(key);
                            if (!account) {
                                this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                                return [
                                    2 /*return*/ ,
                                    ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenObj, requestStateObj, undefined, serverRequestId)
                                ];
                            }
                        }
                        return [
                            4 /*yield*/ ,
                            this.cacheStorage.saveCacheRecord(cacheRecord)
                        ];
                    case 4:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 5:
                        if (!(this.persistencePlugin && this.serializableCache && cacheContext)) return [
                            3 /*break*/ ,
                            7
                        ];
                        this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                        return [
                            4 /*yield*/ ,
                            this.persistencePlugin.afterCacheAccess(cacheContext)
                        ];
                    case 6:
                        _b.sent();
                        _b.label = 7;
                    case 7:
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        return [
                            2 /*return*/ ,
                            ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenObj, requestStateObj, serverTokenResponse, serverRequestId)
                        ];
                }
            });
        });
    };
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ ResponseHandler.prototype.generateCacheRecord = function(serverTokenResponse, authority, reqTimestamp, request, idTokenObj, userAssertionHash, authCodePayload) {
        var env = authority.getPreferredCache();
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(env)) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createInvalidCacheEnvironmentError();
        // IdToken: non AAD scenarios can have empty realm
        var cachedIdToken;
        var cachedAccount;
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(serverTokenResponse.id_token) && !!idTokenObj) {
            cachedIdToken = (0, $0c09c5966c1cc91f$export$49ed297fa7d02bde).createIdTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.id_token || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, this.clientId, idTokenObj.claims.tid || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
            cachedAccount = this.generateAccountEntity(serverTokenResponse, idTokenObj, authority, authCodePayload);
        }
        // AccessToken
        var cachedAccessToken = null;
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(serverTokenResponse.access_token)) {
            // If scopes not returned in server response, use request scopes
            var responseScopes = serverTokenResponse.scope ? (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(serverTokenResponse.scope) : new (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99)(request.scopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ var expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            var extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            var refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            var tokenExpirationSeconds = reqTimestamp + expiresIn;
            var extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            var refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, $698539a43f4f793b$export$6b7a8e14ec177765).createAccessTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.access_token || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, this.clientId, idTokenObj ? idTokenObj.claims.tid || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING : authority.tenant, responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, request.claims, request.requestedClaimsHash);
        }
        // refreshToken
        var cachedRefreshToken = null;
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(serverTokenResponse.refresh_token)) cachedRefreshToken = (0, $16a85bb95b6824db$export$2f7722c9adbc0a1b).createRefreshTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, this.clientId, serverTokenResponse.foci, userAssertionHash);
        // appMetadata
        var cachedAppMetadata = null;
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(serverTokenResponse.foci)) cachedAppMetadata = (0, $bd0d508238673d4b$export$b939be19f91a34cc).createAppMetadataEntity(this.clientId, env, serverTokenResponse.foci);
        return new (0, $4e2a602fb391f03c$export$5ee5669a32bdea66)(cachedAccount, cachedIdToken, cachedAccessToken, cachedRefreshToken, cachedAppMetadata);
    };
    /**
     * Generate Account
     * @param serverTokenResponse
     * @param idToken
     * @param authority
     */ ResponseHandler.prototype.generateAccountEntity = function(serverTokenResponse, idToken, authority, authCodePayload) {
        var authorityType = authority.authorityType;
        var cloudGraphHostName = authCodePayload ? authCodePayload.cloud_graph_host_name : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        var msGraphhost = authCodePayload ? authCodePayload.msgraph_host : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        // ADFS does not require client_info in the response
        if (authorityType === (0, $26d2ec0e655e729b$export$cd82032b224a3839).Adfs) {
            this.logger.verbose("Authority type is ADFS, creating ADFS account");
            return (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).createGenericAccount(this.homeAccountIdentifier, idToken, authority, cloudGraphHostName, msGraphhost);
        }
        // This fallback applies to B2C as well as they fall under an AAD account type.
        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(serverTokenResponse.client_info) && authority.protocolMode === "AAD") throw (0, $30cd164be78785f3$export$a839ff85a7957561).createClientInfoEmptyError();
        return serverTokenResponse.client_info ? (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).createAccount(serverTokenResponse.client_info, this.homeAccountIdentifier, idToken, authority, cloudGraphHostName, msGraphhost) : (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).createGenericAccount(this.homeAccountIdentifier, idToken, authority, cloudGraphHostName, msGraphhost);
    };
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ ResponseHandler.generateAuthenticationResult = function(cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenObj, requestState, serverTokenResponse, requestId) {
        var _a, _b, _c;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var accessToken, responseScopes, expiresOn, extExpiresOn, familyId, popTokenGenerator, _d, secret, keyId, uid, tid;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        accessToken = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                        responseScopes = [];
                        expiresOn = null;
                        familyId = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                        if (!cacheRecord.accessToken) return [
                            3 /*break*/ ,
                            4
                        ];
                        if (!(cacheRecord.accessToken.tokenType === (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        popTokenGenerator = new (0, $6ca44babb2872b58$export$3dd8467151c83e3e)(cryptoObj);
                        _d = cacheRecord.accessToken, secret = _d.secret, keyId = _d.keyId;
                        if (!keyId) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createKeyIdMissingError();
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.signPopToken(secret, keyId, request)
                        ];
                    case 1:
                        accessToken = _e.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        accessToken = cacheRecord.accessToken.secret;
                        _e.label = 3;
                    case 3:
                        responseScopes = (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
                        expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
                        extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
                        _e.label = 4;
                    case 4:
                        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, $1b76d687a319d9ed$export$978fe7ab5e74b539) ? (0, $1b76d687a319d9ed$export$978fe7ab5e74b539) : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                        uid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.oid) || (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.sub) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                        tid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.tid) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                        // for hybrid + native bridge enablement, send back the native account Id
                        if ((serverTokenResponse === null || serverTokenResponse === void 0 ? void 0 : serverTokenResponse.spa_accountid) && !!cacheRecord.account) cacheRecord.account.nativeAccountId = serverTokenResponse === null || serverTokenResponse === void 0 ? void 0 : serverTokenResponse.spa_accountid;
                        return [
                            2 /*return*/ ,
                            {
                                authority: authority.canonicalAuthority,
                                uniqueId: uid,
                                tenantId: tid,
                                scopes: responseScopes,
                                account: cacheRecord.account ? cacheRecord.account.getAccountInfo() : null,
                                idToken: idTokenObj ? idTokenObj.rawToken : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                                idTokenClaims: idTokenObj ? idTokenObj.claims : {},
                                accessToken: accessToken,
                                fromCache: fromTokenCache,
                                expiresOn: expiresOn,
                                correlationId: request.correlationId,
                                requestId: requestId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                                extExpiresOn: extExpiresOn,
                                familyId: familyId,
                                tokenType: ((_a = cacheRecord.accessToken) === null || _a === void 0 ? void 0 : _a.tokenType) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                                state: requestState ? requestState.userRequestState : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                                cloudGraphHostName: ((_b = cacheRecord.account) === null || _b === void 0 ? void 0 : _b.cloudGraphHostName) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                                msGraphHost: ((_c = cacheRecord.account) === null || _c === void 0 ? void 0 : _c.msGraphHost) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                                code: serverTokenResponse === null || serverTokenResponse === void 0 ? void 0 : serverTokenResponse.spa_code,
                                fromNativeBroker: false
                            }
                        ];
                }
            });
        });
    };
    return ResponseHandler;
}();












"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 */ var $c49acda2ee30d5da$export$8538731fd397fb90 = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(AuthorizationCodeClient, _super);
    function AuthorizationCodeClient(configuration, performanceClient) {
        var _this = _super.call(this, configuration, performanceClient) || this;
        // Flag to indicate if client is for hybrid spa auth code redemption
        _this.includeRedirectUri = true;
        return _this;
    }
    /**
     * Creates the URL of the authorization request letting the user input credentials and consent to the
     * application. The URL target the /authorize endpoint of the authority configured in the
     * application object.
     *
     * Once the user inputs their credentials and consents, the authority will send a response to the redirect URI
     * sent in the request and should contain an authorization code, which can then be used to acquire tokens via
     * acquireToken(AuthorizationCodeRequest)
     * @param request
     */ AuthorizationCodeClient.prototype.getAuthCodeUrl = function(request) {
        var _a, _b;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var queryString;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).GetAuthCodeUrl, request.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthClientCreateQueryString, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeUrlQueryString(request)
                        ];
                    case 1:
                        queryString = _c.sent();
                        return [
                            2 /*return*/ ,
                            (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).appendQueryString(this.authority.authorizationEndpoint, queryString)
                        ];
                }
            });
        });
    };
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ AuthorizationCodeClient.prototype.acquireToken = function(request, authCodePayload) {
        var _a, _b, _c, _d, _e, _f;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var atsMeasurement, reqTimestamp, response, requestId, httpVerAuthority, responseHandler;
            var _this = this;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_g) {
                switch(_g.label){
                    case 0:
                        if (!request || !request.code) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createTokenRequestCannotBeMadeError();
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthClientAcquireToken, request.correlationId);
                        atsMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement("AuthCodeClientAcquireToken", request.correlationId);
                        this.logger.info("in acquireToken call in auth-code client");
                        reqTimestamp = (0, $7efd823b057a2db4$export$3117a0de16ab2854).nowSeconds();
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.executeTokenRequest(this.authority, request)
                        ];
                    case 1:
                        response = _g.sent();
                        requestId = (_d = response.headers) === null || _d === void 0 ? void 0 : _d[(0, $1b76d687a319d9ed$export$28d77f87efed1d88).X_MS_REQUEST_ID];
                        httpVerAuthority = (_e = response.headers) === null || _e === void 0 ? void 0 : _e[(0, $1b76d687a319d9ed$export$28d77f87efed1d88).X_MS_HTTP_VERSION];
                        if (httpVerAuthority) atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.addStaticFields({
                            httpVerAuthority: httpVerAuthority
                        });
                        responseHandler = new (0, $61eec8e2bbef8abe$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin, this.performanceClient);
                        // Validate response. This function throws a server error if an error is returned by the server.
                        responseHandler.validateTokenResponse(response.body);
                        (_f = this.performanceClient) === null || _f === void 0 || _f.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).HandleServerTokenResponse, request.correlationId);
                        return [
                            2 /*return*/ ,
                            responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request, authCodePayload, undefined, undefined, undefined, requestId).then(function(result) {
                                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            }).catch(function(error) {
                                _this.logger.verbose("Error in fetching token in ACC", request.correlationId);
                                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Handles the hash fragment response from public client code request. Returns a code response used by
     * the client to exchange for a token in acquireToken.
     * @param hashFragment
     */ AuthorizationCodeClient.prototype.handleFragmentResponse = function(hashFragment, cachedState) {
        // Handle responses.
        var responseHandler = new (0, $61eec8e2bbef8abe$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, null, null);
        // Deserialize hash fragment response parameters.
        var hashUrlString = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(hashFragment);
        // Deserialize hash fragment response parameters.
        var serverParams = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getDeserializedHash(hashUrlString.getHash());
        // Get code response
        responseHandler.validateServerAuthorizationCodeResponse(serverParams, cachedState, this.cryptoUtils);
        // throw when there is no auth code in the response
        if (!serverParams.code) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNoAuthCodeInServerResponseError();
        return (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, serverParams), {
            // Code param is optional in ServerAuthorizationCodeResponse but required in AuthorizationCodePaylod
            code: serverParams.code
        });
    };
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ AuthorizationCodeClient.prototype.getLogoutUri = function(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createEmptyLogoutRequestError();
        var queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).appendQueryString(this.authority.endSessionEndpoint, queryString);
    };
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ AuthorizationCodeClient.prototype.executeTokenRequest = function(authority, request) {
        var _a, _b;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var queryParametersString, endpoint, requestBody, ccsCredential, clientInfo, headers, thumbprint;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
                        queryParametersString = this.createTokenQueryParameters(request);
                        endpoint = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
                        return [
                            4 /*yield*/ ,
                            this.createTokenRequestBody(request)
                        ];
                    case 1:
                        requestBody = _c.sent();
                        ccsCredential = undefined;
                        if (request.clientInfo) try {
                            clientInfo = (0, $c78bc4095f73f45d$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils);
                            ccsCredential = {
                                credential: "" + clientInfo.uid + (0, $1b76d687a319d9ed$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR + clientInfo.utid,
                                type: (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
                            };
                        } catch (e) {
                            this.logger.verbose("Could not parse client info for CCS Header: " + e);
                        }
                        headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: authority.canonicalAuthority,
                            scopes: request.scopes,
                            claims: request.claims,
                            authenticationScheme: request.authenticationScheme,
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            sshKid: request.sshKid
                        };
                        return [
                            2 /*return*/ ,
                            this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint)
                        ];
                }
            });
        });
    };
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ AuthorizationCodeClient.prototype.createTokenRequestBody = function(request) {
        var _a, _b;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parameterBuilder, clientAssertion, popTokenGenerator, reqCnfData, correlationId, ccsCred, clientInfo, clientInfo;
            var _c;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
                        parameterBuilder = new (0, $310de39a31effb4f$export$882078dd8a9e0bfa)();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        /*
                         * For hybrid spa flow, there will be a code but no verifier
                         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
                         */ if (!this.includeRedirectUri) // Just validate
                        (0, $2742c18af4f8d62d$export$9800b929b6984365).validateRedirectUri(request.redirectUri);
                        else // Validate and include redirect uri
                        parameterBuilder.addRedirectUri(request.redirectUri);
                        // Add scope array, parameter builder will add default scopes and dedupe
                        parameterBuilder.addScopes(request.scopes);
                        // add code: user set, not validated
                        parameterBuilder.addAuthorizationCode(request.code);
                        // Add library metadata
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
                        parameterBuilder.addThrottling();
                        if (this.serverTelemetryManager) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
                        // add code_verifier if passed
                        if (request.codeVerifier) parameterBuilder.addCodeVerifier(request.codeVerifier);
                        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
                        if (this.config.clientCredentials.clientAssertion) {
                            clientAssertion = this.config.clientCredentials.clientAssertion;
                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
                        }
                        parameterBuilder.addGrantType((0, $1b76d687a319d9ed$export$ce68f19b50b39c0b).AUTHORIZATION_CODE_GRANT);
                        parameterBuilder.addClientInfo();
                        if (!(request.authenticationScheme === (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        popTokenGenerator = new (0, $6ca44babb2872b58$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
                        (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.generateCnf(request)
                        ];
                    case 1:
                        reqCnfData = _d.sent();
                        // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
                        parameterBuilder.addPopToken(reqCnfData.reqCnfString);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (request.authenticationScheme === (0, $1b76d687a319d9ed$export$901491a717da2ba5).SSH) {
                            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
                            else throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createMissingSshJwkError();
                        }
                        _d.label = 3;
                    case 3:
                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
                        parameterBuilder.addCorrelationId(correlationId);
                        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        ccsCred = undefined;
                        if (request.clientInfo) try {
                            clientInfo = (0, $c78bc4095f73f45d$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils);
                            ccsCred = {
                                credential: "" + clientInfo.uid + (0, $1b76d687a319d9ed$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR + clientInfo.utid,
                                type: (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
                            };
                        } catch (e) {
                            this.logger.verbose("Could not parse client info for CCS Header: " + e);
                        }
                        else ccsCred = request.ccsCredential;
                        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
                        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
                            case (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                                try {
                                    clientInfo = (0, $c78bc4095f73f45d$export$63508a6d6b7dbe07)(ccsCred.credential);
                                    parameterBuilder.addCcsOid(clientInfo);
                                } catch (e) {
                                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                                }
                                break;
                            case (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).UPN:
                                parameterBuilder.addCcsUpn(ccsCred.credential);
                                break;
                        }
                        if (request.tokenBodyParameters) parameterBuilder.addExtraQueryParameters(request.tokenBodyParameters);
                        // Add hybrid spa parameters if not already provided
                        if (request.enableSpaAuthorizationCode && (!request.tokenBodyParameters || !request.tokenBodyParameters[(0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).RETURN_SPA_CODE])) parameterBuilder.addExtraQueryParameters((_c = {}, _c[(0, $1b76d687a319d9ed$export$cf7709e7db2ddf5d).RETURN_SPA_CODE] = "1", _c));
                        return [
                            2 /*return*/ ,
                            parameterBuilder.createQueryString()
                        ];
                }
            });
        });
    };
    /**
     * This API validates the `AuthorizationCodeUrlRequest` and creates a URL
     * @param request
     */ AuthorizationCodeClient.prototype.createAuthCodeUrlQueryString = function(request) {
        var _a;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var parameterBuilder, requestScopes, correlationId, accountSid, accountLoginHintClaim, clientInfo, clientInfo, clientInfo, popTokenGenerator, reqCnfData;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthClientCreateQueryString, request.correlationId);
                        parameterBuilder = new (0, $310de39a31effb4f$export$882078dd8a9e0bfa)();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        requestScopes = (0, $35bd2ff9e18a8648$export$6388937ca91ccae8)(request.scopes || [], request.extraScopesToConsent || []);
                        parameterBuilder.addScopes(requestScopes);
                        // validate the redirectUri (to be a non null value)
                        parameterBuilder.addRedirectUri(request.redirectUri);
                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
                        parameterBuilder.addCorrelationId(correlationId);
                        // add response_mode. If not passed in it defaults to query.
                        parameterBuilder.addResponseMode(request.responseMode);
                        // add response_type = code
                        parameterBuilder.addResponseTypeCode();
                        // add library info parameters
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
                        // add client_info=1
                        parameterBuilder.addClientInfo();
                        if (request.codeChallenge && request.codeChallengeMethod) parameterBuilder.addCodeChallengeParams(request.codeChallenge, request.codeChallengeMethod);
                        if (request.prompt) parameterBuilder.addPrompt(request.prompt);
                        if (request.domainHint) parameterBuilder.addDomainHint(request.domainHint);
                        // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
                        if (request.prompt !== (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).SELECT_ACCOUNT) {
                            // AAD will throw if prompt=select_account is passed with an account hint
                            if (request.sid && request.prompt === (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).NONE) {
                                // SessionID is only used in silent calls
                                this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
                                parameterBuilder.addSid(request.sid);
                            } else if (request.account) {
                                accountSid = this.extractAccountSid(request.account);
                                accountLoginHintClaim = this.extractLoginHint(request.account);
                                // If login_hint claim is present, use it over sid/username
                                if (accountLoginHintClaim) {
                                    this.logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account");
                                    parameterBuilder.addLoginHint(accountLoginHintClaim);
                                    try {
                                        clientInfo = (0, $c78bc4095f73f45d$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    } catch (e) {
                                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                                    }
                                } else if (accountSid && request.prompt === (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).NONE) {
                                    /*
                                     * If account and loginHint are provided, we will check account first for sid before adding loginHint
                                     * SessionId is only used in silent calls
                                     */ this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                                    parameterBuilder.addSid(accountSid);
                                    try {
                                        clientInfo = (0, $c78bc4095f73f45d$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    } catch (e) {
                                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                                    }
                                } else if (request.loginHint) {
                                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                                    parameterBuilder.addLoginHint(request.loginHint);
                                    parameterBuilder.addCcsUpn(request.loginHint);
                                } else if (request.account.username) {
                                    // Fallback to account username if provided
                                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                                    parameterBuilder.addLoginHint(request.account.username);
                                    try {
                                        clientInfo = (0, $c78bc4095f73f45d$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                                        parameterBuilder.addCcsOid(clientInfo);
                                    } catch (e) {
                                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                                    }
                                }
                            } else if (request.loginHint) {
                                this.logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
                                parameterBuilder.addLoginHint(request.loginHint);
                                parameterBuilder.addCcsUpn(request.loginHint);
                            }
                        } else this.logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
                        if (request.nonce) parameterBuilder.addNonce(request.nonce);
                        if (request.state) parameterBuilder.addState(request.state);
                        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        if (request.extraQueryParameters) parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
                        if (!request.nativeBroker) return [
                            3 /*break*/ ,
                            2
                        ];
                        // signal ests that this is a WAM call
                        parameterBuilder.addNativeBroker();
                        if (!(request.authenticationScheme === (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        popTokenGenerator = new (0, $6ca44babb2872b58$export$3dd8467151c83e3e)(this.cryptoUtils);
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.generateCnf(request)
                        ];
                    case 1:
                        reqCnfData = _b.sent();
                        parameterBuilder.addPopToken(reqCnfData.reqCnfString);
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ ,
                            parameterBuilder.createQueryString()
                        ];
                }
            });
        });
    };
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ AuthorizationCodeClient.prototype.createLogoutUrlQueryString = function(request) {
        var parameterBuilder = new (0, $310de39a31effb4f$export$882078dd8a9e0bfa)();
        if (request.postLogoutRedirectUri) parameterBuilder.addPostLogoutRedirectUri(request.postLogoutRedirectUri);
        if (request.correlationId) parameterBuilder.addCorrelationId(request.correlationId);
        if (request.idTokenHint) parameterBuilder.addIdTokenHint(request.idTokenHint);
        if (request.state) parameterBuilder.addState(request.state);
        if (request.logoutHint) parameterBuilder.addLogoutHint(request.logoutHint);
        if (request.extraQueryParameters) parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
        return parameterBuilder.createQueryString();
    };
    /**
     * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
     * @param account
     */ AuthorizationCodeClient.prototype.extractAccountSid = function(account) {
        var _a;
        return ((_a = account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.sid) || null;
    };
    AuthorizationCodeClient.prototype.extractLoginHint = function(account) {
        var _a;
        return ((_a = account.idTokenClaims) === null || _a === void 0 ? void 0 : _a.login_hint) || null;
    };
    return AuthorizationCodeClient;
}((0, $a9ce84fba6ce70d2$export$4f22f74eddb7716a));


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 
/*! @azure/msal-common v13.1.0 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $62669417631cd239$export$bddbbc43a3ca9c53 = /** @class */ function() {
    function ServerTelemetryManager(telemetryRequest, cacheManager) {
        this.cacheOutcome = (0, $1b76d687a319d9ed$export$aa4af185ea049f6b).NO_CACHE_HIT;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        this.telemetryCacheKey = (0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).CACHE_KEY + (0, $1b76d687a319d9ed$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ ServerTelemetryManager.prototype.generateCurrentRequestHeaderValue = function() {
        var request = "" + this.apiId + (0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).VALUE_SEPARATOR + this.cacheOutcome;
        var platformFields = [
            this.wrapperSKU,
            this.wrapperVer
        ].join((0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        var regionDiscoveryFields = this.getRegionDiscoveryFields();
        var requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    };
    /**
     * API to add MSER Telemetry for the last failed request
     */ ServerTelemetryManager.prototype.generateLastRequestHeaderValue = function() {
        var lastRequests = this.getLastRequests();
        var maxErrors = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        var failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        var errors = lastRequests.errors.slice(0, maxErrors).join((0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        var errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        var overflow = maxErrors < errorCount ? (0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).OVERFLOW_TRUE : (0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).OVERFLOW_FALSE;
        var platformFields = [
            errorCount,
            overflow
        ].join((0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    };
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ ServerTelemetryManager.prototype.cacheFailedRequest = function(error) {
        var lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= (0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(error.subError)) lastRequests.errors.push(error.subError);
        else if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(error.errorCode)) lastRequests.errors.push(error.errorCode);
        else if (!!error && error.toString()) lastRequests.errors.push(error.toString());
        else lastRequests.errors.push((0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).UNKNOWN_ERROR);
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return;
    };
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ ServerTelemetryManager.prototype.incrementCacheHits = function() {
        var lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
        return lastRequests.cacheHits;
    };
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ ServerTelemetryManager.prototype.getLastRequests = function() {
        var initialValue = new (0, $9b88af41c7151908$export$ff670b37c5e10296)();
        var lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    };
    /**
     * Remove server telemetry cache entry
     */ ServerTelemetryManager.prototype.clearTelemetryCache = function() {
        var lastRequests = this.getLastRequests();
        var numErrorsFlushed = ServerTelemetryManager.maxErrorsToSend(lastRequests);
        var errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            var serverTelemEntity = new (0, $9b88af41c7151908$export$ff670b37c5e10296)();
            serverTelemEntity.failedRequests = lastRequests.failedRequests.slice(numErrorsFlushed * 2); // failedRequests contains 2 items for each error
            serverTelemEntity.errors = lastRequests.errors.slice(numErrorsFlushed);
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity);
        }
    };
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ ServerTelemetryManager.maxErrorsToSend = function(serverTelemetryEntity) {
        var i;
        var maxErrors = 0;
        var dataSize = 0;
        var errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            var apiId = serverTelemetryEntity.failedRequests[2 * i] || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            var correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            var errorCode = serverTelemetryEntity.errors[i] || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, $1b76d687a319d9ed$export$30fa4ad28fb9feeb).MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    };
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ ServerTelemetryManager.prototype.getRegionDiscoveryFields = function() {
        var regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionSource || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionOutcome || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
        return regionDiscoveryFields.join(",");
    };
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ ServerTelemetryManager.prototype.updateRegionDiscoveryMetadata = function(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    };
    /**
     * Set cache outcome
     */ ServerTelemetryManager.prototype.setCacheOutcome = function(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    };
    return ServerTelemetryManager;
}();





"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $fca38100868b2f7f$export$d858565f81c03f1f = /** @class */ function() {
    function BaseInteractionClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) {
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.nativeMessageHandler = nativeMessageHandler;
        this.correlationId = correlationId || this.browserCrypto.createNewGuid();
        this.logger = logger.clone((0, $7b3089fdde5d004f$export$a0a689e4294b9880).MSAL_SKU, (0, $374e1ca34fdd445d$export$83d89fbfd8236492), this.correlationId);
        this.performanceClient = performanceClient;
    }
    BaseInteractionClient.prototype.clearCacheOnLogout = function(account) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!account) return [
                            3 /*break*/ ,
                            5
                        ];
                        if ((0, $5d6dde05c7528aa5$export$680160523e6bfa6a).accountInfoIsEqual(account, this.browserStorage.getActiveAccount(), false)) {
                            this.logger.verbose("Setting active account to null");
                            this.browserStorage.setActiveAccount(null);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.browserStorage.removeAccount((0, $5d6dde05c7528aa5$export$680160523e6bfa6a).generateAccountCacheKey(account))
                        ];
                    case 2:
                        _a.sent();
                        this.logger.verbose("Cleared cache items belonging to the account provided in the logout request.");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        _a.sent();
                        this.logger.error("Account provided in logout request was not found. Local cache unchanged.");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 5:
                        _a.trys.push([
                            5,
                            8,
                            ,
                            9
                        ]);
                        this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId);
                        // Clear all accounts and tokens
                        return [
                            4 /*yield*/ ,
                            this.browserStorage.clear()
                        ];
                    case 6:
                        // Clear all accounts and tokens
                        _a.sent();
                        // Clear any stray keys from IndexedDB
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.clearKeystore()
                        ];
                    case 7:
                        // Clear any stray keys from IndexedDB
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 8:
                        _a.sent();
                        this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged.");
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Initializer function for all request APIs
     * @param request
     */ BaseInteractionClient.prototype.initializeBaseRequest = function(request, account) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authority, scopes, validatedRequest, _a;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
                        this.logger.verbose("Initializing BaseAuthRequest");
                        authority = request.authority || this.config.auth.authority;
                        if (!account) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.validateRequestAuthority(authority, account)
                        ];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        scopes = (0, $ac3fbc8ec7de8c8c$export$afc72e2116322959)(request && request.scopes || []);
                        validatedRequest = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request), {
                            correlationId: this.correlationId,
                            authority: authority,
                            scopes: scopes
                        });
                        // Set authenticationScheme to BEARER if not explicitly set in the request
                        if (!validatedRequest.authenticationScheme) {
                            validatedRequest.authenticationScheme = (0, $1b76d687a319d9ed$export$901491a717da2ba5).BEARER;
                            this.logger.verbose('Authentication Scheme wasn\'t explicitly set in request, defaulting to "Bearer" request');
                        } else {
                            if (validatedRequest.authenticationScheme === (0, $1b76d687a319d9ed$export$901491a717da2ba5).SSH) {
                                if (!request.sshJwk) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createMissingSshJwkError();
                                if (!request.sshKid) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createMissingSshKidError();
                            }
                            this.logger.verbose('Authentication Scheme set to "' + validatedRequest.authenticationScheme + '" as configured in Auth request');
                        }
                        if (!(request.claims && !(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(request.claims))) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = validatedRequest;
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.hashString(request.claims)
                        ];
                    case 3:
                        _a.requestedClaimsHash = _b.sent();
                        _b.label = 4;
                    case 4:
                        return [
                            2 /*return*/ ,
                            validatedRequest
                        ];
                }
            });
        });
    };
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */ BaseInteractionClient.prototype.getRedirectUri = function(requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        var redirectUri = requestRedirectUri || this.config.auth.redirectUri || (0, $94c261d7c4faec3a$export$311899ae85124b2d).getCurrentUri();
        return (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getAbsoluteUrl(redirectUri, (0, $94c261d7c4faec3a$export$311899ae85124b2d).getCurrentUri());
    };
    /*
     * If authority provided in the request does not match environment/authority specified
     * in the account or MSAL config, we throw an error.
     */ BaseInteractionClient.prototype.validateRequestAuthority = function(authority, account) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var discoveredAuthority;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getDiscoveredAuthority(authority)
                        ];
                    case 1:
                        discoveredAuthority = _a.sent();
                        if (!discoveredAuthority.isAlias(account.environment)) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createAuthorityMismatchError();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */ BaseInteractionClient.prototype.initializeServerTelemetryManager = function(apiId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called");
        var telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: this.correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
            wrapperVer: this.browserStorage.getWrapperMetadata()[1]
        };
        return new (0, $62669417631cd239$export$bddbbc43a3ca9c53)(telemetryPayload, this.browserStorage);
    };
    /**
     * Used to get a discovered version of the default authority.
     * @param requestAuthority
     * @param requestCorrelationId
     */ BaseInteractionClient.prototype.getDiscoveredAuthority = function(requestAuthority) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authorityOptions;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("getDiscoveredAuthority called");
                        authorityOptions = {
                            protocolMode: this.config.auth.protocolMode,
                            knownAuthorities: this.config.auth.knownAuthorities,
                            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                            authorityMetadata: this.config.auth.authorityMetadata
                        };
                        if (!requestAuthority) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.logger.verbose("Creating discovered authority with request authority");
                        return [
                            4 /*yield*/ ,
                            (0, $188344d4eb4caccf$export$4b476259e3402a97).createDiscoveredInstance(requestAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        this.logger.verbose("Creating discovered authority with configured authority");
                        return [
                            4 /*yield*/ ,
                            (0, $188344d4eb4caccf$export$4b476259e3402a97).createDiscoveredInstance(this.config.auth.authority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger)
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return BaseInteractionClient;
}();







"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ var $4eafc7ca6d6f2ff1$export$fa9179cade3eb05a = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(StandardInteractionClient, _super);
    function StandardInteractionClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Generates an auth code request tied to the url request.
     * @param request
     */ StandardInteractionClient.prototype.initializeAuthorizationCodeRequest = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var generatedPkceParams, authCodeRequest;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, request.correlationId);
                        this.logger.verbose("initializeAuthorizationRequest called", request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.browserCrypto.generatePkceCodes()
                        ];
                    case 1:
                        generatedPkceParams = _a.sent();
                        authCodeRequest = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request), {
                            redirectUri: request.redirectUri,
                            code: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                            codeVerifier: generatedPkceParams.verifier
                        });
                        request.codeChallenge = generatedPkceParams.challenge;
                        request.codeChallengeMethod = (0, $1b76d687a319d9ed$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD;
                        return [
                            2 /*return*/ ,
                            authCodeRequest
                        ];
                }
            });
        });
    };
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ StandardInteractionClient.prototype.initializeLogoutRequest = function(logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest === null || logoutRequest === void 0 ? void 0 : logoutRequest.correlationId);
        var validLogoutRequest = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({
            correlationId: this.correlationId || this.browserCrypto.createNewGuid()
        }, logoutRequest);
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    var logoutHint = this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided");
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
            } else this.logger.verbose("logoutHint has already been set in logoutRequest");
        } else this.logger.verbose("logoutHint will not be set since no logout request was configured");
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, $94c261d7c4faec3a$export$311899ae85124b2d).getCurrentUri());
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, $94c261d7c4faec3a$export$311899ae85124b2d).getCurrentUri());
            } else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getAbsoluteUrl((0, $94c261d7c4faec3a$export$311899ae85124b2d).getCurrentUri(), (0, $94c261d7c4faec3a$export$311899ae85124b2d).getCurrentUri());
            }
        } else this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        return validLogoutRequest;
    };
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ StandardInteractionClient.prototype.getLogoutHintFromIdTokenClaims = function(account) {
        var idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) return idTokenClaims.login_hint;
            else this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
        } else this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
        return null;
    };
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */ StandardInteractionClient.prototype.createAuthCodeClient = function(serverTelemetryManager, authorityUrl, requestAzureCloudOptions) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientConfig;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.correlationId);
                        // Create auth module.
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getClientConfiguration(serverTelemetryManager, authorityUrl, requestAzureCloudOptions)
                        ];
                    case 1:
                        clientConfig = _a.sent();
                        return [
                            2 /*return*/ ,
                            new (0, $c49acda2ee30d5da$export$8538731fd397fb90)(clientConfig, this.performanceClient)
                        ];
                }
            });
        });
    };
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param serverTelemetryManager
     * @param requestAuthority
     * @param requestCorrelationId
     */ StandardInteractionClient.prototype.getClientConfiguration = function(serverTelemetryManager, requestAuthority, requestAzureCloudOptions) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var discoveredAuthority, logger;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
                        this.logger.verbose("getClientConfiguration called", this.correlationId);
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getDiscoveredAuthority(requestAuthority, requestAzureCloudOptions)
                        ];
                    case 1:
                        discoveredAuthority = _a.sent();
                        logger = this.config.system.loggerOptions;
                        return [
                            2 /*return*/ ,
                            {
                                authOptions: {
                                    clientId: this.config.auth.clientId,
                                    authority: discoveredAuthority,
                                    clientCapabilities: this.config.auth.clientCapabilities
                                },
                                systemOptions: {
                                    tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                                    preventCorsPreflight: true
                                },
                                loggerOptions: {
                                    loggerCallback: logger.loggerCallback,
                                    piiLoggingEnabled: logger.piiLoggingEnabled,
                                    logLevel: logger.logLevel,
                                    correlationId: this.correlationId
                                },
                                cryptoInterface: this.browserCrypto,
                                networkInterface: this.networkClient,
                                storageInterface: this.browserStorage,
                                serverTelemetryManager: serverTelemetryManager,
                                libraryInfo: {
                                    sku: (0, $7b3089fdde5d004f$export$a0a689e4294b9880).MSAL_SKU,
                                    version: (0, $374e1ca34fdd445d$export$83d89fbfd8236492),
                                    cpu: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                                    os: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING
                                },
                                telemetry: this.config.telemetry
                            }
                        ];
                }
            });
        });
    };
    /**
     * @param hash
     * @param interactionType
     */ StandardInteractionClient.prototype.validateAndExtractStateFromHash = function(serverParams, interactionType, requestCorrelationId) {
        this.logger.verbose("validateAndExtractStateFromHash called", requestCorrelationId);
        if (!serverParams.state) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createHashDoesNotContainStateError();
        var platformStateObj = (0, $60804433685cab28$export$83c579d74a9d4ed7).extractBrowserRequestState(this.browserCrypto, serverParams.state);
        if (!platformStateObj) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToParseStateError();
        if (platformStateObj.interactionType !== interactionType) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createStateInteractionTypeMismatchError();
        this.logger.verbose("Returning state from hash", requestCorrelationId);
        return serverParams.state;
    };
    /**
     * Used to get a discovered version of the default authority.
     * @param requestAuthority
     * @param requestCorrelationId
     */ StandardInteractionClient.prototype.getDiscoveredAuthority = function(requestAuthority, requestAzureCloudOptions) {
        var _a;
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var getAuthorityMeasurement, authorityOptions, userAuthority, builtAuthority;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
                        this.logger.verbose("getDiscoveredAuthority called", this.correlationId);
                        getAuthorityMeasurement = (_a = this.performanceClient) === null || _a === void 0 ? void 0 : _a.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
                        authorityOptions = {
                            protocolMode: this.config.auth.protocolMode,
                            knownAuthorities: this.config.auth.knownAuthorities,
                            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                            authorityMetadata: this.config.auth.authorityMetadata,
                            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
                        };
                        userAuthority = requestAuthority ? requestAuthority : this.config.auth.authority;
                        builtAuthority = (0, $08caa87d494f4ccf$export$f1c6ec2e6d68c49c).generateAuthority(userAuthority, requestAzureCloudOptions || this.config.auth.azureCloudOptions);
                        this.logger.verbose("Creating discovered authority with configured authority", this.correlationId);
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            (0, $188344d4eb4caccf$export$4b476259e3402a97).createDiscoveredInstance(builtAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger, this.performanceClient, this.correlationId).then(function(result) {
                                getAuthorityMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            }).catch(function(error) {
                                getAuthorityMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _b.sent()
                        ];
                }
            });
        });
    };
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */ StandardInteractionClient.prototype.initializeAuthorizationRequest = function(request, interactionType) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var redirectUri, browserState, state, validatedRequest, _a, account, legacyLoginHint;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.correlationId);
                        this.logger.verbose("initializeAuthorizationRequest called", this.correlationId);
                        redirectUri = this.getRedirectUri(request.redirectUri);
                        browserState = {
                            interactionType: interactionType
                        };
                        state = (0, $43862c84d67ae4c1$export$871e33217042c65e).setRequestState(this.browserCrypto, request && request.state || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, browserState);
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).InitializeBaseRequest, this.correlationId);
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            this.initializeBaseRequest(request)
                        ];
                    case 1:
                        validatedRequest = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b).apply(void 0, [
                            (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b).apply(void 0, _a.concat([
                                _b.sent()
                            ])),
                            {
                                redirectUri: redirectUri,
                                state: state,
                                nonce: request.nonce || this.browserCrypto.createNewGuid(),
                                responseMode: (0, $1b76d687a319d9ed$export$f990a5bae1260b8c).FRAGMENT
                            }
                        ]);
                        account = request.account || this.browserStorage.getActiveAccount();
                        if (account) {
                            this.logger.verbose("Setting validated request account", this.correlationId);
                            this.logger.verbosePii("Setting validated request account: " + account.homeAccountId, this.correlationId);
                            validatedRequest.account = account;
                        }
                        // Check for ADAL/MSAL v1 SSO
                        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(validatedRequest.loginHint) && !account) {
                            legacyLoginHint = this.browserStorage.getLegacyLoginHint();
                            if (legacyLoginHint) validatedRequest.loginHint = legacyLoginHint;
                        }
                        return [
                            2 /*return*/ ,
                            validatedRequest
                        ];
                }
            });
        });
    };
    return StandardInteractionClient;
}((0, $fca38100868b2f7f$export$d858565f81c03f1f));





/*! @azure/msal-browser v2.37.1 2023-06-07 */ 



/*! @azure/msal-browser v2.37.1 2023-06-07 */ 


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $6b6150874d021a33$export$6154327c09fa1b4d;
(function(NativeStatusCode) {
    NativeStatusCode["USER_INTERACTION_REQUIRED"] = "USER_INTERACTION_REQUIRED";
    NativeStatusCode["USER_CANCEL"] = "USER_CANCEL";
    NativeStatusCode["NO_NETWORK"] = "NO_NETWORK";
    NativeStatusCode["TRANSIENT_ERROR"] = "TRANSIENT_ERROR";
    NativeStatusCode["PERSISTENT_ERROR"] = "PERSISTENT_ERROR";
    NativeStatusCode["DISABLED"] = "DISABLED";
    NativeStatusCode["ACCOUNT_UNAVAILABLE"] = "ACCOUNT_UNAVAILABLE";
})($6b6150874d021a33$export$6154327c09fa1b4d || ($6b6150874d021a33$export$6154327c09fa1b4d = {}));
var $6b6150874d021a33$export$a91608f60d986622 = {
    extensionError: {
        code: "ContentError"
    },
    userSwitch: {
        code: "user_switch",
        desc: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
    },
    tokensNotFoundInCache: {
        code: "tokens_not_found_in_internal_memory_cache",
        desc: "Tokens not cached in MSAL JS internal memory, please make the WAM request"
    }
};
var $6b6150874d021a33$export$4b8a4f6256e840ab = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(NativeAuthError, _super);
    function NativeAuthError(errorCode, description, ext) {
        var _this = _super.call(this, errorCode, description) || this;
        Object.setPrototypeOf(_this, NativeAuthError.prototype);
        _this.name = "NativeAuthError";
        _this.ext = ext;
        return _this;
    }
    /**
     * These errors should result in a fallback to the 'standard' browser based auth flow.
     */ NativeAuthError.prototype.isFatal = function() {
        if (this.ext && this.ext.status && (this.ext.status === $6b6150874d021a33$export$6154327c09fa1b4d.PERSISTENT_ERROR || this.ext.status === $6b6150874d021a33$export$6154327c09fa1b4d.DISABLED)) return true;
        switch(this.errorCode){
            case $6b6150874d021a33$export$a91608f60d986622.extensionError.code:
                return true;
            default:
                return false;
        }
    };
    /**
     * Create the appropriate error object based on the WAM status code.
     * @param code
     * @param description
     * @param ext
     * @returns
     */ NativeAuthError.createError = function(code, description, ext) {
        if (ext && ext.status) switch(ext.status){
            case $6b6150874d021a33$export$6154327c09fa1b4d.ACCOUNT_UNAVAILABLE:
                return (0, $dec424bb7347a355$export$6ba3e818c6bc76ba).createNativeAccountUnavailableError();
            case $6b6150874d021a33$export$6154327c09fa1b4d.USER_INTERACTION_REQUIRED:
                return new (0, $dec424bb7347a355$export$6ba3e818c6bc76ba)(code, description);
            case $6b6150874d021a33$export$6154327c09fa1b4d.USER_CANCEL:
                return (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUserCancelledError();
            case $6b6150874d021a33$export$6154327c09fa1b4d.NO_NETWORK:
                return (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNoNetworkConnectivityError();
        }
        return new NativeAuthError(code, description, ext);
    };
    /**
     * Creates user switch error when the user chooses a different account in the native broker prompt
     * @returns
     */ NativeAuthError.createUserSwitchError = function() {
        return new NativeAuthError($6b6150874d021a33$export$a91608f60d986622.userSwitch.code, $6b6150874d021a33$export$a91608f60d986622.userSwitch.desc);
    };
    /**
     * Creates a tokens not found error when the internal cache look up fails
     * @returns NativeAuthError: tokensNotFoundInCache
     */ NativeAuthError.createTokensNotFoundInCacheError = function() {
        return new NativeAuthError($6b6150874d021a33$export$a91608f60d986622.tokensNotFoundInCache.code, $6b6150874d021a33$export$a91608f60d986622.tokensNotFoundInCache.desc);
    };
    return NativeAuthError;
}((0, $7f0aeee92385582d$export$145273558d58e0ac));



/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

/*! @azure/msal-common v13.1.0 2023-06-07 */ 



/*! @azure/msal-common v13.1.0 2023-06-07 */ 















"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * OAuth2.0 refresh token client
 */ var $c49c56ec754e9bf1$export$9cb096b89b92d8a8 = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(RefreshTokenClient, _super);
    function RefreshTokenClient(configuration, performanceClient) {
        return _super.call(this, configuration, performanceClient) || this;
    }
    RefreshTokenClient.prototype.acquireToken = function(request) {
        var _a, _b, _c, _d, _e, _f, _g;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var atsMeasurement, reqTimestamp, response, httpVerToken, requestId, responseHandler;
            var _this = this;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_h) {
                switch(_h.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
                        atsMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
                        this.logger.verbose("RefreshTokenClientAcquireToken called", request.correlationId);
                        reqTimestamp = (0, $7efd823b057a2db4$export$3117a0de16ab2854).nowSeconds();
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.executeTokenRequest(request, this.authority)
                        ];
                    case 1:
                        response = _h.sent();
                        httpVerToken = (_d = response.headers) === null || _d === void 0 ? void 0 : _d[(0, $1b76d687a319d9ed$export$28d77f87efed1d88).X_MS_HTTP_VERSION];
                        atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.addStaticFields({
                            refreshTokenSize: ((_e = response.body.refresh_token) === null || _e === void 0 ? void 0 : _e.length) || 0
                        });
                        if (httpVerToken) atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.addStaticFields({
                            httpVerToken: httpVerToken
                        });
                        requestId = (_f = response.headers) === null || _f === void 0 ? void 0 : _f[(0, $1b76d687a319d9ed$export$28d77f87efed1d88).X_MS_REQUEST_ID];
                        responseHandler = new (0, $61eec8e2bbef8abe$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
                        responseHandler.validateTokenResponse(response.body);
                        (_g = this.performanceClient) === null || _g === void 0 || _g.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).HandleServerTokenResponse, request.correlationId);
                        return [
                            2 /*return*/ ,
                            responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request, undefined, undefined, true, request.forceCache, requestId).then(function(result) {
                                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            }).catch(function(error) {
                                _this.logger.verbose("Error in fetching refresh token", request.correlationId);
                                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ RefreshTokenClient.prototype.acquireTokenByRefreshToken = function(request) {
        var _a, _b, _c, _d;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var isFOCI, noFamilyRTInCache, clientMismatchErrorWithFamilyRT;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_e) {
                // Cannot renew token if no request object is given.
                if (!request) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createEmptyTokenRequestError();
                (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
                // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
                if (!request.account) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNoAccountInSilentRequestError();
                isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment);
                // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
                if (isFOCI) try {
                    (_b = this.performanceClient) === null || _b === void 0 || _b.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                    return [
                        2 /*return*/ ,
                        this.acquireTokenWithCachedRefreshToken(request, true)
                    ];
                } catch (e) {
                    noFamilyRTInCache = e instanceof (0, $dec424bb7347a355$export$6ba3e818c6bc76ba) && e.errorCode === (0, $dec424bb7347a355$export$d44d3b7b7a580eb6).noTokensFoundError.code;
                    clientMismatchErrorWithFamilyRT = e instanceof (0, $b198a6cc5c52ae21$export$ea52035eac03daf0) && e.errorCode === (0, $1b76d687a319d9ed$export$b8e9cd941e8016ac).INVALID_GRANT_ERROR && e.subError === (0, $1b76d687a319d9ed$export$b8e9cd941e8016ac).CLIENT_MISMATCH_ERROR;
                    // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
                    if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) {
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                        return [
                            2 /*return*/ ,
                            this.acquireTokenWithCachedRefreshToken(request, false)
                        ];
                    // throw in all other cases
                    } else throw e;
                }
                // fall back to application refresh token acquisition
                (_d = this.performanceClient) === null || _d === void 0 || _d.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                return [
                    2 /*return*/ ,
                    this.acquireTokenWithCachedRefreshToken(request, false)
                ];
            });
        });
    };
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ RefreshTokenClient.prototype.acquireTokenWithCachedRefreshToken = function(request, foci) {
        var _a, _b, _c;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var atsMeasurement, refreshToken, refreshTokenRequest;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_d) {
                (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                atsMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
                this.logger.verbose("RefreshTokenClientAcquireTokenWithCachedRefreshToken called", request.correlationId);
                refreshToken = this.cacheManager.getRefreshToken(request.account, foci);
                if (!refreshToken) {
                    atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.discardMeasurement();
                    throw (0, $dec424bb7347a355$export$6ba3e818c6bc76ba).createNoTokensFoundError();
                }
                // attach cached RT size to the current measurement
                atsMeasurement === null || atsMeasurement === void 0 || atsMeasurement.endMeasurement({
                    success: true
                });
                refreshTokenRequest = (0, $35bd2ff9e18a8648$export$18ce0697a983be9b)((0, $35bd2ff9e18a8648$export$18ce0697a983be9b)({}, request), {
                    refreshToken: refreshToken.secret,
                    authenticationScheme: request.authenticationScheme || (0, $1b76d687a319d9ed$export$901491a717da2ba5).BEARER,
                    ccsCredential: {
                        credential: request.account.homeAccountId,
                        type: (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
                    }
                });
                (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
                return [
                    2 /*return*/ ,
                    this.acquireToken(refreshTokenRequest)
                ];
            });
        });
    };
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ RefreshTokenClient.prototype.executeTokenRequest = function(request, authority) {
        var _a, _b, _c;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var acquireTokenMeasurement, queryParametersString, endpoint, requestBody, headers, thumbprint;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
                        acquireTokenMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
                        queryParametersString = this.createTokenQueryParameters(request);
                        endpoint = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
                        return [
                            4 /*yield*/ ,
                            this.createTokenRequestBody(request)
                        ];
                    case 1:
                        requestBody = _d.sent();
                        headers = this.createTokenRequestHeaders(request.ccsCredential);
                        thumbprint = {
                            clientId: this.config.authOptions.clientId,
                            authority: authority.canonicalAuthority,
                            scopes: request.scopes,
                            claims: request.claims,
                            authenticationScheme: request.authenticationScheme,
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            sshKid: request.sshKid
                        };
                        return [
                            2 /*return*/ ,
                            this.executePostToTokenEndpoint(endpoint, requestBody, headers, thumbprint).then(function(result) {
                                acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 || acquireTokenMeasurement.endMeasurement({
                                    success: true
                                });
                                return result;
                            }).catch(function(error) {
                                acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 || acquireTokenMeasurement.endMeasurement({
                                    success: false
                                });
                                throw error;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Helper function to create the token request body
     * @param request
     */ RefreshTokenClient.prototype.createTokenRequestBody = function(request) {
        var _a, _b, _c;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, acquireTokenMeasurement, parameterBuilder, clientAssertion, popTokenGenerator, reqCnfData, clientInfo;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        (_a = this.performanceClient) === null || _a === void 0 || _a.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
                        correlationId = request.correlationId;
                        acquireTokenMeasurement = (_b = this.performanceClient) === null || _b === void 0 ? void 0 : _b.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).BaseClientCreateTokenRequestHeaders, correlationId);
                        parameterBuilder = new (0, $310de39a31effb4f$export$882078dd8a9e0bfa)();
                        parameterBuilder.addClientId(this.config.authOptions.clientId);
                        parameterBuilder.addScopes(request.scopes);
                        parameterBuilder.addGrantType((0, $1b76d687a319d9ed$export$ce68f19b50b39c0b).REFRESH_TOKEN_GRANT);
                        parameterBuilder.addClientInfo();
                        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
                        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
                        parameterBuilder.addThrottling();
                        if (this.serverTelemetryManager) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
                        parameterBuilder.addCorrelationId(correlationId);
                        parameterBuilder.addRefreshToken(request.refreshToken);
                        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
                        if (this.config.clientCredentials.clientAssertion) {
                            clientAssertion = this.config.clientCredentials.clientAssertion;
                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
                        }
                        if (!(request.authenticationScheme === (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        popTokenGenerator = new (0, $6ca44babb2872b58$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
                        (_c = this.performanceClient) === null || _c === void 0 || _c.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.generateCnf(request)
                        ];
                    case 1:
                        reqCnfData = _d.sent();
                        // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
                        parameterBuilder.addPopToken(reqCnfData.reqCnfString);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (request.authenticationScheme === (0, $1b76d687a319d9ed$export$901491a717da2ba5).SSH) {
                            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
                            else {
                                acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 || acquireTokenMeasurement.endMeasurement({
                                    success: false
                                });
                                throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createMissingSshJwkError();
                            }
                        }
                        _d.label = 3;
                    case 3:
                        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
                        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
                            case (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                                try {
                                    clientInfo = (0, $c78bc4095f73f45d$export$63508a6d6b7dbe07)(request.ccsCredential.credential);
                                    parameterBuilder.addCcsOid(clientInfo);
                                } catch (e) {
                                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                                }
                                break;
                            case (0, $8ac3ff1b00f89083$export$17b7b3ac1abef49f).UPN:
                                parameterBuilder.addCcsUpn(request.ccsCredential.credential);
                                break;
                        }
                        acquireTokenMeasurement === null || acquireTokenMeasurement === void 0 || acquireTokenMeasurement.endMeasurement({
                            success: true
                        });
                        return [
                            2 /*return*/ ,
                            parameterBuilder.createQueryString()
                        ];
                }
            });
        });
    };
    return RefreshTokenClient;
}((0, $a9ce84fba6ce70d2$export$4f22f74eddb7716a));






"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $2da6e487cef6c056$export$e344f5b12c464597 = /** @class */ function(_super) {
    (0, $35bd2ff9e18a8648$export$a8ba968b8961cb8a)(SilentFlowClient, _super);
    function SilentFlowClient(configuration, performanceClient) {
        return _super.call(this, configuration, performanceClient) || this;
    }
    /**
     * Retrieves a token from cache if it is still valid, or uses the cached refresh token to renew
     * the given token and returns the renewed token
     * @param request
     */ SilentFlowClient.prototype.acquireToken = function(request) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var e_1, refreshTokenClient;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.acquireCachedToken(request)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $30cd164be78785f3$export$a839ff85a7957561) && e_1.errorCode === (0, $30cd164be78785f3$export$51eee17394e135b).tokenRefreshRequired.code) {
                            refreshTokenClient = new (0, $c49c56ec754e9bf1$export$9cb096b89b92d8a8)(this.config, this.performanceClient);
                            return [
                                2 /*return*/ ,
                                refreshTokenClient.acquireTokenByRefreshToken(request)
                            ];
                        } else throw e_1;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ SilentFlowClient.prototype.acquireCachedToken = function(request) {
        var _a, _b, _c, _d;
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var environment, cacheRecord;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        // Cannot renew token if no request object is given.
                        if (!request) throw (0, $00955c54f5ad4b2a$export$ac9d9d20c2327339).createEmptyTokenRequestError();
                        if (request.forceRefresh) {
                            // Must refresh due to present force_refresh flag.
                            (_a = this.serverTelemetryManager) === null || _a === void 0 || _a.setCacheOutcome((0, $1b76d687a319d9ed$export$aa4af185ea049f6b).FORCE_REFRESH);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Skipping cache because forceRefresh is true.");
                            throw (0, $30cd164be78785f3$export$a839ff85a7957561).createRefreshRequiredError();
                        }
                        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
                        if (!request.account) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNoAccountInSilentRequestError();
                        environment = request.authority || this.authority.getPreferredCache();
                        cacheRecord = this.cacheManager.readCacheRecord(request.account, request, environment);
                        if (!cacheRecord.accessToken) {
                            // Must refresh due to non-existent access_token.
                            (_b = this.serverTelemetryManager) === null || _b === void 0 || _b.setCacheOutcome((0, $1b76d687a319d9ed$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN);
                            this.logger.info("SilentFlowClient:acquireCachedToken - No access token found in cache for the given properties.");
                            throw (0, $30cd164be78785f3$export$a839ff85a7957561).createRefreshRequiredError();
                        } else if ((0, $7efd823b057a2db4$export$3117a0de16ab2854).wasClockTurnedBack(cacheRecord.accessToken.cachedAt) || (0, $7efd823b057a2db4$export$3117a0de16ab2854).isTokenExpired(cacheRecord.accessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
                            // Must refresh due to expired access_token.
                            (_c = this.serverTelemetryManager) === null || _c === void 0 || _c.setCacheOutcome((0, $1b76d687a319d9ed$export$aa4af185ea049f6b).CACHED_ACCESS_TOKEN_EXPIRED);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token is expired or will expire within " + this.config.systemOptions.tokenRenewalOffsetSeconds + " seconds.");
                            throw (0, $30cd164be78785f3$export$a839ff85a7957561).createRefreshRequiredError();
                        } else if (cacheRecord.accessToken.refreshOn && (0, $7efd823b057a2db4$export$3117a0de16ab2854).isTokenExpired(cacheRecord.accessToken.refreshOn, 0)) {
                            // Must refresh due to the refresh_in value.
                            (_d = this.serverTelemetryManager) === null || _d === void 0 || _d.setCacheOutcome((0, $1b76d687a319d9ed$export$aa4af185ea049f6b).REFRESH_CACHED_ACCESS_TOKEN);
                            this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token's refreshOn property has been exceeded'.");
                            throw (0, $30cd164be78785f3$export$a839ff85a7957561).createRefreshRequiredError();
                        }
                        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
                        return [
                            4 /*yield*/ ,
                            this.generateResultFromCacheRecord(cacheRecord, request)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _e.sent()
                        ];
                }
            });
        });
    };
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ SilentFlowClient.prototype.generateResultFromCacheRecord = function(cacheRecord, request) {
        return (0, $35bd2ff9e18a8648$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var idTokenObj, authTime;
            return (0, $35bd2ff9e18a8648$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (cacheRecord.idToken) idTokenObj = new (0, $88f623fdecedc666$export$3a170961dab30083)(cacheRecord.idToken.secret, this.config.cryptoInterface);
                        // token max_age check
                        if (request.maxAge || request.maxAge === 0) {
                            authTime = idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.auth_time;
                            if (!authTime) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createAuthTimeNotFoundError();
                            (0, $88f623fdecedc666$export$3a170961dab30083).checkMaxAge(authTime, request.maxAge);
                        }
                        return [
                            4 /*yield*/ ,
                            (0, $61eec8e2bbef8abe$export$f456c9835cc63582).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenObj)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return SilentFlowClient;
}((0, $a9ce84fba6ce70d2$export$4f22f74eddb7716a));




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $1d1eca9cf4a95a8a$export$59d4f873ee62d01e = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(SilentCacheClient, _super);
    function SilentCacheClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ SilentCacheClient.prototype.acquireToken = function(silentRequest) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var acquireTokenMeasurement, serverTelemetryManager, silentAuthClient, cachedToken, error_1;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        acquireTokenMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, silentRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
                        return [
                            4 /*yield*/ ,
                            this.createSilentFlowClient(serverTelemetryManager, silentRequest.authority, silentRequest.azureCloudOptions)
                        ];
                    case 1:
                        silentAuthClient = _a.sent();
                        this.logger.verbose("Silent auth client created");
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            silentAuthClient.acquireCachedToken(silentRequest)
                        ];
                    case 3:
                        cachedToken = _a.sent();
                        acquireTokenMeasurement.endMeasurement({
                            success: true,
                            fromCache: true
                        });
                        return [
                            2 /*return*/ ,
                            cachedToken
                        ];
                    case 4:
                        error_1 = _a.sent();
                        if (error_1 instanceof (0, $68ecaba305c397db$export$f8eb6760ca13876a) && error_1.errorCode === (0, $68ecaba305c397db$export$6deffaef56f0bd5a).signingKeyNotFoundInStorage.code) this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair.");
                        acquireTokenMeasurement.endMeasurement({
                            errorCode: error_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac) && error_1.errorCode || undefined,
                            subErrorCode: error_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac) && error_1.subError || undefined,
                            success: false
                        });
                        throw error_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */ SilentCacheClient.prototype.logout = function() {
        // Synchronous so we must reject
        return Promise.reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createSilentLogoutUnsupportedError());
    };
    /**
     * Creates an Silent Flow Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */ SilentCacheClient.prototype.createSilentFlowClient = function(serverTelemetryManager, authorityUrl, azureCloudOptions) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientConfig;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Create auth module.
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getClientConfiguration(serverTelemetryManager, authorityUrl, azureCloudOptions)
                        ];
                    case 1:
                        clientConfig = _a.sent();
                        return [
                            2 /*return*/ ,
                            new (0, $2da6e487cef6c056$export$e344f5b12c464597)(clientConfig, this.performanceClient)
                        ];
                }
            });
        });
    };
    SilentCacheClient.prototype.initializeSilentRequest = function(request, account) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var _a;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).InitializeSilentRequest, this.correlationId);
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).InitializeBaseRequest, this.correlationId);
                        _a = [
                            (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.initializeBaseRequest(request, account)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b).apply(void 0, [
                                (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b).apply(void 0, _a.concat([
                                    _b.sent()
                                ])),
                                {
                                    account: account,
                                    forceRefresh: request.forceRefresh || false
                                }
                            ])
                        ];
                }
            });
        });
    };
    return SilentCacheClient;
}((0, $4eafc7ca6d6f2ff1$export$fa9179cade3eb05a));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $6295e6242c57d6a1$export$38af86d4cb90fd61 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(NativeInteractionClient, _super);
    function NativeInteractionClient(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId) {
        var _this = _super.call(this, config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId) || this;
        _this.apiId = apiId;
        _this.accountId = accountId;
        _this.nativeMessageHandler = provider;
        _this.nativeStorageManager = nativeStorageImpl;
        _this.silentCacheClient = new (0, $1d1eca9cf4a95a8a$export$59d4f873ee62d01e)(config, _this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        return _this;
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ NativeInteractionClient.prototype.acquireToken = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var nativeATMeasurement, reqTimestamp, nativeRequest, result, messageBody, response, validatedResponse;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - acquireToken called.");
                        nativeATMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
                        reqTimestamp = (0, $7efd823b057a2db4$export$3117a0de16ab2854).nowSeconds();
                        return [
                            4 /*yield*/ ,
                            this.initializeNativeRequest(request)
                        ];
                    case 1:
                        nativeRequest = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.acquireTokensFromCache(this.accountId, nativeRequest)
                        ];
                    case 3:
                        result = _a.sent();
                        nativeATMeasurement.endMeasurement({
                            success: true,
                            isNativeBroker: false,
                            fromCache: true
                        });
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 4:
                        _a.sent();
                        // continue with a native call for any and all errors
                        this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call");
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        messageBody = {
                            method: (0, $7b3089fdde5d004f$export$3536098be6c7dadb).GetToken,
                            request: nativeRequest
                        };
                        return [
                            4 /*yield*/ ,
                            this.nativeMessageHandler.sendMessage(messageBody)
                        ];
                    case 6:
                        response = _a.sent();
                        validatedResponse = this.validateNativeResponse(response);
                        return [
                            2 /*return*/ ,
                            this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then(function(result) {
                                nativeATMeasurement.endMeasurement({
                                    success: true,
                                    isNativeBroker: true,
                                    requestId: result.requestId
                                });
                                return result;
                            }).catch(function(error) {
                                nativeATMeasurement.endMeasurement({
                                    success: false,
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    isNativeBroker: true
                                });
                                throw error;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ NativeInteractionClient.prototype.createSilentCacheRequest = function(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(request.scope).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    };
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ NativeInteractionClient.prototype.acquireTokensFromCache = function(nativeAccountId, request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var account, silentRequest, result, e_2;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!nativeAccountId) {
                            this.logger.warning("NativeInteractionClient:acquireTokensFromCache - No nativeAccountId provided");
                            throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNoAccountFoundError();
                        }
                        account = this.browserStorage.getAccountInfoFilteredBy({
                            nativeAccountId: nativeAccountId
                        });
                        if (!account) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createNoAccountFoundError();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        silentRequest = this.createSilentCacheRequest(request, account);
                        return [
                            4 /*yield*/ ,
                            this.silentCacheClient.acquireToken(silentRequest)
                        ];
                    case 2:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        e_2 = _a.sent();
                        throw e_2;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param request
     */ NativeInteractionClient.prototype.acquireTokenRedirect = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var nativeRequest, messageBody, response, e_3, navigationOptions, redirectUri;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - acquireTokenRedirect called.");
                        return [
                            4 /*yield*/ ,
                            this.initializeNativeRequest(request)
                        ];
                    case 1:
                        nativeRequest = _a.sent();
                        messageBody = {
                            method: (0, $7b3089fdde5d004f$export$3536098be6c7dadb).GetToken,
                            request: nativeRequest
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.nativeMessageHandler.sendMessage(messageBody)
                        ];
                    case 3:
                        response = _a.sent();
                        this.validateNativeResponse(response);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_3 = _a.sent();
                        // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
                        if (e_3 instanceof (0, $6b6150874d021a33$export$4b8a4f6256e840ab) && e_3.isFatal()) throw e_3;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.browserStorage.setTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
                        navigationOptions = {
                            apiId: (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenRedirect,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        redirectUri = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(request.redirectUri);
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateExternal(redirectUri, navigationOptions)
                        ];
                    case 6:
                        _a.sent(); // Need to treat this as external to ensure handleRedirectPromise is run again
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     */ NativeInteractionClient.prototype.handleRedirectPromise = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var cachedRequest, prompt, request, messageBody, reqTimestamp, response, result, e_4;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - handleRedirectPromise called.");
                        if (!this.browserStorage.isInteractionInProgress(true)) {
                            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        cachedRequest = this.browserStorage.getCachedNativeRequest();
                        if (!cachedRequest) {
                            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null.");
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        prompt = cachedRequest.prompt, request = (0, $ac3fbc8ec7de8c8c$export$3c9a16f847548506)(cachedRequest, [
                            "prompt"
                        ]);
                        if (prompt) this.logger.verbose("NativeInteractionClient - handleRedirectPromise called and prompt was included in the original request, removing prompt from cached request to prevent second interaction with native broker window.");
                        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).NATIVE_REQUEST));
                        messageBody = {
                            method: (0, $7b3089fdde5d004f$export$3536098be6c7dadb).GetToken,
                            request: request
                        };
                        reqTimestamp = (0, $7efd823b057a2db4$export$3117a0de16ab2854).nowSeconds();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker.");
                        return [
                            4 /*yield*/ ,
                            this.nativeMessageHandler.sendMessage(messageBody)
                        ];
                    case 2:
                        response = _a.sent();
                        this.validateNativeResponse(response);
                        result = this.handleNativeResponse(response, request, reqTimestamp);
                        this.browserStorage.setInteractionInProgress(false);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        e_4 = _a.sent();
                        this.browserStorage.setInteractionInProgress(false);
                        throw e_4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Logout from native platform via browser extension
     * @param request
     */ NativeInteractionClient.prototype.logout = function() {
        this.logger.trace("NativeInteractionClient - logout called.");
        return Promise.reject("Logout not implemented yet");
    };
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ NativeInteractionClient.prototype.handleNativeResponse = function(response, request, reqTimestamp) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authority, authorityPreferredCache, idTokenObj, homeAccountIdentifier, accountEntity, result;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - handleNativeResponse called.");
                        if (response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
                        throw (0, $6b6150874d021a33$export$4b8a4f6256e840ab).createUserSwitchError();
                        return [
                            4 /*yield*/ ,
                            this.getDiscoveredAuthority(request.authority)
                        ];
                    case 1:
                        authority = _a.sent();
                        authorityPreferredCache = authority.getPreferredCache();
                        idTokenObj = this.createIdTokenObj(response);
                        homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenObj);
                        accountEntity = this.createAccountEntity(response, homeAccountIdentifier, idTokenObj, authorityPreferredCache);
                        return [
                            4 /*yield*/ ,
                            this.generateAuthenticationResult(response, request, idTokenObj, accountEntity, authority.canonicalAuthority, reqTimestamp)
                        ];
                    case 2:
                        result = _a.sent();
                        // cache accounts and tokens in the appropriate storage
                        this.cacheAccount(accountEntity);
                        this.cacheNativeTokens(response, request, homeAccountIdentifier, accountEntity, idTokenObj, result.accessToken, result.tenantId, reqTimestamp);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * Create an idToken Object (not entity)
     * @param response
     * @returns
     */ NativeInteractionClient.prototype.createIdTokenObj = function(response) {
        return new (0, $88f623fdecedc666$export$3a170961dab30083)(response.id_token || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, this.browserCrypto);
    };
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ NativeInteractionClient.prototype.createHomeAccountIdentifier = function(response, idTokenObj) {
        // Save account in browser storage
        var homeAccountIdentifier = (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).generateHomeAccountId(response.client_info || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, (0, $26d2ec0e655e729b$export$cd82032b224a3839).Default, this.logger, this.browserCrypto, idTokenObj);
        return homeAccountIdentifier;
    };
    /**
     * Creates account entity
     * @param response
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param authority
     * @returns
     */ NativeInteractionClient.prototype.createAccountEntity = function(response, homeAccountIdentifier, idTokenObj, authority) {
        return (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).createAccount(response.client_info, homeAccountIdentifier, idTokenObj, undefined, undefined, undefined, authority, response.account.id);
    };
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ NativeInteractionClient.prototype.generateScopes = function(response, request) {
        return response.scope ? (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(request.scope);
    };
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ NativeInteractionClient.prototype.generatePopAccessToken = function(response, request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var popTokenGenerator, shrParameters;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(request.tokenType === (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            2
                        ];
                        /**
                         * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
                         * is still received, SHR is calculated locally
                         */ // Check if native layer returned an SHR token
                        if (response.shr) {
                            this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer");
                            return [
                                2 /*return*/ ,
                                response.shr
                            ];
                        }
                        popTokenGenerator = new (0, $6ca44babb2872b58$export$3dd8467151c83e3e)(this.browserCrypto);
                        shrParameters = {
                            resourceRequestMethod: request.resourceRequestMethod,
                            resourceRequestUri: request.resourceRequestUri,
                            shrClaims: request.shrClaims,
                            shrNonce: request.shrNonce
                        };
                        /**
                         * KeyID must be present in the native request from when the PoP key was generated in order for
                         * PopTokenGenerator to query the full key for signing
                         */ if (!request.keyId) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createKeyIdMissingError();
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            response.access_token
                        ];
                }
            });
        });
    };
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ NativeInteractionClient.prototype.generateAuthenticationResult = function(response, request, idTokenObj, accountEntity, authority, reqTimestamp) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var mats, responseScopes, accountProperties, uid, tid, responseAccessToken, tokenType, result;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        mats = this.addTelemetryFromNativeResponse(response);
                        responseScopes = response.scope ? (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(request.scope);
                        accountProperties = response.account.properties || {};
                        uid = accountProperties["UID"] || idTokenObj.claims.oid || idTokenObj.claims.sub || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                        tid = accountProperties["TenantId"] || idTokenObj.claims.tid || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                        return [
                            4 /*yield*/ ,
                            this.generatePopAccessToken(response, request)
                        ];
                    case 1:
                        responseAccessToken = _a.sent();
                        tokenType = request.tokenType === (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP ? (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP : (0, $1b76d687a319d9ed$export$901491a717da2ba5).BEARER;
                        result = {
                            authority: authority,
                            uniqueId: uid,
                            tenantId: tid,
                            scopes: responseScopes.asArray(),
                            account: accountEntity.getAccountInfo(),
                            idToken: response.id_token,
                            idTokenClaims: idTokenObj.claims,
                            accessToken: responseAccessToken,
                            fromCache: mats ? this.isResponseFromCache(mats) : false,
                            expiresOn: new Date(Number(reqTimestamp + response.expires_in) * 1000),
                            tokenType: tokenType,
                            correlationId: this.correlationId,
                            state: response.state,
                            fromNativeBroker: true
                        };
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ NativeInteractionClient.prototype.cacheAccount = function(accountEntity) {
        var _this = this;
        // Store the account info and hence `nativeAccountId` in browser cache
        this.browserStorage.setAccount(accountEntity);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext(accountEntity).catch(function(e) {
            _this.logger.error("Error occurred while removing account context from browser storage. " + e);
        });
    };
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ NativeInteractionClient.prototype.cacheNativeTokens = function(response, request, homeAccountIdentifier, accountEntity, idTokenObj, responseAccessToken, tenantId, reqTimestamp) {
        var cachedIdToken = (0, $0c09c5966c1cc91f$export$49ed297fa7d02bde).createIdTokenEntity(homeAccountIdentifier, request.authority, response.id_token || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, request.clientId, idTokenObj.claims.tid || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING);
        // cache accessToken in inmemory storage
        var expiresIn = request.tokenType === (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP ? (0, $1b76d687a319d9ed$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        var tokenExpirationSeconds = reqTimestamp + expiresIn;
        var responseScopes = this.generateScopes(response, request);
        var cachedAccessToken = (0, $698539a43f4f793b$export$6b7a8e14ec177765).createAccessTokenEntity(homeAccountIdentifier, request.authority, responseAccessToken, request.clientId, idTokenObj ? idTokenObj.claims.tid || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING : tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, this.browserCrypto);
        var nativeCacheRecord = new (0, $4e2a602fb391f03c$export$5ee5669a32bdea66)(accountEntity, cachedIdToken, cachedAccessToken);
        this.nativeStorageManager.saveCacheRecord(nativeCacheRecord);
    };
    NativeInteractionClient.prototype.addTelemetryFromNativeResponse = function(response) {
        var mats = this.getMATSFromResponse(response);
        if (!mats) return null;
        this.performanceClient.addStaticFields({
            extensionId: this.nativeMessageHandler.getExtensionId(),
            extensionVersion: this.nativeMessageHandler.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    };
    /**
     * Validates native platform response before processing
     * @param response
     */ NativeInteractionClient.prototype.validateNativeResponse = function(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, $6b6150874d021a33$export$4b8a4f6256e840ab).createUnexpectedError("Response missing expected properties.");
    };
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ NativeInteractionClient.prototype.getMATSFromResponse = function(response) {
        if (response.properties.MATS) try {
            return JSON.parse(response.properties.MATS);
        } catch (e) {
            this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
        }
        return null;
    };
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ NativeInteractionClient.prototype.isResponseFromCache = function(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false.");
            return false;
        }
        return !!mats.is_cached;
    };
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ NativeInteractionClient.prototype.initializeNativeRequest = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authority, canonicalAuthority, scopes, remainingProperties, scopeSet, getPrompt, validatedRequest, shrParameters, popTokenGenerator, reqCnfData;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("NativeInteractionClient - initializeNativeRequest called");
                        authority = request.authority || this.config.auth.authority;
                        if (!request.account) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.validateRequestAuthority(authority, request.account)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        canonicalAuthority = new (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2)(authority);
                        canonicalAuthority.validateAsUri();
                        scopes = request.scopes, remainingProperties = (0, $ac3fbc8ec7de8c8c$export$3c9a16f847548506)(request, [
                            "scopes"
                        ]);
                        scopeSet = new (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99)(scopes || []);
                        scopeSet.appendScopes((0, $1b76d687a319d9ed$export$893b1b5b686d84ef));
                        getPrompt = function() {
                            // If request is silent, prompt is always none
                            switch(_this.apiId){
                                case (0, $7b3089fdde5d004f$export$192d74ad69b40705).ssoSilent:
                                case (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenSilent_silentFlow:
                                    _this.logger.trace("initializeNativeRequest: silent request sets prompt to none");
                                    return (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).NONE;
                            }
                            // Prompt not provided, request may proceed and native broker decides if it needs to prompt
                            if (!request.prompt) {
                                _this.logger.trace("initializeNativeRequest: prompt was not provided");
                                return undefined;
                            }
                            // If request is interactive, check if prompt provided is allowed to go directly to native broker
                            switch(request.prompt){
                                case (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).NONE:
                                case (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).CONSENT:
                                case (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).LOGIN:
                                    _this.logger.trace("initializeNativeRequest: prompt is compatible with native flow");
                                    return request.prompt;
                                default:
                                    _this.logger.trace("initializeNativeRequest: prompt = " + request.prompt + " is not compatible with native flow");
                                    throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNativePromptParameterNotSupportedError();
                            }
                        };
                        validatedRequest = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, remainingProperties), {
                            accountId: this.accountId,
                            clientId: this.config.auth.clientId,
                            authority: canonicalAuthority.urlString,
                            scope: scopeSet.printScopes(),
                            redirectUri: this.getRedirectUri(request.redirectUri),
                            prompt: getPrompt(),
                            correlationId: this.correlationId,
                            tokenType: request.authenticationScheme,
                            windowTitleSubstring: document.title,
                            extraParameters: (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request.extraQueryParameters), request.tokenQueryParameters), {
                                telemetry: (0, $7b3089fdde5d004f$export$fec113838800867f).MATS_TELEMETRY
                            }),
                            extendedExpiryToken: false // Make this configurable?
                        });
                        if (!(request.authenticationScheme === (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP)) return [
                            3 /*break*/ ,
                            4
                        ];
                        shrParameters = {
                            resourceRequestUri: request.resourceRequestUri,
                            resourceRequestMethod: request.resourceRequestMethod,
                            shrClaims: request.shrClaims,
                            shrNonce: request.shrNonce
                        };
                        popTokenGenerator = new (0, $6ca44babb2872b58$export$3dd8467151c83e3e)(this.browserCrypto);
                        return [
                            4 /*yield*/ ,
                            popTokenGenerator.generateCnf(shrParameters)
                        ];
                    case 3:
                        reqCnfData = _a.sent();
                        // to reduce the URL length, it is recommended to send the short form of the req_cnf 
                        validatedRequest.reqCnf = reqCnfData.reqCnfString;
                        validatedRequest.keyId = reqCnfData.kid;
                        _a.label = 4;
                    case 4:
                        return [
                            2 /*return*/ ,
                            validatedRequest
                        ];
                }
            });
        });
    };
    return NativeInteractionClient;
}((0, $fca38100868b2f7f$export$d858565f81c03f1f));


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $0342fe40e0ad80a3$export$c98888b8059e2702 = /** @class */ function() {
    function NativeMessageHandler(logger, handshakeTimeoutMs, performanceClient, extensionId) {
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.responseId = 0;
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).NativeMessageHandlerHandshake);
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param body
     */ NativeMessageHandler.prototype.sendMessage = function(body) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var req;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                this.logger.trace("NativeMessageHandler - sendMessage called.");
                req = {
                    channel: (0, $7b3089fdde5d004f$export$fec113838800867f).CHANNEL_ID,
                    extensionId: this.extensionId,
                    responseId: this.responseId++,
                    body: body
                };
                this.logger.trace("NativeMessageHandler - Sending request to browser extension");
                this.logger.tracePii("NativeMessageHandler - Sending request to browser extension: " + JSON.stringify(req));
                this.messageChannel.port1.postMessage(req);
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        _this.resolvers.set(req.responseId, {
                            resolve: resolve,
                            reject: reject
                        });
                    })
                ];
            });
        });
    };
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     */ NativeMessageHandler.createProvider = function(logger, handshakeTimeoutMs, performanceClient) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var preferredProvider, backupProvider;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        logger.trace("NativeMessageHandler - createProvider called.");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            5
                        ]);
                        preferredProvider = new NativeMessageHandler(logger, handshakeTimeoutMs, performanceClient, (0, $7b3089fdde5d004f$export$fec113838800867f).PREFERRED_EXTENSION_ID);
                        return [
                            4 /*yield*/ ,
                            preferredProvider.sendHandshakeRequest()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            preferredProvider
                        ];
                    case 3:
                        _a.sent();
                        backupProvider = new NativeMessageHandler(logger, handshakeTimeoutMs, performanceClient);
                        return [
                            4 /*yield*/ ,
                            backupProvider.sendHandshakeRequest()
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            backupProvider
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Send handshake request helper.
     */ NativeMessageHandler.prototype.sendHandshakeRequest = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var req;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                this.logger.trace("NativeMessageHandler - sendHandshakeRequest called.");
                // Register this event listener before sending handshake
                window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
                req = {
                    channel: (0, $7b3089fdde5d004f$export$fec113838800867f).CHANNEL_ID,
                    extensionId: this.extensionId,
                    responseId: this.responseId++,
                    body: {
                        method: (0, $7b3089fdde5d004f$export$3536098be6c7dadb).HandshakeRequest
                    }
                };
                this.handshakeEvent.addStaticFields({
                    extensionId: this.extensionId,
                    extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
                });
                this.messageChannel.port1.onmessage = function(event) {
                    _this.onChannelMessage(event);
                };
                window.postMessage(req, window.origin, [
                    this.messageChannel.port2
                ]);
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        _this.handshakeResolvers.set(req.responseId, {
                            resolve: resolve,
                            reject: reject
                        });
                        _this.timeoutId = window.setTimeout(function() {
                            /*
                             * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                             * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                             */ window.removeEventListener("message", _this.windowListener, false);
                            _this.messageChannel.port1.close();
                            _this.messageChannel.port2.close();
                            _this.handshakeEvent.endMeasurement({
                                extensionHandshakeTimedOut: true,
                                success: false
                            });
                            reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createNativeHandshakeTimeoutError());
                            _this.handshakeResolvers.delete(req.responseId);
                        }, _this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
                    })
                ];
            });
        });
    };
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ NativeMessageHandler.prototype.onWindowMessage = function(event) {
        this.logger.trace("NativeMessageHandler - onWindowMessage called");
        // We only accept messages from ourselves
        if (event.source !== window) return;
        var request = event.data;
        if (!request.channel || request.channel !== (0, $7b3089fdde5d004f$export$fec113838800867f).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, $7b3089fdde5d004f$export$3536098be6c7dadb).HandshakeRequest) {
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? "Extension with id: " + request.extensionId + " not installed" : "No extension installed");
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            var handshakeResolver = this.handshakeResolvers.get(request.responseId);
            if (handshakeResolver) {
                this.handshakeEvent.endMeasurement({
                    success: false,
                    extensionInstalled: false
                });
                handshakeResolver.reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createNativeExtensionNotInstalledError());
            }
        }
    };
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ NativeMessageHandler.prototype.onChannelMessage = function(event) {
        this.logger.trace("NativeMessageHandler - onChannelMessage called.");
        var request = event.data;
        var resolver = this.resolvers.get(request.responseId);
        var handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            var method = request.body.method;
            if (method === (0, $7b3089fdde5d004f$export$3536098be6c7dadb).Response) {
                if (!resolver) return;
                var response = request.body.response;
                this.logger.trace("NativeMessageHandler - Received response from browser extension");
                this.logger.tracePii("NativeMessageHandler - Received response from browser extension: " + JSON.stringify(response));
                if (response.status !== "Success") resolver.reject((0, $6b6150874d021a33$export$4b8a4f6256e840ab).createError(response.code, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, $6b6150874d021a33$export$4b8a4f6256e840ab).createError(response.result["code"], response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, $7f0aeee92385582d$export$145273558d58e0ac).createUnexpectedError("Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, $7b3089fdde5d004f$export$3536098be6c7dadb).HandshakeResponse) {
                if (!handshakeResolver) return;
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose("NativeMessageHandler - Received HandshakeResponse from extension: " + this.extensionId);
                this.handshakeEvent.endMeasurement({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("Error parsing response from WAM Extension");
            this.logger.errorPii("Error parsing response from WAM Extension: " + err.toString());
            this.logger.errorPii("Unable to parse " + event);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    };
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ NativeMessageHandler.prototype.getExtensionId = function() {
        return this.extensionId;
    };
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ NativeMessageHandler.prototype.getExtensionVersion = function() {
        return this.extensionVersion;
    };
    /**
     * Returns boolean indicating whether or not the request should attempt to use native broker
     * @param logger
     * @param config
     * @param nativeExtensionProvider
     * @param authenticationScheme
     */ NativeMessageHandler.isNativeAvailable = function(config, logger, nativeExtensionProvider, authenticationScheme) {
        logger.trace("isNativeAvailable called");
        if (!config.system.allowNativeBroker) {
            logger.trace("isNativeAvailable: allowNativeBroker is not enabled, returning false");
            // Developer disabled WAM
            return false;
        }
        if (!nativeExtensionProvider) {
            logger.trace("isNativeAvailable: WAM extension provider is not initialized, returning false");
            // Extension is not available
            return false;
        }
        if (authenticationScheme) switch(authenticationScheme){
            case (0, $1b76d687a319d9ed$export$901491a717da2ba5).BEARER:
            case (0, $1b76d687a319d9ed$export$901491a717da2ba5).POP:
                logger.trace("isNativeAvailable: authenticationScheme is supported, returning true");
                return true;
            default:
                logger.trace("isNativeAvailable: authenticationScheme is not supported, returning false");
                return false;
        }
        return true;
    };
    return NativeMessageHandler;
}();



/*! @azure/msal-browser v2.37.1 2023-06-07 */ 



"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ var $7acd28d32a2b7245$export$a30cd982b4e89bdb = /** @class */ function() {
    function InteractionHandler(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient) {
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ InteractionHandler.prototype.handleCodeResponseFromHash = function(locationHash, state, authority, networkModule) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stateKey, requestState, authCodeResponse;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).HandleCodeResponseFromHash, this.authCodeRequest.correlationId);
                this.logger.verbose("InteractionHandler.handleCodeResponse called");
                // Check that location hash isn't empty.
                if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(locationHash)) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createEmptyHashError(locationHash);
                stateKey = this.browserStorage.generateStateKey(state);
                requestState = this.browserStorage.getTemporaryCache(stateKey);
                if (!requestState) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createStateNotFoundError("Cached State");
                try {
                    authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
                } catch (e) {
                    if (e instanceof (0, $b198a6cc5c52ae21$export$ea52035eac03daf0) && e.subError === (0, $68ecaba305c397db$export$6deffaef56f0bd5a).userCancelledError.code) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
                    throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUserCancelledError();
                    else throw e;
                }
                this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.authCodeRequest.correlationId);
                return [
                    2 /*return*/ ,
                    this.handleCodeResponseFromServer(authCodeResponse, state, authority, networkModule)
                ];
            });
        });
    };
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param state
     * @param authority
     * @param networkModule
     * @returns
     */ InteractionHandler.prototype.handleCodeResponseFromServer = function(authCodeResponse, state, authority, networkModule, validateNonce) {
        if (validateNonce === void 0) validateNonce = true;
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stateKey, requestState, nonceKey, cachedNonce, cachedCcsCred, tokenResponse;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.authCodeRequest.correlationId);
                        this.logger.trace("InteractionHandler.handleCodeResponseFromServer called");
                        stateKey = this.browserStorage.generateStateKey(state);
                        requestState = this.browserStorage.getTemporaryCache(stateKey);
                        if (!requestState) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createStateNotFoundError("Cached State");
                        nonceKey = this.browserStorage.generateNonceKey(requestState);
                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
                        // Assign code to request
                        this.authCodeRequest.code = authCodeResponse.code;
                        if (!authCodeResponse.cloud_instance_host_name) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.authCodeRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
                        if (validateNonce) authCodeResponse.nonce = cachedNonce || undefined;
                        authCodeResponse.state = requestState;
                        // Add CCS parameters if available
                        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
                        else {
                            cachedCcsCred = this.checkCcsCredentials();
                            if (cachedCcsCred) this.authCodeRequest.ccsCredential = cachedCcsCred;
                        }
                        // Acquire token with retrieved code.
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AuthClientAcquireToken, this.authCodeRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)
                        ];
                    case 3:
                        tokenResponse = _a.sent();
                        this.browserStorage.cleanRequestByState(state);
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    };
    /**
     * Updates authority based on cloudInstanceHostname
     * @param cloudInstanceHostname
     * @param authority
     * @param networkModule
     */ InteractionHandler.prototype.updateTokenEndpointAuthority = function(cloudInstanceHostname, authority, networkModule) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var cloudInstanceAuthorityUri, cloudInstanceAuthority;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.authCodeRequest.correlationId);
                        cloudInstanceAuthorityUri = "https://" + cloudInstanceHostname + "/" + authority.tenant + "/";
                        return [
                            4 /*yield*/ ,
                            (0, $188344d4eb4caccf$export$4b476259e3402a97).createDiscoveredInstance(cloudInstanceAuthorityUri, networkModule, this.browserStorage, authority.options, this.logger, this.performanceClient, this.authCodeRequest.correlationId)
                        ];
                    case 1:
                        cloudInstanceAuthority = _a.sent();
                        this.authModule.updateAuthority(cloudInstanceAuthority);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Looks up ccs creds in the cache
     */ InteractionHandler.prototype.checkCcsCredentials = function() {
        // Look up ccs credential in temp cache
        var cachedCcsCred = this.browserStorage.getTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).CCS_CREDENTIAL, true);
        if (cachedCcsCred) try {
            return JSON.parse(cachedCcsCred);
        } catch (e) {
            this.authModule.logger.error("Cache credential could not be parsed");
            this.authModule.logger.errorPii("Cache credential could not be parsed: " + cachedCcsCred);
        }
        return null;
    };
    return InteractionHandler;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $25a90acdc8c2f00b$export$43b0fce132d066f4 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(PopupClient, _super);
    function PopupClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        // Properly sets this reference for the unload event.
        _this.unloadWindow = _this.unloadWindow.bind(_this);
        _this.nativeStorage = nativeStorageImpl;
        return _this;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     */ PopupClient.prototype.acquireToken = function(request) {
        try {
            var popupName = this.generatePopupName(request.scopes || (0, $1b76d687a319d9ed$export$893b1b5b686d84ef), request.authority || this.config.auth.authority);
            var popupWindowAttributes = request.popupWindowAttributes || {};
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true, acquiring token");
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupName, popupWindowAttributes);
            } else {
                // asyncPopups flag is set to false. Opens popup before acquiring token.
                this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
                var popup = this.openSizedPopup("about:blank", popupName, popupWindowAttributes);
                return this.acquireTokenPopupAsync(request, popupName, popupWindowAttributes, popup);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    };
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ PopupClient.prototype.logout = function(logoutRequest) {
        try {
            this.logger.verbose("logoutPopup called");
            var validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            var popupName = this.generateLogoutPopupName(validLogoutRequest);
            var authority = logoutRequest && logoutRequest.authority;
            var mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            var popupWindowAttributes = (logoutRequest === null || logoutRequest === void 0 ? void 0 : logoutRequest.popupWindowAttributes) || {};
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true");
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupName, popupWindowAttributes, authority, undefined, mainWindowRedirectUri);
            } else {
                // asyncPopups flag is set to false. Opens popup before logging out.
                this.logger.verbose("asyncPopup set to false, opening popup");
                var popup = this.openSizedPopup("about:blank", popupName, popupWindowAttributes);
                return this.logoutPopupAsync(validLogoutRequest, popupName, popupWindowAttributes, authority, popup, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    };
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param validRequest
     * @param popupName
     * @param popup
     * @param popupWindowAttributes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ PopupClient.prototype.acquireTokenPopupAsync = function(request, popupName, popupWindowAttributes, popup) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var serverTelemetryManager, validRequest, authCodeRequest, authClient, isNativeBroker, fetchNativeAccountIdMeasurement, navigateUrl, interactionHandler, popupParameters, popupWindow, hash, serverParams, state_1, nativeInteractionClient, userRequestState, result, e_1;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("acquireTokenPopupAsync called");
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenPopup);
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationRequest(request, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup)
                        ];
                    case 1:
                        validRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(validRequest.state, validRequest.nonce, validRequest.authority, validRequest.loginHint || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, validRequest.account || null);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            8,
                            ,
                            9
                        ]);
                        // Create auth code request and generate PKCE params
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationCodeRequest(validRequest)
                        ];
                    case 3:
                        authCodeRequest = _a.sent();
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, validRequest.authority, validRequest.azureCloudOptions)
                        ];
                    case 4:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        isNativeBroker = (0, $0342fe40e0ad80a3$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme);
                        fetchNativeAccountIdMeasurement = void 0;
                        if (isNativeBroker) fetchNativeAccountIdMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).FetchAccountIdWithNativeBroker, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            authClient.getAuthCodeUrl((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, validRequest), {
                                nativeBroker: isNativeBroker
                            }))
                        ];
                    case 5:
                        navigateUrl = _a.sent();
                        interactionHandler = new (0, $7acd28d32a2b7245$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
                        popupParameters = {
                            popup: popup,
                            popupName: popupName,
                            popupWindowAttributes: popupWindowAttributes
                        };
                        popupWindow = this.initiateAuthRequest(navigateUrl, popupParameters);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).POPUP_OPENED, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, {
                            popupWindow: popupWindow
                        }, null);
                        return [
                            4 /*yield*/ ,
                            this.monitorPopupForHash(popupWindow)
                        ];
                    case 6:
                        hash = _a.sent();
                        serverParams = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getDeserializedHash(hash);
                        state_1 = this.validateAndExtractStateFromHash(serverParams, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, validRequest.correlationId);
                        // Remove throttle if it exists
                        (0, $c78f3ba4540ca0dd$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, authCodeRequest);
                        if (serverParams.accountId) {
                            this.logger.verbose("Account id found in hash, calling WAM for token");
                            // end measurement for server call with native brokering enabled
                            if (fetchNativeAccountIdMeasurement) fetchNativeAccountIdMeasurement.endMeasurement({
                                success: true,
                                isNativeBroker: true
                            });
                            if (!this.nativeMessageHandler) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNativeConnectionNotEstablishedError();
                            nativeInteractionClient = new (0, $6295e6242c57d6a1$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, validRequest.correlationId);
                            userRequestState = (0, $43862c84d67ae4c1$export$871e33217042c65e).parseRequestState(this.browserCrypto, state_1).userRequestState;
                            return [
                                2 /*return*/ ,
                                nativeInteractionClient.acquireToken((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, validRequest), {
                                    state: userRequestState,
                                    prompt: undefined // Server should handle the prompt, ideally native broker can do this part silently
                                })).finally(function() {
                                    _this.browserStorage.cleanRequestByState(state_1);
                                })
                            ];
                        }
                        return [
                            4 /*yield*/ ,
                            interactionHandler.handleCodeResponseFromHash(hash, state_1, authClient.authority, this.networkClient)
                        ];
                    case 7:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 8:
                        e_1 = _a.sent();
                        if (popup) // Close the synchronous popup if an error is thrown before the window unload event is registered
                        popup.close();
                        if (e_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) e_1.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(validRequest.state);
                        throw e_1;
                    case 9:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ PopupClient.prototype.logoutPopupAsync = function(validRequest, popupName, popupWindowAttributes, requestAuthority, popup, mainWindowRedirectUri) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var serverTelemetryManager, authClient, logoutUri, popupWindow, navigationOptions, absoluteUrl, e_2;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("logoutPopupAsync called");
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, validRequest);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $7b3089fdde5d004f$export$192d74ad69b40705).logoutPopup);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        // Clear cache on logout
                        return [
                            4 /*yield*/ ,
                            this.clearCacheOnLogout(validRequest.account)
                        ];
                    case 2:
                        // Clear cache on logout
                        _a.sent();
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, validRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, requestAuthority)
                        ];
                    case 3:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        logoutUri = authClient.getLogoutUri(validRequest);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, validRequest);
                        popupWindow = this.openPopup(logoutUri, {
                            popupName: popupName,
                            popupWindowAttributes: popupWindowAttributes,
                            popup: popup
                        });
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).POPUP_OPENED, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, {
                            popupWindow: popupWindow
                        }, null);
                        return [
                            4 /*yield*/ ,
                            this.waitForLogoutPopup(popupWindow)
                        ];
                    case 4:
                        _a.sent();
                        if (mainWindowRedirectUri) {
                            navigationOptions = {
                                apiId: (0, $7b3089fdde5d004f$export$192d74ad69b40705).logoutPopup,
                                timeout: this.config.system.redirectNavigationTimeout,
                                noHistory: false
                            };
                            absoluteUrl = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $94c261d7c4faec3a$export$311899ae85124b2d).getCurrentUri());
                            this.logger.verbose("Redirecting main window to url specified in the request");
                            this.logger.verbosePii("Redirecting main window to: " + absoluteUrl);
                            this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                        } else this.logger.verbose("No main window navigation requested");
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        e_2 = _a.sent();
                        if (popup) // Close the synchronous popup if an error is thrown before the window unload event is registered
                        popup.close();
                        if (e_2 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) e_2.setCorrelationId(this.correlationId);
                        this.browserStorage.setInteractionInProgress(false);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, null, e_2);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_END, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup);
                        serverTelemetryManager.cacheFailedRequest(e_2);
                        throw e_2;
                    case 6:
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_END, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ PopupClient.prototype.initiateAuthRequest = function(requestUrl, params) {
        // Check that request url is not empty.
        if (!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(requestUrl)) {
            this.logger.infoPii("Navigate to: " + requestUrl);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("Navigate url is empty");
            throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createEmptyNavigationUriError();
        }
    };
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @param timeout - timeout for processing hash once popup is redirected back to application
     */ PopupClient.prototype.monitorPopupForHash = function(popupWindow) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            /*
             * Polling for popups needs to be tick-based,
             * since a non-trivial amount of time can be spent on interaction (which should not count against the timeout).
             */ var maxTicks = _this.config.system.windowHashTimeout / _this.config.system.pollIntervalMilliseconds;
            var ticks = 0;
            _this.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
            var intervalId = setInterval(function() {
                // Window is closed
                if (popupWindow.closed) {
                    _this.logger.error("PopupHandler.monitorPopupForHash - window closed");
                    _this.cleanPopup();
                    clearInterval(intervalId);
                    reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createUserCancelledError());
                    return;
                }
                var href = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                var hash = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                    hash = popupWindow.location.hash;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(href) || href === "about:blank") return;
                _this.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller");
                /*
                 * Only run clock when we are on same domain for popups
                 * as popup operations can take a long time.
                 */ ticks++;
                if (hash) {
                    _this.logger.verbose("PopupHandler.monitorPopupForHash - found hash in url");
                    clearInterval(intervalId);
                    _this.cleanPopup(popupWindow);
                    if ((0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).hashContainsKnownProperties(hash)) {
                        _this.logger.verbose("PopupHandler.monitorPopupForHash - hash contains known properties, returning.");
                        resolve(hash);
                    } else {
                        _this.logger.error("PopupHandler.monitorPopupForHash - found hash in url but it does not contain known properties. Check that your router is not changing the hash prematurely.");
                        _this.logger.errorPii("PopupHandler.monitorPopupForHash - hash found: " + hash);
                        reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createHashDoesNotContainKnownPropertiesError());
                    }
                } else if (ticks > maxTicks) {
                    _this.logger.error("PopupHandler.monitorPopupForHash - unable to find hash in url, timing out");
                    clearInterval(intervalId);
                    reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createMonitorPopupTimeoutError());
                }
            }, _this.config.system.pollIntervalMilliseconds);
        });
    };
    /**
     * Waits for user interaction in logout popup window
     * @param popupWindow
     * @returns
     */ PopupClient.prototype.waitForLogoutPopup = function(popupWindow) {
        var _this = this;
        return new Promise(function(resolve) {
            _this.logger.verbose("PopupHandler.waitForLogoutPopup - polling started");
            var intervalId = setInterval(function() {
                // Window is closed
                if (popupWindow.closed) {
                    _this.logger.error("PopupHandler.waitForLogoutPopup - window closed");
                    _this.cleanPopup();
                    clearInterval(intervalId);
                    resolve();
                }
                var href = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(href) || href === "about:blank") return;
                _this.logger.verbose("PopupHandler.waitForLogoutPopup - popup window is on same origin as caller, closing.");
                clearInterval(intervalId);
                _this.cleanPopup(popupWindow);
                resolve();
            }, _this.config.system.pollIntervalMilliseconds);
        });
    };
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ PopupClient.prototype.openPopup = function(urlNavigate, popupParams) {
        try {
            var popupWindow = void 0;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii("Navigating popup window to: " + urlNavigate);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii("Opening popup window to: " + urlNavigate);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams.popupName, popupParams.popupWindowAttributes);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createEmptyWindowCreatedError();
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            window.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        } catch (e) {
            this.logger.error("error opening popup " + e.message);
            this.browserStorage.setInteractionInProgress(false);
            throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createPopupWindowError(e.toString());
        }
    };
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ PopupClient.prototype.openSizedPopup = function(urlNavigate, popupName, popupWindowAttributes) {
        var _a, _b, _c, _d;
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ var winLeft = window.screenLeft ? window.screenLeft : window.screenX;
        var winTop = window.screenTop ? window.screenTop : window.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ var winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        var width = (_a = popupWindowAttributes.popupSize) === null || _a === void 0 ? void 0 : _a.width;
        var height = (_b = popupWindowAttributes.popupSize) === null || _b === void 0 ? void 0 : _b.height;
        var top = (_c = popupWindowAttributes.popupPosition) === null || _c === void 0 ? void 0 : _c.top;
        var left = (_d = popupWindowAttributes.popupPosition) === null || _d === void 0 ? void 0 : _d.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("Default popup window width used. Window width not configured or invalid.");
            width = (0, $7b3089fdde5d004f$export$a0a689e4294b9880).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("Default popup window height used. Window height not configured or invalid.");
            height = (0, $7b3089fdde5d004f$export$a0a689e4294b9880).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("Default popup window top position used. Window top not configured or invalid.");
            top = Math.max(0, winHeight / 2 - (0, $7b3089fdde5d004f$export$a0a689e4294b9880).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("Default popup window left position used. Window left not configured or invalid.");
            left = Math.max(0, winWidth / 2 - (0, $7b3089fdde5d004f$export$a0a689e4294b9880).POPUP_WIDTH / 2 + winLeft);
        }
        return window.open(urlNavigate, popupName, "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left + ", scrollbars=yes");
    };
    /**
     * Event callback to unload main window.
     */ PopupClient.prototype.unloadWindow = function(e) {
        this.browserStorage.cleanRequestByInteractionType((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup);
        if (this.currentWindow) this.currentWindow.close();
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    };
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */ PopupClient.prototype.cleanPopup = function(popupWindow) {
        if (popupWindow) // Close window.
        popupWindow.close();
        // Remove window unload function
        window.removeEventListener("beforeunload", this.unloadWindow);
        // Interaction is completed - remove interaction status.
        this.browserStorage.setInteractionInProgress(false);
    };
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ PopupClient.prototype.generatePopupName = function(scopes, authority) {
        return (0, $7b3089fdde5d004f$export$a0a689e4294b9880).POPUP_NAME_PREFIX + "." + this.config.auth.clientId + "." + scopes.join("-") + "." + authority + "." + this.correlationId;
    };
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ PopupClient.prototype.generateLogoutPopupName = function(request) {
        var homeAccountId = request.account && request.account.homeAccountId;
        return (0, $7b3089fdde5d004f$export$a0a689e4294b9880).POPUP_NAME_PREFIX + "." + this.config.auth.clientId + "." + homeAccountId + "." + this.correlationId;
    };
    return PopupClient;
}((0, $4eafc7ca6d6f2ff1$export$fa9179cade3eb05a));


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 



/*! @azure/msal-browser v2.37.1 2023-06-07 */ 




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $105ad1851bca71d7$export$9af91951fcedc08c = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(RedirectHandler, _super);
    function RedirectHandler(authCodeModule, storageImpl, authCodeRequest, logger, browserCrypto, performanceClient) {
        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest, logger, performanceClient) || this;
        _this.browserCrypto = browserCrypto;
        return _this;
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     */ RedirectHandler.prototype.initiateAuthRequest = function(requestUrl, params) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var navigationOptions, navigate;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("RedirectHandler.initiateAuthRequest called");
                        if (!!(0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(requestUrl)) return [
                            3 /*break*/ ,
                            7
                        ];
                        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
                        if (params.redirectStartPage) {
                            this.logger.verbose("RedirectHandler.initiateAuthRequest: redirectStartPage set, caching start page");
                            this.browserStorage.setTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).ORIGIN_URI, params.redirectStartPage, true);
                        }
                        // Set interaction status in the library.
                        this.browserStorage.setTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).CORRELATION_ID, this.authCodeRequest.correlationId, true);
                        this.browserStorage.cacheCodeRequest(this.authCodeRequest, this.browserCrypto);
                        this.logger.infoPii("RedirectHandler.initiateAuthRequest: Navigate to: " + requestUrl);
                        navigationOptions = {
                            apiId: (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenRedirect,
                            timeout: params.redirectTimeout,
                            noHistory: false
                        };
                        if (!(typeof params.onRedirectNavigate === "function")) return [
                            3 /*break*/ ,
                            4
                        ];
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                        navigate = params.onRedirectNavigate(requestUrl);
                        if (!(navigate !== false)) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                        return [
                            4 /*yield*/ ,
                            params.navigationClient.navigateExternal(requestUrl, navigationOptions)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 2:
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        // Navigate window to request URL
                        this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                        return [
                            4 /*yield*/ ,
                            params.navigationClient.navigateExternal(requestUrl, navigationOptions)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        // Throw error if request URL is empty.
                        this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
                        throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createEmptyNavigationUriError();
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Handle authorization code response in the window.
     * @param hash
     */ RedirectHandler.prototype.handleCodeResponseFromHash = function(locationHash, state, authority, networkModule) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var stateKey, requestState, authCodeResponse, nonceKey, cachedNonce, cachedCcsCred, tokenResponse;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("RedirectHandler.handleCodeResponse called");
                        // Check that location hash isn't empty.
                        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(locationHash)) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createEmptyHashError(locationHash);
                        // Interaction is completed - remove interaction status.
                        this.browserStorage.setInteractionInProgress(false);
                        stateKey = this.browserStorage.generateStateKey(state);
                        requestState = this.browserStorage.getTemporaryCache(stateKey);
                        if (!requestState) throw (0, $30cd164be78785f3$export$a839ff85a7957561).createStateNotFoundError("Cached State");
                        try {
                            authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
                        } catch (e) {
                            if (e instanceof (0, $b198a6cc5c52ae21$export$ea52035eac03daf0) && e.subError === (0, $68ecaba305c397db$export$6deffaef56f0bd5a).userCancelledError.code) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
                            throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUserCancelledError();
                            else throw e;
                        }
                        nonceKey = this.browserStorage.generateNonceKey(requestState);
                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
                        // Assign code to request
                        this.authCodeRequest.code = authCodeResponse.code;
                        if (!authCodeResponse.cloud_instance_host_name) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        authCodeResponse.nonce = cachedNonce || undefined;
                        authCodeResponse.state = requestState;
                        // Add CCS parameters if available
                        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
                        else {
                            cachedCcsCred = this.checkCcsCredentials();
                            if (cachedCcsCred) this.authCodeRequest.ccsCredential = cachedCcsCred;
                        }
                        return [
                            4 /*yield*/ ,
                            this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)
                        ];
                    case 3:
                        tokenResponse = _a.sent();
                        this.browserStorage.cleanRequestByState(state);
                        return [
                            2 /*return*/ ,
                            tokenResponse
                        ];
                }
            });
        });
    };
    return RedirectHandler;
}((0, $7acd28d32a2b7245$export$a30cd982b4e89bdb));







"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $430112e1234035e1$export$a368977effbc1ed6 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(RedirectClient, _super);
    function RedirectClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        _this.nativeStorage = nativeStorageImpl;
        return _this;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ RedirectClient.prototype.acquireToken = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var validRequest, serverTelemetryManager, handleBackButton, authCodeRequest, authClient, interactionHandler, navigateUrl, redirectStartPage, e_1;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationRequest(request, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect)
                        ];
                    case 1:
                        validRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(validRequest.state, validRequest.nonce, validRequest.authority, validRequest.loginHint || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, validRequest.account || null);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenRedirect);
                        handleBackButton = function(event) {
                            // Clear temporary cache if the back button is clicked during the redirect flow.
                            if (event.persisted) {
                                _this.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache.");
                                _this.browserStorage.cleanRequestByState(validRequest.state);
                                _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).RESTORE_FROM_BFCACHE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                            }
                        };
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            7,
                            ,
                            8
                        ]);
                        // Create auth code request and generate PKCE params
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationCodeRequest(validRequest)
                        ];
                    case 3:
                        authCodeRequest = _a.sent();
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, validRequest.authority, validRequest.azureCloudOptions)
                        ];
                    case 4:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        interactionHandler = new (0, $105ad1851bca71d7$export$9af91951fcedc08c)(authClient, this.browserStorage, authCodeRequest, this.logger, this.browserCrypto, this.performanceClient);
                        return [
                            4 /*yield*/ ,
                            authClient.getAuthCodeUrl((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, validRequest), {
                                nativeBroker: (0, $0342fe40e0ad80a3$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme)
                            }))
                        ];
                    case 5:
                        navigateUrl = _a.sent();
                        redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
                        this.logger.verbosePii("Redirect start page: " + redirectStartPage);
                        // Clear temporary cache if the back button is clicked during the redirect flow.
                        window.addEventListener("pageshow", handleBackButton);
                        return [
                            4 /*yield*/ ,
                            interactionHandler.initiateAuthRequest(navigateUrl, {
                                navigationClient: this.navigationClient,
                                redirectTimeout: this.config.system.redirectNavigationTimeout,
                                redirectStartPage: redirectStartPage,
                                onRedirectNavigate: request.onRedirectNavigate
                            })
                        ];
                    case 6:
                        // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 7:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) e_1.setCorrelationId(this.correlationId);
                        window.removeEventListener("pageshow", handleBackButton);
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(validRequest.state);
                        throw e_1;
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash
     */ RedirectClient.prototype.handleRedirectPromise = function(hash) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var serverTelemetryManager, responseHash, state, serverParams, loginRequestUrl, loginRequestUrlNormalized, currentUrlNormalized, handleHashResult, navigationOptions, processHashOnRedirect, homepage, e_2;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $7b3089fdde5d004f$export$192d74ad69b40705).handleRedirectPromise);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        if (!this.browserStorage.isInteractionInProgress(true)) {
                            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        responseHash = this.getRedirectResponseHash(hash || window.location.hash);
                        if (!responseHash) {
                            // Not a recognized server response hash or hash not associated with a redirect request
                            this.logger.info("handleRedirectPromise did not detect a response hash as a result of a redirect. Cleaning temporary cache.");
                            this.browserStorage.cleanRequestByInteractionType((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        state = void 0;
                        try {
                            serverParams = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getDeserializedHash(responseHash);
                            state = this.validateAndExtractStateFromHash(serverParams, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                            this.logger.verbose("State extracted from hash");
                        } catch (e) {
                            this.logger.info("handleRedirectPromise was unable to extract state due to: " + e);
                            this.browserStorage.cleanRequestByInteractionType((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                            return [
                                2 /*return*/ ,
                                null
                            ];
                        }
                        loginRequestUrl = this.browserStorage.getTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).ORIGIN_URI, true) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                        loginRequestUrlNormalized = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).removeHashFromUrl(loginRequestUrl);
                        currentUrlNormalized = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).removeHashFromUrl(window.location.href);
                        if (!(loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl)) return [
                            3 /*break*/ ,
                            3
                        ];
                        // We are on the page we need to navigate to - handle hash
                        this.logger.verbose("Current page is loginRequestUrl, handling hash");
                        return [
                            4 /*yield*/ ,
                            this.handleHash(responseHash, state, serverTelemetryManager)
                        ];
                    case 2:
                        handleHashResult = _a.sent();
                        if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                        (0, $94c261d7c4faec3a$export$311899ae85124b2d).replaceHash(loginRequestUrl);
                        return [
                            2 /*return*/ ,
                            handleHashResult
                        ];
                    case 3:
                        if (!!this.config.auth.navigateToLoginRequestUrl) return [
                            3 /*break*/ ,
                            4
                        ];
                        this.logger.verbose("NavigateToLoginRequestUrl set to false, handling hash");
                        return [
                            2 /*return*/ ,
                            this.handleHash(responseHash, state, serverTelemetryManager)
                        ];
                    case 4:
                        if (!(!(0, $94c261d7c4faec3a$export$311899ae85124b2d).isInIframe() || this.config.system.allowRedirectInIframe)) return [
                            3 /*break*/ ,
                            9
                        ];
                        /*
                         * Returned from authority using redirect - need to perform navigation before processing response
                         * Cache the hash to be retrieved after the next redirect
                         */ this.browserStorage.setTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).URL_HASH, responseHash, true);
                        navigationOptions = {
                            apiId: (0, $7b3089fdde5d004f$export$192d74ad69b40705).handleRedirectPromise,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: true
                        };
                        processHashOnRedirect = true;
                        if (!(!loginRequestUrl || loginRequestUrl === "null")) return [
                            3 /*break*/ ,
                            6
                        ];
                        homepage = (0, $94c261d7c4faec3a$export$311899ae85124b2d).getHomepage();
                        // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                        this.browserStorage.setTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).ORIGIN_URI, homepage, true);
                        this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateInternal(homepage, navigationOptions)
                        ];
                    case 5:
                        processHashOnRedirect = _a.sent();
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        // Navigate to page that initiated the redirect request
                        this.logger.verbose("Navigating to loginRequestUrl: " + loginRequestUrl);
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions)
                        ];
                    case 7:
                        processHashOnRedirect = _a.sent();
                        _a.label = 8;
                    case 8:
                        // If navigateInternal implementation returns false, handle the hash now
                        if (!processHashOnRedirect) return [
                            2 /*return*/ ,
                            this.handleHash(responseHash, state, serverTelemetryManager)
                        ];
                        _a.label = 9;
                    case 9:
                        return [
                            2 /*return*/ ,
                            null
                        ];
                    case 10:
                        e_2 = _a.sent();
                        if (e_2 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) e_2.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_2);
                        this.browserStorage.cleanRequestByInteractionType((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                        throw e_2;
                    case 11:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ RedirectClient.prototype.getRedirectResponseHash = function(hash) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        var isResponseHash = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).hashContainsKnownProperties(hash);
        if (isResponseHash) {
            (0, $94c261d7c4faec3a$export$311899ae85124b2d).clearHash(window);
            this.logger.verbose("Hash contains known properties, returning response hash");
            return hash;
        }
        var cachedHash = this.browserStorage.getTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).URL_HASH));
        this.logger.verbose("Hash does not contain known properties, returning cached hash");
        return cachedHash;
    };
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ RedirectClient.prototype.handleHash = function(hash, state, serverTelemetryManager) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var cachedRequest, serverParams, nativeInteractionClient, userRequestState, currentAuthority, authClient, interactionHandler;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        cachedRequest = this.browserStorage.getCachedRequest(state, this.browserCrypto);
                        this.logger.verbose("handleHash called, retrieved cached request");
                        serverParams = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getDeserializedHash(hash);
                        if (serverParams.accountId) {
                            this.logger.verbose("Account id found in hash, calling WAM for token");
                            if (!this.nativeMessageHandler) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNativeConnectionNotEstablishedError();
                            nativeInteractionClient = new (0, $6295e6242c57d6a1$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, cachedRequest.correlationId);
                            userRequestState = (0, $43862c84d67ae4c1$export$871e33217042c65e).parseRequestState(this.browserCrypto, state).userRequestState;
                            return [
                                2 /*return*/ ,
                                nativeInteractionClient.acquireToken((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, cachedRequest), {
                                    state: userRequestState,
                                    prompt: undefined // Server should handle the prompt, ideally native broker can do this part silently
                                })).finally(function() {
                                    _this.browserStorage.cleanRequestByState(state);
                                })
                            ];
                        }
                        currentAuthority = this.browserStorage.getCachedAuthority(state);
                        if (!currentAuthority) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNoCachedAuthorityError();
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, cachedRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, currentAuthority)
                        ];
                    case 1:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        (0, $c78f3ba4540ca0dd$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, cachedRequest);
                        interactionHandler = new (0, $105ad1851bca71d7$export$9af91951fcedc08c)(authClient, this.browserStorage, cachedRequest, this.logger, this.browserCrypto, this.performanceClient);
                        return [
                            4 /*yield*/ ,
                            interactionHandler.handleCodeResponseFromHash(hash, state, authClient.authority, this.networkClient)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ RedirectClient.prototype.logout = function(logoutRequest) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var validLogoutRequest, serverTelemetryManager, navigationOptions, authClient, logoutUri, navigate, e_3;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.verbose("logoutRedirect called");
                        validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $7b3089fdde5d004f$export$192d74ad69b40705).logout);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            10,
                            ,
                            11
                        ]);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, logoutRequest);
                        // Clear cache on logout
                        return [
                            4 /*yield*/ ,
                            this.clearCacheOnLogout(validLogoutRequest.account)
                        ];
                    case 2:
                        // Clear cache on logout
                        _a.sent();
                        navigationOptions = {
                            apiId: (0, $7b3089fdde5d004f$export$192d74ad69b40705).logout,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, validLogoutRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, logoutRequest && logoutRequest.authority)
                        ];
                    case 3:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        logoutUri = authClient.getLogoutUri(validLogoutRequest);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
                        if (!(logoutRequest && typeof logoutRequest.onRedirectNavigate === "function")) return [
                            3 /*break*/ ,
                            7
                        ];
                        navigate = logoutRequest.onRedirectNavigate(logoutUri);
                        if (!(navigate !== false)) return [
                            3 /*break*/ ,
                            5
                        ];
                        this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
                        // Ensure interaction is in progress
                        if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateExternal(logoutUri, navigationOptions)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        // Ensure interaction is not in progress
                        this.browserStorage.setInteractionInProgress(false);
                        this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                        _a.label = 6;
                    case 6:
                        return [
                            3 /*break*/ ,
                            9
                        ];
                    case 7:
                        // Ensure interaction is in progress
                        if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                        return [
                            4 /*yield*/ ,
                            this.navigationClient.navigateExternal(logoutUri, navigationOptions)
                        ];
                    case 8:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 9:
                        return [
                            3 /*break*/ ,
                            11
                        ];
                    case 10:
                        e_3 = _a.sent();
                        if (e_3 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) e_3.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_3);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, null, e_3);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_END, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                        throw e_3;
                    case 11:
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGOUT_END, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ RedirectClient.prototype.getRedirectStartPage = function(requestStartPage) {
        var redirectStartPage = requestStartPage || window.location.href;
        return (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getAbsoluteUrl(redirectStartPage, (0, $94c261d7c4faec3a$export$311899ae85124b2d).getCurrentUri());
    };
    return RedirectClient;
}((0, $4eafc7ca6d6f2ff1$export$fa9179cade3eb05a));


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 




/*! @azure/msal-browser v2.37.1 2023-06-07 */ 




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $522d341a340b34c4$export$578d2d1abe796151 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(SilentHandler, _super);
    function SilentHandler(authCodeModule, storageImpl, authCodeRequest, logger, systemOptions, performanceClient) {
        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest, logger, performanceClient) || this;
        _this.navigateFrameWait = systemOptions.navigateFrameWait;
        _this.pollIntervalMilliseconds = systemOptions.pollIntervalMilliseconds;
        return _this;
    }
    /**
     * Creates a hidden iframe to given URL using user-requested scopes as an id.
     * @param urlNavigate
     * @param userRequestScopes
     */ SilentHandler.prototype.initiateAuthRequest = function(requestUrl) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.authCodeRequest.correlationId);
                        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(requestUrl)) {
                            // Throw error if request URL is empty.
                            this.logger.info("Navigate url is empty");
                            throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createEmptyNavigationUriError();
                        }
                        if (!this.navigateFrameWait) return [
                            3 /*break*/ ,
                            2
                        ];
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentHandlerLoadFrame, this.authCodeRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.loadFrame(requestUrl)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            this.loadFrameSync(requestUrl)
                        ];
                }
            });
        });
    };
    /**
     * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
     * @param iframe
     * @param timeout
     */ SilentHandler.prototype.monitorIframeForHash = function(iframe, timeout) {
        var _this = this;
        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.authCodeRequest.correlationId);
        return new Promise(function(resolve, reject) {
            if (timeout < (0, $f8475258f3a6b261$export$f3ffe700be354b19)) _this.logger.warning("system.loadFrameTimeout or system.iframeHashTimeout set to lower (" + timeout + "ms) than the default (" + (0, $f8475258f3a6b261$export$f3ffe700be354b19) + "ms). This may result in timeouts.");
            /*
             * Polling for iframes can be purely timing based,
             * since we don't need to account for interaction.
             */ var nowMark = window.performance.now();
            var timeoutMark = nowMark + timeout;
            var intervalId = setInterval(function() {
                if (window.performance.now() > timeoutMark) {
                    _this.removeHiddenIframe(iframe);
                    clearInterval(intervalId);
                    reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createMonitorIframeTimeoutError());
                    return;
                }
                var href = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                var contentWindow = iframe.contentWindow;
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = contentWindow ? contentWindow.location.href : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                } catch (e) {}
                if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(href)) return;
                var contentHash = contentWindow ? contentWindow.location.hash : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                if ((0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).hashContainsKnownProperties(contentHash)) {
                    // Success case
                    _this.removeHiddenIframe(iframe);
                    clearInterval(intervalId);
                    resolve(contentHash);
                    return;
                }
            }, _this.pollIntervalMilliseconds);
        });
    };
    /**
     * @hidden
     * Loads iframe with authorization endpoint URL
     * @ignore
     */ SilentHandler.prototype.loadFrame = function(urlNavigate) {
        var _this = this;
        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentHandlerLoadFrame, this.authCodeRequest.correlationId);
        /*
         * This trick overcomes iframe navigation in IE
         * IE does not load the page consistently in iframe
         */ return new Promise(function(resolve, reject) {
            var frameHandle = _this.createHiddenIframe();
            setTimeout(function() {
                if (!frameHandle) {
                    reject("Unable to load iframe");
                    return;
                }
                frameHandle.src = urlNavigate;
                resolve(frameHandle);
            }, _this.navigateFrameWait);
        });
    };
    /**
     * @hidden
     * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
     * @param urlNavigate
     * @param frameName
     * @param logger
     */ SilentHandler.prototype.loadFrameSync = function(urlNavigate) {
        var frameHandle = this.createHiddenIframe();
        frameHandle.src = urlNavigate;
        return frameHandle;
    };
    /**
     * @hidden
     * Creates a new hidden iframe or gets an existing one for silent token renewal.
     * @ignore
     */ SilentHandler.prototype.createHiddenIframe = function() {
        var authFrame = document.createElement("iframe");
        authFrame.style.visibility = "hidden";
        authFrame.style.position = "absolute";
        authFrame.style.width = authFrame.style.height = "0";
        authFrame.style.border = "0";
        authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
        document.getElementsByTagName("body")[0].appendChild(authFrame);
        return authFrame;
    };
    /**
     * @hidden
     * Removes a hidden iframe from the page.
     * @ignore
     */ SilentHandler.prototype.removeHiddenIframe = function(iframe) {
        if (document.body === iframe.parentNode) document.body.removeChild(iframe);
    };
    return SilentHandler;
}((0, $7acd28d32a2b7245$export$a30cd982b4e89bdb));




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $0ce5ebcdbe996c3e$export$e81c7938bccef977 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(SilentIframeClient, _super);
    function SilentIframeClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        _this.apiId = apiId;
        _this.nativeStorage = nativeStorageImpl;
        return _this;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ SilentIframeClient.prototype.acquireToken = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var acquireTokenMeasurement, silentRequest, serverTelemetryManager, authClient, e_1;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
                        this.logger.verbose("acquireTokenByIframe called");
                        acquireTokenMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
                        // Check that we have some SSO data
                        if ((0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(request.loginHint) && (0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(request.sid) && (!request.account || (0, $1842614da3ac031b$export$ecc754f99843e759).isEmpty(request.account.username))) this.logger.warning("No user hint provided. The authorization server may need more information to complete this request.");
                        // Check that prompt is set to none or no_session, throw error if it is set to anything else.
                        if (request.prompt && request.prompt !== (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).NONE && request.prompt !== (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).NO_SESSION) {
                            acquireTokenMeasurement.endMeasurement({
                                success: false
                            });
                            throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createSilentPromptValueError(request.prompt);
                        }
                        // Create silent request
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationRequest((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request), {
                                prompt: request.prompt || (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).NONE
                            }), (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent)
                        ];
                    case 1:
                        silentRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(silentRequest.state, silentRequest.nonce, silentRequest.authority, silentRequest.loginHint || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, silentRequest.account || null);
                        serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            5,
                            ,
                            6
                        ]);
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.createAuthCodeClient(serverTelemetryManager, silentRequest.authority, silentRequest.azureCloudOptions)
                        ];
                    case 3:
                        authClient = _a.sent();
                        this.logger.verbose("Auth code client created");
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.silentTokenHelper(authClient, silentRequest).then(function(result) {
                                acquireTokenMeasurement.endMeasurement({
                                    success: true,
                                    fromCache: false,
                                    requestId: result.requestId
                                });
                                return result;
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 5:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) e_1.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(silentRequest.state);
                        acquireTokenMeasurement.endMeasurement({
                            errorCode: e_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac) && e_1.errorCode || undefined,
                            subErrorCode: e_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac) && e_1.subError || undefined,
                            success: false
                        });
                        throw e_1;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */ SilentIframeClient.prototype.logout = function() {
        // Synchronous so we must reject
        return Promise.reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createSilentLogoutUnsupportedError());
    };
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ SilentIframeClient.prototype.silentTokenHelper = function(authClient, silentRequest) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var authCodeRequest, navigateUrl, silentHandler, msalFrame, hash, serverParams, state, nativeInteractionClient, userRequestState;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, silentRequest.correlationId);
                        // Create auth code request and generate PKCE params
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, silentRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationCodeRequest(silentRequest)
                        ];
                    case 1:
                        authCodeRequest = _a.sent();
                        // Create authorize request url
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).GetAuthCodeUrl, silentRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            authClient.getAuthCodeUrl((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, silentRequest), {
                                nativeBroker: (0, $0342fe40e0ad80a3$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, silentRequest.authenticationScheme)
                            }))
                        ];
                    case 2:
                        navigateUrl = _a.sent();
                        silentHandler = new (0, $522d341a340b34c4$export$578d2d1abe796151)(authClient, this.browserStorage, authCodeRequest, this.logger, this.config.system, this.performanceClient);
                        // Get the frame handle for the silent request
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, silentRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            silentHandler.initiateAuthRequest(navigateUrl)
                        ];
                    case 3:
                        msalFrame = _a.sent();
                        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, silentRequest.correlationId);
                        return [
                            4 /*yield*/ ,
                            silentHandler.monitorIframeForHash(msalFrame, this.config.system.iframeHashTimeout)
                        ];
                    case 4:
                        hash = _a.sent();
                        serverParams = (0, $7e4e9c310bf6f49d$export$3abcdca7229e54f2).getDeserializedHash(hash);
                        state = this.validateAndExtractStateFromHash(serverParams, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, authCodeRequest.correlationId);
                        if (serverParams.accountId) {
                            this.logger.verbose("Account id found in hash, calling WAM for token");
                            if (!this.nativeMessageHandler) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNativeConnectionNotEstablishedError();
                            nativeInteractionClient = new (0, $6295e6242c57d6a1$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.apiId, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.browserStorage, this.correlationId);
                            userRequestState = (0, $43862c84d67ae4c1$export$871e33217042c65e).parseRequestState(this.browserCrypto, state).userRequestState;
                            return [
                                2 /*return*/ ,
                                nativeInteractionClient.acquireToken((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, silentRequest), {
                                    state: userRequestState,
                                    prompt: silentRequest.prompt || (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).NONE
                                })).finally(function() {
                                    _this.browserStorage.cleanRequestByState(state);
                                })
                            ];
                        }
                        // Handle response from hash string
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).HandleCodeResponseFromHash, silentRequest.correlationId);
                        return [
                            2 /*return*/ ,
                            silentHandler.handleCodeResponseFromHash(hash, state, authClient.authority, this.networkClient)
                        ];
                }
            });
        });
    };
    return SilentIframeClient;
}((0, $4eafc7ca6d6f2ff1$export$fa9179cade3eb05a));


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 




"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $69c4a2deffcc1b73$export$b4a36596822a5d2 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(SilentRefreshClient, _super);
    function SilentRefreshClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ SilentRefreshClient.prototype.acquireToken = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentRequest, _a, acquireTokenMeasurement, serverTelemetryManager, refreshTokenClient;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, request.correlationId);
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
                        _a = [
                            (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.initializeBaseRequest(request, request.account)
                        ];
                    case 1:
                        silentRequest = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b).apply(void 0, _a.concat([
                            _b.sent()
                        ]));
                        acquireTokenMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, silentRequest.correlationId);
                        serverTelemetryManager = this.initializeServerTelemetryManager((0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
                        return [
                            4 /*yield*/ ,
                            this.createRefreshTokenClient(serverTelemetryManager, silentRequest.authority, silentRequest.azureCloudOptions)
                        ];
                    case 2:
                        refreshTokenClient = _b.sent();
                        this.logger.verbose("Refresh token client created");
                        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
                        return [
                            2 /*return*/ ,
                            refreshTokenClient.acquireTokenByRefreshToken(silentRequest).then(function(result) {
                                acquireTokenMeasurement.endMeasurement({
                                    success: true,
                                    fromCache: result.fromCache,
                                    requestId: result.requestId
                                });
                                return result;
                            }).catch(function(e) {
                                if (e instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) e.setCorrelationId(_this.correlationId);
                                serverTelemetryManager.cacheFailedRequest(e);
                                acquireTokenMeasurement.endMeasurement({
                                    errorCode: e.errorCode,
                                    subErrorCode: e.subError,
                                    success: false
                                });
                                throw e;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */ SilentRefreshClient.prototype.logout = function() {
        // Synchronous so we must reject
        return Promise.reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createSilentLogoutUnsupportedError());
    };
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param serverTelemetryManager
     * @param authorityUrl
     */ SilentRefreshClient.prototype.createRefreshTokenClient = function(serverTelemetryManager, authorityUrl, azureCloudOptions) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var clientConfig;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Create auth module.
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getClientConfiguration(serverTelemetryManager, authorityUrl, azureCloudOptions)
                        ];
                    case 1:
                        clientConfig = _a.sent();
                        return [
                            2 /*return*/ ,
                            new (0, $c49c56ec754e9bf1$export$9cb096b89b92d8a8)(clientConfig, this.performanceClient)
                        ];
                }
            });
        });
    };
    return SilentRefreshClient;
}((0, $4eafc7ca6d6f2ff1$export$fa9179cade3eb05a));


/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Token cache manager
 */ var $62c97a8b78c73ec7$export$ed5d1a18907a1001 = /** @class */ function() {
    function TokenCache(configuration, storage, logger, cryptoObj) {
        this.isBrowserEnvironment = typeof window !== "undefined";
        this.config = configuration;
        this.storage = storage;
        this.logger = logger;
        this.cryptoObj = cryptoObj;
    }
    // Move getAllAccounts here and cache utility APIs
    /**
     * API to load tokens to msal-browser cache.
     * @param request
     * @param response
     * @param options
     * @returns `AuthenticationResult` for the response that was loaded.
     */ TokenCache.prototype.loadExternalTokens = function(request, response, options) {
        this.logger.info("TokenCache - loadExternalTokens called");
        if (!response.id_token) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please ensure server response includes id token.");
        var idToken = new (0, $88f623fdecedc666$export$3a170961dab30083)(response.id_token, this.cryptoObj);
        var cacheRecord;
        var authority;
        if (request.account) {
            var cacheRecordAccount = this.loadAccount(idToken, request.account.environment, undefined, undefined, request.account.homeAccountId);
            cacheRecord = new (0, $4e2a602fb391f03c$export$5ee5669a32bdea66)(cacheRecordAccount, this.loadIdToken(idToken, cacheRecordAccount.homeAccountId, request.account.environment, request.account.tenantId), this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, request.account.environment, request.account.tenantId, options), this.loadRefreshToken(request, response, cacheRecordAccount.homeAccountId, request.account.environment));
        } else if (request.authority) {
            var authorityUrl = (0, $08caa87d494f4ccf$export$f1c6ec2e6d68c49c).generateAuthority(request.authority, request.azureCloudOptions);
            var authorityOptions = {
                protocolMode: this.config.auth.protocolMode,
                knownAuthorities: this.config.auth.knownAuthorities,
                cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                authorityMetadata: this.config.auth.authorityMetadata,
                skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
            };
            authority = new (0, $08caa87d494f4ccf$export$f1c6ec2e6d68c49c)(authorityUrl, this.config.system.networkClient, this.storage, authorityOptions, this.logger);
            // "clientInfo" from options takes precedence over "clientInfo" in response
            if (options.clientInfo) {
                this.logger.trace("TokenCache - homeAccountId from options");
                var cacheRecordAccount = this.loadAccount(idToken, authority.hostnameAndPort, options.clientInfo, authority.authorityType);
                cacheRecord = new (0, $4e2a602fb391f03c$export$5ee5669a32bdea66)(cacheRecordAccount, this.loadIdToken(idToken, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant), this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant, options), this.loadRefreshToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort));
            } else if (response.client_info) {
                this.logger.trace("TokenCache - homeAccountId from response");
                var cacheRecordAccount = this.loadAccount(idToken, authority.hostnameAndPort, response.client_info, authority.authorityType);
                cacheRecord = new (0, $4e2a602fb391f03c$export$5ee5669a32bdea66)(cacheRecordAccount, this.loadIdToken(idToken, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant), this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort, authority.tenant, options), this.loadRefreshToken(request, response, cacheRecordAccount.homeAccountId, authority.hostnameAndPort));
            } else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please provide clientInfo in the response or options.");
        } else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please provide a request with an account or a request with authority.");
        return this.generateAuthenticationResult(request, idToken, cacheRecord, authority);
    };
    /**
     * Helper function to load account to msal-browser cache
     * @param idToken
     * @param environment
     * @param clientInfo
     * @param authorityType
     * @param requestHomeAccountId
     * @returns `AccountEntity`
     */ TokenCache.prototype.loadAccount = function(idToken, environment, clientInfo, authorityType, requestHomeAccountId) {
        var homeAccountId;
        if (requestHomeAccountId) homeAccountId = requestHomeAccountId;
        else if (authorityType !== undefined && clientInfo) homeAccountId = (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).generateHomeAccountId(clientInfo, authorityType, this.logger, this.cryptoObj, idToken);
        if (!homeAccountId) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("Unexpected missing homeAccountId");
        var accountEntity = clientInfo ? (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).createAccount(clientInfo, homeAccountId, idToken, undefined, undefined, undefined, environment) : (0, $5d6dde05c7528aa5$export$680160523e6bfa6a).createGenericAccount(homeAccountId, idToken, undefined, undefined, undefined, environment);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading account");
            this.storage.setAccount(accountEntity);
            return accountEntity;
        } else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    };
    /**
     * Helper function to load id tokens to msal-browser cache
     * @param idToken
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `IdTokenEntity`
     */ TokenCache.prototype.loadIdToken = function(idToken, homeAccountId, environment, tenantId) {
        var idTokenEntity = (0, $0c09c5966c1cc91f$export$49ed297fa7d02bde).createIdTokenEntity(homeAccountId, environment, idToken.rawToken, this.config.auth.clientId, tenantId);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading id token");
            this.storage.setIdTokenCredential(idTokenEntity);
            return idTokenEntity;
        } else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    };
    /**
     * Helper function to load access tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `AccessTokenEntity`
     */ TokenCache.prototype.loadAccessToken = function(request, response, homeAccountId, environment, tenantId, options) {
        if (!response.access_token) {
            this.logger.verbose("TokenCache - No access token provided for caching");
            return null;
        }
        if (!response.expires_in) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please ensure server response includes expires_in value.");
        if (!options.extendedExpiresOn) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("Please provide an extendedExpiresOn value in the options.");
        var scopes = new (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99)(request.scopes).printScopes();
        var expiresOn = options.expiresOn || response.expires_in + new Date().getTime() / 1000;
        var extendedExpiresOn = options.extendedExpiresOn;
        var accessTokenEntity = (0, $698539a43f4f793b$export$6b7a8e14ec177765).createAccessTokenEntity(homeAccountId, environment, response.access_token, this.config.auth.clientId, tenantId, scopes, expiresOn, extendedExpiresOn, this.cryptoObj);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading access token");
            this.storage.setAccessTokenCredential(accessTokenEntity);
            return accessTokenEntity;
        } else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    };
    /**
     * Helper function to load refresh tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @returns `RefreshTokenEntity`
     */ TokenCache.prototype.loadRefreshToken = function(request, response, homeAccountId, environment) {
        if (!response.refresh_token) {
            this.logger.verbose("TokenCache - No refresh token provided for caching");
            return null;
        }
        var refreshTokenEntity = (0, $16a85bb95b6824db$export$2f7722c9adbc0a1b).createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, this.config.auth.clientId);
        if (this.isBrowserEnvironment) {
            this.logger.verbose("TokenCache - loading refresh token");
            this.storage.setRefreshTokenCredential(refreshTokenEntity);
            return refreshTokenEntity;
        } else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    };
    /**
     * Helper function to generate an `AuthenticationResult` for the result.
     * @param request
     * @param idTokenObj
     * @param cacheRecord
     * @param authority
     * @returns `AuthenticationResult`
     */ TokenCache.prototype.generateAuthenticationResult = function(request, idTokenObj, cacheRecord, authority) {
        var _a, _b, _c;
        var accessToken = (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        var responseScopes = [];
        var expiresOn = null;
        var extExpiresOn;
        if (cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.accessToken) {
            accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $6c0c9a351143193b$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
            extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
        }
        var uid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.oid) || (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.sub) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        var tid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.tid) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
        return {
            authority: authority ? authority.canonicalAuthority : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: (cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.account) ? cacheRecord.account.getAccountInfo() : null,
            idToken: idTokenObj ? idTokenObj.rawToken : (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            idTokenClaims: idTokenObj ? idTokenObj.claims : {},
            accessToken: accessToken,
            fromCache: true,
            expiresOn: expiresOn,
            correlationId: request.correlationId || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            requestId: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            extExpiresOn: extExpiresOn,
            familyId: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            tokenType: ((_a = cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.accessToken) === null || _a === void 0 ? void 0 : _a.tokenType) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            state: (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            cloudGraphHostName: ((_b = cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.account) === null || _b === void 0 ? void 0 : _b.cloudGraphHostName) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            msGraphHost: ((_c = cacheRecord === null || cacheRecord === void 0 ? void 0 : cacheRecord.account) === null || _c === void 0 ? void 0 : _c.msGraphHost) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
            code: undefined,
            fromNativeBroker: false
        };
    };
    return TokenCache;
}();






/*! @azure/msal-browser v2.37.1 2023-06-07 */ 





/*! @azure/msal-browser v2.37.1 2023-06-07 */ 

"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $912fae4baca52184$export$a2dbbd28e9bce542 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(HybridSpaAuthorizationCodeClient, _super);
    function HybridSpaAuthorizationCodeClient(config) {
        var _this = _super.call(this, config) || this;
        _this.includeRedirectUri = false;
        return _this;
    }
    return HybridSpaAuthorizationCodeClient;
}((0, $c49acda2ee30d5da$export$8538731fd397fb90));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $131a918488917121$export$d7f5ef311b3e9fca = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(SilentAuthCodeClient, _super);
    function SilentAuthCodeClient(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeMessageHandler, correlationId) {
        var _this = _super.call(this, config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId) || this;
        _this.apiId = apiId;
        return _this;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ SilentAuthCodeClient.prototype.acquireToken = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentRequest, serverTelemetryManager, authCodeRequest, clientConfig, authClient, silentHandler, e_1;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.logger.trace("SilentAuthCodeClient.acquireToken called");
                        // Auth code payload is required
                        if (!request.code) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createAuthCodeRequiredError();
                        // Create silent request
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.initializeAuthorizationRequest(request, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent)
                        ];
                    case 1:
                        silentRequest = _a.sent();
                        this.browserStorage.updateCacheEntries(silentRequest.state, silentRequest.nonce, silentRequest.authority, silentRequest.loginHint || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING, silentRequest.account || null);
                        serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        authCodeRequest = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, silentRequest), {
                            code: request.code
                        });
                        // Initialize the client
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            this.getClientConfiguration(serverTelemetryManager, silentRequest.authority)
                        ];
                    case 3:
                        clientConfig = _a.sent();
                        authClient = new (0, $912fae4baca52184$export$a2dbbd28e9bce542)(clientConfig);
                        this.logger.verbose("Auth code client created");
                        silentHandler = new (0, $522d341a340b34c4$export$578d2d1abe796151)(authClient, this.browserStorage, authCodeRequest, this.logger, this.config.system, this.performanceClient);
                        // Handle auth code parameters from request
                        return [
                            2 /*return*/ ,
                            silentHandler.handleCodeResponseFromServer({
                                code: request.code,
                                msgraph_host: request.msGraphHost,
                                cloud_graph_host_name: request.cloudGraphHostName,
                                cloud_instance_host_name: request.cloudInstanceHostName
                            }, silentRequest.state, authClient.authority, this.networkClient, false)
                        ];
                    case 4:
                        e_1 = _a.sent();
                        if (e_1 instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac)) e_1.setCorrelationId(this.correlationId);
                        serverTelemetryManager.cacheFailedRequest(e_1);
                        this.browserStorage.cleanRequestByState(silentRequest.state);
                        throw e_1;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Currently Unsupported
     */ SilentAuthCodeClient.prototype.logout = function() {
        // Synchronous so we must reject
        return Promise.reject((0, $68ecaba305c397db$export$f8eb6760ca13876a).createSilentLogoutUnsupportedError());
    };
    return SilentAuthCodeClient;
}((0, $4eafc7ca6d6f2ff1$export$fa9179cade3eb05a));



/*! @azure/msal-browser v2.37.1 2023-06-07 */ 



/*! @azure/msal-browser v2.37.1 2023-06-07 */ "use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $f1439ddc6bb8eaaa$export$f97b8b5459a3aa4 = /** @class */ function() {
    function BrowserPerformanceMeasurement(name, correlationId) {
        this.correlationId = correlationId;
        this.measureName = BrowserPerformanceMeasurement.makeMeasureName(name, correlationId);
        this.startMark = BrowserPerformanceMeasurement.makeStartMark(name, correlationId);
        this.endMark = BrowserPerformanceMeasurement.makeEndMark(name, correlationId);
    }
    BrowserPerformanceMeasurement.makeMeasureName = function(name, correlationId) {
        return "msal.measure." + name + "." + correlationId;
    };
    BrowserPerformanceMeasurement.makeStartMark = function(name, correlationId) {
        return "msal.start." + name + "." + correlationId;
    };
    BrowserPerformanceMeasurement.makeEndMark = function(name, correlationId) {
        return "msal.end." + name + "." + correlationId;
    };
    BrowserPerformanceMeasurement.supportsBrowserPerformance = function() {
        return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.mark === "function" && typeof window.performance.measure === "function" && typeof window.performance.clearMarks === "function" && typeof window.performance.clearMeasures === "function" && typeof window.performance.getEntriesByName === "function";
    };
    /**
     * Flush browser marks and measurements.
     * @param {string} correlationId
     * @param {SubMeasurement} measurements
     */ BrowserPerformanceMeasurement.flushMeasurements = function(correlationId, measurements) {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            measurements.forEach(function(measurement) {
                var measureName = BrowserPerformanceMeasurement.makeMeasureName(measurement.name, correlationId);
                var entriesForMeasurement = window.performance.getEntriesByName(measureName, "measure");
                if (entriesForMeasurement.length > 0) {
                    window.performance.clearMeasures(measureName);
                    window.performance.clearMarks(BrowserPerformanceMeasurement.makeStartMark(measureName, correlationId));
                    window.performance.clearMarks(BrowserPerformanceMeasurement.makeEndMark(measureName, correlationId));
                }
            });
        } catch (e) {
        // Silently catch and return null
        }
    };
    BrowserPerformanceMeasurement.prototype.startMeasurement = function() {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.startMark);
        } catch (e) {
        // Silently catch
        }
    };
    BrowserPerformanceMeasurement.prototype.endMeasurement = function() {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.endMark);
            window.performance.measure(this.measureName, this.startMark, this.endMark);
        } catch (e) {
        // Silently catch
        }
    };
    BrowserPerformanceMeasurement.prototype.flushMeasurement = function() {
        if (BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            var entriesForMeasurement = window.performance.getEntriesByName(this.measureName, "measure");
            if (entriesForMeasurement.length > 0) {
                var durationMs = entriesForMeasurement[0].duration;
                window.performance.clearMeasures(this.measureName);
                window.performance.clearMarks(this.startMark);
                window.performance.clearMarks(this.endMark);
                return durationMs;
            }
        } catch (e) {
        // Silently catch and return null
        }
        return null;
    };
    return BrowserPerformanceMeasurement;
}();


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $7d6b489c584eae69$export$3714d85cfc8f4a02 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(BrowserPerformanceClient, _super);
    function BrowserPerformanceClient(clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry, cryptoOptions) {
        var _this = _super.call(this, clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry) || this;
        _this.browserCrypto = new (0, $9e4f9f8893be8953$export$bdaac271e902e541)(_this.logger, cryptoOptions);
        _this.guidGenerator = new (0, $2adb43089fcdf0dc$export$62dc58eaf2cdc52)(_this.browserCrypto);
        return _this;
    }
    BrowserPerformanceClient.prototype.startPerformanceMeasuremeant = function(measureName, correlationId) {
        return new (0, $f1439ddc6bb8eaaa$export$f97b8b5459a3aa4)(measureName, correlationId);
    };
    BrowserPerformanceClient.prototype.generateId = function() {
        return this.guidGenerator.generateGuid();
    };
    BrowserPerformanceClient.prototype.getPageVisibility = function() {
        var _a;
        return ((_a = document.visibilityState) === null || _a === void 0 ? void 0 : _a.toString()) || null;
    };
    BrowserPerformanceClient.prototype.deleteIncompleteSubMeasurements = function(inProgressEvent) {
        var rootEvent = this.eventsByCorrelationId.get(inProgressEvent.event.correlationId);
        var isRootEvent = rootEvent && rootEvent.eventId === inProgressEvent.event.eventId;
        var incompleteMeasurements = [];
        if (isRootEvent && (rootEvent === null || rootEvent === void 0 ? void 0 : rootEvent.incompleteSubMeasurements)) rootEvent.incompleteSubMeasurements.forEach(function(subMeasurement) {
            incompleteMeasurements.push((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, subMeasurement));
        });
        // Clean up remaining marks for incomplete sub-measurements
        if (incompleteMeasurements.length > 0) (0, $f1439ddc6bb8eaaa$export$f97b8b5459a3aa4).flushMeasurements(inProgressEvent.event.correlationId, incompleteMeasurements);
    };
    BrowserPerformanceClient.prototype.supportsBrowserPerformanceNow = function() {
        return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.now === "function";
    };
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     * Also captures browser page visibilityState.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {((event?: Partial<PerformanceEvent>) => PerformanceEvent| null)}
     */ BrowserPerformanceClient.prototype.startMeasurement = function(measureName, correlationId) {
        var _this = this;
        // Capture page visibilityState and then invoke start/end measurement
        var startPageVisibility = this.getPageVisibility();
        var inProgressEvent = _super.prototype.startMeasurement.call(this, measureName, correlationId);
        return (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, inProgressEvent), {
            endMeasurement: function(event) {
                var res = inProgressEvent.endMeasurement((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({
                    startPageVisibility: startPageVisibility,
                    endPageVisibility: _this.getPageVisibility()
                }, event));
                _this.deleteIncompleteSubMeasurements(inProgressEvent);
                return res;
            },
            discardMeasurement: function() {
                inProgressEvent.discardMeasurement();
                _this.deleteIncompleteSubMeasurements(inProgressEvent);
                inProgressEvent.measurement.flushMeasurement();
            }
        });
    };
    /**
     * Adds pre-queue time to preQueueTimeByCorrelationId map.
     * @param {PerformanceEvents} eventName
     * @param {?string} correlationId
     * @returns
     */ BrowserPerformanceClient.prototype.setPreQueueTime = function(eventName, correlationId) {
        if (!this.supportsBrowserPerformanceNow()) {
            this.logger.trace("BrowserPerformanceClient: window performance API not available, unable to set telemetry queue time for " + eventName);
            return;
        }
        if (!correlationId) {
            this.logger.trace("BrowserPerformanceClient: correlationId for " + eventName + " not provided, unable to set telemetry queue time");
            return;
        }
        var preQueueEvent = this.preQueueTimeByCorrelationId.get(correlationId);
        /**
         * Manually complete queue measurement if there is an incomplete pre-queue event.
         * Incomplete pre-queue events are instrumentation bugs that should be fixed.
         */ if (preQueueEvent) {
            this.logger.trace("BrowserPerformanceClient: Incomplete pre-queue " + preQueueEvent.name + " found", correlationId);
            this.addQueueMeasurement(preQueueEvent.name, correlationId, undefined, true);
        }
        this.preQueueTimeByCorrelationId.set(correlationId, {
            name: eventName,
            time: window.performance.now()
        });
    };
    /**
     * Calculates and adds queue time measurement for given performance event.
     *
     * @param {PerformanceEvents} eventName
     * @param {?string} correlationId
     * @param {?number} queueTime
     * @param {?boolean} manuallyCompleted - indicator for manually completed queue measurements
     * @returns
     */ BrowserPerformanceClient.prototype.addQueueMeasurement = function(eventName, correlationId, queueTime, manuallyCompleted) {
        if (!this.supportsBrowserPerformanceNow()) {
            this.logger.trace("BrowserPerformanceClient: window performance API not available, unable to add queue measurement for " + eventName);
            return;
        }
        if (!correlationId) {
            this.logger.trace("BrowserPerformanceClient: correlationId for " + eventName + " not provided, unable to add queue measurement");
            return;
        }
        var preQueueTime = _super.prototype.getPreQueueTime.call(this, eventName, correlationId);
        if (!preQueueTime) return;
        var currentTime = window.performance.now();
        var resQueueTime = queueTime || _super.prototype.calculateQueuedTime.call(this, preQueueTime, currentTime);
        return _super.prototype.addQueueMeasurement.call(this, eventName, correlationId, resQueueTime, manuallyCompleted);
    };
    return BrowserPerformanceClient;
}((0, $25dab4b95c1456d8$export$820526014323765f));


"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ var $63cc57bb2064b171$export$8d1a43f377c8df92 = /** @class */ function() {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ function ClientApplication(configuration) {
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.isBrowserEnvironment = typeof window !== "undefined";
        // Set the configuration.
        this.config = (0, $f8475258f3a6b261$export$f8352245bee68086)(configuration, this.isBrowserEnvironment);
        this.initialized = false;
        // Initialize logger
        this.logger = new (0, $176db342bac9b10e$export$efa9a398d6368992)(this.config.system.loggerOptions, (0, $374e1ca34fdd445d$export$a8ff84c12d48cfa6), (0, $374e1ca34fdd445d$export$83d89fbfd8236492));
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.isBrowserEnvironment ? new (0, $7d6b489c584eae69$export$3714d85cfc8f4a02)(this.config.auth.clientId, this.config.auth.authority, this.logger, (0, $374e1ca34fdd445d$export$a8ff84c12d48cfa6), (0, $374e1ca34fdd445d$export$83d89fbfd8236492), this.config.telemetry.application, this.config.system.cryptoOptions) : new (0, $a4de6f8cf4e2564d$export$c70f2989a65fda3e)(this.config.auth.clientId, this.config.auth.authority, this.logger, (0, $374e1ca34fdd445d$export$a8ff84c12d48cfa6), (0, $374e1ca34fdd445d$export$83d89fbfd8236492), this.config.telemetry.application);
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, $188a01d1aa1ef5b2$export$c274a7f0ebd24b14)(this.logger, this.performanceClient, this.config.system.cryptoOptions) : (0, $2e9f1da89a74ab73$export$865f57d401606752);
        this.eventHandler = new (0, $07757f610459ee76$export$ce0ba2422a1c7815)(this.logger, this.browserCrypto);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, $6a4e3e48f11f536f$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger) : (0, $6a4e3e48f11f536f$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger);
        // initialize in memory storage for native flows
        var nativeCacheOptions = {
            cacheLocation: (0, $7b3089fdde5d004f$export$573384e47a12d835).MemoryStorage,
            temporaryCacheLocation: (0, $7b3089fdde5d004f$export$573384e47a12d835).MemoryStorage,
            storeAuthStateInCookie: false,
            secureCookies: false,
            cacheMigrationEnabled: false
        };
        this.nativeInternalStorage = new (0, $6a4e3e48f11f536f$export$44d7291b5c8cc149)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger);
        // Initialize the token cache
        this.tokenCache = new (0, $62c97a8b78c73ec7$export$ed5d1a18907a1001)(this.config, this.browserStorage, this.logger, this.browserCrypto);
        // Register listener functions
        this.trackPageVisibilityWithMeasurement = this.trackPageVisibilityWithMeasurement.bind(this);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     */ ClientApplication.prototype.initialize = function() {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var allowNativeBroker, initMeasurement, _a, e_1;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.logger.trace("initialize called");
                        if (this.initialized) {
                            this.logger.info("initialize has already been called, exiting early.");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        allowNativeBroker = this.config.system.allowNativeBroker;
                        initMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).InitializeClientApplication);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).INITIALIZE_START);
                        if (!allowNativeBroker) return [
                            3 /*break*/ ,
                            4
                        ];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            (0, $0342fe40e0ad80a3$export$c98888b8059e2702).createProvider(this.logger, this.config.system.nativeBrokerHandshakeTimeout, this.performanceClient)
                        ];
                    case 2:
                        _a.nativeExtensionProvider = _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _b.sent();
                        this.logger.verbose(e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        this.initialized = true;
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).INITIALIZE_END);
                        initMeasurement.endMeasurement({
                            allowNativeBroker: allowNativeBroker,
                            success: true
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ ClientApplication.prototype.handleRedirectPromise = function(hash) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var loggedInAccounts, redirectResponseKey, response, request, redirectResponse, nativeClient, correlationId, redirectClient;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                this.logger.verbose("handleRedirectPromise called");
                // Block token acquisition before initialize has been called if native brokering is enabled
                (0, $94c261d7c4faec3a$export$311899ae85124b2d).blockNativeBrokerCalledBeforeInitialized(this.config.system.allowNativeBroker, this.initialized);
                loggedInAccounts = this.getAllAccounts();
                if (this.isBrowserEnvironment) {
                    redirectResponseKey = hash || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                    response = this.redirectResponse.get(redirectResponseKey);
                    if (typeof response === "undefined") {
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).HANDLE_REDIRECT_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                        this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
                        request = this.browserStorage.getCachedNativeRequest();
                        redirectResponse = void 0;
                        if (request && (0, $0342fe40e0ad80a3$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider) && this.nativeExtensionProvider && !hash) {
                            this.logger.trace("handleRedirectPromise - acquiring token from native platform");
                            nativeClient = new (0, $6295e6242c57d6a1$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7b3089fdde5d004f$export$192d74ad69b40705).handleRedirectPromise, this.performanceClient, this.nativeExtensionProvider, request.accountId, this.nativeInternalStorage, request.correlationId);
                            redirectResponse = nativeClient.handleRedirectPromise();
                        } else {
                            this.logger.trace("handleRedirectPromise - acquiring token from web flow");
                            correlationId = this.browserStorage.getTemporaryCache((0, $7b3089fdde5d004f$export$21d55bedf0d269fb).CORRELATION_ID, true) || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
                            redirectClient = this.createRedirectClient(correlationId);
                            redirectResponse = redirectClient.handleRedirectPromise(hash);
                        }
                        response = redirectResponse.then(function(result) {
                            if (result) {
                                // Emit login event if number of accounts change
                                var isLoggingIn = loggedInAccounts.length < _this.getAllAccounts().length;
                                if (isLoggingIn) {
                                    _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, result);
                                    _this.logger.verbose("handleRedirectResponse returned result, login success");
                                } else {
                                    _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, result);
                                    _this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                                }
                            }
                            _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                            return result;
                        }).catch(function(e) {
                            // Emit login event if there is an account
                            if (loggedInAccounts.length > 0) _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, null, e);
                            else _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, null, e);
                            _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                            throw e;
                        });
                        this.redirectResponse.set(redirectResponseKey, response);
                    } else this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
                    return [
                        2 /*return*/ ,
                        response
                    ];
                }
                this.logger.verbose("handleRedirectPromise returns null, not browser environment");
                return [
                    2 /*return*/ ,
                    null
                ];
            });
        });
    };
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ ClientApplication.prototype.acquireTokenRedirect = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, isLoggedIn, result, nativeClient, redirectClient;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(request);
                this.logger.verbose("acquireTokenRedirect called", correlationId);
                this.preflightBrowserEnvironmentCheck((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                isLoggedIn = this.getAllAccounts().length > 0;
                if (isLoggedIn) this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, request);
                else this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, request);
                if (this.nativeExtensionProvider && this.canUseNative(request)) {
                    nativeClient = new (0, $6295e6242c57d6a1$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenRedirect, this.performanceClient, this.nativeExtensionProvider, this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
                    result = nativeClient.acquireTokenRedirect(request).catch(function(e) {
                        if (e instanceof (0, $6b6150874d021a33$export$4b8a4f6256e840ab) && e.isFatal()) {
                            _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                            var redirectClient = _this.createRedirectClient(request.correlationId);
                            return redirectClient.acquireToken(request);
                        } else if (e instanceof (0, $dec424bb7347a355$export$6ba3e818c6bc76ba)) {
                            _this.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
                            var redirectClient = _this.createRedirectClient(request.correlationId);
                            return redirectClient.acquireToken(request);
                        }
                        _this.browserStorage.setInteractionInProgress(false);
                        throw e;
                    });
                } else {
                    redirectClient = this.createRedirectClient(request.correlationId);
                    result = redirectClient.acquireToken(request);
                }
                return [
                    2 /*return*/ ,
                    result.catch(function(e) {
                        // If logged in, emit acquire token events
                        if (isLoggedIn) _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, null, e);
                        else _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect, null, e);
                        throw e;
                    })
                ];
            });
        });
    };
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ClientApplication.prototype.acquireTokenPopup = function(request) {
        var _this = this;
        var correlationId = this.getRequestCorrelationId(request);
        var atPopupMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenPopup, correlationId);
        try {
            this.logger.verbose("acquireTokenPopup called", correlationId);
            this.preflightBrowserEnvironmentCheck((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        var loggedInAccounts = this.getAllAccounts();
        if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, request);
        else this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, request);
        var result;
        if (this.canUseNative(request)) result = this.acquireTokenNative(request, (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenPopup).then(function(response) {
            _this.browserStorage.setInteractionInProgress(false);
            atPopupMeasurement.endMeasurement({
                success: true,
                isNativeBroker: true,
                requestId: response.requestId
            });
            return response;
        }).catch(function(e) {
            if (e instanceof (0, $6b6150874d021a33$export$4b8a4f6256e840ab) && e.isFatal()) {
                _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                var popupClient = _this.createPopupClient(request.correlationId);
                return popupClient.acquireToken(request);
            } else if (e instanceof (0, $dec424bb7347a355$export$6ba3e818c6bc76ba)) {
                _this.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
                var popupClient = _this.createPopupClient(request.correlationId);
                return popupClient.acquireToken(request);
            }
            _this.browserStorage.setInteractionInProgress(false);
            throw e;
        });
        else {
            var popupClient = this.createPopupClient(request.correlationId);
            result = popupClient.acquireToken(request);
        }
        return result.then(function(result) {
            /*
             *  If logged in, emit acquire token events
             */ var isLoggingIn = loggedInAccounts.length < _this.getAllAccounts().length;
            if (isLoggingIn) _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, result);
            else _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.addStaticFields({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.endMeasurement({
                success: true,
                requestId: result.requestId
            });
            return result;
        }).catch(function(e) {
            if (loggedInAccounts.length > 0) _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, null, e);
            else _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.endMeasurement({
                errorCode: e.errorCode,
                subErrorCode: e.subError,
                success: false
            });
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        });
    };
    ClientApplication.prototype.trackPageVisibilityWithMeasurement = function() {
        var measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        this.logger.info("Perf: Visibility change detected in ", measurement.event.name);
        measurement.increment({
            visibilityChangeCount: 1
        });
    };
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ClientApplication.prototype.ssoSilent = function(request) {
        var _a;
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, validRequest, result, silentIframeClient;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                correlationId = this.getRequestCorrelationId(request);
                validRequest = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request), {
                    // will be PromptValue.NONE or PromptValue.NO_SESSION
                    prompt: request.prompt,
                    correlationId: correlationId
                });
                this.preflightBrowserEnvironmentCheck((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent);
                this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).SsoSilent, correlationId);
                (_a = this.ssoSilentMeasurement) === null || _a === void 0 || _a.increment({
                    visibilityChangeCount: 0
                });
                document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
                this.logger.verbose("ssoSilent called", correlationId);
                this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).SSO_SILENT_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, validRequest);
                if (this.canUseNative(validRequest)) result = this.acquireTokenNative(validRequest, (0, $7b3089fdde5d004f$export$192d74ad69b40705).ssoSilent).catch(function(e) {
                    // If native token acquisition fails for availability reasons fallback to standard flow
                    if (e instanceof (0, $6b6150874d021a33$export$4b8a4f6256e840ab) && e.isFatal()) {
                        _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        var silentIframeClient = _this.createSilentIframeClient(validRequest.correlationId);
                        return silentIframeClient.acquireToken(validRequest);
                    }
                    throw e;
                });
                else {
                    silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                    result = silentIframeClient.acquireToken(validRequest);
                }
                return [
                    2 /*return*/ ,
                    result.then(function(response) {
                        var _a, _b;
                        _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).SSO_SILENT_SUCCESS, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, response);
                        (_a = _this.ssoSilentMeasurement) === null || _a === void 0 || _a.addStaticFields({
                            accessTokenSize: response.accessToken.length,
                            idTokenSize: response.idToken.length
                        });
                        (_b = _this.ssoSilentMeasurement) === null || _b === void 0 || _b.endMeasurement({
                            success: true,
                            isNativeBroker: response.fromNativeBroker,
                            requestId: response.requestId
                        });
                        return response;
                    }).catch(function(e) {
                        var _a;
                        _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).SSO_SILENT_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, null, e);
                        (_a = _this.ssoSilentMeasurement) === null || _a === void 0 || _a.endMeasurement({
                            errorCode: e.errorCode,
                            subErrorCode: e.subError,
                            success: false
                        });
                        throw e;
                    }).finally(function() {
                        document.removeEventListener("visibilitychange", _this.trackPageVisibilityWithMeasurement);
                    })
                ];
            });
        });
    };
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ClientApplication.prototype.acquireTokenByCode = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, atbcMeasurement, hybridAuthCode_1, response;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(request);
                this.preflightBrowserEnvironmentCheck((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent);
                this.logger.trace("acquireTokenByCode called", correlationId);
                this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, request);
                atbcMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenByCode, request.correlationId);
                try {
                    if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
                    throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createSpaCodeAndNativeAccountIdPresentError();
                    else if (request.code) {
                        hybridAuthCode_1 = request.code;
                        response = this.hybridAuthCodeResponses.get(hybridAuthCode_1);
                        if (!response) {
                            this.logger.verbose("Initiating new acquireTokenByCode request", correlationId);
                            response = this.acquireTokenByCodeAsync((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request), {
                                correlationId: correlationId
                            })).then(function(result) {
                                _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_SUCCESS, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, result);
                                _this.hybridAuthCodeResponses.delete(hybridAuthCode_1);
                                atbcMeasurement.addStaticFields({
                                    accessTokenSize: result.accessToken.length,
                                    idTokenSize: result.idToken.length
                                });
                                atbcMeasurement.endMeasurement({
                                    success: true,
                                    isNativeBroker: result.fromNativeBroker,
                                    requestId: result.requestId
                                });
                                return result;
                            }).catch(function(error) {
                                _this.hybridAuthCodeResponses.delete(hybridAuthCode_1);
                                _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, null, error);
                                atbcMeasurement.endMeasurement({
                                    errorCode: error.errorCode,
                                    subErrorCode: error.subError,
                                    success: false
                                });
                                throw error;
                            });
                            this.hybridAuthCodeResponses.set(hybridAuthCode_1, response);
                        } else {
                            this.logger.verbose("Existing acquireTokenByCode request found", request.correlationId);
                            atbcMeasurement.discardMeasurement();
                        }
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    } else if (request.nativeAccountId) {
                        if (this.canUseNative(request, request.nativeAccountId)) return [
                            2 /*return*/ ,
                            this.acquireTokenNative(request, (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenByCode, request.nativeAccountId).catch(function(e) {
                                // If native token acquisition fails for availability reasons fallback to standard flow
                                if (e instanceof (0, $6b6150874d021a33$export$4b8a4f6256e840ab) && e.isFatal()) _this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                                throw e;
                            })
                        ];
                        else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createUnableToAcquireTokenFromNativePlatformError();
                    } else throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createAuthCodeOrNativeAccountIdRequiredError();
                } catch (e) {
                    this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, null, e);
                    atbcMeasurement.endMeasurement({
                        errorCode: e instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac) && e.errorCode || undefined,
                        subErrorCode: e instanceof (0, $7f0aeee92385582d$export$145273558d58e0ac) && e.subError || undefined,
                        success: false
                    });
                    throw e;
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ ClientApplication.prototype.acquireTokenByCodeAsync = function(request) {
        var _a;
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentAuthCodeClient, silentTokenResult;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.logger.trace("acquireTokenByCodeAsync called", request.correlationId);
                        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenByCodeAsync, request.correlationId);
                        (_a = this.acquireTokenByCodeAsyncMeasurement) === null || _a === void 0 || _a.increment({
                            visibilityChangeCount: 0
                        });
                        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
                        silentAuthCodeClient = this.createSilentAuthCodeClient(request.correlationId);
                        return [
                            4 /*yield*/ ,
                            silentAuthCodeClient.acquireToken(request).then(function(response) {
                                var _a;
                                (_a = _this.acquireTokenByCodeAsyncMeasurement) === null || _a === void 0 || _a.endMeasurement({
                                    success: true,
                                    fromCache: response.fromCache,
                                    isNativeBroker: response.fromNativeBroker,
                                    requestId: response.requestId
                                });
                                return response;
                            }).catch(function(tokenRenewalError) {
                                var _a;
                                (_a = _this.acquireTokenByCodeAsyncMeasurement) === null || _a === void 0 || _a.endMeasurement({
                                    errorCode: tokenRenewalError.errorCode,
                                    subErrorCode: tokenRenewalError.subError,
                                    success: false
                                });
                                throw tokenRenewalError;
                            }).finally(function() {
                                document.removeEventListener("visibilitychange", _this.trackPageVisibilityWithMeasurement);
                            })
                        ];
                    case 1:
                        silentTokenResult = _b.sent();
                        return [
                            2 /*return*/ ,
                            silentTokenResult
                        ];
                }
            });
        });
    };
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ ClientApplication.prototype.acquireTokenFromCache = function(silentCacheClient, commonRequest, silentRequest) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenFromCache, commonRequest.correlationId);
                switch(silentRequest.cacheLookupPolicy){
                    case (0, $7b3089fdde5d004f$export$4394baa7e922d42d).Default:
                    case (0, $7b3089fdde5d004f$export$4394baa7e922d42d).AccessToken:
                    case (0, $7b3089fdde5d004f$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                        return [
                            2 /*return*/ ,
                            silentCacheClient.acquireToken(commonRequest)
                        ];
                    default:
                        throw (0, $30cd164be78785f3$export$a839ff85a7957561).createRefreshRequiredError();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ ClientApplication.prototype.acquireTokenByRefreshToken = function(commonRequest, silentRequest) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentRefreshClient;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, commonRequest.correlationId);
                switch(silentRequest.cacheLookupPolicy){
                    case (0, $7b3089fdde5d004f$export$4394baa7e922d42d).Default:
                    case (0, $7b3089fdde5d004f$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                    case (0, $7b3089fdde5d004f$export$4394baa7e922d42d).RefreshToken:
                    case (0, $7b3089fdde5d004f$export$4394baa7e922d42d).RefreshTokenAndNetwork:
                        silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, commonRequest.correlationId);
                        return [
                            2 /*return*/ ,
                            silentRefreshClient.acquireToken(commonRequest)
                        ];
                    default:
                        throw (0, $30cd164be78785f3$export$a839ff85a7957561).createRefreshRequiredError();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ ClientApplication.prototype.acquireTokenBySilentIframe = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var silentIframeClient;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, request.correlationId);
                silentIframeClient = this.createSilentIframeClient(request.correlationId);
                this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
                return [
                    2 /*return*/ ,
                    silentIframeClient.acquireToken(request)
                ];
            });
        });
    };
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ ClientApplication.prototype.logout = function(logoutRequest) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(logoutRequest);
                this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", correlationId);
                return [
                    2 /*return*/ ,
                    this.logoutRedirect((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({
                        correlationId: correlationId
                    }, logoutRequest))
                ];
            });
        });
    };
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ ClientApplication.prototype.logoutRedirect = function(logoutRequest) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, redirectClient;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(logoutRequest);
                this.preflightBrowserEnvironmentCheck((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
                redirectClient = this.createRedirectClient(correlationId);
                return [
                    2 /*return*/ ,
                    redirectClient.logout(logoutRequest)
                ];
            });
        });
    };
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ ClientApplication.prototype.logoutPopup = function(logoutRequest) {
        try {
            var correlationId = this.getRequestCorrelationId(logoutRequest);
            this.preflightBrowserEnvironmentCheck((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup);
            var popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    };
    // #endregion
    // #region Account APIs
    /**
     * Returns all accounts that MSAL currently has data for.
     * (the account object is created at the time of successful login)
     * or empty array when no accounts are found
     * @returns Array of account objects in cache
     */ ClientApplication.prototype.getAllAccounts = function() {
        this.logger.verbose("getAllAccounts called");
        return this.isBrowserEnvironment ? this.browserStorage.getAllAccounts() : [];
    };
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ ClientApplication.prototype.getAccountByUsername = function(username) {
        this.logger.trace("getAccountByUsername called");
        if (!username) {
            this.logger.warning("getAccountByUsername: No username provided");
            return null;
        }
        var account = this.browserStorage.getAccountInfoFilteredBy({
            username: username
        });
        if (account) {
            this.logger.verbose("getAccountByUsername: Account matching username found, returning");
            this.logger.verbosePii("getAccountByUsername: Returning signed-in accounts matching username: " + username);
            return account;
        } else {
            this.logger.verbose("getAccountByUsername: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ ClientApplication.prototype.getAccountByHomeId = function(homeAccountId) {
        this.logger.trace("getAccountByHomeId called");
        if (!homeAccountId) {
            this.logger.warning("getAccountByHomeId: No homeAccountId provided");
            return null;
        }
        var account = this.browserStorage.getAccountInfoFilteredBy({
            homeAccountId: homeAccountId
        });
        if (account) {
            this.logger.verbose("getAccountByHomeId: Account matching homeAccountId found, returning");
            this.logger.verbosePii("getAccountByHomeId: Returning signed-in accounts matching homeAccountId: " + homeAccountId);
            return account;
        } else {
            this.logger.verbose("getAccountByHomeId: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ ClientApplication.prototype.getAccountByLocalId = function(localAccountId) {
        this.logger.trace("getAccountByLocalId called");
        if (!localAccountId) {
            this.logger.warning("getAccountByLocalId: No localAccountId provided");
            return null;
        }
        var account = this.browserStorage.getAccountInfoFilteredBy({
            localAccountId: localAccountId
        });
        if (account) {
            this.logger.verbose("getAccountByLocalId: Account matching localAccountId found, returning");
            this.logger.verbosePii("getAccountByLocalId: Returning signed-in accounts matching localAccountId: " + localAccountId);
            return account;
        } else {
            this.logger.verbose("getAccountByLocalId: No matching account found, returning null");
            return null;
        }
    };
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ ClientApplication.prototype.setActiveAccount = function(account) {
        this.browserStorage.setActiveAccount(account);
    };
    /**
     * Gets the currently active account
     */ ClientApplication.prototype.getActiveAccount = function() {
        return this.browserStorage.getActiveAccount();
    };
    // #endregion
    // #region Helpers
    /**
     * Helper to validate app environment before making an auth request
     *
     * @protected
     * @param {InteractionType} interactionType What kind of interaction is being used
     * @param {boolean} [setInteractionInProgress=true] Whether to set interaction in progress temp cache flag
     */ ClientApplication.prototype.preflightBrowserEnvironmentCheck = function(interactionType, setInteractionInProgress) {
        if (setInteractionInProgress === void 0) setInteractionInProgress = true;
        this.logger.verbose("preflightBrowserEnvironmentCheck started");
        // Block request if not in browser environment
        (0, $94c261d7c4faec3a$export$311899ae85124b2d).blockNonBrowserEnvironment(this.isBrowserEnvironment);
        // Block redirects if in an iframe
        (0, $94c261d7c4faec3a$export$311899ae85124b2d).blockRedirectInIframe(interactionType, this.config.system.allowRedirectInIframe);
        // Block auth requests inside a hidden iframe
        (0, $94c261d7c4faec3a$export$311899ae85124b2d).blockReloadInHiddenIframes();
        // Block redirectUri opened in a popup from calling MSAL APIs
        (0, $94c261d7c4faec3a$export$311899ae85124b2d).blockAcquireTokenInPopups();
        // Block token acquisition before initialize has been called if native brokering is enabled
        (0, $94c261d7c4faec3a$export$311899ae85124b2d).blockNativeBrokerCalledBeforeInitialized(this.config.system.allowNativeBroker, this.initialized);
        // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
        if (interactionType === (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect && this.config.cache.cacheLocation === (0, $7b3089fdde5d004f$export$573384e47a12d835).MemoryStorage && !this.config.cache.storeAuthStateInCookie) throw (0, $9979eb0576c15d31$export$2eb7a1dfdc4c5fba).createInMemoryRedirectUnavailableError();
        if (interactionType === (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect || interactionType === (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Popup) this.preflightInteractiveRequest(setInteractionInProgress);
    };
    /**
     * Preflight check for interactive requests
     *
     * @protected
     * @param {boolean} setInteractionInProgress Whether to set interaction in progress temp cache flag
     */ ClientApplication.prototype.preflightInteractiveRequest = function(setInteractionInProgress) {
        this.logger.verbose("preflightInteractiveRequest called, validating app environment");
        // block the reload if it occurred inside a hidden iframe
        (0, $94c261d7c4faec3a$export$311899ae85124b2d).blockReloadInHiddenIframes();
        // Set interaction in progress temporary cache or throw if alread set.
        if (setInteractionInProgress) this.browserStorage.setInteractionInProgress(true);
    };
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ ClientApplication.prototype.acquireTokenNative = function(request, apiId, accountId) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var nativeClient;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                this.logger.trace("acquireTokenNative called");
                if (!this.nativeExtensionProvider) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNativeConnectionNotEstablishedError();
                nativeClient = new (0, $6295e6242c57d6a1$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.nativeExtensionProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
                return [
                    2 /*return*/ ,
                    nativeClient.acquireToken(request)
                ];
            });
        });
    };
    /**
     * Returns boolean indicating if this request can use the native broker
     * @param request
     */ ClientApplication.prototype.canUseNative = function(request, accountId) {
        this.logger.trace("canUseNative called");
        if (!(0, $0342fe40e0ad80a3$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, request.authenticationScheme)) {
            this.logger.trace("canUseNative: isNativeAvailable returned false, returning false");
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).NONE:
            case (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).CONSENT:
            case (0, $1b76d687a319d9ed$export$49a06cbda5acaa5).LOGIN:
                this.logger.trace("canUseNative: prompt is compatible with native flow");
                break;
            default:
                this.logger.trace("canUseNative: prompt = " + request.prompt + " is not compatible with native flow, returning false");
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("canUseNative: nativeAccountId is not available, returning false");
            return false;
        }
        return true;
    };
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ ClientApplication.prototype.getNativeAccountId = function(request) {
        var account = request.account || this.browserStorage.getAccountInfoByHints(request.loginHint, request.sid) || this.getActiveAccount();
        return account && account.nativeAccountId || "";
    };
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ ClientApplication.prototype.createPopupClient = function(correlationId) {
        return new (0, $25a90acdc8c2f00b$export$43b0fce132d066f4)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ ClientApplication.prototype.createRedirectClient = function(correlationId) {
        return new (0, $430112e1234035e1$export$a368977effbc1ed6)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ ClientApplication.prototype.createSilentIframeClient = function(correlationId) {
        return new (0, $0ce5ebcdbe996c3e$export$e81c7938bccef977)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7b3089fdde5d004f$export$192d74ad69b40705).ssoSilent, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ ClientApplication.prototype.createSilentCacheClient = function(correlationId) {
        return new (0, $1d1eca9cf4a95a8a$export$59d4f873ee62d01e)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ ClientApplication.prototype.createSilentRefreshClient = function(correlationId) {
        return new (0, $69c4a2deffcc1b73$export$b4a36596822a5d2)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ ClientApplication.prototype.createSilentAuthCodeClient = function(correlationId) {
        return new (0, $131a918488917121$export$d7f5ef311b3e9fca)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenByCode, this.performanceClient, this.nativeExtensionProvider, correlationId);
    };
    /**
     * Adds event callbacks to array
     * @param callback
     */ ClientApplication.prototype.addEventCallback = function(callback) {
        return this.eventHandler.addEventCallback(callback);
    };
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ ClientApplication.prototype.removeEventCallback = function(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    };
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ ClientApplication.prototype.addPerformanceCallback = function(callback) {
        return this.performanceClient.addPerformanceCallback(callback);
    };
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ ClientApplication.prototype.removePerformanceCallback = function(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    };
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ ClientApplication.prototype.enableAccountStorageEvents = function() {
        this.eventHandler.enableAccountStorageEvents();
    };
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ ClientApplication.prototype.disableAccountStorageEvents = function() {
        this.eventHandler.disableAccountStorageEvents();
    };
    /**
     * Gets the token cache for the application.
     */ ClientApplication.prototype.getTokenCache = function() {
        return this.tokenCache;
    };
    /**
     * Returns the logger instance
     */ ClientApplication.prototype.getLogger = function() {
        return this.logger;
    };
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ ClientApplication.prototype.setLogger = function(logger) {
        this.logger = logger;
    };
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ ClientApplication.prototype.initializeWrapperLibrary = function(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    };
    /**
     * Sets navigation client
     * @param navigationClient
     */ ClientApplication.prototype.setNavigationClient = function(navigationClient) {
        this.navigationClient = navigationClient;
    };
    /**
     * Returns the configuration object
     */ ClientApplication.prototype.getConfiguration = function() {
        return this.config;
    };
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ ClientApplication.prototype.getRequestCorrelationId = function(request) {
        if (request === null || request === void 0 ? void 0 : request.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return this.browserCrypto.createNewGuid();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING;
    };
    return ClientApplication;
}();







"use strict";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ var $ff46adc1ee21bccd$export$89f4855ef88b7920 = /** @class */ function(_super) {
    (0, $ac3fbc8ec7de8c8c$export$a8ba968b8961cb8a)(PublicClientApplication, _super);
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration object for the MSAL PublicClientApplication instance
     */ function PublicClientApplication(configuration) {
        var _this = _super.call(this, configuration) || this;
        _this.astsAsyncMeasurement = undefined;
        _this.activeSilentTokenRequests = new Map();
        // Register listener functions
        _this.trackPageVisibility = _this.trackPageVisibility.bind(_this);
        return _this;
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ PublicClientApplication.prototype.loginRedirect = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(request);
                this.logger.verbose("loginRedirect called", correlationId);
                return [
                    2 /*return*/ ,
                    this.acquireTokenRedirect((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({
                        correlationId: correlationId
                    }, request || (0, $7b3089fdde5d004f$export$7e12949cd6884193)))
                ];
            });
        });
    };
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ PublicClientApplication.prototype.loginPopup = function(request) {
        var correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginPopup called", correlationId);
        return this.acquireTokenPopup((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({
            correlationId: correlationId
        }, request || (0, $7b3089fdde5d004f$export$7e12949cd6884193)));
    };
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ PublicClientApplication.prototype.acquireTokenSilent = function(request) {
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var correlationId, atsMeasurement, account, thumbprint, silentRequestKey, cachedResponse, response;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                correlationId = this.getRequestCorrelationId(request);
                atsMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenSilent, correlationId);
                atsMeasurement.addStaticFields({
                    cacheLookupPolicy: request.cacheLookupPolicy
                });
                this.preflightBrowserEnvironmentCheck((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent);
                this.logger.verbose("acquireTokenSilent called", correlationId);
                account = request.account || this.getActiveAccount();
                if (!account) throw (0, $68ecaba305c397db$export$f8eb6760ca13876a).createNoAccountError();
                thumbprint = {
                    clientId: this.config.auth.clientId,
                    authority: request.authority || (0, $1b76d687a319d9ed$export$a002182e51710d39).EMPTY_STRING,
                    scopes: request.scopes,
                    homeAccountIdentifier: account.homeAccountId,
                    claims: request.claims,
                    authenticationScheme: request.authenticationScheme,
                    resourceRequestMethod: request.resourceRequestMethod,
                    resourceRequestUri: request.resourceRequestUri,
                    shrClaims: request.shrClaims,
                    sshKid: request.sshKid
                };
                silentRequestKey = JSON.stringify(thumbprint);
                cachedResponse = this.activeSilentTokenRequests.get(silentRequestKey);
                if (typeof cachedResponse === "undefined") {
                    this.logger.verbose("acquireTokenSilent called for the first time, storing active request", correlationId);
                    this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenSilentAsync, correlationId);
                    response = this.acquireTokenSilentAsync((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request), {
                        correlationId: correlationId
                    }), account).then(function(result) {
                        _this.activeSilentTokenRequests.delete(silentRequestKey);
                        atsMeasurement.addStaticFields({
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length
                        });
                        atsMeasurement.endMeasurement({
                            success: true,
                            fromCache: result.fromCache,
                            isNativeBroker: result.fromNativeBroker,
                            cacheLookupPolicy: request.cacheLookupPolicy,
                            requestId: result.requestId
                        });
                        return result;
                    }).catch(function(error) {
                        _this.activeSilentTokenRequests.delete(silentRequestKey);
                        atsMeasurement.endMeasurement({
                            errorCode: error.errorCode,
                            subErrorCode: error.subError,
                            success: false
                        });
                        throw error;
                    });
                    this.activeSilentTokenRequests.set(silentRequestKey, response);
                    return [
                        2 /*return*/ ,
                        response
                    ];
                } else {
                    this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", correlationId);
                    // Discard measurements for memoized calls, as they are usually only a couple of ms and will artificially deflate metrics
                    atsMeasurement.discardMeasurement();
                    return [
                        2 /*return*/ ,
                        cachedResponse
                    ];
                }
            });
        });
    };
    PublicClientApplication.prototype.trackPageVisibility = function() {
        if (!this.astsAsyncMeasurement) return;
        this.logger.info("Perf: Visibility change detected");
        this.astsAsyncMeasurement.increment({
            visibilityChangeCount: 1
        });
    };
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ PublicClientApplication.prototype.acquireTokenSilentAsync = function(request, account) {
        var _a;
        return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var result, silentRequest, silentCacheClient, silentRequest_1, requestWithCLP_1;
            var _this = this;
            return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.performanceClient.addQueueMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
                        this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, request);
                        this.astsAsyncMeasurement = this.performanceClient.startMeasurement((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
                        (_a = this.astsAsyncMeasurement) === null || _a === void 0 || _a.increment({
                            visibilityChangeCount: 0
                        });
                        document.addEventListener("visibilitychange", this.trackPageVisibility);
                        if (!((0, $0342fe40e0ad80a3$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, request.authenticationScheme) && account.nativeAccountId)) return [
                            3 /*break*/ ,
                            1
                        ];
                        this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform");
                        silentRequest = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request), {
                            account: account
                        });
                        result = this.acquireTokenNative(silentRequest, (0, $7b3089fdde5d004f$export$192d74ad69b40705).acquireTokenSilent_silentFlow).catch(function(e) {
                            return (0, $ac3fbc8ec7de8c8c$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                                var silentIframeClient;
                                return (0, $ac3fbc8ec7de8c8c$export$67ebef60e6f28a6)(this, function(_a) {
                                    // If native token acquisition fails for availability reasons fallback to web flow
                                    if (e instanceof (0, $6b6150874d021a33$export$4b8a4f6256e840ab) && e.isFatal()) {
                                        this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow");
                                        this.nativeExtensionProvider = undefined; // Prevent future requests from continuing to attempt
                                        silentIframeClient = this.createSilentIframeClient(request.correlationId);
                                        return [
                                            2 /*return*/ ,
                                            silentIframeClient.acquireToken(request)
                                        ];
                                    }
                                    throw e;
                                });
                            });
                        });
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow");
                        silentCacheClient = this.createSilentCacheClient(request.correlationId);
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).InitializeSilentRequest, request.correlationId);
                        return [
                            4 /*yield*/ ,
                            silentCacheClient.initializeSilentRequest(request, account)
                        ];
                    case 2:
                        silentRequest_1 = _b.sent();
                        requestWithCLP_1 = (0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)((0, $ac3fbc8ec7de8c8c$export$18ce0697a983be9b)({}, request), {
                            // set the request's CacheLookupPolicy to Default if it was not optionally passed in
                            cacheLookupPolicy: request.cacheLookupPolicy || (0, $7b3089fdde5d004f$export$4394baa7e922d42d).Default
                        });
                        this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenFromCache, silentRequest_1.correlationId);
                        result = this.acquireTokenFromCache(silentCacheClient, silentRequest_1, requestWithCLP_1).catch(function(cacheError) {
                            if (requestWithCLP_1.cacheLookupPolicy === (0, $7b3089fdde5d004f$export$4394baa7e922d42d).AccessToken) throw cacheError;
                            // block the reload if it occurred inside a hidden iframe
                            (0, $94c261d7c4faec3a$export$311899ae85124b2d).blockReloadInHiddenIframes();
                            _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_NETWORK_START, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, silentRequest_1);
                            _this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, silentRequest_1.correlationId);
                            return _this.acquireTokenByRefreshToken(silentRequest_1, requestWithCLP_1).catch(function(refreshTokenError) {
                                var isServerError = refreshTokenError instanceof (0, $b198a6cc5c52ae21$export$ea52035eac03daf0);
                                var isInteractionRequiredError = refreshTokenError instanceof (0, $dec424bb7347a355$export$6ba3e818c6bc76ba);
                                var isInvalidGrantError = refreshTokenError.errorCode === (0, $7b3089fdde5d004f$export$a0a689e4294b9880).INVALID_GRANT_ERROR;
                                if ((!isServerError || !isInvalidGrantError || isInteractionRequiredError || requestWithCLP_1.cacheLookupPolicy === (0, $7b3089fdde5d004f$export$4394baa7e922d42d).AccessTokenAndRefreshToken || requestWithCLP_1.cacheLookupPolicy === (0, $7b3089fdde5d004f$export$4394baa7e922d42d).RefreshToken) && requestWithCLP_1.cacheLookupPolicy !== (0, $7b3089fdde5d004f$export$4394baa7e922d42d).Skip) throw refreshTokenError;
                                _this.logger.verbose("Refresh token expired/invalid or CacheLookupPolicy is set to Skip, attempting acquire token by iframe.", request.correlationId);
                                _this.performanceClient.setPreQueueTime((0, $57d7adee307e257f$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, silentRequest_1.correlationId);
                                return _this.acquireTokenBySilentIframe(silentRequest_1);
                            });
                        });
                        _b.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            result.then(function(response) {
                                var _a;
                                _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, response);
                                (_a = _this.astsAsyncMeasurement) === null || _a === void 0 || _a.endMeasurement({
                                    success: true,
                                    fromCache: response.fromCache,
                                    isNativeBroker: response.fromNativeBroker,
                                    requestId: response.requestId
                                });
                                return response;
                            }).catch(function(tokenRenewalError) {
                                var _a;
                                _this.eventHandler.emitEvent((0, $8576a8f6fd30fa65$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Silent, null, tokenRenewalError);
                                (_a = _this.astsAsyncMeasurement) === null || _a === void 0 || _a.endMeasurement({
                                    errorCode: tokenRenewalError.errorCode,
                                    subErrorCode: tokenRenewalError.subError,
                                    success: false
                                });
                                throw tokenRenewalError;
                            }).finally(function() {
                                document.removeEventListener("visibilitychange", _this.trackPageVisibility);
                            })
                        ];
                }
            });
        });
    };
    return PublicClientApplication;
}((0, $63cc57bb2064b171$export$8d1a43f377c8df92));


/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ 
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */ const $31d3020758198998$var$TENANT_ID = "740e0ba1-e4ed-4c5d-9a56-2559c8fb94a6";
const $31d3020758198998$var$CLIENT_ID = "b1116872-b672-41e3-99da-de3699fc0c8b";
const $31d3020758198998$var$redirectUri = `${window.location.origin}`;
const $31d3020758198998$export$f6d610d2730cbf1a = {
    auth: {
        clientId: `${$31d3020758198998$var$CLIENT_ID}`,
        authority: `https://login.microsoftonline.com/${$31d3020758198998$var$TENANT_ID}`,
        redirectUri: $31d3020758198998$var$redirectUri,
        postLogoutRedirectUri: $31d3020758198998$var$redirectUri
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
        temporaryCacheLocation: "sessionStorage"
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii)=>{
                if (containsPii) return;
                switch(level){
                    case (0, $176db342bac9b10e$export$243e62d78d3b544d).Error:
                        break;
                    case (0, $176db342bac9b10e$export$243e62d78d3b544d).Info:
                        break;
                    case (0, $176db342bac9b10e$export$243e62d78d3b544d).Verbose:
                        break;
                    case (0, $176db342bac9b10e$export$243e62d78d3b544d).Warning:
                        break;
                }
            }
        }
    }
};
const $31d3020758198998$export$be6c432b2463c5eb = {
    scopes: [
        "User.Read"
    ]
};
const $31d3020758198998$export$4965d3e40bbf5ccb = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};


const $abad72839459f54c$var$CLIENT_ID = "b1116872-b672-41e3-99da-de3699fc0c8b";
const $abad72839459f54c$export$ca9e2d319cf1d00d = {
    scopes: [
        `${$abad72839459f54c$var$CLIENT_ID}/.default`
    ]
};
const $abad72839459f54c$export$a59c2286a7150b12 = new (0, $ff46adc1ee21bccd$export$89f4855ef88b7920)((0, $31d3020758198998$export$f6d610d2730cbf1a));
const $abad72839459f54c$export$84773cc9bf7dbe87 = async ()=>{
    await $abad72839459f54c$export$a59c2286a7150b12.initialize();
    const accounts = $abad72839459f54c$export$a59c2286a7150b12.getAllAccounts();
    if (accounts.length > 0) {
        const accessToken = await $abad72839459f54c$export$a59c2286a7150b12.acquireTokenSilent($abad72839459f54c$export$ca9e2d319cf1d00d).then((response)=>{
            return response.accessToken;
        }).catch((error)=>{
            // Do not fallback to interaction when running outside the context of MsalProvider. Interaction should always be done inside context.
            console.log(error);
            return null;
        });
        return accessToken;
    }
    return null;
};
// Account selection logic is app dependent. Adjust as needed for different use cases.
$abad72839459f54c$export$a59c2286a7150b12.addEventCallback((event)=>{
    if (event.eventType === (0, $8576a8f6fd30fa65$export$3d7865934588d77e).LOGIN_SUCCESS) {
        // @ts-expect-error: see above
        const account = event.payload.account;
        $abad72839459f54c$export$a59c2286a7150b12.setActiveAccount(account);
    }
});



var $2WrlN = parcelRequire("2WrlN");
/**
 * React Router DOM v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $ld5Xm = parcelRequire("ld5Xm");

/**
 * @remix-run/router v1.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $2d8227aa615edd2d$var$_extends() {
    $2d8227aa615edd2d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2d8227aa615edd2d$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $2d8227aa615edd2d$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($2d8227aa615edd2d$export$e19cd5f9376f8cee || ($2d8227aa615edd2d$export$e19cd5f9376f8cee = {}));
const $2d8227aa615edd2d$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $2d8227aa615edd2d$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $2d8227aa615edd2d$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $2d8227aa615edd2d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $2d8227aa615edd2d$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $2d8227aa615edd2d$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $2d8227aa615edd2d$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $2d8227aa615edd2d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $2d8227aa615edd2d$export$fe53371bee54353d(to);
    }
    return $2d8227aa615edd2d$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $2d8227aa615edd2d$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $2d8227aa615edd2d$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $2d8227aa615edd2d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $2d8227aa615edd2d$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $2d8227aa615edd2d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $2d8227aa615edd2d$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $2d8227aa615edd2d$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $2d8227aa615edd2d$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $2d8227aa615edd2d$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $2d8227aa615edd2d$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $2d8227aa615edd2d$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $2d8227aa615edd2d$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $2d8227aa615edd2d$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $2d8227aa615edd2d$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $2d8227aa615edd2d$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $2d8227aa615edd2d$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $2d8227aa615edd2d$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($2d8227aa615edd2d$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Push;
        let location = $2d8227aa615edd2d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $2d8227aa615edd2d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Replace;
        let location = $2d8227aa615edd2d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $2d8227aa615edd2d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $2d8227aa615edd2d$export$fe53371bee54353d(to);
        $2d8227aa615edd2d$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($2d8227aa615edd2d$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($2d8227aa615edd2d$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $2d8227aa615edd2d$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($2d8227aa615edd2d$var$ResultType || ($2d8227aa615edd2d$var$ResultType = {}));
const $2d8227aa615edd2d$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $2d8227aa615edd2d$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $2d8227aa615edd2d$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $2d8227aa615edd2d$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $2d8227aa615edd2d$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($2d8227aa615edd2d$var$isIndexRoute(route)) {
            let indexRoute = $2d8227aa615edd2d$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $2d8227aa615edd2d$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $2d8227aa615edd2d$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $2d8227aa615edd2d$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $2d8227aa615edd2d$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $2d8227aa615edd2d$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $2d8227aa615edd2d$var$flattenRoutes(routes);
    $2d8227aa615edd2d$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $2d8227aa615edd2d$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $2d8227aa615edd2d$var$safelyDecodeURI(pathname));
    return matches;
}
function $2d8227aa615edd2d$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $2d8227aa615edd2d$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $2d8227aa615edd2d$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $2d8227aa615edd2d$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $2d8227aa615edd2d$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $2d8227aa615edd2d$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $2d8227aa615edd2d$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $2d8227aa615edd2d$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $2d8227aa615edd2d$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $2d8227aa615edd2d$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $2d8227aa615edd2d$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $2d8227aa615edd2d$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $2d8227aa615edd2d$var$paramRe = /^:[\w-]+$/;
const $2d8227aa615edd2d$var$dynamicSegmentValue = 3;
const $2d8227aa615edd2d$var$indexRouteValue = 2;
const $2d8227aa615edd2d$var$emptySegmentValue = 1;
const $2d8227aa615edd2d$var$staticSegmentValue = 10;
const $2d8227aa615edd2d$var$splatPenalty = -2;
const $2d8227aa615edd2d$var$isSplat = (s)=>s === "*";
function $2d8227aa615edd2d$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($2d8227aa615edd2d$var$isSplat)) initialScore += $2d8227aa615edd2d$var$splatPenalty;
    if (index) initialScore += $2d8227aa615edd2d$var$indexRouteValue;
    return segments.filter((s)=>!$2d8227aa615edd2d$var$isSplat(s)).reduce((score, segment)=>score + ($2d8227aa615edd2d$var$paramRe.test(segment) ? $2d8227aa615edd2d$var$dynamicSegmentValue : segment === "" ? $2d8227aa615edd2d$var$emptySegmentValue : $2d8227aa615edd2d$var$staticSegmentValue), initialScore);
}
function $2d8227aa615edd2d$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $2d8227aa615edd2d$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $2d8227aa615edd2d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $2d8227aa615edd2d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $2d8227aa615edd2d$export$a5c6d149b50c1d86($2d8227aa615edd2d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $2d8227aa615edd2d$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $2d8227aa615edd2d$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $2d8227aa615edd2d$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $2d8227aa615edd2d$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $2d8227aa615edd2d$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $2d8227aa615edd2d$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $2d8227aa615edd2d$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $2d8227aa615edd2d$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $2d8227aa615edd2d$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $2d8227aa615edd2d$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $2d8227aa615edd2d$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $2d8227aa615edd2d$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $2d8227aa615edd2d$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $2d8227aa615edd2d$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $2d8227aa615edd2d$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $2d8227aa615edd2d$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $2d8227aa615edd2d$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $2d8227aa615edd2d$var$normalizeSearch(search),
        hash: $2d8227aa615edd2d$var$normalizeHash(hash)
    };
}
function $2d8227aa615edd2d$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $2d8227aa615edd2d$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $2d8227aa615edd2d$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $2d8227aa615edd2d$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $2d8227aa615edd2d$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $2d8227aa615edd2d$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $2d8227aa615edd2d$export$8ccf933b0513f8d0(toArg);
    else {
        to = $2d8227aa615edd2d$var$_extends({}, toArg);
        $2d8227aa615edd2d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $2d8227aa615edd2d$var$getInvalidPathError("?", "pathname", "search", to));
        $2d8227aa615edd2d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $2d8227aa615edd2d$var$getInvalidPathError("#", "pathname", "hash", to));
        $2d8227aa615edd2d$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $2d8227aa615edd2d$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $2d8227aa615edd2d$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $2d8227aa615edd2d$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $2d8227aa615edd2d$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $2d8227aa615edd2d$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $2d8227aa615edd2d$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $2d8227aa615edd2d$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $2d8227aa615edd2d$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $2d8227aa615edd2d$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $2d8227aa615edd2d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $2d8227aa615edd2d$export$42a99a7a4bc0e76a extends Error {
}
class $2d8227aa615edd2d$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $2d8227aa615edd2d$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $2d8227aa615edd2d$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $2d8227aa615edd2d$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $2d8227aa615edd2d$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $2d8227aa615edd2d$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $2d8227aa615edd2d$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $2d8227aa615edd2d$var$unwrapTrackedPromise(value) {
    if (!$2d8227aa615edd2d$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $2d8227aa615edd2d$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $2d8227aa615edd2d$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $2d8227aa615edd2d$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $2d8227aa615edd2d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $2d8227aa615edd2d$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $2d8227aa615edd2d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $2d8227aa615edd2d$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $2d8227aa615edd2d$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $2d8227aa615edd2d$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $2d8227aa615edd2d$var$validMutationMethods = new Set($2d8227aa615edd2d$var$validMutationMethodsArr);
const $2d8227aa615edd2d$var$validRequestMethodsArr = [
    "get",
    ...$2d8227aa615edd2d$var$validMutationMethodsArr
];
const $2d8227aa615edd2d$var$validRequestMethods = new Set($2d8227aa615edd2d$var$validRequestMethodsArr);
const $2d8227aa615edd2d$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $2d8227aa615edd2d$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $2d8227aa615edd2d$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $2d8227aa615edd2d$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $2d8227aa615edd2d$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $2d8227aa615edd2d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $2d8227aa615edd2d$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $2d8227aa615edd2d$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $2d8227aa615edd2d$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $2d8227aa615edd2d$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $2d8227aa615edd2d$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $2d8227aa615edd2d$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $2d8227aa615edd2d$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $2d8227aa615edd2d$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $2d8227aa615edd2d$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $2d8227aa615edd2d$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $2d8227aa615edd2d$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $2d8227aa615edd2d$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $2d8227aa615edd2d$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $2d8227aa615edd2d$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$2d8227aa615edd2d$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($2d8227aa615edd2d$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $2d8227aa615edd2d$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $2d8227aa615edd2d$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $2d8227aa615edd2d$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $2d8227aa615edd2d$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $2d8227aa615edd2d$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $2d8227aa615edd2d$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $2d8227aa615edd2d$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $2d8227aa615edd2d$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $2d8227aa615edd2d$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($2d8227aa615edd2d$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $2d8227aa615edd2d$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $2d8227aa615edd2d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $2d8227aa615edd2d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $2d8227aa615edd2d$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $2d8227aa615edd2d$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $2d8227aa615edd2d$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $2d8227aa615edd2d$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $2d8227aa615edd2d$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $2d8227aa615edd2d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $2d8227aa615edd2d$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $2d8227aa615edd2d$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $2d8227aa615edd2d$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $2d8227aa615edd2d$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$2d8227aa615edd2d$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $2d8227aa615edd2d$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $2d8227aa615edd2d$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $2d8227aa615edd2d$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $2d8227aa615edd2d$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $2d8227aa615edd2d$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $2d8227aa615edd2d$var$ResultType.error,
            error: $2d8227aa615edd2d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $2d8227aa615edd2d$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($2d8227aa615edd2d$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($2d8227aa615edd2d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $2d8227aa615edd2d$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $2d8227aa615edd2d$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($2d8227aa615edd2d$var$isDeferredResult(result)) throw $2d8227aa615edd2d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $2d8227aa615edd2d$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $2d8227aa615edd2d$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $2d8227aa615edd2d$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $2d8227aa615edd2d$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $2d8227aa615edd2d$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($2d8227aa615edd2d$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $2d8227aa615edd2d$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $2d8227aa615edd2d$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $2d8227aa615edd2d$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $2d8227aa615edd2d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $2d8227aa615edd2d$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $2d8227aa615edd2d$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $2d8227aa615edd2d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $2d8227aa615edd2d$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $2d8227aa615edd2d$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $2d8227aa615edd2d$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $2d8227aa615edd2d$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $2d8227aa615edd2d$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $2d8227aa615edd2d$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($2d8227aa615edd2d$var$isRedirectResult(actionResult) || $2d8227aa615edd2d$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $2d8227aa615edd2d$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($2d8227aa615edd2d$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $2d8227aa615edd2d$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $2d8227aa615edd2d$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($2d8227aa615edd2d$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($2d8227aa615edd2d$var$isDeferredResult(actionResult)) throw $2d8227aa615edd2d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $2d8227aa615edd2d$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $2d8227aa615edd2d$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $2d8227aa615edd2d$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $2d8227aa615edd2d$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $2d8227aa615edd2d$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $2d8227aa615edd2d$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $2d8227aa615edd2d$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $2d8227aa615edd2d$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $2d8227aa615edd2d$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $2d8227aa615edd2d$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $2d8227aa615edd2d$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $2d8227aa615edd2d$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $2d8227aa615edd2d$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $2d8227aa615edd2d$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($2d8227aa615edd2d$var$isDeferredResult(result)) result = await $2d8227aa615edd2d$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $2d8227aa615edd2d$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($2d8227aa615edd2d$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $2d8227aa615edd2d$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($2d8227aa615edd2d$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $2d8227aa615edd2d$export$3e9cee6b33872309(!$2d8227aa615edd2d$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $2d8227aa615edd2d$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $2d8227aa615edd2d$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $2d8227aa615edd2d$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($2d8227aa615edd2d$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $2d8227aa615edd2d$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $2d8227aa615edd2d$export$e19cd5f9376f8cee.Replace : $2d8227aa615edd2d$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $2d8227aa615edd2d$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($2d8227aa615edd2d$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $2d8227aa615edd2d$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $2d8227aa615edd2d$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $2d8227aa615edd2d$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$2d8227aa615edd2d$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $2d8227aa615edd2d$var$callLoaderOrAction("loader", $2d8227aa615edd2d$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $2d8227aa615edd2d$var$ResultType.error,
                        error: $2d8227aa615edd2d$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $2d8227aa615edd2d$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $2d8227aa615edd2d$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $2d8227aa615edd2d$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $2d8227aa615edd2d$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $2d8227aa615edd2d$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $2d8227aa615edd2d$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $2d8227aa615edd2d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $2d8227aa615edd2d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $2d8227aa615edd2d$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $2d8227aa615edd2d$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $2d8227aa615edd2d$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $2d8227aa615edd2d$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $2d8227aa615edd2d$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$2d8227aa615edd2d$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $2d8227aa615edd2d$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $2d8227aa615edd2d$export$4d0306f8f6a4585b = Symbol("deferred");
function $2d8227aa615edd2d$export$3336b097a6fbc59a(routes, opts) {
    $2d8227aa615edd2d$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $2d8227aa615edd2d$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $2d8227aa615edd2d$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $2d8227aa615edd2d$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $2d8227aa615edd2d$var$createLocation("", $2d8227aa615edd2d$export$fe53371bee54353d(url), null, "default");
        let matches = $2d8227aa615edd2d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$2d8227aa615edd2d$var$isValidMethod(method) && method !== "HEAD") {
            let error = $2d8227aa615edd2d$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $2d8227aa615edd2d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $2d8227aa615edd2d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $2d8227aa615edd2d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($2d8227aa615edd2d$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $2d8227aa615edd2d$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $2d8227aa615edd2d$var$createLocation("", $2d8227aa615edd2d$export$fe53371bee54353d(url), null, "default");
        let matches = $2d8227aa615edd2d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$2d8227aa615edd2d$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $2d8227aa615edd2d$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $2d8227aa615edd2d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $2d8227aa615edd2d$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $2d8227aa615edd2d$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $2d8227aa615edd2d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($2d8227aa615edd2d$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$2d8227aa615edd2d$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $2d8227aa615edd2d$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($2d8227aa615edd2d$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $2d8227aa615edd2d$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $2d8227aa615edd2d$var$isResponse(result) ? result : $2d8227aa615edd2d$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($2d8227aa615edd2d$var$isQueryRouteResponse(e)) {
                if (e.type === $2d8227aa615edd2d$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($2d8227aa615edd2d$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $2d8227aa615edd2d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $2d8227aa615edd2d$var$ResultType.error,
                error: error
            };
        } else {
            result = await $2d8227aa615edd2d$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $2d8227aa615edd2d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($2d8227aa615edd2d$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($2d8227aa615edd2d$var$isDeferredResult(result)) {
            let error = $2d8227aa615edd2d$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $2d8227aa615edd2d$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($2d8227aa615edd2d$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($2d8227aa615edd2d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $2d8227aa615edd2d$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $2d8227aa615edd2d$var$_extends({}, context, {
                statusCode: $2d8227aa615edd2d$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $2d8227aa615edd2d$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $2d8227aa615edd2d$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $2d8227aa615edd2d$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $2d8227aa615edd2d$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $2d8227aa615edd2d$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$2d8227aa615edd2d$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $2d8227aa615edd2d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $2d8227aa615edd2d$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $2d8227aa615edd2d$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $2d8227aa615edd2d$export$fec11da027c70692(routes, context, error) {
    let newContext = $2d8227aa615edd2d$var$_extends({}, context, {
        statusCode: $2d8227aa615edd2d$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $2d8227aa615edd2d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $2d8227aa615edd2d$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $2d8227aa615edd2d$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $2d8227aa615edd2d$export$cae722b0cc860f13(to ? to : ".", $2d8227aa615edd2d$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $2d8227aa615edd2d$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$2d8227aa615edd2d$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $2d8227aa615edd2d$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $2d8227aa615edd2d$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $2d8227aa615edd2d$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$2d8227aa615edd2d$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$2d8227aa615edd2d$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $2d8227aa615edd2d$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $2d8227aa615edd2d$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $2d8227aa615edd2d$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$2d8227aa615edd2d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$2d8227aa615edd2d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $2d8227aa615edd2d$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $2d8227aa615edd2d$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $2d8227aa615edd2d$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $2d8227aa615edd2d$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $2d8227aa615edd2d$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($2d8227aa615edd2d$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $2d8227aa615edd2d$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $2d8227aa615edd2d$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $2d8227aa615edd2d$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $2d8227aa615edd2d$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $2d8227aa615edd2d$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $2d8227aa615edd2d$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($2d8227aa615edd2d$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $2d8227aa615edd2d$var$shouldRevalidateLoader(match, $2d8227aa615edd2d$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $2d8227aa615edd2d$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $2d8227aa615edd2d$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $2d8227aa615edd2d$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $2d8227aa615edd2d$var$shouldRevalidateLoader(fetcherMatch, $2d8227aa615edd2d$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $2d8227aa615edd2d$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $2d8227aa615edd2d$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $2d8227aa615edd2d$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $2d8227aa615edd2d$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $2d8227aa615edd2d$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $2d8227aa615edd2d$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$2d8227aa615edd2d$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $2d8227aa615edd2d$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $2d8227aa615edd2d$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $2d8227aa615edd2d$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $2d8227aa615edd2d$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $2d8227aa615edd2d$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $2d8227aa615edd2d$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $2d8227aa615edd2d$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $2d8227aa615edd2d$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $2d8227aa615edd2d$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($2d8227aa615edd2d$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($2d8227aa615edd2d$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $2d8227aa615edd2d$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$2d8227aa615edd2d$var$ABSOLUTE_URL_REGEX.test(location)) location = $2d8227aa615edd2d$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $2d8227aa615edd2d$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $2d8227aa615edd2d$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $2d8227aa615edd2d$var$ResultType.error ? $2d8227aa615edd2d$var$ResultType.error : $2d8227aa615edd2d$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $2d8227aa615edd2d$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $2d8227aa615edd2d$var$ResultType.error) return {
            type: resultType,
            error: new $2d8227aa615edd2d$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $2d8227aa615edd2d$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $2d8227aa615edd2d$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($2d8227aa615edd2d$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $2d8227aa615edd2d$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $2d8227aa615edd2d$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $2d8227aa615edd2d$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($2d8227aa615edd2d$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $2d8227aa615edd2d$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $2d8227aa615edd2d$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $2d8227aa615edd2d$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $2d8227aa615edd2d$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $2d8227aa615edd2d$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $2d8227aa615edd2d$export$3e9cee6b33872309(!$2d8227aa615edd2d$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($2d8227aa615edd2d$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $2d8227aa615edd2d$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $2d8227aa615edd2d$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($2d8227aa615edd2d$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $2d8227aa615edd2d$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $2d8227aa615edd2d$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $2d8227aa615edd2d$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($2d8227aa615edd2d$var$isErrorResult(result)) {
            let boundaryMatch = $2d8227aa615edd2d$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $2d8227aa615edd2d$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($2d8227aa615edd2d$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $2d8227aa615edd2d$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($2d8227aa615edd2d$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $2d8227aa615edd2d$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $2d8227aa615edd2d$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $2d8227aa615edd2d$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $2d8227aa615edd2d$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $2d8227aa615edd2d$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $2d8227aa615edd2d$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $2d8227aa615edd2d$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $2d8227aa615edd2d$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $2d8227aa615edd2d$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($2d8227aa615edd2d$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $2d8227aa615edd2d$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $2d8227aa615edd2d$export$8ccf933b0513f8d0(path) : path;
    return $2d8227aa615edd2d$export$fe53371bee54353d($2d8227aa615edd2d$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $2d8227aa615edd2d$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $2d8227aa615edd2d$var$isDeferredResult(result) {
    return result.type === $2d8227aa615edd2d$var$ResultType.deferred;
}
function $2d8227aa615edd2d$var$isErrorResult(result) {
    return result.type === $2d8227aa615edd2d$var$ResultType.error;
}
function $2d8227aa615edd2d$var$isRedirectResult(result) {
    return (result && result.type) === $2d8227aa615edd2d$var$ResultType.redirect;
}
function $2d8227aa615edd2d$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $2d8227aa615edd2d$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $2d8227aa615edd2d$var$isRedirectResponse(result) {
    if (!$2d8227aa615edd2d$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $2d8227aa615edd2d$var$isQueryRouteResponse(obj) {
    return obj && $2d8227aa615edd2d$var$isResponse(obj.response) && (obj.type === $2d8227aa615edd2d$var$ResultType.data || obj.type === $2d8227aa615edd2d$var$ResultType.error);
}
function $2d8227aa615edd2d$var$isValidMethod(method) {
    return $2d8227aa615edd2d$var$validRequestMethods.has(method.toLowerCase());
}
function $2d8227aa615edd2d$var$isMutationMethod(method) {
    return $2d8227aa615edd2d$var$validMutationMethods.has(method.toLowerCase());
}
async function $2d8227aa615edd2d$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$2d8227aa615edd2d$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($2d8227aa615edd2d$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $2d8227aa615edd2d$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $2d8227aa615edd2d$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $2d8227aa615edd2d$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $2d8227aa615edd2d$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $2d8227aa615edd2d$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $2d8227aa615edd2d$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $2d8227aa615edd2d$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $2d8227aa615edd2d$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $2d8227aa615edd2d$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $2d8227aa615edd2d$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $2d8227aa615edd2d$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $2d8227aa615edd2d$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $2d8227aa615edd2d$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $2d8227aa615edd2d$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $2d8227aa615edd2d$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $2d8227aa615edd2d$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $2d8227aa615edd2d$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $2d8227aa615edd2d$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($2d8227aa615edd2d$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $2d8227aa615edd2d$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($2d8227aa615edd2d$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $2d8227aa615edd2d$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $ld5Xm = parcelRequire("ld5Xm");

function $bb19e89bd54fc2f3$var$_extends() {
    $bb19e89bd54fc2f3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bb19e89bd54fc2f3$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $bb19e89bd54fc2f3$export$3add0d5dce533e2e = /*#__PURE__*/ $ld5Xm.createContext(null);
const $bb19e89bd54fc2f3$export$145dfa71566a64dc = /*#__PURE__*/ $ld5Xm.createContext(null);
const $bb19e89bd54fc2f3$var$AwaitContext = /*#__PURE__*/ $ld5Xm.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $bb19e89bd54fc2f3$export$26749e8557646306 = /*#__PURE__*/ $ld5Xm.createContext(null);
const $bb19e89bd54fc2f3$export$c7914228fb69b0f5 = /*#__PURE__*/ $ld5Xm.createContext(null);
const $bb19e89bd54fc2f3$export$9072aa6dd1f93057 = /*#__PURE__*/ $ld5Xm.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $bb19e89bd54fc2f3$var$RouteErrorContext = /*#__PURE__*/ $ld5Xm.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $bb19e89bd54fc2f3$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$bb19e89bd54fc2f3$export$9c954a9d03d32f4a() && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $bb19e89bd54fc2f3$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2d8227aa615edd2d$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $bb19e89bd54fc2f3$export$9c954a9d03d32f4a() {
    return $ld5Xm.useContext($bb19e89bd54fc2f3$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $bb19e89bd54fc2f3$export$45d76561a5302f2b() {
    !$bb19e89bd54fc2f3$export$9c954a9d03d32f4a() && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    return $ld5Xm.useContext($bb19e89bd54fc2f3$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $bb19e89bd54fc2f3$export$1b3f31771c5d07c() {
    return $ld5Xm.useContext($bb19e89bd54fc2f3$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $bb19e89bd54fc2f3$export$6c330e8992e8a295(pattern) {
    !$bb19e89bd54fc2f3$export$9c954a9d03d32f4a() && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $bb19e89bd54fc2f3$export$45d76561a5302f2b();
    return $ld5Xm.useMemo(()=>(0, $2d8227aa615edd2d$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $bb19e89bd54fc2f3$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $bb19e89bd54fc2f3$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $ld5Xm.useContext($bb19e89bd54fc2f3$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $ld5Xm.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $bb19e89bd54fc2f3$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $bb19e89bd54fc2f3$var$useNavigateStable() : $bb19e89bd54fc2f3$var$useNavigateUnstable();
}
function $bb19e89bd54fc2f3$var$useNavigateUnstable() {
    !$bb19e89bd54fc2f3$export$9c954a9d03d32f4a() && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    let dataRouterContext = $ld5Xm.useContext($bb19e89bd54fc2f3$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$26749e8557646306);
    let { matches: matches } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bb19e89bd54fc2f3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2d8227aa615edd2d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $ld5Xm.useRef(false);
    $bb19e89bd54fc2f3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $ld5Xm.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2d8227aa615edd2d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2d8227aa615edd2d$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $bb19e89bd54fc2f3$var$OutletContext = /*#__PURE__*/ $ld5Xm.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $bb19e89bd54fc2f3$export$4138103a3ae699cc() {
    return $ld5Xm.useContext($bb19e89bd54fc2f3$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $bb19e89bd54fc2f3$export$a3be3530d8e40d0b(context) {
    let outlet = $ld5Xm.useContext($bb19e89bd54fc2f3$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $bb19e89bd54fc2f3$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $bb19e89bd54fc2f3$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$26749e8557646306);
    let { matches: matches } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bb19e89bd54fc2f3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2d8227aa615edd2d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $ld5Xm.useMemo(()=>(0, $2d8227aa615edd2d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $bb19e89bd54fc2f3$export$5d3fca4a98652595(routes, locationArg) {
    return $bb19e89bd54fc2f3$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $bb19e89bd54fc2f3$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$bb19e89bd54fc2f3$export$9c954a9d03d32f4a() && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$26749e8557646306);
    let { matches: parentMatches } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $bb19e89bd54fc2f3$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2d8227aa615edd2d$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $2d8227aa615edd2d$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $bb19e89bd54fc2f3$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2d8227aa615edd2d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2d8227aa615edd2d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $bb19e89bd54fc2f3$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2d8227aa615edd2d$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $bb19e89bd54fc2f3$var$DefaultErrorComponent() {
    let error = $bb19e89bd54fc2f3$export$ed527bf60f6e05f2();
    let message = (0, $2d8227aa615edd2d$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $ld5Xm.createElement($ld5Xm.Fragment, null, /*#__PURE__*/ $ld5Xm.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $ld5Xm.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $ld5Xm.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $bb19e89bd54fc2f3$var$defaultErrorElement = /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$DefaultErrorComponent, null);
class $bb19e89bd54fc2f3$var$RenderErrorBoundary extends $ld5Xm.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $bb19e89bd54fc2f3$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $ld5Xm.useContext($bb19e89bd54fc2f3$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $bb19e89bd54fc2f3$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $bb19e89bd54fc2f3$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $bb19e89bd54fc2f3$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $ld5Xm.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $bb19e89bd54fc2f3$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($bb19e89bd54fc2f3$var$DataRouterHook || {});
var $bb19e89bd54fc2f3$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($bb19e89bd54fc2f3$var$DataRouterStateHook || {});
function $bb19e89bd54fc2f3$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $bb19e89bd54fc2f3$var$useDataRouterContext(hookName) {
    let ctx = $ld5Xm.useContext($bb19e89bd54fc2f3$export$3add0d5dce533e2e);
    !ctx && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $bb19e89bd54fc2f3$var$useDataRouterState(hookName) {
    let state = $ld5Xm.useContext($bb19e89bd54fc2f3$export$145dfa71566a64dc);
    !state && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    return state;
}
function $bb19e89bd54fc2f3$var$useRouteContext(hookName) {
    let route = $ld5Xm.useContext($bb19e89bd54fc2f3$export$9072aa6dd1f93057);
    !route && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $bb19e89bd54fc2f3$var$useCurrentRouteId(hookName) {
    let route = $bb19e89bd54fc2f3$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $bb19e89bd54fc2f3$export$5fc8298006ad9e58() {
    return $bb19e89bd54fc2f3$var$useCurrentRouteId($bb19e89bd54fc2f3$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $bb19e89bd54fc2f3$export$d0fd4b7106de2769() {
    let state = $bb19e89bd54fc2f3$var$useDataRouterState($bb19e89bd54fc2f3$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $bb19e89bd54fc2f3$export$600dc272ed516c15() {
    let dataRouterContext = $bb19e89bd54fc2f3$var$useDataRouterContext($bb19e89bd54fc2f3$var$DataRouterHook.UseRevalidator);
    let state = $bb19e89bd54fc2f3$var$useDataRouterState($bb19e89bd54fc2f3$var$DataRouterStateHook.UseRevalidator);
    return $ld5Xm.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $bb19e89bd54fc2f3$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $bb19e89bd54fc2f3$var$useDataRouterState($bb19e89bd54fc2f3$var$DataRouterStateHook.UseMatches);
    return $ld5Xm.useMemo(()=>matches.map((m)=>(0, $2d8227aa615edd2d$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $bb19e89bd54fc2f3$export$1448a5050d252c4d() {
    let state = $bb19e89bd54fc2f3$var$useDataRouterState($bb19e89bd54fc2f3$var$DataRouterStateHook.UseLoaderData);
    let routeId = $bb19e89bd54fc2f3$var$useCurrentRouteId($bb19e89bd54fc2f3$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $bb19e89bd54fc2f3$export$fd5d37484eab868d(routeId) {
    let state = $bb19e89bd54fc2f3$var$useDataRouterState($bb19e89bd54fc2f3$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $bb19e89bd54fc2f3$export$fdc00f3f26066d5e() {
    let state = $bb19e89bd54fc2f3$var$useDataRouterState($bb19e89bd54fc2f3$var$DataRouterStateHook.UseActionData);
    let routeId = $bb19e89bd54fc2f3$var$useCurrentRouteId($bb19e89bd54fc2f3$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $bb19e89bd54fc2f3$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $ld5Xm.useContext($bb19e89bd54fc2f3$var$RouteErrorContext);
    let state = $bb19e89bd54fc2f3$var$useDataRouterState($bb19e89bd54fc2f3$var$DataRouterStateHook.UseRouteError);
    let routeId = $bb19e89bd54fc2f3$var$useCurrentRouteId($bb19e89bd54fc2f3$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $bb19e89bd54fc2f3$export$78a72ddb39bdd145() {
    let value = $ld5Xm.useContext($bb19e89bd54fc2f3$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $bb19e89bd54fc2f3$export$17f53340677d5831() {
    let value = $ld5Xm.useContext($bb19e89bd54fc2f3$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $bb19e89bd54fc2f3$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $bb19e89bd54fc2f3$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $bb19e89bd54fc2f3$var$useDataRouterContext($bb19e89bd54fc2f3$var$DataRouterHook.UseBlocker);
    let state = $bb19e89bd54fc2f3$var$useDataRouterState($bb19e89bd54fc2f3$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $ld5Xm.useState("");
    let blockerFunction = $ld5Xm.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $bb19e89bd54fc2f3$var$_extends({}, currentLocation, {
                pathname: (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $bb19e89bd54fc2f3$var$_extends({}, nextLocation, {
                pathname: (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $ld5Xm.useEffect(()=>{
        let key = String(++$bb19e89bd54fc2f3$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $ld5Xm.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2d8227aa615edd2d$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $bb19e89bd54fc2f3$var$useNavigateStable() {
    let { router: router } = $bb19e89bd54fc2f3$var$useDataRouterContext($bb19e89bd54fc2f3$var$DataRouterHook.UseNavigateStable);
    let id = $bb19e89bd54fc2f3$var$useCurrentRouteId($bb19e89bd54fc2f3$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $ld5Xm.useRef(false);
    $bb19e89bd54fc2f3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $ld5Xm.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $bb19e89bd54fc2f3$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $bb19e89bd54fc2f3$var$alreadyWarned = {};
function $bb19e89bd54fc2f3$var$warningOnce(key, cond, message) {
    if (!cond && !$bb19e89bd54fc2f3$var$alreadyWarned[key]) $bb19e89bd54fc2f3$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $bb19e89bd54fc2f3$var$START_TRANSITION = "startTransition";
const $bb19e89bd54fc2f3$var$startTransitionImpl = $ld5Xm[$bb19e89bd54fc2f3$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $bb19e89bd54fc2f3$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $ld5Xm.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $ld5Xm.useCallback((newState)=>{
        if (v7_startTransition && $bb19e89bd54fc2f3$var$startTransitionImpl) $bb19e89bd54fc2f3$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $ld5Xm.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $ld5Xm.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $ld5Xm.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $ld5Xm.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $ld5Xm.createElement($ld5Xm.Fragment, null, /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $bb19e89bd54fc2f3$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $bb19e89bd54fc2f3$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $bb19e89bd54fc2f3$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $ld5Xm.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2d8227aa615edd2d$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ld5Xm.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $ld5Xm.useCallback((newState)=>{
        v7_startTransition && $bb19e89bd54fc2f3$var$startTransitionImpl ? $bb19e89bd54fc2f3$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $ld5Xm.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $bb19e89bd54fc2f3$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$bb19e89bd54fc2f3$export$9c954a9d03d32f4a() && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$26749e8557646306);
    let { matches: matches } = $ld5Xm.useContext($bb19e89bd54fc2f3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bb19e89bd54fc2f3$export$45d76561a5302f2b();
    let navigate = $bb19e89bd54fc2f3$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2d8227aa615edd2d$export$cae722b0cc860f13)(to, (0, $2d8227aa615edd2d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $ld5Xm.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $bb19e89bd54fc2f3$export$910ae8079b2c2852(props) {
    return $bb19e89bd54fc2f3$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $bb19e89bd54fc2f3$export$e7b0ac011bb776c6(_props) {
    (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $bb19e89bd54fc2f3$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2d8227aa615edd2d$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$bb19e89bd54fc2f3$export$9c954a9d03d32f4a() && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $ld5Xm.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $bb19e89bd54fc2f3$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2d8227aa615edd2d$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $ld5Xm.useMemo(()=>{
        let trailingPathname = (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $bb19e89bd54fc2f3$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $bb19e89bd54fc2f3$export$5d3fca4a98652595($bb19e89bd54fc2f3$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $bb19e89bd54fc2f3$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$ResolveAwait, null, children));
}
var $bb19e89bd54fc2f3$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($bb19e89bd54fc2f3$var$AwaitRenderStatus || {});
const $bb19e89bd54fc2f3$var$neverSettledPromise = new Promise(()=>{});
class $bb19e89bd54fc2f3$var$AwaitErrorBoundary extends $ld5Xm.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $bb19e89bd54fc2f3$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $bb19e89bd54fc2f3$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $bb19e89bd54fc2f3$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $bb19e89bd54fc2f3$var$AwaitRenderStatus.error : promise._data !== undefined ? $bb19e89bd54fc2f3$var$AwaitRenderStatus.success : $bb19e89bd54fc2f3$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $bb19e89bd54fc2f3$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $bb19e89bd54fc2f3$var$AwaitRenderStatus.error && promise._error instanceof (0, $2d8227aa615edd2d$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $bb19e89bd54fc2f3$var$neverSettledPromise;
        if (status === $bb19e89bd54fc2f3$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $bb19e89bd54fc2f3$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $bb19e89bd54fc2f3$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $ld5Xm.createElement($bb19e89bd54fc2f3$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $bb19e89bd54fc2f3$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $bb19e89bd54fc2f3$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $ld5Xm.createElement($ld5Xm.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $bb19e89bd54fc2f3$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $ld5Xm.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $ld5Xm.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $ld5Xm.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $bb19e89bd54fc2f3$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $bb19e89bd54fc2f3$export$e7b0ac011bb776c6) && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $bb19e89bd54fc2f3$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $bb19e89bd54fc2f3$export$daf73786167a7f72(matches) {
    return $bb19e89bd54fc2f3$var$_renderMatches(matches);
}
function $bb19e89bd54fc2f3$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $ld5Xm.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $ld5Xm.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $ld5Xm.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $bb19e89bd54fc2f3$export$f30f7e456d254e83(routes, opts) {
    return (0, $2d8227aa615edd2d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $bb19e89bd54fc2f3$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2d8227aa615edd2d$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $bb19e89bd54fc2f3$export$52b333d321859367
    }).initialize();
}



function $68c2ac1c8be5656b$var$_extends() {
    $68c2ac1c8be5656b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $68c2ac1c8be5656b$var$_extends.apply(this, arguments);
}
function $68c2ac1c8be5656b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $68c2ac1c8be5656b$var$defaultMethod = "get";
const $68c2ac1c8be5656b$var$defaultEncType = "application/x-www-form-urlencoded";
function $68c2ac1c8be5656b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $68c2ac1c8be5656b$var$isButtonElement(object) {
    return $68c2ac1c8be5656b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $68c2ac1c8be5656b$var$isFormElement(object) {
    return $68c2ac1c8be5656b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $68c2ac1c8be5656b$var$isInputElement(object) {
    return $68c2ac1c8be5656b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $68c2ac1c8be5656b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $68c2ac1c8be5656b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$68c2ac1c8be5656b$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $68c2ac1c8be5656b$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $68c2ac1c8be5656b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $68c2ac1c8be5656b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $68c2ac1c8be5656b$var$_formDataSupportsSubmitter = null;
function $68c2ac1c8be5656b$var$isFormDataSubmitterSupported() {
    if ($68c2ac1c8be5656b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $68c2ac1c8be5656b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $68c2ac1c8be5656b$var$_formDataSupportsSubmitter = true;
    }
    return $68c2ac1c8be5656b$var$_formDataSupportsSubmitter;
}
const $68c2ac1c8be5656b$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $68c2ac1c8be5656b$var$getFormEncType(encType) {
    if (encType != null && !$68c2ac1c8be5656b$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $68c2ac1c8be5656b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($68c2ac1c8be5656b$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $68c2ac1c8be5656b$var$defaultMethod;
        encType = $68c2ac1c8be5656b$var$getFormEncType(target.getAttribute("enctype")) || $68c2ac1c8be5656b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($68c2ac1c8be5656b$var$isButtonElement(target) || $68c2ac1c8be5656b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $68c2ac1c8be5656b$var$defaultMethod;
        encType = $68c2ac1c8be5656b$var$getFormEncType(target.getAttribute("formenctype")) || $68c2ac1c8be5656b$var$getFormEncType(form.getAttribute("enctype")) || $68c2ac1c8be5656b$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$68c2ac1c8be5656b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($68c2ac1c8be5656b$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $68c2ac1c8be5656b$var$defaultMethod;
        action = null;
        encType = $68c2ac1c8be5656b$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $68c2ac1c8be5656b$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $68c2ac1c8be5656b$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $68c2ac1c8be5656b$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $68c2ac1c8be5656b$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $68c2ac1c8be5656b$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $68c2ac1c8be5656b$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2d8227aa615edd2d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $68c2ac1c8be5656b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2d8227aa615edd2d$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $68c2ac1c8be5656b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bb19e89bd54fc2f3$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $68c2ac1c8be5656b$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2d8227aa615edd2d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $68c2ac1c8be5656b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2d8227aa615edd2d$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $68c2ac1c8be5656b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bb19e89bd54fc2f3$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $68c2ac1c8be5656b$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $68c2ac1c8be5656b$var$_extends({}, state, {
        errors: $68c2ac1c8be5656b$var$deserializeErrors(state.errors)
    });
    return state;
}
function $68c2ac1c8be5656b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2d8227aa615edd2d$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $68c2ac1c8be5656b$export$7ad602f0e94e62d1 = /*#__PURE__*/ $ld5Xm.createContext({
    isTransitioning: false
});
const $68c2ac1c8be5656b$export$148fd98d095596d4 = /*#__PURE__*/ $ld5Xm.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $68c2ac1c8be5656b$var$START_TRANSITION = "startTransition";
const $68c2ac1c8be5656b$var$startTransitionImpl = $ld5Xm[$68c2ac1c8be5656b$var$START_TRANSITION];
const $68c2ac1c8be5656b$var$FLUSH_SYNC = "flushSync";
const $68c2ac1c8be5656b$var$flushSyncImpl = $b86f1e2f9a665e04$exports[$68c2ac1c8be5656b$var$FLUSH_SYNC];
const $68c2ac1c8be5656b$var$USE_ID = "useId";
const $68c2ac1c8be5656b$var$useIdImpl = $ld5Xm[$68c2ac1c8be5656b$var$USE_ID];
function $68c2ac1c8be5656b$var$startTransitionSafe(cb) {
    if ($68c2ac1c8be5656b$var$startTransitionImpl) $68c2ac1c8be5656b$var$startTransitionImpl(cb);
    else cb();
}
function $68c2ac1c8be5656b$var$flushSyncSafe(cb) {
    if ($68c2ac1c8be5656b$var$flushSyncImpl) $68c2ac1c8be5656b$var$flushSyncImpl(cb);
    else cb();
}
class $68c2ac1c8be5656b$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $68c2ac1c8be5656b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $ld5Xm.useState(router.state);
    let [pendingState, setPendingState] = $ld5Xm.useState();
    let [vtContext, setVtContext] = $ld5Xm.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $ld5Xm.useState();
    let [transition, setTransition] = $ld5Xm.useState();
    let [interruption, setInterruption] = $ld5Xm.useState();
    let fetcherData = $ld5Xm.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $ld5Xm.useCallback((cb)=>{
        if (v7_startTransition) $68c2ac1c8be5656b$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $ld5Xm.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $68c2ac1c8be5656b$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $68c2ac1c8be5656b$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $68c2ac1c8be5656b$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $68c2ac1c8be5656b$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $68c2ac1c8be5656b$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $ld5Xm.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $ld5Xm.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $68c2ac1c8be5656b$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $ld5Xm.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $ld5Xm.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $ld5Xm.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $ld5Xm.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $ld5Xm.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $ld5Xm.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $ld5Xm.createElement($ld5Xm.Fragment, null, /*#__PURE__*/ $ld5Xm.createElement((0, $bb19e89bd54fc2f3$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $ld5Xm.createElement((0, $bb19e89bd54fc2f3$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $ld5Xm.createElement($68c2ac1c8be5656b$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $ld5Xm.createElement($68c2ac1c8be5656b$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $ld5Xm.createElement((0, $bb19e89bd54fc2f3$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $ld5Xm.createElement($68c2ac1c8be5656b$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $68c2ac1c8be5656b$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $bb19e89bd54fc2f3$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $68c2ac1c8be5656b$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $ld5Xm.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2d8227aa615edd2d$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ld5Xm.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $ld5Xm.useCallback((newState)=>{
        v7_startTransition && $68c2ac1c8be5656b$var$startTransitionImpl ? $68c2ac1c8be5656b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $ld5Xm.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $ld5Xm.createElement((0, $bb19e89bd54fc2f3$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $68c2ac1c8be5656b$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $ld5Xm.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2d8227aa615edd2d$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $ld5Xm.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $ld5Xm.useCallback((newState)=>{
        v7_startTransition && $68c2ac1c8be5656b$var$startTransitionImpl ? $68c2ac1c8be5656b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $ld5Xm.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $ld5Xm.createElement((0, $bb19e89bd54fc2f3$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $68c2ac1c8be5656b$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $ld5Xm.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $ld5Xm.useCallback((newState)=>{
        v7_startTransition && $68c2ac1c8be5656b$var$startTransitionImpl ? $68c2ac1c8be5656b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $ld5Xm.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $ld5Xm.createElement((0, $bb19e89bd54fc2f3$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $68c2ac1c8be5656b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $68c2ac1c8be5656b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $68c2ac1c8be5656b$export$a6c7ac8248d6e38a = /*#__PURE__*/ $ld5Xm.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $68c2ac1c8be5656b$var$_objectWithoutPropertiesLoose(_ref7, $68c2ac1c8be5656b$var$_excluded);
    let { basename: basename } = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $68c2ac1c8be5656b$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($68c2ac1c8be5656b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $bb19e89bd54fc2f3$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $68c2ac1c8be5656b$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $ld5Xm.createElement("a", $68c2ac1c8be5656b$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $68c2ac1c8be5656b$export$b0d92dbee9b5b60d = /*#__PURE__*/ $ld5Xm.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $68c2ac1c8be5656b$var$_objectWithoutPropertiesLoose(_ref8, $68c2ac1c8be5656b$var$_excluded2);
    let path = (0, $bb19e89bd54fc2f3$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $bb19e89bd54fc2f3$export$45d76561a5302f2b)();
    let routerState = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $68c2ac1c8be5656b$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $ld5Xm.createElement($68c2ac1c8be5656b$export$a6c7ac8248d6e38a, $68c2ac1c8be5656b$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $68c2ac1c8be5656b$export$a7fed597f4b8afd8 = /*#__PURE__*/ $ld5Xm.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $68c2ac1c8be5656b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $68c2ac1c8be5656b$var$_objectWithoutPropertiesLoose(_ref9, $68c2ac1c8be5656b$var$_excluded3);
    let submit = $68c2ac1c8be5656b$export$47c85c6e3a081d3();
    let formAction = $68c2ac1c8be5656b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $ld5Xm.createElement("form", $68c2ac1c8be5656b$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $68c2ac1c8be5656b$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $68c2ac1c8be5656b$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $68c2ac1c8be5656b$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($68c2ac1c8be5656b$var$DataRouterHook || ($68c2ac1c8be5656b$var$DataRouterHook = {}));
var $68c2ac1c8be5656b$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($68c2ac1c8be5656b$var$DataRouterStateHook || ($68c2ac1c8be5656b$var$DataRouterStateHook = {}));
// Internal hooks
function $68c2ac1c8be5656b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $68c2ac1c8be5656b$var$useDataRouterContext(hookName) {
    let ctx = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$3add0d5dce533e2e));
    !ctx && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $68c2ac1c8be5656b$var$useDataRouterState(hookName) {
    let state = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$145dfa71566a64dc));
    !state && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $68c2ac1c8be5656b$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $bb19e89bd54fc2f3$export$9770f232ac06a008)();
    let location = (0, $bb19e89bd54fc2f3$export$45d76561a5302f2b)();
    let path = (0, $bb19e89bd54fc2f3$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $ld5Xm.useCallback((event)=>{
        if ($68c2ac1c8be5656b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2d8227aa615edd2d$export$fe53371bee54353d)(location) === (0, $2d8227aa615edd2d$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $68c2ac1c8be5656b$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $ld5Xm.useRef($68c2ac1c8be5656b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $ld5Xm.useRef(false);
    let location = (0, $bb19e89bd54fc2f3$export$45d76561a5302f2b)();
    let searchParams = $ld5Xm.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $68c2ac1c8be5656b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $bb19e89bd54fc2f3$export$9770f232ac06a008)();
    let setSearchParams = $ld5Xm.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $68c2ac1c8be5656b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $68c2ac1c8be5656b$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $68c2ac1c8be5656b$var$fetcherId = 0;
let $68c2ac1c8be5656b$var$getUniqueFetcherId = ()=>"__" + String(++$68c2ac1c8be5656b$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $68c2ac1c8be5656b$export$47c85c6e3a081d3() {
    let { router: router } = $68c2ac1c8be5656b$var$useDataRouterContext($68c2ac1c8be5656b$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$26749e8557646306));
    let currentRouteId = (0, $bb19e89bd54fc2f3$export$5fc8298006ad9e58)();
    return $ld5Xm.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $68c2ac1c8be5656b$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $68c2ac1c8be5656b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $68c2ac1c8be5656b$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $68c2ac1c8be5656b$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$26749e8557646306));
    let routeContext = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$9072aa6dd1f93057));
    !routeContext && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $68c2ac1c8be5656b$var$_extends({}, (0, $bb19e89bd54fc2f3$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $bb19e89bd54fc2f3$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2d8227aa615edd2d$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $2d8227aa615edd2d$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $68c2ac1c8be5656b$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $68c2ac1c8be5656b$var$useDataRouterContext($68c2ac1c8be5656b$var$DataRouterHook.UseFetcher);
    let state = $68c2ac1c8be5656b$var$useDataRouterState($68c2ac1c8be5656b$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $ld5Xm.useContext($68c2ac1c8be5656b$export$148fd98d095596d4);
    let route = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    !route && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $68c2ac1c8be5656b$var$useIdImpl ? $68c2ac1c8be5656b$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $ld5Xm.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($68c2ac1c8be5656b$var$getUniqueFetcherId());
    // Registration/cleanup
    $ld5Xm.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $ld5Xm.useCallback((href, opts)=>{
        !routeId && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $68c2ac1c8be5656b$export$47c85c6e3a081d3();
    let submit = $ld5Xm.useCallback((target, opts)=>{
        submitImpl(target, $68c2ac1c8be5656b$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $ld5Xm.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $ld5Xm.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $ld5Xm.createElement($68c2ac1c8be5656b$export$a7fed597f4b8afd8, $68c2ac1c8be5656b$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2d8227aa615edd2d$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $ld5Xm.useMemo(()=>$68c2ac1c8be5656b$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $68c2ac1c8be5656b$export$fa996778a3a31087() {
    let state = $68c2ac1c8be5656b$var$useDataRouterState($68c2ac1c8be5656b$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $68c2ac1c8be5656b$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $68c2ac1c8be5656b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $68c2ac1c8be5656b$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $68c2ac1c8be5656b$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $68c2ac1c8be5656b$var$useDataRouterContext($68c2ac1c8be5656b$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $68c2ac1c8be5656b$var$useDataRouterState($68c2ac1c8be5656b$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $ld5Xm.useContext((0, $bb19e89bd54fc2f3$export$26749e8557646306));
    let location = (0, $bb19e89bd54fc2f3$export$45d76561a5302f2b)();
    let matches = (0, $bb19e89bd54fc2f3$export$2378eb7f5ff86053)();
    let navigation = (0, $bb19e89bd54fc2f3$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $ld5Xm.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $68c2ac1c8be5656b$var$usePageHide($ld5Xm.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $68c2ac1c8be5656b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $68c2ac1c8be5656b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($68c2ac1c8be5656b$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $ld5Xm.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $68c2ac1c8be5656b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $68c2ac1c8be5656b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $ld5Xm.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($68c2ac1c8be5656b$var$_extends({}, location, {
                    pathname: (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($68c2ac1c8be5656b$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $ld5Xm.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $68c2ac1c8be5656b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $ld5Xm.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $68c2ac1c8be5656b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $ld5Xm.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $68c2ac1c8be5656b$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $bb19e89bd54fc2f3$export$b273b3273281a049)(when);
    $ld5Xm.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $ld5Xm.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $68c2ac1c8be5656b$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $ld5Xm.useContext($68c2ac1c8be5656b$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2d8227aa615edd2d$export$3e9cee6b33872309)(false);
    let { basename: basename } = $68c2ac1c8be5656b$var$useDataRouterContext($68c2ac1c8be5656b$var$DataRouterHook.useViewTransitionState);
    let path = (0, $bb19e89bd54fc2f3$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2d8227aa615edd2d$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2d8227aa615edd2d$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $2d8227aa615edd2d$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $2WrlN = parcelRequire("2WrlN");


var $2WrlN = parcelRequire("2WrlN");
var $b810a1b85b9c4cf6$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $b810a1b85b9c4cf6$exports) {
        classNames.default = classNames;
        $b810a1b85b9c4cf6$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $ld5Xm = parcelRequire("ld5Xm");
var $c84e9dc3e0962cd8$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($c84e9dc3e0962cd8$exports, "__esModule", {
    value: true
});
$c84e9dc3e0962cd8$exports.default = void 0;

var $c84e9dc3e0962cd8$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $c84e9dc3e0962cd8$var$_default = $c84e9dc3e0962cd8$exports.default = (0, $c84e9dc3e0962cd8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15M14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2"
}), "QuestionMarkOutlined");


var $2900a532f3cf2bc7$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($2900a532f3cf2bc7$exports, "__esModule", {
    value: true
});
$2900a532f3cf2bc7$exports.default = void 0;

var $2900a532f3cf2bc7$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $2900a532f3cf2bc7$var$_default = $2900a532f3cf2bc7$exports.default = (0, $2900a532f3cf2bc7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "AddOutlined");


var $15fa0d41843f186e$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($15fa0d41843f186e$exports, "__esModule", {
    value: true
});
$15fa0d41843f186e$exports.default = void 0;

var $15fa0d41843f186e$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $15fa0d41843f186e$var$_default = $15fa0d41843f186e$exports.default = (0, $15fa0d41843f186e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "MoreVertOutlined");


var $546758ebb0f69379$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($546758ebb0f69379$exports, "__esModule", {
    value: true
});
$546758ebb0f69379$exports.default = void 0;

var $546758ebb0f69379$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $546758ebb0f69379$var$_default = $546758ebb0f69379$exports.default = (0, $546758ebb0f69379$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), "ArrowBackIos");


var $d2d5f79491d4a0db$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($d2d5f79491d4a0db$exports, "__esModule", {
    value: true
});
$d2d5f79491d4a0db$exports.default = void 0;

var $d2d5f79491d4a0db$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $d2d5f79491d4a0db$var$_default = $d2d5f79491d4a0db$exports.default = (0, $d2d5f79491d4a0db$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), "ArrowDropDownOutlined");


var $551733de3e454344$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($551733de3e454344$exports, "__esModule", {
    value: true
});
$551733de3e454344$exports.default = void 0;

var $551733de3e454344$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $551733de3e454344$var$_default = $551733de3e454344$exports.default = (0, $551733de3e454344$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "m17 8-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5z"
}), "LogoutOutlined");


var $d58c46bbf35492a7$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($d58c46bbf35492a7$exports, "__esModule", {
    value: true
});
$d58c46bbf35492a7$exports.default = void 0;

var $d58c46bbf35492a7$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $d58c46bbf35492a7$var$_default = $d58c46bbf35492a7$exports.default = (0, $d58c46bbf35492a7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMoreOutlined");


var $a76fa9277b75f24c$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($a76fa9277b75f24c$exports, "__esModule", {
    value: true
});
$a76fa9277b75f24c$exports.default = void 0;

var $a76fa9277b75f24c$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $a76fa9277b75f24c$var$_default = $a76fa9277b75f24c$exports.default = (0, $a76fa9277b75f24c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRightOutlined");


var $fa48ae5fc630408a$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($fa48ae5fc630408a$exports, "__esModule", {
    value: true
});
$fa48ae5fc630408a$exports.default = void 0;

var $fa48ae5fc630408a$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $fa48ae5fc630408a$var$_default = $fa48ae5fc630408a$exports.default = (0, $fa48ae5fc630408a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "CloseOutlined");


var $f6cb230180ba1382$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($f6cb230180ba1382$exports, "__esModule", {
    value: true
});
$f6cb230180ba1382$exports.default = void 0;

var $f6cb230180ba1382$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $f6cb230180ba1382$var$_default = $f6cb230180ba1382$exports.default = (0, $f6cb230180ba1382$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z"
}), "ReportProblemOutlined");


var $a1374c8aba48d683$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($a1374c8aba48d683$exports, "__esModule", {
    value: true
});
$a1374c8aba48d683$exports.default = void 0;

var $a1374c8aba48d683$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $a1374c8aba48d683$var$_default = $a1374c8aba48d683$exports.default = (0, $a1374c8aba48d683$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), "InfoOutlined");


var $9fe4b30679576696$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($9fe4b30679576696$exports, "__esModule", {
    value: true
});
$9fe4b30679576696$exports.default = void 0;

var $9fe4b30679576696$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $9fe4b30679576696$var$_default = $9fe4b30679576696$exports.default = (0, $9fe4b30679576696$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
}), "CheckCircleOutlineOutlined");


var $23377da788716ef6$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($23377da788716ef6$exports, "__esModule", {
    value: true
});
$23377da788716ef6$exports.default = void 0;

var $23377da788716ef6$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $23377da788716ef6$var$_default = $23377da788716ef6$exports.default = (0, $23377da788716ef6$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutlineOutlined");


var $5f8085bc4021bf03$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($5f8085bc4021bf03$exports, "__esModule", {
    value: true
});
$5f8085bc4021bf03$exports.default = void 0;

var $5f8085bc4021bf03$var$_createSvgIcon = $hkjon((parcelRequire("iKQu3")));

var $2WrlN = parcelRequire("2WrlN");
var $5f8085bc4021bf03$var$_default = $5f8085bc4021bf03$exports.default = (0, $5f8085bc4021bf03$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5z"
}), "FileDownloadOutlined");



function $59f7253eae80d478$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $59f7253eae80d478$var$$parcel$defineInteropFlag(a) {
    Object.defineProperty(a, "__esModule", {
        value: true,
        configurable: true
    });
}
// Help @parcel/transformer-typescript-types find css module type
/// <reference types="./css.d.ts" />
var $59f7253eae80d478$var$$a4cd2e5379ae3619$exports = {};
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a4cd2e5379ae3619$exports, "avatar", function() {
    return $59f7253eae80d478$var$$a4cd2e5379ae3619$export$345c5736c8054f22;
}, function(v) {
    return $59f7253eae80d478$var$$a4cd2e5379ae3619$export$345c5736c8054f22 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a4cd2e5379ae3619$exports, "md", function() {
    return $59f7253eae80d478$var$$a4cd2e5379ae3619$export$f4de1c043ce6927;
}, function(v) {
    return $59f7253eae80d478$var$$a4cd2e5379ae3619$export$f4de1c043ce6927 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a4cd2e5379ae3619$exports, "sm", function() {
    return $59f7253eae80d478$var$$a4cd2e5379ae3619$export$92d98d0701d4531a;
}, function(v) {
    return $59f7253eae80d478$var$$a4cd2e5379ae3619$export$92d98d0701d4531a = v;
});
var $59f7253eae80d478$var$$a4cd2e5379ae3619$export$345c5736c8054f22;
var $59f7253eae80d478$var$$a4cd2e5379ae3619$export$f4de1c043ce6927;
var $59f7253eae80d478$var$$a4cd2e5379ae3619$export$92d98d0701d4531a;
$59f7253eae80d478$var$$a4cd2e5379ae3619$export$345c5736c8054f22 = `MZwSAW_avatar`;
$59f7253eae80d478$var$$a4cd2e5379ae3619$export$f4de1c043ce6927 = `MZwSAW_md`;
$59f7253eae80d478$var$$a4cd2e5379ae3619$export$92d98d0701d4531a = `MZwSAW_sm`;
const $59f7253eae80d478$export$e2255cf6045e8d47 = ({ initials: initials, size: size })=>{
    return (0, $2WrlN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$a4cd2e5379ae3619$exports.avatar, $59f7253eae80d478$var$$a4cd2e5379ae3619$exports[size]),
        children: initials
    });
};
var $59f7253eae80d478$var$$f1e10137373c17b6$exports = {};
$59f7253eae80d478$var$$f1e10137373c17b6$exports["function"] = `_0RedaG_function`;
$59f7253eae80d478$var$$f1e10137373c17b6$exports["icon-only"] = `_0RedaG_icon-only`;
$59f7253eae80d478$var$$f1e10137373c17b6$exports["link"] = `_0RedaG_link`;
$59f7253eae80d478$var$$f1e10137373c17b6$exports["primary-default"] = `_0RedaG_primary-default`;
$59f7253eae80d478$var$$f1e10137373c17b6$exports["primary-impact"] = `_0RedaG_primary-impact`;
$59f7253eae80d478$var$$f1e10137373c17b6$exports["secondary"] = `_0RedaG_secondary`;
for(let key in {})if (key in $59f7253eae80d478$var$$f1e10137373c17b6$exports) $59f7253eae80d478$var$$f1e10137373c17b6$exports[key] += " " + ({})[key];
else $59f7253eae80d478$var$$f1e10137373c17b6$exports[key] = ({})[key];
/**
 * Helper function to open links in new tab and eliminate window.opener vulnerabilities
 */ const $59f7253eae80d478$var$$917b1540128ca986$export$705f2bd319df8782 = (href)=>{
    if (typeof href === "string") {
        const newWindow = window.open(href, "_blank");
        if (newWindow !== null) newWindow.opener = null;
    }
};
const $59f7253eae80d478$export$353f5b6fc5456de1 = (0, $ld5Xm.forwardRef)(function Button(props, ref) {
    const { children: children, style: style, type: type, as: as, href: href, linkNewTab: linkNewTab = false, ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, disabled: disabled, onClick: onClick, className: className, id: id, title: title } = props;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))(`${$59f7253eae80d478$var$$f1e10137373c17b6$exports[style]}`, className);
    const externalLinkProps = {};
    if (linkNewTab) {
        externalLinkProps.onClick = (event)=>{
            event.preventDefault();
            $59f7253eae80d478$var$$917b1540128ca986$export$705f2bd319df8782(href);
        };
        externalLinkProps.rel = "external nofollow nooopener";
    }
    if (as === "a") return (0, $2WrlN.jsx)("a", {
        href: href,
        "aria-label": ariaLabel ?? "",
        "aria-describedby": ariaDescribedBy ?? "",
        className: classes,
        onClick: onClick,
        ...externalLinkProps,
        id: id,
        ref: ref,
        children: children
    });
    else return (0, $2WrlN.jsx)("button", {
        type: type,
        disabled: disabled,
        className: classes,
        "aria-label": ariaLabel ?? "",
        "aria-describedby": ariaDescribedBy ?? "",
        ...disabled ? {
            "aria-disabled": true
        } : {},
        onClick: disabled ? undefined : onClick,
        id: id,
        ref: ref,
        title: title,
        children: children
    });
});
var $59f7253eae80d478$var$$9e852ed4413296f9$exports = {};
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "center", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$3481c78889e8fbe8;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$3481c78889e8fbe8 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "icon", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$1ca1ec8b29a4ce27;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$1ca1ec8b29a4ce27 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "left", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$eabcd2c8791e7bf4;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$eabcd2c8791e7bf4 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "lg", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$27ac7b32bf0e709e;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$27ac7b32bf0e709e = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "md", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$f4de1c043ce6927;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$f4de1c043ce6927 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "none", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$f883a24d5edde77c;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$f883a24d5edde77c = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "right", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$79ffe56a765070d2;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$79ffe56a765070d2 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "rotate", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$bb628a54ab399bc9;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$bb628a54ab399bc9 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "sm", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$92d98d0701d4531a;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$92d98d0701d4531a = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "xl", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$abb3878d4b973569;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$abb3878d4b973569 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "xs", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$f005493441391ad1;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$f005493441391ad1 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$9e852ed4413296f9$exports, "xxxl", function() {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$649fac613cc4a5;
}, function(v) {
    return $59f7253eae80d478$var$$9e852ed4413296f9$export$649fac613cc4a5 = v;
});
var $59f7253eae80d478$var$$9e852ed4413296f9$export$3481c78889e8fbe8;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$1ca1ec8b29a4ce27;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$eabcd2c8791e7bf4;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$27ac7b32bf0e709e;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$f4de1c043ce6927;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$f883a24d5edde77c;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$79ffe56a765070d2;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$bb628a54ab399bc9;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$92d98d0701d4531a;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$abb3878d4b973569;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$f005493441391ad1;
var $59f7253eae80d478$var$$9e852ed4413296f9$export$649fac613cc4a5;
$59f7253eae80d478$var$$9e852ed4413296f9$export$3481c78889e8fbe8 = `_80CRQq_center`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$1ca1ec8b29a4ce27 = `_80CRQq_icon`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$eabcd2c8791e7bf4 = `_80CRQq_left`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$27ac7b32bf0e709e = `_80CRQq_lg`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$f4de1c043ce6927 = `_80CRQq_md`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$f883a24d5edde77c = `_80CRQq_none`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$79ffe56a765070d2 = `_80CRQq_right`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$bb628a54ab399bc9 = `_80CRQq_rotate`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$92d98d0701d4531a = `_80CRQq_sm`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$abb3878d4b973569 = `_80CRQq_xl`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$f005493441391ad1 = `_80CRQq_xs`;
$59f7253eae80d478$var$$9e852ed4413296f9$export$649fac613cc4a5 = `_80CRQq_xxxl`;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports = {};
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "align-center", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$103da05444fe0664;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$103da05444fe0664 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "alku-black", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$b999fe50cb24a908;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$b999fe50cb24a908 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "alku-brand-primary", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$1c1de8c1257ce12e;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$1c1de8c1257ce12e = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "alku-icon-default", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$c314c8fdf8d15eb3;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$c314c8fdf8d15eb3 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "alku-white", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$ba48749b8f0985a7;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$ba48749b8f0985a7 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "bold", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$73ba5813cda80a49;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$73ba5813cda80a49 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "flex", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$97691fbb80847c19;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$97691fbb80847c19 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "flex-start", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$fb04de77fa42ac56;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$fb04de77fa42ac56 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "flex-wrap", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$1f4cea2e27b57b02;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$1f4cea2e27b57b02 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "flyout-overlay", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7aecf4a8d47d14ff;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7aecf4a8d47d14ff = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "header", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$38e42c68cf43b5d4;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$38e42c68cf43b5d4 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "header-account-wrapper", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$4dd6232dd12b948a;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$4dd6232dd12b948a = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "header-avatar", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$dc04afc4075173d6;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$dc04afc4075173d6 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "header-logo", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$f59d5279c2d040a8;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$f59d5279c2d040a8 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "header-nav-wrapper", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$232368ef6df1fa9;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$232368ef6df1fa9 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "header-profile", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$e766cfad7bbd8569;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$e766cfad7bbd8569 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "hyperlink", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$aaf0e9785a4e9240;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$aaf0e9785a4e9240 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "icon-info", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7fdab38ec047cfcb;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7fdab38ec047cfcb = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "icon-success", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$be7f98134691b9c8;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$be7f98134691b9c8 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "icon-warn", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7045e4723eb45ed0;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7045e4723eb45ed0 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "regular", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$28a535dd448ffda4;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$28a535dd448ffda4 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "relative", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$f0e7d1106eeabbe6;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$f0e7d1106eeabbe6 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "semibold", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$ee40a85ed9c2d535;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$ee40a85ed9c2d535 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "space-between", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$72b535cced3bbc2a;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$72b535cced3bbc2a = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports, "u-sr-only", function() {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$a52403d6f9e45688;
}, function(v) {
    return $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$a52403d6f9e45688 = v;
});
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$103da05444fe0664;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$b999fe50cb24a908;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$1c1de8c1257ce12e;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$c314c8fdf8d15eb3;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$ba48749b8f0985a7;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$73ba5813cda80a49;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$97691fbb80847c19;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$fb04de77fa42ac56;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$1f4cea2e27b57b02;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7aecf4a8d47d14ff;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$38e42c68cf43b5d4;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$4dd6232dd12b948a;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$dc04afc4075173d6;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$f59d5279c2d040a8;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$232368ef6df1fa9;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$e766cfad7bbd8569;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$aaf0e9785a4e9240;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7fdab38ec047cfcb;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$be7f98134691b9c8;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7045e4723eb45ed0;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$28a535dd448ffda4;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$f0e7d1106eeabbe6;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$ee40a85ed9c2d535;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$72b535cced3bbc2a;
var $59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$a52403d6f9e45688;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$103da05444fe0664 = `TQ6Uua_align-center`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$b999fe50cb24a908 = `TQ6Uua_alku-black`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$1c1de8c1257ce12e = `TQ6Uua_alku-brand-primary`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$c314c8fdf8d15eb3 = `TQ6Uua_alku-icon-default`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$ba48749b8f0985a7 = `TQ6Uua_alku-white`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$73ba5813cda80a49 = `TQ6Uua_bold`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$97691fbb80847c19 = `TQ6Uua_flex`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$fb04de77fa42ac56 = `TQ6Uua_flex-start`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$1f4cea2e27b57b02 = `TQ6Uua_flex-wrap`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7aecf4a8d47d14ff = `TQ6Uua_flyout-overlay`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$38e42c68cf43b5d4 = `TQ6Uua_header`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$4dd6232dd12b948a = `TQ6Uua_header-account-wrapper`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$dc04afc4075173d6 = `TQ6Uua_header-avatar`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$f59d5279c2d040a8 = `TQ6Uua_header-logo`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$232368ef6df1fa9 = `TQ6Uua_header-nav-wrapper`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$e766cfad7bbd8569 = `TQ6Uua_header-profile`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$aaf0e9785a4e9240 = `TQ6Uua_hyperlink`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7fdab38ec047cfcb = `TQ6Uua_icon-info`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$be7f98134691b9c8 = `TQ6Uua_icon-success`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$7045e4723eb45ed0 = `TQ6Uua_icon-warn`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$28a535dd448ffda4 = `TQ6Uua_regular`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$f0e7d1106eeabbe6 = `TQ6Uua_relative`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$ee40a85ed9c2d535 = `TQ6Uua_semibold`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$72b535cced3bbc2a = `TQ6Uua_space-between`;
$59f7253eae80d478$var$$a6d82f8a0e5bcabb$export$a52403d6f9e45688 = `TQ6Uua_u-sr-only`;
const $59f7253eae80d478$var$$a7a7876988c6a28d$export$c82760de046b5a30 = {
    QuestionMarkOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c84e9dc3e0962cd8$exports))),
    AddOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2900a532f3cf2bc7$exports))),
    MoreVertOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($15fa0d41843f186e$exports))),
    ArrowBackIosIcon: (0, (/*@__PURE__*/$parcel$interopDefault($546758ebb0f69379$exports))),
    ArrowDropDownOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d2d5f79491d4a0db$exports))),
    LogoutOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($551733de3e454344$exports))),
    ExpandMoreOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($d58c46bbf35492a7$exports))),
    ChevronRightOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($a76fa9277b75f24c$exports))),
    CloseOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fa48ae5fc630408a$exports))),
    ReportProblemOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cb230180ba1382$exports))),
    InfoOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($a1374c8aba48d683$exports))),
    CheckCircleOutlineOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($9fe4b30679576696$exports))),
    ErrorOutlineOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($23377da788716ef6$exports))),
    FileDownloadOutlinedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5f8085bc4021bf03$exports)))
};
/**
 * Icons
 * @param {ReactNode} [children] - typically an mui icon component
 * @param {IconOptions} symbol - string of available icon options
 * @param {string} size - icon size, currently supports xs, sm, md and lg (see if we can manage w/o custom rems)
 * @param {string} color - icon color from global colors defined in root css
 * @param {string} [space] - add default spacing to left or right or both ("center") sides of icon
 * @param {boolean} [rotate] - rotate 180 when true
 */ const $59f7253eae80d478$var$$54b3890db507985c$var$IconSymbol = (props)=>{
    const Symbol = $59f7253eae80d478$var$$a7a7876988c6a28d$export$c82760de046b5a30[props.symbol];
    return (0, $2WrlN.jsx)(Symbol, {
        ...props
    });
};
const $59f7253eae80d478$export$f04a61298a47a40f = (props)=>{
    const { children: children, symbol: symbol, color: color = "alku-icon-default", size: size, space: space = "none", rotate: rotate = false } = props;
    return (0, $2WrlN.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$9e852ed4413296f9$exports.icon, $59f7253eae80d478$var$$9e852ed4413296f9$exports[size], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[color], $59f7253eae80d478$var$$9e852ed4413296f9$exports[space], rotate ? $59f7253eae80d478$var$$9e852ed4413296f9$exports.rotate : ""),
        "aria-hidden": true,
        children: children ?? (0, $2WrlN.jsx)($59f7253eae80d478$var$$54b3890db507985c$var$IconSymbol, {
            fontSize: "inherit",
            color: "inherit",
            symbol: symbol ?? "QuestionMarkOutlinedIcon",
            style: {
                height: "1.5em",
                width: "1.5em"
            }
        })
    });
};
var $59f7253eae80d478$var$$10e2b9e52a693fdf$exports = {};
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "detail", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$13a2d28b88853ef2;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$13a2d28b88853ef2 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "link", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$9c30223ca0a664fb;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$9c30223ca0a664fb = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "menu-item", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$9aa3f5850e4e7780;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$9aa3f5850e4e7780 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "metadata", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$dbb5e893e736e4ee;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$dbb5e893e736e4ee = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "nav-text", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$8fa00096d2f15ccf;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$8fa00096d2f15ccf = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "normal", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$411e9a7b4316b872;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$411e9a7b4316b872 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "one", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$80bf7733f1207381;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$80bf7733f1207381 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "small", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$3c17b0e969a90510;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$3c17b0e969a90510 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "subheading", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$eeb03afd9378c335;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$eeb03afd9378c335 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "subheading-small", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$34b935c76b893dbf;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$34b935c76b893dbf = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "three", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$c93cff18cf760708;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$c93cff18cf760708 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "title", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$fb184b623420d9be;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$fb184b623420d9be = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$10e2b9e52a693fdf$exports, "two", function() {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$7dfe6c2e21a8ba69;
}, function(v) {
    return $59f7253eae80d478$var$$10e2b9e52a693fdf$export$7dfe6c2e21a8ba69 = v;
});
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$13a2d28b88853ef2;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$9c30223ca0a664fb;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$9aa3f5850e4e7780;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$dbb5e893e736e4ee;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$8fa00096d2f15ccf;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$411e9a7b4316b872;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$80bf7733f1207381;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$3c17b0e969a90510;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$eeb03afd9378c335;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$34b935c76b893dbf;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$c93cff18cf760708;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$fb184b623420d9be;
var $59f7253eae80d478$var$$10e2b9e52a693fdf$export$7dfe6c2e21a8ba69;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$13a2d28b88853ef2 = `tt8iCq_detail`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$9c30223ca0a664fb = `tt8iCq_link`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$9aa3f5850e4e7780 = `tt8iCq_menu-item`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$dbb5e893e736e4ee = `tt8iCq_metadata`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$8fa00096d2f15ccf = `tt8iCq_nav-text`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$411e9a7b4316b872 = `tt8iCq_normal`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$80bf7733f1207381 = `tt8iCq_one`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$3c17b0e969a90510 = `tt8iCq_small`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$eeb03afd9378c335 = `tt8iCq_subheading`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$34b935c76b893dbf = `tt8iCq_subheading-small`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$c93cff18cf760708 = `tt8iCq_three`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$fb184b623420d9be = `tt8iCq_title`;
$59f7253eae80d478$var$$10e2b9e52a693fdf$export$7dfe6c2e21a8ba69 = `tt8iCq_two`;
const $59f7253eae80d478$export$a8a3e93435678ff9 = ({ children: children, style: style, as: as = "div", color: color = "alku-black" })=>{
    const Component = as;
    return (0, $2WrlN.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$10e2b9e52a693fdf$exports[style], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[color]),
        children: children
    });
};
const $59f7253eae80d478$export$5f1af8db9871e1d6 = ({ children: children, style: style, as: as, color: color = "alku-black", weight: weight = "regular", href: href, linkNewTab: linkNewTab = false, className: className })=>{
    const optionalLinkProps = {};
    if (linkNewTab && as === "a") {
        optionalLinkProps.onClick = (event)=>{
            event.preventDefault();
            $59f7253eae80d478$var$$917b1540128ca986$export$705f2bd319df8782(href);
        };
        optionalLinkProps.rel = "external nofollow nooopener";
    }
    switch(as){
        case "p":
            return (0, $2WrlN.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$10e2b9e52a693fdf$exports[style], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[weight], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[color], className),
                children: children
            });
        case "span":
            return (0, $2WrlN.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$10e2b9e52a693fdf$exports[style], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[weight], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[color], className),
                children: children
            });
        case "strong":
            return (0, $2WrlN.jsx)("strong", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$10e2b9e52a693fdf$exports[style], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[weight], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[color]),
                children: children
            });
        case "a":
            return (0, $2WrlN.jsx)("a", {
                href: href,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$10e2b9e52a693fdf$exports[style], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[weight], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[color]),
                ...optionalLinkProps,
                children: children
            });
        default:
            return (0, $2WrlN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$10e2b9e52a693fdf$exports[style], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[weight], $59f7253eae80d478$var$$a6d82f8a0e5bcabb$exports[color]),
                children: children
            });
    }
};
var $59f7253eae80d478$var$$14def1888e8888b0$exports = {};
$59f7253eae80d478$var$$parcel$defineInteropFlag($59f7253eae80d478$var$$14def1888e8888b0$exports);
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "account", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$6b501c78a3684162;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$6b501c78a3684162 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "account-wrapper", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$50b1df6aa49d0846;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$50b1df6aa49d0846 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "closed", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$15ff61f90f7efc74;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$15ff61f90f7efc74 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "default", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$2e2bcd8739ae039;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$2e2bcd8739ae039 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "default-wrapper", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$2c25cd47e5687053;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$2c25cd47e5687053 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "flyout", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$ec4922be16378791;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$ec4922be16378791 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "flyout-item", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$16a014f920f26dab;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$16a014f920f26dab = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "flyout-list-item-btn", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$8a2f27b9e1738769;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$8a2f27b9e1738769 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "left", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$eabcd2c8791e7bf4;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$eabcd2c8791e7bf4 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "lg", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$27ac7b32bf0e709e;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$27ac7b32bf0e709e = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "md", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$f4de1c043ce6927;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$f4de1c043ce6927 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "open", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$3ce6949f20cea765;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$3ce6949f20cea765 = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "position-right", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$80a9b1256f183cca;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$80a9b1256f183cca = v;
});
$59f7253eae80d478$var$$parcel$export($59f7253eae80d478$var$$14def1888e8888b0$exports, "right", function() {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$79ffe56a765070d2;
}, function(v) {
    return $59f7253eae80d478$var$$14def1888e8888b0$export$79ffe56a765070d2 = v;
});
var $59f7253eae80d478$var$$14def1888e8888b0$export$6b501c78a3684162;
var $59f7253eae80d478$var$$14def1888e8888b0$export$50b1df6aa49d0846;
var $59f7253eae80d478$var$$14def1888e8888b0$export$15ff61f90f7efc74;
var $59f7253eae80d478$var$$14def1888e8888b0$export$2e2bcd8739ae039;
var $59f7253eae80d478$var$$14def1888e8888b0$export$2c25cd47e5687053;
var $59f7253eae80d478$var$$14def1888e8888b0$export$ec4922be16378791;
var $59f7253eae80d478$var$$14def1888e8888b0$export$16a014f920f26dab;
var $59f7253eae80d478$var$$14def1888e8888b0$export$8a2f27b9e1738769;
var $59f7253eae80d478$var$$14def1888e8888b0$export$eabcd2c8791e7bf4;
var $59f7253eae80d478$var$$14def1888e8888b0$export$27ac7b32bf0e709e;
var $59f7253eae80d478$var$$14def1888e8888b0$export$f4de1c043ce6927;
var $59f7253eae80d478$var$$14def1888e8888b0$export$3ce6949f20cea765;
var $59f7253eae80d478$var$$14def1888e8888b0$export$80a9b1256f183cca;
var $59f7253eae80d478$var$$14def1888e8888b0$export$79ffe56a765070d2;
$59f7253eae80d478$var$$14def1888e8888b0$export$6b501c78a3684162 = `_7t1vbW_account`;
$59f7253eae80d478$var$$14def1888e8888b0$export$50b1df6aa49d0846 = `_7t1vbW_account-wrapper`;
$59f7253eae80d478$var$$14def1888e8888b0$export$15ff61f90f7efc74 = `_7t1vbW_closed`;
$59f7253eae80d478$var$$14def1888e8888b0$export$2e2bcd8739ae039 = `_7t1vbW_default`;
$59f7253eae80d478$var$$14def1888e8888b0$export$2c25cd47e5687053 = `_7t1vbW_default-wrapper`;
$59f7253eae80d478$var$$14def1888e8888b0$export$ec4922be16378791 = `_7t1vbW_flyout`;
$59f7253eae80d478$var$$14def1888e8888b0$export$16a014f920f26dab = `_7t1vbW_flyout-item`;
$59f7253eae80d478$var$$14def1888e8888b0$export$8a2f27b9e1738769 = `_7t1vbW_flyout-list-item-btn`;
$59f7253eae80d478$var$$14def1888e8888b0$export$eabcd2c8791e7bf4 = `_7t1vbW_left`;
$59f7253eae80d478$var$$14def1888e8888b0$export$27ac7b32bf0e709e = `_7t1vbW_lg`;
$59f7253eae80d478$var$$14def1888e8888b0$export$f4de1c043ce6927 = `_7t1vbW_md`;
$59f7253eae80d478$var$$14def1888e8888b0$export$3ce6949f20cea765 = `_7t1vbW_open`;
$59f7253eae80d478$var$$14def1888e8888b0$export$80a9b1256f183cca = `_7t1vbW_position-right`;
$59f7253eae80d478$var$$14def1888e8888b0$export$79ffe56a765070d2 = `_7t1vbW_right`;
const $59f7253eae80d478$export$924d1752b27abfc8 = (props)=>{
    const { type: type = "default", children: children, isOpen: isOpen, setIsOpen: setIsOpen, width: width } = props;
    const ref = (0, $ld5Xm.useRef)(null);
    (0, $ld5Xm.useLayoutEffect)(()=>{
        if (isOpen) setTimeout(()=>{
            document.addEventListener("click", handleClickAway);
        });
        else document.removeEventListener("click", handleClickAway);
        return ()=>{
            document.removeEventListener("click", handleClickAway);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
    const handleClickAway = (e)=>{
        const target = e.target;
        if (ref?.current === document.activeElement && ref?.current?.contains(target)) return;
        setIsOpen(false);
    };
    return (0, $2WrlN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$14def1888e8888b0$exports.flyout, $59f7253eae80d478$var$$14def1888e8888b0$exports[type], isOpen ? $59f7253eae80d478$var$$14def1888e8888b0$exports.open : $59f7253eae80d478$var$$14def1888e8888b0$exports.closed, width === "md" ? $59f7253eae80d478$var$$14def1888e8888b0$exports.md : $59f7253eae80d478$var$$14def1888e8888b0$exports.lg),
        "aria-expanded": isOpen,
        ref: ref,
        children: children
    });
};
const $59f7253eae80d478$export$cce593c893bdcfd0 = (props)=>{
    const { onClick: onClick, buttonProps: buttonProps, iconSymbol: iconSymbol, iconProps: iconProps, buttonText: buttonText, afterButton: afterButton, isDisabled: isDisabled = false } = props;
    return (0, $2WrlN.jsxs)("li", {
        className: $59f7253eae80d478$var$$14def1888e8888b0$export$16a014f920f26dab,
        children: [
            (0, $2WrlN.jsxs)($59f7253eae80d478$export$353f5b6fc5456de1, {
                as: buttonProps?.as ?? "button",
                style: "icon-only",
                onClick: onClick,
                ...buttonProps,
                disabled: isDisabled,
                className: $59f7253eae80d478$var$$14def1888e8888b0$export$8a2f27b9e1738769,
                children: [
                    (0, $2WrlN.jsx)($59f7253eae80d478$export$f04a61298a47a40f, {
                        space: "right",
                        color: isDisabled ? "disabled-check" : "alku-brand-primary",
                        size: "sm",
                        symbol: iconSymbol,
                        ...iconProps
                    }),
                    (0, $2WrlN.jsx)($59f7253eae80d478$export$5f1af8db9871e1d6, {
                        as: "span",
                        style: "detail",
                        color: isDisabled ? "disabled-check" : "alku-black",
                        weight: "semibold",
                        children: buttonText
                    })
                ]
            }),
            afterButton
        ]
    });
};
const $59f7253eae80d478$export$f4188c4fe84d69c1 = (props)=>{
    const { label: label, id: id, iconProps: iconProps, flyoutChildren: flyoutChildren, buttonProps: buttonProps, position: position = "right", flyoutWidth: flyoutWidth, type: type = "default" } = props;
    const [isFlyoutOpen, setIsFlyoutOpen] = (0, $ld5Xm.useState)(false);
    const toggleFlyoutVisibility = (0, $ld5Xm.useCallback)(()=>{
        setIsFlyoutOpen((bool)=>!bool);
    }, []);
    return (0, $2WrlN.jsxs)((0, $2WrlN.Fragment), {
        children: [
            (0, $2WrlN.jsx)($59f7253eae80d478$export$353f5b6fc5456de1, {
                as: "button",
                type: "button",
                style: "function",
                ariaLabel: label,
                id: id,
                onClick: toggleFlyoutVisibility,
                ...buttonProps,
                children: type === "account" ? (0, $2WrlN.jsxs)((0, $2WrlN.Fragment), {
                    children: [
                        buttonProps?.children ?? "",
                        iconProps && (0, $2WrlN.jsx)($59f7253eae80d478$export$f04a61298a47a40f, {
                            color: "black",
                            size: "lg",
                            ...iconProps,
                            rotate: isFlyoutOpen
                        })
                    ]
                }) : (0, $2WrlN.jsxs)((0, $2WrlN.Fragment), {
                    children: [
                        iconProps && (0, $2WrlN.jsx)($59f7253eae80d478$export$f04a61298a47a40f, {
                            color: "black",
                            size: "lg",
                            ...iconProps,
                            rotate: isFlyoutOpen
                        }),
                        buttonProps?.children ?? ""
                    ]
                })
            }),
            (0, $2WrlN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))(type === "account" ? $59f7253eae80d478$var$$14def1888e8888b0$exports["account-wrapper"] : $59f7253eae80d478$var$$14def1888e8888b0$exports["default-wrapper"], $59f7253eae80d478$var$$14def1888e8888b0$exports[`position-${position}`]),
                children: (0, $2WrlN.jsx)($59f7253eae80d478$export$924d1752b27abfc8, {
                    type: type,
                    isOpen: isFlyoutOpen,
                    width: flyoutWidth ?? "lg",
                    setIsOpen: setIsFlyoutOpen,
                    children: (0, $2WrlN.jsx)("ul", {
                        children: flyoutChildren
                    })
                })
            })
        ]
    });
};
var $59f7253eae80d478$var$$8f3896e6ad19250c$export$89da14300d534261;
var $59f7253eae80d478$var$$8f3896e6ad19250c$export$9c30223ca0a664fb;
var $59f7253eae80d478$var$$8f3896e6ad19250c$export$80e4b313e5e6b30d;
$59f7253eae80d478$var$$8f3896e6ad19250c$export$89da14300d534261 = `bh3Kaq_active`;
$59f7253eae80d478$var$$8f3896e6ad19250c$export$9c30223ca0a664fb = `bh3Kaq_link`;
$59f7253eae80d478$var$$8f3896e6ad19250c$export$80e4b313e5e6b30d = `bh3Kaq_nav`;
const $59f7253eae80d478$export$e3925dbaeffcc83f = (props)=>{
    const { children: children, isActive: isActive } = props;
    return (0, $2WrlN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($59f7253eae80d478$var$$8f3896e6ad19250c$export$9c30223ca0a664fb, isActive ? $59f7253eae80d478$var$$8f3896e6ad19250c$export$89da14300d534261 : ""),
        children: (0, $2WrlN.jsx)($59f7253eae80d478$export$5f1af8db9871e1d6, {
            as: "div",
            style: "nav-text",
            color: "alku-black",
            weight: isActive ? "bold" : "semibold",
            children: children
        })
    });
};
var $59f7253eae80d478$var$$c3273e8c502b4291$export$96e4b36520c26a2c;
var $59f7253eae80d478$var$$c3273e8c502b4291$export$5f4794bfaafb4f26;
var $59f7253eae80d478$var$$c3273e8c502b4291$export$a7facc7e2bc2d2b4;
var $59f7253eae80d478$var$$c3273e8c502b4291$export$5834f0b85cf53b19;
$59f7253eae80d478$var$$c3273e8c502b4291$export$96e4b36520c26a2c = `_8mrmkq_modal`;
$59f7253eae80d478$var$$c3273e8c502b4291$export$5f4794bfaafb4f26 = `_8mrmkq_modal-close`;
$59f7253eae80d478$var$$c3273e8c502b4291$export$a7facc7e2bc2d2b4 = `_8mrmkq_modal-container`;
$59f7253eae80d478$var$$c3273e8c502b4291$export$5834f0b85cf53b19 = `_8mrmkq_modal-title`;
const $59f7253eae80d478$var$$5c20e4021538b3b6$var$themeIcons = {
    alert: "ReportProblemOutlinedIcon",
    error: "ErrorOutlineOutlinedIcon",
    info: "InfoOutlinedIcon",
    success: "CheckCircleOutlineOutlinedIcon"
};
const $59f7253eae80d478$var$$5c20e4021538b3b6$var$themeColors = {
    alert: "icon-warn",
    error: "alku-brand-primary",
    info: "icon-info",
    success: "icon-success"
};
const $59f7253eae80d478$var$$5c20e4021538b3b6$var$getThemeIcon = (theme)=>{
    return $59f7253eae80d478$var$$5c20e4021538b3b6$var$themeIcons[theme];
};
const $59f7253eae80d478$var$$5c20e4021538b3b6$var$getThemeColor = (theme)=>{
    return $59f7253eae80d478$var$$5c20e4021538b3b6$var$themeColors[theme];
};
const $59f7253eae80d478$export$2b77a92f1a5ad772 = ({ children: children, open: open, onRequestClose: onRequestClose, closeOnOutsideClick: closeOnOutsideClick, title: title, theme: theme = "default" })=>{
    const dialogRef = (0, $ld5Xm.useRef)(null);
    const lastActiveElement = (0, $ld5Xm.useRef)(null);
    (0, $ld5Xm.useEffect)(()=>{
        if (!dialogRef?.current) return;
        const dialogNode = dialogRef.current;
        if (open) {
            lastActiveElement.current = document.activeElement;
            dialogNode.showModal();
            dialogNode.focus();
        } else if (dialogNode.open) {
            dialogNode.close();
            if (lastActiveElement.current instanceof HTMLElement) lastActiveElement.current.focus();
        }
    }, [
        open
    ]);
    // add cancel handling
    const handleCancel = (0, $ld5Xm.useCallback)((event)=>{
        event.preventDefault();
        if (event.target === dialogRef.current) onRequestClose();
    }, [
        onRequestClose
    ]);
    (0, $ld5Xm.useEffect)(()=>{
        if (!dialogRef?.current) return;
        const dialogNode = dialogRef.current;
        dialogNode.addEventListener("cancel", handleCancel);
        return ()=>{
            dialogNode.removeEventListener("cancel", handleCancel);
        };
    }, [
        dialogRef,
        handleCancel
    ]);
    const handleOutsideClick = (event)=>{
        const dialogNode = dialogRef.current;
        if (closeOnOutsideClick && event.target === dialogNode) onRequestClose();
    };
    return (0, $b86f1e2f9a665e04$exports.createPortal)((0, $2WrlN.jsxs)("dialog", {
        className: $59f7253eae80d478$var$$c3273e8c502b4291$export$96e4b36520c26a2c,
        ref: dialogRef,
        onClick: handleOutsideClick,
        children: [
            (0, $2WrlN.jsx)("div", {
                className: `${$59f7253eae80d478$var$$c3273e8c502b4291$export$5f4794bfaafb4f26}`,
                children: (0, $2WrlN.jsx)($59f7253eae80d478$export$353f5b6fc5456de1, {
                    as: "button",
                    id: "close-modal",
                    type: "button",
                    style: "icon-only",
                    ariaLabel: "close",
                    onClick: onRequestClose,
                    children: (0, $2WrlN.jsx)($59f7253eae80d478$export$f04a61298a47a40f, {
                        symbol: "CloseOutlinedIcon",
                        color: "alku-brand-primary",
                        size: "lg"
                    })
                })
            }),
            (0, $2WrlN.jsxs)("div", {
                className: `${$59f7253eae80d478$var$$c3273e8c502b4291$export$a7facc7e2bc2d2b4}`,
                children: [
                    typeof title === "string" && (0, $2WrlN.jsxs)("div", {
                        className: $59f7253eae80d478$var$$c3273e8c502b4291$export$5834f0b85cf53b19,
                        children: [
                            theme !== "default" && (0, $2WrlN.jsx)($59f7253eae80d478$export$f04a61298a47a40f, {
                                symbol: $59f7253eae80d478$var$$5c20e4021538b3b6$var$getThemeIcon(theme),
                                color: $59f7253eae80d478$var$$5c20e4021538b3b6$var$getThemeColor(theme),
                                size: "lg",
                                space: "right"
                            }),
                            (0, $2WrlN.jsx)($59f7253eae80d478$export$a8a3e93435678ff9, {
                                as: "h3",
                                style: "three",
                                children: title
                            })
                        ]
                    }),
                    open ? children : null
                ]
            })
        ]
    }), document.body);
};



var $2WrlN = parcelRequire("2WrlN");
var $858ca740b389edf3$export$34e0f9847d4c02dd;
$858ca740b389edf3$export$34e0f9847d4c02dd = `Y0Z-SW_container`;


const $76ef91adf46192f3$export$42a852a2b6b56249 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
        className: $858ca740b389edf3$export$34e0f9847d4c02dd,
        children: children
    });
};


var $439ad22215b8fe99$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($439ad22215b8fe99$exports, "__esModule", {
    value: true
});
$439ad22215b8fe99$exports.default = void 0;

var $439ad22215b8fe99$var$_createSvgIcon = $hkjon((parcelRequire("kYoAx")));

var $2WrlN = parcelRequire("2WrlN");
var $439ad22215b8fe99$var$_default = $439ad22215b8fe99$exports.default = (0, $439ad22215b8fe99$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "m22 9.24-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28z"
}), "StarBorderOutlined");


var $02107f5ada3562cf$exports = {};

$02107f5ada3562cf$exports["align-center"] = `d5motq_align-center`;
$02107f5ada3562cf$exports["align-top"] = `d5motq_align-top`;
$02107f5ada3562cf$exports["black"] = `d5motq_black`;
$02107f5ada3562cf$exports["bold"] = `d5motq_bold`;
$02107f5ada3562cf$exports["brand-red"] = `d5motq_brand-red`;
$02107f5ada3562cf$exports["brand-white"] = `d5motq_brand-white`;
$02107f5ada3562cf$exports["brand-white-inactive"] = `d5motq_brand-white-inactive`;
$02107f5ada3562cf$exports["bright-blue"] = `d5motq_bright-blue`;
$02107f5ada3562cf$exports["container"] = `d5motq_container`;
$02107f5ada3562cf$exports["dark-blue"] = `d5motq_dark-blue`;
$02107f5ada3562cf$exports["dark-grey"] = `d5motq_dark-grey`;
$02107f5ada3562cf$exports["disabled-check"] = `d5motq_disabled-check`;
$02107f5ada3562cf$exports["ellipsis-anim"] = `d5motq_ellipsis-anim`;
$02107f5ada3562cf$exports["ellipsis-dot"] = `d5motq_ellipsis-dot`;
$02107f5ada3562cf$exports["ellipsis-dot"];
$02107f5ada3562cf$exports["error"] = `d5motq_error`;
$02107f5ada3562cf$exports["flex"] = `d5motq_flex`;
$02107f5ada3562cf$exports["flex-start"] = `d5motq_flex-start`;
$02107f5ada3562cf$exports["flyout-item"] = `d5motq_flyout-item`;
$02107f5ada3562cf$exports["flyout-overlay"] = `d5motq_flyout-overlay`;
$02107f5ada3562cf$exports["grey-8"] = `d5motq_grey-8`;
$02107f5ada3562cf$exports["hidden"] = `d5motq_hidden`;
$02107f5ada3562cf$exports["hyperlink"] = `d5motq_hyperlink`;
$02107f5ada3562cf$exports["icon-default"] = `d5motq_icon-default`;
$02107f5ada3562cf$exports["icon-favorite"] = `d5motq_icon-favorite`;
$02107f5ada3562cf$exports["icon-success"] = `d5motq_icon-success`;
$02107f5ada3562cf$exports["icon-warn"] = `d5motq_icon-warn`;
$02107f5ada3562cf$exports["input"] = `d5motq_input`;
$02107f5ada3562cf$exports["label"] = `d5motq_label`;
$02107f5ada3562cf$exports["regular"] = `d5motq_regular`;
$02107f5ada3562cf$exports["required"] = `d5motq_required`;
$02107f5ada3562cf$exports["select"] = `d5motq_select`;
$02107f5ada3562cf$exports["semibold"] = `d5motq_semibold`;
$02107f5ada3562cf$exports["space-between"] = `d5motq_space-between`;
$02107f5ada3562cf$exports["text-green"] = `d5motq_text-green`;
$02107f5ada3562cf$exports["text-red"] = `d5motq_text-red`;
$02107f5ada3562cf$exports["textarea"] = `d5motq_textarea`;
$02107f5ada3562cf$exports["u-sr-only"] = `d5motq_u-sr-only`;
for(let key in {})if (key in $02107f5ada3562cf$exports) $02107f5ada3562cf$exports[key] += " " + {}[key];
else $02107f5ada3562cf$exports[key] = {}[key];




var $ld5Xm = parcelRequire("ld5Xm");
function $8b1e6b8aa40f03b8$export$6eae17274b77b4a6() {
    const [openDefault, setOpenDefault] = (0, $ld5Xm.useState)(false);
    const [openInfo, setOpenInfo] = (0, $ld5Xm.useState)(false);
    const [openAlert, setOpenAlert] = (0, $ld5Xm.useState)(false);
    const [openSuccess, setOpenSuccess] = (0, $ld5Xm.useState)(false);
    const [openError, setOpenError] = (0, $ld5Xm.useState)(false);
    return /*#__PURE__*/ (0, $2WrlN.jsx)((0, $76ef91adf46192f3$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($02107f5ada3562cf$exports.flex, $02107f5ada3562cf$exports["align-top"], $02107f5ada3562cf$exports["space-between"]),
            children: /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                style: {
                    paddingRight: "10rem"
                },
                children: [
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$a8a3e93435678ff9), {
                        as: "div",
                        style: "one",
                        children: "UI Kit"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("h2", {
                        id: "typography",
                        children: "Typography"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("h3", {
                        id: "headings",
                        children: "Headings"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$a8a3e93435678ff9), {
                        as: "div",
                        style: "one",
                        children: "Heading 1"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$a8a3e93435678ff9), {
                        as: "h2",
                        style: "two",
                        children: "Heading 2"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$a8a3e93435678ff9), {
                        as: "h3",
                        style: "three",
                        children: "Modal Heading"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                        id: "nav-text",
                        children: "Nav Text:"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                        href: "#",
                        as: "a",
                        style: "nav-text",
                        color: "alku-black",
                        weight: "semibold",
                        children: "Nav Item"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                        id: "detail-text",
                        children: "Detail Text:"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                        as: "div",
                        style: "detail",
                        color: "alku-black",
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$e2255cf6045e8d47), {
                                initials: "JD",
                                size: "sm"
                            }),
                            "Jane Doe"
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                        as: "p",
                        style: "detail",
                        color: "alku-black",
                        children: [
                            "1244 Boylston Street, Suite 1200",
                            /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                            "Boston, MA 02164"
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                        as: "p",
                        style: "detail",
                        color: "alku-black",
                        weight: "bold",
                        children: "Detail Text Bold"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                        id: "link-text",
                        children: "Link Text:"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                        href: "#",
                        as: "a",
                        style: "link",
                        color: "alku-black",
                        weight: "semibold",
                        children: "Text Link Component"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("h2", {
                        id: "buttons",
                        children: "Buttons"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                        id: "primary-button",
                        children: "Primary Button (impact):"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        id: "primary",
                        style: "primary-impact",
                        type: "submit",
                        as: "button",
                        children: "Submit"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        id: "secondary",
                        style: "primary-impact",
                        type: "submit",
                        disabled: true,
                        as: "button",
                        children: "Submit Disabled"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                        id: "primary-button",
                        children: "Primary Button (default):"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        id: "primary",
                        style: "primary-default",
                        type: "submit",
                        as: "button",
                        children: "Submit"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        id: "secondary",
                        style: "primary-default",
                        type: "submit",
                        disabled: true,
                        as: "button",
                        children: "Submit Disabled"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                        id: "secondary-button",
                        children: "Secondary Button: "
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        id: "click",
                        as: "button",
                        type: "submit",
                        style: "secondary",
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                                symbol: "AddOutlinedIcon",
                                color: "alku-brand-primary",
                                size: "md",
                                space: "right"
                            }),
                            "Click Here"
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        id: "browse",
                        as: "button",
                        type: "submit",
                        style: "secondary",
                        children: "Browse..."
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        id: "link",
                        as: "a",
                        style: "primary-impact",
                        href: "#",
                        children: "Link Button"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                        id: "function-button",
                        children: "Function Button:"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        id: "icon-plus",
                        as: "button",
                        type: "button",
                        style: "function",
                        children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                            symbol: "AddOutlinedIcon",
                            color: "alku-black",
                            size: "lg"
                        })
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        id: "icon-menu",
                        as: "button",
                        type: "button",
                        style: "function",
                        children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                            symbol: "MoreVertOutlinedIcon",
                            color: "alku-black",
                            size: "lg"
                        })
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                        id: "icon-only",
                        children: "Icon Only Button:"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        as: "button",
                        style: "icon-only",
                        ariaLabel: "Back To Previous Page",
                        onClick: ()=>{
                            console.log("icon only button clicked");
                        },
                        id: "icon-only-button",
                        children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                            symbol: "ArrowBackIosIcon",
                            color: "alku-brand-primary",
                            size: "lg",
                            space: "right"
                        })
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("h2", {
                        id: "avatar",
                        children: "Avatar"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$e2255cf6045e8d47), {
                        initials: "SA",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("h2", {
                        id: "icons",
                        children: "Icons"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                        children: "Icons can be managed in two ways:"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)("li", {
                                children: "With a supported symbol string from the UI Kit"
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)("li", {
                                children: "By passing in a child component with an MUI Icon"
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)("li", {
                                children: "Note: if you do not have a supported symbol string or child component a question mark will render"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "QuestionMarkOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "AddOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "MoreVertOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "ArrowBackIosIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "ArrowDropDownOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "LogoutOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "ExpandMoreOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "ChevronRightOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "CloseOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "ReportProblemOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "InfoOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "CheckCircleOutlineOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "ErrorOutlineOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "FileDownloadOutlinedIcon",
                        color: "alku-black",
                        size: "md"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        color: "alku-black",
                        size: "lg",
                        children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($439ad22215b8fe99$exports))), {
                            fontSize: "inherit",
                            color: "inherit",
                            style: {
                                height: "1.5em",
                                width: "1.5em"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("h2", {
                        id: "modals",
                        children: "Modals"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        disabled: openDefault,
                        style: "primary-impact",
                        as: "button",
                        onClick: ()=>setOpenDefault(true),
                        children: "Open Default Modal"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        disabled: openInfo,
                        style: "primary-impact",
                        as: "button",
                        onClick: ()=>setOpenInfo(true),
                        children: "Open Info Modal"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        disabled: openAlert,
                        style: "primary-impact",
                        as: "button",
                        onClick: ()=>setOpenAlert(true),
                        children: "Open Alert Modal"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        disabled: openSuccess,
                        style: "primary-impact",
                        as: "button",
                        onClick: ()=>setOpenSuccess(true),
                        children: "Open Success Modal"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                        disabled: openError,
                        style: "primary-impact",
                        as: "button",
                        onClick: ()=>setOpenError(true),
                        children: "Open Error Modal"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$2b77a92f1a5ad772), {
                        theme: "default",
                        open: openDefault,
                        onRequestClose: ()=>setOpenDefault(false),
                        closeOnOutsideClick: true,
                        title: "Default Modal",
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "This is what a default modal looks like"
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "You can put anything you want in here"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$2b77a92f1a5ad772), {
                        theme: "info",
                        open: openInfo,
                        onRequestClose: ()=>setOpenInfo(false),
                        closeOnOutsideClick: true,
                        title: "Info Modal",
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "This is what an info modal looks like"
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "You can put anything you want in here"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$2b77a92f1a5ad772), {
                        theme: "alert",
                        open: openAlert,
                        onRequestClose: ()=>setOpenAlert(false),
                        closeOnOutsideClick: true,
                        title: "Alert Modal",
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "This is what an alert modal looks like"
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "You can put anything you want in here"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$2b77a92f1a5ad772), {
                        theme: "success",
                        open: openSuccess,
                        onRequestClose: ()=>setOpenSuccess(false),
                        closeOnOutsideClick: true,
                        title: "Success Modal",
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "This is what a success modal looks like"
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "You can put anything you want in here"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$2b77a92f1a5ad772), {
                        theme: "error",
                        open: openError,
                        onRequestClose: ()=>setOpenError(false),
                        closeOnOutsideClick: true,
                        title: "Error Modal",
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "This is what an error modal looks like"
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                children: "You can put anything you want in here"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("br", {})
                ]
            })
        })
    });
}



var $2WrlN = parcelRequire("2WrlN");



var $1b3d60035dfc4871$export$50b1df6aa49d0846;
var $1b3d60035dfc4871$export$89da14300d534261;
var $1b3d60035dfc4871$export$345c5736c8054f22;
var $1b3d60035dfc4871$export$38e42c68cf43b5d4;
var $1b3d60035dfc4871$export$4dd6232dd12b948a;
var $1b3d60035dfc4871$export$463b44d9bf3628be;
var $1b3d60035dfc4871$export$9c30223ca0a664fb;
var $1b3d60035dfc4871$export$db3c28d99448dcff;
var $1b3d60035dfc4871$export$e6c1918473d79145;
var $1b3d60035dfc4871$export$b1e5508a851be14d;
var $1b3d60035dfc4871$export$80e4b313e5e6b30d;
var $1b3d60035dfc4871$export$4882ae973e0491e;
$1b3d60035dfc4871$export$50b1df6aa49d0846 = `o781xq_account-wrapper`;
$1b3d60035dfc4871$export$89da14300d534261 = `o781xq_active`;
$1b3d60035dfc4871$export$345c5736c8054f22 = `o781xq_avatar`;
$1b3d60035dfc4871$export$38e42c68cf43b5d4 = `o781xq_header`;
$1b3d60035dfc4871$export$4dd6232dd12b948a = `o781xq_header-account-wrapper`;
$1b3d60035dfc4871$export$463b44d9bf3628be = `o781xq_img`;
$1b3d60035dfc4871$export$9c30223ca0a664fb = `o781xq_link`;
$1b3d60035dfc4871$export$db3c28d99448dcff = `o781xq_logo`;
$1b3d60035dfc4871$export$e6c1918473d79145 = `o781xq_logo-mobile`;
$1b3d60035dfc4871$export$b1e5508a851be14d = `o781xq_menu`;
$1b3d60035dfc4871$export$80e4b313e5e6b30d = `o781xq_nav`;
$1b3d60035dfc4871$export$4882ae973e0491e = `o781xq_profile`;



var $2WrlN = parcelRequire("2WrlN");

var $ld5Xm = parcelRequire("ld5Xm");




var $2WrlN = parcelRequire("2WrlN");


var $24a8bb51359be90a$export$34e0f9847d4c02dd;
$24a8bb51359be90a$export$34e0f9847d4c02dd = `k_JnYa_container`;


const $be15517559363752$var$UnauthenticatedScreen = ({ hasAccounts: hasAccounts })=>{
    return /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
        className: $24a8bb51359be90a$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $2WrlN.jsx)("center", {
            children: /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$a8a3e93435678ff9), {
                as: "h1",
                style: "one",
                children: [
                    hasAccounts ? /*#__PURE__*/ (0, $2WrlN.jsx)("span", {
                        children: "User found, verifying auth state"
                    }) : /*#__PURE__*/ (0, $2WrlN.jsx)("span", {
                        children: "User is unauthenticated, redirecting to login page"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)("span", {
                        className: $02107f5ada3562cf$exports["ellipsis-anim"],
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)("span", {
                                children: "."
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)("span", {
                                children: "."
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)("span", {
                                children: "."
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $be15517559363752$export$2e2bcd8739ae039 = $be15517559363752$var$UnauthenticatedScreen;



var $2WrlN = parcelRequire("2WrlN");

var $7c1f270ac6faabef$export$34e0f9847d4c02dd;
var $7c1f270ac6faabef$export$eaceaf7f88807f33;
var $7c1f270ac6faabef$export$7f951d8d5ede654f;
var $7c1f270ac6faabef$export$a80b3bd66acc52ff;
var $7c1f270ac6faabef$export$db3c28d99448dcff;
$7c1f270ac6faabef$export$34e0f9847d4c02dd = `B9_LqW_container`;
$7c1f270ac6faabef$export$eaceaf7f88807f33 = `B9_LqW_error-container`;
$7c1f270ac6faabef$export$7f951d8d5ede654f = `B9_LqW_img-container`;
$7c1f270ac6faabef$export$a80b3bd66acc52ff = `B9_LqW_info`;
$7c1f270ac6faabef$export$db3c28d99448dcff = `B9_LqW_logo`;




var $2WrlN = parcelRequire("2WrlN");
var $4dca4d63c212ae93$exports = {};

$parcel$export($4dca4d63c212ae93$exports, "alert", function () { return $4dca4d63c212ae93$export$5ea928c9faf85bd3; }, function (v) { return $4dca4d63c212ae93$export$5ea928c9faf85bd3 = v; });
$parcel$export($4dca4d63c212ae93$exports, "container", function () { return $4dca4d63c212ae93$export$34e0f9847d4c02dd; }, function (v) { return $4dca4d63c212ae93$export$34e0f9847d4c02dd = v; });
$parcel$export($4dca4d63c212ae93$exports, "content", function () { return $4dca4d63c212ae93$export$a7db06668cad9adb; }, function (v) { return $4dca4d63c212ae93$export$a7db06668cad9adb = v; });
$parcel$export($4dca4d63c212ae93$exports, "error", function () { return $4dca4d63c212ae93$export$a3bc9b8ed74fc; }, function (v) { return $4dca4d63c212ae93$export$a3bc9b8ed74fc = v; });
$parcel$export($4dca4d63c212ae93$exports, "info", function () { return $4dca4d63c212ae93$export$a80b3bd66acc52ff; }, function (v) { return $4dca4d63c212ae93$export$a80b3bd66acc52ff = v; });
$parcel$export($4dca4d63c212ae93$exports, "md", function () { return $4dca4d63c212ae93$export$f4de1c043ce6927; }, function (v) { return $4dca4d63c212ae93$export$f4de1c043ce6927 = v; });
$parcel$export($4dca4d63c212ae93$exports, "sm", function () { return $4dca4d63c212ae93$export$92d98d0701d4531a; }, function (v) { return $4dca4d63c212ae93$export$92d98d0701d4531a = v; });
$parcel$export($4dca4d63c212ae93$exports, "success", function () { return $4dca4d63c212ae93$export$fe7c49d056ea1d88; }, function (v) { return $4dca4d63c212ae93$export$fe7c49d056ea1d88 = v; });
$parcel$export($4dca4d63c212ae93$exports, "text", function () { return $4dca4d63c212ae93$export$6f093cfa640b7166; }, function (v) { return $4dca4d63c212ae93$export$6f093cfa640b7166 = v; });
var $4dca4d63c212ae93$export$5ea928c9faf85bd3;
var $4dca4d63c212ae93$export$34e0f9847d4c02dd;
var $4dca4d63c212ae93$export$a7db06668cad9adb;
var $4dca4d63c212ae93$export$a3bc9b8ed74fc;
var $4dca4d63c212ae93$export$a80b3bd66acc52ff;
var $4dca4d63c212ae93$export$f4de1c043ce6927;
var $4dca4d63c212ae93$export$92d98d0701d4531a;
var $4dca4d63c212ae93$export$fe7c49d056ea1d88;
var $4dca4d63c212ae93$export$6f093cfa640b7166;
$4dca4d63c212ae93$export$5ea928c9faf85bd3 = `_94fhDW_alert`;
$4dca4d63c212ae93$export$34e0f9847d4c02dd = `_94fhDW_container`;
$4dca4d63c212ae93$export$a7db06668cad9adb = `_94fhDW_content`;
$4dca4d63c212ae93$export$a3bc9b8ed74fc = `_94fhDW_error`;
$4dca4d63c212ae93$export$a80b3bd66acc52ff = `_94fhDW_info`;
$4dca4d63c212ae93$export$f4de1c043ce6927 = `_94fhDW_md`;
$4dca4d63c212ae93$export$92d98d0701d4531a = `_94fhDW_sm`;
$4dca4d63c212ae93$export$fe7c49d056ea1d88 = `_94fhDW_success`;
$4dca4d63c212ae93$export$6f093cfa640b7166 = `_94fhDW_text`;




const $1eb39025bbddccd5$var$themeIcons = {
    alert: "ReportProblemOutlinedIcon",
    error: "ErrorOutlineOutlinedIcon",
    info: "InfoOutlinedIcon",
    success: "CheckCircleOutlineOutlinedIcon"
};
const $1eb39025bbddccd5$var$themeColors = {
    alert: "icon-warn",
    error: "brand-red",
    info: "bright-blue",
    success: "icon-check-outlined"
};
const $1eb39025bbddccd5$export$585c3647f0cf4d02 = (theme)=>{
    return $1eb39025bbddccd5$var$themeIcons[theme];
};
const $1eb39025bbddccd5$export$e22c5d06d177c3fa = (theme)=>{
    return $1eb39025bbddccd5$var$themeColors[theme];
};


const $dd5074bf6bf802f4$export$caec2af78bcc877f = ({ children: children, type: type = "error", dismissable: dismissable = false, id: id, size: size = "md" })=>{
    return /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($4dca4d63c212ae93$exports.container, $4dca4d63c212ae93$exports[type], $4dca4d63c212ae93$exports[size]),
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                className: $4dca4d63c212ae93$exports.content,
                children: [
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: (0, $1eb39025bbddccd5$export$585c3647f0cf4d02)(type),
                        color: (0, $1eb39025bbddccd5$export$e22c5d06d177c3fa)(type),
                        size: size === "sm" ? "md" : "xl"
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                        className: $4dca4d63c212ae93$exports.text,
                        children: children
                    })
                ]
            }),
            dismissable ? /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                as: "button",
                type: "button",
                id: id,
                style: "icon-only",
                ariaLabel: "close",
                children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                    symbol: "CloseOutlinedIcon",
                    color: type === "info" ? "bright-blue" : type === "alert" ? "icon-warn" : type === "success" ? "icon-check-outlined" : "brand-red",
                    size: "lg"
                })
            }) : ""
        ]
    });
};


var $e76666a491c23283$exports = {};
$e76666a491c23283$exports = new URL("alku-logo.a90db96a.png", import.meta.url).toString();


const $389b44433c393742$var$AppLoading = ({ errorMessage: errorMessage })=>{
    const imageUrl = new URL($e76666a491c23283$exports);
    return /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
        className: $7c1f270ac6faabef$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                className: $7c1f270ac6faabef$export$7f951d8d5ede654f,
                children: /*#__PURE__*/ (0, $2WrlN.jsx)("img", {
                    className: $7c1f270ac6faabef$export$db3c28d99448dcff,
                    src: imageUrl.toString(),
                    alt: "ALKU"
                })
            }),
            /*#__PURE__*/ (0, $2WrlN.jsx)("center", {
                className: $7c1f270ac6faabef$export$a80b3bd66acc52ff,
                children: errorMessage === undefined ? /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$a8a3e93435678ff9), {
                    as: "h1",
                    style: "one",
                    children: [
                        "Loading",
                        /*#__PURE__*/ (0, $2WrlN.jsxs)("span", {
                            className: $02107f5ada3562cf$exports["ellipsis-anim"],
                            children: [
                                /*#__PURE__*/ (0, $2WrlN.jsx)("span", {
                                    children: "."
                                }),
                                /*#__PURE__*/ (0, $2WrlN.jsx)("span", {
                                    children: "."
                                }),
                                /*#__PURE__*/ (0, $2WrlN.jsx)("span", {
                                    children: "."
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                    className: $7c1f270ac6faabef$export$eaceaf7f88807f33,
                    children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $dd5074bf6bf802f4$export$caec2af78bcc877f), {
                        type: "error",
                        id: "signup-error",
                        children: `Error retrieving user data from database${typeof errorMessage === "string" ? `: ${errorMessage}` : ""}`
                    })
                })
            })
        ]
    });
};
var $389b44433c393742$export$2e2bcd8739ae039 = $389b44433c393742$var$AppLoading;


const $f3f9f758e1c80e18$export$a0fd8390cfe8ae69 = /*#__PURE__*/ (0, $ld5Xm.createContext)({
    first_name: "",
    last_name: ""
});
function $f3f9f758e1c80e18$export$87091915187a1a85({ children: children }) {
    const [authToken, setAuthToken] = (0, $ld5Xm.useState)(null);
    const { accounts: accounts } = (0, $6552874ea2db8d8d$export$f41558044a1dd55)();
    const isAuthenticated = (0, $6552874ea2db8d8d$export$7e9c60d6d1836c84)(accounts[0]);
    const validTokenGetCurrentUser = (0, $ld5Xm.useCallback)(async ()=>{
        if (isAuthenticated) {
            const token = await (0, $abad72839459f54c$export$84773cc9bf7dbe87)();
            if (typeof token === "string") setAuthToken(token);
        }
    }, [
        isAuthenticated
    ]);
    const names = accounts[0]?.name?.split(" ") || [
        "",
        ""
    ];
    const user = {
        first_name: names ? names[0] : "",
        last_name: names && names.length > 1 ? names[names.length - 1] : ""
    };
    // Fetch the current user bullhornid on initial load
    (0, $ld5Xm.useEffect)(()=>{
        validTokenGetCurrentUser();
    }, [
        validTokenGetCurrentUser
    ]);
    // We only want to render the underlying app after we
    // assert for the presence of a current user.
    return /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $2WrlN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsx)($f3f9f758e1c80e18$var$AppAuth, {}),
            authToken !== null ? /*#__PURE__*/ (0, $2WrlN.jsx)((0, $6552874ea2db8d8d$export$3f7734c901feade6), {
                children: /*#__PURE__*/ (0, $2WrlN.jsx)($f3f9f758e1c80e18$export$a0fd8390cfe8ae69.Provider, {
                    value: user,
                    children: children
                })
            }) : isAuthenticated ? /*#__PURE__*/ (0, $2WrlN.jsx)((0, $389b44433c393742$export$2e2bcd8739ae039), {}) : null,
            !isAuthenticated && /*#__PURE__*/ (0, $2WrlN.jsx)((0, $6552874ea2db8d8d$export$8285a35799c5812b), {
                children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $be15517559363752$export$2e2bcd8739ae039), {
                    hasAccounts: accounts.length > 0
                })
            })
        ]
    });
}
const $f3f9f758e1c80e18$var$AppAuth = ()=>{
    (0, $6552874ea2db8d8d$export$f41558044a1dd55)();
    (0, $6552874ea2db8d8d$export$d130d543558e611f)((0, $7b3089fdde5d004f$export$4ec29255e7e7f68f).Redirect);
    return /*#__PURE__*/ (0, $2WrlN.jsx)((0, $2WrlN.Fragment), {});
};
const $f3f9f758e1c80e18$export$1d39dc5b47e56ff0 = ()=>{
    return (0, $ld5Xm.useContext)($f3f9f758e1c80e18$export$a0fd8390cfe8ae69);
};


var $548ab8ef022c7ced$exports = {};
$548ab8ef022c7ced$exports = new URL("logo.a6de682e.png", import.meta.url).toString();


const $4ecbeb3399fcf92c$export$8b251419efc915eb = ()=>{
    const { instance: instance } = (0, $6552874ea2db8d8d$export$f41558044a1dd55)();
    const imageUrl = new URL($548ab8ef022c7ced$exports);
    const handleLogout = (logoutType, instance)=>{
        if (logoutType === "popup") instance.logoutPopup({
            postLogoutRedirectUri: "/",
            mainWindowRedirectUri: "/"
        });
        else if (logoutType === "redirect") instance.logoutRedirect({
            postLogoutRedirectUri: "/"
        });
    };
    const { first_name: first_name, last_name: last_name } = (0, $f3f9f758e1c80e18$export$1d39dc5b47e56ff0)();
    const getInitials = (first_name, last_name)=>{
        return first_name.substring(0, 1).toUpperCase() + last_name.substring(0, 1).toUpperCase();
    };
    const flyoutChildren = ()=>{
        return /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
            as: "div",
            style: "detail",
            color: "alku-black",
            children: /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$e2255cf6045e8d47), {
                        initials: getInitials(first_name, last_name),
                        size: "sm"
                    }),
                    first_name,
                    " ",
                    last_name
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
        className: $1b3d60035dfc4871$export$38e42c68cf43b5d4,
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsx)((0, $68c2ac1c8be5656b$export$a6c7ac8248d6e38a), {
                to: "/",
                className: $1b3d60035dfc4871$export$db3c28d99448dcff,
                children: /*#__PURE__*/ (0, $2WrlN.jsx)("img", {
                    className: $1b3d60035dfc4871$export$463b44d9bf3628be,
                    src: imageUrl.toString(),
                    alt: "Spread App"
                })
            }),
            /*#__PURE__*/ (0, $2WrlN.jsxs)("nav", {
                "aria-label": "Main",
                id: "main-nav",
                className: $1b3d60035dfc4871$export$80e4b313e5e6b30d,
                children: [
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $68c2ac1c8be5656b$export$a6c7ac8248d6e38a), {
                        to: "/",
                        className: $1b3d60035dfc4871$export$e6c1918473d79145,
                        children: /*#__PURE__*/ (0, $2WrlN.jsx)("img", {
                            className: $1b3d60035dfc4871$export$463b44d9bf3628be,
                            src: imageUrl.toString(),
                            alt: "Spread App"
                        })
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                        className: $1b3d60035dfc4871$export$4dd6232dd12b948a,
                        children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f4188c4fe84d69c1), {
                            id: "user-profile-menu",
                            label: "Spread Profile Menu",
                            buttonProps: {
                                style: "icon-only",
                                children: flyoutChildren()
                            },
                            iconProps: {
                                symbol: "ArrowDropDownOutlinedIcon",
                                color: "alku-brand-primary"
                            },
                            position: "left",
                            type: "account",
                            flyoutWidth: "md",
                            flyoutChildren: [
                                /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$cce593c893bdcfd0), {
                                    buttonText: "Sign Out",
                                    iconSymbol: "LogoutOutlinedIcon",
                                    buttonProps: {
                                        id: `profile-menu-button`
                                    },
                                    onClick: ()=>{
                                        handleLogout("redirect", instance);
                                    }
                                }, "header-sign-out")
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



var $2WrlN = parcelRequire("2WrlN");


var $7723f654767736cd$export$4e0c71f277ca26b3;
var $7723f654767736cd$export$f4c5de44377d2946;
var $7723f654767736cd$export$1fbd99162bd109d6;
var $7723f654767736cd$export$2b4ea30de06c071c;
var $7723f654767736cd$export$bdc1311fb7c6b2d1;
var $7723f654767736cd$export$36fb5c59ac576fb8;
var $7723f654767736cd$export$120ff0929b202a6d;
var $7723f654767736cd$export$8c0fbf88670831dc;
var $7723f654767736cd$export$c82e186cf428d56d;
var $7723f654767736cd$export$e6026be2f2fe3fd1;
$7723f654767736cd$export$4e0c71f277ca26b3 = `WXqopW_column`;
$7723f654767736cd$export$f4c5de44377d2946 = `WXqopW_loader`;
$7723f654767736cd$export$1fbd99162bd109d6 = `WXqopW_max-width`;
$7723f654767736cd$export$2b4ea30de06c071c = `WXqopW_mt-1`;
$7723f654767736cd$export$bdc1311fb7c6b2d1 = `WXqopW_mt-2`;
$7723f654767736cd$export$36fb5c59ac576fb8 = `WXqopW_pt-1`;
$7723f654767736cd$export$120ff0929b202a6d = `WXqopW_row`;
$7723f654767736cd$export$8c0fbf88670831dc = `WXqopW_sm-loader`;
$7723f654767736cd$export$c82e186cf428d56d = `WXqopW_spin`;
$7723f654767736cd$export$c82e186cf428d56d;
$7723f654767736cd$export$e6026be2f2fe3fd1 = `WXqopW_width-100`;



var $2WrlN = parcelRequire("2WrlN");




"use strict";
function $33e8d8c108580d5f$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $02a574ef6c4f5e3b$var$toString } = Object.prototype;
const { getPrototypeOf: $02a574ef6c4f5e3b$var$getPrototypeOf } = Object;
const $02a574ef6c4f5e3b$var$kindOf = ((cache)=>(thing)=>{
        const str = $02a574ef6c4f5e3b$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $02a574ef6c4f5e3b$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$02a574ef6c4f5e3b$var$kindOf(thing) === type;
};
const $02a574ef6c4f5e3b$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $02a574ef6c4f5e3b$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $02a574ef6c4f5e3b$var$isUndefined = $02a574ef6c4f5e3b$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $02a574ef6c4f5e3b$var$isBuffer(val) {
    return val !== null && !$02a574ef6c4f5e3b$var$isUndefined(val) && val.constructor !== null && !$02a574ef6c4f5e3b$var$isUndefined(val.constructor) && $02a574ef6c4f5e3b$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $02a574ef6c4f5e3b$var$isArrayBuffer = $02a574ef6c4f5e3b$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $02a574ef6c4f5e3b$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $02a574ef6c4f5e3b$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $02a574ef6c4f5e3b$var$isString = $02a574ef6c4f5e3b$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $02a574ef6c4f5e3b$var$isFunction = $02a574ef6c4f5e3b$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $02a574ef6c4f5e3b$var$isNumber = $02a574ef6c4f5e3b$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $02a574ef6c4f5e3b$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $02a574ef6c4f5e3b$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $02a574ef6c4f5e3b$var$isPlainObject = (val)=>{
    if ($02a574ef6c4f5e3b$var$kindOf(val) !== "object") return false;
    const prototype = $02a574ef6c4f5e3b$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $02a574ef6c4f5e3b$var$isDate = $02a574ef6c4f5e3b$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $02a574ef6c4f5e3b$var$isFile = $02a574ef6c4f5e3b$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $02a574ef6c4f5e3b$var$isBlob = $02a574ef6c4f5e3b$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $02a574ef6c4f5e3b$var$isFileList = $02a574ef6c4f5e3b$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $02a574ef6c4f5e3b$var$isStream = (val)=>$02a574ef6c4f5e3b$var$isObject(val) && $02a574ef6c4f5e3b$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $02a574ef6c4f5e3b$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $02a574ef6c4f5e3b$var$isFunction(thing.append) && ((kind = $02a574ef6c4f5e3b$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $02a574ef6c4f5e3b$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $02a574ef6c4f5e3b$var$isURLSearchParams = $02a574ef6c4f5e3b$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $02a574ef6c4f5e3b$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $02a574ef6c4f5e3b$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($02a574ef6c4f5e3b$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $02a574ef6c4f5e3b$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $02a574ef6c4f5e3b$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $02a574ef6c4f5e3b$var$isContextDefined = (context)=>!$02a574ef6c4f5e3b$var$isUndefined(context) && context !== $02a574ef6c4f5e3b$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $02a574ef6c4f5e3b$var$merge() {
    const { caseless: caseless } = $02a574ef6c4f5e3b$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $02a574ef6c4f5e3b$var$findKey(result, key) || key;
        if ($02a574ef6c4f5e3b$var$isPlainObject(result[targetKey]) && $02a574ef6c4f5e3b$var$isPlainObject(val)) result[targetKey] = $02a574ef6c4f5e3b$var$merge(result[targetKey], val);
        else if ($02a574ef6c4f5e3b$var$isPlainObject(val)) result[targetKey] = $02a574ef6c4f5e3b$var$merge({}, val);
        else if ($02a574ef6c4f5e3b$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $02a574ef6c4f5e3b$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $02a574ef6c4f5e3b$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $02a574ef6c4f5e3b$var$forEach(b, (val, key)=>{
        if (thisArg && $02a574ef6c4f5e3b$var$isFunction(val)) a[key] = (0, $33e8d8c108580d5f$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $02a574ef6c4f5e3b$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $02a574ef6c4f5e3b$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $02a574ef6c4f5e3b$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $02a574ef6c4f5e3b$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $02a574ef6c4f5e3b$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $02a574ef6c4f5e3b$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($02a574ef6c4f5e3b$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$02a574ef6c4f5e3b$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $02a574ef6c4f5e3b$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $02a574ef6c4f5e3b$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $02a574ef6c4f5e3b$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $02a574ef6c4f5e3b$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $02a574ef6c4f5e3b$var$isHTMLForm = $02a574ef6c4f5e3b$var$kindOfTest("HTMLFormElement");
const $02a574ef6c4f5e3b$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $02a574ef6c4f5e3b$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $02a574ef6c4f5e3b$var$isRegExp = $02a574ef6c4f5e3b$var$kindOfTest("RegExp");
const $02a574ef6c4f5e3b$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $02a574ef6c4f5e3b$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $02a574ef6c4f5e3b$var$freezeMethods = (obj)=>{
    $02a574ef6c4f5e3b$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($02a574ef6c4f5e3b$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$02a574ef6c4f5e3b$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $02a574ef6c4f5e3b$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $02a574ef6c4f5e3b$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $02a574ef6c4f5e3b$var$noop = ()=>{};
const $02a574ef6c4f5e3b$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $02a574ef6c4f5e3b$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $02a574ef6c4f5e3b$var$DIGIT = "0123456789";
const $02a574ef6c4f5e3b$var$ALPHABET = {
    DIGIT: $02a574ef6c4f5e3b$var$DIGIT,
    ALPHA: $02a574ef6c4f5e3b$var$ALPHA,
    ALPHA_DIGIT: $02a574ef6c4f5e3b$var$ALPHA + $02a574ef6c4f5e3b$var$ALPHA.toUpperCase() + $02a574ef6c4f5e3b$var$DIGIT
};
const $02a574ef6c4f5e3b$var$generateString = (size = 16, alphabet = $02a574ef6c4f5e3b$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $02a574ef6c4f5e3b$var$isSpecCompliantForm(thing) {
    return !!(thing && $02a574ef6c4f5e3b$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $02a574ef6c4f5e3b$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($02a574ef6c4f5e3b$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $02a574ef6c4f5e3b$var$isArray(source) ? [] : {};
                $02a574ef6c4f5e3b$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$02a574ef6c4f5e3b$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $02a574ef6c4f5e3b$var$isAsyncFn = $02a574ef6c4f5e3b$var$kindOfTest("AsyncFunction");
const $02a574ef6c4f5e3b$var$isThenable = (thing)=>thing && ($02a574ef6c4f5e3b$var$isObject(thing) || $02a574ef6c4f5e3b$var$isFunction(thing)) && $02a574ef6c4f5e3b$var$isFunction(thing.then) && $02a574ef6c4f5e3b$var$isFunction(thing.catch);
var $02a574ef6c4f5e3b$export$2e2bcd8739ae039 = {
    isArray: $02a574ef6c4f5e3b$var$isArray,
    isArrayBuffer: $02a574ef6c4f5e3b$var$isArrayBuffer,
    isBuffer: $02a574ef6c4f5e3b$var$isBuffer,
    isFormData: $02a574ef6c4f5e3b$var$isFormData,
    isArrayBufferView: $02a574ef6c4f5e3b$var$isArrayBufferView,
    isString: $02a574ef6c4f5e3b$var$isString,
    isNumber: $02a574ef6c4f5e3b$var$isNumber,
    isBoolean: $02a574ef6c4f5e3b$var$isBoolean,
    isObject: $02a574ef6c4f5e3b$var$isObject,
    isPlainObject: $02a574ef6c4f5e3b$var$isPlainObject,
    isUndefined: $02a574ef6c4f5e3b$var$isUndefined,
    isDate: $02a574ef6c4f5e3b$var$isDate,
    isFile: $02a574ef6c4f5e3b$var$isFile,
    isBlob: $02a574ef6c4f5e3b$var$isBlob,
    isRegExp: $02a574ef6c4f5e3b$var$isRegExp,
    isFunction: $02a574ef6c4f5e3b$var$isFunction,
    isStream: $02a574ef6c4f5e3b$var$isStream,
    isURLSearchParams: $02a574ef6c4f5e3b$var$isURLSearchParams,
    isTypedArray: $02a574ef6c4f5e3b$var$isTypedArray,
    isFileList: $02a574ef6c4f5e3b$var$isFileList,
    forEach: $02a574ef6c4f5e3b$var$forEach,
    merge: $02a574ef6c4f5e3b$var$merge,
    extend: $02a574ef6c4f5e3b$var$extend,
    trim: $02a574ef6c4f5e3b$var$trim,
    stripBOM: $02a574ef6c4f5e3b$var$stripBOM,
    inherits: $02a574ef6c4f5e3b$var$inherits,
    toFlatObject: $02a574ef6c4f5e3b$var$toFlatObject,
    kindOf: $02a574ef6c4f5e3b$var$kindOf,
    kindOfTest: $02a574ef6c4f5e3b$var$kindOfTest,
    endsWith: $02a574ef6c4f5e3b$var$endsWith,
    toArray: $02a574ef6c4f5e3b$var$toArray,
    forEachEntry: $02a574ef6c4f5e3b$var$forEachEntry,
    matchAll: $02a574ef6c4f5e3b$var$matchAll,
    isHTMLForm: $02a574ef6c4f5e3b$var$isHTMLForm,
    hasOwnProperty: $02a574ef6c4f5e3b$var$hasOwnProperty,
    hasOwnProp: $02a574ef6c4f5e3b$var$hasOwnProperty,
    reduceDescriptors: $02a574ef6c4f5e3b$var$reduceDescriptors,
    freezeMethods: $02a574ef6c4f5e3b$var$freezeMethods,
    toObjectSet: $02a574ef6c4f5e3b$var$toObjectSet,
    toCamelCase: $02a574ef6c4f5e3b$var$toCamelCase,
    noop: $02a574ef6c4f5e3b$var$noop,
    toFiniteNumber: $02a574ef6c4f5e3b$var$toFiniteNumber,
    findKey: $02a574ef6c4f5e3b$var$findKey,
    global: $02a574ef6c4f5e3b$var$_global,
    isContextDefined: $02a574ef6c4f5e3b$var$isContextDefined,
    ALPHABET: $02a574ef6c4f5e3b$var$ALPHABET,
    generateString: $02a574ef6c4f5e3b$var$generateString,
    isSpecCompliantForm: $02a574ef6c4f5e3b$var$isSpecCompliantForm,
    toJSONObject: $02a574ef6c4f5e3b$var$toJSONObject,
    isAsyncFn: $02a574ef6c4f5e3b$var$isAsyncFn,
    isThenable: $02a574ef6c4f5e3b$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $9bbb2707dbcf8bb8$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).inherits($9bbb2707dbcf8bb8$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $9bbb2707dbcf8bb8$var$prototype = $9bbb2707dbcf8bb8$var$AxiosError.prototype;
const $9bbb2707dbcf8bb8$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $9bbb2707dbcf8bb8$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($9bbb2707dbcf8bb8$var$AxiosError, $9bbb2707dbcf8bb8$var$descriptors);
Object.defineProperty($9bbb2707dbcf8bb8$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$9bbb2707dbcf8bb8$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($9bbb2707dbcf8bb8$var$prototype);
    (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $9bbb2707dbcf8bb8$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $9bbb2707dbcf8bb8$export$2e2bcd8739ae039 = $9bbb2707dbcf8bb8$var$AxiosError;


// eslint-disable-next-line strict
var $49bf49a59f9428f9$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a75212021caad51d$export$a143d493d941bafc;
var $a75212021caad51d$export$e4cf37d7f6fb9e0a;
var $a75212021caad51d$export$f99ded8fe4b79145;
var $a75212021caad51d$export$599f31c3813fae4d;
"use strict";
var $99dd0b62c1fdb9a8$export$a48f0734ac7c2329;
var $99dd0b62c1fdb9a8$export$d622b2ad8d90c771;
var $99dd0b62c1fdb9a8$export$6100ba28696e12de;
"use strict";
$99dd0b62c1fdb9a8$export$a48f0734ac7c2329 = $99dd0b62c1fdb9a8$var$byteLength;
$99dd0b62c1fdb9a8$export$d622b2ad8d90c771 = $99dd0b62c1fdb9a8$var$toByteArray;
$99dd0b62c1fdb9a8$export$6100ba28696e12de = $99dd0b62c1fdb9a8$var$fromByteArray;
var $99dd0b62c1fdb9a8$var$lookup = [];
var $99dd0b62c1fdb9a8$var$revLookup = [];
var $99dd0b62c1fdb9a8$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $99dd0b62c1fdb9a8$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $99dd0b62c1fdb9a8$var$i = 0, $99dd0b62c1fdb9a8$var$len = $99dd0b62c1fdb9a8$var$code.length; $99dd0b62c1fdb9a8$var$i < $99dd0b62c1fdb9a8$var$len; ++$99dd0b62c1fdb9a8$var$i){
    $99dd0b62c1fdb9a8$var$lookup[$99dd0b62c1fdb9a8$var$i] = $99dd0b62c1fdb9a8$var$code[$99dd0b62c1fdb9a8$var$i];
    $99dd0b62c1fdb9a8$var$revLookup[$99dd0b62c1fdb9a8$var$code.charCodeAt($99dd0b62c1fdb9a8$var$i)] = $99dd0b62c1fdb9a8$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$99dd0b62c1fdb9a8$var$revLookup["-".charCodeAt(0)] = 62;
$99dd0b62c1fdb9a8$var$revLookup["_".charCodeAt(0)] = 63;
function $99dd0b62c1fdb9a8$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $99dd0b62c1fdb9a8$var$byteLength(b64) {
    var lens = $99dd0b62c1fdb9a8$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $99dd0b62c1fdb9a8$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $99dd0b62c1fdb9a8$var$toByteArray(b64) {
    var tmp;
    var lens = $99dd0b62c1fdb9a8$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $99dd0b62c1fdb9a8$var$Arr($99dd0b62c1fdb9a8$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $99dd0b62c1fdb9a8$var$revLookup[b64.charCodeAt(i)] << 18 | $99dd0b62c1fdb9a8$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $99dd0b62c1fdb9a8$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $99dd0b62c1fdb9a8$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $99dd0b62c1fdb9a8$var$revLookup[b64.charCodeAt(i)] << 2 | $99dd0b62c1fdb9a8$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $99dd0b62c1fdb9a8$var$revLookup[b64.charCodeAt(i)] << 10 | $99dd0b62c1fdb9a8$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $99dd0b62c1fdb9a8$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $99dd0b62c1fdb9a8$var$tripletToBase64(num) {
    return $99dd0b62c1fdb9a8$var$lookup[num >> 18 & 0x3F] + $99dd0b62c1fdb9a8$var$lookup[num >> 12 & 0x3F] + $99dd0b62c1fdb9a8$var$lookup[num >> 6 & 0x3F] + $99dd0b62c1fdb9a8$var$lookup[num & 0x3F];
}
function $99dd0b62c1fdb9a8$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($99dd0b62c1fdb9a8$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $99dd0b62c1fdb9a8$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($99dd0b62c1fdb9a8$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($99dd0b62c1fdb9a8$var$lookup[tmp >> 2] + $99dd0b62c1fdb9a8$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($99dd0b62c1fdb9a8$var$lookup[tmp >> 10] + $99dd0b62c1fdb9a8$var$lookup[tmp >> 4 & 0x3F] + $99dd0b62c1fdb9a8$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $bac048a52ca25f26$export$aafa59e2e03f2942;
var $bac048a52ca25f26$export$68d8715fc104d294;
$bac048a52ca25f26$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$bac048a52ca25f26$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $a75212021caad51d$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$a75212021caad51d$export$a143d493d941bafc = $a75212021caad51d$var$Buffer;
$a75212021caad51d$export$e4cf37d7f6fb9e0a = $a75212021caad51d$var$SlowBuffer;
$a75212021caad51d$export$f99ded8fe4b79145 = 50;
const $a75212021caad51d$var$K_MAX_LENGTH = 0x7fffffff;
$a75212021caad51d$export$599f31c3813fae4d = $a75212021caad51d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a75212021caad51d$var$Buffer.TYPED_ARRAY_SUPPORT = $a75212021caad51d$var$typedArraySupport();
if (!$a75212021caad51d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a75212021caad51d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a75212021caad51d$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$a75212021caad51d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a75212021caad51d$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$a75212021caad51d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a75212021caad51d$var$createBuffer(length) {
    if (length > $a75212021caad51d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a75212021caad51d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a75212021caad51d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a75212021caad51d$var$allocUnsafe(arg);
    }
    return $a75212021caad51d$var$from(arg, encodingOrOffset, length);
}
$a75212021caad51d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a75212021caad51d$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $a75212021caad51d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a75212021caad51d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a75212021caad51d$var$isInstance(value, ArrayBuffer) || value && $a75212021caad51d$var$isInstance(value.buffer, ArrayBuffer)) return $a75212021caad51d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($a75212021caad51d$var$isInstance(value, SharedArrayBuffer) || value && $a75212021caad51d$var$isInstance(value.buffer, SharedArrayBuffer))) return $a75212021caad51d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a75212021caad51d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $a75212021caad51d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $a75212021caad51d$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a75212021caad51d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a75212021caad51d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a75212021caad51d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a75212021caad51d$var$Buffer, Uint8Array);
function $a75212021caad51d$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a75212021caad51d$var$alloc(size, fill, encoding) {
    $a75212021caad51d$var$assertSize(size);
    if (size <= 0) return $a75212021caad51d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $a75212021caad51d$var$createBuffer(size).fill(fill, encoding) : $a75212021caad51d$var$createBuffer(size).fill(fill);
    return $a75212021caad51d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a75212021caad51d$var$Buffer.alloc = function(size, fill, encoding) {
    return $a75212021caad51d$var$alloc(size, fill, encoding);
};
function $a75212021caad51d$var$allocUnsafe(size) {
    $a75212021caad51d$var$assertSize(size);
    return $a75212021caad51d$var$createBuffer(size < 0 ? 0 : $a75212021caad51d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a75212021caad51d$var$Buffer.allocUnsafe = function(size) {
    return $a75212021caad51d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a75212021caad51d$var$Buffer.allocUnsafeSlow = function(size) {
    return $a75212021caad51d$var$allocUnsafe(size);
};
function $a75212021caad51d$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$a75212021caad51d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $a75212021caad51d$var$byteLength(string, encoding) | 0;
    let buf = $a75212021caad51d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a75212021caad51d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $a75212021caad51d$var$checked(array.length) | 0;
    const buf = $a75212021caad51d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a75212021caad51d$var$fromArrayView(arrayView) {
    if ($a75212021caad51d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $a75212021caad51d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a75212021caad51d$var$fromArrayLike(arrayView);
}
function $a75212021caad51d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a75212021caad51d$var$Buffer.prototype);
    return buf;
}
function $a75212021caad51d$var$fromObject(obj) {
    if ($a75212021caad51d$var$Buffer.isBuffer(obj)) {
        const len = $a75212021caad51d$var$checked(obj.length) | 0;
        const buf = $a75212021caad51d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $a75212021caad51d$var$numberIsNaN(obj.length)) return $a75212021caad51d$var$createBuffer(0);
        return $a75212021caad51d$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $a75212021caad51d$var$fromArrayLike(obj.data);
}
function $a75212021caad51d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a75212021caad51d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a75212021caad51d$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $a75212021caad51d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a75212021caad51d$var$Buffer.alloc(+length);
}
$a75212021caad51d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a75212021caad51d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a75212021caad51d$var$Buffer.compare = function compare(a, b) {
    if ($a75212021caad51d$var$isInstance(a, Uint8Array)) a = $a75212021caad51d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a75212021caad51d$var$isInstance(b, Uint8Array)) b = $a75212021caad51d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a75212021caad51d$var$Buffer.isBuffer(a) || !$a75212021caad51d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a75212021caad51d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$a75212021caad51d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a75212021caad51d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $a75212021caad51d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($a75212021caad51d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a75212021caad51d$var$Buffer.isBuffer(buf)) buf = $a75212021caad51d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a75212021caad51d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a75212021caad51d$var$byteLength(string, encoding) {
    if ($a75212021caad51d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a75212021caad51d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $a75212021caad51d$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $a75212021caad51d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a75212021caad51d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a75212021caad51d$var$Buffer.byteLength = $a75212021caad51d$var$byteLength;
function $a75212021caad51d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $a75212021caad51d$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $a75212021caad51d$var$utf8Slice(this, start, end);
        case "ascii":
            return $a75212021caad51d$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $a75212021caad51d$var$latin1Slice(this, start, end);
        case "base64":
            return $a75212021caad51d$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a75212021caad51d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a75212021caad51d$var$Buffer.prototype._isBuffer = true;
function $a75212021caad51d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a75212021caad51d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$a75212021caad51d$var$swap(this, i, i + 1);
    return this;
};
$a75212021caad51d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $a75212021caad51d$var$swap(this, i, i + 3);
        $a75212021caad51d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a75212021caad51d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $a75212021caad51d$var$swap(this, i, i + 7);
        $a75212021caad51d$var$swap(this, i + 1, i + 6);
        $a75212021caad51d$var$swap(this, i + 2, i + 5);
        $a75212021caad51d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a75212021caad51d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $a75212021caad51d$var$utf8Slice(this, 0, length);
    return $a75212021caad51d$var$slowToString.apply(this, arguments);
};
$a75212021caad51d$var$Buffer.prototype.toLocaleString = $a75212021caad51d$var$Buffer.prototype.toString;
$a75212021caad51d$var$Buffer.prototype.equals = function equals(b) {
    if (!$a75212021caad51d$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $a75212021caad51d$var$Buffer.compare(this, b) === 0;
};
$a75212021caad51d$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $a75212021caad51d$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($a75212021caad51d$var$customInspectSymbol) $a75212021caad51d$var$Buffer.prototype[$a75212021caad51d$var$customInspectSymbol] = $a75212021caad51d$var$Buffer.prototype.inspect;
$a75212021caad51d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a75212021caad51d$var$isInstance(target, Uint8Array)) target = $a75212021caad51d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a75212021caad51d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a75212021caad51d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a75212021caad51d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $a75212021caad51d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a75212021caad51d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a75212021caad51d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a75212021caad51d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $a75212021caad51d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a75212021caad51d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a75212021caad51d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a75212021caad51d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a75212021caad51d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a75212021caad51d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a75212021caad51d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a75212021caad51d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a75212021caad51d$var$utf8Write(buf, string, offset, length) {
    return $a75212021caad51d$var$blitBuffer($a75212021caad51d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a75212021caad51d$var$asciiWrite(buf, string, offset, length) {
    return $a75212021caad51d$var$blitBuffer($a75212021caad51d$var$asciiToBytes(string), buf, offset, length);
}
function $a75212021caad51d$var$base64Write(buf, string, offset, length) {
    return $a75212021caad51d$var$blitBuffer($a75212021caad51d$var$base64ToBytes(string), buf, offset, length);
}
function $a75212021caad51d$var$ucs2Write(buf, string, offset, length) {
    return $a75212021caad51d$var$blitBuffer($a75212021caad51d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a75212021caad51d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $a75212021caad51d$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $a75212021caad51d$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $a75212021caad51d$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $a75212021caad51d$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a75212021caad51d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a75212021caad51d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a75212021caad51d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $99dd0b62c1fdb9a8$export$6100ba28696e12de(buf);
    else return $99dd0b62c1fdb9a8$export$6100ba28696e12de(buf.slice(start, end));
}
function $a75212021caad51d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a75212021caad51d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $a75212021caad51d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a75212021caad51d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $a75212021caad51d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a75212021caad51d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a75212021caad51d$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a75212021caad51d$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a75212021caad51d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $a75212021caad51d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a75212021caad51d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a75212021caad51d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a75212021caad51d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a75212021caad51d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$a75212021caad51d$var$Buffer.prototype.readUintLE = $a75212021caad51d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a75212021caad51d$var$Buffer.prototype.readUintBE = $a75212021caad51d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a75212021caad51d$var$Buffer.prototype.readUint8 = $a75212021caad51d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a75212021caad51d$var$Buffer.prototype.readUint16LE = $a75212021caad51d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a75212021caad51d$var$Buffer.prototype.readUint16BE = $a75212021caad51d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a75212021caad51d$var$Buffer.prototype.readUint32LE = $a75212021caad51d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a75212021caad51d$var$Buffer.prototype.readUint32BE = $a75212021caad51d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a75212021caad51d$var$Buffer.prototype.readBigUInt64LE = $a75212021caad51d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a75212021caad51d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a75212021caad51d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a75212021caad51d$var$Buffer.prototype.readBigUInt64BE = $a75212021caad51d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a75212021caad51d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a75212021caad51d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a75212021caad51d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a75212021caad51d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a75212021caad51d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a75212021caad51d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a75212021caad51d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a75212021caad51d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a75212021caad51d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a75212021caad51d$var$Buffer.prototype.readBigInt64LE = $a75212021caad51d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a75212021caad51d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a75212021caad51d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$a75212021caad51d$var$Buffer.prototype.readBigInt64BE = $a75212021caad51d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a75212021caad51d$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a75212021caad51d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$a75212021caad51d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 4, this.length);
    return $bac048a52ca25f26$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$a75212021caad51d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 4, this.length);
    return $bac048a52ca25f26$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$a75212021caad51d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 8, this.length);
    return $bac048a52ca25f26$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$a75212021caad51d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkOffset(offset, 8, this.length);
    return $bac048a52ca25f26$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $a75212021caad51d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a75212021caad51d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$a75212021caad51d$var$Buffer.prototype.writeUintLE = $a75212021caad51d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a75212021caad51d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a75212021caad51d$var$Buffer.prototype.writeUintBE = $a75212021caad51d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a75212021caad51d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a75212021caad51d$var$Buffer.prototype.writeUint8 = $a75212021caad51d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a75212021caad51d$var$Buffer.prototype.writeUint16LE = $a75212021caad51d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a75212021caad51d$var$Buffer.prototype.writeUint16BE = $a75212021caad51d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a75212021caad51d$var$Buffer.prototype.writeUint32LE = $a75212021caad51d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a75212021caad51d$var$Buffer.prototype.writeUint32BE = $a75212021caad51d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a75212021caad51d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a75212021caad51d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a75212021caad51d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a75212021caad51d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a75212021caad51d$var$Buffer.prototype.writeBigUInt64LE = $a75212021caad51d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $a75212021caad51d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$a75212021caad51d$var$Buffer.prototype.writeBigUInt64BE = $a75212021caad51d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $a75212021caad51d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$a75212021caad51d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a75212021caad51d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a75212021caad51d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a75212021caad51d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a75212021caad51d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a75212021caad51d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a75212021caad51d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a75212021caad51d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a75212021caad51d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a75212021caad51d$var$Buffer.prototype.writeBigInt64LE = $a75212021caad51d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $a75212021caad51d$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$a75212021caad51d$var$Buffer.prototype.writeBigInt64BE = $a75212021caad51d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $a75212021caad51d$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $a75212021caad51d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $a75212021caad51d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $bac048a52ca25f26$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a75212021caad51d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a75212021caad51d$var$writeFloat(this, value, offset, true, noAssert);
};
$a75212021caad51d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a75212021caad51d$var$writeFloat(this, value, offset, false, noAssert);
};
function $a75212021caad51d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a75212021caad51d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $bac048a52ca25f26$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a75212021caad51d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a75212021caad51d$var$writeDouble(this, value, offset, true, noAssert);
};
$a75212021caad51d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a75212021caad51d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a75212021caad51d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a75212021caad51d$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a75212021caad51d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$a75212021caad51d$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $a75212021caad51d$var$Buffer.isBuffer(val) ? val : $a75212021caad51d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $a75212021caad51d$var$errors = {};
function $a75212021caad51d$var$E(sym, getMessage, Base) {
    $a75212021caad51d$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$a75212021caad51d$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$a75212021caad51d$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$a75212021caad51d$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $a75212021caad51d$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $a75212021caad51d$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $a75212021caad51d$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $a75212021caad51d$var$checkBounds(buf, offset, byteLength) {
    $a75212021caad51d$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a75212021caad51d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a75212021caad51d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $a75212021caad51d$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $a75212021caad51d$var$checkBounds(buf, offset, byteLength);
}
function $a75212021caad51d$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $a75212021caad51d$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $a75212021caad51d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a75212021caad51d$var$validateNumber(value, type);
        throw new $a75212021caad51d$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $a75212021caad51d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a75212021caad51d$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $a75212021caad51d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a75212021caad51d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a75212021caad51d$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $a75212021caad51d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $a75212021caad51d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a75212021caad51d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a75212021caad51d$var$base64ToBytes(str) {
    return $99dd0b62c1fdb9a8$export$d622b2ad8d90c771($a75212021caad51d$var$base64clean(str));
}
function $a75212021caad51d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a75212021caad51d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a75212021caad51d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $a75212021caad51d$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a75212021caad51d$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $a75212021caad51d$var$BufferBigIntNotDefined : fn;
}
function $a75212021caad51d$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $4915dc046517dde0$require$Buffer = $a75212021caad51d$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $4915dc046517dde0$var$isVisitable(thing) {
    return (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $4915dc046517dde0$var$removeBrackets(key) {
    return (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $4915dc046517dde0$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $4915dc046517dde0$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $4915dc046517dde0$var$isFlatArray(arr) {
    return (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(arr) && !arr.some($4915dc046517dde0$var$isVisitable);
}
const $4915dc046517dde0$var$predicates = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).toFlatObject((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $4915dc046517dde0$var$toFormData(obj, formData, options) {
    if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $49bf49a59f9428f9$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $4915dc046517dde0$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(value) && $4915dc046517dde0$var$isFlatArray(value) || ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFileList(value) || (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $4915dc046517dde0$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $4915dc046517dde0$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($4915dc046517dde0$var$isVisitable(value)) return true;
        formData.append($4915dc046517dde0$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($4915dc046517dde0$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $4915dc046517dde0$var$isVisitable
    });
    function build(value, path) {
        if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $4915dc046517dde0$export$2e2bcd8739ae039 = $4915dc046517dde0$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $360d4d0530d925f6$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $360d4d0530d925f6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $4915dc046517dde0$export$2e2bcd8739ae039)(params, this, options);
}
const $360d4d0530d925f6$var$prototype = $360d4d0530d925f6$var$AxiosURLSearchParams.prototype;
$360d4d0530d925f6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$360d4d0530d925f6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $360d4d0530d925f6$var$encode);
    } : $360d4d0530d925f6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $360d4d0530d925f6$export$2e2bcd8739ae039 = $360d4d0530d925f6$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $f706fc1cf7780b58$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $f706fc1cf7780b58$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $f706fc1cf7780b58$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $360d4d0530d925f6$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $1d2078cffcabebc4$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $1d2078cffcabebc4$export$2e2bcd8739ae039 = $1d2078cffcabebc4$var$InterceptorManager;





"use strict";
var $4d33ed53ff7a48e4$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $0e0a42bc9d5adcbf$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $360d4d0530d925f6$export$2e2bcd8739ae039);


"use strict";
var $b3ff5e02dd1427e4$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $663bacff7c3ee397$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $d19223ba42fd6491$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $0e0a42bc9d5adcbf$export$2e2bcd8739ae039,
        FormData: $b3ff5e02dd1427e4$export$2e2bcd8739ae039,
        Blob: $663bacff7c3ee397$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $1e5e2cf4fb084560$exports = {};

$parcel$export($1e5e2cf4fb084560$exports, "hasBrowserEnv", function () { return $1e5e2cf4fb084560$export$c4996c4b7b93b0bf; });
$parcel$export($1e5e2cf4fb084560$exports, "hasStandardBrowserEnv", function () { return $1e5e2cf4fb084560$export$c0bcc9250309d66; });
$parcel$export($1e5e2cf4fb084560$exports, "hasStandardBrowserWebWorkerEnv", function () { return $1e5e2cf4fb084560$export$c81692cf5af97dac; });
const $1e5e2cf4fb084560$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1e5e2cf4fb084560$export$c0bcc9250309d66 = ((product)=>{
    return $1e5e2cf4fb084560$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1e5e2cf4fb084560$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $5baf945d39d4cff6$export$2e2bcd8739ae039 = {
    ...$1e5e2cf4fb084560$exports,
    ...(0, $d19223ba42fd6491$export$2e2bcd8739ae039)
};


"use strict";
function $ff68231de4acea31$export$2e2bcd8739ae039(data, options) {
    return (0, $4915dc046517dde0$export$2e2bcd8739ae039)(data, new (0, $5baf945d39d4cff6$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $5baf945d39d4cff6$export$2e2bcd8739ae039).isNode && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $e5434e27577520e7$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $e5434e27577520e7$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $e5434e27577520e7$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $e5434e27577520e7$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFormData(formData) && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($e5434e27577520e7$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $e5434e27577520e7$export$2e2bcd8739ae039 = $e5434e27577520e7$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $5da244e06046a924$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $5da244e06046a924$var$defaults = {
    transitional: (0, $4d33ed53ff7a48e4$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $e5434e27577520e7$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isBuffer(data) || (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isStream(data) || (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFile(data) || (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $ff68231de4acea31$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $4915dc046517dde0$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $5da244e06046a924$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $5da244e06046a924$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).from(e, (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $5baf945d39d4cff6$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $5baf945d39d4cff6$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $5da244e06046a924$var$defaults.headers[method] = {};
});
var $5da244e06046a924$export$2e2bcd8739ae039 = $5da244e06046a924$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $18efb6a0f805b795$var$ignoreDuplicateOf = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $18efb6a0f805b795$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $18efb6a0f805b795$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $0e239459452bb0cd$var$$internals = Symbol("internals");
function $0e239459452bb0cd$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $0e239459452bb0cd$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(value) ? value.map($0e239459452bb0cd$var$normalizeValue) : String(value);
}
function $0e239459452bb0cd$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $0e239459452bb0cd$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $0e239459452bb0cd$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $0e239459452bb0cd$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $0e239459452bb0cd$var$buildAccessors(obj, header) {
    const accessorName = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $0e239459452bb0cd$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $0e239459452bb0cd$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $0e239459452bb0cd$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$0e239459452bb0cd$var$isValidHeaderName(header)) setHeaders((0, $18efb6a0f805b795$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $0e239459452bb0cd$var$normalizeHeader(header);
        if (header) {
            const key = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $0e239459452bb0cd$var$parseTokens(value);
                if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $0e239459452bb0cd$var$normalizeHeader(header);
        if (header) {
            const key = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $0e239459452bb0cd$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $0e239459452bb0cd$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $0e239459452bb0cd$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $0e239459452bb0cd$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $0e239459452bb0cd$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $0e239459452bb0cd$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $0e239459452bb0cd$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$0e239459452bb0cd$var$$internals] = this[$0e239459452bb0cd$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $0e239459452bb0cd$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $0e239459452bb0cd$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$0e239459452bb0cd$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).reduceDescriptors($0e239459452bb0cd$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).freezeMethods($0e239459452bb0cd$var$AxiosHeaders);
var $0e239459452bb0cd$export$2e2bcd8739ae039 = $0e239459452bb0cd$var$AxiosHeaders;


"use strict";
function $63597e17adbc86c0$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $5da244e06046a924$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $0e239459452bb0cd$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $bec9598ddf54b9d7$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $7ca82efc1b9524f1$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).inherits($7ca82efc1b9524f1$var$CanceledError, (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $7ca82efc1b9524f1$export$2e2bcd8739ae039 = $7ca82efc1b9524f1$var$CanceledError;







"use strict";
function $f30be5a9ac80ae1e$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $fc4a8bb011d47507$export$2e2bcd8739ae039 = (0, $5baf945d39d4cff6$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $891f1c74ec6e491f$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $811e851ab6755b80$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $489176c8510329f3$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $891f1c74ec6e491f$export$2e2bcd8739ae039)(requestedURL)) return (0, $811e851ab6755b80$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $1b4654f64e981d70$export$2e2bcd8739ae039 = (0, $5baf945d39d4cff6$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $1bacf9c672748539$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $704c2a4d883c9044$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $704c2a4d883c9044$export$2e2bcd8739ae039 = $704c2a4d883c9044$var$speedometer;


"use strict";
function $690174157657ced0$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $704c2a4d883c9044$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $690174157657ced0$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $690174157657ced0$export$2e2bcd8739ae039 = $690174157657ced0$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $0e239459452bb0cd$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $5baf945d39d4cff6$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $5baf945d39d4cff6$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $489176c8510329f3$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $f706fc1cf7780b58$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $0e239459452bb0cd$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $f30be5a9ac80ae1e$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)("Request aborted", (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)("Network Error", (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $4d33ed53ff7a48e4$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ETIMEDOUT : (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $5baf945d39d4cff6$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $1b4654f64e981d70$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $fc4a8bb011d47507$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $690174157657ced0$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $690174157657ced0$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $7ca82efc1b9524f1$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $1bacf9c672748539$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $5baf945d39d4cff6$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $301596dfead170e8$var$knownAdapters = {
    http: (0, $49bf49a59f9428f9$export$2e2bcd8739ae039),
    xhr: (0, $690174157657ced0$export$2e2bcd8739ae039)
};
(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach($301596dfead170e8$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $301596dfead170e8$var$renderReason = (reason)=>`- ${reason}`;
const $301596dfead170e8$var$isResolvedHandle = (adapter)=>(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $301596dfead170e8$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$301596dfead170e8$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $301596dfead170e8$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($301596dfead170e8$var$renderReason).join("\n") : " " + $301596dfead170e8$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $301596dfead170e8$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1567a9f23d4be30e$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $7ca82efc1b9524f1$export$2e2bcd8739ae039)(null, config);
}
function $1567a9f23d4be30e$export$2e2bcd8739ae039(config) {
    $1567a9f23d4be30e$var$throwIfCancellationRequested(config);
    config.headers = (0, $0e239459452bb0cd$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $63597e17adbc86c0$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $301596dfead170e8$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $5da244e06046a924$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $1567a9f23d4be30e$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $63597e17adbc86c0$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $0e239459452bb0cd$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $bec9598ddf54b9d7$export$2e2bcd8739ae039)(reason)) {
            $1567a9f23d4be30e$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $63597e17adbc86c0$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $0e239459452bb0cd$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $911c0f62dcd9aedd$var$headersToObject = (thing)=>thing instanceof (0, $0e239459452bb0cd$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $911c0f62dcd9aedd$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isPlainObject(target) && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($911c0f62dcd9aedd$var$headersToObject(a), $911c0f62dcd9aedd$var$headersToObject(b), true)
    };
    (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $fa19bbe71087c9a0$export$a4ad2735b021c132 = "1.6.7";



"use strict";
const $18a5d1fa466b232b$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $18a5d1fa466b232b$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $18a5d1fa466b232b$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $18a5d1fa466b232b$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $fa19bbe71087c9a0$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$18a5d1fa466b232b$var$deprecatedWarnings[opt]) {
            $18a5d1fa466b232b$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $18a5d1fa466b232b$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)("options must be an object", (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $18a5d1fa466b232b$export$2e2bcd8739ae039 = {
    assertOptions: $18a5d1fa466b232b$var$assertOptions,
    validators: $18a5d1fa466b232b$var$validators
};



"use strict";
const $69a4460ca4518646$var$validators = (0, $18a5d1fa466b232b$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $69a4460ca4518646$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $1d2078cffcabebc4$export$2e2bcd8739ae039)(),
            response: new (0, $1d2078cffcabebc4$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $911c0f62dcd9aedd$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $18a5d1fa466b232b$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $69a4460ca4518646$var$validators.transitional($69a4460ca4518646$var$validators.boolean),
            forcedJSONParsing: $69a4460ca4518646$var$validators.transitional($69a4460ca4518646$var$validators.boolean),
            clarifyTimeoutError: $69a4460ca4518646$var$validators.transitional($69a4460ca4518646$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $18a5d1fa466b232b$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $69a4460ca4518646$var$validators.function,
                serialize: $69a4460ca4518646$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $0e239459452bb0cd$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $1567a9f23d4be30e$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $1567a9f23d4be30e$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $911c0f62dcd9aedd$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $489176c8510329f3$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $f706fc1cf7780b58$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $69a4460ca4518646$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $911c0f62dcd9aedd$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $911c0f62dcd9aedd$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $69a4460ca4518646$var$Axios.prototype[method] = generateHTTPMethod();
    $69a4460ca4518646$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $69a4460ca4518646$export$2e2bcd8739ae039 = $69a4460ca4518646$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $64729088d4b8ae72$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $7ca82efc1b9524f1$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $64729088d4b8ae72$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $64729088d4b8ae72$export$2e2bcd8739ae039 = $64729088d4b8ae72$var$CancelToken;






"use strict";
function $591c224e336fba4c$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $6b7aafbe31fc957b$export$2e2bcd8739ae039(payload) {
    return (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $c5be40f3ec789f4b$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($c5be40f3ec789f4b$var$HttpStatusCode).forEach(([key, value])=>{
    $c5be40f3ec789f4b$var$HttpStatusCode[value] = key;
});
var $c5be40f3ec789f4b$export$2e2bcd8739ae039 = $c5be40f3ec789f4b$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $563c4cfb39e16102$var$createInstance(defaultConfig) {
    const context = new (0, $69a4460ca4518646$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $33e8d8c108580d5f$export$2e2bcd8739ae039)((0, $69a4460ca4518646$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).extend(instance, (0, $69a4460ca4518646$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $563c4cfb39e16102$var$createInstance((0, $911c0f62dcd9aedd$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $563c4cfb39e16102$var$axios = $563c4cfb39e16102$var$createInstance((0, $5da244e06046a924$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$563c4cfb39e16102$var$axios.Axios = (0, $69a4460ca4518646$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$563c4cfb39e16102$var$axios.CanceledError = (0, $7ca82efc1b9524f1$export$2e2bcd8739ae039);
$563c4cfb39e16102$var$axios.CancelToken = (0, $64729088d4b8ae72$export$2e2bcd8739ae039);
$563c4cfb39e16102$var$axios.isCancel = (0, $bec9598ddf54b9d7$export$2e2bcd8739ae039);
$563c4cfb39e16102$var$axios.VERSION = (0, $fa19bbe71087c9a0$export$a4ad2735b021c132);
$563c4cfb39e16102$var$axios.toFormData = (0, $4915dc046517dde0$export$2e2bcd8739ae039);
// Expose AxiosError class
$563c4cfb39e16102$var$axios.AxiosError = (0, $9bbb2707dbcf8bb8$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$563c4cfb39e16102$var$axios.Cancel = $563c4cfb39e16102$var$axios.CanceledError;
// Expose all/spread
$563c4cfb39e16102$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$563c4cfb39e16102$var$axios.spread = (0, $591c224e336fba4c$export$2e2bcd8739ae039);
// Expose isAxiosError
$563c4cfb39e16102$var$axios.isAxiosError = (0, $6b7aafbe31fc957b$export$2e2bcd8739ae039);
// Expose mergeConfig
$563c4cfb39e16102$var$axios.mergeConfig = (0, $911c0f62dcd9aedd$export$2e2bcd8739ae039);
$563c4cfb39e16102$var$axios.AxiosHeaders = (0, $0e239459452bb0cd$export$2e2bcd8739ae039);
$563c4cfb39e16102$var$axios.formToJSON = (thing)=>(0, $e5434e27577520e7$export$2e2bcd8739ae039)((0, $02a574ef6c4f5e3b$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$563c4cfb39e16102$var$axios.getAdapter = (0, $301596dfead170e8$export$2e2bcd8739ae039).getAdapter;
$563c4cfb39e16102$var$axios.HttpStatusCode = (0, $c5be40f3ec789f4b$export$2e2bcd8739ae039);
$563c4cfb39e16102$var$axios.default = $563c4cfb39e16102$var$axios;
var // this module should only have a default export
$563c4cfb39e16102$export$2e2bcd8739ae039 = $563c4cfb39e16102$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $fb7b7d4ebdf4403b$export$1c00760e9e5a4e95, AxiosError: $fb7b7d4ebdf4403b$export$c1fbed17c2f6a328, CanceledError: $fb7b7d4ebdf4403b$export$1ab0c6b20d94fa14, isCancel: $fb7b7d4ebdf4403b$export$3b22524397b493c6, CancelToken: $fb7b7d4ebdf4403b$export$fd08e3cb425f0d61, VERSION: $fb7b7d4ebdf4403b$export$a4ad2735b021c132, all: $fb7b7d4ebdf4403b$export$84bf76cd7afc7469, Cancel: $fb7b7d4ebdf4403b$export$848c9b7ead0df967, isAxiosError: $fb7b7d4ebdf4403b$export$fbafdbe06a5b5a9a, spread: $fb7b7d4ebdf4403b$export$3ae0fd4797ed47c8, toFormData: $fb7b7d4ebdf4403b$export$10ae0d317ea97f8b, AxiosHeaders: $fb7b7d4ebdf4403b$export$4e7d6ff0f3e6520, HttpStatusCode: $fb7b7d4ebdf4403b$export$a972f69c851492b3, formToJSON: $fb7b7d4ebdf4403b$export$86d7c59254d6a2c9, getAdapter: $fb7b7d4ebdf4403b$export$17ddc20a97d669e2, mergeConfig: $fb7b7d4ebdf4403b$export$7ec1ebcfa9d8bd6a } = (0, $563c4cfb39e16102$export$2e2bcd8739ae039);


const $37f00dda556cffcc$var$ENVIRONMENT = "dev";
const $37f00dda556cffcc$var$api = (0, $563c4cfb39e16102$export$2e2bcd8739ae039).create({
    baseURL: $37f00dda556cffcc$var$ENVIRONMENT === "prod" ? "https://3k5m4ovsc6.execute-api.us-east-1.amazonaws.com/prod" : `https://luhclwcvl9.execute-api.us-east-1.amazonaws.com/${$37f00dda556cffcc$var$ENVIRONMENT || "dev"}`,
    headers: {
        "Content-Type": "application/json"
    }
});
const $37f00dda556cffcc$export$6b241ade6d8f8817 = async ()=>{
    try {
        const token = await (0, $abad72839459f54c$export$84773cc9bf7dbe87)();
        const response = await $37f00dda556cffcc$var$api.get(`/startReportGeneration`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (err) {
        console.error("Failed to generate report");
        throw err;
    }
};
const $37f00dda556cffcc$export$9dc937f1c1abf620 = async ()=>{
    try {
        const token = await (0, $abad72839459f54c$export$84773cc9bf7dbe87)();
        const response = await $37f00dda556cffcc$var$api.get(`/getReportsMetadata`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (err) {
        console.error("Failed to get reports");
        throw err;
    }
};
const $37f00dda556cffcc$export$ff50b76619962c6c = async (id)=>{
    try {
        const token = await (0, $abad72839459f54c$export$84773cc9bf7dbe87)();
        const response = await $37f00dda556cffcc$var$api.get(`/getReport?id=${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    } catch (err) {
        console.error("Failed to get report by ID");
        throw err;
    }
};
const $37f00dda556cffcc$export$611fc8957e8d71f7 = async (report)=>{
    try {
        const token = await (0, $abad72839459f54c$export$84773cc9bf7dbe87)();
        let data = new FormData();
        data.append("adjustmentsFile", report);
        const response = await $37f00dda556cffcc$var$api.post(`/uploadSpreadAdjustments`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": `multipart/form-data`
            }
        });
        return response;
    } catch (err) {
        console.error("Failed to upload adjustment report");
        throw err;
    }
};



var $ld5Xm = parcelRequire("ld5Xm");

const $893f38dce37802d9$export$bb42c091ac7d4ce7 = ({ recentReport: recentReport })=>{
    const [modalVisible, setModalVisible] = (0, $ld5Xm.useState)(false);
    const [error, setError] = (0, $ld5Xm.useState)("");
    const [loading, setLoading] = (0, $ld5Xm.useState)(false);
    let lastUpdated = "";
    if (recentReport?.generatedAtTimestamp) lastUpdated = new Date(recentReport.generatedAtTimestamp).toLocaleString("en-US", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });
    const handleClick = async ()=>{
        try {
            setError("");
            setLoading(true);
            await (0, $37f00dda556cffcc$export$6b241ade6d8f8817)();
            setModalVisible(true);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            if (err instanceof (0, $fb7b7d4ebdf4403b$export$c1fbed17c2f6a328) && err.response && err.response.status === 409) setError("Report generation already in progress, please try again later.");
            else setError("Failed to generate spread report. Please try again or reach out to SOS.");
        }
    };
    return /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $2WrlN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                disabled: loading,
                as: "button",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($7723f654767736cd$export$1fbd99162bd109d6, $7723f654767736cd$export$bdc1311fb7c6b2d1, $7723f654767736cd$export$e6026be2f2fe3fd1),
                onClick: ()=>handleClick(),
                id: "primary",
                style: "primary-default",
                type: "button",
                title: "Generate Spread Report",
                children: loading ? /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                    style: {
                        width: "16px",
                        height: "16px"
                    },
                    children: /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                        className: $7723f654767736cd$export$8c0fbf88670831dc
                    })
                }) : /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                    children: [
                        "Generate Spread Report",
                        lastUpdated && /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                            style: "normal",
                            as: "p",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($7723f654767736cd$export$36fb5c59ac576fb8),
                            children: [
                                "Last Updated: ",
                                lastUpdated
                            ]
                        })
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($7723f654767736cd$export$1fbd99162bd109d6, $7723f654767736cd$export$bdc1311fb7c6b2d1),
                children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                    style: "div",
                    color: "alku-brand-primary",
                    children: error
                })
            }),
            modalVisible && /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$2b77a92f1a5ad772), {
                title: "Generating Spread Report ...",
                open: modalVisible,
                onRequestClose: ()=>setModalVisible(false),
                closeOnOutsideClick: true,
                theme: "success",
                children: /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                    className: $7723f654767736cd$export$bdc1311fb7c6b2d1,
                    children: "You will receive an email when the report is complete. If you don't receive an email within an hour, please reach out to SOS."
                })
            })
        ]
    });
};



var $2WrlN = parcelRequire("2WrlN");



var $ld5Xm = parcelRequire("ld5Xm");


const $7eded2c6c63ed79e$export$897026084cbe1e0 = (data, fileName)=>{
    const blob = new Blob([
        data
    ], {
        type: "text/csv"
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    setTimeout(()=>{
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
    }, 0);
};


const $b4148de03918bf6e$export$5ab06ab8185d7a0e = ({ recentReport: recentReport })=>{
    const [error, setError] = (0, $ld5Xm.useState)("");
    const [loading, setLoading] = (0, $ld5Xm.useState)(false);
    const handleClick = async ()=>{
        try {
            setLoading(true);
            setError("");
            const response = await (0, $37f00dda556cffcc$export$ff50b76619962c6c)(recentReport?.id);
            const data = response.data;
            const filename = recentReport?.s3Key || "";
            (0, $7eded2c6c63ed79e$export$897026084cbe1e0)(data, filename);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            setError("Failed to download spread report. Please try again or contact support.");
        }
    };
    return /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
        className: $7723f654767736cd$export$bdc1311fb7c6b2d1,
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                disabled: loading || recentReport === undefined,
                as: "button",
                style: "primary-default",
                id: "primary",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($7723f654767736cd$export$1fbd99162bd109d6, $7723f654767736cd$export$e6026be2f2fe3fd1),
                onClick: ()=>handleClick(),
                title: "Download Spread Report",
                children: loading ? /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                    className: $7723f654767736cd$export$f4c5de44377d2946
                }) : /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                    children: [
                        "Download Spread Report",
                        recentReport && /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                            style: "normal",
                            as: "p",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($7723f654767736cd$export$36fb5c59ac576fb8),
                            children: recentReport?.s3Key
                        })
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($7723f654767736cd$export$2b4ea30de06c071c, $7723f654767736cd$export$1fbd99162bd109d6),
                children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                    style: "span",
                    color: "alku-brand-primary",
                    children: error
                })
            })
        ]
    });
};




var $ld5Xm = parcelRequire("ld5Xm");

var $2WrlN = parcelRequire("2WrlN");

var $ld5Xm = parcelRequire("ld5Xm");
var $4c0aa45418b2a5d4$export$136fd86de524d3c2;
var $4c0aa45418b2a5d4$export$3481c78889e8fbe8;
var $4c0aa45418b2a5d4$export$a51f79187e038b94;
var $4c0aa45418b2a5d4$export$683472f6198a076e;
var $4c0aa45418b2a5d4$export$d6cfb32d83c28a38;
var $4c0aa45418b2a5d4$export$6fbb5939890fda3b;
var $4c0aa45418b2a5d4$export$6173d4a273008e45;
var $4c0aa45418b2a5d4$export$5a11e9f32df400a2;
var $4c0aa45418b2a5d4$export$bdc1311fb7c6b2d1;
var $4c0aa45418b2a5d4$export$23b449722ddd128a;
var $4c0aa45418b2a5d4$export$f0722bd88b230141;
var $4c0aa45418b2a5d4$export$3e78fa447bb3bdd0;
var $4c0aa45418b2a5d4$export$cc74dcc53cfce4eb;
$4c0aa45418b2a5d4$export$136fd86de524d3c2 = `_26O0zq_bg`;
$4c0aa45418b2a5d4$export$3481c78889e8fbe8 = `_26O0zq_center`;
$4c0aa45418b2a5d4$export$a51f79187e038b94 = `_26O0zq_cursor-pointer`;
$4c0aa45418b2a5d4$export$683472f6198a076e = `_26O0zq_disabled`;
$4c0aa45418b2a5d4$export$d6cfb32d83c28a38 = `_26O0zq_font-size-16`;
$4c0aa45418b2a5d4$export$6fbb5939890fda3b = `_26O0zq_font-sm`;
$4c0aa45418b2a5d4$export$6173d4a273008e45 = `_26O0zq_loader-wrapper`;
$4c0aa45418b2a5d4$export$5a11e9f32df400a2 = `_26O0zq_min-width-32`;
$4c0aa45418b2a5d4$export$bdc1311fb7c6b2d1 = `_26O0zq_mt-2`;
$4c0aa45418b2a5d4$export$23b449722ddd128a = `_26O0zq_pb-1`;
$4c0aa45418b2a5d4$export$f0722bd88b230141 = `_26O0zq_pl-3`;
$4c0aa45418b2a5d4$export$3e78fa447bb3bdd0 = `_26O0zq_pl-6`;
$4c0aa45418b2a5d4$export$cc74dcc53cfce4eb = `_26O0zq_wrapper`;







const $a472c85250d3bcda$var$ExpandableYear = ({ year: year, months: months, index: index })=>{
    const [expanded, setExpanded] = (0, $ld5Xm.useState)(index === 0);
    return /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $2WrlN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                onClick: ()=>setExpanded(!expanded),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($4c0aa45418b2a5d4$export$cc74dcc53cfce4eb, $4c0aa45418b2a5d4$export$a51f79187e038b94),
                children: [
                    /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                        children: expanded ? /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                            symbol: "ExpandMoreOutlinedIcon",
                            color: "alku-black",
                            size: "sm",
                            space: "right"
                        }) // ExpandMoreOutlinedIcon
                         : /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                            symbol: "ChevronRightOutlinedIcon",
                            color: "alku-black",
                            size: "sm",
                            space: "right"
                        }) // ChevronRightOutlinedIcon
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                        as: "div",
                        style: "title",
                        weight: "semibold",
                        children: year
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $2WrlN.jsx)($a472c85250d3bcda$var$ExpandableMonths, {
                months: months
            })
        ]
    });
};
const $a472c85250d3bcda$var$ExpandableMonths = ({ months: months })=>{
    return months.map((month, i)=>/*#__PURE__*/ (0, $2WrlN.jsx)($a472c85250d3bcda$var$ExpandableMonth, {
            index: i,
            month: month.month,
            files: month.files
        }, i));
};
const $a472c85250d3bcda$var$ExpandableMonth = ({ month: month, files: files, index: index })=>{
    const [expanded, setExpanded] = (0, $ld5Xm.useState)(index === 0);
    return /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $2WrlN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                onClick: ()=>setExpanded(!expanded),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($4c0aa45418b2a5d4$export$cc74dcc53cfce4eb, $4c0aa45418b2a5d4$export$f0722bd88b230141, $4c0aa45418b2a5d4$export$a51f79187e038b94),
                children: [
                    /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                        children: expanded ? /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                            symbol: "ExpandMoreOutlinedIcon",
                            color: "alku-black",
                            size: "sm",
                            space: "right"
                        }) // ExpandMoreOutlinedIcon
                         : /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                            symbol: "ChevronRightOutlinedIcon",
                            color: "alku-black",
                            size: "sm",
                            space: "right"
                        }) // ChevronRightOutlinedIcon
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                        style: "title",
                        as: "div",
                        weight: "semibold",
                        children: month
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $2WrlN.jsx)($a472c85250d3bcda$var$ExpandableFiles, {
                files: files
            })
        ]
    });
};
const $a472c85250d3bcda$var$ExpandableFiles = ({ files: files })=>{
    return files.map((file, i)=>/*#__PURE__*/ (0, $2WrlN.jsx)($a472c85250d3bcda$var$FileLink, {
            fileName: file.fileName,
            id: file.id
        }, i));
};
const $a472c85250d3bcda$var$FileLink = ({ fileName: fileName, id: id })=>{
    const [loader, setLoader] = (0, $ld5Xm.useState)(false);
    const [error, setError] = (0, $ld5Xm.useState)("");
    const handleClick = async ()=>{
        try {
            setError("");
            setLoader(true);
            const response = await (0, $37f00dda556cffcc$export$ff50b76619962c6c)(id);
            const data = response.data;
            (0, $7eded2c6c63ed79e$export$897026084cbe1e0)(data, fileName);
            setLoader(false);
        } catch (err) {
            setLoader(false);
            setError("Failed to download spread report. Please try again or contact support.");
        }
    };
    return /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $2WrlN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($4c0aa45418b2a5d4$export$cc74dcc53cfce4eb, $4c0aa45418b2a5d4$export$3e78fa447bb3bdd0),
                children: [
                    loader ? /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                        className: $4c0aa45418b2a5d4$export$6173d4a273008e45,
                        children: /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                            className: $7723f654767736cd$export$8c0fbf88670831dc
                        })
                    }) : /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$f04a61298a47a40f), {
                        symbol: "FileDownloadOutlinedIcon",
                        color: "alku-black",
                        size: "sm",
                        space: "right"
                    }) // FileDownloadOutlinedIcon
                    ,
                    /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                        style: "link",
                        color: "alku-black",
                        weight: "semibold",
                        children: [
                            !loader && /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                onClick: ()=>handleClick(),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($4c0aa45418b2a5d4$export$a51f79187e038b94, $4c0aa45418b2a5d4$export$d6cfb32d83c28a38),
                                children: fileName
                            }),
                            loader && /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($4c0aa45418b2a5d4$export$683472f6198a076e, $4c0aa45418b2a5d4$export$d6cfb32d83c28a38),
                                children: fileName
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($4c0aa45418b2a5d4$export$3e78fa447bb3bdd0, $4c0aa45418b2a5d4$export$6fbb5939890fda3b, $4c0aa45418b2a5d4$export$23b449722ddd128a),
                children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                    style: "span",
                    color: "alku-brand-primary",
                    children: error
                })
            })
        ]
    });
};
const $a472c85250d3bcda$export$84202caead5689ba = ({ reports: reports, isLoading: isLoading })=>{
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    function findInsertIndex(dayInt, files) {
        for(let i = 0; i < files.length; i++){
            const fileDay = files[i].fileName.split("-") || [];
            if (parseInt(fileDay[1]) > dayInt) return i;
        }
    }
    const sortedData = reports.filter((report)=>report.completedStatus === "completed").reduce((sorted, report)=>{
        const [month, day, year] = report?.s3Key.split("-") || [];
        const fullMonth = monthNames[parseInt(month) - 1];
        const existingYearIndex = sorted.findIndex((item)=>item.year === Number(year));
        let dayInt = parseInt(day);
        if (existingYearIndex !== -1) {
            const existingMonthIndex = sorted[existingYearIndex].months.findIndex((item)=>item.month === fullMonth);
            if (existingMonthIndex !== -1) {
                let insertIndex = findInsertIndex(dayInt, sorted[existingYearIndex].months[existingMonthIndex].files) ?? 0;
                sorted[existingYearIndex].months[existingMonthIndex].files.splice(insertIndex, 0, {
                    fileName: report?.s3Key,
                    id: report?.id
                });
            } else sorted[existingYearIndex].months.push({
                month: fullMonth,
                files: [
                    {
                        fileName: report?.s3Key,
                        id: report?.id
                    }
                ]
            });
        } else sorted.push({
            year: Number(year),
            months: [
                {
                    month: fullMonth,
                    files: [
                        {
                            fileName: report?.s3Key,
                            id: report?.id
                        }
                    ]
                }
            ]
        });
        // Sort months array in descending order within each year
        sorted.forEach((yearObj)=>{
            yearObj.months.sort((a, b)=>monthNames.indexOf(b.month) - monthNames.indexOf(a.month));
        });
        return sorted;
    }, []);
    return /*#__PURE__*/ (0, $2WrlN.jsx)((0, $2WrlN.Fragment), {
        children: /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$a8a3e93435678ff9), {
                    as: "div",
                    style: "one",
                    children: "Historical Reports"
                }),
                sortedData.length === 0 ? isLoading ? /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($4c0aa45418b2a5d4$export$3481c78889e8fbe8, $4c0aa45418b2a5d4$export$136fd86de524d3c2),
                    children: /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                        className: $7723f654767736cd$export$f4c5de44377d2946
                    })
                }) : /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($4c0aa45418b2a5d4$export$3481c78889e8fbe8, $4c0aa45418b2a5d4$export$bdc1311fb7c6b2d1),
                    children: "No Historical Reports"
                }) : /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                    className: $4c0aa45418b2a5d4$export$136fd86de524d3c2,
                    children: sortedData.map((year, i)=>{
                        return /*#__PURE__*/ (0, $2WrlN.jsx)($a472c85250d3bcda$var$ExpandableYear, {
                            index: i,
                            year: year.year,
                            months: year.months
                        }, i);
                    })
                })
            ]
        })
    });
};



var $2WrlN = parcelRequire("2WrlN");



var $ld5Xm = parcelRequire("ld5Xm");

var $3910cb85049ce48f$export$4d09fd711e9035f8;
var $3910cb85049ce48f$export$c5d887be07952494;
var $3910cb85049ce48f$export$c5146dc355f85bfb;
var $3910cb85049ce48f$export$258ab528b5d27510;
var $3910cb85049ce48f$export$cf17420ae7a8211c;
var $3910cb85049ce48f$export$3a7169f1a7f439a4;
var $3910cb85049ce48f$export$66971e77c1b2305a;
var $3910cb85049ce48f$export$16bc9d7eee926699;
var $3910cb85049ce48f$export$7ef09dced151af4a;
$3910cb85049ce48f$export$4d09fd711e9035f8 = `B8ETRa_action-buttons`;
$3910cb85049ce48f$export$c5d887be07952494 = `B8ETRa_drop-zone`;
$3910cb85049ce48f$export$c5146dc355f85bfb = `B8ETRa_file-error`;
$3910cb85049ce48f$export$258ab528b5d27510 = `B8ETRa_file-item`;
$3910cb85049ce48f$export$cf17420ae7a8211c = `B8ETRa_file-list`;
$3910cb85049ce48f$export$3a7169f1a7f439a4 = `B8ETRa_file-size-info`;
$3910cb85049ce48f$export$66971e77c1b2305a = `B8ETRa_file-upload`;
$3910cb85049ce48f$export$16bc9d7eee926699 = `B8ETRa_mr-2`;
$3910cb85049ce48f$export$7ef09dced151af4a = `B8ETRa_upload-icon`;


var $d0a8ff7dea01f287$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($d0a8ff7dea01f287$exports, "__esModule", {
    value: true
});
$d0a8ff7dea01f287$exports.default = void 0;

var $d0a8ff7dea01f287$var$_createSvgIcon = $hkjon((parcelRequire("kYoAx")));

var $2WrlN = parcelRequire("2WrlN");
var $d0a8ff7dea01f287$var$_default = $d0a8ff7dea01f287$exports.default = (0, $d0a8ff7dea01f287$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5z"
}), "FileUploadOutlined");


var $a4fa296104d153c2$exports = {};
"use strict";
"use client";

var $hkjon = parcelRequire("hkjon");
Object.defineProperty($a4fa296104d153c2$exports, "__esModule", {
    value: true
});
$a4fa296104d153c2$exports.default = void 0;

var $a4fa296104d153c2$var$_createSvgIcon = $hkjon((parcelRequire("kYoAx")));

var $2WrlN = parcelRequire("2WrlN");
var $a4fa296104d153c2$var$_default = $a4fa296104d153c2$exports.default = (0, $a4fa296104d153c2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $2WrlN.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), "DeleteOutlineOutlined");



const $fda1f52d9f2d2df7$export$f68847957015c04 = ()=>{
    const [error, setError] = (0, $ld5Xm.useState)("");
    const [loading, setLoading] = (0, $ld5Xm.useState)(false);
    const [modalVisible, setModalVisible] = (0, $ld5Xm.useState)(false);
    const [successModalVisible, setSuccessModalVisible] = (0, $ld5Xm.useState)(false);
    const [file, setFile] = (0, $ld5Xm.useState)({
        file: null,
        size: null
    });
    const fileInputRef = (0, $ld5Xm.useRef)(null);
    const handleButtonClick = ()=>{
        fileInputRef.current?.click();
    };
    const handleFileInputChange = (event)=>{
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            if (selectedFile.name.endsWith(".xlsx")) {
                setFile({
                    file: selectedFile,
                    size: formatFileSize(selectedFile.size)
                });
                setError("");
            } else setError("Please select a .xlsx file.");
        }
    };
    const handleDrop = (event)=>{
        event.preventDefault();
        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            const droppedFile = event.dataTransfer.files[0];
            if (droppedFile.name.endsWith(".xlsx")) {
                setFile({
                    file: droppedFile,
                    size: formatFileSize(droppedFile.size)
                });
                setError("");
            } else setError("Please drop a .xlsx file");
        }
    };
    const handleDragOver = (event)=>{
        event.preventDefault();
    };
    const handleDeleteFile = ()=>{
        setFile({
            file: null,
            size: null
        });
        setError("");
        if (fileInputRef.current) fileInputRef.current.value = "";
    };
    const handleUpload = async ()=>{
        try {
            if (file.file) {
                setLoading(true);
                setError("");
                console.log("Uploading file:", file.file);
                await (0, $37f00dda556cffcc$export$611fc8957e8d71f7)(file.file);
                setLoading(false);
                setModalVisible(false);
                setSuccessModalVisible(true);
                setFile({
                    file: null,
                    size: null
                });
            } else {
                setLoading(false);
                setError("Please select a .xlsx file.");
            }
        } catch (error) {
            setLoading(false);
            if (error.response.status === 409) setError("There was already an adjustment uploaded for this week. Please try again later or reach out to SOS@alku.com");
            else setError("There was a problem uploading adjustments - Please try again or reach out to SOS@alku.com");
        }
    };
    const formatFileSize = (size)=>{
        if (size === 0) return "0 Bytes";
        const k = 1024;
        const sizes = [
            "Bytes",
            "KB",
            "MB",
            "GB",
            "TB"
        ];
        const i = Math.floor(Math.log(size) / Math.log(k));
        return parseFloat((size / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };
    const closeModal = ()=>{
        setFile({
            file: null,
            size: null
        });
        setError("");
        setModalVisible(false);
    };
    return /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $2WrlN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                className: $7723f654767736cd$export$bdc1311fb7c6b2d1,
                children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                    as: "button",
                    style: "primary-default",
                    id: "primary",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($7723f654767736cd$export$1fbd99162bd109d6, $7723f654767736cd$export$e6026be2f2fe3fd1),
                    onClick: ()=>setModalVisible(true),
                    title: "Upload Adjustment",
                    children: /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                        children: "Upload Adjustment"
                    })
                })
            }),
            modalVisible && /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$2b77a92f1a5ad772), {
                title: "Upload Adjustment",
                open: modalVisible,
                onRequestClose: closeModal,
                closeOnOutsideClick: true,
                theme: "default",
                children: [
                    /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                        className: $3910cb85049ce48f$export$66971e77c1b2305a,
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                                className: $3910cb85049ce48f$export$c5d887be07952494,
                                onDrop: handleDrop,
                                onDragOver: handleDragOver,
                                children: [
                                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d0a8ff7dea01f287$exports))), {
                                        className: $3910cb85049ce48f$export$7ef09dced151af4a
                                    }),
                                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                                        style: "title",
                                        weight: "semibold",
                                        children: "Drag & Drop Your File Here"
                                    }),
                                    /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                        className: $7723f654767736cd$export$2b4ea30de06c071c,
                                        children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                                            style: "small",
                                            children: "or"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                                        onClick: handleButtonClick,
                                        as: "button",
                                        id: "primary",
                                        style: "primary-default",
                                        disabled: loading,
                                        children: "Browse Computer"
                                    }),
                                    /*#__PURE__*/ (0, $2WrlN.jsx)("input", {
                                        type: "file",
                                        accept: ".xlsx",
                                        ref: fileInputRef,
                                        style: {
                                            display: "none"
                                        },
                                        onChange: handleFileInputChange
                                    }),
                                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                                        className: $3910cb85049ce48f$export$3a7169f1a7f439a4,
                                        children: "Supported file type: .xlsx"
                                    }),
                                    /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                                        className: $3910cb85049ce48f$export$3a7169f1a7f439a4,
                                        children: "Max file size: 10MB"
                                    })
                                ]
                            }),
                            error && /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($b810a1b85b9c4cf6$exports)))($7723f654767736cd$export$2b4ea30de06c071c, $3910cb85049ce48f$export$c5146dc355f85bfb),
                                children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                                    style: "normal",
                                    weight: "bold",
                                    color: "alku-brand-primary",
                                    children: error
                                })
                            }),
                            file.file && /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                className: $3910cb85049ce48f$export$cf17420ae7a8211c,
                                children: /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                                    className: $3910cb85049ce48f$export$258ab528b5d27510,
                                    children: [
                                        /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                                            style: "normal",
                                            weight: "semibold",
                                            className: $3910cb85049ce48f$export$3a7169f1a7f439a4,
                                            children: [
                                                file.file.name,
                                                /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$5f1af8db9871e1d6), {
                                                    style: "small",
                                                    color: "alku-icon-default",
                                                    children: file.size
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2WrlN.jsx)("p", {
                                            className: $3910cb85049ce48f$export$3a7169f1a7f439a4
                                        }),
                                        /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                                            style: "icon-only",
                                            as: "button",
                                            ariaLabel: "Delete file",
                                            onClick: handleDeleteFile,
                                            id: "delete-file",
                                            children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4fa296104d153c2$exports))), {
                                                fontSize: "medium"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                        className: $3910cb85049ce48f$export$4d09fd711e9035f8,
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                                id: "cancel",
                                style: "primary-default",
                                type: "submit",
                                as: "button",
                                className: $3910cb85049ce48f$export$16bc9d7eee926699,
                                onClick: closeModal,
                                disabled: loading,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$353f5b6fc5456de1), {
                                id: "upload",
                                style: "primary-impact",
                                type: "submit",
                                as: "button",
                                disabled: !file.file,
                                onClick: handleUpload,
                                children: loading ? /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                    className: $7723f654767736cd$export$f4c5de44377d2946,
                                    style: {
                                        width: "2rem",
                                        height: "2rem"
                                    }
                                }) : /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                                    children: "Upload File"
                                })
                            })
                        ]
                    })
                ]
            }),
            successModalVisible && /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$2b77a92f1a5ad772), {
                title: "Upload Adjustment",
                open: successModalVisible,
                onRequestClose: ()=>setSuccessModalVisible(false),
                closeOnOutsideClick: true,
                theme: "success",
                children: /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                    children: "Your manual adjustments were successfully uploaded!"
                })
            })
        ]
    });
};


const $1445f90e85ab667b$var$MINUTE_MILLISECONDS = 60000;
const $1445f90e85ab667b$export$b94310965bed44e6 = ()=>{
    const [reports, setReports] = (0, $ld5Xm.useState)([]);
    const [recentReport, setRecentReport] = (0, $ld5Xm.useState)();
    const [isLoading, setIsLoading] = (0, $ld5Xm.useState)(true);
    (0, $ld5Xm.useEffect)(()=>{
        const getReportsData = async ()=>{
            try {
                const reportsData = await (0, $37f00dda556cffcc$export$9dc937f1c1abf620)();
                setReports(reportsData);
                setIsLoading(false);
            } catch (error) {
                console.log(error);
                setIsLoading(false);
            }
        };
        getReportsData();
        const intervalId = setInterval(getReportsData, $1445f90e85ab667b$var$MINUTE_MILLISECONDS); // Gets reports every minute
        return ()=>clearInterval(intervalId);
    }, []);
    (0, $ld5Xm.useEffect)(()=>{
        if (reports.length > 0) {
            const report = mostRecentReport();
            setRecentReport(report);
        }
    }, [
        reports
    ]);
    const mostRecentReport = ()=>{
        const mostRecent = reports.reduce((prev, current)=>{
            const prevDate = new Date(prev.requestedAtTime);
            const currentDate = new Date(current.requestedAtTime);
            const currentCompleted = current.completedStatus === "completed";
            const prevCompleted = prev.completedStatus === "completed";
            if (!prevCompleted || currentCompleted && currentDate > prevDate) return current;
            return prev;
        });
        return mostRecent;
    };
    return /*#__PURE__*/ (0, $2WrlN.jsx)((0, $76ef91adf46192f3$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
            className: $7723f654767736cd$export$120ff0929b202a6d,
            children: [
                /*#__PURE__*/ (0, $2WrlN.jsxs)("div", {
                    className: $7723f654767736cd$export$4e0c71f277ca26b3,
                    children: [
                        /*#__PURE__*/ (0, $2WrlN.jsx)((0, $59f7253eae80d478$export$a8a3e93435678ff9), {
                            as: "div",
                            style: "one",
                            children: "Create Spread Report"
                        }),
                        /*#__PURE__*/ (0, $2WrlN.jsx)((0, $893f38dce37802d9$export$bb42c091ac7d4ce7), {
                            recentReport: recentReport
                        }),
                        /*#__PURE__*/ (0, $2WrlN.jsx)((0, $b4148de03918bf6e$export$5ab06ab8185d7a0e), {
                            recentReport: recentReport
                        }),
                        /*#__PURE__*/ (0, $2WrlN.jsx)((0, $fda1f52d9f2d2df7$export$f68847957015c04), {})
                    ]
                }),
                /*#__PURE__*/ (0, $2WrlN.jsx)("div", {
                    className: $7723f654767736cd$export$4e0c71f277ca26b3,
                    children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $a472c85250d3bcda$export$84202caead5689ba), {
                        reports: reports,
                        isLoading: isLoading
                    })
                })
            ]
        })
    });
};


function $208f1fe9334475c7$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $2WrlN.jsx)((0, $2WrlN.Fragment), {
        children: /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $68c2ac1c8be5656b$export$9ba4e89fdfa1fc54), {
            children: [
                /*#__PURE__*/ (0, $2WrlN.jsx)((0, $4ecbeb3399fcf92c$export$8b251419efc915eb), {}),
                /*#__PURE__*/ (0, $2WrlN.jsx)("main", {
                    children: /*#__PURE__*/ (0, $2WrlN.jsxs)((0, $bb19e89bd54fc2f3$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $2WrlN.jsx)((0, $bb19e89bd54fc2f3$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $1445f90e85ab667b$export$b94310965bed44e6), {})
                            }),
                            /*#__PURE__*/ (0, $2WrlN.jsx)((0, $bb19e89bd54fc2f3$export$e7b0ac011bb776c6), {
                                path: "/ui-kit",
                                element: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $8b1e6b8aa40f03b8$export$6eae17274b77b4a6), {})
                            })
                        ]
                    })
                })
            ]
        })
    });
}



const $5b636ed3ac8f86ba$var$container = document.getElementById("app");
if ($5b636ed3ac8f86ba$var$container !== null) {
    const root = (0, $adf38e62d3ba55f8$export$882461b6382ed46c)($5b636ed3ac8f86ba$var$container);
    root.render(/*#__PURE__*/ (0, $2WrlN.jsx)((0, $6552874ea2db8d8d$export$25bac41dc3d78d47), {
        instance: (0, $abad72839459f54c$export$a59c2286a7150b12),
        children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $f3f9f758e1c80e18$export$87091915187a1a85), {
            children: /*#__PURE__*/ (0, $2WrlN.jsx)((0, $208f1fe9334475c7$export$86fbec116b87613f), {})
        })
    }));
} else console.error("Cannot Find Element with #app");


//# sourceMappingURL=index.471d7eb1.js.map
